import { HIVE_SIZING_500, HIVE_SIZING_400, HIVE_SIZING_300, HIVE_SIZING_200, HIVE_SIZING_100, HIVE_SPACING_XXXSM, HIVE_SPACING_SM, HIVE_SPACING_LG, HIVE_BORDER_SUCCESS_BOLD, HIVE_BORDER_NEUTRAL_SUBTLE, HIVE_TEXT_ONNEUTRAL_PRIMARY, HIVE_BACKGROUND_SUCCESS_SUBTLEST, HIVE_TEXT_ONSUCCESS, HIVE_SPACING_XXLG } from '@pure/hive-tokens/ts/raspberry';
export * from '@pure/hive-tokens/ts/raspberry';
import * as i0 from '@angular/core';
import { InjectionToken, inject, DestroyRef, Directive, Inject, Component, ChangeDetectionStrategy, Output, HostBinding, Input, Injectable, Pipe, booleanAttribute, Optional, SkipSelf, ContentChildren, forwardRef, HostListener, numberAttribute, NgModule, EventEmitter, Host, ViewChild, ContentChild, QueryList, input, output, Injector, ViewChildren, ChangeDetectorRef, ElementRef, signal } from '@angular/core';
import * as i4 from 'rxjs';
import { BehaviorSubject, distinctUntilChanged, map, filter, pipe, takeUntil, NEVER, catchError, EMPTY, defaultIfEmpty, asyncScheduler, of, ReplaySubject, timer, combineLatest, merge, fromEvent, Subject, debounceTime as debounceTime$1, switchMap as switchMap$1, startWith as startWith$1, tap as tap$1, firstValueFrom, race, Observable, take, forkJoin, delay, skip, first } from 'rxjs';
import { throttleTime, switchMap, map as map$1, tap, catchError as catchError$1, startWith, debounceTime, debounce, filter as filter$1 } from 'rxjs/operators';
import * as i2 from '@angular/cdk/collections';
import { SelectionModel, UniqueSelectionDispatcher } from '@angular/cdk/collections';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import * as i2$1 from '@angular/common';
import { DOCUMENT, CommonModule, NgClass, TitleCasePipe, NgForOf, NgIf, NgTemplateOutlet, AsyncPipe, NgStyle, DecimalPipe } from '@angular/common';
import { __decorate } from 'tslib';
import * as i1 from '@angular/common/http';
import * as i1$1 from '@angular/cdk/overlay';
import { ConnectionPositionPair, OverlayConfig, OverlayModule, CdkOverlayOrigin, CdkConnectedOverlay, Overlay } from '@angular/cdk/overlay';
import * as i2$2 from '@angular/cdk/portal';
import { ComponentPortal, PortalModule, CdkPortal } from '@angular/cdk/portal';
import { isString, uniqueId, isUndefined, isNull, range, groupBy, isEmpty } from 'lodash-es';
import * as i1$3 from '@angular/forms';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, FormsModule, ReactiveFormsModule, Validators, NgControl, FormControl } from '@angular/forms';
import { coerceBooleanProperty, coerceNumberProperty } from '@angular/cdk/coercion';
import * as i1$4 from '@angular/animations';
import { trigger, state, style, transition, animate, group, query } from '@angular/animations';
import * as i1$2 from '@angular/cdk/platform';
import { FocusKeyManager } from '@angular/cdk/a11y';
import { BreakpointObserver } from '@angular/cdk/layout';
import uniqueId$1 from 'lodash/uniqueId';
import * as i5 from '@angular/cdk/drag-drop';
import { DragDropModule } from '@angular/cdk/drag-drop';
import * as i1$5 from '@angular/cdk/stepper';
import { CdkStep, CdkStepper, CdkStepperModule } from '@angular/cdk/stepper';
import { ObserversModule } from '@angular/cdk/observers';
import { HIVE_SIZING_3200 } from '@pure/hive-tokens/ts/dark';

var Themes;
(function (Themes) {
    Themes["UINext"] = "raspberry";
    Themes["Dark"] = "dark";
    Themes["Clementine"] = "clementine";
})(Themes || (Themes = {}));
const HIVE_THEMING = new InjectionToken('Theming token for Hive library', {
    factory: () => new BehaviorSubject(Themes.UINext),
});

class HiveThemedDirective {
    constructor(theming$, elementRef) {
        this.theming$ = theming$;
        this.elementRef = elementRef;
        this.destroyRef$ = inject(DestroyRef);
    }
    ngOnInit() {
        this.theming$
            .pipe(takeUntilDestroyed(this.destroyRef$), distinctUntilChanged())
            .subscribe((theme) => {
            const element = this.elementRef.nativeElement;
            element.classList.toggle('hive-theme-raspberry', theme === Themes.UINext);
            element.classList.toggle('hive-theme-dark', theme === Themes.Dark);
            element.classList.toggle('hive-theme-clementine', theme === Themes.Clementine);
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: HiveThemedDirective, deps: [{ token: HIVE_THEMING }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: HiveThemedDirective, isStandalone: true, selector: "hive-themed", ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: HiveThemedDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'hive-themed',
                    standalone: true,
                }]
        }], ctorParameters: () => [{ type: i4.BehaviorSubject, decorators: [{
                    type: Inject,
                    args: [HIVE_THEMING]
                }] }, { type: i0.ElementRef }] });

/**
 * Injection token for the selection model.
 */
const EXPANSION_MODEL = new InjectionToken('expansionModel');
/**
 * Injection token for the active model.
 */
const ACTIVE_MODEL = new InjectionToken('activeModel');
/**
 * @deprecated
 */
class DeprecatedAppNavigationDirective {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DeprecatedAppNavigationDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: DeprecatedAppNavigationDirective, selector: "hive-app-navigation", ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DeprecatedAppNavigationDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'hive-app-navigation',
                }]
        }] });
/**
 * The component represents a left-side navigation menu (or navigation tree).
 * It is used to navigate between different pages or sections of the application.
 * and could be used as follows:
 *
 * @example:
 * <hive-left-navigation
 *     [selection]="selection"
 *     [expansion]="expansion"
 *     (selectionChange)="selectionChange($event)"
 *     (expansionChange)="expansionChange($event)"
 * >
 *     <a hive-left-navigation-item
 *         label="Item 1"
 *         icon="assets/icons/arrow.svg"
 *         [routerLink]="['/']"
 *     >
 *         <hive-tag severity="info" label="Info"></hive-tag>
 *         <hive-badge label="1"></hive-badge>
 *         <a hive-left-navigation-item
 *             label="Item 1.1"
 *             icon="assets/icons/arrow.svg"
 *             [routerLink]="['/info']"
 *         >
 *             <hive-tag severity="info" label="Info"></hive-tag>
 *             <hive-badge label="1"></hive-badge>
 *         </a>
 *     </a>
 * </hive-left-navigation>
 *
 * In this example you can see that the `hive-left-navigation-item` component can be nested.
 * Also, it can be used with `routerLink` directive and `uiSref` directive.
 * If you want to use it directly - you can use `selectionChange` and `expansionChange` events.
 * Another feature - that you can use it along with `hive-badge` and `hive-tag` components.
 *
 * The left navigation also can have a header and a footer. You can use it to add some custom content.
 *
 * Also, you can use it with `hive-separator` component to separate navigation items like this:
 *
 * @example:
 * <hive-left-navigation
 *     [(selection)]="selection"
 *     [(expansion)]="expansion"
 * >
 *     <header>
 *         <hive-button label="Open New case"/>
 *     </header>
 *     <a hive-left-navigation-item
 *         label="Item 1"
 *         icon="assets/icons/arrow.svg"
 *         [routerLink]="['/']"
 *     >
 *         <hive-tag severity="info" label="Info"></hive-tag>
 *         <hive-badge label="1"></hive-badge>
 *     </a>
 *     <hive-separator></hive-separator>
 *     <a hive-left-navigation-item
 *         label="Item 2"
 *         icon="assets/icons/arrow.svg"
 *         [routerLink]="['/']"
 *     >
 *         <hive-tag severity="info" label="Info"></hive-tag>
 *         <hive-badge label="1"></hive-badge>
 *     </a>
 *     <footer>
 *         <hive-button label="Ask AI Assistant"></hive-button>
 *     </footer>
 * </hive-left-navigation>
 */
class LeftNavigationComponent {
    constructor(expansionModel, activeModel) {
        this.expansionModel = expansionModel;
        this.activeModel = activeModel;
        this.hiveAppNavigation = true;
        this.selectionChange = this.activeModel.changed.asObservable().pipe(map(({ added }) => added.at(0)), filter((id) => !!id));
        this.expansionChange = this.expansionModel.changed
            .asObservable()
            .pipe(map(({ source }) => source.selected));
    }
    /**
     * Set active selection
     * @param value
     */
    set selection(value) {
        this.activeModel.select(value);
    }
    /**
     * Set expanded tab
     * @param value
     */
    set expansion(value) {
        this.expansionModel.select(...value);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: LeftNavigationComponent, deps: [{ token: EXPANSION_MODEL }, { token: ACTIVE_MODEL }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: LeftNavigationComponent, selector: "hive-left-navigation,hive-app-navigation", inputs: { selection: "selection", expansion: "expansion" }, outputs: { expansionChange: "expansionChange", selectionChange: "selectionChange" }, host: { properties: { "class.hive-left-navigation": "this.hiveAppNavigation" } }, providers: [
            {
                provide: EXPANSION_MODEL,
                useFactory: () => new SelectionModel(true),
            },
            {
                provide: ACTIVE_MODEL,
                useFactory: () => new SelectionModel(false),
            },
        ], hostDirectives: [{ directive: HiveThemedDirective }], ngImport: i0, template: `
        <div class="hive-left-navigation-container">
            <ng-content select="header"></ng-content>

            <ng-content
                select="hive-app-navigation-item,a[hive-app-navigation-item],a[hive-left-navigation-item],hive-separator:not([orientation=vertical])"
            ></ng-content>

            <ng-content select="footer"></ng-content>
        </div>
    `, isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: LeftNavigationComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'hive-left-navigation,hive-app-navigation',
                    template: `
        <div class="hive-left-navigation-container">
            <ng-content select="header"></ng-content>

            <ng-content
                select="hive-app-navigation-item,a[hive-app-navigation-item],a[hive-left-navigation-item],hive-separator:not([orientation=vertical])"
            ></ng-content>

            <ng-content select="footer"></ng-content>
        </div>
    `,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    providers: [
                        {
                            provide: EXPANSION_MODEL,
                            useFactory: () => new SelectionModel(true),
                        },
                        {
                            provide: ACTIVE_MODEL,
                            useFactory: () => new SelectionModel(false),
                        },
                    ],
                    hostDirectives: [HiveThemedDirective],
                }]
        }], ctorParameters: () => [{ type: i2.SelectionModel, decorators: [{
                    type: Inject,
                    args: [EXPANSION_MODEL]
                }] }, { type: i2.SelectionModel, decorators: [{
                    type: Inject,
                    args: [ACTIVE_MODEL]
                }] }], propDecorators: { expansionChange: [{
                type: Output
            }], selectionChange: [{
                type: Output
            }], hiveAppNavigation: [{
                type: HostBinding,
                args: ['class.hive-left-navigation']
            }], selection: [{
                type: Input
            }], expansion: [{
                type: Input
            }] } });

function safeTakeUntilDestroyed(destroyRef) {
    return pipe(takeUntil(NEVER.pipe(takeUntilDestroyed(destroyRef), catchError(() => EMPTY), defaultIfEmpty(null))));
}

/**
 * Use to specify path for hive-svg directive.
 * For example if token set to '/images/' and hive-svg="honeycomb.svg" it will request svg from '/images/honeycomb.svg'
 */
const SVG_ROOT = new InjectionToken('Token to specify root for svg files', {
    factory: () => '',
});

/**
 * This function will check is value present
 * @param value
 * @param key
 * @param errorText
 */
function checkNoValue(value, key, errorText) {
    if (!value) {
        throw new Error(errorText || `Value for ${key} is required`);
    }
}
/**
 * This decorator will check is value present and throw error if not
 * @param errorText
 *
 * @example
 *  ```
 *      @Component({ ... })
 *      export class MyComponent {
 *          @RequiredInput() myInput: string;
 *      }
 *  ```
 */
function RequiredInput(errorText) {
    return (target, key) => {
        const originalOnChanges = target.ngOnChanges;
        const originalOnInit = target.ngOnInit;
        target.ngOnChanges = function CheckRequiredFieldsOnChanges(...args) {
            checkNoValue(this[key], key, errorText);
            if (originalOnChanges) {
                originalOnChanges.apply(this, args);
            }
        };
        target.ngOnInit = function CheckRequiredFieldsOnInit(...args) {
            checkNoValue(this[key], key, errorText);
            if (originalOnInit) {
                originalOnInit.apply(this, args);
            }
        };
    };
}

class SvgDirectiveCacheService extends Map {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SvgDirectiveCacheService, deps: null, target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SvgDirectiveCacheService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SvgDirectiveCacheService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

/**
 * @internal
 */
const unknownIcon = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
    <path d="M48 421.8L162.8 256 48 90.2V421.8zM77.2 464H306.8L192 298.2 77.2 464zm144-208L336 421.8V90.2L221.2 256zM306.8 48H77.2L192 213.8 306.8 48zM0 48C0 21.5 21.5 0 48 0H336c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V48z"/>
</svg>`;
/**
 * @internal
 */
const DEBOUNCE_INTERVAL = 500;
/**
 * SVG directive is used to request SVGs through HTTP.
 *
 * It will interpolate svg resource from `hive-svg`
 * property into an element by innerHTML
 * as well as assign svg attributes to the element.
 *
 * This element also supports caching of the svg resources.
 *
 * For unsuccessful requests, it will fall back to built-in unknown icon.
 *
 * This directive works with `SVG_ROOT` injection token.
 * See hive-svg input property for more info.
 *
 * This directive is based on Pure1-gui's `PureSvgComponent`.
 *
 * @example
 * <svg hive-svg="honeycomb.svg" [width]="64" [height]="64"></svg>
 */
class SvgDirective {
    get nativeElement() {
        return this.elementRef.nativeElement;
    }
    get aspectRatio() {
        if (!this.loadedWidth || !this.loadedHeight) {
            return 1;
        }
        return this.loadedWidth / this.loadedHeight;
    }
    get computedWidth() {
        const userHeight = this.height && !isNaN(this.height)
            ? this.height
            : this.defaultHeight;
        return this.width ? this.width : userHeight * this.aspectRatio;
    }
    get computedHeight() {
        const userWidth = this.width && !isNaN(this.width) ? this.width : this.defaultWidth;
        return this.height ? this.height : userWidth / this.aspectRatio;
    }
    get rootWidth() {
        return `${this.computedWidth}px`;
    }
    get rootHeight() {
        return `${this.computedHeight}px`;
    }
    constructor(httpClient, elementRef, svgDirectiveCache, document, svgRoot) {
        this.httpClient = httpClient;
        this.elementRef = elementRef;
        this.svgDirectiveCache = svgDirectiveCache;
        this.document = document;
        this.svgRoot = svgRoot;
        this.destroyRef = inject(DestroyRef);
        this.defaultWidth = 16;
        this.defaultHeight = 16;
        this.svgPath$ = new BehaviorSubject(null);
    }
    ngOnInit() {
        this.svgPath$
            .pipe(takeUntilDestroyed(this.destroyRef), throttleTime(DEBOUNCE_INTERVAL, asyncScheduler, {
            trailing: true,
            leading: true,
        }), distinctUntilChanged(), switchMap(this.fetchSVG.bind(this)), map$1(this.createDOMFromText.bind(this)), tap(this.setAttributes.bind(this)), tap(this.setSizesByAspectRatio.bind(this)), tap(this.setContent.bind(this)), tap(this.setSizes.bind(this)))
            .subscribe();
    }
    setSizes() {
        this.nativeElement.style.setProperty('width', this.rootWidth);
        this.nativeElement.style.setProperty('height', this.rootHeight);
        this.nativeElement.setAttribute('width', this.rootWidth);
        this.nativeElement.setAttribute('height', this.rootHeight);
    }
    setAttributes(svgElement) {
        const previousAttributePrefix = this.constructor.name;
        if (!svgElement?.attributes) {
            return;
        }
        // Revert attribute changes from last execution and clear it
        for (const { name, value } of this.nativeElement?.attributes) {
            const [namespace, qualifiedName] = name.split(':');
            if (qualifiedName && namespace === previousAttributePrefix) {
                this.nativeElement.setAttribute(qualifiedName, value);
                this.nativeElement.removeAttribute(name);
            }
        }
        // Set new attributes
        for (const { name, value } of svgElement?.attributes) {
            // Save previous attributes if it is about to change
            if (this.nativeElement.hasAttribute(name)) {
                this.nativeElement.setAttribute(`${previousAttributePrefix}:${name}`, this.nativeElement.getAttribute(name));
            }
            this.nativeElement.setAttribute(name, value);
        }
    }
    createDOMFromText(templateHtml) {
        const template = this.document.createElement('template');
        template.insertAdjacentHTML('beforeend', templateHtml ?? '');
        return template.querySelector('svg');
    }
    setSizesByAspectRatio() {
        const baseVal = this.nativeElement?.viewBox.baseVal;
        this.loadedWidth = baseVal.width;
        this.loadedHeight = baseVal.height;
    }
    setContent(svgElement) {
        this.nativeElement.innerHTML = '';
        this.nativeElement.insertAdjacentHTML('beforeend', svgElement.innerHTML);
    }
    fetchSVG(svgPath) {
        console.assert(svgPath !== null, 'svgPath should not be null');
        if (!svgPath) {
            return of(unknownIcon);
        }
        if (this.svgDirectiveCache.has(svgPath)) {
            return (this.svgDirectiveCache.get(svgPath));
        }
        const content = new ReplaySubject();
        this.svgDirectiveCache.set(svgPath, content);
        return this.httpClient.get(svgPath, { responseType: 'text' }).pipe(tap({
            next: (value) => content.next(value),
            error: (err) => {
                this.svgDirectiveCache.delete(svgPath);
                console.error(`${this.constructor.name}: '${svgPath}' was not found. Removed from cache and applied placeholder.`, err);
            },
        }), catchError$1(() => of(unknownIcon)));
    }
    ngOnChanges(changes) {
        if (changes['svg']) {
            this.svgPath$.next(`${this.svgRoot ?? ''}${changes['svg'].currentValue}`);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SvgDirective, deps: [{ token: i1.HttpClient }, { token: i0.ElementRef }, { token: SvgDirectiveCacheService }, { token: DOCUMENT }, { token: SVG_ROOT }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: SvgDirective, isStandalone: true, selector: "svg[hive-svg]", inputs: { svg: ["hive-svg", "svg"], width: "width", height: "height" }, usesOnChanges: true, ngImport: i0 }); }
}
__decorate([
    RequiredInput('SvgDirective needs \'hive-svg\' property to be set.')
], SvgDirective.prototype, "svg", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SvgDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'svg[hive-svg]',
                    standalone: true,
                }]
        }], ctorParameters: () => [{ type: i1.HttpClient }, { type: i0.ElementRef }, { type: SvgDirectiveCacheService }, { type: Document, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [SVG_ROOT]
                }] }], propDecorators: { svg: [{
                type: Input,
                args: ['hive-svg']
            }], width: [{
                type: Input
            }], height: [{
                type: Input
            }] } });

function isDefined(value) {
    return value !== null && value !== undefined;
}
/**
 * Returns false if given value is null or undefined
 */
class IsDefinedPipe {
    constructor() {
        this.transform = isDefined;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: IsDefinedPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: IsDefinedPipe, isStandalone: true, name: "isDefined" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: IsDefinedPipe, decorators: [{
            type: Pipe,
            args: [{ name: 'isDefined', standalone: true }]
        }] });

class IconSizeToNumberPipe {
    transform(size) {
        switch (size) {
            case 'smallest':
                return parseInt(HIVE_SIZING_100);
            case 'small':
                return parseInt(HIVE_SIZING_100) + parseInt(HIVE_SPACING_XXXSM);
            case 'medium':
                return parseInt(HIVE_SIZING_200);
            case 'large':
                return parseInt(HIVE_SIZING_300);
            case 'x-large':
                return parseInt(HIVE_SIZING_400);
            case '2x-large':
                return parseInt(HIVE_SIZING_500);
            default:
                return this.transform('medium');
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: IconSizeToNumberPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: IconSizeToNumberPipe, isStandalone: true, name: "iconSizeToNumber" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: IconSizeToNumberPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'iconSizeToNumber',
                    pure: true,
                    standalone: true,
                }]
        }] });

/**
 * Unifies interface which can be used for including SVG with {@link SvgDirective}
 * or Font Awesome with `<i>` icons class.
 *
 * @property {string | undefined} faIconClass Font Awesome icon class format:
 * `fa fa-example`
 * @property {string | undefined} svgIconPath {@link SvgDirective}
 */
class IconComponent {
    constructor() {
        this.sizeSet = false;
        this._size = 'medium';
    }
    get size() {
        return this._size;
    }
    /**
     * Size of the icon.
     *
     * If not defined - browser will define the size.
     * If provided, `svgIconWidth` and `svgIconHeight` will be ignored.
     */
    set size(size) {
        this.sizeSet = true;
        this._size = size;
    }
    get sizeClass() {
        return this.sizeSet
            ? [
                'hive-icon-component',
                'hive-icon-component--resized',
                `hive-icon-component--size-${this.size}`,
            ]
            : '';
    }
    get svgIconPath() {
        if (this.icon?.endsWith('.svg')) {
            return this.icon;
        }
        return null;
    }
    get faIconClass() {
        if (this.icon?.endsWith('.svg') === false) {
            return this.icon;
        }
        return null;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: IconComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.3.12", type: IconComponent, isStandalone: true, selector: "hive-icon-component", inputs: { icon: "icon", size: "size" }, host: { properties: { "class": "this.sizeClass" } }, ngImport: i0, template: `
        @if (faIconClass) {
            <i class="hive-icon-component_fa-icon" [ngClass]="faIconClass"></i>
        }

        @if (svgIconPath) {
            <svg
                class="hive-icon-component_svg-icon"
                [hive-svg]="svgIconPath"
                [width]="size | iconSizeToNumber"
                [height]="size | iconSizeToNumber"
            ></svg>
        }
    `, isInline: true, dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i2$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: SvgDirective, selector: "svg[hive-svg]", inputs: ["hive-svg", "width", "height"] }, { kind: "pipe", type: IconSizeToNumberPipe, name: "iconSizeToNumber" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: IconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'hive-icon-component',
                    template: `
        @if (faIconClass) {
            <i class="hive-icon-component_fa-icon" [ngClass]="faIconClass"></i>
        }

        @if (svgIconPath) {
            <svg
                class="hive-icon-component_svg-icon"
                [hive-svg]="svgIconPath"
                [width]="size | iconSizeToNumber"
                [height]="size | iconSizeToNumber"
            ></svg>
        }
    `,
                    standalone: true,
                    imports: [CommonModule, SvgDirective, IconSizeToNumberPipe, IsDefinedPipe],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], propDecorators: { icon: [{
                type: Input
            }], size: [{
                type: Input
            }], sizeClass: [{
                type: HostBinding,
                args: ['class']
            }] } });

/**
 * Contains some CSS to rotate a chevron.
 *
 * @internal
 */
class ChevronDirective {
    constructor() {
        this.hiveChevron = true;
        /**
         * Even though chevrons usually rotate 180 degress clockwise,
         * in some cases we need to have the option to rotate them counter-clockwise.
         */
        this.rotationDirection = 'clockwise';
        this.rotated = false;
    }
    get rotationDirectionClass() {
        return `hive-chevron--rotation-${this.rotationDirection}`;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ChevronDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "16.1.0", version: "17.3.12", type: ChevronDirective, isStandalone: true, selector: "hive-icon-component[hiveChevron]", inputs: { rotationDirection: "rotationDirection", rotated: ["rotated", "rotated", booleanAttribute] }, host: { properties: { "class.hive-chevron": "this.hiveChevron", "class.hive-chevron--rotated": "this.rotated", "class": "this.rotationDirectionClass" } }, hostDirectives: [{ directive: HiveThemedDirective }], ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ChevronDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'hive-icon-component[hiveChevron]',
                    standalone: true,
                    hostDirectives: [HiveThemedDirective],
                }]
        }], propDecorators: { hiveChevron: [{
                type: HostBinding,
                args: ['class.hive-chevron']
            }], rotationDirection: [{
                type: Input
            }], rotated: [{
                type: HostBinding,
                args: ['class.hive-chevron--rotated']
            }, {
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], rotationDirectionClass: [{
                type: HostBinding,
                args: ['class']
            }] } });

/**
 * This component represents a single item in the navigation tree.
 * It has collapsing/expandable functionality, and can be nested.
 * Also, it can be used with `hive-badge` and `hive-tag` components.
 * Additionally:
 *
 * 1. Multiple items from the same level can be expanded in the same time.
 * 2. When clicking on the chevron icon, child items are expanded without redirection.
 * 3. When clicking anywhere except the chevron icon, child items are expanded and the first one is selected.
 *
 */
class LeftNavigationItemComponent {
    constructor(parent, expansionModel, activeModel, changeDetectorRef) {
        this.parent = parent;
        this.expansionModel = expansionModel;
        this.activeModel = activeModel;
        this.changeDetectorRef = changeDetectorRef;
        /**
         * Label of navigation item.
         */
        this.label = '';
        /**
         * Additional data of navigation item.
         */
        this.data = null;
        /**
         * Icon of navigation item.
         */
        this.icon = '';
        /**
         * Icon of navigation item when highlighted.
         * If not provided, the {@link icon} will be used.
         */
        this.iconHighlighted = '';
        this.hiveAppNavigationItem = true;
        /**
         * @deprecated Use `hive-left-navigation-item` instead. AppNavigationItem will be removed in the next major version.
         * @internal
         */
        this.deprecatedAlias = '';
        /**
         * Set disabled state of navigation item.
         * @param value
         */
        this.disabled = false;
        this.destroyRef$ = inject(DestroyRef);
    }
    get tabIndex() {
        return this.disabled ? -1 : 0;
    }
    get isDisabled() {
        return this.disabled || null;
    }
    get isActive() {
        return this.activeModel.isSelected(this.id);
    }
    set isActive(value) {
        if (value) {
            this.activeModel.select(this.id);
        }
        else {
            this.activeModel.deselect(this.id);
        }
    }
    get hasChildren() {
        return !!this.nestedItems?.first;
    }
    get isExpanded() {
        return this.expansionModel.isSelected(this.id) ?? false;
    }
    set isExpanded(value) {
        if (value) {
            this.expansionModel.select(this.id);
        }
        else {
            this.expansionModel.deselect(this.id);
        }
    }
    get isHighlighted() {
        return this.hasActiveChildren || this.isActive;
    }
    get hasActiveChildren() {
        return this.nestedItems?.some((item) => item.isActive) ?? false;
    }
    get nestingLevel() {
        return this.parent ? this.parent.nestingLevel + 1 : 0;
    }
    get displayIcon() {
        if (this.isHighlighted && this.iconHighlighted) {
            return this.iconHighlighted;
        }
        return this.icon;
    }
    ngAfterContentInit() {
        // We want to expand element if it has active children
        // This timer(0) required to avoid ExpressionChangedAfterItHasBeenCheckedError
        timer(0)
            .pipe(safeTakeUntilDestroyed(this.destroyRef$), 
        // Apply following logic only if we have active children
        filter(() => {
            const isCollapsed = !this.isExpanded;
            const hasActiveChild = this.hasActiveChildren;
            return hasActiveChild && isCollapsed;
        }))
            .subscribe(() => {
            this.isExpanded = true;
            this.changeDetectorRef.markForCheck();
            this.changeDetectorRef.detectChanges();
        });
        // We want to update the view when the expansion model changes or the active model changes
        combineLatest([
            this.expansionModel.changed.pipe(startWith(null)),
            this.activeModel.changed.pipe(startWith(null)),
            this.nestedItems.changes.pipe(startWith(null)),
        ])
            .pipe(safeTakeUntilDestroyed(this.destroyRef$), debounceTime(0))
            .subscribe(() => {
            if (this.hasChildren && this.isActive) {
                const firstChild = this.nestedItems.get(0);
                if (firstChild) {
                    firstChild.isActive = true;
                }
            }
            this.changeDetectorRef.markForCheck();
            this.changeDetectorRef.detectChanges();
        });
    }
    handleClick(event) {
        event.stopPropagation();
        if (this.disabled) {
            return;
        }
        this.isActive = true;
        this.isExpanded = true;
    }
    toggleExpansion(event) {
        event.stopImmediatePropagation();
        event.preventDefault();
        this.isExpanded = !this.isExpanded;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: LeftNavigationItemComponent, deps: [{ token: LeftNavigationItemComponent, optional: true, skipSelf: true }, { token: EXPANSION_MODEL }, { token: ACTIVE_MODEL }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.3.12", type: LeftNavigationItemComponent, selector: "a[hive-left-navigation-item], a[hive-app-navigation-item]", inputs: { label: "label", id: "id", data: "data", icon: "icon", iconHighlighted: "iconHighlighted", deprecatedAlias: ["hive-app-navigation-item", "deprecatedAlias"], disabled: ["disabled", "disabled", booleanAttribute] }, host: { listeners: { "click": "handleClick($event)", "keyup.space": "toggleExpansion($event)" }, properties: { "attr.id": "this.id", "class.hive-left-navigation-item": "this.hiveAppNavigationItem", "attr.tabindex": "this.tabIndex", "attr.disabled": "this.isDisabled", "style.--nesting-level": "this.nestingLevel" } }, queries: [{ propertyName: "nestedItems", predicate: i0.forwardRef(() => LeftNavigationItemComponent), descendants: true }], hostDirectives: [{ directive: HiveThemedDirective }], ngImport: i0, template: "<div\n    [attr.tabindex]=\"-1\"\n    [class.hive-left-navigation-item-container--active]=\"isActive\"\n    [class.hive-left-navigation-item-container--highlighted]=\"isHighlighted\"\n    [class.hive-left-navigation-item-container--expanded]=\"isExpanded\"\n    [attr.data-is-active]=\"isActive\"\n    [attr.data-is-hightlighted]=\"isHighlighted\"\n    class=\"hive-left-navigation-item-container\"\n    data-role=\"navigation-item\"\n>\n    <div class=\"hive-left-navigation-item-icon-container\">\n        @if (icon && !nestingLevel) {\n            <hive-icon-component\n                class=\"hive-left-navigation-item-icon\"\n                size=\"medium\"\n                [icon]=\"displayIcon\"\n            />\n        }\n    </div>\n\n    <div\n        class=\"hive-left-navigation-item-label-container\"\n        [class.hive-left-navigation-item-label-container--item-nested]=\"\n            nestingLevel > 0\n        \"\n    >\n        <span>{{ label }}</span>\n\n        <ng-content select=\"hive-tag\"></ng-content>\n    </div>\n\n    <div class=\"hive-left-navigation-item-controls\">\n        <ng-content select=\"hive-badge\"></ng-content>\n\n        @if (hasChildren) {\n            <button\n                data-role=\"toggle-expansion\"\n                class=\"hive-left-navigation-item-expansion-button\"\n                type=\"button\"\n                (click)=\"toggleExpansion($event)\"\n            >\n                <hive-icon-component\n                    hiveChevron\n                    [rotated]=\"isExpanded\"\n                    size=\"small\"\n                    icon=\"light/chevron-down.svg\"\n                ></hive-icon-component>\n            </button>\n        }\n    </div>\n</div>\n\n<div\n    class=\"hive-left-navigation-item-children\"\n    [class.hive-left-navigation-item-children--collapsed]=\"!isExpanded\"\n>\n    <ng-content\n        select=\"a[hive-left-navigation-item],a[hive-app-navigation-item],hive-separator:not([orientation=vertical])\"\n    ></ng-content>\n</div>\n", dependencies: [{ kind: "component", type: IconComponent, selector: "hive-icon-component", inputs: ["icon", "size"] }, { kind: "directive", type: ChevronDirective, selector: "hive-icon-component[hiveChevron]", inputs: ["rotationDirection", "rotated"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: LeftNavigationItemComponent, decorators: [{
            type: Component,
            args: [{ selector: 'a[hive-left-navigation-item], a[hive-app-navigation-item]', changeDetection: ChangeDetectionStrategy.OnPush, hostDirectives: [HiveThemedDirective], template: "<div\n    [attr.tabindex]=\"-1\"\n    [class.hive-left-navigation-item-container--active]=\"isActive\"\n    [class.hive-left-navigation-item-container--highlighted]=\"isHighlighted\"\n    [class.hive-left-navigation-item-container--expanded]=\"isExpanded\"\n    [attr.data-is-active]=\"isActive\"\n    [attr.data-is-hightlighted]=\"isHighlighted\"\n    class=\"hive-left-navigation-item-container\"\n    data-role=\"navigation-item\"\n>\n    <div class=\"hive-left-navigation-item-icon-container\">\n        @if (icon && !nestingLevel) {\n            <hive-icon-component\n                class=\"hive-left-navigation-item-icon\"\n                size=\"medium\"\n                [icon]=\"displayIcon\"\n            />\n        }\n    </div>\n\n    <div\n        class=\"hive-left-navigation-item-label-container\"\n        [class.hive-left-navigation-item-label-container--item-nested]=\"\n            nestingLevel > 0\n        \"\n    >\n        <span>{{ label }}</span>\n\n        <ng-content select=\"hive-tag\"></ng-content>\n    </div>\n\n    <div class=\"hive-left-navigation-item-controls\">\n        <ng-content select=\"hive-badge\"></ng-content>\n\n        @if (hasChildren) {\n            <button\n                data-role=\"toggle-expansion\"\n                class=\"hive-left-navigation-item-expansion-button\"\n                type=\"button\"\n                (click)=\"toggleExpansion($event)\"\n            >\n                <hive-icon-component\n                    hiveChevron\n                    [rotated]=\"isExpanded\"\n                    size=\"small\"\n                    icon=\"light/chevron-down.svg\"\n                ></hive-icon-component>\n            </button>\n        }\n    </div>\n</div>\n\n<div\n    class=\"hive-left-navigation-item-children\"\n    [class.hive-left-navigation-item-children--collapsed]=\"!isExpanded\"\n>\n    <ng-content\n        select=\"a[hive-left-navigation-item],a[hive-app-navigation-item],hive-separator:not([orientation=vertical])\"\n    ></ng-content>\n</div>\n" }]
        }], ctorParameters: () => [{ type: LeftNavigationItemComponent, decorators: [{
                    type: Optional
                }, {
                    type: SkipSelf
                }] }, { type: i2.SelectionModel, decorators: [{
                    type: Inject,
                    args: [EXPANSION_MODEL]
                }] }, { type: i2.SelectionModel, decorators: [{
                    type: Inject,
                    args: [ACTIVE_MODEL]
                }] }, { type: i0.ChangeDetectorRef }], propDecorators: { label: [{
                type: Input
            }], id: [{
                type: HostBinding,
                args: ['attr.id']
            }, {
                type: Input,
                args: [{ required: true }]
            }], data: [{
                type: Input
            }], icon: [{
                type: Input
            }], iconHighlighted: [{
                type: Input
            }], hiveAppNavigationItem: [{
                type: HostBinding,
                args: ['class.hive-left-navigation-item']
            }], deprecatedAlias: [{
                type: Input,
                args: [{
                        alias: 'hive-app-navigation-item',
                    }]
            }], disabled: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], nestedItems: [{
                type: ContentChildren,
                args: [forwardRef(() => LeftNavigationItemComponent), {
                        descendants: true,
                    }]
            }], tabIndex: [{
                type: HostBinding,
                args: ['attr.tabindex']
            }], isDisabled: [{
                type: HostBinding,
                args: ['attr.disabled']
            }], nestingLevel: [{
                type: HostBinding,
                args: ['style.--nesting-level']
            }], handleClick: [{
                type: HostListener,
                args: ['click', ['$event']]
            }], toggleExpansion: [{
                type: HostListener,
                args: ['keyup.space', ['$event']]
            }] } });

class IsStringPipe {
    transform(value) {
        return isString(value);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: IsStringPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: IsStringPipe, isStandalone: true, name: "isString" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: IsStringPipe, decorators: [{
            type: Pipe,
            args: [{ name: 'isString', standalone: true }]
        }] });

/**
 * @internal
 */
class TooltipWindowComponent {
    /**
     * Class with the position of the tooltip. Needed for arrow positioning.
     */
    get positionAndCustomClass() {
        const positionClass = `hive-tooltip-position_${this.position}`;
        if (this.windowClass) {
            return `${this.windowClass} ${positionClass}`;
        }
        return positionClass;
    }
    constructor(elementRef) {
        this.elementRef = elementRef;
        /**
         * Position of the tooltip. Needed for arrow positioning.
         */
        this.position = 'bottomRight';
        this.nativeElement = this.elementRef.nativeElement;
        this.destroyRef$ = inject(DestroyRef);
        /**
         * Needed for the tooltip directive to not disappear when the mouse is over the tooltip window.
         */
        this.hovered$ = merge(fromEvent(this.nativeElement, 'pointerover').pipe(map(() => true), safeTakeUntilDestroyed(this.destroyRef$)), fromEvent(this.nativeElement, 'pointerout').pipe(map(() => false), safeTakeUntilDestroyed(this.destroyRef$))).pipe(distinctUntilChanged());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TooltipWindowComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.3.12", type: TooltipWindowComponent, selector: "hive-tooltip-window", inputs: { heading: "heading", description: "description", customContentTemplateRef: "customContentTemplateRef", customContentContext: "customContentContext", position: "position", windowClass: "windowClass" }, outputs: { hovered$: "hovered$" }, host: { properties: { "class": "this.positionAndCustomClass" } }, hostDirectives: [{ directive: HiveThemedDirective }], ngImport: i0, template: `
        <div class="hive-tooltip-window-container">
            @if ((customContentTemplateRef | isDefined) === false) {
                <div>
                    <h6 class="hive-header-semibold">
                        {{ heading }}
                    </h6>
                    <p class="hive-paragraph-small hive-paragraph-regular">
                        {{ description }}
                    </p>
                </div>
            } @else {
                <ng-container
                    [ngTemplateOutlet]="customContentTemplateRef ?? null"
                    [ngTemplateOutletContext]="customContentContext"
                ></ng-container>
            }
        </div>
    `, isInline: true, dependencies: [{ kind: "directive", type: i2$1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "pipe", type: IsDefinedPipe, name: "isDefined" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TooltipWindowComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'hive-tooltip-window',
                    template: `
        <div class="hive-tooltip-window-container">
            @if ((customContentTemplateRef | isDefined) === false) {
                <div>
                    <h6 class="hive-header-semibold">
                        {{ heading }}
                    </h6>
                    <p class="hive-paragraph-small hive-paragraph-regular">
                        {{ description }}
                    </p>
                </div>
            } @else {
                <ng-container
                    [ngTemplateOutlet]="customContentTemplateRef ?? null"
                    [ngTemplateOutletContext]="customContentContext"
                ></ng-container>
            }
        </div>
    `,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    hostDirectives: [HiveThemedDirective],
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }], propDecorators: { heading: [{
                type: Input
            }], description: [{
                type: Input
            }], customContentTemplateRef: [{
                type: Input
            }], customContentContext: [{
                type: Input
            }], position: [{
                type: Input
            }], windowClass: [{
                type: Input
            }], positionAndCustomClass: [{
                type: HostBinding,
                args: ['class']
            }], hovered$: [{
                type: Output
            }] } });

const PredefinedPositions = {
    topLeft: new ConnectionPositionPair({
        originX: 'start',
        originY: 'top',
    }, {
        overlayX: 'end',
        overlayY: 'bottom',
    }),
    topStart: new ConnectionPositionPair({
        originX: 'start',
        originY: 'top',
    }, {
        overlayX: 'start',
        overlayY: 'bottom',
    }),
    topEnd: new ConnectionPositionPair({
        originX: 'end',
        originY: 'top',
    }, {
        overlayX: 'end',
        overlayY: 'bottom',
    }),
    top: new ConnectionPositionPair({
        originX: 'center',
        originY: 'top',
    }, {
        overlayX: 'center',
        overlayY: 'bottom',
    }),
    topRight: new ConnectionPositionPair({
        originX: 'end',
        originY: 'top',
    }, {
        overlayX: 'start',
        overlayY: 'bottom',
    }),
    left: new ConnectionPositionPair({
        originX: 'start',
        originY: 'center',
    }, {
        overlayX: 'end',
        overlayY: 'center',
    }),
    right: new ConnectionPositionPair({
        originX: 'end',
        originY: 'center',
    }, {
        overlayX: 'start',
        overlayY: 'center',
    }),
    bottomLeft: new ConnectionPositionPair({
        originX: 'start',
        originY: 'bottom',
    }, {
        overlayX: 'end',
        overlayY: 'top',
    }),
    bottomStart: new ConnectionPositionPair({
        originX: 'start',
        originY: 'bottom',
    }, {
        overlayX: 'start',
        overlayY: 'top',
    }),
    bottomEnd: new ConnectionPositionPair({
        originX: 'end',
        originY: 'bottom',
    }, {
        overlayX: 'end',
        overlayY: 'top',
    }),
    bottom: new ConnectionPositionPair({
        originX: 'center',
        originY: 'bottom',
    }, {
        overlayX: 'center',
        overlayY: 'top',
    }),
    bottomRight: new ConnectionPositionPair({
        originX: 'end',
        originY: 'bottom',
    }, {
        overlayX: 'start',
        overlayY: 'top',
    }),
};

/**
 * Directive to show a tooltip on hover.
 *
 * Note that this directive is standalone only to be usable as `hostDirective`.
 * Applications still should import `TooltipModule` at least once
 * since the directive has other dependencies it cannot import on its own.
 *
 * @see TooltipModule
 * @see TooltipWindowComponent
 */
class TooltipDirective {
    constructor(overlay, elementRef, theming$, document) {
        this.overlay = overlay;
        this.elementRef = elementRef;
        this.theming$ = theming$;
        this.document = document;
        /**
         * Disabled tooltips can't be shown
         */
        this.disableTooltip = false;
        /**
         * Position of the tooltip.
         */
        this.hiveTooltipPosition = 'bottomRight';
        /**
         * Delay before hiding the tooltip.
         */
        this.hideDelay = 0;
        /**
         * Delay before showing the tooltip.
         */
        this.showDelay = 0;
        this.tooltipWindow = new ReplaySubject();
        this.cancelShow$ = new Subject();
        this.cancelHide$ = new Subject();
        this.destroyRef = inject(DestroyRef);
        this.directiveHovered$ = merge(merge(fromEvent(this.nativeElement, 'pointerover'), fromEvent(this.nativeElement, 'focusin')).pipe(map(() => true)), merge(fromEvent(this.nativeElement, 'pointerout'), fromEvent(this.nativeElement, 'focusout'), fromEvent(this.document, 'visibilitychange')).pipe(map(() => false))).pipe(debounceTime$1(100), distinctUntilChanged());
        this.tooltipWindowHovered$ = fromEvent(this.nativeElement, 'pointerout').pipe(switchMap$1(() => this.tooltipWindow), switchMap$1((tooltipWindow) => tooltipWindow.hovered$));
        this.WINDOW_HOVER_DEBOUNCE = 10;
        /**
         * Emits `true` when tooltip window is hovered.
         * Emits `false` when mouse leaves the tooltip window.
         */
        this.tooltipWindowHovered = this.tooltipWindowHovered$.pipe(debounceTime$1(this.WINDOW_HOVER_DEBOUNCE), distinctUntilChanged());
        this.hovered$ = combineLatest([
            this.directiveHovered$.pipe(startWith$1(false)),
            this.tooltipWindowHovered$.pipe(startWith$1(false)),
        ]).pipe(map(([directiveHovered, windowsHovered]) => directiveHovered || windowsHovered), distinctUntilChanged());
        this.show$ = this.hovered$.pipe(filter((hovered) => !!hovered), // '!!' To not have: Use a closure instead of a thisArg. Signatures accepting a thisArg will be removed in v8.
        tap$1(() => this.cancelHide$.next()), filter(() => !this.overlayRef?.hasAttached()), switchMap$1(() => {
            return timer(this.showDelay).pipe(takeUntil(this.cancelShow$), tap$1(() => this.show()));
        }));
        this.close$ = this.hovered$.pipe(filter((hovered) => !hovered), tap$1(() => this.cancelShow$.next()), switchMap$1(() => {
            return timer(this.hideDelay).pipe(takeUntil(this.cancelHide$), tap$1(() => this.hide()));
        }));
    }
    get nativeElement() {
        return this.elementRef.nativeElement;
    }
    get contentEmpty() {
        return (!this.hiveTooltipHeading &&
            !this.hiveTooltipDescription &&
            !this.hiveTooltipCustomContentTemplateRef);
    }
    ngOnInit() {
        const position = PredefinedPositions[this.hiveTooltipPosition];
        const positionStrategy = this.overlay
            .position()
            .flexibleConnectedTo(this.nativeElement)
            .withPositions([position]);
        this.overlayConfig = new OverlayConfig({
            positionStrategy: positionStrategy,
            scrollStrategy: this.overlay.scrollStrategies.reposition(),
            panelClass: ['hive-root', `hive-theme-${this.theming$.getValue()}`],
        });
        merge(this.show$, this.close$)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe();
    }
    ngOnChanges(changes) {
        if (changes['position'] || changes['hiveTooltipPosition']) {
            this.overlayRef?.updatePositionStrategy(this.overlay
                .position()
                .flexibleConnectedTo(this.nativeElement)
                .withPositions([
                PredefinedPositions[this.hiveTooltipPosition],
            ]));
        }
    }
    /**
     * Show the tooltip if not disabled and the content is not empty
     */
    show() {
        if (this.disableTooltip || this.contentEmpty) {
            return;
        }
        this.createWindow();
    }
    /**
     * Hide the tooltip
     */
    hide() {
        this.overlayRef?.detach();
        this.overlayRef?.dispose();
    }
    ngOnDestroy() {
        this.hide();
    }
    createWindow() {
        this.overlayRef = this.overlay.create(this.overlayConfig);
        const portal = new ComponentPortal(TooltipWindowComponent);
        const componentRef = this.overlayRef?.attach(portal);
        if (componentRef) {
            componentRef.instance.heading = this.hiveTooltipHeading;
            componentRef.instance.description = this.hiveTooltipDescription;
            componentRef.instance.customContentTemplateRef =
                this.hiveTooltipCustomContentTemplateRef;
            componentRef.instance.customContentContext =
                this.hiveTooltipCustomContentContext;
            componentRef.instance.position = this.hiveTooltipPosition;
            componentRef.instance.windowClass = this.windowClass ?? '';
            this.tooltipWindow.next(componentRef.instance);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TooltipDirective, deps: [{ token: i1$1.Overlay }, { token: i0.ElementRef }, { token: HIVE_THEMING }, { token: DOCUMENT }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "16.1.0", version: "17.3.12", type: TooltipDirective, isStandalone: true, selector: "[hiveTooltip]", inputs: { hiveTooltipHeading: "hiveTooltipHeading", hiveTooltipDescription: "hiveTooltipDescription", hiveTooltipCustomContentTemplateRef: "hiveTooltipCustomContentTemplateRef", hiveTooltipCustomContentContext: "hiveTooltipCustomContentContext", disableTooltip: ["disableTooltip", "disableTooltip", booleanAttribute], hiveTooltipPosition: "hiveTooltipPosition", hideDelay: ["hideDelay", "hideDelay", numberAttribute], showDelay: ["showDelay", "showDelay", numberAttribute], windowClass: "windowClass" }, outputs: { tooltipWindowHovered: "tooltipWindowHovered" }, usesOnChanges: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TooltipDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[hiveTooltip]',
                    standalone: true,
                }]
        }], ctorParameters: () => [{ type: i1$1.Overlay }, { type: i0.ElementRef }, { type: i4.BehaviorSubject, decorators: [{
                    type: Inject,
                    args: [HIVE_THEMING]
                }] }, { type: Document, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }], propDecorators: { hiveTooltipHeading: [{
                type: Input
            }], hiveTooltipDescription: [{
                type: Input
            }], hiveTooltipCustomContentTemplateRef: [{
                type: Input
            }], hiveTooltipCustomContentContext: [{
                type: Input
            }], disableTooltip: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], hiveTooltipPosition: [{
                type: Input
            }], hideDelay: [{
                type: Input,
                args: [{ transform: numberAttribute }]
            }], showDelay: [{
                type: Input,
                args: [{ transform: numberAttribute }]
            }], windowClass: [{
                type: Input
            }], tooltipWindowHovered: [{
                type: Output
            }] } });

class TooltipModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TooltipModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: TooltipModule, declarations: [TooltipWindowComponent], imports: [CommonModule,
            TooltipDirective,
            OverlayModule,
            PortalModule,
            IsStringPipe,
            IsDefinedPipe], exports: [TooltipWindowComponent, TooltipDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TooltipModule, imports: [CommonModule,
            OverlayModule,
            PortalModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TooltipModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [TooltipWindowComponent],
                    imports: [
                        CommonModule,
                        TooltipDirective,
                        OverlayModule,
                        PortalModule,
                        IsStringPipe,
                        IsDefinedPipe,
                    ],
                    exports: [TooltipWindowComponent, TooltipDirective],
                }]
        }] });

function oneOfOrDefault(value, defaultValue, ...values) {
    return values.includes(value) ? value : defaultValue;
}

function linkSizeAttribute(size) {
    return oneOfOrDefault(size, 'large', 'medium', 'small', 'smallest');
}
/**
 * Links are clickable elements that take the user to
 * a different location within the same page,
 * or to a different page or website altogether.
 *
 * By default, the linked document will open in the same frame as the link.
 * When a link is 'external', the linked document will instead open in a new tab.
 */
class LinkComponent {
    constructor() {
        this.cssClass = true;
        /**
         * Whether the link is disabled.
         */
        this.disabled = false;
        /**
         * The size of the link.
         */
        this.size = 'small';
        /**
         * Whether the link is external. External will open the link in a new tab,
         * and is indicated visually by an icon appended to the link text.
         *
         * @default false
         */
        this.external = false;
    }
    get sizeClass() {
        return `hive-link-size--${this.size}`;
    }
    get disabledAttribute() {
        return this.disabled ? '' : null;
    }
    get target() {
        return this.external ? '_blank' : '_self';
    }
    get tabIndex() {
        return this.disabled ? -1 : 0;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: LinkComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.3.12", type: LinkComponent, isStandalone: true, selector: "a[hive-link]", inputs: { disabled: ["disabled", "disabled", booleanAttribute], size: ["size", "size", linkSizeAttribute], external: ["external", "external", booleanAttribute] }, host: { properties: { "class.hive-link": "this.cssClass", "class.hive-link--disabled": "this.disabled", "class": "this.sizeClass", "attr.disabled": "this.disabledAttribute", "attr.target": "this.target", "attr.tabindex": "this.tabIndex" } }, hostDirectives: [{ directive: HiveThemedDirective }], ngImport: i0, template: "<ng-content></ng-content>\n\n@if (external) {\n    <hive-icon-component\n        class=\"hive-link_icon\"\n        [class.hive-link_icon--disabled]=\"disabled\"\n        icon=\"regular/arrow-up-right-from-square.svg\"\n        size=\"smallest\"\n    ></hive-icon-component>\n}\n", dependencies: [{ kind: "component", type: IconComponent, selector: "hive-icon-component", inputs: ["icon", "size"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: LinkComponent, decorators: [{
            type: Component,
            args: [{ selector: 'a[hive-link]', standalone: true, imports: [IconComponent], changeDetection: ChangeDetectionStrategy.OnPush, hostDirectives: [HiveThemedDirective], template: "<ng-content></ng-content>\n\n@if (external) {\n    <hive-icon-component\n        class=\"hive-link_icon\"\n        [class.hive-link_icon--disabled]=\"disabled\"\n        icon=\"regular/arrow-up-right-from-square.svg\"\n        size=\"smallest\"\n    ></hive-icon-component>\n}\n" }]
        }], propDecorators: { cssClass: [{
                type: HostBinding,
                args: ['class.hive-link']
            }], disabled: [{
                type: HostBinding,
                args: ['class.hive-link--disabled']
            }, {
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], sizeClass: [{
                type: HostBinding,
                args: ['class']
            }], size: [{
                type: Input,
                args: [{ transform: linkSizeAttribute }]
            }], external: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], disabledAttribute: [{
                type: HostBinding,
                args: ['attr.disabled']
            }], target: [{
                type: HostBinding,
                args: ['attr.target']
            }], tabIndex: [{
                type: HostBinding,
                args: ['attr.tabindex']
            }] } });

/**
 * @description
 * Labels are static text or information that used to provide instructions, to identify fields or sections of the interface, or to display other relevant information.
 *
 * @example
 * <!--Text only-->
 * <hive-label label="Label Text"></hive-label>
 *
 * @example
 * <!--Text and defined weight and size-->
 * <hive-label label="Label Text" weight="bold" size="large"></hive-label>
 *
 * @example
 * <!--Text and left icon with tooltip-->
 * <hive-label label="Label Text" leftIcon="icon-name" leftIconHelpInfoMessage="Tooltip text"></hive-label>
 *
 * @example
 * <!--Text and right icon-->
 * <hive-label label="Label Text" rightIcon="icon-name"></hive-label>
 *
 * @example
 * <!--Text and required-->
 * <hive-label label="Label Text" required></hive-label>
 */
class LabelComponent {
    constructor() {
        /**
         * Size of the label.
         */
        this.size = 'small';
        /**
         * Weight of the label.
         */
        this.weight = 'regular';
        /**
         * Aligns the content.
         */
        this.horizontalAlignment = 'left';
        /**
         * In some cases, you might want to truncate the text with an ellipsis
         * when it exceeds the width of the label.
         * This property allows you to enable this behavior.
         */
        this.textOverflowEllipsis = false;
        this.isString = isString;
    }
    /**
     * Returns proper icon size based on the `size` property.
     *
     * @protected
     */
    get iconSize() {
        return this.size === 'smallest' || this.size === 'small'
            ? 'small'
            : 'medium';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: LabelComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.3.12", type: LabelComponent, isStandalone: true, selector: "hive-label", inputs: { label: "label", for: "for", size: "size", weight: "weight", maxWeight: "maxWeight", horizontalAlignment: "horizontalAlignment", leftIconHelpInfoMessage: "leftIconHelpInfoMessage", rightIconHelpInfoMessage: "rightIconHelpInfoMessage", leftIcon: "leftIcon", rightIcon: "rightIcon", required: ["required", "required", booleanAttribute], textOverflowEllipsis: ["textOverflowEllipsis", "textOverflowEllipsis", booleanAttribute] }, hostDirectives: [{ directive: HiveThemedDirective }], ngImport: i0, template: "<div\n    class=\"hive-label\"\n    [ngClass]=\"['hive-label--align-' + this.horizontalAlignment]\"\n>\n    @if (leftIcon | isDefined) {\n        <hive-icon-component\n            class=\"hive-label_icon hive-label_icon-left\"\n            data-role=\"left-icon\"\n            hiveTooltip\n            [hiveTooltipDescription]=\"\n                isString(leftIconHelpInfoMessage)\n                    ? leftIconHelpInfoMessage\n                    : null\n            \"\n            [hiveTooltipCustomContentTemplateRef]=\"\n                !isString(leftIconHelpInfoMessage)\n                    ? leftIconHelpInfoMessage\n                    : null\n            \"\n            [icon]=\"leftIcon\"\n            [size]=\"iconSize\"\n        ></hive-icon-component>\n    }\n\n    @if (label | isDefined) {\n        <div\n            class=\"hive-label_text\"\n            [ngClass]=\"[\n                'hive-label_text--size-' + size,\n                'hive-label_text--weight-' + weight,\n                maxWeight ? 'hive-label_text--max_weight-' + maxWeight : '',\n                textOverflowEllipsis\n                    ? 'hive-label_text--overflow-ellipsis'\n                    : '',\n            ]\"\n        >\n            <label\n                class=\"hive-label_text-label\"\n                data-role=\"text\"\n                [for]=\"for\"\n                [attr.label]=\"!!maxWeight ? label : undefined\"\n            >\n                {{ label }}\n            </label>\n            @if (required) {\n                <span\n                    class=\"hive-label_required\"\n                    data-role=\"required-indication\"\n                >\n                    *\n                </span>\n            }\n        </div>\n    }\n\n    @if (rightIcon | isDefined) {\n        <hive-icon-component\n            class=\"hive-label_icon hive-label_icon--right\"\n            data-role=\"right-icon\"\n            hiveTooltip\n            [hiveTooltipDescription]=\"\n                isString(rightIconHelpInfoMessage)\n                    ? rightIconHelpInfoMessage\n                    : null\n            \"\n            [hiveTooltipCustomContentTemplateRef]=\"\n                !isString(rightIconHelpInfoMessage)\n                    ? rightIconHelpInfoMessage\n                    : null\n            \"\n            [icon]=\"rightIcon\"\n            [size]=\"iconSize\"\n        ></hive-icon-component>\n    }\n</div>\n", dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i2$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "component", type: IconComponent, selector: "hive-icon-component", inputs: ["icon", "size"] }, { kind: "ngmodule", type: TooltipModule }, { kind: "directive", type: TooltipDirective, selector: "[hiveTooltip]", inputs: ["hiveTooltipHeading", "hiveTooltipDescription", "hiveTooltipCustomContentTemplateRef", "hiveTooltipCustomContentContext", "disableTooltip", "hiveTooltipPosition", "hideDelay", "showDelay", "windowClass"], outputs: ["tooltipWindowHovered"] }, { kind: "pipe", type: IsDefinedPipe, name: "isDefined" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: LabelComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hive-label', changeDetection: ChangeDetectionStrategy.OnPush, imports: [
                        CommonModule,
                        IconComponent,
                        TooltipModule,
                        IsDefinedPipe,
                        LinkComponent,
                    ], standalone: true, hostDirectives: [HiveThemedDirective], template: "<div\n    class=\"hive-label\"\n    [ngClass]=\"['hive-label--align-' + this.horizontalAlignment]\"\n>\n    @if (leftIcon | isDefined) {\n        <hive-icon-component\n            class=\"hive-label_icon hive-label_icon-left\"\n            data-role=\"left-icon\"\n            hiveTooltip\n            [hiveTooltipDescription]=\"\n                isString(leftIconHelpInfoMessage)\n                    ? leftIconHelpInfoMessage\n                    : null\n            \"\n            [hiveTooltipCustomContentTemplateRef]=\"\n                !isString(leftIconHelpInfoMessage)\n                    ? leftIconHelpInfoMessage\n                    : null\n            \"\n            [icon]=\"leftIcon\"\n            [size]=\"iconSize\"\n        ></hive-icon-component>\n    }\n\n    @if (label | isDefined) {\n        <div\n            class=\"hive-label_text\"\n            [ngClass]=\"[\n                'hive-label_text--size-' + size,\n                'hive-label_text--weight-' + weight,\n                maxWeight ? 'hive-label_text--max_weight-' + maxWeight : '',\n                textOverflowEllipsis\n                    ? 'hive-label_text--overflow-ellipsis'\n                    : '',\n            ]\"\n        >\n            <label\n                class=\"hive-label_text-label\"\n                data-role=\"text\"\n                [for]=\"for\"\n                [attr.label]=\"!!maxWeight ? label : undefined\"\n            >\n                {{ label }}\n            </label>\n            @if (required) {\n                <span\n                    class=\"hive-label_required\"\n                    data-role=\"required-indication\"\n                >\n                    *\n                </span>\n            }\n        </div>\n    }\n\n    @if (rightIcon | isDefined) {\n        <hive-icon-component\n            class=\"hive-label_icon hive-label_icon--right\"\n            data-role=\"right-icon\"\n            hiveTooltip\n            [hiveTooltipDescription]=\"\n                isString(rightIconHelpInfoMessage)\n                    ? rightIconHelpInfoMessage\n                    : null\n            \"\n            [hiveTooltipCustomContentTemplateRef]=\"\n                !isString(rightIconHelpInfoMessage)\n                    ? rightIconHelpInfoMessage\n                    : null\n            \"\n            [icon]=\"rightIcon\"\n            [size]=\"iconSize\"\n        ></hive-icon-component>\n    }\n</div>\n" }]
        }], propDecorators: { label: [{
                type: Input
            }], for: [{
                type: Input
            }], size: [{
                type: Input
            }], weight: [{
                type: Input
            }], maxWeight: [{
                type: Input
            }], horizontalAlignment: [{
                type: Input
            }], leftIconHelpInfoMessage: [{
                type: Input
            }], rightIconHelpInfoMessage: [{
                type: Input
            }], leftIcon: [{
                type: Input
            }], rightIcon: [{
                type: Input
            }], required: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], textOverflowEllipsis: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }] } });

function stringOrUndefinedAttribute(value) {
    return value === undefined || value === null ? undefined : String(value);
}

function loadingSpinnerModeAttribute(value) {
    return oneOfOrDefault(value, undefined, 'centered', 'overlay', 'fullscreen');
}
function loadingSpinnerSizeAttribute(value) {
    return oneOfOrDefault(value, 'medium', 'smallest', 'small', 'medium', 'large', 'x-large');
}
function loadingSpinnerOrientationAttribute(value) {
    return oneOfOrDefault(value, 'vertical', 'horizontal');
}
/**
 * **Note: A 100ms delay occurs before showing a spinner to mitigate unnecessary
 * spinners showing up at the same time when load times are minimal.**
 *
 * **Note: Sizing and Text are only available for UINext theme.**
 *
 * **Note: `centered` spinner has `height: 100%` property.
 * If parent container has other elements/uneven paddings, spinner might be misaligned.**
 *
 * @example
 * <!--Regular use-case-->
 * <hive-loading-spinner></hive-loading-spinner>
 *
 * @example
 * <!-- Non-centered overlay spinner-->
 * <hive-loading-spinner displayMode="overlay"></hive-loading-spinner>
 *
 * @example
 * <!-- Non-centered overlay spinner with custom text-->
 * <hive-loading-spinner displayMode="overlay" label="..."></hive-loading-spinner>
 */
class LoadingSpinnerComponent {
    constructor() {
        /**
         * The orientation of the spinner.
         *
         */
        this.orientation = 'vertical';
        /**
         * The size of the spinner.
         *
         */
        this.size = 'medium';
        this.Themes = Themes;
    }
    get labelSize() {
        return this.size === 'x-large' ? 'small' : 'smallest';
    }
    get containerClass() {
        return {
            'hive-loading-spinner_position-container--centered': this.displayMode === 'centered',
            'hive-loading-spinner_position-container--overlay': this.displayMode === 'overlay',
            'hive-loading-spinner_position-container--fullscreen': this.displayMode === 'fullscreen',
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: LoadingSpinnerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.3.12", type: LoadingSpinnerComponent, isStandalone: true, selector: "hive-loading-spinner", inputs: { displayMode: ["displayMode", "displayMode", loadingSpinnerModeAttribute], orientation: ["orientation", "orientation", loadingSpinnerOrientationAttribute], label: ["label", "label", stringOrUndefinedAttribute], size: ["size", "size", loadingSpinnerSizeAttribute] }, hostDirectives: [{ directive: HiveThemedDirective }], ngImport: i0, template: "<div\n    class=\"hive-loading-spinner hive-loading-spinner_position-container\"\n    [ngClass]=\"containerClass\"\n>\n    <div\n        class=\"hive-loading-spinner_container\"\n        [ngClass]=\"[\n            'hive-loading-spinner_container--' + (this.size ?? 'medium'),\n            'hive-loading-spinner_container--' +\n                (this.orientation ?? 'vertical'),\n        ]\"\n    >\n        <svg\n            class=\"hive-loading-spinner_icon\"\n            fill=\"none\"\n            viewBox=\"0 0 41 40\"\n            xmlns=\"http://www.w3.org/2000/svg\"\n        >\n            <path\n                class=\"hive-loading-spinner_indicator\"\n                d=\"M38 20C38 22.2981 37.5474 24.5738 36.6679 26.697C35.7884 28.8202 34.4994 30.7493 32.8744 32.3744C31.2493 33.9994 29.3202 35.2884 27.197 36.1679C25.0738 37.0473 22.7981 37.5 20.5 37.5C18.2019 37.5 15.9262 37.0473 13.803 36.1679C11.6798 35.2884 9.75065 33.9994 8.12563 32.3744C6.5006 30.7493 5.21156 28.8202 4.33211 26.697C3.45265 24.5738 3 22.2981 3 20C3 17.7019 3.45265 15.4262 4.33211 13.303C5.21157 11.1798 6.50061 9.25065 8.12564 7.62563C9.75066 6.0006 11.6798 4.71156 13.803 3.83211C15.9262 2.95265 18.2019 2.5 20.5 2.5C22.7981 2.5 25.0738 2.95265 27.197 3.83211C29.3202 4.71157 31.2494 6.00061 32.8744 7.62564C34.4994 9.25066 35.7884 11.1799 36.6679 13.303C37.5474 15.4262 38 17.7019 38 20L38 20Z\"\n                stroke-linecap=\"round\"\n                stroke-linejoin=\"round\"\n            />\n            <path\n                class=\"hive-loading-spinner_background\"\n                d=\"M20.5 2.5C24.1956 2.5 27.7964 3.66996 30.7862 5.8422C33.7761 8.01444 36.0015 11.0774 37.1435 14.5922C38.2855 18.107 38.2855 21.893 37.1435 25.4078C36.0015 28.9226 33.7761 31.9856 30.7862 34.1578C27.7964 36.33 24.1956 37.5 20.5 37.5C16.8044 37.5 13.2036 36.33 10.2138 34.1578C7.22392 31.9856 4.99852 28.9226 3.85651 25.4078C2.7145 21.893 2.7145 18.107 3.85651 14.5922\"\n                stroke-linecap=\"round\"\n                stroke-linejoin=\"round\"\n            />\n        </svg>\n\n        @if (label | isDefined) {\n            <hive-label\n                class=\"hive-loading-spinner_label\"\n                [size]=\"labelSize\"\n                weight=\"regular\"\n                [label]=\"label\"\n            />\n        }\n    </div>\n</div>\n", dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i2$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "pipe", type: IsDefinedPipe, name: "isDefined" }, { kind: "component", type: LabelComponent, selector: "hive-label", inputs: ["label", "for", "size", "weight", "maxWeight", "horizontalAlignment", "leftIconHelpInfoMessage", "rightIconHelpInfoMessage", "leftIcon", "rightIcon", "required", "textOverflowEllipsis"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: LoadingSpinnerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hive-loading-spinner', standalone: true, imports: [CommonModule, IsDefinedPipe, LabelComponent], hostDirectives: [HiveThemedDirective], changeDetection: ChangeDetectionStrategy.OnPush, template: "<div\n    class=\"hive-loading-spinner hive-loading-spinner_position-container\"\n    [ngClass]=\"containerClass\"\n>\n    <div\n        class=\"hive-loading-spinner_container\"\n        [ngClass]=\"[\n            'hive-loading-spinner_container--' + (this.size ?? 'medium'),\n            'hive-loading-spinner_container--' +\n                (this.orientation ?? 'vertical'),\n        ]\"\n    >\n        <svg\n            class=\"hive-loading-spinner_icon\"\n            fill=\"none\"\n            viewBox=\"0 0 41 40\"\n            xmlns=\"http://www.w3.org/2000/svg\"\n        >\n            <path\n                class=\"hive-loading-spinner_indicator\"\n                d=\"M38 20C38 22.2981 37.5474 24.5738 36.6679 26.697C35.7884 28.8202 34.4994 30.7493 32.8744 32.3744C31.2493 33.9994 29.3202 35.2884 27.197 36.1679C25.0738 37.0473 22.7981 37.5 20.5 37.5C18.2019 37.5 15.9262 37.0473 13.803 36.1679C11.6798 35.2884 9.75065 33.9994 8.12563 32.3744C6.5006 30.7493 5.21156 28.8202 4.33211 26.697C3.45265 24.5738 3 22.2981 3 20C3 17.7019 3.45265 15.4262 4.33211 13.303C5.21157 11.1798 6.50061 9.25065 8.12564 7.62563C9.75066 6.0006 11.6798 4.71156 13.803 3.83211C15.9262 2.95265 18.2019 2.5 20.5 2.5C22.7981 2.5 25.0738 2.95265 27.197 3.83211C29.3202 4.71157 31.2494 6.00061 32.8744 7.62564C34.4994 9.25066 35.7884 11.1799 36.6679 13.303C37.5474 15.4262 38 17.7019 38 20L38 20Z\"\n                stroke-linecap=\"round\"\n                stroke-linejoin=\"round\"\n            />\n            <path\n                class=\"hive-loading-spinner_background\"\n                d=\"M20.5 2.5C24.1956 2.5 27.7964 3.66996 30.7862 5.8422C33.7761 8.01444 36.0015 11.0774 37.1435 14.5922C38.2855 18.107 38.2855 21.893 37.1435 25.4078C36.0015 28.9226 33.7761 31.9856 30.7862 34.1578C27.7964 36.33 24.1956 37.5 20.5 37.5C16.8044 37.5 13.2036 36.33 10.2138 34.1578C7.22392 31.9856 4.99852 28.9226 3.85651 25.4078C2.7145 21.893 2.7145 18.107 3.85651 14.5922\"\n                stroke-linecap=\"round\"\n                stroke-linejoin=\"round\"\n            />\n        </svg>\n\n        @if (label | isDefined) {\n            <hive-label\n                class=\"hive-loading-spinner_label\"\n                [size]=\"labelSize\"\n                weight=\"regular\"\n                [label]=\"label\"\n            />\n        }\n    </div>\n</div>\n" }]
        }], propDecorators: { displayMode: [{
                type: Input,
                args: [{ transform: loadingSpinnerModeAttribute }]
            }], orientation: [{
                type: Input,
                args: [{ transform: loadingSpinnerOrientationAttribute }]
            }], label: [{
                type: Input,
                args: [{ transform: stringOrUndefinedAttribute }]
            }], size: [{
                type: Input,
                args: [{ transform: loadingSpinnerSizeAttribute }]
            }] } });

/**
 * Buttons allow users to perform actions such as submitting a form,
 * navigating to a new page, or initiating a process.
 *
 * A button can be text-only, icon-only, or have both text and an icon.
 * For icon-only buttons, a tooltip with a label on mouse hover is mandatory.
 * This will help users understand the meaning and action of the icon on the button.
 */
class ButtonComponent {
    /**
     * Size of the button. The 4 sizes are:
     * 'smallest', 'small', 'medium' and 'large'.
     * @default 'small'
     */
    set size(val) {
        this._size = val ?? 'small';
        this.changeDetectorRef.markForCheck();
    }
    get size() {
        return this._size;
    }
    // The following can be used as attributes without a boolean value passed explicitly
    /**
     * Provide to display loading spinner.
     * @default false
     */
    set isLoading(value) {
        this._isLoading = value;
    }
    get isLoading() {
        return this._isLoading;
    }
    /**
     * Whether the button should be disabled. When disabled, the button
     * will appear greyed-out, and will not be clickable.
     * NOTE: It can be overridden by MenuButtonDirective or loading state.
     * @default false
     */
    set disabled(disabled) {
        this._disabled = disabled;
        this.changeDetectorRef.markForCheck();
    }
    get disabled() {
        return (this._disabled ||
            this._disabledByMenuButton ||
            this._isLoading ||
            null);
    }
    /**
     * Creates a button with a more rounded border. When used with just an icon,
     * creates a circular button.
     * @default false
     */
    set rounded(rounded) {
        this._rounded = rounded;
        this.changeDetectorRef.markForCheck();
    }
    get rounded() {
        return this._rounded;
    }
    get widthClass() {
        return 'hive-button--width-' + this.width;
    }
    get iconAndText() {
        return isDefined(this.icon) && isDefined(this.label);
    }
    /**
     * Checks if the button has only an icon and no label.
     */
    get iconOnly() {
        return !isDefined(this.label) && isDefined(this.icon);
    }
    get isIconOnlyVisible() {
        return this.iconOnly && !this.isLoading;
    }
    get isLabelVisible() {
        return ((isDefined(this.label) || isDefined(this.icon)) && !this.iconOnly);
    }
    /**
     * Checks if the left icon should be visible.
     */
    get isLeftIconVisible() {
        if (this.iconPosition !== 'left') {
            return false;
        }
        if (this.isLoading) {
            return false;
        }
        return true;
    }
    /**
     * Checks if the right icon should be visible.
     */
    get isRightIconVisible() {
        if (this.iconPosition !== 'right') {
            return false;
        }
        return true;
    }
    get buttonClass() {
        return {
            ['hive-button--' + this.emphasis]: true,
            ['hive-button--' + this.size]: true,
            'hive-button--menu-button-active': this.menuButtonActive,
            'hive-button--has-menu-button-caret': this.hasMenuButtonCaret,
            'hive-button--rounded': this.rounded,
            'hive-button--text-and-icon': this.iconAndText,
            'hive-button--icon-only': this.iconOnly,
            'hive-button--icon-right': this.iconPosition === 'right',
            'hive-button--width-auto': this.width === 'auto',
            'hive-button--loading': this.isLoading,
        };
    }
    /**
     * @internal Used by other Hive components. Do not use outside of Hive.
     */
    set disabledByMenuButton(disabled) {
        this._disabledByMenuButton = disabled;
        this.changeDetectorRef.markForCheck();
    }
    constructor(changeDetectorRef) {
        this.changeDetectorRef = changeDetectorRef;
        /**
         *  HTML Button type.
         *  @default 'button'
         */
        this.type = 'button';
        /**
         * Whether the button is active or not.
         *
         * Represents a certain state which is used in `hive-menu-button`
         *
         * @internal do not use outside the library
         */
        this.menuButtonActive = false;
        /**
         * Whether the button has a caret icon.
         *
         * @internal do not use outside the library
         */
        this.hasMenuButtonCaret = false;
        /**
         * When used along with both {@link label} and {@link icon}, determines
         * whether the icon will appear to the left or right of the text.
         *
         * @default 'left'
         */
        this.iconPosition = 'left';
        /**
         * Emphasis level for button. The 4 states are:
         * 'primary', 'secondary', 'tertiary', and 'destructive'.
         * @default 'primary'
         */
        this.emphasis = 'primary';
        this._size = 'small';
        /**
         * Defines width of the button.
         * By default, it's size depends on the content.
         * Fit-parent will make the button take the full width of the parent container.
         * @default 'auto'
         */
        this.width = 'auto';
        this.iconOnlySize = {
            smallest: 'small',
            small: 'medium',
            medium: 'large',
            large: 'x-large',
        };
        this.loadingSpinnerSize = {
            smallest: 'smallest',
            small: 'small',
            medium: 'small',
            large: 'medium',
        };
        this._disabledByMenuButton = false;
        this._disabled = false;
        this._rounded = false;
        this._isLoading = false;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ButtonComponent, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.3.12", type: ButtonComponent, isStandalone: true, selector: "hive-button", inputs: { type: "type", menuButtonActive: "menuButtonActive", hasMenuButtonCaret: "hasMenuButtonCaret", label: "label", accessibleName: "accessibleName", icon: "icon", iconPosition: "iconPosition", emphasis: "emphasis", title: "title", size: "size", isLoading: ["isLoading", "isLoading", booleanAttribute], disabled: ["disabled", "disabled", booleanAttribute], rounded: ["rounded", "rounded", booleanAttribute], width: "width" }, host: { properties: { "attr.disabled": "this.disabled", "class": "this.widthClass" } }, hostDirectives: [{ directive: HiveThemedDirective }], ngImport: i0, template: "<button\n    class=\"hive-button\"\n    [attr.aria-label]=\"accessibleName\"\n    [attr.type]=\"type\"\n    [attr.title]=\"title\"\n    [disabled]=\"disabled\"\n    [ngClass]=\"buttonClass\"\n>\n    @if (isLoading) {\n        <hive-loading-spinner\n            [size]=\"loadingSpinnerSize[_size]\"\n            class=\"hive-button_spinner\"\n        ></hive-loading-spinner>\n    }\n\n    @if (isLabelVisible) {\n        <hive-label\n            class=\"hive-button_label\"\n            weight=\"semibold\"\n            [label]=\"label\"\n            [size]=\"size\"\n            [leftIcon]=\"isLeftIconVisible ? icon : null\"\n            [rightIcon]=\"isRightIconVisible ? icon : null\"\n        ></hive-label>\n    }\n\n    @if (isIconOnlyVisible) {\n        <hive-icon-component\n            class=\"hive-button_icon-only-icon\"\n            [icon]=\"icon\"\n            [size]=\"iconOnlySize[_size]\"\n        ></hive-icon-component>\n    }\n\n    @if (hasMenuButtonCaret) {\n        <hive-icon-component\n            hiveChevron\n            class=\"hive-button_caret-icon\"\n            icon=\"light/chevron-down.svg\"\n            size=\"small\"\n            [rotated]=\"menuButtonActive\"\n        ></hive-icon-component>\n    }\n</button>\n", dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i2$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "component", type: IconComponent, selector: "hive-icon-component", inputs: ["icon", "size"] }, { kind: "component", type: LoadingSpinnerComponent, selector: "hive-loading-spinner", inputs: ["displayMode", "orientation", "label", "size"] }, { kind: "component", type: LabelComponent, selector: "hive-label", inputs: ["label", "for", "size", "weight", "maxWeight", "horizontalAlignment", "leftIconHelpInfoMessage", "rightIconHelpInfoMessage", "leftIcon", "rightIcon", "required", "textOverflowEllipsis"] }, { kind: "directive", type: ChevronDirective, selector: "hive-icon-component[hiveChevron]", inputs: ["rotationDirection", "rotated"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ButtonComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hive-button', standalone: true, imports: [
                        CommonModule,
                        SvgDirective,
                        IconComponent,
                        LoadingSpinnerComponent,
                        LabelComponent,
                        IsDefinedPipe,
                        ChevronDirective,
                    ], changeDetection: ChangeDetectionStrategy.OnPush, hostDirectives: [HiveThemedDirective], template: "<button\n    class=\"hive-button\"\n    [attr.aria-label]=\"accessibleName\"\n    [attr.type]=\"type\"\n    [attr.title]=\"title\"\n    [disabled]=\"disabled\"\n    [ngClass]=\"buttonClass\"\n>\n    @if (isLoading) {\n        <hive-loading-spinner\n            [size]=\"loadingSpinnerSize[_size]\"\n            class=\"hive-button_spinner\"\n        ></hive-loading-spinner>\n    }\n\n    @if (isLabelVisible) {\n        <hive-label\n            class=\"hive-button_label\"\n            weight=\"semibold\"\n            [label]=\"label\"\n            [size]=\"size\"\n            [leftIcon]=\"isLeftIconVisible ? icon : null\"\n            [rightIcon]=\"isRightIconVisible ? icon : null\"\n        ></hive-label>\n    }\n\n    @if (isIconOnlyVisible) {\n        <hive-icon-component\n            class=\"hive-button_icon-only-icon\"\n            [icon]=\"icon\"\n            [size]=\"iconOnlySize[_size]\"\n        ></hive-icon-component>\n    }\n\n    @if (hasMenuButtonCaret) {\n        <hive-icon-component\n            hiveChevron\n            class=\"hive-button_caret-icon\"\n            icon=\"light/chevron-down.svg\"\n            size=\"small\"\n            [rotated]=\"menuButtonActive\"\n        ></hive-icon-component>\n    }\n</button>\n" }]
        }], ctorParameters: () => [{ type: i0.ChangeDetectorRef }], propDecorators: { type: [{
                type: Input
            }], menuButtonActive: [{
                type: Input
            }], hasMenuButtonCaret: [{
                type: Input
            }], label: [{
                type: Input
            }], accessibleName: [{
                type: Input
            }], icon: [{
                type: Input
            }], iconPosition: [{
                type: Input
            }], emphasis: [{
                type: Input
            }], title: [{
                type: Input
            }], size: [{
                type: Input
            }], isLoading: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], disabled: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }, {
                type: HostBinding,
                args: ['attr.disabled']
            }], rounded: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], width: [{
                type: Input
            }], widthClass: [{
                type: HostBinding,
                args: ['class']
            }] } });

const ON_ICON_PATH = '/light/check.svg';
const OFF_ICON_PATH = '/light/xmark.svg';
/**
 * Toggle Button allows a user to switch between two states, typically on/off or yes/no.
 */
class ToggleButtonComponent {
    constructor(cdr) {
        this.cdr = cdr;
        this._disabled = false;
        this._required = false;
        this._size = 'small';
        /**
         * The icon (svg path or FontAwesome icon string) shown when the button is in the "off" state (i.e. when
         * {@link checked} is 'false'. If not provided or an empty string, the toggle
         * button will use the default 'x' mark icon for the off state.
         */
        this.offIcon = '/light/xmark.svg';
        /**
         * The icon (svg path or FontAwesome icon string) shown when the button is in the "on" state (i.e. when
         * {@link checked} is 'true'. If not provided or an empty string, the toggle
         * button will use the default 'check' mark icon for the on state.
         */
        this.onIcon = '/light/check.svg';
        /**
         * Output event emitter associated with {@link checked}.
         */
        this.checkedChange = new EventEmitter();
        // Form Control implementation methods
        this.controlValueAccessorOnChange = () => { };
        this.controlValueAccessorOnTouched = () => { };
    }
    /**
     * Size of the button. The 4 sizes are:
     * 'smallest', 'small', 'medium', and 'large'.
     * @default 'small'
     */
    set size(value) {
        this._size = value;
        this.cdr.markForCheck();
    }
    get size() {
        return this._size;
    }
    /**
     * Whether the toggle button is checked ("on" state).
     */
    get checked() {
        return this._checked;
    }
    set checked(checked) {
        this._checked = checked ?? false;
        this.cdr.markForCheck();
    }
    /**
     * Whether the toggle button is disabled.
     * @default false
     */
    get disabled() {
        return this._disabled;
    }
    set disabled(disabled) {
        this._disabled = coerceBooleanProperty(disabled);
        this.cdr.markForCheck();
    }
    /**
     * Whether the toggle button is required (for use with forms).
     * @default false
     */
    get required() {
        return this._required;
    }
    set required(required) {
        this._required = coerceBooleanProperty(required);
    }
    /**
     * A value associated with the toggle being {@link checked}.
     * For use in form or Select Button Group.
     */
    get value() {
        return this._value;
    }
    set value(value) {
        if (this._value !== value) {
            this._value = value;
            this.checked = false;
        }
    }
    /**
     * @internal
     */
    ngOnChanges(changes) {
        if (changes['checked'] ||
            changes['offLabel'] ||
            changes['onLabel'] ||
            changes['label']) {
            this._currentLabel = this.determineLabel();
        }
        if (changes['checked'] ||
            changes['offIcon'] ||
            changes['onIcon'] ||
            changes['icon']) {
            this._currentIcon = this.determineIcon();
        }
    }
    /**
     * @internal
     */
    onClickToggle() {
        if (!this.disabled) {
            this.checked = !this.checked;
            this.controlValueAccessorOnTouched();
            this.controlValueAccessorOnChange(this.checked);
            this.checkedChange.emit(this.checked);
        }
    }
    /**
     * @internal
     */
    writeValue(checked) {
        if (this.checked !== checked && !this.disabled) {
            this.checked = checked;
            this.checkedChange.emit(this.checked);
            this.cdr.markForCheck();
        }
    }
    /**
     * @internal
     */
    registerOnChange(fn) {
        this.controlValueAccessorOnChange = fn;
    }
    /**
     * @internal
     */
    registerOnTouched(fn) {
        this.controlValueAccessorOnTouched = fn;
    }
    /**
     * @internal
     */
    setDisabledState(disabled) {
        this.disabled = disabled;
    }
    /**
     * @internal
     */
    validate(control) {
        if (this.required && control.value !== true) {
            return {
                required: true,
            };
        }
        return null;
    }
    determineLabel() {
        if (this.label !== null && this.label !== undefined) {
            return this.label;
        }
        else if (this.checked) {
            return this.onLabel;
        }
        else {
            return this.offLabel;
        }
    }
    determineIcon() {
        if (this.icon !== null &&
            this.icon !== undefined &&
            this.icon.length > 0) {
            return this.icon;
        }
        else if (this.checked) {
            return this.onIcon || ON_ICON_PATH;
        }
        else {
            return this.offIcon || OFF_ICON_PATH;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ToggleButtonComponent, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: ToggleButtonComponent, isStandalone: true, selector: "hive-toggle-button", inputs: { offAccessibleName: "offAccessibleName", onAccessibleName: "onAccessibleName", size: "size", offLabel: "offLabel", onLabel: "onLabel", label: "label", offIcon: "offIcon", onIcon: "onIcon", icon: "icon", checked: "checked", disabled: "disabled", required: "required", value: "value" }, outputs: { checkedChange: "checkedChange" }, providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                multi: true,
                useExisting: forwardRef(() => ToggleButtonComponent),
            },
            {
                provide: NG_VALIDATORS,
                multi: true,
                useExisting: forwardRef(() => ToggleButtonComponent),
            },
        ], usesOnChanges: true, hostDirectives: [{ directive: HiveThemedDirective }], ngImport: i0, template: "<hive-button\n    emphasis=\"tertiary\"\n    [accessibleName]=\"checked ? onAccessibleName : offAccessibleName\"\n    [size]=\"_size\"\n    [label]=\"_currentLabel\"\n    [icon]=\"_currentIcon\"\n    [class.hive-toggle-checked]=\"checked\"\n    [class.hive-toggle-unchecked]=\"!checked\"\n    [disabled]=\"disabled\"\n    (click)=\"onClickToggle()\"\n>\n</hive-button>\n", dependencies: [{ kind: "component", type: ButtonComponent, selector: "hive-button", inputs: ["type", "menuButtonActive", "hasMenuButtonCaret", "label", "accessibleName", "icon", "iconPosition", "emphasis", "title", "size", "isLoading", "disabled", "rounded", "width"] }, { kind: "ngmodule", type: FormsModule }, { kind: "ngmodule", type: ReactiveFormsModule }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ToggleButtonComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hive-toggle-button', standalone: true, hostDirectives: [HiveThemedDirective], imports: [ButtonComponent, FormsModule, ReactiveFormsModule], providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            multi: true,
                            useExisting: forwardRef(() => ToggleButtonComponent),
                        },
                        {
                            provide: NG_VALIDATORS,
                            multi: true,
                            useExisting: forwardRef(() => ToggleButtonComponent),
                        },
                    ], changeDetection: ChangeDetectionStrategy.OnPush, template: "<hive-button\n    emphasis=\"tertiary\"\n    [accessibleName]=\"checked ? onAccessibleName : offAccessibleName\"\n    [size]=\"_size\"\n    [label]=\"_currentLabel\"\n    [icon]=\"_currentIcon\"\n    [class.hive-toggle-checked]=\"checked\"\n    [class.hive-toggle-unchecked]=\"!checked\"\n    [disabled]=\"disabled\"\n    (click)=\"onClickToggle()\"\n>\n</hive-button>\n" }]
        }], ctorParameters: () => [{ type: i0.ChangeDetectorRef }], propDecorators: { offAccessibleName: [{
                type: Input
            }], onAccessibleName: [{
                type: Input
            }], size: [{
                type: Input
            }], offLabel: [{
                type: Input
            }], onLabel: [{
                type: Input
            }], label: [{
                type: Input
            }], offIcon: [{
                type: Input
            }], onIcon: [{
                type: Input
            }], icon: [{
                type: Input
            }], checked: [{
                type: Input
            }], disabled: [{
                type: Input
            }], required: [{
                type: Input
            }], value: [{
                type: Input
            }], checkedChange: [{
                type: Output
            }] } });

class LeftNavigationModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: LeftNavigationModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: LeftNavigationModule, declarations: [LeftNavigationComponent,
            LeftNavigationItemComponent,
            DeprecatedAppNavigationDirective], imports: [CommonModule,
            ToggleButtonComponent,
            IconComponent,
            ChevronDirective], exports: [LeftNavigationComponent, LeftNavigationItemComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: LeftNavigationModule, imports: [CommonModule,
            ToggleButtonComponent,
            IconComponent] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: LeftNavigationModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        ToggleButtonComponent,
                        IconComponent,
                        ChevronDirective,
                    ],
                    declarations: [
                        LeftNavigationComponent,
                        LeftNavigationItemComponent,
                        DeprecatedAppNavigationDirective,
                    ],
                    exports: [LeftNavigationComponent, LeftNavigationItemComponent],
                }]
        }] });

/**
 * @deprecated Use 'LeftNavigationModule' instead. AppNavigationModule will be removed in the next major version.
 */
class AppNavigationModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AppNavigationModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: AppNavigationModule, imports: [LeftNavigationModule], exports: [LeftNavigationModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AppNavigationModule, imports: [LeftNavigationModule, LeftNavigationModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AppNavigationModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [LeftNavigationModule],
                    exports: [LeftNavigationModule],
                }]
        }] });

/**
 * @class
 * @property {HiveTemplate} name name of the template
 * */
class HiveTemplateDirective {
    constructor(template) {
        this.template = template;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: HiveTemplateDirective, deps: [{ token: i0.TemplateRef, host: true }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: HiveTemplateDirective, isStandalone: true, selector: "ng-template[hiveTemplate]", inputs: { name: ["hiveTemplate", "name"] }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: HiveTemplateDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'ng-template[hiveTemplate]',
                    standalone: true,
                }]
        }], ctorParameters: () => [{ type: i0.TemplateRef, decorators: [{
                    type: Host
                }] }], propDecorators: { name: [{
                type: Input,
                args: ['hiveTemplate']
            }] } });

function stringAttribute(value) {
    return String(value ?? '') || '';
}

/**
 * Directive to invert the colors of the element.
 * You can use the class `hive-inverted-colors` directly on the element, but this directive is provided for convenience and consistency.
 *
 * @internal This directive most likely will be used only at `hostDirectives` section of a component declaration.
 */
class InvertedColorsDirective {
    constructor() {
        this.hiveInvertedColors = false;
    }
    get hiveDirectColors() {
        return !this.hiveInvertedColors;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: InvertedColorsDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "16.1.0", version: "17.3.12", type: InvertedColorsDirective, isStandalone: true, selector: "[hiveInvertedColors]", inputs: { hiveInvertedColors: ["hiveInvertedColors", "hiveInvertedColors", booleanAttribute] }, host: { properties: { "class.hive-inverted-colors": "this.hiveInvertedColors", "class.hive-direct-colors": "this.hiveDirectColors" } }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: InvertedColorsDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[hiveInvertedColors]',
                    standalone: true,
                }]
        }], propDecorators: { hiveInvertedColors: [{
                type: HostBinding,
                args: ['class.hive-inverted-colors']
            }, {
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], hiveDirectColors: [{
                type: HostBinding,
                args: ['class.hive-direct-colors']
            }] } });

function badgesDotSizeAttribute(size) {
    return oneOfOrDefault(size, 'large', 'small', 'medium', 'large');
}
function badgesDotEmphasisAttribute(emphasis) {
    return oneOfOrDefault(emphasis, 'none', 'none', 'info', 'success', 'warning', 'major');
}
/**
 * Badge dot is primarily used to indicate user status does
 * and does not support any icons or labels as opposed to the badge component.
 */
class BadgeDotComponent {
    constructor() {
        /**
         * Size of the badge dot.
         */
        this.size = 'large';
        /**
         * Emphasis style for the badge dot.
         */
        this.emphasis = 'none';
    }
    get hostClass() {
        return [
            'hive-badge-dot',
            `hive-badge-dot--size-${this.size}`,
            `hive-badge-dot--emphasis-${this.emphasis}`,
        ];
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: BadgeDotComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "16.1.0", version: "17.3.12", type: BadgeDotComponent, isStandalone: true, selector: "hive-badge-dot", inputs: { size: ["size", "size", badgesDotSizeAttribute], emphasis: ["emphasis", "emphasis", badgesDotEmphasisAttribute] }, host: { properties: { "class": "this.hostClass" } }, hostDirectives: [{ directive: HiveThemedDirective }], ngImport: i0, template: '', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: BadgeDotComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'hive-badge-dot',
                    template: '',
                    standalone: true,
                    hostDirectives: [HiveThemedDirective],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], propDecorators: { size: [{
                type: Input,
                args: [{ transform: badgesDotSizeAttribute }]
            }], emphasis: [{
                type: Input,
                args: [{ transform: badgesDotEmphasisAttribute }]
            }], hostClass: [{
                type: HostBinding,
                args: ['class']
            }] } });

/**
 * Badge dot is an extension of badge component. It does not support any icons or labels since it is primarily used to indicate user status.
 *
 * @deprecated use `hive-badge-dot` component instead
 */
class BadgeDotDirective {
    constructor() {
        this.size = 'large';
        this._hasBorder = false;
    }
    get hasBorder() {
        return this._hasBorder;
    }
    set hasBorder(value) {
        this._hasBorder = coerceBooleanProperty(value);
    }
    get sizeClass() {
        return `hive-badge-dot--${this.size ?? 'large'}`;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: BadgeDotDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: BadgeDotDirective, selector: "[hiveBadgeDot]", inputs: { size: "size", hasBorder: "hasBorder" }, host: { properties: { "class.hive-badge-dot--has-border": "this.hasBorder", "class": "this.sizeClass" }, classAttribute: "hive-badge-dot" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: BadgeDotDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[hiveBadgeDot]',
                    host: {
                        class: 'hive-badge-dot',
                    },
                }]
        }], propDecorators: { size: [{
                type: Input
            }], hasBorder: [{
                type: HostBinding,
                args: ['class.hive-badge-dot--has-border']
            }, {
                type: Input
            }], sizeClass: [{
                type: HostBinding,
                args: ['class']
            }] } });

/**
 * Avatar supports rendering:
 * - an image, by passing `<img>` element as a child
 * - a letter, by passing a string into `letter` input
 *
 * It also supports different `size`s:
 * - small
 * - medium
 * - large
 *
 * And `impersonated` state, which is displayed as a red circle in the
 * bottom-right corner.
 *
 * @example
 * // image approach
 * <hive-avatar>
 *    <img src="imageUrl.png" />
 * </hive-avatar>
 *
 * @example
 * // letter approach
 * <hive-avatar letter="AB" />
 */
class AvatarComponent {
    constructor() {
        /**
         * Letter to display if no icon is provided.
         * Only the first two letters will be displayed.
         */
        this.letter = '';
        /**
         * @default 'medium'
         */
        this.size = 'medium';
        /**
         * @default false
         */
        this.impersonated = false;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AvatarComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.3.12", type: AvatarComponent, selector: "hive-avatar", inputs: { letter: ["letter", "letter", stringAttribute], size: "size", impersonated: ["impersonated", "impersonated", booleanAttribute] }, viewQueries: [{ propertyName: "imgContainerRef", first: true, predicate: ["imgRef"], descendants: true }], hostDirectives: [{ directive: HiveThemedDirective }, { directive: InvertedColorsDirective, inputs: ["hiveInvertedColors", "inverted"] }], ngImport: i0, template: "<div\n    class=\"hive-avatar_container\"\n    [ngClass]=\"['hive-avatar_container--' + size]\"\n>\n    <div\n        class=\"hive-avatar_figure-container\"\n        [class.hive-avatar_figure-container--has-img]=\"\n            imgContainerRef &&\n            imgContainerRef.nativeElement.children?.length !== 0\n        \"\n    >\n        <div #imgRef class=\"hive-avatar_figure\">\n            <ng-content select=\"img\"></ng-content>\n        </div>\n\n        @if (letter) {\n            <div class=\"hive-avatar_letter\">{{ letter[0] }}{{ letter[1] }}</div>\n        }\n    </div>\n\n    <div class=\"hive-avatar_status\">\n        @if (impersonated) {\n            <hive-badge-dot\n                class=\"hive-avatar_status-dot\"\n                hiveBadgeDot\n                emphasis=\"major\"\n                [size]=\"size\"\n            ></hive-badge-dot>\n        }\n    </div>\n</div>\n", dependencies: [{ kind: "directive", type: i2$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "component", type: BadgeDotComponent, selector: "hive-badge-dot", inputs: ["size", "emphasis"] }, { kind: "directive", type: BadgeDotDirective, selector: "[hiveBadgeDot]", inputs: ["size", "hasBorder"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AvatarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hive-avatar', changeDetection: ChangeDetectionStrategy.OnPush, hostDirectives: [
                        HiveThemedDirective,
                        {
                            directive: InvertedColorsDirective,
                            inputs: ['hiveInvertedColors: inverted'],
                        },
                    ], template: "<div\n    class=\"hive-avatar_container\"\n    [ngClass]=\"['hive-avatar_container--' + size]\"\n>\n    <div\n        class=\"hive-avatar_figure-container\"\n        [class.hive-avatar_figure-container--has-img]=\"\n            imgContainerRef &&\n            imgContainerRef.nativeElement.children?.length !== 0\n        \"\n    >\n        <div #imgRef class=\"hive-avatar_figure\">\n            <ng-content select=\"img\"></ng-content>\n        </div>\n\n        @if (letter) {\n            <div class=\"hive-avatar_letter\">{{ letter[0] }}{{ letter[1] }}</div>\n        }\n    </div>\n\n    <div class=\"hive-avatar_status\">\n        @if (impersonated) {\n            <hive-badge-dot\n                class=\"hive-avatar_status-dot\"\n                hiveBadgeDot\n                emphasis=\"major\"\n                [size]=\"size\"\n            ></hive-badge-dot>\n        }\n    </div>\n</div>\n" }]
        }], propDecorators: { imgContainerRef: [{
                type: ViewChild,
                args: ['imgRef']
            }], letter: [{
                type: Input,
                args: [{ transform: stringAttribute }]
            }], size: [{
                type: Input
            }], impersonated: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }] } });

/**
 * Directive to trigger an overlay
 * It can be used to open the overlay on click
 * or to toggle the overlay on click
 *
 * You can use it as a foundation for your own overlay trigger
 *
 * @example
 *  <hive-button
 *    [hiveOverlayTrigger]="myOverlay"
 *    [disabled]="overlayDisabled"
 *    [shouldToggle]="overlayShouldToggle"
 *    label="Open overlay"
 * ></hive-button>
 *
 */
class OverlayTriggerDirective {
    constructor(selfOverlayOrigin) {
        this.selfOverlayOrigin = selfOverlayOrigin;
        /**
         * Shouldn't open the overlay if set to true
         */
        this.disabled = false;
        /**
         * Whether the overlay should toggle instead of showing on click
         */
        this.shouldToggle = false;
    }
    /**
     * Propagates the `showOverlay` call to the Overlay instance
     */
    showOverlay() {
        this.hiveOverlayTrigger.showOverlay(this.selfOverlayOrigin);
    }
    /**
     * Propagates the `toggleOverlay` call to the Overlay instance
     */
    toggleOverlay() {
        this.hiveOverlayTrigger.toggleOverlay(this.selfOverlayOrigin);
    }
    /**
     * Propagates the `hideOverlay` call to the Overlay instance
     */
    hideOverlay() {
        this.hiveOverlayTrigger.hideOverlay();
    }
    /**
     * Handles the click event on the host element
     * If the overlay is disabled, it does nothing
     * If the overlay should toggle, it toggles the overlay
     * Otherwise, it shows the overlay
     */
    handleClick(event) {
        event.preventDefault();
        if (coerceBooleanProperty(this.disabled)) {
            return;
        }
        if (coerceBooleanProperty(this.shouldToggle)) {
            this.toggleOverlay();
        }
        else {
            this.showOverlay();
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: OverlayTriggerDirective, deps: [{ token: i1$1.CdkOverlayOrigin, host: true }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: OverlayTriggerDirective, isStandalone: true, selector: "[hiveOverlayTrigger]", inputs: { disabled: "disabled", hiveOverlayTrigger: "hiveOverlayTrigger", shouldToggle: "shouldToggle" }, host: { listeners: { "click": "handleClick($event)", "keydown.enter": "handleClick($event)", "keydown.space": "handleClick($event)" } }, hostDirectives: [{ directive: i1$1.CdkOverlayOrigin }], ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: OverlayTriggerDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[hiveOverlayTrigger]',
                    hostDirectives: [CdkOverlayOrigin],
                    standalone: true,
                }]
        }], ctorParameters: () => [{ type: i1$1.CdkOverlayOrigin, decorators: [{
                    type: Host
                }] }], propDecorators: { disabled: [{
                type: Input
            }], hiveOverlayTrigger: [{
                type: Input
            }], shouldToggle: [{
                type: Input
            }], handleClick: [{
                type: HostListener,
                args: ['click', ['$event']]
            }, {
                type: HostListener,
                args: ['keydown.enter', ['$event']]
            }, {
                type: HostListener,
                args: ['keydown.space', ['$event']]
            }] } });

/**
 * Coerces a value to a string | string[] type.
 */
function coerceMultilineString(value, fallbackValue = '') {
    const type = typeof value;
    if (isString(value)) {
        return value;
    }
    if (type !== 'undefined' && value !== null) {
        return value;
    }
    return fallbackValue;
}

class OverlayComponent {
    onResize() {
        if (this.closeOnPageResize) {
            this.hideOverlay();
        }
    }
    constructor(_selfOverlayOrigin, changeDetectorRef, theming$) {
        this._selfOverlayOrigin = _selfOverlayOrigin;
        this.changeDetectorRef = changeDetectorRef;
        this.theming$ = theming$;
        /**
         * Whether the overlay should take width from trigger
         *
         * @default false
         */
        this.takeWidthFromTrigger = false;
        /**
         * Whether the overlay should close when the page is resized.
         *
         * @default false
         */
        this.closeOnPageResize = false;
        /**
         * Classes to be appended to the panel element.
         * By default, the panel class is 'hive-overlay__panel'.
         * Classes passed into this input will be added to the panel in addition to this default.
         */
        this.panelClass = '';
        /**
         * Classes to be appended to the backdrop element.
         * By default, the backdrop class is 'hive-overlay__backdrop'.
         * Classes passed into this input will be added to the backdrop in addition to this default.
         */
        this.backdropClass = '';
        /**
         * The offset in pixels for the overlay connection point on the x-axis
         */
        this.offsetX = 0;
        /**
         * The offset in pixels for the overlay connection point on the y-axis
         */
        this.offsetY = 0;
        /**
         * Whether the overlay should close when the user clicks on the backdrop.
         * @default true
         */
        this.closeOnBackdropClick = true;
        /**
         * Whether the overlay should close when the user clicks outside the overlay.
         */
        this.closeOnOutsideClick = true;
        /**
         * Whether the overlay should attach a backdrop.
         * @default true
         */
        this.hasBackdrop = false;
        /**
         * The minimum width of the overlay.
         */
        this.overlayMinWidth = 'auto';
        /**
         * Whether the overlay is open or not (visible or hidden)
         */
        this.visibilityChange = new EventEmitter();
        /**
         * @internal
         */
        this._connectedOverlayPositions = this.remapPositionsValues();
        this._connectedOverlayOffsetX = 0;
        this._connectedOverlayOffsetY = 0;
        this._connectedOverlayBackdropClass = [
            'hive-overlay__backdrop',
        ].concat(coerceMultilineString(this.backdropClass));
        this._connectedOverlayPanelClass = [
            'hive-overlay__panel',
            'hive-root',
        ].concat(coerceMultilineString(this.panelClass));
        this._connectedOverlayHasBackdrop = false;
        this._connectedOverlayOpen = false;
        this._connectedOverlayWidth = 'auto';
        this.redrawTrigger$ = new Subject();
        /**
         * Emits false immediately after the redrawTrigger$ emits, then true after the next change detection cycle
         */
        this.redraw$ = this.redrawTrigger$.pipe(startWith(true), switchMap$1(() => timer(0).pipe(map((_) => true), startWith(false))));
        this.destroyRef = inject(DestroyRef);
        this.theming$
            .pipe(takeUntilDestroyed(this.destroyRef), distinctUntilChanged())
            .subscribe(() => {
            this._connectedOverlayPanelClass = [
                'hive-overlay__panel',
                'hive-root',
            ].concat(coerceMultilineString(this.panelClass), `hive-theme-${this.theming$.getValue()}`);
            this._connectedOverlayBackdropClass = [
                'hive-overlay__backdrop',
            ].concat(coerceMultilineString(this.backdropClass), `hive-theme-${this.theming$.getValue()}`);
            this.redrawTrigger$.next();
        });
    }
    handleAttachAndDetach(attached) {
        this.visibilityChange.emit(attached);
        this.changeDetectorRef.detectChanges();
    }
    get _connectedOverlayOrigin() {
        return this._triggerOverlayOrigin ?? this._selfOverlayOrigin;
    }
    /**
     * This method shows an overlay.
     *
     * If origin is not provided, it uses self-origin.
     * @param origin
     */
    showOverlay(origin) {
        this._connectedOverlayOpen = true;
        this._triggerOverlayOrigin = origin;
        if (this.takeWidthFromTrigger) {
            this._connectedOverlayWidth =
                this._connectedOverlayOrigin.elementRef.nativeElement?.offsetWidth;
        }
        this.changeDetectorRef.detectChanges();
    }
    ngOnChanges(changes) {
        if (changes['position']) {
            this._connectedOverlayPositions = this.remapPositionsValues();
            this.redrawTrigger$.next();
        }
        if (changes['offsetX']) {
            this._connectedOverlayOffsetX = this.offsetX;
            this.redrawTrigger$.next();
        }
        if (changes['offsetY']) {
            this._connectedOverlayOffsetY = this.offsetY;
            this.redrawTrigger$.next();
        }
        if (changes['panelClass']) {
            this._connectedOverlayPanelClass = ['hive-overlay__panel'].concat(coerceMultilineString(this.panelClass), `hive-theme-${this.theming$.getValue()}`);
            this.redrawTrigger$.next();
        }
        if (changes['backdropClass']) {
            this._connectedOverlayBackdropClass = [
                'hive-overlay__backdrop',
            ].concat(coerceMultilineString(this.backdropClass), `hive-theme-${this.theming$.getValue()}`);
            this.redrawTrigger$.next();
        }
        if (changes['hasBackdrop']) {
            this._connectedOverlayHasBackdrop = this.hasBackdrop;
            this.redrawTrigger$.next();
        }
        if (changes['takeWidthFromTrigger']) {
            this.redrawTrigger$.next();
        }
    }
    /**
     * Hides overlay.
     */
    hideOverlay() {
        this._connectedOverlayOpen = false;
        this._triggerOverlayOrigin = undefined;
        this.changeDetectorRef.detectChanges();
    }
    /**
     * Handles keydown event on the overlay.
     * @internal
     * @param event
     */
    handleOverlayKeydown(event) {
        if (event.key === 'Escape' && this.closeOnBackdropClick) {
            this.hideOverlay();
        }
    }
    /**
     * This method toggles the overlay.
     *
     * If origin is not provided, it uses self-origin.
     * @param origin
     */
    toggleOverlay(origin) {
        if (this._connectedOverlayOpen) {
            this.hideOverlay();
        }
        else {
            this.showOverlay(origin);
        }
    }
    handleBackdropClick(event) {
        const currentElementContains = this._selfOverlayOrigin?.elementRef?.nativeElement?.contains?.(event.target);
        const triggerElementContains = this._triggerOverlayOrigin?.elementRef?.nativeElement?.contains?.(event.target);
        if (!currentElementContains &&
            !triggerElementContains &&
            this.closeOnBackdropClick) {
            this.hideOverlay();
        }
    }
    handleOutsideClick(event) {
        const currentElementContains = this._selfOverlayOrigin?.elementRef?.nativeElement?.contains?.(event.target);
        const triggerElementContains = this._triggerOverlayOrigin?.elementRef?.nativeElement?.contains?.(event.target);
        if (!currentElementContains &&
            !triggerElementContains &&
            this.closeOnOutsideClick) {
            this.hideOverlay();
        }
    }
    /**
     * @internal
     */
    get connectedOverlayOpen() {
        return this._connectedOverlayOpen;
    }
    /**
     * @internal
     */
    remapPositionsValues() {
        return this.position
            ? [PredefinedPositions[this.position]]
            : [PredefinedPositions['bottomStart']];
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: OverlayComponent, deps: [{ token: i1$1.CdkOverlayOrigin, host: true }, { token: i0.ChangeDetectorRef }, { token: HIVE_THEMING }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.3.12", type: OverlayComponent, isStandalone: true, selector: "hive-overlay", inputs: { takeWidthFromTrigger: ["takeWidthFromTrigger", "takeWidthFromTrigger", booleanAttribute], closeOnPageResize: ["closeOnPageResize", "closeOnPageResize", booleanAttribute], panelClass: "panelClass", backdropClass: "backdropClass", position: "position", offsetX: ["offsetX", "offsetX", numberAttribute], offsetY: ["offsetY", "offsetY", numberAttribute], closeOnBackdropClick: ["closeOnBackdropClick", "closeOnBackdropClick", booleanAttribute], closeOnOutsideClick: ["closeOnOutsideClick", "closeOnOutsideClick", booleanAttribute], hasBackdrop: ["hasBackdrop", "hasBackdrop", booleanAttribute], overlayMinWidth: "overlayMinWidth" }, outputs: { visibilityChange: "visibilityChange" }, host: { listeners: { "window:resize": "onResize()" } }, viewQueries: [{ propertyName: "connectedOverlay", first: true, predicate: CdkConnectedOverlay, descendants: true, static: true }], usesOnChanges: true, hostDirectives: [{ directive: i1$1.CdkOverlayOrigin }], ngImport: i0, template: "@if (redraw$ | async) {\n    <ng-template\n        (backdropClick)=\"handleBackdropClick($event)\"\n        (overlayOutsideClick)=\"handleOutsideClick($event)\"\n        (overlayKeydown)=\"handleOverlayKeydown($event)\"\n        (attach)=\"handleAttachAndDetach(true)\"\n        (detach)=\"handleAttachAndDetach(false)\"\n        [cdkConnectedOverlayBackdropClass]=\"_connectedOverlayBackdropClass\"\n        [cdkConnectedOverlayHasBackdrop]=\"_connectedOverlayHasBackdrop\"\n        [cdkConnectedOverlayOffsetX]=\"_connectedOverlayOffsetX\"\n        [cdkConnectedOverlayOffsetY]=\"_connectedOverlayOffsetY\"\n        [cdkConnectedOverlayOpen]=\"_connectedOverlayOpen\"\n        [cdkConnectedOverlayOrigin]=\"_connectedOverlayOrigin\"\n        [cdkConnectedOverlayPanelClass]=\"_connectedOverlayPanelClass\"\n        [cdkConnectedOverlayPositions]=\"_connectedOverlayPositions\"\n        [cdkConnectedOverlayDisableClose]=\"true\"\n        [cdkConnectedOverlayPush]=\"true\"\n        [cdkConnectedOverlayWidth]=\"_connectedOverlayWidth ?? 'auto'\"\n        [cdkConnectedOverlayMinWidth]=\"overlayMinWidth\"\n        cdkConnectedOverlay\n    >\n        <div style=\"width: 100%\">\n            <ng-content></ng-content>\n        </div>\n    </ng-template>\n}\n", dependencies: [{ kind: "ngmodule", type: OverlayModule }, { kind: "directive", type: i1$1.CdkConnectedOverlay, selector: "[cdk-connected-overlay], [connected-overlay], [cdkConnectedOverlay]", inputs: ["cdkConnectedOverlayOrigin", "cdkConnectedOverlayPositions", "cdkConnectedOverlayPositionStrategy", "cdkConnectedOverlayOffsetX", "cdkConnectedOverlayOffsetY", "cdkConnectedOverlayWidth", "cdkConnectedOverlayHeight", "cdkConnectedOverlayMinWidth", "cdkConnectedOverlayMinHeight", "cdkConnectedOverlayBackdropClass", "cdkConnectedOverlayPanelClass", "cdkConnectedOverlayViewportMargin", "cdkConnectedOverlayScrollStrategy", "cdkConnectedOverlayOpen", "cdkConnectedOverlayDisableClose", "cdkConnectedOverlayTransformOriginOn", "cdkConnectedOverlayHasBackdrop", "cdkConnectedOverlayLockPosition", "cdkConnectedOverlayFlexibleDimensions", "cdkConnectedOverlayGrowAfterOpen", "cdkConnectedOverlayPush", "cdkConnectedOverlayDisposeOnNavigation"], outputs: ["backdropClick", "positionChange", "attach", "detach", "overlayKeydown", "overlayOutsideClick"], exportAs: ["cdkConnectedOverlay"] }, { kind: "ngmodule", type: CommonModule }, { kind: "pipe", type: i2$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: OverlayComponent, decorators: [{
            type: Component,
            args: [{ changeDetection: ChangeDetectionStrategy.OnPush, hostDirectives: [CdkOverlayOrigin], imports: [OverlayModule, CommonModule], selector: 'hive-overlay', standalone: true, template: "@if (redraw$ | async) {\n    <ng-template\n        (backdropClick)=\"handleBackdropClick($event)\"\n        (overlayOutsideClick)=\"handleOutsideClick($event)\"\n        (overlayKeydown)=\"handleOverlayKeydown($event)\"\n        (attach)=\"handleAttachAndDetach(true)\"\n        (detach)=\"handleAttachAndDetach(false)\"\n        [cdkConnectedOverlayBackdropClass]=\"_connectedOverlayBackdropClass\"\n        [cdkConnectedOverlayHasBackdrop]=\"_connectedOverlayHasBackdrop\"\n        [cdkConnectedOverlayOffsetX]=\"_connectedOverlayOffsetX\"\n        [cdkConnectedOverlayOffsetY]=\"_connectedOverlayOffsetY\"\n        [cdkConnectedOverlayOpen]=\"_connectedOverlayOpen\"\n        [cdkConnectedOverlayOrigin]=\"_connectedOverlayOrigin\"\n        [cdkConnectedOverlayPanelClass]=\"_connectedOverlayPanelClass\"\n        [cdkConnectedOverlayPositions]=\"_connectedOverlayPositions\"\n        [cdkConnectedOverlayDisableClose]=\"true\"\n        [cdkConnectedOverlayPush]=\"true\"\n        [cdkConnectedOverlayWidth]=\"_connectedOverlayWidth ?? 'auto'\"\n        [cdkConnectedOverlayMinWidth]=\"overlayMinWidth\"\n        cdkConnectedOverlay\n    >\n        <div style=\"width: 100%\">\n            <ng-content></ng-content>\n        </div>\n    </ng-template>\n}\n" }]
        }], ctorParameters: () => [{ type: i1$1.CdkOverlayOrigin, decorators: [{
                    type: Host
                }] }, { type: i0.ChangeDetectorRef }, { type: i4.BehaviorSubject, decorators: [{
                    type: Inject,
                    args: [HIVE_THEMING]
                }] }], propDecorators: { onResize: [{
                type: HostListener,
                args: ['window:resize']
            }], takeWidthFromTrigger: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], closeOnPageResize: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], panelClass: [{
                type: Input
            }], backdropClass: [{
                type: Input
            }], position: [{
                type: Input
            }], offsetX: [{
                type: Input,
                args: [{ transform: numberAttribute }]
            }], offsetY: [{
                type: Input,
                args: [{ transform: numberAttribute }]
            }], closeOnBackdropClick: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], closeOnOutsideClick: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], hasBackdrop: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], overlayMinWidth: [{
                type: Input
            }], connectedOverlay: [{
                type: ViewChild,
                args: [CdkConnectedOverlay, { static: true }]
            }], visibilityChange: [{
                type: Output
            }] } });

/**
 * Pop-up panel provides additional information or functionality that is relevant to the current context, without requiring the user to navigate away from the current page or view.
 */
class PopUpComponent {
    constructor() {
        /**
         * If you want to have close button on this pop-up - enable this property
         * @default false
         */
        this.showCloseButton = false;
        /**
         * Applies dark theme into the view
         */
        this.dark = false;
        /**
         * Sets the position of the overlay panel
         */
        this.position = 'bottomStart';
        /**
         * Offset by axis X for overlay menu
         */
        this.offsetX = 0;
        /**
         * Offset by axis Y for overlay menu
         */
        this.offsetY = 2;
        /**
         * Use this property to make the overlay close on outside click
         */
        this.closeOnOutsideClick = false;
        /**
         * Use this property to make the overlay close on backdrop click
         */
        this.closeOnBackdropClick = true;
        /**
         * Whether show the backdrop
         */
        this.hasBackdrop = false;
        /**
         * Whether the overlay panel is open
         */
        this.visibilityChange = new EventEmitter();
    }
    /**
     * Shows the overlay panel. If you need to override the origin of the overlay, you can pass in a new origin via the `overlayOrigin` parameter.
     * @param overlayOrigin
     */
    showOverlay(overlayOrigin) {
        this.overlay.showOverlay(overlayOrigin);
    }
    /**
     * Hides the overlay panel.
     */
    hideOverlay() {
        this.overlay.hideOverlay();
    }
    /**
     * Toggles the overlay panel. If you need to override the origin of the overlay, you can pass in a new origin via the `overlayOrigin` parameter.
     * @param overlayOrigin
     */
    toggleOverlay(overlayOrigin) {
        this.overlay.toggleOverlay(overlayOrigin);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PopUpComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.3.12", type: PopUpComponent, isStandalone: true, selector: "hive-pop-up", inputs: { testId: "testId", showCloseButton: ["showCloseButton", "showCloseButton", booleanAttribute], dark: ["dark", "dark", booleanAttribute], position: "position", offsetX: ["offsetX", "offsetX", numberAttribute], offsetY: ["offsetY", "offsetY", numberAttribute], closeOnOutsideClick: ["closeOnOutsideClick", "closeOnOutsideClick", booleanAttribute], closeOnBackdropClick: ["closeOnBackdropClick", "closeOnBackdropClick", booleanAttribute], hasBackdrop: ["hasBackdrop", "hasBackdrop", booleanAttribute] }, outputs: { visibilityChange: "visibilityChange" }, viewQueries: [{ propertyName: "overlay", first: true, predicate: OverlayComponent, descendants: true, static: true }], exportAs: ["hivePopUp"], hostDirectives: [{ directive: HiveThemedDirective }], ngImport: i0, template: "<hive-overlay\n    [closeOnBackdropClick]=\"closeOnBackdropClick\"\n    [closeOnOutsideClick]=\"closeOnOutsideClick\"\n    [hasBackdrop]=\"hasBackdrop\"\n    [offsetX]=\"offsetX\"\n    [offsetY]=\"offsetY\"\n    [position]=\"position\"\n    (visibilityChange)=\"visibilityChange.emit($event)\"\n>\n    <div\n        class=\"hive-pop-up-panel\"\n        [class.hive-pop-up-panel--dark]=\"dark\"\n    >\n        <div [attr.data-testid]=\"testId\" class=\"hive-pop-up_container\">\n            @if (showCloseButton) {\n                <hive-button\n                    (click)=\"hideOverlay()\"\n                    (keydown.enter)=\"hideOverlay()\"\n                    aria-label=\"Close\"\n                    class=\"hive-pop-up_dialog-close-button\"\n                    emphasis=\"tertiary\"\n                    icon=\"regular/xmark.svg\"\n                    size=\"smallest\"\n                ></hive-button>\n            }\n            <div class=\"hive-pop-up-dialog-body\">\n                <ng-content></ng-content>\n            </div>\n        </div>\n    </div>\n</hive-overlay>\n", dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "ngmodule", type: OverlayModule }, { kind: "component", type: ButtonComponent, selector: "hive-button", inputs: ["type", "menuButtonActive", "hasMenuButtonCaret", "label", "accessibleName", "icon", "iconPosition", "emphasis", "title", "size", "isLoading", "disabled", "rounded", "width"] }, { kind: "component", type: OverlayComponent, selector: "hive-overlay", inputs: ["takeWidthFromTrigger", "closeOnPageResize", "panelClass", "backdropClass", "position", "offsetX", "offsetY", "closeOnBackdropClick", "closeOnOutsideClick", "hasBackdrop", "overlayMinWidth"], outputs: ["visibilityChange"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PopUpComponent, decorators: [{
            type: Component,
            args: [{ standalone: true, selector: 'hive-pop-up', imports: [CommonModule, OverlayModule, ButtonComponent, OverlayComponent], changeDetection: ChangeDetectionStrategy.OnPush, hostDirectives: [HiveThemedDirective], exportAs: 'hivePopUp', template: "<hive-overlay\n    [closeOnBackdropClick]=\"closeOnBackdropClick\"\n    [closeOnOutsideClick]=\"closeOnOutsideClick\"\n    [hasBackdrop]=\"hasBackdrop\"\n    [offsetX]=\"offsetX\"\n    [offsetY]=\"offsetY\"\n    [position]=\"position\"\n    (visibilityChange)=\"visibilityChange.emit($event)\"\n>\n    <div\n        class=\"hive-pop-up-panel\"\n        [class.hive-pop-up-panel--dark]=\"dark\"\n    >\n        <div [attr.data-testid]=\"testId\" class=\"hive-pop-up_container\">\n            @if (showCloseButton) {\n                <hive-button\n                    (click)=\"hideOverlay()\"\n                    (keydown.enter)=\"hideOverlay()\"\n                    aria-label=\"Close\"\n                    class=\"hive-pop-up_dialog-close-button\"\n                    emphasis=\"tertiary\"\n                    icon=\"regular/xmark.svg\"\n                    size=\"smallest\"\n                ></hive-button>\n            }\n            <div class=\"hive-pop-up-dialog-body\">\n                <ng-content></ng-content>\n            </div>\n        </div>\n    </div>\n</hive-overlay>\n" }]
        }], propDecorators: { testId: [{
                type: Input
            }], overlay: [{
                type: ViewChild,
                args: [OverlayComponent, { static: true }]
            }], showCloseButton: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], dark: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], position: [{
                type: Input
            }], offsetX: [{
                type: Input,
                args: [{ transform: numberAttribute }]
            }], offsetY: [{
                type: Input,
                args: [{ transform: numberAttribute }]
            }], closeOnOutsideClick: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], closeOnBackdropClick: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], hasBackdrop: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], visibilityChange: [{
                type: Output
            }] } });

class PopUpTriggerDirective {
    constructor(overlayTriggerDirective) {
        this.overlayTriggerDirective = overlayTriggerDirective;
    }
    /**
     * @todo: Move this logic into hostDirective declaration as new input - `'hiveOverlayTrigger: hivePopUpTrigger'` once we got rid of `popUpRef` input. Check for '' is needed just only for a case when `popUpRef` is used.
     * @param value
     */
    set hivePopUpTrigger(value) {
        if (value !== '') {
            this.overlayTriggerDirective.hiveOverlayTrigger = value;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PopUpTriggerDirective, deps: [{ token: OverlayTriggerDirective, host: true }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: PopUpTriggerDirective, isStandalone: true, selector: "[hivePopUpTrigger]", inputs: { hivePopUpTrigger: "hivePopUpTrigger" }, hostDirectives: [{ directive: OverlayTriggerDirective, inputs: ["disabled", "disabled", "shouldToggle", "shouldToggle"] }], ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PopUpTriggerDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[hivePopUpTrigger]',
                    standalone: true,
                    hostDirectives: [
                        {
                            directive: OverlayTriggerDirective,
                            inputs: ['disabled', 'shouldToggle'],
                        },
                    ],
                }]
        }], ctorParameters: () => [{ type: OverlayTriggerDirective, decorators: [{
                    type: Host
                }] }], propDecorators: { hivePopUpTrigger: [{
                type: Input
            }] } });

/**
 * Avatar menu uses `<hive-avatar>` component to display user avatar.
 *
 * Note that `<hive-avatar>` should have `small` `size`, otherwise, an error
 * will be thrown.
 * This is to avoid misunderstanding why the avatar doesn't change its size:
 * it does support only `small`.
 *
 * Avatar menu also displays user details: username, user role, user role subtext.
 *
 * To control, whether the user details are visible, use `expanded` input.
 *
 * @example
 * <hive-avatar-menu
 *     [expanded]="expanded"
 *     [userName]="userName"
 *     [userRole]="userRole"
 *     [userRoleSubtext]="userRoleSubtext"
 * >
 *   <hive-avatar letter="J" size="small"></hive-avatar>
 *   <ng-template hiveTemplate="menuContent">
 *       Menu Content
 *   </ng-template>
 * </hive-avatar-menu>
 */
class AvatarMenuComponent {
    constructor() {
        this.visibilityState$ = new BehaviorSubject(false);
        /**
         * If set to `false`, only the avatar is visible.
         * If set to `true`, the avatar and user details are visible.
         *
         * User details: user name, user role, user role subtext.
         *
         * @default false
         */
        this.expanded = false;
    }
    ngOnInit() {
        this.ensureAvatarSize(this.avatarComponent);
    }
    /**
     * Checks if the avatar size is `small`.
     * @param avatarComponent
     * @internal
     */
    ensureAvatarSize(avatarComponent) {
        if (avatarComponent?.size !== 'small') {
            throw new Error('Avatar menu should be used only with small avatars');
        }
    }
    showMenu() {
        this.overlayTriggerDirective.showOverlay();
    }
    hideMenu() {
        this.overlayTriggerDirective.hideOverlay();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AvatarMenuComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.3.12", type: AvatarMenuComponent, selector: "hive-avatar-menu", inputs: { expanded: "expanded", userName: "userName", userRole: "userRole", userRoleSubtext: "userRoleSubtext" }, queries: [{ propertyName: "menuTemplate", first: true, predicate: HiveTemplateDirective, descendants: true, static: true }, { propertyName: "avatarComponent", first: true, predicate: AvatarComponent, descendants: true, static: true }], viewQueries: [{ propertyName: "overlayTriggerDirective", first: true, predicate: OverlayTriggerDirective, descendants: true }], hostDirectives: [{ directive: HiveThemedDirective }], ngImport: i0, template: "<div\n    tabindex=\"0\"\n    class=\"hive-avatar-menu_container\"\n    shouldToggle\n    [class.hive-avatar-menu_container--active]=\"visibilityState$ | async\"\n    [hivePopUpTrigger]=\"hivePopUp\"\n>\n    <ng-content select=\"hive-avatar[size='small']\"></ng-content>\n\n    @if (expanded) {\n        <div class=\"hive-avatar-menu_user-details\">\n            <div class=\"hive-avatar-menu_user-details-container\">\n                <div class=\"hive-avatar-menu_user-name\">\n                    {{ userName }}\n                </div>\n                <div class=\"hive-avatar-menu_user-role\">\n                    {{ userRole }}\n                </div>\n                <div class=\"hive-avatar-menu_user-role-subtext\">\n                    {{ userRoleSubtext }}\n                </div>\n            </div>\n            <div class=\"hive-avatar-menu_dropdown\">\n                <hive-icon-component\n                    hiveChevron\n                    class=\"hive-avatar-menu_dropdown-icon\"\n                    icon=\"light/chevron-down.svg\"\n                    size=\"small\"\n                    [rotated]=\"visibilityState$ | async\"\n                ></hive-icon-component>\n            </div>\n        </div>\n    }\n</div>\n\n<hive-pop-up\n    #hivePopUp\n    heading=\"\"\n    [showCloseButton]=\"false\"\n    [dark]=\"false\"\n    (visibilityChange)=\"visibilityState$.next($event)\"\n    position=\"bottomEnd\"\n    animationType=\"slide\"\n    closeOnOutsideClick\n>\n    @if (menuTemplate?.template; as template) {\n        <ng-container *ngTemplateOutlet=\"template\"></ng-container>\n    }\n</hive-pop-up>\n", dependencies: [{ kind: "directive", type: i2$1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "component", type: IconComponent, selector: "hive-icon-component", inputs: ["icon", "size"] }, { kind: "component", type: PopUpComponent, selector: "hive-pop-up", inputs: ["testId", "showCloseButton", "dark", "position", "offsetX", "offsetY", "closeOnOutsideClick", "closeOnBackdropClick", "hasBackdrop"], outputs: ["visibilityChange"], exportAs: ["hivePopUp"] }, { kind: "directive", type: PopUpTriggerDirective, selector: "[hivePopUpTrigger]", inputs: ["hivePopUpTrigger"] }, { kind: "directive", type: ChevronDirective, selector: "hive-icon-component[hiveChevron]", inputs: ["rotationDirection", "rotated"] }, { kind: "pipe", type: i2$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AvatarMenuComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hive-avatar-menu', hostDirectives: [HiveThemedDirective], changeDetection: ChangeDetectionStrategy.OnPush, template: "<div\n    tabindex=\"0\"\n    class=\"hive-avatar-menu_container\"\n    shouldToggle\n    [class.hive-avatar-menu_container--active]=\"visibilityState$ | async\"\n    [hivePopUpTrigger]=\"hivePopUp\"\n>\n    <ng-content select=\"hive-avatar[size='small']\"></ng-content>\n\n    @if (expanded) {\n        <div class=\"hive-avatar-menu_user-details\">\n            <div class=\"hive-avatar-menu_user-details-container\">\n                <div class=\"hive-avatar-menu_user-name\">\n                    {{ userName }}\n                </div>\n                <div class=\"hive-avatar-menu_user-role\">\n                    {{ userRole }}\n                </div>\n                <div class=\"hive-avatar-menu_user-role-subtext\">\n                    {{ userRoleSubtext }}\n                </div>\n            </div>\n            <div class=\"hive-avatar-menu_dropdown\">\n                <hive-icon-component\n                    hiveChevron\n                    class=\"hive-avatar-menu_dropdown-icon\"\n                    icon=\"light/chevron-down.svg\"\n                    size=\"small\"\n                    [rotated]=\"visibilityState$ | async\"\n                ></hive-icon-component>\n            </div>\n        </div>\n    }\n</div>\n\n<hive-pop-up\n    #hivePopUp\n    heading=\"\"\n    [showCloseButton]=\"false\"\n    [dark]=\"false\"\n    (visibilityChange)=\"visibilityState$.next($event)\"\n    position=\"bottomEnd\"\n    animationType=\"slide\"\n    closeOnOutsideClick\n>\n    @if (menuTemplate?.template; as template) {\n        <ng-container *ngTemplateOutlet=\"template\"></ng-container>\n    }\n</hive-pop-up>\n" }]
        }], propDecorators: { menuTemplate: [{
                type: ContentChild,
                args: [HiveTemplateDirective, { static: true }]
            }], avatarComponent: [{
                type: ContentChild,
                args: [AvatarComponent, { static: true }]
            }], expanded: [{
                type: Input
            }], userName: [{
                type: Input
            }], userRole: [{
                type: Input
            }], userRoleSubtext: [{
                type: Input
            }], overlayTriggerDirective: [{
                type: ViewChild,
                args: [OverlayTriggerDirective]
            }] } });

function badgeSizeAttribute(value) {
    return oneOfOrDefault(value, 'smallest', 'small', 'medium', 'large');
}
function badgeEmphasisAttribute(value) {
    return oneOfOrDefault(value, 'none', 'info', 'success', 'warning', 'major');
}
/**
 * Badges are used to display information, such as a number or a short text,
 * and can be used to indicate various types of information,
 * such as the number of new messages, the status of a task,
 * or the availability of a feature.
 *
 * A badge can be text-only, icon-only, or have both text and an icon.
 * For icon-only badges that are merely decorative, no tooltip is required.
 * However, if an icon-only badge presents important information such as severity,
 * a descriptive tooltip should be used.
 */
class BadgeComponent {
    constructor(badgeDot) {
        this.badgeDot = badgeDot;
        /**
         * Text that appears in the badge.
         * Can be left blank or used along with {@link icon}
         */
        this.label = '';
        /**
         * @see {@link IconComponent}
         * @see {@link SvgDirective}
         */
        this.icon = '';
        /**
         * Emphasis style for the badge.
         */
        this.emphasis = 'none';
        /**
         * Size of the badge.
         */
        this.size = 'smallest';
    }
    get iconSize() {
        const sizes = {
            smallest: 'small',
            small: 'small',
            medium: 'medium',
            large: 'medium',
        };
        return sizes[this.size] ?? 'small';
    }
    get rounded() {
        if (this.isDot) {
            return true;
        }
        if (this.label?.trim().length <= 1) {
            return true;
        }
        return !this.label && !!this.icon;
    }
    get isDot() {
        return isDefined(this.badgeDot);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: BadgeComponent, deps: [{ token: BadgeDotDirective, host: true, optional: true }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.3.12", type: BadgeComponent, selector: "hive-badge", inputs: { label: ["label", "label", stringAttribute], icon: ["icon", "icon", stringAttribute], emphasis: ["emphasis", "emphasis", badgeEmphasisAttribute], size: ["size", "size", badgeSizeAttribute] }, host: { properties: { "class.hive-badge--rounded": "this.rounded" } }, hostDirectives: [{ directive: HiveThemedDirective }], ngImport: i0, template: "<div\n    [ngClass]=\"[\n        'hive-badge-emphasis-' + emphasis,\n        rounded ? 'hive-badge-container--rounded' : '',\n        'hive-badge-container--' + size,\n    ]\"\n    class=\"hive-badge-container\"\n>\n    @if (!isDot) {\n        @if (label) {\n            <hive-label\n                [label]=\"label\"\n                [size]=\"size\"\n                class=\"hive-badge_label\"\n                weight=\"semibold\"\n            />\n        }\n        @if (icon) {\n            <hive-icon-component\n                [icon]=\"icon\"\n                class=\"hive-badge_icon\"\n                [size]=\"iconSize\"\n            />\n        }\n    }\n</div>\n", dependencies: [{ kind: "directive", type: i2$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "component", type: IconComponent, selector: "hive-icon-component", inputs: ["icon", "size"] }, { kind: "component", type: LabelComponent, selector: "hive-label", inputs: ["label", "for", "size", "weight", "maxWeight", "horizontalAlignment", "leftIconHelpInfoMessage", "rightIconHelpInfoMessage", "leftIcon", "rightIcon", "required", "textOverflowEllipsis"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: BadgeComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hive-badge', changeDetection: ChangeDetectionStrategy.OnPush, hostDirectives: [HiveThemedDirective], template: "<div\n    [ngClass]=\"[\n        'hive-badge-emphasis-' + emphasis,\n        rounded ? 'hive-badge-container--rounded' : '',\n        'hive-badge-container--' + size,\n    ]\"\n    class=\"hive-badge-container\"\n>\n    @if (!isDot) {\n        @if (label) {\n            <hive-label\n                [label]=\"label\"\n                [size]=\"size\"\n                class=\"hive-badge_label\"\n                weight=\"semibold\"\n            />\n        }\n        @if (icon) {\n            <hive-icon-component\n                [icon]=\"icon\"\n                class=\"hive-badge_icon\"\n                [size]=\"iconSize\"\n            />\n        }\n    }\n</div>\n" }]
        }], ctorParameters: () => [{ type: BadgeDotDirective, decorators: [{
                    type: Host
                }, {
                    type: Optional
                }] }], propDecorators: { label: [{
                type: Input,
                args: [{ transform: stringAttribute }]
            }], icon: [{
                type: Input,
                args: [{ transform: stringAttribute }]
            }], emphasis: [{
                type: Input,
                args: [{ transform: badgeEmphasisAttribute }]
            }], size: [{
                type: Input,
                args: [{ transform: badgeSizeAttribute }]
            }], rounded: [{
                type: HostBinding,
                args: ['class.hive-badge--rounded']
            }] } });

class BadgeModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: BadgeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: BadgeModule, declarations: [BadgeComponent, BadgeDotDirective], imports: [CommonModule,
            BadgeDotComponent,
            SvgDirective,
            IconComponent,
            LabelComponent], exports: [BadgeComponent, BadgeDotComponent, BadgeDotDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: BadgeModule, imports: [CommonModule,
            IconComponent,
            LabelComponent] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: BadgeModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [BadgeComponent, BadgeDotDirective],
                    imports: [
                        CommonModule,
                        BadgeDotComponent,
                        SvgDirective,
                        IconComponent,
                        LabelComponent,
                    ],
                    exports: [BadgeComponent, BadgeDotComponent, BadgeDotDirective],
                }]
        }] });

class PopUpModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PopUpModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: PopUpModule, imports: [CommonModule, PopUpComponent, PopUpTriggerDirective], exports: [PopUpComponent, PopUpTriggerDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PopUpModule, imports: [CommonModule, PopUpComponent] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PopUpModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, PopUpComponent, PopUpTriggerDirective],
                    exports: [PopUpComponent, PopUpTriggerDirective],
                }]
        }] });

class AvatarModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AvatarModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: AvatarModule, declarations: [AvatarComponent, AvatarMenuComponent], imports: [CommonModule,
            IconComponent,
            PopUpModule,
            BadgeModule,
            HiveTemplateDirective,
            ChevronDirective], exports: [AvatarComponent, AvatarMenuComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AvatarModule, imports: [CommonModule,
            IconComponent,
            PopUpModule,
            BadgeModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AvatarModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [AvatarComponent, AvatarMenuComponent],
                    imports: [
                        CommonModule,
                        IconComponent,
                        PopUpModule,
                        BadgeModule,
                        HiveTemplateDirective,
                        ChevronDirective,
                    ],
                    exports: [AvatarComponent, AvatarMenuComponent],
                }]
        }] });

const openCloseAnimation = trigger('openClose', [
    state('*', style({
        height: '*',
        paddingTop: '{{contentPaddingTopOpened}}',
        paddingBottom: '{{contentPaddingBottomOpened}}',
    }), {
        params: {
            contentPaddingTopOpened: HIVE_SPACING_SM,
            contentPaddingBottomOpened: HIVE_SPACING_LG,
        },
    }),
    state('void', style({
        height: '0px',
        paddingTop: 0,
        paddingBottom: 0,
    })),
    transition('* <=> void', [animate('0.2s ease-in')]),
]);

function accordionSizeAttribute(size) {
    return oneOfOrDefault(size, 'normal', 'smaller-inplace');
}
// @todo: [CLOUD-151803] rewrite to use collapsable-item
/**
 * `hive-accordion` provides an API to organize and present content in a collapsible and expandable manner.
 * It allows users to efficiently navigate and access information while maintaining a clean and organized user interface.
 *
 * If you want to provide custom content to the accordion tab:
 *   - Left-side icon - use `[slot=left]` selector
 *   - Right-side icon - use `[slot=right]` selector (previously `[hiveTemplate]`, but it's deprecated)
 *   Any other content without selector will be projected to the body of the tab.
 */
class AccordionComponent {
    constructor() {
        /**
         * Update list of expansions. Updates state only for those that are present in the list.
         * To use this property, each `hive-accordion-tab` should have a unique `itemId`.
         */
        this.expansion = [];
        /**
         * Type of the accordion component. `smaller-inplace` has no borders and smaller margins,
         * it is designed to use in smaller containers like panels, modals etc
         */
        this.size = 'normal';
        /**
         * @internal
         */
        this._size$ = new BehaviorSubject('normal');
        this.expansionChange = new EventEmitter();
        this._destroyRef = inject(DestroyRef);
        this._tabs$ = new BehaviorSubject([]);
        this._expansion$ = new BehaviorSubject([]);
    }
    /**
     * Expands tab with provided id
     * @see AccordionTabComponent#itemId
     */
    async expand(itemId) {
        await this.setExpanded(itemId, true);
    }
    /**
     * Close tab with provided id
     * @see AccordionTabComponent#itemId
     */
    async close(itemId) {
        await this.setExpanded(itemId, false);
    }
    async setExpanded(itemId, expanded) {
        const expansion = await firstValueFrom(this._expansion$);
        const item = expansion.find((target) => target.itemId === itemId);
        if (!item) {
            expansion.push({ itemId, isOpen: expanded });
            this.expansionChange.emit(expansion);
        }
        else if (item.isOpen !== expanded) {
            item.isOpen = expanded;
            this.expansionChange.emit(expansion);
        }
        this._expansion$.next(expansion);
    }
    async closeAll() {
        const tabs = await firstValueFrom(this._tabs$);
        this._expansion$.next(tabs.map((tab) => ({ itemId: tab.expansionId, isOpen: false })));
        this.expansionChange.emit(this._expansion$.value);
    }
    ngOnChanges(changes) {
        if (changes['expansion']) {
            this.validateExpansionIds(this._tabs$.value);
            this._expansion$.next(changes['expansion'].currentValue);
        }
        if (changes['size']) {
            this._size$.next(changes['size'].currentValue);
        }
    }
    ngAfterContentInit() {
        this.watchAndUpdateContentChildren();
        this.watchForContentChildrenEvents();
        this.watchForTabs();
        if (this.expansion) {
            this.validateExpansionIds(this._tabs$.value);
        }
    }
    /**
     * Should be called only if an expansion is provided.
     */
    validateExpansionIds(tabs) {
        if (tabs.some((tab) => !tab.itemId)) {
            // eslint-disable-next-line no-console
            console.warn('AccordionTabComponent should have itemId to set expansion through input property');
        }
    }
    watchForContentChildrenEvents() {
        this._tabs$
            .pipe(takeUntilDestroyed(this._destroyRef), switchMap$1((tabs) => merge(...tabs.map((tab) => tab.expandedChange.pipe(map((value) => ({
            itemId: tab.expansionId,
            isOpen: value,
        })))))), tap(({ itemId, isOpen }) => this.setExpanded(itemId, isOpen)))
            .subscribe();
    }
    watchForTabs() {
        this.accordionTabComponents?.changes
            .pipe(startWith(this.accordionTabComponents), tap((tabs) => this._tabs$.next(tabs.toArray())), takeUntilDestroyed(this._destroyRef))
            .subscribe();
    }
    watchAndUpdateContentChildren() {
        combineLatest([this._tabs$, this._expansion$])
            .pipe(takeUntilDestroyed(this._destroyRef), tap(([tabs, expansion]) => this.updateTabs(tabs, expansion)))
            .subscribe();
    }
    updateTabs(tabs, expansion) {
        for (const tab of tabs) {
            const item = expansion.find((target) => target.itemId === tab.expansionId);
            if (item) {
                tab.setExpanded(item.isOpen || false, false);
            }
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AccordionComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "16.1.0", version: "17.3.12", type: AccordionComponent, selector: "hive-accordion", inputs: { expansion: "expansion", size: ["size", "size", accordionSizeAttribute] }, outputs: { expansionChange: "expansionChange" }, queries: [{ propertyName: "accordionTabComponents", predicate: i0.forwardRef(() => AccordionTabComponent), descendants: true }], usesOnChanges: true, hostDirectives: [{ directive: HiveThemedDirective }], ngImport: i0, template: "<ng-content select=\"hive-accordion-tab\"></ng-content>\n", changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AccordionComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hive-accordion', changeDetection: ChangeDetectionStrategy.OnPush, hostDirectives: [HiveThemedDirective], template: "<ng-content select=\"hive-accordion-tab\"></ng-content>\n" }]
        }], propDecorators: { expansion: [{
                type: Input
            }], size: [{
                type: Input,
                args: [{ transform: accordionSizeAttribute }]
            }], expansionChange: [{
                type: Output
            }], accordionTabComponents: [{
                type: ContentChildren,
                args: [forwardRef(() => AccordionTabComponent), {
                        descendants: true,
                    }]
            }] } });

// @todo: [CLOUD-151803] rewrite to use collapsable-item
/**
 * Accordion tab is a part of the accordion component. It represents a single expansion in the accordion.
 * It can be expanded or collapsed by the user.
 *
 * If you want to provide custom content for the left-side icon - use '[slot=left]' selector
 * If you want to provide custom content for the right-side icon - use '[slot=right]' selector (previously it was '[hiveTemplate]', but its deprecated)
 *
 * `hive-accordion` provides API to expand and collapse content programmatically.
 */
class AccordionTabComponent {
    constructor(changeDetectorRef, accordionComponent) {
        this.changeDetectorRef = changeDetectorRef;
        this.accordionComponent = accordionComponent;
        /**
         * Whether the expansion is interactive.
         * NOTE: It is possible to change the state of the expansion using expansions input and public methods even if it's disabled.
         * @see AccordionComponent#expansion
         * @default false
         */
        this.disabled = false;
        /**
         * Whether the expansion is expanded.
         */
        this.isOpen = false;
        /**
         * Value is passed from Accordion component.
         * Type of the accordion component. `smaller-inplace` has no borders and smaller margins,
         * it is designed to use in smaller containers like panels, modals etc
         */
        this.size = 'normal';
        this.expandedChange = new EventEmitter();
        this._expanded = false;
        this._uniqueId = uniqueId('hive-accordion-tab-');
        this.getSize$ = this.accordionComponent?._size$?.pipe(map((groupSize) => groupSize)) ||
            of('normal');
    }
    get expansionId() {
        return this.itemId || this._uniqueId;
    }
    ngOnChanges(changes) {
        if (changes['isOpen']?.currentValue !== undefined) {
            this._expanded = changes['isOpen'].currentValue;
        }
    }
    setExpanded(expanded, emitEvent = true) {
        this._expanded = expanded;
        if (emitEvent) {
            this.expandedChange.emit(this._expanded);
        }
        this.changeDetectorRef.detectChanges();
    }
    close(emitEvent = true) {
        this.setExpanded(false, emitEvent);
    }
    open(emitEvent = true) {
        this.setExpanded(true, emitEvent);
    }
    toggle(emitEvent = true) {
        if (!this.disabled) {
            this.setExpanded(!this._expanded, emitEvent);
        }
    }
    get animationParams() {
        let size = 'normal';
        this.getSize$.subscribe((value) => (size = value)).unsubscribe();
        return {
            contentPaddingTopOpened: size === 'normal' ? HIVE_SPACING_SM : HIVE_SPACING_XXXSM,
            contentPaddingBottomOpened: size === 'normal' ? HIVE_SPACING_LG : HIVE_SPACING_SM,
        };
    }
    countLabelSize(size) {
        return size === 'normal' ? 'large' : 'small';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AccordionTabComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: forwardRef(() => AccordionComponent), optional: true }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.3.12", type: AccordionTabComponent, selector: "hive-accordion-tab", inputs: { heading: "heading", disabled: ["disabled", "disabled", booleanAttribute], itemId: "itemId", isOpen: ["isOpen", "isOpen", booleanAttribute], size: ["size", "size", accordionSizeAttribute] }, outputs: { expandedChange: "expandedChange" }, usesOnChanges: true, hostDirectives: [{ directive: HiveThemedDirective }], ngImport: i0, template: "<div\n    class=\"hive-accordion-tab\"\n    [class.hive-accordion-tab--expanded]=\"_expanded\"\n    [class.hive-accordion-tab--smaller-inplace]=\"\n        (getSize$ | async) === 'smaller-inplace'\n    \"\n>\n    <div\n        (click)=\"toggle(true)\"\n        [class.hive-accordion-tab-trigger--disabled]=\"disabled\"\n        class=\"hive-accordion-tab-trigger\"\n    >\n        <div class=\"hive-accordion-tab-trigger-left\">\n            <div class=\"hive-accordion-tab-trigger-left-content\">\n                <ng-content select=\"[slot=left]\"></ng-content>\n            </div>\n\n            <hive-icon-component\n                hiveChevron\n                class=\"hive-accordion-tab-trigger-chevron-icon\"\n                [class.hive-accordion-tab-trigger-chevron-icon--disabled]=\"\n                    disabled\n                \"\n                icon=\"light/chevron-down.svg\"\n                size=\"medium\"\n                rotationDirection=\"counter-clockwise\"\n                [rotated]=\"_expanded\"\n            ></hive-icon-component>\n        </div>\n\n        <div class=\"hive-accordion-tab-trigger-center\">\n            <hive-label\n                class=\"hive-accordion-tab-trigger-label\"\n                [class.hive-accordion-tab-trigger-label--disabled]=\"disabled\"\n                [size]=\"countLabelSize(getSize$ | async)\"\n                weight=\"semibold\"\n                [label]=\"heading\"\n                [textOverflowEllipsis]=\"!_expanded\"\n            ></hive-label>\n        </div>\n\n        <div class=\"hive-accordion-tab-trigger-right\">\n            <ng-content select=\"[slot=right]\"></ng-content>\n            <ng-content select=\"[hiveTemplate]\"></ng-content>\n        </div>\n    </div>\n\n    @if (_expanded) {\n        <div\n            [@openClose]=\"{\n                value: _expanded ? '*' : 'void',\n                params: animationParams,\n            }\"\n            class=\"hive-accordion-tab-content\"\n        >\n            <ng-content select=\":not([hiveTemplate])\"></ng-content>\n        </div>\n    }\n</div>\n", dependencies: [{ kind: "component", type: LabelComponent, selector: "hive-label", inputs: ["label", "for", "size", "weight", "maxWeight", "horizontalAlignment", "leftIconHelpInfoMessage", "rightIconHelpInfoMessage", "leftIcon", "rightIcon", "required", "textOverflowEllipsis"] }, { kind: "component", type: IconComponent, selector: "hive-icon-component", inputs: ["icon", "size"] }, { kind: "directive", type: ChevronDirective, selector: "hive-icon-component[hiveChevron]", inputs: ["rotationDirection", "rotated"] }, { kind: "pipe", type: i2$1.AsyncPipe, name: "async" }], animations: [openCloseAnimation], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AccordionTabComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hive-accordion-tab', changeDetection: ChangeDetectionStrategy.OnPush, hostDirectives: [HiveThemedDirective], animations: [openCloseAnimation], template: "<div\n    class=\"hive-accordion-tab\"\n    [class.hive-accordion-tab--expanded]=\"_expanded\"\n    [class.hive-accordion-tab--smaller-inplace]=\"\n        (getSize$ | async) === 'smaller-inplace'\n    \"\n>\n    <div\n        (click)=\"toggle(true)\"\n        [class.hive-accordion-tab-trigger--disabled]=\"disabled\"\n        class=\"hive-accordion-tab-trigger\"\n    >\n        <div class=\"hive-accordion-tab-trigger-left\">\n            <div class=\"hive-accordion-tab-trigger-left-content\">\n                <ng-content select=\"[slot=left]\"></ng-content>\n            </div>\n\n            <hive-icon-component\n                hiveChevron\n                class=\"hive-accordion-tab-trigger-chevron-icon\"\n                [class.hive-accordion-tab-trigger-chevron-icon--disabled]=\"\n                    disabled\n                \"\n                icon=\"light/chevron-down.svg\"\n                size=\"medium\"\n                rotationDirection=\"counter-clockwise\"\n                [rotated]=\"_expanded\"\n            ></hive-icon-component>\n        </div>\n\n        <div class=\"hive-accordion-tab-trigger-center\">\n            <hive-label\n                class=\"hive-accordion-tab-trigger-label\"\n                [class.hive-accordion-tab-trigger-label--disabled]=\"disabled\"\n                [size]=\"countLabelSize(getSize$ | async)\"\n                weight=\"semibold\"\n                [label]=\"heading\"\n                [textOverflowEllipsis]=\"!_expanded\"\n            ></hive-label>\n        </div>\n\n        <div class=\"hive-accordion-tab-trigger-right\">\n            <ng-content select=\"[slot=right]\"></ng-content>\n            <ng-content select=\"[hiveTemplate]\"></ng-content>\n        </div>\n    </div>\n\n    @if (_expanded) {\n        <div\n            [@openClose]=\"{\n                value: _expanded ? '*' : 'void',\n                params: animationParams,\n            }\"\n            class=\"hive-accordion-tab-content\"\n        >\n            <ng-content select=\":not([hiveTemplate])\"></ng-content>\n        </div>\n    }\n</div>\n" }]
        }], ctorParameters: () => [{ type: i0.ChangeDetectorRef }, { type: AccordionComponent, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [forwardRef(() => AccordionComponent)]
                }] }], propDecorators: { heading: [{
                type: Input
            }], disabled: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], itemId: [{
                type: Input
            }], isOpen: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], size: [{
                type: Input,
                args: [{ transform: accordionSizeAttribute }]
            }], expandedChange: [{
                type: Output
            }] } });

class AccordionModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AccordionModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: AccordionModule, declarations: [AccordionComponent, AccordionTabComponent], imports: [CommonModule, LabelComponent, IconComponent, ChevronDirective], exports: [AccordionComponent, AccordionTabComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AccordionModule, imports: [CommonModule, LabelComponent, IconComponent] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AccordionModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [AccordionComponent, AccordionTabComponent],
                    imports: [CommonModule, LabelComponent, IconComponent, ChevronDirective],
                    exports: [AccordionComponent, AccordionTabComponent],
                }]
        }] });

// @todo: [CLOUD-151803] rewrite to use collapsable-item
/**
 * `hive-accordion-stepper` provides an API to break down content step by step.
 * It allows to guide users through a series of steps or stages within a process.
 * To project custom actions for step - use `[slot=actions]` selector. (previously `[hiveTemplate]`, but it's deprecated)
 * Any other content without selector will be projected to the body of the step.
 */
class AccordionStepperComponent {
    /**
     * Starts from zero.
     * If currentStep < 0 => value is reassigned to 0
     * If currentStep > steps.length => value is reassigned to the last step
     * @default 0
     */
    set currentStep(val) {
        let step = coerceNumberProperty(val);
        if (!this._ngOnInited) {
            this._currentStepBeforeInit = step;
        }
        if (step >= this.steps.length) {
            step = this.steps.length - 1;
        }
        if (step < 0) {
            step = 0;
        }
        if (step > this.lastTouchedStepIndex$.getValue()) {
            this.lastTouchedStepIndex$.next(step);
        }
        this._currentStep = step;
        this.currentStepChange.emit(this._currentStep);
        this.openStep(this._currentStep);
    }
    get currentStep() {
        return this._currentStep;
    }
    ngOnInit() {
        this._ngOnInited = true;
    }
    ngAfterContentInit() {
        this.steps.forEach((stepComponent, index) => {
            this.initializeStep(stepComponent, index);
        });
        this.steps.changes
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((steps) => {
            steps.forEach((step, index) => {
                this.initializeStep(step, index);
            });
        });
        if (this._currentStepBeforeInit) {
            this.currentStep = this._currentStepBeforeInit;
        }
        this.openStep(this.currentStep);
        this.lastTouchedStepIndex$
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((lastTouchedStepIndex) => {
            this.steps.forEach((step) => {
                if (step.stepIndex === undefined) {
                    return;
                }
                if (step.stepIndex > lastTouchedStepIndex) {
                    step._flowEmphasis = 'unknown';
                    step.disabledFromFlow$.next(true);
                }
                if (step.stepIndex <= lastTouchedStepIndex) {
                    step.disabledFromFlow$.next(false);
                }
            });
        });
    }
    initializeStep(stepComponent, index) {
        stepComponent.stepIndex = index;
        if (!stepComponent.initialized) {
            stepComponent.submitButtonClicked
                .pipe(takeUntilDestroyed(this.destroyRef))
                .subscribe(() => {
                this.handleSubmitOrSkipClick(stepComponent);
            });
            stepComponent.skipButtonClicked
                .pipe(takeUntilDestroyed(this.destroyRef))
                .subscribe(() => {
                this.handleSubmitOrSkipClick(stepComponent);
            });
            stepComponent.stepOpened
                .pipe(takeUntilDestroyed(this.destroyRef))
                .subscribe(() => {
                this.steps.forEach((sc) => {
                    if (sc !== stepComponent) {
                        sc.isOpen = false;
                    }
                });
            });
        }
        if (stepComponent.stepIndex === this.currentStep &&
            stepComponent._flowEmphasis === 'unknown' &&
            !stepComponent.disabled) {
            stepComponent._flowEmphasis = 'in-progress';
            stepComponent.isOpen = true;
        }
        if (this.steps.length - 1 === index) {
            stepComponent.submitButtonOverride =
                this.defaultLastSubmitButtonLabel;
        }
        stepComponent.initialized = true;
    }
    handleSubmitOrSkipClick(stepComponentInWhichClickWasFired) {
        stepComponentInWhichClickWasFired._flowEmphasis = 'complete';
        if (stepComponentInWhichClickWasFired.stepIndex !== undefined &&
            this.allFurtherStepsDisabled(stepComponentInWhichClickWasFired.stepIndex)) {
            const currentIndex = stepComponentInWhichClickWasFired.stepIndex;
            this.currentStep = this.steps
                .toArray()
                .findIndex(({ disabled }, index) => index > currentIndex && !disabled);
            this.openStep(this.currentStep);
        }
        else {
            this.currentStep = this.currentStep + 1;
            stepComponentInWhichClickWasFired.isOpen = false;
        }
    }
    allFurtherStepsDisabled(stepIndex) {
        return this.steps
            .toArray()
            .slice(stepIndex + 1)
            .some(({ disabled }) => !disabled);
    }
    /**
     * @param stepIndex starts from 0
     */
    openStep(stepIndex) {
        const stepComponent = this.steps.get(stepIndex);
        if (!stepComponent) {
            return;
        }
        stepComponent.isOpen = !stepComponent.disabled;
        if (!stepComponent.disabled &&
            stepComponent._flowEmphasis === 'unknown') {
            stepComponent._flowEmphasis = 'in-progress';
        }
    }
    constructor(destroyRef, cdr) {
        this.destroyRef = destroyRef;
        this.cdr = cdr;
        /**
         * @internal
         */
        this.lastTouchedStepIndex$ = new BehaviorSubject(0);
        /**
         * @internal
         */
        this.defaultLastSubmitButtonLabel = 'Finish';
        /**
         * Emits when the current step is changed.
         */
        this.currentStepChange = new EventEmitter();
        this.steps = new QueryList();
        this._currentStep = 0;
        this._currentStepBeforeInit = 0;
        this._ngOnInited = false;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AccordionStepperComponent, deps: [{ token: i0.DestroyRef }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: AccordionStepperComponent, selector: "hive-accordion-stepper", inputs: { currentStep: "currentStep" }, outputs: { currentStepChange: "currentStepChange" }, queries: [{ propertyName: "steps", predicate: i0.forwardRef(() => AccordionStepComponent) }], hostDirectives: [{ directive: HiveThemedDirective }], ngImport: i0, template: "<hive-accordion>\n    <ng-container ngProjectAs=\"hive-accordion-tab\">\n        <ng-content select=\"hive-accordion-step\"></ng-content>\n    </ng-container>\n</hive-accordion>\n", dependencies: [{ kind: "component", type: AccordionComponent, selector: "hive-accordion", inputs: ["expansion", "size"], outputs: ["expansionChange"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AccordionStepperComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hive-accordion-stepper', changeDetection: ChangeDetectionStrategy.OnPush, hostDirectives: [HiveThemedDirective], template: "<hive-accordion>\n    <ng-container ngProjectAs=\"hive-accordion-tab\">\n        <ng-content select=\"hive-accordion-step\"></ng-content>\n    </ng-container>\n</hive-accordion>\n" }]
        }], ctorParameters: () => [{ type: i0.DestroyRef }, { type: i0.ChangeDetectorRef }], propDecorators: { currentStep: [{
                type: Input
            }], currentStepChange: [{
                type: Output
            }], steps: [{
                type: ContentChildren,
                args: [forwardRef(() => AccordionStepComponent)]
            }] } });

/**
 * To project custom actions for step - use `[slot=actions]` selector. (previously `[hiveTemplate]`, but it's deprecated)
 * Any other content without selector will be projected to the body of the step.
 */
class AccordionStepComponent {
    /**
     * "Continue", by default for all elements except last step. Last step default label will be: "Finish"
     */
    set submitButtonLabel(value) {
        this._submitButtonLabel = value;
    }
    /**
     * Whether the submit button is disabled.
     *
     * Whenever submit button gets disabled, all following steps will be disabled as well,
     * and current step will be marked as in-progress.
     */
    set submitButtonDisabled(val) {
        this._submitButtonDisabled = coerceBooleanProperty(val);
        if (this._submitButtonDisabled && this.stepIndex !== undefined) {
            this.accordionStepper.lastTouchedStepIndex$.next(this.stepIndex);
            this._flowEmphasis = 'in-progress';
            this.cdr.detectChanges();
        }
    }
    get submitButtonDisabled() {
        return this._submitButtonDisabled;
    }
    /**
     * This is the actual emphasis of the step.
     * An intention is to keep both states of `emphasis`,
     * defined by user and by stepper flow.
     *
     * When user defines emphasis, we should use it.
     * But when they set undefined value instead, we need to know
     * what's the emphasis of the step, defined by interactions.
     *
     * @internal
     */
    get actualEmphasis() {
        if (isDefined(this.emphasis)) {
            return this.emphasis;
        }
        else {
            return this._flowEmphasis;
        }
    }
    /**
     * internal
     */
    get submitButtonLabel() {
        return (this._submitButtonLabel ||
            this.submitButtonOverride ||
            this.DEFAULT_SUBMIT_BUTTON_LABEL);
    }
    /**
     * @internal
     */
    set stepIndex(val) {
        this._stepIndex = val;
        this.cdr.detectChanges();
    }
    get stepIndex() {
        return this._stepIndex;
    }
    /**
     * @internal
     */
    set isOpen(val) {
        this._isOpen = val;
        if (this._isOpen) {
            this.stepOpened.next();
            this.touched = true;
        }
        this.expandedChange.emit(this._isOpen);
        this.cdr.markForCheck();
    }
    get isOpen() {
        return this._isOpen;
    }
    constructor(cdr, accordionStepper) {
        this.cdr = cdr;
        this.accordionStepper = accordionStepper;
        /**
         * Determines whether step is interactive or not
         */
        this.disabled = false;
        /**
         * Defines label for the skip button
         */
        this.skipButtonLabel = 'Skip';
        /**
         * Whether the submit button is visible
         */
        this.submitButtonVisible = true;
        /**
         * Whether the skip button is visible
         */
        this.skipButtonVisible = false;
        /**
         * The emphasis, defined by stepper flow.
         * Only used if custom `emphasis` is not defined.
         *
         * @internal
         */
        this._flowEmphasis = 'unknown';
        this.submitButtonClicked = new EventEmitter();
        this.expandedChange = new EventEmitter();
        /**
         * @internal
         */
        this.stepOpened = new Subject();
        /**
         * @internal
         */
        this.skipButtonClicked = new Subject();
        /**
         * @internal
         */
        this.initialized = false;
        /**
         * Whether the step was touched
         */
        this.touched = false;
        this.EMPHASIS_TO_ICON_MAP = {
            'error': 'solid/triangle-exclamation.svg',
            'warning': 'solid/exclamation.svg',
            'complete': 'solid/check.svg',
            'in-progress': 'solid/hourglass-half.svg',
            'unknown': 'solid/question.svg',
        };
        this._isOpen = false;
        this._submitButtonDisabled = false;
        this._submitButtonLabel = '';
        /**
         * Meaning, this step is disabled because user has not submitted previous steps yet.
         *
         * @internal
         */
        this.disabledFromFlow$ = new BehaviorSubject(true);
        this.DEFAULT_SUBMIT_BUTTON_LABEL = 'Continue';
    }
    ngOnDestroy() {
        this.stepOpened.complete();
        this.skipButtonClicked.complete();
    }
    toggle() {
        if (!this.disabled && !this.disabledFromFlow$.getValue()) {
            this.isOpen = !this.isOpen;
        }
    }
    handleSubmitButtonClick() {
        this.submitButtonClicked.emit();
    }
    handleSkipButtonClick() {
        this.skipButtonClicked.next();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AccordionStepComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: AccordionStepperComponent }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.3.12", type: AccordionStepComponent, selector: "hive-accordion-step", inputs: { heading: "heading", disabled: ["disabled", "disabled", booleanAttribute], emphasis: "emphasis", skipButtonLabel: "skipButtonLabel", submitButtonVisible: ["submitButtonVisible", "submitButtonVisible", booleanAttribute], skipButtonVisible: ["skipButtonVisible", "skipButtonVisible", booleanAttribute], submitButtonLabel: "submitButtonLabel", submitButtonDisabled: "submitButtonDisabled" }, outputs: { submitButtonClicked: "submitButtonClicked", expandedChange: "expandedChange" }, host: { properties: { "attr.aria-expanded": "this.isOpen" } }, hostDirectives: [{ directive: HiveThemedDirective }], ngImport: i0, template: "<hive-accordion-tab\n    (expandedChange)=\"toggle()\"\n    [disabled]=\"disabled || (disabledFromFlow$ | async)\"\n    [heading]=\"heading\"\n    [isOpen]=\"isOpen\"\n    size=\"normal\"\n>\n    <ng-container slot=\"left\">\n        <div\n            class=\"hive-accordion-step-trigger-icon-container\"\n            [class.hive-accordion-step-trigger-icon-container--disabled]=\"\n                disabled\n            \"\n            [ngClass]=\"[\n                'hive-accordion-step-trigger-icon-container--' + actualEmphasis,\n            ]\"\n        >\n            <hive-icon-component\n                size=\"smallest\"\n                [icon]=\"EMPHASIS_TO_ICON_MAP[actualEmphasis]\"\n            ></hive-icon-component>\n        </div>\n    </ng-container>\n\n    <ng-container slot=\"right\">\n        <hive-icon-component\n            class=\"hive-accordion-step_chevron\"\n            [class.hive-accordion-step_chevron--disabled]=\"disabled\"\n            hiveChevron\n            icon=\"light/chevron-down.svg\"\n            size=\"medium\"\n            [rotated]=\"isOpen\"\n        ></hive-icon-component>\n    </ng-container>\n\n    <ng-container>\n        <div class=\"hive-accordion-step-body\">\n            <div class=\"hive-accordion-step-content\">\n                <ng-content\n                    select=\":not([hiveTemplate]):not([slot=actions])\"\n                ></ng-content>\n            </div>\n\n            <div class=\"hive-accordion-step-buttons\">\n                @if (submitButtonVisible) {\n                    <hive-button\n                        [label]=\"submitButtonLabel\"\n                        [disabled]=\"submitButtonDisabled\"\n                        (click)=\"handleSubmitButtonClick()\"\n                        data-testid=\"accordion-step-submit-button\"\n                    ></hive-button>\n                }\n\n                @if (skipButtonVisible) {\n                    <hive-button\n                        [label]=\"skipButtonLabel\"\n                        emphasis=\"tertiary\"\n                        (click)=\"handleSkipButtonClick()\"\n                        data-testid=\"accordion-step-skip-button\"\n                    ></hive-button>\n                }\n\n                <ng-content select=\"[hiveTemplate]\"></ng-content>\n\n                <ng-content select=\"[slot=actions]\"></ng-content>\n            </div>\n        </div>\n    </ng-container>\n</hive-accordion-tab>\n", dependencies: [{ kind: "directive", type: i2$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "component", type: IconComponent, selector: "hive-icon-component", inputs: ["icon", "size"] }, { kind: "component", type: ButtonComponent, selector: "hive-button", inputs: ["type", "menuButtonActive", "hasMenuButtonCaret", "label", "accessibleName", "icon", "iconPosition", "emphasis", "title", "size", "isLoading", "disabled", "rounded", "width"] }, { kind: "component", type: AccordionTabComponent, selector: "hive-accordion-tab", inputs: ["heading", "disabled", "itemId", "isOpen", "size"], outputs: ["expandedChange"] }, { kind: "directive", type: ChevronDirective, selector: "hive-icon-component[hiveChevron]", inputs: ["rotationDirection", "rotated"] }, { kind: "pipe", type: i2$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AccordionStepComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hive-accordion-step', changeDetection: ChangeDetectionStrategy.OnPush, hostDirectives: [HiveThemedDirective], template: "<hive-accordion-tab\n    (expandedChange)=\"toggle()\"\n    [disabled]=\"disabled || (disabledFromFlow$ | async)\"\n    [heading]=\"heading\"\n    [isOpen]=\"isOpen\"\n    size=\"normal\"\n>\n    <ng-container slot=\"left\">\n        <div\n            class=\"hive-accordion-step-trigger-icon-container\"\n            [class.hive-accordion-step-trigger-icon-container--disabled]=\"\n                disabled\n            \"\n            [ngClass]=\"[\n                'hive-accordion-step-trigger-icon-container--' + actualEmphasis,\n            ]\"\n        >\n            <hive-icon-component\n                size=\"smallest\"\n                [icon]=\"EMPHASIS_TO_ICON_MAP[actualEmphasis]\"\n            ></hive-icon-component>\n        </div>\n    </ng-container>\n\n    <ng-container slot=\"right\">\n        <hive-icon-component\n            class=\"hive-accordion-step_chevron\"\n            [class.hive-accordion-step_chevron--disabled]=\"disabled\"\n            hiveChevron\n            icon=\"light/chevron-down.svg\"\n            size=\"medium\"\n            [rotated]=\"isOpen\"\n        ></hive-icon-component>\n    </ng-container>\n\n    <ng-container>\n        <div class=\"hive-accordion-step-body\">\n            <div class=\"hive-accordion-step-content\">\n                <ng-content\n                    select=\":not([hiveTemplate]):not([slot=actions])\"\n                ></ng-content>\n            </div>\n\n            <div class=\"hive-accordion-step-buttons\">\n                @if (submitButtonVisible) {\n                    <hive-button\n                        [label]=\"submitButtonLabel\"\n                        [disabled]=\"submitButtonDisabled\"\n                        (click)=\"handleSubmitButtonClick()\"\n                        data-testid=\"accordion-step-submit-button\"\n                    ></hive-button>\n                }\n\n                @if (skipButtonVisible) {\n                    <hive-button\n                        [label]=\"skipButtonLabel\"\n                        emphasis=\"tertiary\"\n                        (click)=\"handleSkipButtonClick()\"\n                        data-testid=\"accordion-step-skip-button\"\n                    ></hive-button>\n                }\n\n                <ng-content select=\"[hiveTemplate]\"></ng-content>\n\n                <ng-content select=\"[slot=actions]\"></ng-content>\n            </div>\n        </div>\n    </ng-container>\n</hive-accordion-tab>\n" }]
        }], ctorParameters: () => [{ type: i0.ChangeDetectorRef }, { type: AccordionStepperComponent }], propDecorators: { heading: [{
                type: Input
            }], disabled: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], emphasis: [{
                type: Input
            }], skipButtonLabel: [{
                type: Input
            }], submitButtonVisible: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], skipButtonVisible: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], submitButtonLabel: [{
                type: Input
            }], submitButtonDisabled: [{
                type: Input
            }], submitButtonClicked: [{
                type: Output
            }], expandedChange: [{
                type: Output
            }], isOpen: [{
                type: HostBinding,
                args: ['attr.aria-expanded']
            }] } });

class AccordionStepperModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AccordionStepperModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: AccordionStepperModule, declarations: [AccordionStepperComponent, AccordionStepComponent], imports: [CommonModule,
            LabelComponent,
            IconComponent,
            ButtonComponent,
            AccordionModule,
            ChevronDirective], exports: [AccordionStepperComponent, AccordionStepComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AccordionStepperModule, imports: [CommonModule,
            LabelComponent,
            IconComponent,
            ButtonComponent,
            AccordionModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AccordionStepperModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [AccordionStepperComponent, AccordionStepComponent],
                    imports: [
                        CommonModule,
                        LabelComponent,
                        IconComponent,
                        ButtonComponent,
                        AccordionModule,
                        ChevronDirective,
                    ],
                    exports: [AccordionStepperComponent, AccordionStepComponent],
                }]
        }] });

class AppHeaderHelpMenuDirective {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AppHeaderHelpMenuDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: AppHeaderHelpMenuDirective, selector: "hive-menu[appHeaderHelpMenu]", ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AppHeaderHelpMenuDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'hive-menu[appHeaderHelpMenu]',
                }]
        }] });

class MenuItemBulkSelectorComponent {
    constructor() {
        this.cssClass = true;
        /**
         * Text of the item
         */
        this.label = input('');
        this.deselect = output();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: MenuItemBulkSelectorComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.1.0", version: "17.3.12", type: MenuItemBulkSelectorComponent, selector: "hive-menu-item-bulk-selector", inputs: { label: { classPropertyName: "label", publicName: "label", isSignal: true, isRequired: false, transformFunction: null } }, outputs: { deselect: "deselect" }, host: { properties: { "class.hive-menu-item-bulk-selector": "this.cssClass" } }, hostDirectives: [{ directive: HiveThemedDirective }], ngImport: i0, template: "<hive-label\n    class=\"hive-menu-item_label\"\n    size=\"small\"\n    weight=\"regular\"\n    [label]=\"label()\"\n></hive-label>\n\n<hive-icon-component\n    class=\"hive-menu-item-close-icon\"\n    icon=\"light/xmark.svg\"\n    size=\"small\"\n    (click)=\"deselect.emit()\"\n></hive-icon-component>\n", dependencies: [{ kind: "component", type: IconComponent, selector: "hive-icon-component", inputs: ["icon", "size"] }, { kind: "component", type: LabelComponent, selector: "hive-label", inputs: ["label", "for", "size", "weight", "maxWeight", "horizontalAlignment", "leftIconHelpInfoMessage", "rightIconHelpInfoMessage", "leftIcon", "rightIcon", "required", "textOverflowEllipsis"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: MenuItemBulkSelectorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hive-menu-item-bulk-selector', changeDetection: ChangeDetectionStrategy.OnPush, hostDirectives: [HiveThemedDirective], template: "<hive-label\n    class=\"hive-menu-item_label\"\n    size=\"small\"\n    weight=\"regular\"\n    [label]=\"label()\"\n></hive-label>\n\n<hive-icon-component\n    class=\"hive-menu-item-close-icon\"\n    icon=\"light/xmark.svg\"\n    size=\"small\"\n    (click)=\"deselect.emit()\"\n></hive-icon-component>\n" }]
        }], propDecorators: { cssClass: [{
                type: HostBinding,
                args: ['class.hive-menu-item-bulk-selector']
            }] } });

class MenuItemComponent {
    get isDisabled() {
        return this.disabled || null;
    }
    get tabIndex() {
        return this.disabled ? -1 : 0;
    }
    handleKeyboardEvent(event) {
        if (event.key === 'Enter' || event.key === ' ') {
            this.elRef.nativeElement.click();
        }
    }
    handleClick(event) {
        if (!this.disabled) {
            this.menuItemClick.emit(this);
        }
        else {
            event.stopPropagation();
        }
    }
    get isDestructive() {
        return this.destructive;
    }
    constructor(elRef) {
        this.elRef = elRef;
        this.cssClass = true;
        /**
         * Disables the menu item
         */
        this.disabled = false;
        /**
         * Emits when the menu item is clicked
         */
        this.menuItemClick = new EventEmitter();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: MenuItemComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.3.12", type: MenuItemComponent, selector: "hive-menu-item", inputs: { label: "label", disabled: ["disabled", "disabled", booleanAttribute], destructive: ["destructive", "destructive", booleanAttribute], external: ["external", "external", booleanAttribute] }, outputs: { menuItemClick: "menuItemClick" }, host: { listeners: { "keypress": "handleKeyboardEvent($event)", "click": "handleClick($event)" }, properties: { "class.hive-menu-item": "this.cssClass", "attr.disabled": "this.isDisabled", "class.hive-menu-item--disabled": "this.isDisabled", "attr.tabindex": "this.tabIndex", "class.hive-menu-item--destructive": "this.isDestructive" } }, hostDirectives: [{ directive: HiveThemedDirective }], ngImport: i0, template: "<div class=\"hive-menu-item_container\">\n    <hive-label\n        class=\"hive-menu-item_label\"\n        [class.hive-menu-item_label--destructive]=\"destructive\"\n        [class.hive-menu-item_label--disabled]=\"disabled\"\n        size=\"small\"\n        weight=\"regular\"\n        [label]=\"label\"\n    ></hive-label>\n\n    @if (external) {\n        <hive-icon-component\n            class=\"hive-menu-item-external-icon\"\n            icon=\"regular/arrow-up-right-from-square.svg\"\n            size=\"smallest\"\n        ></hive-icon-component>\n    }\n</div>\n", dependencies: [{ kind: "component", type: IconComponent, selector: "hive-icon-component", inputs: ["icon", "size"] }, { kind: "component", type: LabelComponent, selector: "hive-label", inputs: ["label", "for", "size", "weight", "maxWeight", "horizontalAlignment", "leftIconHelpInfoMessage", "rightIconHelpInfoMessage", "leftIcon", "rightIcon", "required", "textOverflowEllipsis"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: MenuItemComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hive-menu-item', changeDetection: ChangeDetectionStrategy.OnPush, hostDirectives: [HiveThemedDirective], template: "<div class=\"hive-menu-item_container\">\n    <hive-label\n        class=\"hive-menu-item_label\"\n        [class.hive-menu-item_label--destructive]=\"destructive\"\n        [class.hive-menu-item_label--disabled]=\"disabled\"\n        size=\"small\"\n        weight=\"regular\"\n        [label]=\"label\"\n    ></hive-label>\n\n    @if (external) {\n        <hive-icon-component\n            class=\"hive-menu-item-external-icon\"\n            icon=\"regular/arrow-up-right-from-square.svg\"\n            size=\"smallest\"\n        ></hive-icon-component>\n    }\n</div>\n" }]
        }], ctorParameters: () => [{ type: i0.ElementRef }], propDecorators: { cssClass: [{
                type: HostBinding,
                args: ['class.hive-menu-item']
            }], label: [{
                type: Input
            }], disabled: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], isDisabled: [{
                type: HostBinding,
                args: ['attr.disabled']
            }, {
                type: HostBinding,
                args: ['class.hive-menu-item--disabled']
            }], tabIndex: [{
                type: HostBinding,
                args: ['attr.tabindex']
            }], handleKeyboardEvent: [{
                type: HostListener,
                args: ['keypress', ['$event']]
            }], handleClick: [{
                type: HostListener,
                args: ['click', ['$event']]
            }], destructive: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], isDestructive: [{
                type: HostBinding,
                args: ['class.hive-menu-item--destructive']
            }], external: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], menuItemClick: [{
                type: Output
            }] } });

/**
 * Injection token for allowing required state of the checkbox
 */
const CHECKBOX_ALLOW_REQUIRED = new InjectionToken('allowRequired');

class SelectionMenuService {
    constructor() {
        /**
         * Subject that emits the selection model.
         */
        this.selectionModel$ = new BehaviorSubject(this.createSelectionModel(false, []));
        /**
         * Subject that emits when the `selectionModel` selection changes.
         */
        this.selectionChanged$ = this.selectionModel$.pipe(switchMap$1((selectionModel) => selectionModel.changed), map((selectionChange) => ({
            selection: selectionChange.source.selected,
            added: selectionChange.added,
            removed: selectionChange.removed,
        })));
        /**
         * Subject that contains the boolean value of whether the menu and,
         * consequently, the selection model is multiselect or not.
         */
        this.isMultiselect$ = new BehaviorSubject(false);
        /**
         * Subject that contains the value of selection which should `selectionModel`
         * set to.
         *
         * It is done that way to not have `selectionModel`
         * emit changes when the selection is set from the outside,
         * not directly by user interaction.
         */
        this.selection$ = new BehaviorSubject([]);
        this.destroy$ = new Subject();
        combineLatest([this.isMultiselect$, this.selection$])
            .pipe(distinctUntilChanged(), takeUntil(this.destroy$))
            .subscribe(([isMultiselect, selection]) => {
            this.selectionModel$.next(this.createSelectionModel(isMultiselect, selection));
        });
    }
    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
    /**
     * Creates a selection model.
     *
     * @param isMultiselect
     * @param selection
     * @private
     */
    createSelectionModel(isMultiselect, selection) {
        return new SelectionModel(isMultiselect, selection, true);
    }
    /**
     * Toggles the selection state of an item.
     */
    toggleSelectionItem(selectionItem) {
        if (!this.isMultiselect$.getValue() &&
            this.selectionModel$.getValue().isSelected(selectionItem.value) &&
            !selectionItem.disabled) {
            return;
        }
        this.selectionModel$.getValue().toggle(selectionItem.value);
    }
    /**
     * Selects items.
     */
    selectItems(...selectionItems) {
        const enabledItems = this.getEnabledItems(selectionItems).map((si) => si.value);
        if (selectionItems.length > 0) {
            this.selectionModel$.getValue().select(...enabledItems);
        }
    }
    /**
     * Selects items.
     */
    selectValues(...values) {
        if (values.length > 0) {
            this.selectionModel$.getValue().select(...values);
        }
    }
    /**
     * Deselects items.
     */
    deselectItems(...selectionItems) {
        const enabledItems = this.getEnabledItems(selectionItems).map((si) => si.value);
        if (selectionItems.length > 0) {
            this.selectionModel$.getValue().deselect(...enabledItems);
        }
    }
    /**
     * Deselects items.
     */
    deselectValues(...values) {
        if (values.length > 0) {
            this.selectionModel$.getValue().deselect(...values);
        }
    }
    /**
     * Filters out items which should not be selectable by user interaction.
     */
    getEnabledItems(selectionItems) {
        return selectionItems.filter((item) => !item.disabled);
    }
    /**
     * Checks if there are any user-selectable items.
     */
    isOnlyDisabledItems(selectionItems) {
        return this.getEnabledItems(selectionItems).length === 0;
    }
    /**
     * Checks if all user-selectable items are selected.
     *
     * In the context of a `SelectionMenuService`, selectable items are considered to
     * be non-disabled items.
     * This is because `SelectionMenuService` does not know anything
     * about what to consider as 'all items', since this is the user who decides
     * which set of items to pass.
     * It means that neither service nor the components that use it do not
     * store the state of initially available items.
     *
     * In the context of a `SelectionMenuComponent`, user-selectable items are considered
     * to be items that are both non-disabled and visible.
     *
     * @returns {boolean} - Returns true if all selectable items are selected, false otherwise.
     */
    isAllSelectableItemsSelected(selectionItems) {
        const items = this.getEnabledItems(selectionItems);
        return items.every((item) => this.selectionModel$.getValue().isSelected(item.value));
    }
    isAllValuesSelected(...values) {
        return values.every((value) => this.selectionModel$.getValue().isSelected(value));
    }
    /**
     * Toggles the selection state of all items.
     * If all items are selected, it clears the selection. Otherwise, it selects all items.
     */
    toggleAllItems(selectionItems) {
        if (this.isAllSelectableItemsSelected(selectionItems)) {
            this.deselectItems(...selectionItems);
        }
        else {
            this.selectItems(...selectionItems);
        }
    }
    /**
     * Toggles the selection state of all values.
     */
    toggleAllValues(...values) {
        if (this.isAllValuesSelected(...values)) {
            this.deselectValues(...values);
        }
        else {
            this.selectValues(...values);
        }
    }
    /**
     * Checks if any item is selected.
     *
     * @returns {boolean} - Returns true if any item is selected, false otherwise.
     */
    isAnySelectableItemSelected(selectionItems) {
        const items = this.getEnabledItems(selectionItems);
        return items.some((item) => this.selectionModel$.getValue().isSelected(item.value));
    }
    isOnlyOneEnabledValueSelected(selectionItems) {
        const items = this.getEnabledItems(selectionItems);
        return (items.filter((item) => this.selectionModel$.getValue().isSelected(item.value)).length === 1);
    }
    /**
     * Checks if a specific item is selected.
     *
     * @param item - The item to check.
     * @returns {boolean} - Returns true if the item is selected, false otherwise.
     */
    isItemSelected(item) {
        return this.selectionModel$.getValue().isSelected(item.value);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SelectionMenuService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SelectionMenuService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SelectionMenuService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [] });

const SELECTION_MENU_PROVIDER = {
    provide: SelectionMenuService,
    useFactory: (parentInjector, service) => {
        if (!service) {
            const injector = Injector.create({
                providers: [{ provide: SelectionMenuService }],
                parent: parentInjector,
            });
            service = injector.get(SelectionMenuService);
        }
        return service;
    },
    deps: [Injector, [new Optional(), new SkipSelf(), SelectionMenuService]],
};

/**
 * Both `Section` and `Item` `SelectionMenu` components are provided by this token.
 *
 * This is to ensure that using `@ContentChildren` in the component will return
 * the structure in the order it was provided.
 */
const SELECTION_MENU_CONTENT = new InjectionToken('hive-selection-menu-item');

/**
 * Check if the given abstract control has a `Validators.required` validator.
 *
 * @param abstractControl
 */
const hasRequiredField = (abstractControl) => {
    if (!abstractControl) {
        return false;
    }
    if (abstractControl.hasValidator(Validators.required)) {
        return true;
    }
    if ('controls' in abstractControl) {
        const abstractGroup = abstractControl;
        for (const controlName in abstractGroup.controls) {
            if (abstractGroup.controls[controlName]) {
                if (hasRequiredField(abstractGroup.controls[controlName])) {
                    return true;
                }
            }
        }
    }
    return false;
};

class FormComponentValidityDirective {
    get invalid() {
        return this.isControlInvalid(this.ngControl, false);
    }
    get webkitInvalid() {
        return this.isControlInvalid(this.ngControl, true);
    }
    get required() {
        return hasRequiredField(this.ngControl?.control);
    }
    isControlInvalid(control, shouldFixAnIssue = false) {
        // https://github.com/angular/angular/issues/24836#issuecomment-1023819950
        // tl;dr: In Safari, clicking a checkbox does not focus it at all,
        // therefore, it can never be blurred ("touched")
        if (this.platform.WEBKIT && shouldFixAnIssue) {
            return control?.invalid ?? false;
        }
        return (control?.invalid && control?.touched) ?? false;
    }
    constructor(injector, platform) {
        this.injector = injector;
        this.platform = platform;
    }
    ngOnInit() {
        // inject in ngOnInit to avoid circular dependency
        this.ngControl = this.injector.get(NgControl, null, {
            optional: true,
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FormComponentValidityDirective, deps: [{ token: i0.Injector }, { token: i1$2.Platform }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: FormComponentValidityDirective, isStandalone: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FormComponentValidityDirective, decorators: [{
            type: Directive,
            args: [{
                    standalone: true,
                }]
        }], ctorParameters: () => [{ type: i0.Injector }, { type: i1$2.Platform }] });

/**
 * Log warning message when component's input is controlled by group component.
 * @param componentName
 * @param inputName
 * @param groupComponentName
 */
function logInputGroupWarning(componentName, inputName, groupComponentName) {
    console.warn(`${componentName}: component's ${inputName} input is controlled by ${groupComponentName}. Use ${inputName} input in ${groupComponentName} instead.`);
}

/**
 * Injection token for the disabled state of the checkbox group.
 */
const CHECKBOX_DISABLED_TOKEN = new InjectionToken('disabled');
/**
 * Injection token for the size of the checkbox group.
 */
const CHECKBOX_SIZE_TOKEN = new InjectionToken('size');
class CheckboxGroupComponent {
    constructor(disabled$, size$) {
        this.disabled$ = disabled$;
        this.size$ = size$;
        /**
         * The label for the checkbox group.
         */
        this.heading = '';
        /**
         * The orientation of the checkbox group.
         */
        this.orientation = 'horizontal';
        this.labelSize$ = this.size$.pipe(map((size) => (size === 'small' ? 'medium' : 'large')));
    }
    /**
     * The disabled state of the checkboxes in group.
     */
    set disabled(isDisabled) {
        this.disabled$.next(isDisabled);
    }
    /**
     * The size of the checkboxes in group.
     */
    set size(size) {
        this.size$.next(size ?? 'small');
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CheckboxGroupComponent, deps: [{ token: CHECKBOX_DISABLED_TOKEN }, { token: CHECKBOX_SIZE_TOKEN }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "16.1.0", version: "17.3.12", type: CheckboxGroupComponent, isStandalone: true, selector: "hive-checkbox-group", inputs: { heading: "heading", orientation: "orientation", disabled: ["disabled", "disabled", booleanAttribute], size: "size" }, providers: [
            {
                provide: CHECKBOX_DISABLED_TOKEN,
                useFactory: () => new BehaviorSubject(false),
            },
            {
                provide: CHECKBOX_SIZE_TOKEN,
                useFactory: () => new BehaviorSubject('small'),
            },
        ], ngImport: i0, template: "<hive-label\n    [label]=\"heading\"\n    weight=\"semibold\"\n    [size]=\"labelSize$ | async\"\n></hive-label>\n\n<div\n    class=\"hive-checkbox-group-container\"\n    [ngClass]=\"'hive-checkbox-group--' + orientation\"\n>\n    <ng-content select=\"hive-checkbox\"></ng-content>\n</div>\n", dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i2$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "pipe", type: i2$1.AsyncPipe, name: "async" }, { kind: "component", type: LabelComponent, selector: "hive-label", inputs: ["label", "for", "size", "weight", "maxWeight", "horizontalAlignment", "leftIconHelpInfoMessage", "rightIconHelpInfoMessage", "leftIcon", "rightIcon", "required", "textOverflowEllipsis"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CheckboxGroupComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hive-checkbox-group', standalone: true, imports: [CommonModule, LabelComponent, NgClass], providers: [
                        {
                            provide: CHECKBOX_DISABLED_TOKEN,
                            useFactory: () => new BehaviorSubject(false),
                        },
                        {
                            provide: CHECKBOX_SIZE_TOKEN,
                            useFactory: () => new BehaviorSubject('small'),
                        },
                    ], template: "<hive-label\n    [label]=\"heading\"\n    weight=\"semibold\"\n    [size]=\"labelSize$ | async\"\n></hive-label>\n\n<div\n    class=\"hive-checkbox-group-container\"\n    [ngClass]=\"'hive-checkbox-group--' + orientation\"\n>\n    <ng-content select=\"hive-checkbox\"></ng-content>\n</div>\n" }]
        }], ctorParameters: () => [{ type: i4.BehaviorSubject, decorators: [{
                    type: Inject,
                    args: [CHECKBOX_DISABLED_TOKEN]
                }] }, { type: i4.BehaviorSubject, decorators: [{
                    type: Inject,
                    args: [CHECKBOX_SIZE_TOKEN]
                }] }], propDecorators: { heading: [{
                type: Input
            }], orientation: [{
                type: Input
            }], disabled: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], size: [{
                type: Input
            }] } });

/**
 * Subscribes to an observable with automatic cleanup and triggers change detection.
 *
 * @param observable The observable to subscribe to.
 * @param next Callback to execute when the observable emits a new value.
 * @param destroyRef Angular's `DestroyRef` for automatic unsubscription.
 * @param cdr Optional `ChangeDetectorRef` to trigger change detection.
 */
function subscribeWithCleanup(observable, next, destroyRef = inject(DestroyRef), cdr) {
    observable?.pipe(safeTakeUntilDestroyed(destroyRef)).subscribe((value) => {
        next(value);
        cdr?.detectChanges();
    });
}

let nextUniqueId$3 = 0;
const CHECKBOX_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => CheckboxComponent),
    multi: true,
};
/**
 * Checkboxes in user interface allow users to make binary choices or selections within a form or list.
 * This component is perfect for scenarios where multiple items can be chosen simultaneously, or for toggling the state of a single option.
 *
 * Checkbox component supports:
 * - `label` property. Provides proper styling for label text, so it should be preferred over `<label>`
 * - `indeterminate` state, in addition to `checked` and `unchecked` states. Useful for cases when a selection is partially made or when the state cannot be determined.
 * - Uncontrolled mode, template and reactive forms.
 */
class CheckboxComponent {
    /**
     * Size of both the checkbox itself and its label
     * @default 'small'
     */
    set size(size) {
        if (this.checkboxGroup) {
            logInputGroupWarning(CheckboxComponent.name, 'size', CheckboxGroupComponent.name);
            return;
        }
        this._size = size ?? 'small';
    }
    /**
     * `disabled` attribute of `<input>`
     *
     * @see {@link HTMLInputElement.prototype#disabled}
     */
    set disabled(isDisabled) {
        this._disabled = coerceBooleanProperty(isDisabled);
    }
    get disabled() {
        return this._disabled || this._groupDisabled;
    }
    /**
     * `checked` attribute of `<input type="checkbox" />`
     *
     * @see {@link HTMLInputElement.prototype#checked}
     */
    get checked() {
        return this._checked;
    }
    set checked(isChecked) {
        const checked = coerceBooleanProperty(isChecked);
        if (checked !== this.checked) {
            this._checked = checked;
            this.cdr.markForCheck();
        }
    }
    /**
     * `required` attribute of `<input>`
     *
     * @default false
     * @see {@link HTMLInputElement.prototype#required}
     */
    get required() {
        return this._required;
    }
    set required(isRequired) {
        this._required = coerceBooleanProperty(isRequired);
    }
    /**
     * `indeterminate` attribute of `<input type="checkbox" />`
     *
     * This state is known as "mixed"
     * mode and represents the third state of the checkbox.
     *
     * Usually, it is used in lists and tables,
     * where it indicates that only part of sub-checkboxes are checked
     *
     * @see {@link HTMLInputElement.prototype#indeterminate}
     * @see [Indeterminate at MDN]{@link https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/checkbox#indeterminate_state_checkboxes}
     */
    set indeterminate(isIndeterminate) {
        this._indeterminate = isIndeterminate ?? false;
        this.cdr.markForCheck();
    }
    get indeterminate() {
        return this._indeterminate;
    }
    get inputId() {
        return `${this.id || this.uniqueId}--hive-input-checkbox`;
    }
    constructor(cdr, injector, formComponentValidityDirective, checkboxGroup, disabled$, size$, allowRequired$) {
        this.cdr = cdr;
        this.injector = injector;
        this.formComponentValidityDirective = formComponentValidityDirective;
        this.checkboxGroup = checkboxGroup;
        this.disabled$ = disabled$;
        this.size$ = size$;
        this.allowRequired$ = allowRequired$;
        this._size = 'small';
        this._disabled = false;
        this._groupDisabled = false;
        this.destroyRef$ = inject(DestroyRef);
        /**
         * `id` global attribute
         *
         * Gets passed to `<input>` and `<label>` elements
         *
         * @default null
         * @see {@link Element#id}
         */
        this.id = null;
        this.tabIndex = 0;
        /**
         * `true` if checkbox is checked, `false` otherwise
         */
        this.checkedChange = new EventEmitter();
        /**
         * `true` if checkbox is indeterminate, `false` otherwise
         */
        this.indeterminateChange = new EventEmitter();
        this.uniqueId = null;
        this._checked = false;
        this._indeterminate = false;
        this._required = false;
        this.allowRequired = true;
        // region ControlValueAccessor
        this.onModelChange = () => { };
        this.onModelTouch = () => { };
        this.uniqueId = `${++nextUniqueId$3}`;
    }
    // Test content projection
    // Add to other components
    ngOnInit() {
        // Subscribe to disabled$ and size$ if they exist
        subscribeWithCleanup(this.disabled$, (isDisabled) => {
            this._groupDisabled = isDisabled;
        }, this.destroyRef$, this.cdr);
        subscribeWithCleanup(this.size$, (size) => {
            this._size = size;
        }, this.destroyRef$, this.cdr);
        subscribeWithCleanup(this.allowRequired$, (required) => {
            this.allowRequired = required;
        }, this.destroyRef$, this.cdr);
        this.injector
            .get(NgControl, null, {
            optional: true,
        })
            ?.control?.statusChanges.subscribe(() => {
            this.cdr.markForCheck();
        });
    }
    handleClick() {
        if (!this.disabled) {
            if (this.indeterminate) {
                this._indeterminate = false;
                this.indeterminateChange.emit(this.indeterminate);
            }
            this._checked = !this._checked;
            this.onModelChange(this.checked);
            this.checkedChange.emit(this._checked);
            if (this.inputElement) {
                this.inputElement.nativeElement.checked = this.checked;
            }
        }
    }
    /**
     * Prevent `<label>` click event from bubbling.
     * Otherwise, `(click)` event on host would get two events: from HTMLInputElement and from HTMLLabelElement
     *
     * @internal
     * @param event
     */
    handleLabelClick(event) {
        event.stopPropagation();
    }
    /**
     * @internal
     * @param isChecked
     */
    writeValue(isChecked) {
        this.checked = coerceBooleanProperty(isChecked);
    }
    /**
     * @internal
     * @param fn
     */
    registerOnChange(fn) {
        this.onModelChange = fn;
    }
    /**
     * @internal
     * @param fn
     */
    registerOnTouched(fn) {
        this.onModelTouch = fn;
    }
    /**
     * @internal
     */
    setDisabledState(isDisabled) {
        this.disabled = coerceBooleanProperty(isDisabled);
        this.cdr.detectChanges();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CheckboxComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.Injector }, { token: FormComponentValidityDirective }, { token: CheckboxGroupComponent, optional: true }, { token: CHECKBOX_DISABLED_TOKEN, optional: true }, { token: CHECKBOX_SIZE_TOKEN, optional: true }, { token: CHECKBOX_ALLOW_REQUIRED, optional: true }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.3.12", type: CheckboxComponent, isStandalone: true, selector: "hive-checkbox", inputs: { size: "size", disabled: "disabled", id: "id", checked: "checked", required: "required", indeterminate: "indeterminate", tabIndex: "tabIndex" }, outputs: { checkedChange: "checkedChange", indeterminateChange: "indeterminateChange" }, host: { properties: { "attr.checked": "this.checked", "attr.indeterminate": "this.indeterminate" } }, providers: [CHECKBOX_VALUE_ACCESSOR], viewQueries: [{ propertyName: "inputElement", first: true, predicate: ["inputElement"], descendants: true }], hostDirectives: [{ directive: HiveThemedDirective }, { directive: FormComponentValidityDirective }], ngImport: i0, template: "<div\n    class=\"hive-checkbox-component-container\"\n    [ngClass]=\"['hive-checkbox-component-container--' + _size]\"\n>\n    <span class=\"hive-checkbox_container\">\n        <input\n            #inputElement\n            type=\"checkbox\"\n            class=\"hive-checkbox_input\"\n            [class.hive-checkbox_input--invalid]=\"\n                formComponentValidityDirective.webkitInvalid\n            \"\n            [ngClass]=\"['hive-checkbox_input--' + _size]\"\n            [attr.aria-invalid]=\"formComponentValidityDirective.webkitInvalid\"\n            [disabled]=\"disabled\"\n            [id]=\"inputId\"\n            [required]=\"formComponentValidityDirective.required || required\"\n            [checked]=\"checked\"\n            [indeterminate]=\"_indeterminate\"\n            [tabIndex]=\"tabIndex\"\n            (change)=\"$event.stopPropagation()\"\n            (click)=\"handleClick()\"\n            (blur)=\"onModelTouch()\"\n        />\n\n        <div class=\"hive-checkbox_icon-container\">\n            @if (checked) {\n                <svg\n                    class=\"hive-checkbox_icon hive-checkbox_icon-check\"\n                    xmlns=\"http://www.w3.org/2000/svg\"\n                    viewBox=\"0 0 448 512\"\n                >\n                    <path\n                        d=\"M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z\"\n                    />\n                </svg>\n            }\n\n            @if (indeterminate && !checked) {\n                <svg\n                    class=\"hive-checkbox_icon hive-checkbox_icon-minus\"\n                    xmlns=\"http://www.w3.org/2000/svg\"\n                    viewBox=\"0 0 448 512\"\n                >\n                    <path\n                        d=\"M432 256c0 17.7-14.3 32-32 32L48 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l352 0c17.7 0 32 14.3 32 32z\"\n                    />\n                </svg>\n            }\n        </div>\n    </span>\n    <label\n        class=\"hive-checkbox_label\"\n        [class.hive-checkbox_label--disabled]=\"disabled\"\n        [ngClass]=\"['hive-checkbox_label--' + _size]\"\n        [for]=\"inputId\"\n        (click)=\"handleLabelClick($event)\"\n    >\n        <ng-content></ng-content>\n\n        @if (\n            (formComponentValidityDirective.required || required) &&\n                allowRequired;\n            as isRequired\n        ) {\n            <hive-label\n                data-role=\"required-indication\"\n                label=\"\"\n                [required]=\"isRequired\"\n            ></hive-label>\n        }\n    </label>\n</div>\n", dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i2$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "ngmodule", type: FormsModule }, { kind: "ngmodule", type: ReactiveFormsModule }, { kind: "component", type: LabelComponent, selector: "hive-label", inputs: ["label", "for", "size", "weight", "maxWeight", "horizontalAlignment", "leftIconHelpInfoMessage", "rightIconHelpInfoMessage", "leftIcon", "rightIcon", "required", "textOverflowEllipsis"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CheckboxComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hive-checkbox', providers: [CHECKBOX_VALUE_ACCESSOR], changeDetection: ChangeDetectionStrategy.OnPush, standalone: true, hostDirectives: [HiveThemedDirective, FormComponentValidityDirective], imports: [CommonModule, FormsModule, ReactiveFormsModule, LabelComponent], template: "<div\n    class=\"hive-checkbox-component-container\"\n    [ngClass]=\"['hive-checkbox-component-container--' + _size]\"\n>\n    <span class=\"hive-checkbox_container\">\n        <input\n            #inputElement\n            type=\"checkbox\"\n            class=\"hive-checkbox_input\"\n            [class.hive-checkbox_input--invalid]=\"\n                formComponentValidityDirective.webkitInvalid\n            \"\n            [ngClass]=\"['hive-checkbox_input--' + _size]\"\n            [attr.aria-invalid]=\"formComponentValidityDirective.webkitInvalid\"\n            [disabled]=\"disabled\"\n            [id]=\"inputId\"\n            [required]=\"formComponentValidityDirective.required || required\"\n            [checked]=\"checked\"\n            [indeterminate]=\"_indeterminate\"\n            [tabIndex]=\"tabIndex\"\n            (change)=\"$event.stopPropagation()\"\n            (click)=\"handleClick()\"\n            (blur)=\"onModelTouch()\"\n        />\n\n        <div class=\"hive-checkbox_icon-container\">\n            @if (checked) {\n                <svg\n                    class=\"hive-checkbox_icon hive-checkbox_icon-check\"\n                    xmlns=\"http://www.w3.org/2000/svg\"\n                    viewBox=\"0 0 448 512\"\n                >\n                    <path\n                        d=\"M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z\"\n                    />\n                </svg>\n            }\n\n            @if (indeterminate && !checked) {\n                <svg\n                    class=\"hive-checkbox_icon hive-checkbox_icon-minus\"\n                    xmlns=\"http://www.w3.org/2000/svg\"\n                    viewBox=\"0 0 448 512\"\n                >\n                    <path\n                        d=\"M432 256c0 17.7-14.3 32-32 32L48 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l352 0c17.7 0 32 14.3 32 32z\"\n                    />\n                </svg>\n            }\n        </div>\n    </span>\n    <label\n        class=\"hive-checkbox_label\"\n        [class.hive-checkbox_label--disabled]=\"disabled\"\n        [ngClass]=\"['hive-checkbox_label--' + _size]\"\n        [for]=\"inputId\"\n        (click)=\"handleLabelClick($event)\"\n    >\n        <ng-content></ng-content>\n\n        @if (\n            (formComponentValidityDirective.required || required) &&\n                allowRequired;\n            as isRequired\n        ) {\n            <hive-label\n                data-role=\"required-indication\"\n                label=\"\"\n                [required]=\"isRequired\"\n            ></hive-label>\n        }\n    </label>\n</div>\n" }]
        }], ctorParameters: () => [{ type: i0.ChangeDetectorRef }, { type: i0.Injector }, { type: FormComponentValidityDirective }, { type: CheckboxGroupComponent, decorators: [{
                    type: Optional
                }] }, { type: i4.BehaviorSubject, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [CHECKBOX_DISABLED_TOKEN]
                }] }, { type: i4.BehaviorSubject, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [CHECKBOX_SIZE_TOKEN]
                }] }, { type: i4.BehaviorSubject, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [CHECKBOX_ALLOW_REQUIRED]
                }] }], propDecorators: { inputElement: [{
                type: ViewChild,
                args: ['inputElement']
            }], size: [{
                type: Input
            }], disabled: [{
                type: Input
            }], id: [{
                type: Input
            }], checked: [{
                type: HostBinding,
                args: ['attr.checked']
            }, {
                type: Input
            }], required: [{
                type: Input
            }], indeterminate: [{
                type: HostBinding,
                args: ['attr.indeterminate']
            }, {
                type: Input
            }], tabIndex: [{
                type: Input
            }], checkedChange: [{
                type: Output
            }], indeterminateChange: [{
                type: Output
            }] } });

/**
 * @internal
 */
class SelectionMenuBaseItemComponent {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SelectionMenuBaseItemComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.3.12", type: SelectionMenuBaseItemComponent, selector: "hive-selection-menu-base-item", inputs: { selected: "selected", disabled: "disabled", multiselect: "multiselect", indeterminate: "indeterminate", label: "label", testId: "testId", icon: "icon" }, providers: [
            {
                provide: CHECKBOX_ALLOW_REQUIRED,
                useFactory: () => new BehaviorSubject(false),
            },
        ], hostDirectives: [{ directive: HiveThemedDirective }], ngImport: i0, template: `
        <div
            class="hive-selection-menu-base-item_container"
            [tabindex]="disabled ? -1 : 0"
            role="option"
            [attr.aria-checked]="selected"
            [attr.aria-disabled]="disabled"
            [class.hive-selection-menu-base-item_container--active]="selected"
            [class.hive-selection-menu-base-item_container--disabled]="disabled"
        >
            @if (multiselect) {
                <hive-checkbox
                    [tabIndex]="-1"
                    [checked]="selected"
                    [indeterminate]="indeterminate"
                    [disabled]="disabled"
                ></hive-checkbox>
            }

            <hive-label
                class="hive-selection-menu-base-item_label"
                [class.hive-selection-menu-base-item_label--disabled]="disabled"
                size="small"
                [weight]="selected ? 'semibold' : 'regular'"
                [label]="label"
            ></hive-label>

            <div class="hive-selection-menu-base-item_tags">
                <ng-content />
            </div>

            @if (icon) {
                <hive-icon-component [icon]="icon" size="small">
                </hive-icon-component>
            }
        </div>
    `, isInline: true, dependencies: [{ kind: "component", type: CheckboxComponent, selector: "hive-checkbox", inputs: ["size", "disabled", "id", "checked", "required", "indeterminate", "tabIndex"], outputs: ["checkedChange", "indeterminateChange"] }, { kind: "component", type: LabelComponent, selector: "hive-label", inputs: ["label", "for", "size", "weight", "maxWeight", "horizontalAlignment", "leftIconHelpInfoMessage", "rightIconHelpInfoMessage", "leftIcon", "rightIcon", "required", "textOverflowEllipsis"] }, { kind: "component", type: IconComponent, selector: "hive-icon-component", inputs: ["icon", "size"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SelectionMenuBaseItemComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'hive-selection-menu-base-item',
                    template: `
        <div
            class="hive-selection-menu-base-item_container"
            [tabindex]="disabled ? -1 : 0"
            role="option"
            [attr.aria-checked]="selected"
            [attr.aria-disabled]="disabled"
            [class.hive-selection-menu-base-item_container--active]="selected"
            [class.hive-selection-menu-base-item_container--disabled]="disabled"
        >
            @if (multiselect) {
                <hive-checkbox
                    [tabIndex]="-1"
                    [checked]="selected"
                    [indeterminate]="indeterminate"
                    [disabled]="disabled"
                ></hive-checkbox>
            }

            <hive-label
                class="hive-selection-menu-base-item_label"
                [class.hive-selection-menu-base-item_label--disabled]="disabled"
                size="small"
                [weight]="selected ? 'semibold' : 'regular'"
                [label]="label"
            ></hive-label>

            <div class="hive-selection-menu-base-item_tags">
                <ng-content />
            </div>

            @if (icon) {
                <hive-icon-component [icon]="icon" size="small">
                </hive-icon-component>
            }
        </div>
    `,
                    hostDirectives: [HiveThemedDirective],
                    providers: [
                        {
                            provide: CHECKBOX_ALLOW_REQUIRED,
                            useFactory: () => new BehaviorSubject(false),
                        },
                    ],
                }]
        }], propDecorators: { selected: [{
                type: Input
            }], disabled: [{
                type: Input
            }], multiselect: [{
                type: Input
            }], indeterminate: [{
                type: Input
            }], label: [{
                type: Input
            }], testId: [{
                type: Input
            }], icon: [{
                type: Input
            }] } });

/**
 * @internal
 */
class SelectionMenuGroupItemComponent {
    /**
     * Defines whether the items are disabled.
     * Important: This will override the disabled state of the items.
     */
    set disabled(value) {
        this.disabled$.next(booleanAttribute(value));
    }
    get isChecked() {
        return this.isAllItemsSelected() && !this.isEmpty();
    }
    get isIndeterminate() {
        return (this.isAnyNonDisabledItemSelected() && !this.isAllItemsSelected());
    }
    constructor(selectionMenuService, cdr, destroyRef) {
        this.selectionMenuService = selectionMenuService;
        this.cdr = cdr;
        this.destroyRef = destroyRef;
        /**
         * @internal
         */
        this.disabled$ = new BehaviorSubject(false);
        /**
         * @internal
         */
        this.onlyOneEnabledValue$ = new BehaviorSubject(false);
        /**
         * @internal
         */
        this.selectionItems = [];
    }
    ngOnInit() {
        merge(this.selectionMenuService.selectionChanged$, this.selectionMenuService.selectionModel$)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(() => {
            this.cdr.detectChanges();
            this.onlyOneEnabledValue$.next(this.isOnlyOneEnabledValueSelected());
        });
    }
    ngAfterViewInit() {
        this.selectionMenuItems?.changes
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((selectionMenuItems) => {
            this.selectionItems = selectionMenuItems.toArray();
            this.onlyOneEnabledValue$.next(this.isOnlyOneEnabledValueSelected());
            this.cdr.detectChanges();
        });
        this.selectionMenuItems?.notifyOnChanges();
    }
    handleSelect() {
        this.toggleAllItems();
    }
    toggleAllItems() {
        const values = this.getSelectableValues();
        if (this.selectionMenuService.isAllValuesSelected(...values)) {
            this.selectionMenuService.deselectValues(...values, this.value);
        }
        else {
            this.selectionMenuService.selectValues(...values, this.value);
        }
    }
    isAllItemsSelected() {
        return this.selectionMenuService.isAllSelectableItemsSelected(this.getItems());
    }
    isAnyNonDisabledItemSelected() {
        return this.selectionMenuService.isAnySelectableItemSelected(this.getItems());
    }
    isEmpty() {
        return this.getItems().length === 0;
    }
    isOnlyOneEnabledValueSelected() {
        return this.selectionMenuService.isOnlyOneEnabledValueSelected(this.getItems());
    }
    getItems() {
        return this.selectionItems ?? [];
    }
    getSelectableValues() {
        return this.getItems()
            .filter((item) => !item.disabled)
            .map((item) => item.value);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SelectionMenuGroupItemComponent, deps: [{ token: SelectionMenuService }, { token: i0.ChangeDetectorRef }, { token: i0.DestroyRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: SelectionMenuGroupItemComponent, selector: "hive-selection-menu-group-item", inputs: { label: "label", value: "value", disabled: "disabled" }, host: { properties: { "attr.data-checked": "this.isChecked" } }, queries: [{ propertyName: "selectionMenuItems", predicate: i0.forwardRef(() => SelectionMenuItemComponent) }], hostDirectives: [{ directive: HiveThemedDirective }], ngImport: i0, template: "<hive-selection-menu-base-item\n    data-role=\"select-group-item\"\n    [multiselect]=\"true\"\n    [selected]=\"isChecked\"\n    [indeterminate]=\"isIndeterminate\"\n    [disabled]=\"disabled$ | async\"\n    [label]=\"label\"\n    (click)=\"handleSelect()\"\n    (keydown.space)=\"$event.preventDefault(); handleSelect()\"\n>\n</hive-selection-menu-base-item>\n<div class=\"hive-selection-menu-group-items_container\">\n    <ng-content select=\"hive-selection-menu-item\"></ng-content>\n</div>\n", dependencies: [{ kind: "component", type: SelectionMenuBaseItemComponent, selector: "hive-selection-menu-base-item", inputs: ["selected", "disabled", "multiselect", "indeterminate", "label", "testId", "icon"] }, { kind: "pipe", type: i2$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SelectionMenuGroupItemComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hive-selection-menu-group-item', changeDetection: ChangeDetectionStrategy.OnPush, hostDirectives: [HiveThemedDirective], template: "<hive-selection-menu-base-item\n    data-role=\"select-group-item\"\n    [multiselect]=\"true\"\n    [selected]=\"isChecked\"\n    [indeterminate]=\"isIndeterminate\"\n    [disabled]=\"disabled$ | async\"\n    [label]=\"label\"\n    (click)=\"handleSelect()\"\n    (keydown.space)=\"$event.preventDefault(); handleSelect()\"\n>\n</hive-selection-menu-base-item>\n<div class=\"hive-selection-menu-group-items_container\">\n    <ng-content select=\"hive-selection-menu-item\"></ng-content>\n</div>\n" }]
        }], ctorParameters: () => [{ type: SelectionMenuService }, { type: i0.ChangeDetectorRef }, { type: i0.DestroyRef }], propDecorators: { selectionMenuItems: [{
                type: ContentChildren,
                args: [forwardRef(() => SelectionMenuItemComponent)]
            }], label: [{
                type: Input
            }], value: [{
                type: Input
            }], disabled: [{
                type: Input
            }], isChecked: [{
                type: HostBinding,
                args: ['attr.data-checked']
            }] } });

/**
 * A single item of the selection menu.
 *
 * @example disabled item
 * <hive-selection-menu-item
 *     label="Item 1"
 *     [value]="item-1"
 *     [disabled]="true"
 * ></hive-selection-menu-item>
 */
class SelectionMenuItemComponent {
    /**
     * Defines whether the item is disabled.
     */
    set disabled(value) {
        this.itemDisabled$.next(booleanAttribute(value));
    }
    get disabled() {
        return this._disabled;
    }
    /**
     * @internal
     */
    focus() {
        this.elementRef.nativeElement.querySelector('.hive-selection-menu-base-item_container')?.focus();
    }
    /**
     * @internal
     */
    getLabel() {
        return this.label ?? '';
    }
    get isSelected() {
        return this.selectionMenuService.isItemSelected(this);
    }
    constructor(selectionGroupItem, selectionMenuService, cdr, destroyRef, elementRef) {
        this.selectionGroupItem = selectionGroupItem;
        this.selectionMenuService = selectionMenuService;
        this.cdr = cdr;
        this.destroyRef = destroyRef;
        this.elementRef = elementRef;
        this.itemDisabled$ = new BehaviorSubject(false);
        this._onlyOneEnabledValue = false;
        this.disabled$ = combineLatest([
            this.itemDisabled$,
            this.selectionGroupItem?.disabled$ ?? of(false),
        ]).pipe(takeUntilDestroyed(this.destroyRef), map((disabledArray) => {
            return disabledArray.some((value) => value);
        }));
        this._disabled = false;
        this.disabled$
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((disabled) => {
            this._disabled = disabled;
        });
        this.selectionGroupItem?.onlyOneEnabledValue$
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((onlyEnabledValue) => {
            this._onlyOneEnabledValue = onlyEnabledValue;
        });
    }
    ngOnInit() {
        merge(this.selectionMenuService.selectionChanged$, this.selectionMenuService.selectionModel$)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(() => {
            this.cdr.detectChanges();
        });
    }
    handleSelect() {
        if (this._disabled) {
            return;
        }
        // When selecting the item, we want to select selection group item as well
        if (this.selectionGroupItem && !this.isSelected) {
            this.selectionMenuService.selectValues(this.value, this.selectionGroupItem.value);
        }
        else if (this.selectionGroupItem &&
            this._onlyOneEnabledValue &&
            this.isSelected) {
            this.selectionMenuService.deselectValues(this.value, this.selectionGroupItem.value);
        }
        else {
            this.selectionMenuService.toggleSelectionItem(this);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SelectionMenuItemComponent, deps: [{ token: SelectionMenuGroupItemComponent, optional: true }, { token: SelectionMenuService }, { token: i0.ChangeDetectorRef }, { token: i0.DestroyRef }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: SelectionMenuItemComponent, selector: "hive-selection-menu-item", inputs: { label: "label", value: "value", icon: "icon", testId: "testId", disabled: "disabled" }, providers: [
            {
                provide: SELECTION_MENU_CONTENT,
                useExisting: SelectionMenuItemComponent,
            },
        ], hostDirectives: [{ directive: HiveThemedDirective }], ngImport: i0, template: `
        <hive-selection-menu-base-item
            [multiselect]="selectionMenuService.isMultiselect$ | async"
            [selected]="isSelected"
            [disabled]="disabled$ | async"
            [label]="label"
            [icon]="icon"
            [attr.data-testid]="testId"
            (click)="handleSelect()"
            (keydown.space)="$event.preventDefault(); handleSelect()"
        >
            <ng-content select="hive-tag"></ng-content>
        </hive-selection-menu-base-item>
    `, isInline: true, dependencies: [{ kind: "component", type: SelectionMenuBaseItemComponent, selector: "hive-selection-menu-base-item", inputs: ["selected", "disabled", "multiselect", "indeterminate", "label", "testId", "icon"] }, { kind: "pipe", type: i2$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SelectionMenuItemComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'hive-selection-menu-item',
                    template: `
        <hive-selection-menu-base-item
            [multiselect]="selectionMenuService.isMultiselect$ | async"
            [selected]="isSelected"
            [disabled]="disabled$ | async"
            [label]="label"
            [icon]="icon"
            [attr.data-testid]="testId"
            (click)="handleSelect()"
            (keydown.space)="$event.preventDefault(); handleSelect()"
        >
            <ng-content select="hive-tag"></ng-content>
        </hive-selection-menu-base-item>
    `,
                    providers: [
                        {
                            provide: SELECTION_MENU_CONTENT,
                            useExisting: SelectionMenuItemComponent,
                        },
                    ],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    hostDirectives: [HiveThemedDirective],
                }]
        }], ctorParameters: () => [{ type: SelectionMenuGroupItemComponent, decorators: [{
                    type: Optional
                }] }, { type: SelectionMenuService }, { type: i0.ChangeDetectorRef }, { type: i0.DestroyRef }, { type: i0.ElementRef }], propDecorators: { label: [{
                type: Input
            }], value: [{
                type: Input
            }], icon: [{
                type: Input
            }], testId: [{
                type: Input
            }], disabled: [{
                type: Input
            }] } });

/**
 * Checks if the value is a string or string[]. For empty array and string returns false.
 * @param value
 */
function isMultilineTextEmpty(value) {
    if (isUndefined(value) || isNull(value)) {
        return true;
    }
    if (Array.isArray(value)) {
        return value.length === 0;
    }
    return `${value}`.length === 0;
}
class IsMultilineTextEmptyPipe {
    constructor() {
        this.transform = isMultilineTextEmpty;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: IsMultilineTextEmptyPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: IsMultilineTextEmptyPipe, isStandalone: true, name: "isMultilineTextEmpty" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: IsMultilineTextEmptyPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'isMultilineTextEmpty',
                    pure: true,
                    standalone: true,
                }]
        }] });

class FormInputBaseComponent {
    constructor() {
        /**
         * @internal
         * Aligns the content.
         */
        this.horizontalAlignment = 'left';
        /**
         * Some field needs different gap spacing from what's used usually.
         */
        this.increasedContentGap = false;
    }
    /**
     * Returns list of error messages if provided, otherwise empty array.
     */
    get errorsList() {
        const type = typeof this.errorMessages;
        if (type !== 'string' && type !== 'undefined') {
            return this.errorMessages;
        }
        return [];
    }
    /**
     * Returns true if error messages are empty.
     */
    get isErrorMessageEmpty() {
        return isMultilineTextEmpty(this.errorMessages);
    }
    /**
     * Returns true if error messages are string.
     */
    get isSingleError() {
        return isString(this.errorMessages);
    }
    /**
     * Returns true if there is only one error message and the field has error.
     */
    get shouldDisplayErrorMessage() {
        return (!this.isErrorMessageEmpty &&
            this.hasError === true &&
            this.isSingleError);
    }
    /**
     * Returns true if there is more than one error message and the field has error.
     */
    get shouldDisplayErrorMessages() {
        return (!this.isErrorMessageEmpty &&
            this.hasError === true &&
            !this.isSingleError);
    }
    /**
     * Returns true if there is assistance text and there is no error message.
     */
    get shouldDisplayAssistanceText() {
        return (!!this.assistanceText &&
            (!this.hasError || this.isErrorMessageEmpty));
    }
    /**
     * Returns true if there is label or help info message.
     */
    get shouldDisplayLabel() {
        return !!(this.label || this.helpInfoMessage);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FormInputBaseComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.3.12", type: FormInputBaseComponent, isStandalone: true, selector: "hive-form-input-base", inputs: { label: "label", for: "for", required: ["required", "required", booleanAttribute], disabled: ["disabled", "disabled", booleanAttribute], helpInfoIcon: "helpInfoIcon", helpInfoMessage: "helpInfoMessage", errorMessages: "errorMessages", hasError: "hasError", assistanceText: "assistanceText", horizontalAlignment: "horizontalAlignment", increasedContentGap: ["increasedContentGap", "increasedContentGap", booleanAttribute] }, hostDirectives: [{ directive: HiveThemedDirective }], ngImport: i0, template: "<div\n    class=\"hive-form-input-base\"\n    [class.hive-form-input-base--increased-content-gap]=\"increasedContentGap\"\n    [ngClass]=\"['hive-form-input-base--' + horizontalAlignment]\"\n>\n    @if (shouldDisplayLabel) {\n        <hive-label\n            class=\"hive-form-input-label-text\"\n            size=\"small\"\n            weight=\"semibold\"\n            [for]=\"for\"\n            [label]=\"label\"\n            [required]=\"required\"\n            [rightIconHelpInfoMessage]=\"\n                helpInfoMessage && helpInfoIcon ? helpInfoMessage : null\n            \"\n            [rightIcon]=\"\n                helpInfoMessage && helpInfoIcon\n                    ? 'light/circle-' + helpInfoIcon + '.svg'\n                    : null\n            \"\n            [horizontalAlignment]=\"horizontalAlignment\"\n        ></hive-label>\n    }\n\n    <div class=\"hive-form-input-base-input-content\">\n        <ng-content></ng-content>\n\n        @switch (true) {\n            @case (shouldDisplayErrorMessage) {\n                <div class=\"hive-form-input-error-message\">\n                    {{ errorMessages }}\n                </div>\n            }\n            @case (shouldDisplayErrorMessages) {\n                @for (err of errorsList; track err) {\n                    <div class=\"hive-form-input-error-message\">\n                        {{ err }}\n                    </div>\n                }\n            }\n            @case (shouldDisplayAssistanceText) {\n                <div\n                    class=\"hive-form-input-assistance-text\"\n                    [class.hive-form-input-assistance-text--disabled]=\"disabled\"\n                >\n                    {{ assistanceText }}\n                </div>\n            }\n        }\n    </div>\n</div>\n", dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i2$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "ngmodule", type: TooltipModule }, { kind: "component", type: LabelComponent, selector: "hive-label", inputs: ["label", "for", "size", "weight", "maxWeight", "horizontalAlignment", "leftIconHelpInfoMessage", "rightIconHelpInfoMessage", "leftIcon", "rightIcon", "required", "textOverflowEllipsis"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FormInputBaseComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hive-form-input-base', changeDetection: ChangeDetectionStrategy.OnPush, standalone: true, imports: [CommonModule, TooltipModule, SvgDirective, LabelComponent], hostDirectives: [HiveThemedDirective], template: "<div\n    class=\"hive-form-input-base\"\n    [class.hive-form-input-base--increased-content-gap]=\"increasedContentGap\"\n    [ngClass]=\"['hive-form-input-base--' + horizontalAlignment]\"\n>\n    @if (shouldDisplayLabel) {\n        <hive-label\n            class=\"hive-form-input-label-text\"\n            size=\"small\"\n            weight=\"semibold\"\n            [for]=\"for\"\n            [label]=\"label\"\n            [required]=\"required\"\n            [rightIconHelpInfoMessage]=\"\n                helpInfoMessage && helpInfoIcon ? helpInfoMessage : null\n            \"\n            [rightIcon]=\"\n                helpInfoMessage && helpInfoIcon\n                    ? 'light/circle-' + helpInfoIcon + '.svg'\n                    : null\n            \"\n            [horizontalAlignment]=\"horizontalAlignment\"\n        ></hive-label>\n    }\n\n    <div class=\"hive-form-input-base-input-content\">\n        <ng-content></ng-content>\n\n        @switch (true) {\n            @case (shouldDisplayErrorMessage) {\n                <div class=\"hive-form-input-error-message\">\n                    {{ errorMessages }}\n                </div>\n            }\n            @case (shouldDisplayErrorMessages) {\n                @for (err of errorsList; track err) {\n                    <div class=\"hive-form-input-error-message\">\n                        {{ err }}\n                    </div>\n                }\n            }\n            @case (shouldDisplayAssistanceText) {\n                <div\n                    class=\"hive-form-input-assistance-text\"\n                    [class.hive-form-input-assistance-text--disabled]=\"disabled\"\n                >\n                    {{ assistanceText }}\n                </div>\n            }\n        }\n    </div>\n</div>\n" }]
        }], propDecorators: { label: [{
                type: Input
            }], for: [{
                type: Input
            }], required: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], disabled: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], helpInfoIcon: [{
                type: Input
            }], helpInfoMessage: [{
                type: Input
            }], errorMessages: [{
                type: Input
            }], hasError: [{
                type: Input
            }], assistanceText: [{
                type: Input
            }], horizontalAlignment: [{
                type: Input
            }], increasedContentGap: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }] } });

function htmlInputTypeAttribute(value) {
    return value;
}
function helpInfoIconAttribute(value) {
    return oneOfOrDefault(value, undefined, 'info', 'question');
}
function inputTextFieldSizeAttribute(value) {
    return oneOfOrDefault(value, 'medium', 'small', 'medium', 'large', 'x-large');
}
/**
 * A text field is an input field that allows users to enter text or other
 * information, such as numbers or symbols.
 *
 * @example
 * <hive-text-field
 *     label="Test Label"
 *     size="large"
 *     helpInfoMessage="This is an info message!"
 *     helpInfoIcon="info"
 *     placeholder="Start typing"
 *     assistanceText="Some assistance text:
 *     readonly
 *     showClear
 *     disabled
 *     [(ngModel)]="value"
 * ></hive-text-field>
 */
class TextFieldComponent {
    constructor(cdr, injector, destroyRef, formComponentValidityDirective) {
        this.cdr = cdr;
        this.injector = injector;
        this.destroyRef = destroyRef;
        this.formComponentValidityDirective = formComponentValidityDirective;
        /**
         * Use to specify sizing of the component
         */
        this.size = 'medium';
        /**
         * When present, it specifies that the component cannot be edited.
         */
        this.readonly = false;
        /**
         * Use to disable the field
         */
        this.disabled = false;
        /**
         * Set to true to show clear button.
         */
        this.showClear = false;
        /**
         * Set to true to mark the field as required.
         */
        this.required = false;
        /**
         * Native `type` attribute of `<input />`
         *
         * @see HTMLInputElement
         */
        this.type = 'text';
        /**
         * Defines the text field style.
         * If set to `true`, the field will have a filled background.
         * If `false`, it will use an outlined style.
         */
        this.filled = false;
        /**
         * Native `blur` event of `<input type="text" />`
         *
         * @see HTMLInputElement
         */
        this.blur = new EventEmitter();
        /**
         * Native `input` event of `<input type="text" />`
         *
         * @see HTMLInputElement
         */
        this.input = new EventEmitter();
        this.passwordVisible = false;
        this._id = uniqueId('hive-text-field--');
        this._value = '';
        /**
         * @internal
         */
        this.onModelChange = () => { };
        /**
         * @internal
         */
        this.onModelTouch = () => { };
    }
    get value() {
        return this._value;
    }
    set value(val) {
        this._value = val ?? '';
        this.onModelChange(this._value);
        this.onModelTouch();
    }
    get clearIconVisible() {
        if (this.type === 'password') {
            return false;
        }
        return (this.showClear && !!this._value && !this.disabled && !this.readonly);
    }
    get inputType() {
        if (this.type !== 'password') {
            return this.type;
        }
        return this.passwordVisible ? 'text' : 'password';
    }
    ngOnInit() {
        this.injector
            .get(NgControl, null, {
            optional: true,
        })
            ?.control?.statusChanges.pipe(safeTakeUntilDestroyed(this.destroyRef))
            .subscribe(() => {
            this.cdr.markForCheck();
        });
    }
    /**
     * Focuses the input field.
     *
     * @public
     */
    focusInput() {
        this.inputElement.nativeElement.focus();
    }
    /**
     * @internal
     */
    writeValue(value) {
        this._value = value;
        this.cdr.detectChanges();
    }
    /**
     * @internal
     */
    registerOnChange(fn) {
        this.onModelChange = fn;
    }
    /**
     * @internal
     */
    registerOnTouched(fn) {
        this.onModelTouch = fn;
    }
    /**
     * @internal
     */
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
        this.cdr.detectChanges();
    }
    handleClearClick() {
        if (this.disabled || this.readonly) {
            return;
        }
        this.value = '';
    }
    handleBlur(e) {
        this.onModelTouch();
        this.blur.emit(e);
    }
    handleInput(e) {
        if (this.disabled || this.readonly) {
            return;
        }
        this.input.emit(e);
        this.onModelChange(e.target?.value);
    }
    handleChange(e) {
        if (this.disabled || this.readonly) {
            return;
        }
        this.onModelChange(e.target?.value);
    }
    togglePasswordVisibility() {
        this.passwordVisible = !this.passwordVisible;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TextFieldComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.Injector }, { token: i0.DestroyRef }, { token: FormComponentValidityDirective }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.3.12", type: TextFieldComponent, isStandalone: true, selector: "hive-text-field", inputs: { label: ["label", "label", stringOrUndefinedAttribute], size: ["size", "size", inputTextFieldSizeAttribute], helpInfoMessage: "helpInfoMessage", helpInfoIcon: ["helpInfoIcon", "helpInfoIcon", helpInfoIconAttribute], placeholder: ["placeholder", "placeholder", stringOrUndefinedAttribute], readonly: ["readonly", "readonly", booleanAttribute], errorMessages: "errorMessages", assistanceText: ["assistanceText", "assistanceText", stringOrUndefinedAttribute], name: ["name", "name", stringOrUndefinedAttribute], leftIcon: ["leftIcon", "leftIcon", stringOrUndefinedAttribute], disabled: ["disabled", "disabled", booleanAttribute], showClear: ["showClear", "showClear", booleanAttribute], required: ["required", "required", booleanAttribute], min: ["min", "min", numberAttribute], max: ["max", "max", numberAttribute], maxLength: ["maxLength", "maxLength", numberAttribute], step: ["step", "step", numberAttribute], type: ["type", "type", htmlInputTypeAttribute], filled: ["filled", "filled", booleanAttribute], value: ["value", "value", stringAttribute] }, outputs: { blur: "blur", input: "input" }, providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => TextFieldComponent),
                multi: true,
            },
        ], viewQueries: [{ propertyName: "inputElement", first: true, predicate: ["inputElement"], descendants: true }], hostDirectives: [{ directive: HiveThemedDirective }, { directive: FormComponentValidityDirective }], ngImport: i0, template: "<hive-form-input-base\n    [assistanceText]=\"assistanceText\"\n    [disabled]=\"disabled\"\n    [errorMessages]=\"errorMessages\"\n    [for]=\"_id\"\n    [hasError]=\"formComponentValidityDirective.invalid\"\n    [helpInfoIcon]=\"helpInfoIcon\"\n    [helpInfoMessage]=\"helpInfoMessage\"\n    [label]=\"label\"\n    [required]=\"formComponentValidityDirective.required || required\"\n>\n    <div\n        [class.hive-text-field-input-container--disabled]=\"disabled\"\n        [class.hive-text-field-input-container--readonly]=\"readonly\"\n        [class.hive-text-field-input-container--filled]=\"filled\"\n        [class.hive-text-field-input-container--error]=\"\n            formComponentValidityDirective.invalid\n        \"\n        class=\"hive-text-field-input-container\"\n        [ngClass]=\"['hive-text-field-input-container-size--' + size]\"\n    >\n        <div class=\"hive-text-field-input-left-addon\">\n            @if (leftIcon) {\n                <hive-icon-component\n                    class=\"hive-text-field-left-icon\"\n                    [icon]=\"leftIcon\"\n                    size=\"medium\"\n                ></hive-icon-component>\n            }\n            <ng-content\n                select=\"hive-icon-component[slot=left-addon],svg[slot=left-addon],abbr[slot=left-addon]\"\n            />\n        </div>\n        <input\n            #inputElement\n            (blur)=\"handleBlur($event)\"\n            (change)=\"handleChange($event)\"\n            (input)=\"handleInput($event)\"\n            [(ngModel)]=\"_value\"\n            [attr.aria-invalid]=\"formComponentValidityDirective.invalid\"\n            [attr.name]=\"name || null\"\n            [attr.placeholder]=\"placeholder || null\"\n            [disabled]=\"disabled\"\n            [id]=\"_id\"\n            [attr.max]=\"max || null\"\n            [attr.min]=\"min || null\"\n            [readonly]=\"readonly || null\"\n            [attr.step]=\"step || null\"\n            [attr.maxLength]=\"maxLength || null\"\n            [type]=\"inputType\"\n            class=\"hive-text-field-input\"\n        />\n        <div class=\"hive-text-field-input-right-controls\">\n            @if (clearIconVisible) {\n                <button\n                    (click)=\"handleClearClick()\"\n                    class=\"hive-text-field-icon hive-text-field-button\"\n                    data-testid=\"clear-icon-button\"\n                    type=\"button\"\n                >\n                    <hive-icon-component\n                        aria-label=\"Clear text field\"\n                        class=\"hive-text-field-clear-icon\"\n                        icon=\"light/xmark.svg\"\n                        size=\"medium\"\n                    ></hive-icon-component>\n                </button>\n            }\n            @if (formComponentValidityDirective.invalid) {\n                <div\n                    class=\"hive-text-field-icon\"\n                    data-testid=\"error-icon-button\"\n                    type=\"button\"\n                >\n                    <hive-icon-component\n                        [class.hive-text-field-error-icon--clear-icon-visible]=\"\n                            clearIconVisible\n                        \"\n                        class=\"hive-text-field-error-icon\"\n                        icon=\"light/circle-exclamation.svg\"\n                        size=\"medium\"\n                    ></hive-icon-component>\n                </div>\n            }\n            @if (type === 'password') {\n                <button\n                    (click)=\"togglePasswordVisibility()\"\n                    class=\"hive-text-field-icon hive-text-field-button\"\n                    data-testid=\"password-visibility-toggle-button\"\n                    type=\"button\"\n                >\n                    <hive-icon-component\n                        [icon]=\"\n                            passwordVisible\n                                ? 'light/eye.svg'\n                                : 'light/eye-slash.svg'\n                        \"\n                        aria-label=\"Toggle password visibility\"\n                        class=\"hive-text-field-password-icon\"\n                        size=\"medium\"\n                    ></hive-icon-component>\n                </button>\n            }\n        </div>\n        <div class=\"hive-text-field-input-right-addon\">\n            <ng-content\n                select=\"hive-icon-component[slot=right-addon],svg[slot=right-addon],abbr[slot=right-addon]\"\n            />\n        </div>\n    </div>\n</hive-form-input-base>\n", dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i2$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "ngmodule", type: FormsModule }, { kind: "directive", type: i1$3.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1$3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$3.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "ngmodule", type: ReactiveFormsModule }, { kind: "component", type: FormInputBaseComponent, selector: "hive-form-input-base", inputs: ["label", "for", "required", "disabled", "helpInfoIcon", "helpInfoMessage", "errorMessages", "hasError", "assistanceText", "horizontalAlignment", "increasedContentGap"] }, { kind: "component", type: IconComponent, selector: "hive-icon-component", inputs: ["icon", "size"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TextFieldComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hive-text-field', standalone: true, imports: [
                        CommonModule,
                        FormsModule,
                        ReactiveFormsModule,
                        FormInputBaseComponent,
                        IconComponent,
                    ], changeDetection: ChangeDetectionStrategy.OnPush, hostDirectives: [HiveThemedDirective, FormComponentValidityDirective], providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => TextFieldComponent),
                            multi: true,
                        },
                    ], template: "<hive-form-input-base\n    [assistanceText]=\"assistanceText\"\n    [disabled]=\"disabled\"\n    [errorMessages]=\"errorMessages\"\n    [for]=\"_id\"\n    [hasError]=\"formComponentValidityDirective.invalid\"\n    [helpInfoIcon]=\"helpInfoIcon\"\n    [helpInfoMessage]=\"helpInfoMessage\"\n    [label]=\"label\"\n    [required]=\"formComponentValidityDirective.required || required\"\n>\n    <div\n        [class.hive-text-field-input-container--disabled]=\"disabled\"\n        [class.hive-text-field-input-container--readonly]=\"readonly\"\n        [class.hive-text-field-input-container--filled]=\"filled\"\n        [class.hive-text-field-input-container--error]=\"\n            formComponentValidityDirective.invalid\n        \"\n        class=\"hive-text-field-input-container\"\n        [ngClass]=\"['hive-text-field-input-container-size--' + size]\"\n    >\n        <div class=\"hive-text-field-input-left-addon\">\n            @if (leftIcon) {\n                <hive-icon-component\n                    class=\"hive-text-field-left-icon\"\n                    [icon]=\"leftIcon\"\n                    size=\"medium\"\n                ></hive-icon-component>\n            }\n            <ng-content\n                select=\"hive-icon-component[slot=left-addon],svg[slot=left-addon],abbr[slot=left-addon]\"\n            />\n        </div>\n        <input\n            #inputElement\n            (blur)=\"handleBlur($event)\"\n            (change)=\"handleChange($event)\"\n            (input)=\"handleInput($event)\"\n            [(ngModel)]=\"_value\"\n            [attr.aria-invalid]=\"formComponentValidityDirective.invalid\"\n            [attr.name]=\"name || null\"\n            [attr.placeholder]=\"placeholder || null\"\n            [disabled]=\"disabled\"\n            [id]=\"_id\"\n            [attr.max]=\"max || null\"\n            [attr.min]=\"min || null\"\n            [readonly]=\"readonly || null\"\n            [attr.step]=\"step || null\"\n            [attr.maxLength]=\"maxLength || null\"\n            [type]=\"inputType\"\n            class=\"hive-text-field-input\"\n        />\n        <div class=\"hive-text-field-input-right-controls\">\n            @if (clearIconVisible) {\n                <button\n                    (click)=\"handleClearClick()\"\n                    class=\"hive-text-field-icon hive-text-field-button\"\n                    data-testid=\"clear-icon-button\"\n                    type=\"button\"\n                >\n                    <hive-icon-component\n                        aria-label=\"Clear text field\"\n                        class=\"hive-text-field-clear-icon\"\n                        icon=\"light/xmark.svg\"\n                        size=\"medium\"\n                    ></hive-icon-component>\n                </button>\n            }\n            @if (formComponentValidityDirective.invalid) {\n                <div\n                    class=\"hive-text-field-icon\"\n                    data-testid=\"error-icon-button\"\n                    type=\"button\"\n                >\n                    <hive-icon-component\n                        [class.hive-text-field-error-icon--clear-icon-visible]=\"\n                            clearIconVisible\n                        \"\n                        class=\"hive-text-field-error-icon\"\n                        icon=\"light/circle-exclamation.svg\"\n                        size=\"medium\"\n                    ></hive-icon-component>\n                </div>\n            }\n            @if (type === 'password') {\n                <button\n                    (click)=\"togglePasswordVisibility()\"\n                    class=\"hive-text-field-icon hive-text-field-button\"\n                    data-testid=\"password-visibility-toggle-button\"\n                    type=\"button\"\n                >\n                    <hive-icon-component\n                        [icon]=\"\n                            passwordVisible\n                                ? 'light/eye.svg'\n                                : 'light/eye-slash.svg'\n                        \"\n                        aria-label=\"Toggle password visibility\"\n                        class=\"hive-text-field-password-icon\"\n                        size=\"medium\"\n                    ></hive-icon-component>\n                </button>\n            }\n        </div>\n        <div class=\"hive-text-field-input-right-addon\">\n            <ng-content\n                select=\"hive-icon-component[slot=right-addon],svg[slot=right-addon],abbr[slot=right-addon]\"\n            />\n        </div>\n    </div>\n</hive-form-input-base>\n" }]
        }], ctorParameters: () => [{ type: i0.ChangeDetectorRef }, { type: i0.Injector }, { type: i0.DestroyRef }, { type: FormComponentValidityDirective }], propDecorators: { inputElement: [{
                type: ViewChild,
                args: ['inputElement']
            }], label: [{
                type: Input,
                args: [{ transform: stringOrUndefinedAttribute }]
            }], size: [{
                type: Input,
                args: [{ transform: inputTextFieldSizeAttribute }]
            }], helpInfoMessage: [{
                type: Input
            }], helpInfoIcon: [{
                type: Input,
                args: [{ transform: helpInfoIconAttribute }]
            }], placeholder: [{
                type: Input,
                args: [{ transform: stringOrUndefinedAttribute }]
            }], readonly: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], errorMessages: [{
                type: Input
            }], assistanceText: [{
                type: Input,
                args: [{ transform: stringOrUndefinedAttribute }]
            }], name: [{
                type: Input,
                args: [{ transform: stringOrUndefinedAttribute }]
            }], leftIcon: [{
                type: Input,
                args: [{ transform: stringOrUndefinedAttribute }]
            }], disabled: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], showClear: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], required: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], min: [{
                type: Input,
                args: [{ transform: numberAttribute }]
            }], max: [{
                type: Input,
                args: [{ transform: numberAttribute }]
            }], maxLength: [{
                type: Input,
                args: [{ transform: numberAttribute }]
            }], step: [{
                type: Input,
                args: [{ transform: numberAttribute }]
            }], type: [{
                type: Input,
                args: [{ transform: htmlInputTypeAttribute }]
            }], filled: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], blur: [{
                type: Output
            }], input: [{
                type: Output
            }], value: [{
                type: Input,
                args: [{ transform: stringAttribute }]
            }] } });

function transformOrientation(value) {
    return oneOfOrDefault(value, 'horizontal', 'horizontal', 'vertical');
}
/**
 * The Separator component is a fundamental element in user interface design that helps visually separate or organize content within a layout.
 */
class SeparatorComponent {
    constructor() {
        /**
         * The orientation of the separator.
         * @default 'horizontal'
         */
        this.orientation = 'horizontal';
        this.cssClass = true;
    }
    get isHorizontal() {
        return this.orientation !== 'vertical';
    }
    get isVertical() {
        return this.orientation === 'vertical';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SeparatorComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "16.1.0", version: "17.3.12", type: SeparatorComponent, isStandalone: true, selector: "hive-separator", inputs: { orientation: ["orientation", "orientation", transformOrientation] }, host: { properties: { "class.hive-separator": "this.cssClass", "class.hive-separator--horizontal": "this.isHorizontal", "class.hive-separator--vertical": "this.isVertical" } }, hostDirectives: [{ directive: HiveThemedDirective }, { directive: InvertedColorsDirective, inputs: ["hiveInvertedColors", "inverted"] }], ngImport: i0, template: '', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SeparatorComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'hive-separator',
                    template: '',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    standalone: true,
                    hostDirectives: [
                        HiveThemedDirective,
                        {
                            directive: InvertedColorsDirective,
                            inputs: ['hiveInvertedColors: inverted'],
                        },
                    ],
                }]
        }], propDecorators: { orientation: [{
                type: Input,
                args: [{ transform: transformOrientation }]
            }], cssClass: [{
                type: HostBinding,
                args: ['class.hive-separator']
            }], isHorizontal: [{
                type: HostBinding,
                args: ['class.hive-separator--horizontal']
            }], isVertical: [{
                type: HostBinding,
                args: ['class.hive-separator--vertical']
            }] } });

const defaultDebounceWait = 300;
function debounceWaitAttribute(value) {
    return [value, defaultDebounceWait].find(isDefined);
}
class DebounceChangeDirective {
    constructor(control) {
        this.control = control;
        this.debounceWait = defaultDebounceWait;
        this.debounceChange = new EventEmitter();
        this.destroy$ = new Subject();
    }
    ngOnInit() {
        this.control.update
            .pipe(takeUntil(this.destroy$), debounce(() => timer(this.debounceWait)))
            .subscribe((event) => this.debounceChange.emit(event));
    }
    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DebounceChangeDirective, deps: [{ token: i1$3.NgModel }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "16.1.0", version: "17.3.12", type: DebounceChangeDirective, isStandalone: true, selector: "[debounceChange][ngModel]", inputs: { debounceWait: ["debounceWait", "debounceWait", debounceWaitAttribute] }, outputs: { debounceChange: "debounceChange" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DebounceChangeDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[debounceChange][ngModel]',
                    standalone: true,
                }]
        }], ctorParameters: () => [{ type: i1$3.NgModel }], propDecorators: { debounceWait: [{
                type: Input,
                args: [{ transform: debounceWaitAttribute }]
            }], debounceChange: [{
                type: Output
            }] } });

class ToArrayPipe {
    transform(value) {
        if (Array.isArray(value)) {
            return value;
        }
        return isDefined(value) ? [value] : [];
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ToArrayPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: ToArrayPipe, isStandalone: true, name: "toArray" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ToArrayPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'toArray',
                    standalone: true,
                    pure: true,
                }]
        }] });

/**
 * An empty state in user interfaces (UI) refers to the visual representation of an interface when there is no data, content or activity to display.
 **/
class EmptyStateComponent {
    constructor() {
        /**
         * The size of the icon.
         */
        this.size = 'large';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EmptyStateComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: EmptyStateComponent, isStandalone: true, selector: "hive-empty-state", inputs: { heading: "heading", description: "description", icon: "icon", size: "size" }, hostDirectives: [{ directive: HiveThemedDirective }], ngImport: i0, template: "<div class=\"hive-empty-state_container\">\n    <div class=\"hive-empty-state_icon-container\" *ngIf=\"size === 'large'\">\n        <span #iconTemplate>\n            <ng-content select=\"svg, i\"></ng-content>\n        </span>\n\n        <hive-icon-component\n            *ngIf=\"!iconTemplate.hasChildNodes() && icon\"\n            [icon]=\"icon\"\n            [size]=\"size\"\n        ></hive-icon-component>\n    </div>\n\n    <div\n        class=\"hive-empty-state_content-container\"\n        [ngClass]=\"'hive-empty-state_content-container--size-' + size\"\n    >\n        <div\n            class=\"hive-empty-state_text-container\"\n            [ngClass]=\"'hive-empty-state_text-container--size-' + size\"\n        >\n            <div\n                class=\"hive-empty-state_status-container\"\n                [ngClass]=\"'hive-empty-state_status-container--size-' + size\"\n            >\n                <ng-container #headingTemplate>\n                    <span *ngIf=\"size === 'large'\">\n                        <ng-content select=\"h6\"></ng-content>\n                    </span>\n                </ng-container>\n\n                <hive-label\n                    *ngIf=\"heading && size === 'small'\"\n                    size=\"smallest\"\n                    weight=\"semibold\"\n                    [label]=\"heading\"\n                ></hive-label>\n\n                <hive-label\n                    *ngIf=\"\n                        !headingTemplate?.firstChild?.hasChildNodes() &&\n                        heading &&\n                        size === 'large'\n                    \"\n                    size=\"large\"\n                    weight=\"semibold\"\n                    [label]=\"heading\"\n                ></hive-label>\n            </div>\n\n            <div\n                class=\"hive-empty-state_description-container\"\n                [ngClass]=\"\n                    'hive-empty-state_description-container--size-' + size\n                \"\n            >\n                <span class=\"hive-empty-state_description\" #descriptionTemplate>\n                    <ng-content select=\"p\"></ng-content>\n                </span>\n\n                <ng-container\n                    *ngIf=\"!descriptionTemplate.hasChildNodes() && description\"\n                >\n                    <ng-container\n                        *ngFor=\"\n                            let line of description | toArray;\n                            last as isLast\n                        \"\n                    >\n                        <p\n                            class=\"hive-empty-state_description hive-paragraph-regular\"\n                            [class.hive-paragraph-smallest]=\"size === 'small'\"\n                            [class.hive-paragraph-small]=\"size === 'large'\"\n                        >\n                            {{ line }}\n                        </p>\n\n                        <br *ngIf=\"!isLast\" />\n                    </ng-container>\n                </ng-container>\n            </div>\n        </div>\n\n        <div\n            class=\"hive-empty-state_controls\"\n            [ngClass]=\"'hive-empty-state_controls--size-' + size\"\n        >\n            <ng-content select=\"hive-button, a[hive-link]\"></ng-content>\n        </div>\n    </div>\n</div>\n", dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i2$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: IconComponent, selector: "hive-icon-component", inputs: ["icon", "size"] }, { kind: "component", type: LabelComponent, selector: "hive-label", inputs: ["label", "for", "size", "weight", "maxWeight", "horizontalAlignment", "leftIconHelpInfoMessage", "rightIconHelpInfoMessage", "leftIcon", "rightIcon", "required", "textOverflowEllipsis"] }, { kind: "pipe", type: ToArrayPipe, name: "toArray" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EmptyStateComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hive-empty-state', imports: [CommonModule, IconComponent, LabelComponent, ToArrayPipe], standalone: true, changeDetection: ChangeDetectionStrategy.OnPush, hostDirectives: [HiveThemedDirective], template: "<div class=\"hive-empty-state_container\">\n    <div class=\"hive-empty-state_icon-container\" *ngIf=\"size === 'large'\">\n        <span #iconTemplate>\n            <ng-content select=\"svg, i\"></ng-content>\n        </span>\n\n        <hive-icon-component\n            *ngIf=\"!iconTemplate.hasChildNodes() && icon\"\n            [icon]=\"icon\"\n            [size]=\"size\"\n        ></hive-icon-component>\n    </div>\n\n    <div\n        class=\"hive-empty-state_content-container\"\n        [ngClass]=\"'hive-empty-state_content-container--size-' + size\"\n    >\n        <div\n            class=\"hive-empty-state_text-container\"\n            [ngClass]=\"'hive-empty-state_text-container--size-' + size\"\n        >\n            <div\n                class=\"hive-empty-state_status-container\"\n                [ngClass]=\"'hive-empty-state_status-container--size-' + size\"\n            >\n                <ng-container #headingTemplate>\n                    <span *ngIf=\"size === 'large'\">\n                        <ng-content select=\"h6\"></ng-content>\n                    </span>\n                </ng-container>\n\n                <hive-label\n                    *ngIf=\"heading && size === 'small'\"\n                    size=\"smallest\"\n                    weight=\"semibold\"\n                    [label]=\"heading\"\n                ></hive-label>\n\n                <hive-label\n                    *ngIf=\"\n                        !headingTemplate?.firstChild?.hasChildNodes() &&\n                        heading &&\n                        size === 'large'\n                    \"\n                    size=\"large\"\n                    weight=\"semibold\"\n                    [label]=\"heading\"\n                ></hive-label>\n            </div>\n\n            <div\n                class=\"hive-empty-state_description-container\"\n                [ngClass]=\"\n                    'hive-empty-state_description-container--size-' + size\n                \"\n            >\n                <span class=\"hive-empty-state_description\" #descriptionTemplate>\n                    <ng-content select=\"p\"></ng-content>\n                </span>\n\n                <ng-container\n                    *ngIf=\"!descriptionTemplate.hasChildNodes() && description\"\n                >\n                    <ng-container\n                        *ngFor=\"\n                            let line of description | toArray;\n                            last as isLast\n                        \"\n                    >\n                        <p\n                            class=\"hive-empty-state_description hive-paragraph-regular\"\n                            [class.hive-paragraph-smallest]=\"size === 'small'\"\n                            [class.hive-paragraph-small]=\"size === 'large'\"\n                        >\n                            {{ line }}\n                        </p>\n\n                        <br *ngIf=\"!isLast\" />\n                    </ng-container>\n                </ng-container>\n            </div>\n        </div>\n\n        <div\n            class=\"hive-empty-state_controls\"\n            [ngClass]=\"'hive-empty-state_controls--size-' + size\"\n        >\n            <ng-content select=\"hive-button, a[hive-link]\"></ng-content>\n        </div>\n    </div>\n</div>\n" }]
        }], propDecorators: { heading: [{
                type: Input
            }], description: [{
                type: Input
            }], icon: [{
                type: Input
            }], size: [{
                type: Input
            }] } });

class SelectionMenuIsScrolledDirective {
    constructor() {
        this.isScrolled = new EventEmitter();
    }
    onScroll(event) {
        const element = event.target;
        this.isScrolled.emit(element.scrollTop > 0);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SelectionMenuIsScrolledDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: SelectionMenuIsScrolledDirective, selector: "[hiveSelectionMenuIsScrolled]", outputs: { isScrolled: "isScrolled" }, host: { listeners: { "scroll": "onScroll($event)" } }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SelectionMenuIsScrolledDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[hiveSelectionMenuIsScrolled]',
                }]
        }], propDecorators: { isScrolled: [{
                type: Output
            }], onScroll: [{
                type: HostListener,
                args: ['scroll', ['$event']]
            }] } });

/**
 * Selection Menu component allows users to make choices from the presented options,
 * which can be either single or multiple selections.
 *
 * @example
 * <hive-selection-menu>
 *      <hive-selection-menu-item
 *          *ngFor="let item of items"
 *          [label]="item.label"
 *      ></hive-selection-menu-item>
 * </hive-selection-menu>
 *
 * @example Loading state
 * <hive-selection-menu [isLoading]="true>
 *      <hive-selection-menu-item
 *          *ngFor="let item of items"
 *          [label]="item.label"
 *      ></hive-selection-menu-item>
 * </hive-selection-menu>
 *
 * @example Empty state
 * <!-- when no items passed, the selection menu will display an empty state -->
 * <hive-selection-menu></hive-selection-menu>
 *
 * @example filter
 * <!-- html -->
 * <hive-selection-menu
 *    [hasFilter]="true"
 *    (filterChange)="handleFilterChange($event)"
 *    [debounceWait]="300"
 * >
 *     <hive-selection-menu-item
 *         *ngFor="let item of items"
 *         [label]="item.label"
 *         [value]="item.value"
 *         [disabled]="item.disabled"
 *     ></hive-selection-menu-item>
 * </hive-selection-menu>
 *
 * @example filter
 * <!-- ts -->
 * const handleFilterChange = (filter: string) => {
 *     this.items = this.items.filter((item) =>
 *         SelectionMenuFilters.fullText(item.label, filter);
 * }
 */
class SelectionMenuComponent {
    constructor(selectionMenuService, cdr) {
        this.selectionMenuService = selectionMenuService;
        this.cdr = cdr;
        /**
         * Even though `SelectionMenuComponent` uses content-projection as a way to render items, there is a tricky part.
         * - When `SelectionMenuItems` are passed directly into the `SelectionMenuComponent`, i.e, there is no wrapping component (like `dropdown`), this `@Input` is not needed.
         * - When `SelectionMenuItems` are passed through a wrapping component, this `@Input` is needed to pass the items to the `SelectionMenuComponent`.
         *   This is because the way Angular works, `@ContentChildren(SelectionMenuItemComponent<T>)` does not get the items when they are passed through a wrapping component.
         *
         * This field is needed to pass it as an argument to the `SelectionMenuService` methods through the template.
         *
         * @internal
         */
        this.selectionItems = [];
        this.selectionContent = [];
        /**
         * Defines whether the selection menu has a filter input.
         */
        this.hasFilter = false;
        /**
         * Defines whether the selection menu has multiselect functionality
         * such as checkboxes
         */
        this.multiselect = false;
        /**
         * Defines whether the selection menu has a loading error.
         */
        this.hasLoadingError = false;
        /**
         * Defines whether the selection menu is in a loading state.
         */
        this.isLoading = false;
        /**
         * Defines debounce wait time for the filter input.
         *
         * If `null`, default value is used.
         *
         * @default 300
         *
         * @see DebounceChangeDirective.debounceWait
         */
        this.debounceWait = null;
        /**
         * When you want to hide the separators header and footer.
         */
        this.hideSeparators = false;
        /**
         * Emits when the selection changes.
         *
         * Always emits an array of `T`.
         *
         * - If `isMultiselect` is `false`, the array will contain only one item.
         * - If `isMultiselect` is `true`, the array will contain all selected items.
         */
        this.selectionChange = this.selectionMenuService.selectionChanged$;
        /**
         * Emits when the user clicks the 'Try Again' message which is displayed
         * when the selection menu is in an error state.
         */
        this.tryAgainClick = new EventEmitter();
        /**
         * Emits when the user types in the filter input. With debouncing.
         */
        this.filterChange = new EventEmitter();
        this.selectionMenuContent = new QueryList();
        this.selectionMenuGroupItems = new QueryList();
        this.headerSeparatorVisible$ = new BehaviorSubject(false);
        this._selectionMenuGroupItems = [];
        this.destroyRef = inject(DestroyRef);
    }
    /**
     * The selected items.
     */
    set selection(value) {
        this.selectionMenuService.selection$.next(value ?? []);
    }
    get selectionMenuEmpty() {
        return this.selectionContent?.length === 0;
    }
    ngOnInit() {
        merge(this.selectionMenuService.selectionChanged$, this.selectionMenuService.selectionModel$)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(() => {
            this.cdr.detectChanges();
        });
    }
    ngAfterViewInit() {
        this.selectionMenuItems?.changes
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((selectionMenuItems) => {
            this.selectionItems = selectionMenuItems.toArray();
            this.updateFocusKeyManager();
            this.cdr.detectChanges();
        });
        this.selectionMenuContent?.changes
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((selectionMenuContent) => {
            this.selectionContent = selectionMenuContent.toArray();
            this.cdr.detectChanges();
        });
        this.selectionMenuGroupItems.changes
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((selectionMenuGroupItems) => {
            this._selectionMenuGroupItems =
                selectionMenuGroupItems.toArray();
            this.cdr.detectChanges();
        });
        this.selectionMenuGroupItems.notifyOnChanges();
        this.selectionMenuItems?.notifyOnChanges();
        this.selectionMenuContent?.notifyOnChanges();
        this.updateFocusKeyManager();
    }
    /**
     * @internal
     */
    initFocusKeyManager() {
        this.focusKeyManager?.setFirstItemActive();
    }
    /**
     * Focuses the filter input field.
     *
     * @public
     */
    focusFilter() {
        this.filterField?.focusInput();
    }
    updateFocusKeyManager() {
        if (this.selectionItems?.length === 0) {
            this.focusKeyManager = new FocusKeyManager(this.selectionMenuItems).withWrap();
        }
        else {
            this.focusKeyManager = new FocusKeyManager(this.selectionItems).withWrap();
        }
    }
    ngOnChanges(changes) {
        if ('multiselect' in changes) {
            this.selectionMenuService.isMultiselect$.next(this.multiselect);
        }
        if ('selectionItems' in changes) {
            this.updateFocusKeyManager();
        }
    }
    handleCheckedChange() {
        const groupValues = this._selectionMenuGroupItems
            .filter((gi) => !gi.disabled)
            .map((item) => item.value);
        const values = this.selectionItems
            ?.filter((i) => !i.disabled)
            .map((item) => item.value) ?? [];
        this.selectionMenuService.toggleAllValues(...groupValues, ...values);
    }
    onKeydown(event) {
        this.focusKeyManager?.onKeydown(event);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SelectionMenuComponent, deps: [{ token: SelectionMenuService }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.3.12", type: SelectionMenuComponent, selector: "hive-selection-menu", inputs: { selectionItems: "selectionItems", selectionContent: "selectionContent", hasFilter: ["hasFilter", "hasFilter", booleanAttribute], multiselect: ["multiselect", "multiselect", booleanAttribute], hasLoadingError: ["hasLoadingError", "hasLoadingError", booleanAttribute], isLoading: ["isLoading", "isLoading", booleanAttribute], debounceWait: ["debounceWait", "debounceWait", numberAttribute], hideSeparators: ["hideSeparators", "hideSeparators", booleanAttribute], selection: "selection" }, outputs: { selectionChange: "selectionChange", tryAgainClick: "tryAgainClick", filterChange: "filterChange" }, host: { listeners: { "keydown": "onKeydown($event)" } }, providers: [
            SELECTION_MENU_PROVIDER,
            {
                provide: CHECKBOX_ALLOW_REQUIRED,
                useFactory: () => new BehaviorSubject(false),
            },
        ], queries: [{ propertyName: "selectionMenuItems", predicate: (SelectionMenuItemComponent), descendants: true }, { propertyName: "selectionMenuContent", predicate: SELECTION_MENU_CONTENT, descendants: true }, { propertyName: "selectionMenuGroupItems", predicate: (SelectionMenuGroupItemComponent), descendants: true }], viewQueries: [{ propertyName: "filterField", first: true, predicate: ["filterField"], descendants: true }, { propertyName: "selectionList", predicate: ["selectionMenu"], descendants: true }], usesOnChanges: true, hostDirectives: [{ directive: HiveThemedDirective }], ngImport: i0, template: "<div\n    class=\"hive-selection-menu_content\"\n    role=\"list\"\n    data-testid=\"hive-selection-menu\"\n    hiveSelectionMenuIsScrolled\n    (isScrolled)=\"headerSeparatorVisible$.next($event)\"\n>\n    @if (isLoading) {\n        <div\n            class=\"hive-selection-menu_loading-container hive-selection-menu_state-container\"\n        >\n            <hive-loading-spinner\n                label=\"Loading\"\n                size=\"small\"\n            ></hive-loading-spinner>\n        </div>\n    } @else {\n        @if (hasLoadingError) {\n            <div\n                class=\"hive-selection-menu_error-container hive-selection-menu_state-container\"\n            >\n                <hive-empty-state\n                    description=\"Unable to load data\"\n                    size=\"small\"\n                >\n                    <a (click)=\"tryAgainClick.emit()\" hive-link size=\"smallest\">\n                        Try again\n                    </a>\n                </hive-empty-state>\n            </div>\n        } @else {\n            <div class=\"hive-selection-menu_container\">\n                <div class=\"hive-selection-menu_header\">\n                    <div class=\"hive-selection-menu_header-container\">\n                        <ng-content\n                            select=\"[slot=selection-menu-header]\"\n                        ></ng-content>\n                    </div>\n                    <hive-separator />\n                    <div class=\"hive-selection-menu_header-container\">\n                        @if (multiselect) {\n                            <div\n                                class=\"hive-selection-menu_header-checkbox-wrapper\"\n                            >\n                                <hive-checkbox\n                                    (checkedChange)=\"handleCheckedChange()\"\n                                    [checked]=\"\n                                        selectionMenuService.isAllSelectableItemsSelected(\n                                            selectionItems ?? []\n                                        ) &&\n                                        !selectionMenuService.isOnlyDisabledItems(\n                                            selectionItems ?? []\n                                        )\n                                    \"\n                                    [disabled]=\"\n                                        selectionMenuService.isOnlyDisabledItems(\n                                            selectionItems ?? []\n                                        ) ||\n                                        !selectionItems ||\n                                        selectionItems.length === 0\n                                    \"\n                                    [indeterminate]=\"\n                                        selectionMenuService.isAnySelectableItemSelected(\n                                            selectionItems ?? []\n                                        ) &&\n                                        !selectionMenuService.isAllSelectableItemsSelected(\n                                            selectionItems ?? []\n                                        )\n                                    \"\n                                ></hive-checkbox>\n                            </div>\n                        }\n                        @if (hasFilter) {\n                            <div\n                                class=\"hive-selection-menu_header-filter-wrapper\"\n                            >\n                                <hive-text-field\n                                    #filterField\n                                    (debounceChange)=\"filterChange.emit($event)\"\n                                    [debounceWait]=\"debounceWait\"\n                                    [showClear]=\"true\"\n                                    data-testid=\"hive-selection-menu-filter\"\n                                    ngModel\n                                    placeholder=\"Search...\"\n                                    size=\"small\"\n                                ></hive-text-field>\n                            </div>\n                        }\n                    </div>\n                    <hive-separator\n                        [class.hive-selection-menu_footer-separator_hidden]=\"\n                            !(headerSeparatorVisible$ | async)\n                        \"\n                    />\n                </div>\n                <div #selectionMenu class=\"hive-selection-menu_list\">\n                    @if (!selectionMenuEmpty) {\n                        <div class=\"hive-selection-menu_items\">\n                            <ng-content\n                                select=\"\n                            hive-selection-menu-item,\n                            hive-selection-menu-section,\n                            hive-selection-menu-group-item,\n                            ng-container\n                        \"\n                            ></ng-content>\n                        </div>\n                    }\n                    @if (selectionMenuEmpty) {\n                        <div\n                            class=\"hive-selection-menu_empty-container hive-selection-menu_state-container\"\n                        >\n                            <hive-empty-state\n                                description=\"No results found\"\n                                size=\"small\"\n                            ></hive-empty-state>\n                        </div>\n                    }\n                </div>\n                <div class=\"hive-selection-menu_footer\">\n                    @if (!hideSeparators) {\n                        <hive-separator />\n                    }\n                    <div class=\"hive-selection-menu_footer-container\">\n                        <ng-content\n                            select=\"[slot=selection-menu-footer]\"\n                        ></ng-content>\n                    </div>\n                </div>\n            </div>\n        }\n    }\n</div>\n", dependencies: [{ kind: "directive", type: i1$3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$3.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: CheckboxComponent, selector: "hive-checkbox", inputs: ["size", "disabled", "id", "checked", "required", "indeterminate", "tabIndex"], outputs: ["checkedChange", "indeterminateChange"] }, { kind: "component", type: TextFieldComponent, selector: "hive-text-field", inputs: ["label", "size", "helpInfoMessage", "helpInfoIcon", "placeholder", "readonly", "errorMessages", "assistanceText", "name", "leftIcon", "disabled", "showClear", "required", "min", "max", "maxLength", "step", "type", "filled", "value"], outputs: ["blur", "input"] }, { kind: "component", type: SeparatorComponent, selector: "hive-separator", inputs: ["orientation"] }, { kind: "component", type: LoadingSpinnerComponent, selector: "hive-loading-spinner", inputs: ["displayMode", "orientation", "label", "size"] }, { kind: "component", type: LinkComponent, selector: "a[hive-link]", inputs: ["disabled", "size", "external"] }, { kind: "directive", type: DebounceChangeDirective, selector: "[debounceChange][ngModel]", inputs: ["debounceWait"], outputs: ["debounceChange"] }, { kind: "component", type: EmptyStateComponent, selector: "hive-empty-state", inputs: ["heading", "description", "icon", "size"] }, { kind: "directive", type: SelectionMenuIsScrolledDirective, selector: "[hiveSelectionMenuIsScrolled]", outputs: ["isScrolled"] }, { kind: "pipe", type: i2$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SelectionMenuComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hive-selection-menu', hostDirectives: [HiveThemedDirective], changeDetection: ChangeDetectionStrategy.OnPush, providers: [
                        SELECTION_MENU_PROVIDER,
                        {
                            provide: CHECKBOX_ALLOW_REQUIRED,
                            useFactory: () => new BehaviorSubject(false),
                        },
                    ], template: "<div\n    class=\"hive-selection-menu_content\"\n    role=\"list\"\n    data-testid=\"hive-selection-menu\"\n    hiveSelectionMenuIsScrolled\n    (isScrolled)=\"headerSeparatorVisible$.next($event)\"\n>\n    @if (isLoading) {\n        <div\n            class=\"hive-selection-menu_loading-container hive-selection-menu_state-container\"\n        >\n            <hive-loading-spinner\n                label=\"Loading\"\n                size=\"small\"\n            ></hive-loading-spinner>\n        </div>\n    } @else {\n        @if (hasLoadingError) {\n            <div\n                class=\"hive-selection-menu_error-container hive-selection-menu_state-container\"\n            >\n                <hive-empty-state\n                    description=\"Unable to load data\"\n                    size=\"small\"\n                >\n                    <a (click)=\"tryAgainClick.emit()\" hive-link size=\"smallest\">\n                        Try again\n                    </a>\n                </hive-empty-state>\n            </div>\n        } @else {\n            <div class=\"hive-selection-menu_container\">\n                <div class=\"hive-selection-menu_header\">\n                    <div class=\"hive-selection-menu_header-container\">\n                        <ng-content\n                            select=\"[slot=selection-menu-header]\"\n                        ></ng-content>\n                    </div>\n                    <hive-separator />\n                    <div class=\"hive-selection-menu_header-container\">\n                        @if (multiselect) {\n                            <div\n                                class=\"hive-selection-menu_header-checkbox-wrapper\"\n                            >\n                                <hive-checkbox\n                                    (checkedChange)=\"handleCheckedChange()\"\n                                    [checked]=\"\n                                        selectionMenuService.isAllSelectableItemsSelected(\n                                            selectionItems ?? []\n                                        ) &&\n                                        !selectionMenuService.isOnlyDisabledItems(\n                                            selectionItems ?? []\n                                        )\n                                    \"\n                                    [disabled]=\"\n                                        selectionMenuService.isOnlyDisabledItems(\n                                            selectionItems ?? []\n                                        ) ||\n                                        !selectionItems ||\n                                        selectionItems.length === 0\n                                    \"\n                                    [indeterminate]=\"\n                                        selectionMenuService.isAnySelectableItemSelected(\n                                            selectionItems ?? []\n                                        ) &&\n                                        !selectionMenuService.isAllSelectableItemsSelected(\n                                            selectionItems ?? []\n                                        )\n                                    \"\n                                ></hive-checkbox>\n                            </div>\n                        }\n                        @if (hasFilter) {\n                            <div\n                                class=\"hive-selection-menu_header-filter-wrapper\"\n                            >\n                                <hive-text-field\n                                    #filterField\n                                    (debounceChange)=\"filterChange.emit($event)\"\n                                    [debounceWait]=\"debounceWait\"\n                                    [showClear]=\"true\"\n                                    data-testid=\"hive-selection-menu-filter\"\n                                    ngModel\n                                    placeholder=\"Search...\"\n                                    size=\"small\"\n                                ></hive-text-field>\n                            </div>\n                        }\n                    </div>\n                    <hive-separator\n                        [class.hive-selection-menu_footer-separator_hidden]=\"\n                            !(headerSeparatorVisible$ | async)\n                        \"\n                    />\n                </div>\n                <div #selectionMenu class=\"hive-selection-menu_list\">\n                    @if (!selectionMenuEmpty) {\n                        <div class=\"hive-selection-menu_items\">\n                            <ng-content\n                                select=\"\n                            hive-selection-menu-item,\n                            hive-selection-menu-section,\n                            hive-selection-menu-group-item,\n                            ng-container\n                        \"\n                            ></ng-content>\n                        </div>\n                    }\n                    @if (selectionMenuEmpty) {\n                        <div\n                            class=\"hive-selection-menu_empty-container hive-selection-menu_state-container\"\n                        >\n                            <hive-empty-state\n                                description=\"No results found\"\n                                size=\"small\"\n                            ></hive-empty-state>\n                        </div>\n                    }\n                </div>\n                <div class=\"hive-selection-menu_footer\">\n                    @if (!hideSeparators) {\n                        <hive-separator />\n                    }\n                    <div class=\"hive-selection-menu_footer-container\">\n                        <ng-content\n                            select=\"[slot=selection-menu-footer]\"\n                        ></ng-content>\n                    </div>\n                </div>\n            </div>\n        }\n    }\n</div>\n" }]
        }], ctorParameters: () => [{ type: SelectionMenuService }, { type: i0.ChangeDetectorRef }], propDecorators: { selectionList: [{
                type: ViewChildren,
                args: ['selectionMenu']
            }], selectionItems: [{
                type: Input
            }], selectionContent: [{
                type: Input
            }], hasFilter: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], multiselect: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], hasLoadingError: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], isLoading: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], debounceWait: [{
                type: Input,
                args: [{ transform: numberAttribute }]
            }], hideSeparators: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], selectionChange: [{
                type: Output
            }], tryAgainClick: [{
                type: Output
            }], filterChange: [{
                type: Output
            }], filterField: [{
                type: ViewChild,
                args: ['filterField']
            }], selectionMenuItems: [{
                type: ContentChildren,
                args: [(SelectionMenuItemComponent), { descendants: true }]
            }], selectionMenuContent: [{
                type: ContentChildren,
                args: [SELECTION_MENU_CONTENT, { descendants: true }]
            }], selectionMenuGroupItems: [{
                type: ContentChildren,
                args: [(SelectionMenuGroupItemComponent), { descendants: true }]
            }], selection: [{
                type: Input
            }], onKeydown: [{
                type: HostListener,
                args: ['keydown', ['$event']]
            }] } });

/**
 * Menus, usually appear as a drop-down or pop-up list, are used to provide quick access to frequently used functions or commands that a user can choose from.
 */
class MenuComponent {
    constructor(theming$) {
        this.theming$ = theming$;
        /**
         * Works only for overlays. {@see overlay}
         */
        this.position = 'bottomStart';
        /**
         * Set false to not use overlay
         * @default true
         */
        this.overlay = true;
        /**
         * Offset by axis X for overlay menu
         */
        this.offsetX = 0;
        /**
         * Offset by axis Y for overlay menu
         */
        this.offsetY = 0;
        /**
         * Close menu on menu item click
         * If you're using menu-button with selection menu you most likely want to set this to false
         */
        this.closeOnMenuClick = true;
        /**
         * Whether the overlay should close when the page is resized.
         *
         * @default false
         */
        this.closeOnPageResize = false;
        /**
         * Whether the menu wrapper should have padding.
         *
         * @default true
         */
        this.useContentPadding = true;
        /**
         * @internal - Emits true if menu has no menu items, false otherwise.
         */
        this.isEmpty$ = new BehaviorSubject(true);
        this.visibilityChange = new EventEmitter();
        this.destroy$ = new Subject();
        /**
         * Emits when menu item is clicked
         */
        this.menuClick = new EventEmitter();
    }
    ngAfterContentInit() {
        const menuItems$ = this.menuItems.changes.pipe(map(() => this.menuItems.toArray()), startWith$1(this.menuItems.toArray()), takeUntil(this.destroy$));
        const selectionMenu$ = this.selectionMenu.changes.pipe(map(() => this.selectionMenu.toArray()), startWith$1(this.selectionMenu.toArray()), takeUntil(this.destroy$));
        const menuItemsBulkSelector$ = this.menuItemsBulkSelector.changes.pipe(map(() => this.menuItemsBulkSelector.toArray()), startWith$1(this.menuItemsBulkSelector.toArray()), takeUntil(this.destroy$));
        combineLatest([selectionMenu$, menuItems$, menuItemsBulkSelector$])
            .pipe(map(([selectionMenus, items, bulkSelector]) => selectionMenus.length +
            items.length +
            bulkSelector.length))
            .subscribe((hasItems) => {
            this.isEmpty$.next(!hasItems);
        });
        menuItems$
            .pipe(switchMap$1((items) => race(...items.map((item) => item.menuItemClick))))
            .subscribe(() => {
            this.menuClick.emit(this);
        });
    }
    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
    handleOverlayClick() {
        if (this.closeOnMenuClick) {
            this.hideOverlay();
        }
    }
    hideOverlay() {
        this.overlayComponent?.hideOverlay();
    }
    showOverlay(overlayOrigin) {
        this.overlayComponent?.showOverlay(overlayOrigin);
    }
    toggleOverlay(overlayOrigin) {
        this.overlayComponent?.toggleOverlay(overlayOrigin);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: MenuComponent, deps: [{ token: HIVE_THEMING }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.3.12", type: MenuComponent, selector: "hive-menu", inputs: { position: "position", overlay: "overlay", offsetX: "offsetX", offsetY: "offsetY", closeOnMenuClick: ["closeOnMenuClick", "closeOnMenuClick", booleanAttribute], closeOnPageResize: ["closeOnPageResize", "closeOnPageResize", booleanAttribute], useContentPadding: ["useContentPadding", "useContentPadding", booleanAttribute] }, outputs: { visibilityChange: "visibilityChange", menuClick: "menuClick" }, queries: [{ propertyName: "menuItems", predicate: MenuItemComponent, descendants: true }, { propertyName: "menuItemsBulkSelector", predicate: MenuItemBulkSelectorComponent, descendants: true }, { propertyName: "selectionMenu", predicate: SelectionMenuComponent, descendants: true }], viewQueries: [{ propertyName: "menuItemsWrapper", first: true, predicate: ["menuItemsWrapper"], descendants: true }, { propertyName: "overlayComponent", first: true, predicate: OverlayComponent, descendants: true }], exportAs: ["hiveMenu"], hostDirectives: [{ directive: HiveThemedDirective }], ngImport: i0, template: "<div class=\"hive-menu-trigger-wrapper\">\n    <ng-content select=\"[hiveMenuButton], [hiveMenuTrigger]\"></ng-content>\n</div>\n\n<ng-template #menuItemsContainer>\n    @if ((isEmpty$ | async) === false) {\n        <div\n            #menuItemsWrapper\n            class=\"hive-menu-wrapper\"\n            role=\"listbox\"\n            (click)=\"handleOverlayClick()\"\n            [class]=\"'hive-theme-' + (theming$ | async)\"\n            [class.hive-menu-wrapper--no-padding]=\"!useContentPadding\"\n        >\n            <ng-content\n                select=\"hive-menu-item, hive-menu-section, hive-separator:not([orientation=vertical]), hive-selection-menu, hive-menu-item-bulk-selector\"\n            ></ng-content>\n        </div>\n    }\n</ng-template>\n\n@if (!overlay) {\n    <ng-container [ngTemplateOutlet]=\"menuItemsContainer\"></ng-container>\n}\n\n@if (overlay) {\n    <hive-overlay\n        [offsetX]=\"offsetX\"\n        [offsetY]=\"offsetY\"\n        [position]=\"position\"\n        closeOnOutsideClick\n        [closeOnPageResize]=\"closeOnPageResize\"\n        (visibilityChange)=\"visibilityChange.emit($event)\"\n    >\n        <ng-container [ngTemplateOutlet]=\"menuItemsContainer\"></ng-container>\n    </hive-overlay>\n}\n", dependencies: [{ kind: "directive", type: i2$1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "component", type: OverlayComponent, selector: "hive-overlay", inputs: ["takeWidthFromTrigger", "closeOnPageResize", "panelClass", "backdropClass", "position", "offsetX", "offsetY", "closeOnBackdropClick", "closeOnOutsideClick", "hasBackdrop", "overlayMinWidth"], outputs: ["visibilityChange"] }, { kind: "pipe", type: i2$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: MenuComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hive-menu', changeDetection: ChangeDetectionStrategy.OnPush, exportAs: 'hiveMenu', hostDirectives: [HiveThemedDirective], template: "<div class=\"hive-menu-trigger-wrapper\">\n    <ng-content select=\"[hiveMenuButton], [hiveMenuTrigger]\"></ng-content>\n</div>\n\n<ng-template #menuItemsContainer>\n    @if ((isEmpty$ | async) === false) {\n        <div\n            #menuItemsWrapper\n            class=\"hive-menu-wrapper\"\n            role=\"listbox\"\n            (click)=\"handleOverlayClick()\"\n            [class]=\"'hive-theme-' + (theming$ | async)\"\n            [class.hive-menu-wrapper--no-padding]=\"!useContentPadding\"\n        >\n            <ng-content\n                select=\"hive-menu-item, hive-menu-section, hive-separator:not([orientation=vertical]), hive-selection-menu, hive-menu-item-bulk-selector\"\n            ></ng-content>\n        </div>\n    }\n</ng-template>\n\n@if (!overlay) {\n    <ng-container [ngTemplateOutlet]=\"menuItemsContainer\"></ng-container>\n}\n\n@if (overlay) {\n    <hive-overlay\n        [offsetX]=\"offsetX\"\n        [offsetY]=\"offsetY\"\n        [position]=\"position\"\n        closeOnOutsideClick\n        [closeOnPageResize]=\"closeOnPageResize\"\n        (visibilityChange)=\"visibilityChange.emit($event)\"\n    >\n        <ng-container [ngTemplateOutlet]=\"menuItemsContainer\"></ng-container>\n    </hive-overlay>\n}\n" }]
        }], ctorParameters: () => [{ type: i4.BehaviorSubject, decorators: [{
                    type: Inject,
                    args: [HIVE_THEMING]
                }] }], propDecorators: { menuItemsWrapper: [{
                type: ViewChild,
                args: ['menuItemsWrapper']
            }], position: [{
                type: Input
            }], overlay: [{
                type: Input
            }], offsetX: [{
                type: Input
            }], offsetY: [{
                type: Input
            }], closeOnMenuClick: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], closeOnPageResize: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], useContentPadding: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], visibilityChange: [{
                type: Output
            }], menuClick: [{
                type: Output
            }], menuItems: [{
                type: ContentChildren,
                args: [MenuItemComponent, { descendants: true }]
            }], menuItemsBulkSelector: [{
                type: ContentChildren,
                args: [MenuItemBulkSelectorComponent, { descendants: true }]
            }], selectionMenu: [{
                type: ContentChildren,
                args: [SelectionMenuComponent, { descendants: true }]
            }], overlayComponent: [{
                type: ViewChild,
                args: [OverlayComponent, { static: false }]
            }] } });

/**
 * A service to be provided in `PageBaseLayoutComponent`
 *
 * It is intended to be a replacement for `AppHeaderStateService`
 *
 * It subscribes to `BreakpointObserver` and updates the layout based on the screen size.
 *
 * @see PageBaseLayoutComponent
 *
 * @see BreakpointObserver
 */
class LayoutService {
    constructor() {
        this.breakpointObserver = inject(BreakpointObserver);
        this.isLargeScreen$ = this.breakpointObserver
            .observe('(min-width: 1024px)')
            .pipe(map$1((breakpointState) => breakpointState.matches));
        this.isMediumScreen$ = this.breakpointObserver
            .observe('(min-width: 576px)')
            .pipe(map$1((breakpointState) => breakpointState.matches));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: LayoutService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: LayoutService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: LayoutService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });
/**
 * A service to be provided in `PageBaseLayoutComponent` and `AppHeaderComponent`
 * to handle the navigation state.
 */
class LeftNavigationStateService {
    constructor() {
        this.navigationOpenChange = new EventEmitter();
        this.forceHidden$ = new BehaviorSubject(false);
        this.navigationOpen$ = new BehaviorSubject(true);
        this.open$ = combineLatest([
            this.navigationOpen$,
            this.forceHidden$,
        ]).pipe(map$1(([navigationOpen, forceHidden]) => navigationOpen && !forceHidden));
        /**
         * Toggles the force hidden state.
         * @param state
         */
        this.toggleForceHidden = (state) => this.forceHidden$.next(state);
    }
    /**
     * Toggles the navigation visibility state.
     * @param state
     * @param emitEvent
     */
    toggleOpen(state, emitEvent = true) {
        const updatedState = state ?? !this.navigationOpen$.getValue();
        this.navigationOpen$.next(updatedState);
        if (emitEvent) {
            this.navigationOpenChange.emit(updatedState);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: LeftNavigationStateService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: LeftNavigationStateService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: LeftNavigationStateService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });
/**
 * A service to be provided in `PageBaseLayoutComponent` to handle the header state.
 */
class AppHeaderStateService {
    constructor() {
        this.headerHiddenChange = new EventEmitter();
        this.headerHidden$ = new BehaviorSubject(false);
        this.hidden$ = this.headerHidden$.asObservable();
        this.visible$ = this.headerHidden$.pipe(map$1((hidden) => !hidden));
    }
    /**
     * Toggles the header visibility state.
     * @param state
     * @param emitEvent
     */
    toggleHidden(state, emitEvent = true) {
        const updatedState = state ?? !this.headerHidden$.getValue();
        this.headerHidden$.next(updatedState);
        if (emitEvent) {
            this.headerHiddenChange.emit(updatedState);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AppHeaderStateService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AppHeaderStateService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AppHeaderStateService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

/**
 * Along with `hiveMenuButton`, MenuTriggerDirective gets applied, which still owns toggling functionality for hive-menu.
 */
class MenuTriggerDirective {
    constructor(overlayTrigger, parentMenuComponent) {
        this.overlayTrigger = overlayTrigger;
        this.parentMenuComponent = parentMenuComponent;
        /**
         * This field is used to determine which menu should be triggered
         * @internal
         */
        this.menuComponent$ = new BehaviorSubject(this.parentMenuComponent);
        /**
         * This field is used to determine whether the menu is empty or not by menu
         * button or any other component used to trigger the menu
         * @internal
         */
        this.isMenuEmpty$ = this.menuComponent$.pipe(distinctUntilChanged((a, b) => a === b), switchMap$1((menuComponent) => {
            if (!menuComponent) {
                return of(true);
            }
            return menuComponent.isEmpty$;
        }));
        this.destroy$ = new Subject();
    }
    set hiveMenuTrigger(value) {
        if (!value) {
            return;
        }
        this.menuComponent$.next(value);
    }
    set menuRef(value) {
        if (!value) {
            return;
        }
        this.menuComponent$.next(value);
    }
    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
    ngOnInit() {
        this.passSelfReferenceToOverlayTrigger();
    }
    /**
     * We need to tell the overlay trigger about the menu component
     * @private
     */
    passSelfReferenceToOverlayTrigger() {
        this.menuComponent$
            .pipe(takeUntil(this.destroy$), filter((menuComponent) => !!menuComponent))
            .subscribe((menuComponent) => {
            this.overlayTrigger.hiveOverlayTrigger =
                menuComponent;
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: MenuTriggerDirective, deps: [{ token: OverlayTriggerDirective, host: true }, { token: MenuComponent, optional: true }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: MenuTriggerDirective, isStandalone: true, selector: "[hiveMenuTrigger]", inputs: { hiveMenuTrigger: "hiveMenuTrigger", menuRef: "menuRef" }, hostDirectives: [{ directive: OverlayTriggerDirective, inputs: ["disabled", "disabled", "shouldToggle", "shouldToggle"] }], ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: MenuTriggerDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[hiveMenuTrigger]',
                    standalone: true,
                    hostDirectives: [
                        {
                            directive: OverlayTriggerDirective,
                            inputs: ['disabled', 'shouldToggle'],
                        },
                    ],
                }]
        }], ctorParameters: () => [{ type: OverlayTriggerDirective, decorators: [{
                    type: Host
                }] }, { type: MenuComponent, decorators: [{
                    type: Optional
                }] }], propDecorators: { hiveMenuTrigger: [{
                type: Input
            }], menuRef: [{
                type: Input
            }] } });

class MenuButtonDirective {
    /**
     * Whether to show caret icon
     */
    get caret() {
        return this._caret;
    }
    set caret(value) {
        this._caret = value;
        this.button.hasMenuButtonCaret = this._caret;
    }
    constructor(button, overlayTrigger, menuTrigger, cdr) {
        this.button = button;
        this.overlayTrigger = overlayTrigger;
        this.menuTrigger = menuTrigger;
        this.cdr = cdr;
        this._caret = true;
        this.isOpen = false;
        this.destroyRef$ = inject(DestroyRef);
    }
    ngOnInit() {
        this.overlayTrigger.shouldToggle = true;
        this.button.hasMenuButtonCaret = this._caret;
    }
    ngAfterViewInit() {
        /**
         * We need to disable button if menu is empty
         */
        this.menuTrigger.isMenuEmpty$
            .pipe(safeTakeUntilDestroyed(this.destroyRef$))
            .subscribe((isEmpty) => {
            this.setButtonDisabledIfNoElementsPresent(isEmpty);
        });
        /**
         * Subscribe to menu visibility change output to toggle local open state, used for caret icon
         */
        this.overlayTrigger.hiveOverlayTrigger?.visibilityChange
            .pipe(safeTakeUntilDestroyed(this.destroyRef$))
            .subscribe((isOpen) => {
            this.toggleLocalOpenState(isOpen);
        });
    }
    toggleLocalOpenState(value) {
        this.isOpen = value;
        this.button.menuButtonActive = value;
        this.cdr.detectChanges();
    }
    setButtonDisabledIfNoElementsPresent(isEmpty) {
        this.button.disabledByMenuButton = isEmpty;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: MenuButtonDirective, deps: [{ token: ButtonComponent, host: true }, { token: OverlayTriggerDirective, host: true }, { token: MenuTriggerDirective, host: true }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "16.1.0", version: "17.3.12", type: MenuButtonDirective, isStandalone: true, selector: "hive-button[hiveMenuButton]", inputs: { caret: ["caret", "caret", booleanAttribute] }, hostDirectives: [{ directive: MenuTriggerDirective, inputs: ["menuRef", "menuRef"] }], ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: MenuButtonDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'hive-button[hiveMenuButton]',
                    standalone: true,
                    hostDirectives: [
                        {
                            directive: MenuTriggerDirective,
                            inputs: ['menuRef'],
                        },
                    ],
                }]
        }], ctorParameters: () => [{ type: ButtonComponent, decorators: [{
                    type: Host
                }] }, { type: OverlayTriggerDirective, decorators: [{
                    type: Host
                }] }, { type: MenuTriggerDirective, decorators: [{
                    type: Host
                }] }, { type: i0.ChangeDetectorRef }], propDecorators: { caret: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }] } });

/**
 * Offset for pop-ups.
 */
const POP_UP_OFFSET_Y = 12;
/**
 * For pop-ups, MENU_OFFSET_Y is enough but for menu, we need to add 1 more pixel
 */
const MENU_OFFSET_Y = 13;
/**
 * App header has responsive behavior. To play with it, open the App Header story and use the Storybook's toolbar viewport option.
 *
 * Breakpoints are:
 *     - 0px to 576px
 *     - 576px to 1024px
 *     - 1024px and more
 *
 *  Logo can be set in two ways: content projection and `largeScreenLogoSrc` and `smallScreenLogoSrc` inputs.
 *                     Large screen logo is displayed when the screen width is more than 1024px.
 *                     Small screen logo is displayed when the screen width is less than 1024px.
 *                     For content projection you should handle breakpoints by yourself.
 */
class AppHeaderComponent {
    constructor(layoutService, leftNavigationStateService, destroyRef) {
        this.layoutService = layoutService;
        this.leftNavigationStateService = leftNavigationStateService;
        this.destroyRef = destroyRef;
        /**
         * Whether to hide the navigation button.
         * Most likely used in conjunction with the `forceHideNavigation` property of the `PageBaseLayoutComponent`.
         *
         * @default false
         */
        this.hideNavigationButton = false;
        /**
         * Emits when navigation button is clicked.
         *
         * Boolean value indicates, whether the navigation is open or not.
         */
        this.navigationOpenChange = this.leftNavigationStateService.navigationOpenChange;
        /**
         * Emits a value representing the state of notifications panel.
         *
         * `true` means the notifications panel is open.
         * `false` means the notifications panel is closed.
         */
        this.notificationOpenChange = new EventEmitter();
        /**
         * Emits a value representing the state of the app switch panel.
         *
         * `true` means the switch is open.
         * `false` means the switch is closed.
         */
        this.appSwitchOpenChange = new EventEmitter();
        /**
         * Emits a value representing the state of the AI bot panel.
         *
         * `true` means the AI bot panel is open.
         * `false` means the AI bot panel is closed.
         */
        this.aiBotOpenChange = new EventEmitter();
        /**
         * Emits when logo is clicked.
         */
        this.logoClick = new EventEmitter();
        /**
         * Emits when one of the icon buttons is clicked.
         *
         * String value represents the name of the icon button.
         */
        this.iconButtonClick = new EventEmitter();
        this.POP_UP_OFFSET_Y = POP_UP_OFFSET_Y;
        this.navigationOpen$ = this.leftNavigationStateService.open$;
        this.isLargeScreen$ = this.layoutService.isLargeScreen$;
        this.isMediumScreen$ = this.layoutService.isMediumScreen$;
        this.templates$ = new BehaviorSubject({
            notifications: null,
            appSwitch: null,
            aiBot: null,
        });
        this.notificationsTemplate$ = this.templates$.pipe(map((templates) => templates.notifications), distinctUntilChanged());
        this.appSwitchTemplate$ = this.templates$.pipe(map((templates) => templates.appSwitch), distinctUntilChanged());
        this.aiBotTemplate$ = this.templates$.pipe(map((templates) => templates.aiBot), distinctUntilChanged());
    }
    /**
     * Use to show the notifications pop-up.
     */
    showNotificationsPopUp() {
        this.notificationsPopUpTrigger?.showOverlay();
    }
    /**
     * Use to hide the notifications pop-up.
     */
    hideNotificationsPopUp() {
        this.notificationsPopUpTrigger?.hideOverlay();
    }
    /**
     * Use to show the app switch pop-up.
     */
    showAppSwitchPopUp() {
        this.appSwitchPopUpTrigger?.showOverlay();
    }
    /**
     * Use to hide the app switch pop-up.
     */
    hideAppSwitchPopUp() {
        this.appSwitchPopUpTrigger?.hideOverlay();
    }
    /**
     * Use to show the AI bot pop-up.
     */
    showAiBotPopUp() {
        this.aiBotPopUpTrigger?.showOverlay();
    }
    /**
     * Use to hide the AI bot pop-up.
     */
    hideAiBotPopUp() {
        this.aiBotPopUpTrigger?.hideOverlay();
    }
    ngAfterContentInit() {
        this.setMenuOffset(this.helpMenu);
        this.templates?.changes
            .pipe(safeTakeUntilDestroyed(this.destroyRef), startWith$1(null), map(() => this.templates?.toArray() ?? []), map((templates) => templates.reduce((acc, template) => ({
            ...acc,
            [template.name]: template,
        }), {})), tap$1((templates) => this.templates$.next(templates)))
            .subscribe();
    }
    ngOnChanges(changes) {
        if ('navigationOpen' in changes) {
            this.leftNavigationStateService.toggleOpen(this.navigationOpen, false);
        }
    }
    handleNavigationClick() {
        this.leftNavigationStateService.toggleOpen();
    }
    setMenuOffset(menuComponent) {
        if (!menuComponent) {
            return false;
        }
        menuComponent.offsetY = MENU_OFFSET_Y;
        menuComponent.position = 'bottomEnd';
        return true;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AppHeaderComponent, deps: [{ token: LayoutService }, { token: LeftNavigationStateService }, { token: i0.DestroyRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.3.12", type: AppHeaderComponent, selector: "hive-app-header", inputs: { largeScreenLogoSrc: ["largeScreenLogoSrc", "largeScreenLogoSrc", stringOrUndefinedAttribute], smallScreenLogoSrc: ["smallScreenLogoSrc", "smallScreenLogoSrc", stringOrUndefinedAttribute], notificationsAmount: "notificationsAmount", navigationOpen: ["navigationOpen", "navigationOpen", booleanAttribute], hideNavigationButton: ["hideNavigationButton", "hideNavigationButton", booleanAttribute] }, outputs: { navigationOpenChange: "navigationOpenChange", notificationOpenChange: "notificationOpenChange", appSwitchOpenChange: "appSwitchOpenChange", aiBotOpenChange: "aiBotOpenChange", logoClick: "logoClick", iconButtonClick: "iconButtonClick" }, queries: [{ propertyName: "helpMenu", first: true, predicate: AppHeaderHelpMenuDirective, descendants: true, read: MenuComponent }, { propertyName: "templates", predicate: HiveTemplateDirective }], viewQueries: [{ propertyName: "notificationsPopUpTrigger", first: true, predicate: ["notificationsPopUpTrigger"], descendants: true, read: OverlayTriggerDirective }, { propertyName: "appSwitchPopUpTrigger", first: true, predicate: ["appSwitchPopUpTrigger"], descendants: true, read: OverlayTriggerDirective }, { propertyName: "aiBotPopUpTrigger", first: true, predicate: ["aiBotPopUpTrigger"], descendants: true, read: OverlayTriggerDirective }], usesOnChanges: true, hostDirectives: [{ directive: HiveThemedDirective }], ngImport: i0, template: "<div class=\"hive-app-header_container\" hiveInvertedColors>\n    <div class=\"hive-app-header_navigation\">\n        @if (!hideNavigationButton) {\n            <div class=\"hive-app-header_navigation-wrapper\">\n                @switch (isLargeScreen$ | async) {\n                    @case (true) {\n                        <hive-button\n                            class=\"hive-app-header_navigation-button\"\n                            icon=\"light/bars.svg\"\n                            emphasis=\"tertiary\"\n                            (click)=\"handleNavigationClick()\"\n                            data-testid=\"hive-app-header-navigation-button\"\n                        ></hive-button>\n                    }\n                    @default {\n                        <hive-button\n                            class=\"hive-app-header_navigation-button\"\n                            [icon]=\"\n                                (navigationOpen$ | async)\n                                    ? 'light/xmark.svg'\n                                    : 'light/bars.svg'\n                            \"\n                            emphasis=\"tertiary\"\n                            (click)=\"handleNavigationClick()\"\n                            data-testid=\"hive-app-header-navigation-button\"\n                        ></hive-button>\n                    }\n                }\n            </div>\n        }\n\n        <div class=\"hive-app-header_logo-container\" (click)=\"logoClick.emit()\">\n            <ng-content select=\"[slot=logo]\"></ng-content>\n\n            @if (smallScreenLogoSrc && (isMediumScreen$ | async) === false) {\n                <svg\n                    class=\"hive-app-header_logo-small\"\n                    [hive-svg]=\"smallScreenLogoSrc\"\n                    [height]=\"30\"\n                ></svg>\n            }\n\n            @if (largeScreenLogoSrc && (isMediumScreen$ | async)) {\n                <svg\n                    class=\"hive-app-header_logo-large\"\n                    [hive-svg]=\"largeScreenLogoSrc\"\n                    [height]=\"30\"\n                ></svg>\n            }\n        </div>\n        <div class=\"hive-app-header_org-switcher\">\n            <hive-separator\n                class=\"hive-app-header_org-switcher-separator\"\n                orientation=\"vertical\"\n            ></hive-separator>\n\n            <div class=\"hive-app-header_org-switcher-content\">\n                <ng-content select=\"hive-organization-switcher\"></ng-content>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"hive-app-header_utility\">\n        <div class=\"hive-app-header_utility-actions\">\n            <a\n                data-testid=\"hive-app-header_utility-actions-confidential\"\n                class=\"hive-app-header_utility-actions-confidential\"\n                href=\"https://www.purestorage.com/legal/pure-end-user-agreement.html\"\n                target=\"_blank\"\n            >\n                <hive-icon-component\n                    class=\"hive-app-header_utility-actions-confidential-icon\"\n                    size=\"smallest\"\n                    icon=\"light/lock.svg\"\n                ></hive-icon-component>\n\n                <div class=\"hive-app-header_utility-actions-confidential-text\">\n                    confidential\n                </div>\n            </a>\n\n            <hive-separator orientation=\"vertical\"></hive-separator>\n\n            <ng-content select=\"hive-button[icon]\"></ng-content>\n\n            @if (aiBotTemplate$ | async; as aiBotTemplate) {\n                <div class=\"hive-app-header_utility-actions-ai-bot-container\">\n                    <hive-button\n                        class=\"hive-app-header_utility-actions-ai-bot-button\"\n                        icon=\"light/sparkles.svg\"\n                        emphasis=\"tertiary\"\n                        shouldToggle\n                        [hivePopUpTrigger]=\"aiBotPopUp\"\n                        #aiBotPopUpTrigger\n                        (click)=\"iconButtonClick.emit('aiBot')\"\n                        title=\"AI Copilot\"\n                    ></hive-button>\n                    <hive-pop-up\n                        #aiBotPopUp\n                        position=\"bottomEnd\"\n                        closeOnOutsideClick\n                        animationType=\"slide\"\n                        [offsetY]=\"POP_UP_OFFSET_Y\"\n                        (visibilityChange)=\"aiBotOpenChange.emit($event)\"\n                    >\n                        <ng-container\n                            *ngTemplateOutlet=\"aiBotTemplate.template\"\n                        ></ng-container>\n                    </hive-pop-up>\n                </div>\n            }\n\n            @if (helpMenu) {\n                <hive-button\n                    class=\"hive-app-header_utility-actions-help-button\"\n                    icon=\"light/circle-question.svg\"\n                    emphasis=\"tertiary\"\n                    hiveMenuButton\n                    [caret]=\"false\"\n                    [menuRef]=\"helpMenu\"\n                    (click)=\"iconButtonClick.emit('help')\"\n                    title=\"Help\"\n                ></hive-button>\n            }\n\n            @if (notificationsTemplate$ | async; as notificationsTemplate) {\n                <div class=\"hive-app-header_notifications-container\">\n                    <hive-button\n                        #notificationsPopUpTrigger\n                        class=\"hive-app-header_notifications-button\"\n                        icon=\"light/bell.svg\"\n                        emphasis=\"tertiary\"\n                        shouldToggle\n                        [hivePopUpTrigger]=\"notificationsPopUp\"\n                        (click)=\"iconButtonClick.emit('notifications')\"\n                        title=\"Notifications\"\n                    ></hive-button>\n                    <hive-pop-up\n                        #notificationsPopUp\n                        position=\"bottomEnd\"\n                        closeOnOutsideClick\n                        animationType=\"slide\"\n                        [offsetY]=\"POP_UP_OFFSET_Y\"\n                        (visibilityChange)=\"notificationOpenChange.emit($event)\"\n                    >\n                        <ng-container\n                            *ngTemplateOutlet=\"notificationsTemplate.template\"\n                        ></ng-container>\n                    </hive-pop-up>\n                    @if (notificationsAmount) {\n                        <div\n                            class=\"hive-app-header_notifications-badge-wrapper\"\n                        >\n                            <hive-badge\n                                emphasis=\"info\"\n                                [label]=\"notificationsAmount\"\n                            ></hive-badge>\n                        </div>\n                    }\n                </div>\n            }\n\n            @if (appSwitchTemplate$ | async; as appSwitchTemplate) {\n                <div\n                    class=\"hive-app-header_utility-actions-app-switch-container\"\n                >\n                    <hive-button\n                        class=\"hive-app-header_utility-actions-app-switch-button\"\n                        icon=\"light/grid.svg\"\n                        emphasis=\"tertiary\"\n                        shouldToggle\n                        [hivePopUpTrigger]=\"appSwitchPopUp\"\n                        #appSwitchPopUpTrigger\n                        (click)=\"iconButtonClick.emit('appSwitch')\"\n                        title=\"Application Switcher\"\n                    ></hive-button>\n                    <hive-pop-up\n                        #appSwitchPopUp\n                        position=\"bottomEnd\"\n                        closeOnOutsideClick\n                        animationType=\"slide\"\n                        [offsetY]=\"POP_UP_OFFSET_Y\"\n                        (visibilityChange)=\"appSwitchOpenChange.emit($event)\"\n                    >\n                        <ng-container\n                            *ngTemplateOutlet=\"appSwitchTemplate.template\"\n                        ></ng-container>\n                    </hive-pop-up>\n                </div>\n            }\n        </div>\n\n        <div class=\"hive-app-header_avatar-wrapper\">\n            <ng-content select=\"hive-avatar-menu\"></ng-content>\n        </div>\n    </div>\n</div>\n", dependencies: [{ kind: "directive", type: i2$1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "component", type: ButtonComponent, selector: "hive-button", inputs: ["type", "menuButtonActive", "hasMenuButtonCaret", "label", "accessibleName", "icon", "iconPosition", "emphasis", "title", "size", "isLoading", "disabled", "rounded", "width"] }, { kind: "directive", type: MenuButtonDirective, selector: "hive-button[hiveMenuButton]", inputs: ["caret"] }, { kind: "directive", type: SvgDirective, selector: "svg[hive-svg]", inputs: ["hive-svg", "width", "height"] }, { kind: "component", type: SeparatorComponent, selector: "hive-separator", inputs: ["orientation"] }, { kind: "component", type: PopUpComponent, selector: "hive-pop-up", inputs: ["testId", "showCloseButton", "dark", "position", "offsetX", "offsetY", "closeOnOutsideClick", "closeOnBackdropClick", "hasBackdrop"], outputs: ["visibilityChange"], exportAs: ["hivePopUp"] }, { kind: "directive", type: PopUpTriggerDirective, selector: "[hivePopUpTrigger]", inputs: ["hivePopUpTrigger"] }, { kind: "component", type: BadgeComponent, selector: "hive-badge", inputs: ["label", "icon", "emphasis", "size"] }, { kind: "component", type: IconComponent, selector: "hive-icon-component", inputs: ["icon", "size"] }, { kind: "directive", type: InvertedColorsDirective, selector: "[hiveInvertedColors]", inputs: ["hiveInvertedColors"] }, { kind: "pipe", type: i2$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AppHeaderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hive-app-header', changeDetection: ChangeDetectionStrategy.OnPush, hostDirectives: [HiveThemedDirective], template: "<div class=\"hive-app-header_container\" hiveInvertedColors>\n    <div class=\"hive-app-header_navigation\">\n        @if (!hideNavigationButton) {\n            <div class=\"hive-app-header_navigation-wrapper\">\n                @switch (isLargeScreen$ | async) {\n                    @case (true) {\n                        <hive-button\n                            class=\"hive-app-header_navigation-button\"\n                            icon=\"light/bars.svg\"\n                            emphasis=\"tertiary\"\n                            (click)=\"handleNavigationClick()\"\n                            data-testid=\"hive-app-header-navigation-button\"\n                        ></hive-button>\n                    }\n                    @default {\n                        <hive-button\n                            class=\"hive-app-header_navigation-button\"\n                            [icon]=\"\n                                (navigationOpen$ | async)\n                                    ? 'light/xmark.svg'\n                                    : 'light/bars.svg'\n                            \"\n                            emphasis=\"tertiary\"\n                            (click)=\"handleNavigationClick()\"\n                            data-testid=\"hive-app-header-navigation-button\"\n                        ></hive-button>\n                    }\n                }\n            </div>\n        }\n\n        <div class=\"hive-app-header_logo-container\" (click)=\"logoClick.emit()\">\n            <ng-content select=\"[slot=logo]\"></ng-content>\n\n            @if (smallScreenLogoSrc && (isMediumScreen$ | async) === false) {\n                <svg\n                    class=\"hive-app-header_logo-small\"\n                    [hive-svg]=\"smallScreenLogoSrc\"\n                    [height]=\"30\"\n                ></svg>\n            }\n\n            @if (largeScreenLogoSrc && (isMediumScreen$ | async)) {\n                <svg\n                    class=\"hive-app-header_logo-large\"\n                    [hive-svg]=\"largeScreenLogoSrc\"\n                    [height]=\"30\"\n                ></svg>\n            }\n        </div>\n        <div class=\"hive-app-header_org-switcher\">\n            <hive-separator\n                class=\"hive-app-header_org-switcher-separator\"\n                orientation=\"vertical\"\n            ></hive-separator>\n\n            <div class=\"hive-app-header_org-switcher-content\">\n                <ng-content select=\"hive-organization-switcher\"></ng-content>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"hive-app-header_utility\">\n        <div class=\"hive-app-header_utility-actions\">\n            <a\n                data-testid=\"hive-app-header_utility-actions-confidential\"\n                class=\"hive-app-header_utility-actions-confidential\"\n                href=\"https://www.purestorage.com/legal/pure-end-user-agreement.html\"\n                target=\"_blank\"\n            >\n                <hive-icon-component\n                    class=\"hive-app-header_utility-actions-confidential-icon\"\n                    size=\"smallest\"\n                    icon=\"light/lock.svg\"\n                ></hive-icon-component>\n\n                <div class=\"hive-app-header_utility-actions-confidential-text\">\n                    confidential\n                </div>\n            </a>\n\n            <hive-separator orientation=\"vertical\"></hive-separator>\n\n            <ng-content select=\"hive-button[icon]\"></ng-content>\n\n            @if (aiBotTemplate$ | async; as aiBotTemplate) {\n                <div class=\"hive-app-header_utility-actions-ai-bot-container\">\n                    <hive-button\n                        class=\"hive-app-header_utility-actions-ai-bot-button\"\n                        icon=\"light/sparkles.svg\"\n                        emphasis=\"tertiary\"\n                        shouldToggle\n                        [hivePopUpTrigger]=\"aiBotPopUp\"\n                        #aiBotPopUpTrigger\n                        (click)=\"iconButtonClick.emit('aiBot')\"\n                        title=\"AI Copilot\"\n                    ></hive-button>\n                    <hive-pop-up\n                        #aiBotPopUp\n                        position=\"bottomEnd\"\n                        closeOnOutsideClick\n                        animationType=\"slide\"\n                        [offsetY]=\"POP_UP_OFFSET_Y\"\n                        (visibilityChange)=\"aiBotOpenChange.emit($event)\"\n                    >\n                        <ng-container\n                            *ngTemplateOutlet=\"aiBotTemplate.template\"\n                        ></ng-container>\n                    </hive-pop-up>\n                </div>\n            }\n\n            @if (helpMenu) {\n                <hive-button\n                    class=\"hive-app-header_utility-actions-help-button\"\n                    icon=\"light/circle-question.svg\"\n                    emphasis=\"tertiary\"\n                    hiveMenuButton\n                    [caret]=\"false\"\n                    [menuRef]=\"helpMenu\"\n                    (click)=\"iconButtonClick.emit('help')\"\n                    title=\"Help\"\n                ></hive-button>\n            }\n\n            @if (notificationsTemplate$ | async; as notificationsTemplate) {\n                <div class=\"hive-app-header_notifications-container\">\n                    <hive-button\n                        #notificationsPopUpTrigger\n                        class=\"hive-app-header_notifications-button\"\n                        icon=\"light/bell.svg\"\n                        emphasis=\"tertiary\"\n                        shouldToggle\n                        [hivePopUpTrigger]=\"notificationsPopUp\"\n                        (click)=\"iconButtonClick.emit('notifications')\"\n                        title=\"Notifications\"\n                    ></hive-button>\n                    <hive-pop-up\n                        #notificationsPopUp\n                        position=\"bottomEnd\"\n                        closeOnOutsideClick\n                        animationType=\"slide\"\n                        [offsetY]=\"POP_UP_OFFSET_Y\"\n                        (visibilityChange)=\"notificationOpenChange.emit($event)\"\n                    >\n                        <ng-container\n                            *ngTemplateOutlet=\"notificationsTemplate.template\"\n                        ></ng-container>\n                    </hive-pop-up>\n                    @if (notificationsAmount) {\n                        <div\n                            class=\"hive-app-header_notifications-badge-wrapper\"\n                        >\n                            <hive-badge\n                                emphasis=\"info\"\n                                [label]=\"notificationsAmount\"\n                            ></hive-badge>\n                        </div>\n                    }\n                </div>\n            }\n\n            @if (appSwitchTemplate$ | async; as appSwitchTemplate) {\n                <div\n                    class=\"hive-app-header_utility-actions-app-switch-container\"\n                >\n                    <hive-button\n                        class=\"hive-app-header_utility-actions-app-switch-button\"\n                        icon=\"light/grid.svg\"\n                        emphasis=\"tertiary\"\n                        shouldToggle\n                        [hivePopUpTrigger]=\"appSwitchPopUp\"\n                        #appSwitchPopUpTrigger\n                        (click)=\"iconButtonClick.emit('appSwitch')\"\n                        title=\"Application Switcher\"\n                    ></hive-button>\n                    <hive-pop-up\n                        #appSwitchPopUp\n                        position=\"bottomEnd\"\n                        closeOnOutsideClick\n                        animationType=\"slide\"\n                        [offsetY]=\"POP_UP_OFFSET_Y\"\n                        (visibilityChange)=\"appSwitchOpenChange.emit($event)\"\n                    >\n                        <ng-container\n                            *ngTemplateOutlet=\"appSwitchTemplate.template\"\n                        ></ng-container>\n                    </hive-pop-up>\n                </div>\n            }\n        </div>\n\n        <div class=\"hive-app-header_avatar-wrapper\">\n            <ng-content select=\"hive-avatar-menu\"></ng-content>\n        </div>\n    </div>\n</div>\n" }]
        }], ctorParameters: () => [{ type: LayoutService }, { type: LeftNavigationStateService }, { type: i0.DestroyRef }], propDecorators: { largeScreenLogoSrc: [{
                type: Input,
                args: [{ transform: stringOrUndefinedAttribute }]
            }], smallScreenLogoSrc: [{
                type: Input,
                args: [{ transform: stringOrUndefinedAttribute }]
            }], notificationsAmount: [{
                type: Input
            }], navigationOpen: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], hideNavigationButton: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], navigationOpenChange: [{
                type: Output
            }], notificationOpenChange: [{
                type: Output
            }], appSwitchOpenChange: [{
                type: Output
            }], aiBotOpenChange: [{
                type: Output
            }], logoClick: [{
                type: Output
            }], iconButtonClick: [{
                type: Output
            }], notificationsPopUpTrigger: [{
                type: ViewChild,
                args: ['notificationsPopUpTrigger', { read: OverlayTriggerDirective }]
            }], appSwitchPopUpTrigger: [{
                type: ViewChild,
                args: ['appSwitchPopUpTrigger', { read: OverlayTriggerDirective }]
            }], aiBotPopUpTrigger: [{
                type: ViewChild,
                args: ['aiBotPopUpTrigger', { read: OverlayTriggerDirective }]
            }], helpMenu: [{
                type: ContentChild,
                args: [AppHeaderHelpMenuDirective, { read: MenuComponent }]
            }], templates: [{
                type: ContentChildren,
                args: [HiveTemplateDirective]
            }] } });

class MenuSectionComponent {
    constructor() {
        this.cssClass = true;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: MenuSectionComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: MenuSectionComponent, selector: "hive-menu-section", inputs: { label: "label" }, host: { properties: { "class.hive-menu-section": "this.cssClass" } }, hostDirectives: [{ directive: HiveThemedDirective }], ngImport: i0, template: `
        <hive-label
            [label]="label"
            weight="semibold"
            size="small"
            class="hive-menu-section_label"
        />
    `, isInline: true, dependencies: [{ kind: "component", type: LabelComponent, selector: "hive-label", inputs: ["label", "for", "size", "weight", "maxWeight", "horizontalAlignment", "leftIconHelpInfoMessage", "rightIconHelpInfoMessage", "leftIcon", "rightIcon", "required", "textOverflowEllipsis"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: MenuSectionComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'hive-menu-section',
                    template: `
        <hive-label
            [label]="label"
            weight="semibold"
            size="small"
            class="hive-menu-section_label"
        />
    `,
                    hostDirectives: [HiveThemedDirective],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], propDecorators: { label: [{
                type: Input,
                args: [{ required: true }]
            }], cssClass: [{
                type: HostBinding,
                args: ['class.hive-menu-section']
            }] } });

class MenuModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: MenuModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: MenuModule, declarations: [MenuComponent,
            MenuItemComponent,
            MenuSectionComponent,
            MenuItemBulkSelectorComponent], imports: [CommonModule,
            OverlayModule,
            SeparatorComponent,
            IconComponent,
            MenuTriggerDirective,
            OverlayComponent,
            MenuButtonDirective,
            LabelComponent], exports: [MenuButtonDirective,
            MenuTriggerDirective,
            MenuComponent,
            MenuItemComponent,
            MenuSectionComponent,
            MenuItemBulkSelectorComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: MenuModule, imports: [CommonModule,
            OverlayModule,
            IconComponent,
            OverlayComponent,
            LabelComponent] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: MenuModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        MenuComponent,
                        MenuItemComponent,
                        MenuSectionComponent,
                        MenuItemBulkSelectorComponent,
                    ],
                    imports: [
                        CommonModule,
                        OverlayModule,
                        SeparatorComponent,
                        IconComponent,
                        MenuTriggerDirective,
                        OverlayComponent,
                        MenuButtonDirective,
                        LabelComponent,
                    ],
                    exports: [
                        MenuButtonDirective,
                        MenuTriggerDirective,
                        MenuComponent,
                        MenuItemComponent,
                        MenuSectionComponent,
                        MenuItemBulkSelectorComponent,
                    ],
                }]
        }] });

class HiveTemplatePipe {
    transform(value, queryList, 
    // `defaultQueryList` is used to get the template from the default template list, provided by the component.
    defaultQueryList) {
        return (queryList?.find((item) => item.name === value)?.template ??
            defaultQueryList?.find((item) => item.name === value)?.template ??
            null);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: HiveTemplatePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: HiveTemplatePipe, isStandalone: true, name: "hiveTemplate" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: HiveTemplatePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'hiveTemplate',
                    standalone: true,
                    pure: true,
                }]
        }] });

class AppHeaderModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AppHeaderModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: AppHeaderModule, declarations: [AppHeaderComponent, AppHeaderHelpMenuDirective], imports: [CommonModule,
            AvatarModule,
            ButtonComponent,
            MenuModule,
            SvgDirective,
            HiveTemplatePipe,
            HiveTemplateDirective,
            SeparatorComponent,
            PopUpModule,
            BadgeModule,
            IconComponent,
            InvertedColorsDirective], exports: [AppHeaderComponent, AppHeaderHelpMenuDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AppHeaderModule, imports: [CommonModule,
            AvatarModule,
            ButtonComponent,
            MenuModule,
            PopUpModule,
            BadgeModule,
            IconComponent] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AppHeaderModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [AppHeaderComponent, AppHeaderHelpMenuDirective],
                    imports: [
                        CommonModule,
                        AvatarModule,
                        ButtonComponent,
                        MenuModule,
                        SvgDirective,
                        HiveTemplatePipe,
                        HiveTemplateDirective,
                        SeparatorComponent,
                        PopUpModule,
                        BadgeModule,
                        IconComponent,
                        InvertedColorsDirective,
                    ],
                    exports: [AppHeaderComponent, AppHeaderHelpMenuDirective],
                }]
        }] });

/**
 * Should be placed inside of the hive-breadcrumb component.
 * NOTE: On the overflown breadcrumbs, native events are not supported. Click and other events will not be emitted. Use breadcrumbClick event on hive-breadcrumb instead.
 */
class BreadcrumbItemComponent {
    constructor() {
        /**
         * Use to specify the label of the breadcrumb
         */
        this.label = '';
        /**
         * Transforms the breadcrumb into a back link with an icon and 'Back to' label prefix
         */
        this.backLink = false;
        this.breadcrumbClick = new EventEmitter();
        this.hiveBreadcrumbItem = true;
        this._disabled = false;
    }
    /**
     * Use to specify the disabled state of the breadcrumb
     * @default false
     */
    set disabled(value) {
        this._disabled = coerceBooleanProperty(value);
    }
    get disabled() {
        return this._disabled;
    }
    handleClick() {
        if (!this._disabled) {
            this.breadcrumbClick.emit(this);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: BreadcrumbItemComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.3.12", type: BreadcrumbItemComponent, selector: "hive-breadcrumb-item,[hive-breadcrumb-item]", inputs: { id: "id", label: "label", backLink: ["backLink", "backLink", booleanAttribute], disabled: "disabled" }, outputs: { breadcrumbClick: "breadcrumbClick" }, host: { properties: { "attr.hive-breadcrumb-item": "this.hiveBreadcrumbItem" } }, ngImport: i0, template: "<a hive-link [disabled]=\"_disabled || false\" (click)=\"handleClick()\">\n    @if (backLink) {\n        <hive-icon-component\n            class=\"hive-link_icon\"\n            [class.hive-link_icon--disabled]=\"_disabled || false\"\n            icon=\"solid/arrow-left.svg\"\n            size=\"smallest\"\n        ></hive-icon-component>\n    }\n    {{ backLink ? 'Back to ' : '' }}\n    {{ label }}\n</a>\n@if (!backLink) {\n    <span class=\"hive-breadcrumb-separator\">/</span>\n}\n", dependencies: [{ kind: "component", type: LinkComponent, selector: "a[hive-link]", inputs: ["disabled", "size", "external"] }, { kind: "component", type: IconComponent, selector: "hive-icon-component", inputs: ["icon", "size"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: BreadcrumbItemComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hive-breadcrumb-item,[hive-breadcrumb-item]', changeDetection: ChangeDetectionStrategy.OnPush, template: "<a hive-link [disabled]=\"_disabled || false\" (click)=\"handleClick()\">\n    @if (backLink) {\n        <hive-icon-component\n            class=\"hive-link_icon\"\n            [class.hive-link_icon--disabled]=\"_disabled || false\"\n            icon=\"solid/arrow-left.svg\"\n            size=\"smallest\"\n        ></hive-icon-component>\n    }\n    {{ backLink ? 'Back to ' : '' }}\n    {{ label }}\n</a>\n@if (!backLink) {\n    <span class=\"hive-breadcrumb-separator\">/</span>\n}\n" }]
        }], propDecorators: { id: [{
                type: Input
            }], label: [{
                type: Input
            }], backLink: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], breadcrumbClick: [{
                type: Output
            }], disabled: [{
                type: Input
            }], hiveBreadcrumbItem: [{
                type: HostBinding,
                args: ['attr.hive-breadcrumb-item']
            }] } });

/**
 * Get a property from object
 * @param property
 * @example
 * of({ a: 1, b: 2 }).pipe(pluckProperty('a')).subscribe(console.log); // 1
 */
function pluckProperty(property) {
    return (source) => source.pipe(map$1((value) => value[property]));
}

/**
 * Just a simple wrapper around ResizeObserver to make it RxJS compatible
 * @param target
 * @param config
 */
const observeOnResize = (target, config) => {
    return new Observable((observer) => {
        const resizeObserver = new ResizeObserver((entries) => {
            observer.next(entries);
        });
        resizeObserver.observe(target, config);
        return () => {
            resizeObserver.disconnect();
        };
    });
};

/**
 * Just a simple wrapper around MutationObserver to make it RxJS compatible
 * @param target
 * @param config
 */
const observeOnMutation = (target, config) => {
    return new Observable((observer) => {
        const mutation = new MutationObserver((mutations) => {
            observer.next(mutations);
        });
        mutation.observe(target, config);
        return () => {
            mutation.disconnect();
        };
    });
};

/**
 * Returns observable that emits true if content overflows container
 * @param content
 * @param container
 */
function watchOverflow(content, container) {
    const breadcrumbsOriginalSize$ = merge(observeOnResize(content, {}), observeOnMutation(content, { childList: true })).pipe(startWith$1(content), map$1(() => content), pluckProperty('scrollWidth'));
    const parentSize$ = merge(observeOnResize(container, {}), observeOnMutation(container, { childList: true })).pipe(startWith$1(container), map$1(() => container), pluckProperty('clientWidth'));
    return combineLatest([breadcrumbsOriginalSize$, parentSize$]).pipe(map$1(([breadcrumbsOriginalSize, parentSize]) => breadcrumbsOriginalSize > parentSize), distinctUntilChanged());
}

class WithoutFirstAndLastPipe {
    transform(value) {
        if (!value) {
            return [];
        }
        const array = [...value];
        switch (array.length) {
            case 0:
                return [];
            case 1:
                return array.slice();
            case 2:
                return array.slice();
            default:
                return array.slice(1, -1);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: WithoutFirstAndLastPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: WithoutFirstAndLastPipe, name: "withoutFirstAndLast" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: WithoutFirstAndLastPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'withoutFirstAndLast',
                }]
        }] });

/**
 * Breadcrumb component provide API to show users their current location relative to the information architecture and enable them to move up to a parent level or previous step.
 *
 * ** NOTE If overflown, native events are not supported for `hive-breadcrumb-item` component. **
 *
 * ** Use `breadcrumbClick` event to handle click. **
 */
class BreadcrumbComponent {
    constructor(elementRef) {
        this.elementRef = elementRef;
        /**
         * Emits when breadcrumb item is clicked
         */
        this.breadcrumbClick = new EventEmitter();
        this.isOverflowing$ = new Subject();
        this.destroy$ = new Subject();
        this.breadcrumbsList$ = new BehaviorSubject([]);
        this._lastBreadcrumbInactive = false;
    }
    /**
     * Use to specify the disabled state of the last breadcrumb
     * Required for cases when page title is not available
     * @param value
     */
    set lastBreadcrumbInactive(value) {
        this._lastBreadcrumbInactive = coerceBooleanProperty(value);
    }
    ngAfterViewInit() {
        this.watchForBreadcrumbClick();
        timer(0)
            .pipe(take(1), takeUntil(this.destroy$))
            .subscribe(() => {
            this.watchOverflow(this.breadcrumbsHidden.nativeElement, this.elementRef.nativeElement);
        });
        this.breadcrumbs.changes.pipe(map$1(() => this.breadcrumbs.toArray()), takeUntil(this.destroy$), tap((breadcrumbs) => this.breadcrumbsList$.next(breadcrumbs))).subscribe();
        this.breadcrumbs.notifyOnChanges();
    }
    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
    /**
     * This method is used to handle click on menu item click only.
     * @param breadcrumb
     * @internal - The reason why its not protected is testing purposes.
     */
    handleMenuItemClick(breadcrumb) {
        this.breadcrumbClick.emit(breadcrumb);
        breadcrumb.breadcrumbClick.emit(breadcrumb);
    }
    /**
     * This method is used to handle click on breadcrumb item click only.
     * @internal - The reason why its not protected is testing purposes.
     * @param breadcrumb
     */
    handleBreadcrumbClick(breadcrumb) {
        this.breadcrumbClick.emit(breadcrumb);
    }
    /**
     * @internal - The reason why its not protected is testing purposes.
     */
    trackByBreadcrumbId(index, item) {
        return item.id || index.toString();
    }
    /**
     * @internal - The reason why its not protected is testing purposes.
     */
    watchForBreadcrumbClick() {
        this.breadcrumbs.changes.pipe(startWith$1(this.breadcrumbs.toArray()), map$1(() => this.breadcrumbs.toArray()), takeUntil(this.destroy$), switchMap$1((breadcrumbs) => merge(...breadcrumbs.map((breadcrumb) => breadcrumb.breadcrumbClick))), tap(this.handleBreadcrumbClick.bind(this))).subscribe();
    }
    /**
     * @internal - The reason why its not protected is testing purposes.
     */
    watchOverflow(content, container) {
        watchOverflow(content, container)
            .pipe(takeUntil(this.destroy$), tap((isOverflowing) => {
            this.isOverflowing$.next(isOverflowing);
        }))
            .subscribe();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: BreadcrumbComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.3.12", type: BreadcrumbComponent, selector: "hive-breadcrumb", inputs: { lastBreadcrumbInactive: "lastBreadcrumbInactive" }, outputs: { breadcrumbClick: "breadcrumbClick" }, queries: [{ propertyName: "breadcrumbs", predicate: i0.forwardRef(() => BreadcrumbItemComponent) }], viewQueries: [{ propertyName: "breadcrumbsHidden", first: true, predicate: ["breadcrumbsHidden"], descendants: true, static: true }], hostDirectives: [{ directive: HiveThemedDirective }], ngImport: i0, template: "<div #breadcrumbsHidden class=\"hive-breadcrumbs__hidden-items\">\n    @for (\n        breadcrumb of breadcrumbs;\n        track trackByBreadcrumbId(position, breadcrumb);\n        let position = $index\n    ) {\n        <hive-breadcrumb-item [label]=\"breadcrumb.label\"></hive-breadcrumb-item>\n    }\n</div>\n\n<div\n    [class.hive-breadcrumbs-container--overflowing]=\"isOverflowing$ | async\"\n    [class.hive-breadcrumbs-container--last-breadcrumb-inactive]=\"\n        _lastBreadcrumbInactive\n    \"\n    class=\"hive-breadcrumbs-container\"\n>\n    <ng-content\n        select=\"hive-breadcrumb-item,a[hive-breadcrumb-item]\"\n    ></ng-content>\n\n    <div\n        class=\"hive-breadcrumbs-menu-trigger\"\n        [menuRef]=\"menu\"\n        hiveMenuTrigger\n        shouldToggle\n    >\n        <a hive-link> \u2026 </a>\n        <span class=\"hive-breadcrumb-separator\">/</span>\n    </div>\n</div>\n\n<hive-menu class=\"hive-breadcrumb_menu\" #menu>\n    @for (\n        breadcrumb of breadcrumbsList$ | async | withoutFirstAndLast;\n        track trackByBreadcrumbId($index, breadcrumb)\n    ) {\n        <hive-menu-item\n            (click)=\"handleMenuItemClick(breadcrumb)\"\n            [disabled]=\"breadcrumb.disabled\"\n            [label]=\"breadcrumb.label\"\n        ></hive-menu-item>\n    }\n</hive-menu>\n", dependencies: [{ kind: "directive", type: MenuTriggerDirective, selector: "[hiveMenuTrigger]", inputs: ["hiveMenuTrigger", "menuRef"] }, { kind: "component", type: MenuComponent, selector: "hive-menu", inputs: ["position", "overlay", "offsetX", "offsetY", "closeOnMenuClick", "closeOnPageResize", "useContentPadding"], outputs: ["visibilityChange", "menuClick"], exportAs: ["hiveMenu"] }, { kind: "component", type: MenuItemComponent, selector: "hive-menu-item", inputs: ["label", "disabled", "destructive", "external"], outputs: ["menuItemClick"] }, { kind: "component", type: LinkComponent, selector: "a[hive-link]", inputs: ["disabled", "size", "external"] }, { kind: "component", type: BreadcrumbItemComponent, selector: "hive-breadcrumb-item,[hive-breadcrumb-item]", inputs: ["id", "label", "backLink", "disabled"], outputs: ["breadcrumbClick"] }, { kind: "pipe", type: i2$1.AsyncPipe, name: "async" }, { kind: "pipe", type: WithoutFirstAndLastPipe, name: "withoutFirstAndLast" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: BreadcrumbComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hive-breadcrumb', changeDetection: ChangeDetectionStrategy.OnPush, hostDirectives: [HiveThemedDirective], template: "<div #breadcrumbsHidden class=\"hive-breadcrumbs__hidden-items\">\n    @for (\n        breadcrumb of breadcrumbs;\n        track trackByBreadcrumbId(position, breadcrumb);\n        let position = $index\n    ) {\n        <hive-breadcrumb-item [label]=\"breadcrumb.label\"></hive-breadcrumb-item>\n    }\n</div>\n\n<div\n    [class.hive-breadcrumbs-container--overflowing]=\"isOverflowing$ | async\"\n    [class.hive-breadcrumbs-container--last-breadcrumb-inactive]=\"\n        _lastBreadcrumbInactive\n    \"\n    class=\"hive-breadcrumbs-container\"\n>\n    <ng-content\n        select=\"hive-breadcrumb-item,a[hive-breadcrumb-item]\"\n    ></ng-content>\n\n    <div\n        class=\"hive-breadcrumbs-menu-trigger\"\n        [menuRef]=\"menu\"\n        hiveMenuTrigger\n        shouldToggle\n    >\n        <a hive-link> \u2026 </a>\n        <span class=\"hive-breadcrumb-separator\">/</span>\n    </div>\n</div>\n\n<hive-menu class=\"hive-breadcrumb_menu\" #menu>\n    @for (\n        breadcrumb of breadcrumbsList$ | async | withoutFirstAndLast;\n        track trackByBreadcrumbId($index, breadcrumb)\n    ) {\n        <hive-menu-item\n            (click)=\"handleMenuItemClick(breadcrumb)\"\n            [disabled]=\"breadcrumb.disabled\"\n            [label]=\"breadcrumb.label\"\n        ></hive-menu-item>\n    }\n</hive-menu>\n" }]
        }], ctorParameters: () => [{ type: i0.ElementRef }], propDecorators: { breadcrumbClick: [{
                type: Output
            }], breadcrumbsHidden: [{
                type: ViewChild,
                args: ['breadcrumbsHidden', { static: true }]
            }], breadcrumbs: [{
                type: ContentChildren,
                args: [forwardRef(() => BreadcrumbItemComponent)]
            }], lastBreadcrumbInactive: [{
                type: Input
            }] } });

class BreadcrumbModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: BreadcrumbModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: BreadcrumbModule, declarations: [BreadcrumbItemComponent,
            BreadcrumbComponent,
            WithoutFirstAndLastPipe], imports: [CommonModule, MenuModule, LinkComponent, IconComponent], exports: [BreadcrumbItemComponent, BreadcrumbComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: BreadcrumbModule, imports: [CommonModule, MenuModule, LinkComponent, IconComponent] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: BreadcrumbModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        BreadcrumbItemComponent,
                        BreadcrumbComponent,
                        WithoutFirstAndLastPipe,
                    ],
                    imports: [CommonModule, MenuModule, LinkComponent, IconComponent],
                    exports: [BreadcrumbItemComponent, BreadcrumbComponent],
                }]
        }] });

/**
 * Button group is a collection of buttons that are grouped together and allow the user to select one of several actions.
 *
 * Use `<hive-button-group>` as a container for your own defined hive-buttons.
 * - These buttons must have `emphasis="tertiary"`, and be icon-only.
 * - To group buttons into subgroups, include `<hive-separator orientation="vertical"/>` between them.
 */
class ButtonGroupComponent {
    constructor() {
        this.size = 'small';
        this.destroy$ = new Subject();
    }
    ngAfterViewInit() {
        this.rawButtonGroupList.toArray().forEach((button) => {
            // Find any misconfigured hive-buttons
            if (button.icon == null ||
                button.label ||
                button.emphasis !== 'tertiary') {
                console.error('<hive-button-group> items should be icon-only with tertiary emphasis.\n', 'Misconfigured element: ', button);
            }
        });
        this.updateButtonsSize();
        this.rawButtonGroupList?.changes
            .pipe(takeUntil(this.destroy$))
            .subscribe((_) => this.updateButtonsSize());
    }
    ngOnChanges(changes) {
        if (changes['size']) {
            this.updateButtonsSize();
        }
    }
    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
    updateButtonsSize() {
        this.rawButtonGroupList
            ?.toArray()
            ?.forEach((b) => (b.size = this.size));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ButtonGroupComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: ButtonGroupComponent, isStandalone: true, selector: "hive-button-group", inputs: { size: "size" }, queries: [{ propertyName: "rawButtonGroupList", predicate: ButtonComponent }], usesOnChanges: true, hostDirectives: [{ directive: HiveThemedDirective }], ngImport: i0, template: "<!-- Hive Button Group component -->\n<div\n    class=\"hive-button-group-container\"\n    [ngClass]=\"'hive-button-group-container--' + size\"\n>\n    <ng-content\n        select=\"hive-button[icon]:not([label])[emphasis='tertiary'], hive-separator[orientation=vertical]\"\n    ></ng-content>\n</div>\n", dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i2$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ButtonGroupComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hive-button-group', standalone: true, imports: [CommonModule, ButtonComponent], changeDetection: ChangeDetectionStrategy.OnPush, hostDirectives: [HiveThemedDirective], template: "<!-- Hive Button Group component -->\n<div\n    class=\"hive-button-group-container\"\n    [ngClass]=\"'hive-button-group-container--' + size\"\n>\n    <ng-content\n        select=\"hive-button[icon]:not([label])[emphasis='tertiary'], hive-separator[orientation=vertical]\"\n    ></ng-content>\n</div>\n" }]
        }], propDecorators: { rawButtonGroupList: [{
                type: ContentChildren,
                args: [ButtonComponent]
            }], size: [{
                type: Input
            }] } });

/**
 * Collapsable entity wrapper. Generalized component to be used in accordions and other similar things
 *
 * @example:
 *  <hive-collapsable-item>
 *      <header>Click me to expand</header>
 *      <div>Content</div>
 *  </hive-collapsable-item>
 */
class CollapsableItemComponent {
    constructor() {
        /**
         * Makes the text inside item to be gray and switches of it's controls
         */
        this.disabled = false;
        /**
         * Makes component non-interactive but doesn't visually influences it
         */
        this.nonInteractive = false;
        /**
         * Set the expansion state
         */
        this.expanded = false;
        /**
         * Whenever element is toggled - isOpenChange emitted
         */
        this.expandedChange = new EventEmitter();
        this.changeDetectorRef = inject(ChangeDetectorRef);
    }
    get _expanded() {
        return this.detailsElement.nativeElement.open;
    }
    set _expanded(value) {
        this.detailsElement.nativeElement.open = value;
    }
    ngOnChanges(changes) {
        if ('expanded' in changes) {
            this._expanded = this.expanded;
        }
    }
    ngAfterViewInit() {
        this._expanded = this.expanded;
    }
    handleClick(_) {
        if ([!this.disabled, !this.nonInteractive].every((x) => x)) {
            this._expanded = !this._expanded;
            this.expandedChange.emit(this._expanded);
            this.changeDetectorRef.markForCheck();
        }
    }
    handleDetailsClick(event) {
        event.preventDefault();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CollapsableItemComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "16.1.0", version: "17.3.12", type: CollapsableItemComponent, isStandalone: true, selector: "hive-collapsable-item", inputs: { disabled: ["disabled", "disabled", booleanAttribute], nonInteractive: ["nonInteractive", "nonInteractive", booleanAttribute], expanded: ["expanded", "expanded", booleanAttribute] }, outputs: { expandedChange: "expandedChange" }, viewQueries: [{ propertyName: "detailsElement", first: true, predicate: ["detailsElement"], descendants: true, static: true }], usesOnChanges: true, ngImport: i0, template: `
        <details
            #detailsElement
            (click)="handleDetailsClick($event)"
            [class.hive-collapsable-item--disabled]="disabled"
            [class.hive-collapsable-item--non-interactive]="nonInteractive"
            class="hive-collapsable-item"
        >
            <summary (click)="handleClick($event)">
                <ng-content select="header" />
            </summary>
            <div class="content">
                <ng-content />
            </div>
        </details>
    `, isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CollapsableItemComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'hive-collapsable-item',
                    standalone: true,
                    template: `
        <details
            #detailsElement
            (click)="handleDetailsClick($event)"
            [class.hive-collapsable-item--disabled]="disabled"
            [class.hive-collapsable-item--non-interactive]="nonInteractive"
            class="hive-collapsable-item"
        >
            <summary (click)="handleClick($event)">
                <ng-content select="header" />
            </summary>
            <div class="content">
                <ng-content />
            </div>
        </details>
    `,
                    imports: [ChevronDirective, IconComponent],
                }]
        }], propDecorators: { disabled: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], nonInteractive: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], expanded: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], expandedChange: [{
                type: Output
            }], detailsElement: [{
                type: ViewChild,
                args: ['detailsElement', { static: true }]
            }] } });

/**
 * Cards allow for visual grouping of elements that are tied to each other (tables, informational, appliances).
 */
class CardComponent {
    constructor() {
        /**
         * Makes the card interactive (clickable)
         */
        this.interactive = false;
        /**
         * Disables the Card
         */
        this.disabled = false;
        /**
         * Makes the Card selected
         */
        this.selected = false;
        /**
         * Fires when the Card is clicked, works only for interactive cards
         */
        this.cardClick = new EventEmitter();
    }
    handleMenuClick() {
        if (this.interactive && !this.disabled) {
            this.cardClick?.emit();
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CardComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "16.1.0", version: "17.3.12", type: CardComponent, isStandalone: true, selector: "hive-card", inputs: { interactive: ["interactive", "interactive", booleanAttribute], disabled: ["disabled", "disabled", booleanAttribute], selected: ["selected", "selected", booleanAttribute] }, outputs: { cardClick: "cardClick" }, hostDirectives: [{ directive: HiveThemedDirective }], ngImport: i0, template: "<div\n    class=\"hive-card\"\n    [class.hive-card--interactive]=\"interactive\"\n    [class.hive-card--disabled]=\"disabled\"\n    [class.hive-card--selected]=\"selected\"\n    [attr.tabindex]=\"interactive && !disabled ? 0 : null\"\n    (click)=\"handleMenuClick()\"\n    (keydown.enter)=\"handleMenuClick()\"\n>\n    <ng-content></ng-content>\n</div>\n", changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CardComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hive-card', standalone: true, imports: [], changeDetection: ChangeDetectionStrategy.OnPush, hostDirectives: [HiveThemedDirective], template: "<div\n    class=\"hive-card\"\n    [class.hive-card--interactive]=\"interactive\"\n    [class.hive-card--disabled]=\"disabled\"\n    [class.hive-card--selected]=\"selected\"\n    [attr.tabindex]=\"interactive && !disabled ? 0 : null\"\n    (click)=\"handleMenuClick()\"\n    (keydown.enter)=\"handleMenuClick()\"\n>\n    <ng-content></ng-content>\n</div>\n" }]
        }], propDecorators: { interactive: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], disabled: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], selected: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], cardClick: [{
                type: Output
            }] } });

// Because the chip can already be set to a state (error, selected, etc.) on
// initialization, we need to explicitly set the color for all parts of
// the chip - the container, the property section, and the value section.
const chipAnimationMetadata = [
    group([
        // Animation for hive-chip-container
        query('.hive-chip-container', [
            animate('0.3s ease-in', style({
                'border-color': HIVE_BORDER_SUCCESS_BOLD,
            })),
            animate('3s', style({
                'border-color': HIVE_BORDER_SUCCESS_BOLD,
            })),
            animate('0.3s ease-out', style({})),
        ]),
        // Animation for hive-chip-property-container
        query('.hive-chip-property-container', [
            animate('0.3s ease-in', style({
                background: HIVE_BORDER_NEUTRAL_SUBTLE,
            })),
            animate('3s', style({
                background: HIVE_BORDER_NEUTRAL_SUBTLE,
            })),
            animate('0.3s ease-out', style({})),
        ], { optional: true }),
        // Animation for hive-chip-property-icon
        query('.hive-chip-property-icon', [
            animate('0.3s ease-in', style({
                fill: HIVE_TEXT_ONNEUTRAL_PRIMARY,
            })),
            animate('3s', style({
                fill: HIVE_TEXT_ONNEUTRAL_PRIMARY,
            })),
            animate('0.3s ease-out', style({})),
        ], { optional: true }),
        // Animation for hive-chip-property-text
        query('.hive-chip-property-text', [
            animate('0.3s ease-in', style({
                color: HIVE_TEXT_ONNEUTRAL_PRIMARY,
            })),
            animate('3s', style({
                color: HIVE_TEXT_ONNEUTRAL_PRIMARY,
            })),
            animate('0.3s ease-out', style({})),
        ], { optional: true }),
        // Animation for hive-chip-value-container
        query('.hive-chip-value-container', [
            animate('0.3s ease-in', style({
                background: HIVE_BACKGROUND_SUCCESS_SUBTLEST,
            })),
            animate('3s', style({
                background: HIVE_BACKGROUND_SUCCESS_SUBTLEST,
            })),
            animate('0.3s ease-out', style({})),
        ]),
        // Animation for hive-chip-value-text
        query('.hive-chip-value-text', [
            animate('0.3s ease-in', style({
                color: HIVE_TEXT_ONSUCCESS,
            })),
            animate('3s', style({
                color: HIVE_TEXT_ONSUCCESS,
            })),
            animate('0.3s ease-out', style({})),
        ]),
    ]),
];
// Animation for hive-chip-value-close-button
const chipCloseButtonAnimationMetadata = query('.hive-chip-value-close-button', [
    animate('0.3s ease-in', style({
        fill: HIVE_TEXT_ONSUCCESS,
    })),
    animate('3s', style({
        fill: HIVE_TEXT_ONSUCCESS,
    })),
    animate('0.3s ease-out', style({})),
]);

function chipSizeAttribute(value) {
    return oneOfOrDefault(value, 'small', 'small', 'smallest');
}
/**
 * Chips allow users to enter information, make selections, filter, or perform actions.
 *
 * A chip has multiple states, some of which can overlap. A chip can be selectable, have an error state,
 * or be disabled. It can also display an emphasis animation when it is first created, to draw
 * attention to itself as a new element for the user.
 *
 * A chip can display a key-value pair, or just a value. If only an icon is needed, consider using
 * the `BadgeComponent` instead.
 */
class ChipComponent {
    constructor(animationBuilder, elementRef, cdr) {
        this.animationBuilder = animationBuilder;
        this.elementRef = elementRef;
        this.cdr = cdr;
        /**
         * Size of the chip. The smallest size is needed for smaller
         * dropdowns that contain a chip.
         *
         * @default 'small'
         */
        this.size = 'small';
        /**
         * @default false
         * If true, the chip can be selected, and emits a `selectedChange` event.
         */
        this.selectable = false;
        /**
         * @default false
         * If true, the chip is disabled. A disabled chip cannot be selected or closed.
         */
        this.disabled = false;
        /**
         * `tabindex` attribute for the chip, to allow for keyboard navigation.
         *
         * @see {@link HTMLInputElement.prototype#tabindex}
         */
        this.tabindex = 0;
        /**
         * @default false
         * If true, the chip displays a close icon, and emits
         * a `chipClose` event when clicked.
         */
        this.closable = false;
        /**
         * @default false
         * If true, the chip is considered selected.
         */
        this.selected = false;
        /**
         * @default false
         * Sets the chip to display an error state.
         */
        this.hasError = false;
        /**
         * @default false
         * @deprecated Use `highlightNewChip` instead
         * If true, the chip displays an emphasis animation when created. Specifically,
         * the animation is triggered during the AfterViewInit lifecycle hook.
         * Note: once the animation is complete, the animation is destroyed and
         * showNewChipAnimation is set to false internally.
         */
        this.showNewChipAnimation = false;
        /**
         * @default false
         * If true, the chip displays an emphasis animation when created. Specifically,
         * the animation is triggered during the AfterViewInit lifecycle hook.
         * Note: once the animation is complete, the animation is destroyed and
         * showNewChipAnimation is set to false internally.
         */
        this.highlightNewChip = false;
        /**
         * Emits when the chip is clicked.
         */
        this.chipClose = new EventEmitter();
        /**
         * Emits current state of `selected`.
         */
        this.selectedChange = new EventEmitter();
    }
    ngAfterViewInit() {
        const animation = [...chipAnimationMetadata];
        if (this.closable) {
            animation.push(chipCloseButtonAnimationMetadata);
        }
        this._animationPlayer = this.animationBuilder
            .build(animation)
            .create(this.elementRef.nativeElement);
        // A little unintuitive, but needed to ensure that the animation is destroyed
        // after the first run. Otherwise, it will prevent the hover effect from
        // ever being applied.
        this._animationPlayer.onDone(() => {
            this.endAnimation();
        });
        if (this.showNewChipAnimation || this.highlightNewChip) {
            this._animationPlayer.play();
        }
    }
    handleClick() {
        this.endAnimation();
        if (!this.disabled && this.selectable) {
            this.selected = !this.selected;
            this.selectedChange.emit(this.selected);
            this.cdr.detectChanges();
        }
    }
    endAnimation() {
        if (this.selectable && (this.showNewChipAnimation || this.highlightNewChip)) {
            this._animationPlayer?.destroy();
            this.showNewChipAnimation = false;
            this.highlightNewChip = false;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ChipComponent, deps: [{ token: i1$4.AnimationBuilder }, { token: i0.ElementRef }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.3.12", type: ChipComponent, isStandalone: true, selector: "hive-chip", inputs: { icon: ["icon", "icon", stringOrUndefinedAttribute], size: ["size", "size", chipSizeAttribute], property: ["property", "property", stringOrUndefinedAttribute], value: ["value", "value", stringAttribute], selectable: ["selectable", "selectable", booleanAttribute], disabled: ["disabled", "disabled", booleanAttribute], tabindex: ["tabindex", "tabindex", numberAttribute], closable: ["closable", "closable", booleanAttribute], selected: ["selected", "selected", booleanAttribute], hasError: ["hasError", "hasError", booleanAttribute], showNewChipAnimation: ["showNewChipAnimation", "showNewChipAnimation", booleanAttribute], highlightNewChip: ["highlightNewChip", "highlightNewChip", booleanAttribute] }, outputs: { chipClose: "chipClose", selectedChange: "selectedChange" }, hostDirectives: [{ directive: HiveThemedDirective }], ngImport: i0, template: "<div\n    class=\"hive-chip-container\"\n    (mouseenter)=\"endAnimation()\"\n    [ngClass]=\"{\n        'hive-chip-container--disabled': disabled,\n        'hive-chip-container--selected': selectable && selected,\n        'hive-chip-container--error': hasError,\n        'hive-chip-container--hoverable': selectable,\n        'hive-chip-container--smallest': size === 'smallest',\n    }\"\n    [tabindex]=\"tabindex\"\n    (keydown.space)=\"handleClick()\"\n    (click)=\"handleClick()\"\n>\n    <div class=\"hive-chip-property-container\">\n        @if (icon | isDefined) {\n            <hive-icon-component\n                class=\"hive-chip-property-icon\"\n                [icon]=\"icon\"\n                [size]=\"size\"\n            ></hive-icon-component>\n        }\n        @if (property | isDefined) {\n            <hive-label\n                class=\"hive-chip-property-text\"\n                weight=\"semibold\"\n                [size]=\"size\"\n                [label]=\"property\"\n            ></hive-label>\n        }\n    </div>\n\n    <div class=\"hive-chip-value-container\">\n        <hive-label\n            class=\"hive-chip-value-text\"\n            weight=\"regular\"\n            [size]=\"size\"\n            [label]=\"value\"\n        />\n\n        @if (closable) {\n            <hive-icon-component\n                class=\"hive-chip-value-close-button\"\n                icon=\"light/xmark.svg\"\n                [size]=\"size\"\n                (click)=\"$event.stopPropagation(); chipClose.emit($event)\"\n            />\n        }\n    </div>\n</div>\n", dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i2$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "component", type: IconComponent, selector: "hive-icon-component", inputs: ["icon", "size"] }, { kind: "component", type: LabelComponent, selector: "hive-label", inputs: ["label", "for", "size", "weight", "maxWeight", "horizontalAlignment", "leftIconHelpInfoMessage", "rightIconHelpInfoMessage", "leftIcon", "rightIcon", "required", "textOverflowEllipsis"] }, { kind: "pipe", type: IsDefinedPipe, name: "isDefined" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ChipComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hive-chip', standalone: true, imports: [CommonModule, IconComponent, LabelComponent, IsDefinedPipe], changeDetection: ChangeDetectionStrategy.OnPush, hostDirectives: [HiveThemedDirective], template: "<div\n    class=\"hive-chip-container\"\n    (mouseenter)=\"endAnimation()\"\n    [ngClass]=\"{\n        'hive-chip-container--disabled': disabled,\n        'hive-chip-container--selected': selectable && selected,\n        'hive-chip-container--error': hasError,\n        'hive-chip-container--hoverable': selectable,\n        'hive-chip-container--smallest': size === 'smallest',\n    }\"\n    [tabindex]=\"tabindex\"\n    (keydown.space)=\"handleClick()\"\n    (click)=\"handleClick()\"\n>\n    <div class=\"hive-chip-property-container\">\n        @if (icon | isDefined) {\n            <hive-icon-component\n                class=\"hive-chip-property-icon\"\n                [icon]=\"icon\"\n                [size]=\"size\"\n            ></hive-icon-component>\n        }\n        @if (property | isDefined) {\n            <hive-label\n                class=\"hive-chip-property-text\"\n                weight=\"semibold\"\n                [size]=\"size\"\n                [label]=\"property\"\n            ></hive-label>\n        }\n    </div>\n\n    <div class=\"hive-chip-value-container\">\n        <hive-label\n            class=\"hive-chip-value-text\"\n            weight=\"regular\"\n            [size]=\"size\"\n            [label]=\"value\"\n        />\n\n        @if (closable) {\n            <hive-icon-component\n                class=\"hive-chip-value-close-button\"\n                icon=\"light/xmark.svg\"\n                [size]=\"size\"\n                (click)=\"$event.stopPropagation(); chipClose.emit($event)\"\n            />\n        }\n    </div>\n</div>\n" }]
        }], ctorParameters: () => [{ type: i1$4.AnimationBuilder }, { type: i0.ElementRef }, { type: i0.ChangeDetectorRef }], propDecorators: { icon: [{
                type: Input,
                args: [{ transform: stringOrUndefinedAttribute }]
            }], size: [{
                type: Input,
                args: [{ transform: chipSizeAttribute }]
            }], property: [{
                type: Input,
                args: [{ transform: stringOrUndefinedAttribute }]
            }], value: [{
                type: Input,
                args: [{ transform: stringAttribute, required: true }]
            }], selectable: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], disabled: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], tabindex: [{
                type: Input,
                args: [{ transform: numberAttribute }]
            }], closable: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], selected: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], hasError: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], showNewChipAnimation: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], highlightNewChip: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], chipClose: [{
                type: Output
            }], selectedChange: [{
                type: Output
            }] } });

/**
 * Dropdown component uses `SelectionMenuComponent` internally.
 * This is why `<hive-selection-menu-item>` and `<hive-selection-menu-section>`
 * are used as child components.
 *
 * @example
 * <hive-dropdown
 *    [label]="label"
 *    [(selection)]="selection"
 * >
 *     <hive-selection-menu-item
 *         *ngFor="let item of items"
 *         [value]="item.value"
 *         [label]="item.label"
 *         [disabled]="item.isDisabled"
 *     ></hive-selection-menu-item>
 * </hive-dropdown>
 *
 * Dropdown supports form API.
 *
 * @example
 * <hive-dropdown
 *    [label]="label"
 *    [(ngModel)]="ngModel"
 * >
 *     <hive-selection-menu-item
 *         *ngFor="let item of items"
 *         [value]="item.value"
 *         [label]="item.label"
 *         [disabled]="item.isDisabled"
 *     ></hive-selection-menu-item>
 * </hive-dropdown>
 *
 * @example
 * <form [formGroup]="formGroup">
 *     <hive-dropdown
 *        [label]="label"
 *        [formControl]="formControl"
 *     >
 *         <hive-selection-menu-item
 *             *ngFor="let item of items"
 *             [value]="item.value"
 *             [label]="item.label"
 *             [disabled]="item.isDisabled"
 *         ></hive-selection-menu-item>
 *     </hive-dropdown>
 * </form>
 */
class DropdownComponent {
    ngOnInit() {
        this.injector
            .get(NgControl, null, {
            optional: true,
        })
            ?.control?.statusChanges.pipe(safeTakeUntilDestroyed(this.destroyRef))
            .subscribe(() => {
            this.cdr.markForCheck();
        });
    }
    ngOnChanges(changes) {
        if ('selection' in changes) {
            this._selection$.next(changes['selection'].currentValue);
        }
        if ('disabled' in changes) {
            this.disabled$.next(changes['disabled'].currentValue);
        }
    }
    constructor(formComponentValidity, destroyRef, cdr, injector) {
        this.formComponentValidity = formComponentValidity;
        this.destroyRef = destroyRef;
        this.cdr = cdr;
        this.injector = injector;
        /**
         * The size which is applied to the form-field.
         */
        this.size = 'medium';
        /**
         * Whether the dropdown has filter input.
         */
        this.hasFilter = false;
        /**
         * Defines debounce wait time for the filter input.
         *
         * If `null`, default value is used.
         *
         * @default 300
         *
         * @see DebounceChangeDirective.debounceWait
         */
        this.debounceWait = null;
        // region states
        /**
         * Whether the selection panel is in error state.
         */
        this.hasLoadingError = false;
        /**
         * Whether the selection panel is in loading state.
         */
        this.isLoading = false;
        /**
         * Whether the component is disabled.
         */
        this.disabled = false;
        /**
         * Displays an asterisk to the right of the form-input label.
         *
         * Does not have any effect outside the forms API.
         */
        this.required = false;
        /**
         * The icon is displayed next to the label.
         * Shows a help message when hovered.
         */
        this.helpInfoIcon = 'info';
        /**
         * Defines whether the filter input should be autofocused when selection menu is opened.
         *
         * @default true
         */
        this.hasFilterAutofocus = true;
        // region events
        /**
         * Emits when a user clicks on the link which is displayed when the
         * selection-menu is in error state.
         */
        this.tryAgainClick = new EventEmitter();
        /**
         * Emits when a user changes selection, i.e., clicks on an item.
         */
        this.selectionChange = new EventEmitter();
        // endregion
        /**
         * Emits when a user types in the filter input.
         */
        this.filterChange = new EventEmitter();
        this.dropdownSelectionMenuItems = new QueryList();
        this.dropdownContent = new QueryList();
        // endregion
        this.isOverlayVisible = false;
        this.dropdownItems$ = new BehaviorSubject([]);
        this._selection$ = new BehaviorSubject(null);
        this.disabled$ = new BehaviorSubject(false);
        this._id = uniqueId$1('hive-dropdown--');
        this.selectedLabel$ = combineLatest([
            this.dropdownItems$,
            this._selection$,
        ]).pipe(map(([items, selection]) => items.find((item) => item.value === selection)?.label ??
            undefined));
        this.selectionMenuItemSelection$ = this._selection$.pipe(map((selection) => selection instanceof Array ? selection : [selection]));
        // region ControlValueAccessor
        /**
         * @internal
         */
        this.onModelChange = () => { };
        /**
         * @internal
         */
        this.onModelTouch = () => { };
    }
    ngAfterContentInit() {
        this.dropdownSelectionMenuItems.changes
            .pipe(startWith$1(null), map(() => this.dropdownSelectionMenuItems.toArray()), safeTakeUntilDestroyed(this.destroyRef))
            .subscribe((items) => {
            this.dropdownItems$.next(items);
        });
        merge(this._selection$, this.disabled$)
            .pipe(startWith$1(null), safeTakeUntilDestroyed(this.destroyRef))
            .subscribe(() => {
            this.dropdownSelectionMenuItems.notifyOnChanges();
        });
    }
    /**
     * User interaction handler.
     *
     * @internal
     */
    handleSelectionChange(event) {
        const selection = event.selection[0];
        this._selection$.next(selection);
        this.onModelChange(selection);
        this.selectionChange.emit(selection);
        this.selectionListOverlay?.hideOverlay();
    }
    /**
     * @internal
     */
    handleVisibilityChange(isVisible) {
        this.isOverlayVisible = isVisible;
        if (isVisible) {
            this.selectionMenu?.initFocusKeyManager();
        }
        // `onModelTouch` is called here because if `onModelTouch`
        // is attached to `<input />` trigger, it is called before `onModelChange`,
        // thus making the component become invalid for a moment,
        // blinking red, which annoying and uncomfortable for eyes.
        if (!this.isOverlayVisible) {
            this.onModelTouch();
        }
        if (this.isOverlayVisible && this.hasFilterAutofocus) {
            this.selectionMenu?.focusFilter();
        }
    }
    /**
     * @internal
     */
    writeValue(value) {
        this._selection$.next(value);
    }
    /**
     * @internal
     */
    registerOnChange(fn) {
        this.onModelChange = fn;
    }
    /**
     * @internal
     */
    registerOnTouched(fn) {
        this.onModelTouch = fn;
    }
    /**
     * @internal
     */
    setDisabledState(isDisabled) {
        this.disabled$.next(isDisabled);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DropdownComponent, deps: [{ token: FormComponentValidityDirective }, { token: i0.DestroyRef }, { token: i0.ChangeDetectorRef }, { token: i0.Injector }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.3.12", type: DropdownComponent, selector: "hive-dropdown", inputs: { selection: "selection", size: "size", hasFilter: ["hasFilter", "hasFilter", booleanAttribute], debounceWait: "debounceWait", hasLoadingError: ["hasLoadingError", "hasLoadingError", booleanAttribute], isLoading: ["isLoading", "isLoading", booleanAttribute], disabled: ["disabled", "disabled", booleanAttribute], label: "label", required: ["required", "required", booleanAttribute], helpInfoIcon: "helpInfoIcon", helpInfoMessage: "helpInfoMessage", errorMessages: "errorMessages", assistanceText: "assistanceText", placeholder: "placeholder", hasFilterAutofocus: ["hasFilterAutofocus", "hasFilterAutofocus", booleanAttribute] }, outputs: { tryAgainClick: "tryAgainClick", selectionChange: "selectionChange", filterChange: "filterChange" }, providers: [
            SELECTION_MENU_PROVIDER,
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => DropdownComponent),
                multi: true,
            },
        ], queries: [{ propertyName: "dropdownSelectionMenuItems", predicate: (SelectionMenuItemComponent), descendants: true }, { propertyName: "dropdownContent", predicate: SELECTION_MENU_CONTENT, descendants: true }], viewQueries: [{ propertyName: "selectionListOverlay", first: true, predicate: ["selectionMenuOverlay"], descendants: true }, { propertyName: "selectionMenu", first: true, predicate: ["selectionMenu"], descendants: true }], usesOnChanges: true, hostDirectives: [{ directive: HiveThemedDirective }, { directive: FormComponentValidityDirective }], ngImport: i0, template: "<hive-form-input-base\n    [for]=\"_id\"\n    [label]=\"label\"\n    [required]=\"formComponentValidity.required || required\"\n    [helpInfoIcon]=\"helpInfoIcon\"\n    [helpInfoMessage]=\"helpInfoMessage\"\n    [errorMessages]=\"errorMessages\"\n    [hasError]=\"formComponentValidity.invalid\"\n    [assistanceText]=\"assistanceText\"\n    [disabled]=\"disabled$ | async\"\n>\n    <div class=\"hive-dropdown_container\">\n        <div\n            class=\"hive-dropdown_trigger-container\"\n            [class.hive-dropdown_trigger-container--disabled]=\"\n                disabled$ | async\n            \"\n        >\n            <input\n                type=\"text\"\n                readonly\n                shouldToggle\n                class=\"hive-dropdown_trigger\"\n                [id]=\"_id\"\n                [ngClass]=\"'hive-dropdown_trigger--' + size\"\n                [class.hive-dropdown_trigger--invalid]=\"\n                    formComponentValidity.invalid\n                \"\n                [hiveOverlayTrigger]=\"selectionMenuOverlay\"\n                [attr.aria-invalid]=\"formComponentValidity.invalid\"\n                [attr.value]=\"selectedLabel$ | async\"\n                [attr.placeholder]=\"placeholder\"\n                [attr.disabled]=\"(disabled$ | async) || null\"\n            />\n\n            <div\n                class=\"hive-dropdown_icon-container\"\n                [ngClass]=\"'hive-dropdown_icon-container--' + size\"\n            >\n                @if (formComponentValidity.invalid) {\n                    <hive-icon-component\n                        class=\"hive-dropdown_error-icon\"\n                        icon=\"light/circle-exclamation.svg\"\n                        size=\"medium\"\n                    ></hive-icon-component>\n                }\n\n                <hive-icon-component\n                    hiveChevron\n                    class=\"hive-dropdown_trigger-icon\"\n                    [rotated]=\"isOverlayVisible\"\n                    size=\"medium\"\n                    icon=\"light/chevron-down.svg\"\n                ></hive-icon-component>\n            </div>\n        </div>\n    </div>\n</hive-form-input-base>\n\n<hive-overlay\n    #selectionMenuOverlay\n    takeWidthFromTrigger\n    closeOnPageResize\n    (visibilityChange)=\"handleVisibilityChange($event)\"\n>\n    <hive-selection-menu\n        #selectionMenu\n        class=\"hive-dropdown_selection-menu\"\n        [selectionItems]=\"$any(dropdownItems$ | async)\"\n        [selectionContent]=\"dropdownContent.toArray()\"\n        [selection]=\"selectionMenuItemSelection$ | async\"\n        [hasFilter]=\"hasFilter\"\n        [multiselect]=\"false\"\n        [hasLoadingError]=\"hasLoadingError\"\n        [isLoading]=\"isLoading\"\n        [debounceWait]=\"debounceWait\"\n        (selectionChange)=\"handleSelectionChange($event)\"\n        (tryAgainClick)=\"tryAgainClick.emit()\"\n        (filterChange)=\"filterChange.emit($event)\"\n    >\n        <ng-container\n            ngProjectAs=\"hive-selection-menu-item, hive-selection-menu-section, ng-container\"\n        >\n            <ng-content\n                select=\"hive-selection-menu-item, hive-selection-menu-section, ng-container\"\n            ></ng-content>\n        </ng-container>\n    </hive-selection-menu>\n</hive-overlay>\n", dependencies: [{ kind: "directive", type: i2$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "component", type: SelectionMenuComponent, selector: "hive-selection-menu", inputs: ["selectionItems", "selectionContent", "hasFilter", "multiselect", "hasLoadingError", "isLoading", "debounceWait", "hideSeparators", "selection"], outputs: ["selectionChange", "tryAgainClick", "filterChange"] }, { kind: "component", type: FormInputBaseComponent, selector: "hive-form-input-base", inputs: ["label", "for", "required", "disabled", "helpInfoIcon", "helpInfoMessage", "errorMessages", "hasError", "assistanceText", "horizontalAlignment", "increasedContentGap"] }, { kind: "component", type: IconComponent, selector: "hive-icon-component", inputs: ["icon", "size"] }, { kind: "directive", type: OverlayTriggerDirective, selector: "[hiveOverlayTrigger]", inputs: ["disabled", "hiveOverlayTrigger", "shouldToggle"] }, { kind: "component", type: OverlayComponent, selector: "hive-overlay", inputs: ["takeWidthFromTrigger", "closeOnPageResize", "panelClass", "backdropClass", "position", "offsetX", "offsetY", "closeOnBackdropClick", "closeOnOutsideClick", "hasBackdrop", "overlayMinWidth"], outputs: ["visibilityChange"] }, { kind: "directive", type: ChevronDirective, selector: "hive-icon-component[hiveChevron]", inputs: ["rotationDirection", "rotated"] }, { kind: "pipe", type: i2$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DropdownComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hive-dropdown', providers: [
                        SELECTION_MENU_PROVIDER,
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => DropdownComponent),
                            multi: true,
                        },
                    ], changeDetection: ChangeDetectionStrategy.OnPush, hostDirectives: [HiveThemedDirective, FormComponentValidityDirective], template: "<hive-form-input-base\n    [for]=\"_id\"\n    [label]=\"label\"\n    [required]=\"formComponentValidity.required || required\"\n    [helpInfoIcon]=\"helpInfoIcon\"\n    [helpInfoMessage]=\"helpInfoMessage\"\n    [errorMessages]=\"errorMessages\"\n    [hasError]=\"formComponentValidity.invalid\"\n    [assistanceText]=\"assistanceText\"\n    [disabled]=\"disabled$ | async\"\n>\n    <div class=\"hive-dropdown_container\">\n        <div\n            class=\"hive-dropdown_trigger-container\"\n            [class.hive-dropdown_trigger-container--disabled]=\"\n                disabled$ | async\n            \"\n        >\n            <input\n                type=\"text\"\n                readonly\n                shouldToggle\n                class=\"hive-dropdown_trigger\"\n                [id]=\"_id\"\n                [ngClass]=\"'hive-dropdown_trigger--' + size\"\n                [class.hive-dropdown_trigger--invalid]=\"\n                    formComponentValidity.invalid\n                \"\n                [hiveOverlayTrigger]=\"selectionMenuOverlay\"\n                [attr.aria-invalid]=\"formComponentValidity.invalid\"\n                [attr.value]=\"selectedLabel$ | async\"\n                [attr.placeholder]=\"placeholder\"\n                [attr.disabled]=\"(disabled$ | async) || null\"\n            />\n\n            <div\n                class=\"hive-dropdown_icon-container\"\n                [ngClass]=\"'hive-dropdown_icon-container--' + size\"\n            >\n                @if (formComponentValidity.invalid) {\n                    <hive-icon-component\n                        class=\"hive-dropdown_error-icon\"\n                        icon=\"light/circle-exclamation.svg\"\n                        size=\"medium\"\n                    ></hive-icon-component>\n                }\n\n                <hive-icon-component\n                    hiveChevron\n                    class=\"hive-dropdown_trigger-icon\"\n                    [rotated]=\"isOverlayVisible\"\n                    size=\"medium\"\n                    icon=\"light/chevron-down.svg\"\n                ></hive-icon-component>\n            </div>\n        </div>\n    </div>\n</hive-form-input-base>\n\n<hive-overlay\n    #selectionMenuOverlay\n    takeWidthFromTrigger\n    closeOnPageResize\n    (visibilityChange)=\"handleVisibilityChange($event)\"\n>\n    <hive-selection-menu\n        #selectionMenu\n        class=\"hive-dropdown_selection-menu\"\n        [selectionItems]=\"$any(dropdownItems$ | async)\"\n        [selectionContent]=\"dropdownContent.toArray()\"\n        [selection]=\"selectionMenuItemSelection$ | async\"\n        [hasFilter]=\"hasFilter\"\n        [multiselect]=\"false\"\n        [hasLoadingError]=\"hasLoadingError\"\n        [isLoading]=\"isLoading\"\n        [debounceWait]=\"debounceWait\"\n        (selectionChange)=\"handleSelectionChange($event)\"\n        (tryAgainClick)=\"tryAgainClick.emit()\"\n        (filterChange)=\"filterChange.emit($event)\"\n    >\n        <ng-container\n            ngProjectAs=\"hive-selection-menu-item, hive-selection-menu-section, ng-container\"\n        >\n            <ng-content\n                select=\"hive-selection-menu-item, hive-selection-menu-section, ng-container\"\n            ></ng-content>\n        </ng-container>\n    </hive-selection-menu>\n</hive-overlay>\n" }]
        }], ctorParameters: () => [{ type: FormComponentValidityDirective }, { type: i0.DestroyRef }, { type: i0.ChangeDetectorRef }, { type: i0.Injector }], propDecorators: { selection: [{
                type: Input
            }], size: [{
                type: Input
            }], hasFilter: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], debounceWait: [{
                type: Input
            }], hasLoadingError: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], isLoading: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], disabled: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], label: [{
                type: Input
            }], required: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], helpInfoIcon: [{
                type: Input
            }], helpInfoMessage: [{
                type: Input
            }], errorMessages: [{
                type: Input
            }], assistanceText: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], hasFilterAutofocus: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], tryAgainClick: [{
                type: Output
            }], selectionChange: [{
                type: Output
            }], filterChange: [{
                type: Output
            }], selectionListOverlay: [{
                type: ViewChild,
                args: ['selectionMenuOverlay']
            }], selectionMenu: [{
                type: ViewChild,
                args: ['selectionMenu']
            }], dropdownSelectionMenuItems: [{
                type: ContentChildren,
                args: [(SelectionMenuItemComponent), { descendants: true }]
            }], dropdownContent: [{
                type: ContentChildren,
                args: [SELECTION_MENU_CONTENT, { descendants: true }]
            }] } });

class NonNullPipe {
    transform(value) {
        return value;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NonNullPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: NonNullPipe, isStandalone: true, name: "nonNull" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NonNullPipe, decorators: [{
            type: Pipe,
            args: [{ name: 'nonNull', standalone: true }]
        }] });

/**
 * Selection Menu Section component is used to separate selection menu items.
 *
 * @example
 * <hive-selection-menu-section label="Section"></hive-selection-menu-section>
 */
class SelectionMenuSectionComponent {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SelectionMenuSectionComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: SelectionMenuSectionComponent, selector: "hive-selection-menu-section", inputs: { label: "label" }, providers: [
            {
                provide: SELECTION_MENU_CONTENT,
                useExisting: SelectionMenuSectionComponent,
            },
        ], hostDirectives: [{ directive: HiveThemedDirective }], ngImport: i0, template: `
        <div class="hive-selection-menu-section_wrapper">
            <hive-label
                class="hive-selection-menu-section_label"
                size="small"
                weight="semibold"
                [label]="label"
            ></hive-label>
        </div>

        <ng-content
            select="
                hive-selection-menu-item,
                hive-selection-menu-group-item,
                ng-container
            "
        />
    `, isInline: true, dependencies: [{ kind: "component", type: LabelComponent, selector: "hive-label", inputs: ["label", "for", "size", "weight", "maxWeight", "horizontalAlignment", "leftIconHelpInfoMessage", "rightIconHelpInfoMessage", "leftIcon", "rightIcon", "required", "textOverflowEllipsis"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SelectionMenuSectionComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'hive-selection-menu-section',
                    template: `
        <div class="hive-selection-menu-section_wrapper">
            <hive-label
                class="hive-selection-menu-section_label"
                size="small"
                weight="semibold"
                [label]="label"
            ></hive-label>
        </div>

        <ng-content
            select="
                hive-selection-menu-item,
                hive-selection-menu-group-item,
                ng-container
            "
        />
    `,
                    providers: [
                        {
                            provide: SELECTION_MENU_CONTENT,
                            useExisting: SelectionMenuSectionComponent,
                        },
                    ],
                    hostDirectives: [HiveThemedDirective],
                }]
        }], propDecorators: { label: [{
                type: Input
            }] } });

class SelectionMenuModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SelectionMenuModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: SelectionMenuModule, declarations: [SelectionMenuComponent,
            SelectionMenuItemComponent,
            SelectionMenuBaseItemComponent,
            SelectionMenuGroupItemComponent,
            SelectionMenuSectionComponent,
            SelectionMenuIsScrolledDirective], imports: [CommonModule,
            FormsModule,
            BadgeModule,
            CheckboxComponent,
            TextFieldComponent,
            LabelComponent,
            SeparatorComponent,
            LoadingSpinnerComponent,
            IconComponent,
            LinkComponent,
            DebounceChangeDirective,
            NonNullPipe,
            IsDefinedPipe,
            EmptyStateComponent], exports: [SelectionMenuComponent,
            SelectionMenuItemComponent,
            SelectionMenuBaseItemComponent,
            SelectionMenuGroupItemComponent,
            SelectionMenuSectionComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SelectionMenuModule, providers: [IsDefinedPipe], imports: [CommonModule,
            FormsModule,
            BadgeModule,
            CheckboxComponent,
            TextFieldComponent,
            LabelComponent,
            LoadingSpinnerComponent,
            IconComponent,
            LinkComponent,
            EmptyStateComponent] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SelectionMenuModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        SelectionMenuComponent,
                        SelectionMenuItemComponent,
                        SelectionMenuBaseItemComponent,
                        SelectionMenuGroupItemComponent,
                        SelectionMenuSectionComponent,
                        SelectionMenuIsScrolledDirective,
                    ],
                    exports: [
                        SelectionMenuComponent,
                        SelectionMenuItemComponent,
                        SelectionMenuBaseItemComponent,
                        SelectionMenuGroupItemComponent,
                        SelectionMenuSectionComponent,
                    ],
                    providers: [IsDefinedPipe],
                    imports: [
                        CommonModule,
                        FormsModule,
                        BadgeModule,
                        CheckboxComponent,
                        TextFieldComponent,
                        LabelComponent,
                        SeparatorComponent,
                        LoadingSpinnerComponent,
                        IconComponent,
                        LinkComponent,
                        DebounceChangeDirective,
                        NonNullPipe,
                        IsDefinedPipe,
                        EmptyStateComponent,
                    ],
                }]
        }] });

class DropdownModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DropdownModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: DropdownModule, declarations: [DropdownComponent], imports: [CommonModule,
            SelectionMenuModule,
            FormInputBaseComponent,
            TextFieldComponent,
            IconComponent,
            FormsModule,
            ReactiveFormsModule,
            OverlayTriggerDirective,
            OverlayComponent,
            NonNullPipe,
            ChevronDirective], exports: [DropdownComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DropdownModule, imports: [CommonModule,
            SelectionMenuModule,
            FormInputBaseComponent,
            TextFieldComponent,
            IconComponent,
            FormsModule,
            ReactiveFormsModule,
            OverlayComponent] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DropdownModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [DropdownComponent],
                    imports: [
                        CommonModule,
                        SelectionMenuModule,
                        FormInputBaseComponent,
                        TextFieldComponent,
                        IconComponent,
                        FormsModule,
                        ReactiveFormsModule,
                        OverlayTriggerDirective,
                        OverlayComponent,
                        NonNullPipe,
                        ChevronDirective,
                    ],
                    exports: [DropdownComponent],
                }]
        }] });

class SelectionMenuFilters {
    /**
     * Calls `.includes()` on the label and filter, both lowercase.
     *
     * @param label
     * @param filter
     *
     * @returns {boolean} - Returns true if the label passes the filter, false otherwise.
     */
    static fullText(label, filter) {
        return label.toLowerCase().includes(filter.toLowerCase());
    }
}

class GfbSelectionMenuComponent {
    constructor() {
        /**
         * The name of the entity that the selection menu is for
         */
        this.entity = '';
        /**
         * The name of the key that the selection menu is currently showing properties for
         */
        this.key = '';
        /**
         * Whether the selection menu is in loading state
         * @default false
         */
        this.isLoading = false;
        /**
         * Whether the selection menu has an error
         * @default false
         */
        this.hasError = false;
        /**
         * Whether the selection menu has a back button. This is desired when the selection menu is nested.
         * @default true
         */
        this.showBackButtonHeader = true;
        /**
         * A single filter is emitted when the selection of properties is applied.
         * The filter will contain the entity, key, and the selected properties.
         */
        this.selectionChange = new EventEmitter();
        /**
         * Emitted when the back button is clicked. Used in conjunction with showBackButtonHeader.
         */
        this.backButtonClick = new EventEmitter();
        // Currently selected properties, that won't be emitted until the user clicks "Apply"
        this.currentSelection = [];
        // For filtering list of keys
        this.filteredKeySections = [];
        this.selectionFilter = {
            entity: this.entity || '',
            key: this.key || '',
            properties: [],
            selectedProperties: [],
        };
        this.totalPropertyCount = 0;
    }
    ngOnChanges(changes) {
        if (changes['keySections']) {
            this.handleFilterChange('');
            this.totalPropertyCount =
                this.keySections?.flatMap((keySection) => keySection.properties)
                    .length || 0;
        }
        if (changes['priorSelection']) {
            this.currentSelection = this.priorSelection || [];
        }
    }
    onSelectionChange(event) {
        this.currentSelection = event.selection;
    }
    applySelection() {
        this.selectionFilter = {
            entity: this.entity || '',
            key: this.key || '',
            properties: this.keySections?.flatMap((keySection) => keySection.properties) || [],
            selectedProperties: this.currentSelection,
        };
        this.selectionChange.emit(this.selectionFilter);
    }
    handleFilterChange(filterStr) {
        this.filteredKeySections =
            this.keySections?.map((keySection) => {
                return {
                    title: keySection.title,
                    properties: keySection.properties.filter((property) => SelectionMenuFilters.fullText(property, filterStr)),
                };
            }) || [];
    }
    clearSelection(event) {
        event.stopPropagation();
        this.currentSelection = [];
    }
    applyDisabled() {
        return (this.currentSelection.length === this.priorSelection?.length &&
            this.currentSelection.every((value) => this.priorSelection?.includes(value)));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: GfbSelectionMenuComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.3.12", type: GfbSelectionMenuComponent, selector: "hive-gfb-selection-menu", inputs: { entity: "entity", key: "key", keySections: "keySections", isLoading: ["isLoading", "isLoading", booleanAttribute], hasError: ["hasError", "hasError", booleanAttribute], showBackButtonHeader: ["showBackButtonHeader", "showBackButtonHeader", booleanAttribute], priorSelection: "priorSelection" }, outputs: { selectionChange: "selectionChange", backButtonClick: "backButtonClick" }, usesOnChanges: true, hostDirectives: [{ directive: HiveThemedDirective }], ngImport: i0, template: "<hive-selection-menu\n    multiselect\n    [hasFilter]=\"true\"\n    (filterChange)=\"handleFilterChange($event)\"\n    (selectionChange)=\"onSelectionChange($event)\"\n    [selection]=\"currentSelection\"\n    [hasLoadingError]=\"hasError\"\n    [isLoading]=\"isLoading\"\n>\n    @if (showBackButtonHeader) {\n        <div\n            slot=\"selection-menu-header\"\n            class=\"hive-gfb-back-button-header\"\n            (click)=\"backButtonClick.emit()\"\n        >\n            <hive-icon-component icon=\"light/arrow-left.svg\" size=\"small\">\n            </hive-icon-component>\n            <hive-label [label]=\"key || '' | titlecase\"> </hive-label>\n        </div>\n    }\n    <ng-container ngProjectAs=\"hive-selection-menu-item\">\n        @for (keySection of filteredKeySections || []; track keySection) {\n            @if (keySection.title) {\n                <hive-selection-menu-section [label]=\"keySection.title\">\n                </hive-selection-menu-section>\n            }\n            @for (\n                keyProperty of keySection.properties || [];\n                track keyProperty\n            ) {\n                <hive-selection-menu-item\n                    [label]=\"keyProperty\"\n                    [value]=\"keyProperty\"\n                >\n                </hive-selection-menu-item>\n            }\n        }\n    </ng-container>\n\n    @if (!!keySections && keySections.length >= 0) {\n        <div slot=\"selection-menu-footer\" class=\"hive-gfb-selection-button-row\">\n            <hive-label\n                class=\"count-label\"\n                [label]=\"(currentSelection.length || '0') + ' selected'\"\n                size=\"smallest\"\n            >\n            </hive-label>\n            <hive-button\n                size=\"smallest\"\n                label=\"Clear All\"\n                emphasis=\"tertiary\"\n                [disabled]=\"currentSelection.length === 0\"\n                (click)=\"clearSelection($event)\"\n            >\n            </hive-button>\n            <hive-button\n                size=\"smallest\"\n                label=\"Apply\"\n                emphasis=\"primary\"\n                [disabled]=\"applyDisabled()\"\n                (click)=\"applySelection()\"\n            >\n            </hive-button>\n        </div>\n    }\n</hive-selection-menu>\n", dependencies: [{ kind: "component", type: SelectionMenuComponent, selector: "hive-selection-menu", inputs: ["selectionItems", "selectionContent", "hasFilter", "multiselect", "hasLoadingError", "isLoading", "debounceWait", "hideSeparators", "selection"], outputs: ["selectionChange", "tryAgainClick", "filterChange"] }, { kind: "component", type: SelectionMenuItemComponent, selector: "hive-selection-menu-item", inputs: ["label", "value", "icon", "testId", "disabled"] }, { kind: "component", type: SelectionMenuSectionComponent, selector: "hive-selection-menu-section", inputs: ["label"] }, { kind: "component", type: ButtonComponent, selector: "hive-button", inputs: ["type", "menuButtonActive", "hasMenuButtonCaret", "label", "accessibleName", "icon", "iconPosition", "emphasis", "title", "size", "isLoading", "disabled", "rounded", "width"] }, { kind: "component", type: LabelComponent, selector: "hive-label", inputs: ["label", "for", "size", "weight", "maxWeight", "horizontalAlignment", "leftIconHelpInfoMessage", "rightIconHelpInfoMessage", "leftIcon", "rightIcon", "required", "textOverflowEllipsis"] }, { kind: "component", type: IconComponent, selector: "hive-icon-component", inputs: ["icon", "size"] }, { kind: "pipe", type: i2$1.TitleCasePipe, name: "titlecase" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: GfbSelectionMenuComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hive-gfb-selection-menu', hostDirectives: [HiveThemedDirective], changeDetection: ChangeDetectionStrategy.OnPush, template: "<hive-selection-menu\n    multiselect\n    [hasFilter]=\"true\"\n    (filterChange)=\"handleFilterChange($event)\"\n    (selectionChange)=\"onSelectionChange($event)\"\n    [selection]=\"currentSelection\"\n    [hasLoadingError]=\"hasError\"\n    [isLoading]=\"isLoading\"\n>\n    @if (showBackButtonHeader) {\n        <div\n            slot=\"selection-menu-header\"\n            class=\"hive-gfb-back-button-header\"\n            (click)=\"backButtonClick.emit()\"\n        >\n            <hive-icon-component icon=\"light/arrow-left.svg\" size=\"small\">\n            </hive-icon-component>\n            <hive-label [label]=\"key || '' | titlecase\"> </hive-label>\n        </div>\n    }\n    <ng-container ngProjectAs=\"hive-selection-menu-item\">\n        @for (keySection of filteredKeySections || []; track keySection) {\n            @if (keySection.title) {\n                <hive-selection-menu-section [label]=\"keySection.title\">\n                </hive-selection-menu-section>\n            }\n            @for (\n                keyProperty of keySection.properties || [];\n                track keyProperty\n            ) {\n                <hive-selection-menu-item\n                    [label]=\"keyProperty\"\n                    [value]=\"keyProperty\"\n                >\n                </hive-selection-menu-item>\n            }\n        }\n    </ng-container>\n\n    @if (!!keySections && keySections.length >= 0) {\n        <div slot=\"selection-menu-footer\" class=\"hive-gfb-selection-button-row\">\n            <hive-label\n                class=\"count-label\"\n                [label]=\"(currentSelection.length || '0') + ' selected'\"\n                size=\"smallest\"\n            >\n            </hive-label>\n            <hive-button\n                size=\"smallest\"\n                label=\"Clear All\"\n                emphasis=\"tertiary\"\n                [disabled]=\"currentSelection.length === 0\"\n                (click)=\"clearSelection($event)\"\n            >\n            </hive-button>\n            <hive-button\n                size=\"smallest\"\n                label=\"Apply\"\n                emphasis=\"primary\"\n                [disabled]=\"applyDisabled()\"\n                (click)=\"applySelection()\"\n            >\n            </hive-button>\n        </div>\n    }\n</hive-selection-menu>\n" }]
        }], propDecorators: { entity: [{
                type: Input
            }], key: [{
                type: Input
            }], keySections: [{
                type: Input
            }], isLoading: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], hasError: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], showBackButtonHeader: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], priorSelection: [{
                type: Input
            }], selectionChange: [{
                type: Output
            }], backButtonClick: [{
                type: Output
            }] } });

const MIN_ITEMS_FOR_FILTER = 9;
class GfbEntityMenuComponent {
    constructor() {
        /**
         * Whether the selection menu is in loading state
         * @default false
         */
        this.isLoading = false;
        /**
         * Whether the selection menu has an error
         * @default false
         */
        this.hasError = false;
        /**
         * A single GfbFilter is emitted when an entity's key is selected
         */
        this.selectionChange = new EventEmitter();
        // For filtering list of entities
        this.filteredEntitySections = [];
        this.totalKeyCount = 0;
        this.minItemsForFilter = MIN_ITEMS_FOR_FILTER;
    }
    ngOnChanges(changes) {
        if (changes['entitySections']) {
            this.handleFilterChange('');
            this.totalKeyCount =
                this.entitySections?.flatMap((entitySection) => entitySection.properties).length || 0;
        }
    }
    onSelectionChange(event) {
        // Single selection
        this.selectionChange.emit(event.selection[0]);
        // reset the selection since it's been emitted and we don't want it to persist visually
        this.selectionMenuComponent.selection = [];
    }
    handleFilterChange(filterStr) {
        this.filteredEntitySections =
            this.entitySections?.map((entitySection) => {
                return {
                    title: entitySection.title,
                    properties: entitySection.properties.filter((property) => SelectionMenuFilters.fullText(property, filterStr)),
                };
            }) || [];
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: GfbEntityMenuComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.3.12", type: GfbEntityMenuComponent, selector: "hive-gfb-entity-menu", inputs: { entitySections: "entitySections", isLoading: ["isLoading", "isLoading", booleanAttribute], hasError: ["hasError", "hasError", booleanAttribute] }, outputs: { selectionChange: "selectionChange" }, viewQueries: [{ propertyName: "selectionMenuComponent", first: true, predicate: ["selectionMenuComponent"], descendants: true }], usesOnChanges: true, hostDirectives: [{ directive: HiveThemedDirective }], ngImport: i0, template: "<hive-selection-menu\n    #selectionMenuComponent\n    [hasFilter]=\"totalKeyCount >= minItemsForFilter\"\n    (filterChange)=\"handleFilterChange($event)\"\n    (selectionChange)=\"onSelectionChange($event)\"\n    [hasLoadingError]=\"hasError\"\n    [isLoading]=\"isLoading\"\n>\n    <ng-container>\n        @for (entity of filteredEntitySections; track entity) {\n            @if (entity.title) {\n                <hive-selection-menu-section [label]=\"entity.title | titlecase\">\n                </hive-selection-menu-section>\n            }\n            @for (entityKey of entity.properties; track entityKey) {\n                <hive-selection-menu-item\n                    [label]=\"entityKey | titlecase\"\n                    [value]=\"{ entity: entity.title, key: entityKey }\"\n                    icon=\"light/chevron-right.svg\"\n                >\n                </hive-selection-menu-item>\n            }\n        }\n    </ng-container>\n</hive-selection-menu>\n", dependencies: [{ kind: "component", type: SelectionMenuComponent, selector: "hive-selection-menu", inputs: ["selectionItems", "selectionContent", "hasFilter", "multiselect", "hasLoadingError", "isLoading", "debounceWait", "hideSeparators", "selection"], outputs: ["selectionChange", "tryAgainClick", "filterChange"] }, { kind: "component", type: SelectionMenuItemComponent, selector: "hive-selection-menu-item", inputs: ["label", "value", "icon", "testId", "disabled"] }, { kind: "component", type: SelectionMenuSectionComponent, selector: "hive-selection-menu-section", inputs: ["label"] }, { kind: "pipe", type: i2$1.TitleCasePipe, name: "titlecase" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: GfbEntityMenuComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hive-gfb-entity-menu', hostDirectives: [HiveThemedDirective], changeDetection: ChangeDetectionStrategy.OnPush, template: "<hive-selection-menu\n    #selectionMenuComponent\n    [hasFilter]=\"totalKeyCount >= minItemsForFilter\"\n    (filterChange)=\"handleFilterChange($event)\"\n    (selectionChange)=\"onSelectionChange($event)\"\n    [hasLoadingError]=\"hasError\"\n    [isLoading]=\"isLoading\"\n>\n    <ng-container>\n        @for (entity of filteredEntitySections; track entity) {\n            @if (entity.title) {\n                <hive-selection-menu-section [label]=\"entity.title | titlecase\">\n                </hive-selection-menu-section>\n            }\n            @for (entityKey of entity.properties; track entityKey) {\n                <hive-selection-menu-item\n                    [label]=\"entityKey | titlecase\"\n                    [value]=\"{ entity: entity.title, key: entityKey }\"\n                    icon=\"light/chevron-right.svg\"\n                >\n                </hive-selection-menu-item>\n            }\n        }\n    </ng-container>\n</hive-selection-menu>\n" }]
        }], propDecorators: { entitySections: [{
                type: Input
            }], isLoading: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], hasError: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], selectionChange: [{
                type: Output
            }], selectionMenuComponent: [{
                type: ViewChild,
                args: ['selectionMenuComponent']
            }] } });

class GfbPillComponent {
    constructor() {
        /**
         * Whether the filter can be modified (i.e. the user can change the selected properties)
         * If this is false, the filter can only be removed with the "x" button, and will not show a dropdown
         * @default true
         */
        this.modifiable = true;
        /**
         * A single GfbFilter is emitted when an entity's key is selected.
         * If the filter is cleared, the selectedProperties of this filter will be an empty array.
         */
        this.selectionChange = new EventEmitter();
        this.selectedProperties = [];
        // For tags
        this.tagEntity = 'tag';
    }
    ngOnChanges(changes) {
        if (changes['filter']) {
            this.selectedProperties = this.filter.selectedProperties;
        }
    }
    onSelectionChange(event) {
        this.gfbPillDropdown.hideOverlay();
        this.selectionChange.emit(event);
    }
    clearFilter() {
        this.selectionChange.emit({
            ...this.filter,
            selectedProperties: [],
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: GfbPillComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.3.12", type: GfbPillComponent, selector: "hive-gfb-pill", inputs: { filter: "filter", modifiable: ["modifiable", "modifiable", booleanAttribute], defaultText: "defaultText" }, outputs: { selectionChange: "selectionChange" }, viewQueries: [{ propertyName: "gfbPillDropdown", first: true, predicate: ["gfbPillDropdown"], descendants: true }], usesOnChanges: true, hostDirectives: [{ directive: HiveThemedDirective }], ngImport: i0, template: "<div\n    class=\"hive-gfb-pill-container\"\n    [ngClass]=\"{ 'hive-gfb-pill-container_clickable': modifiable }\"\n    [hiveOverlayTrigger]=\"gfbPillDropdown\"\n    [disabled]=\"!modifiable\"\n>\n    <!-- For tags specifically, show the tag icon -->\n    <!-- This is needed since tags can have keys that overlap with those expected in other entities, -->\n    <!-- and we want to differentiate them visually. -->\n    @if (filter.entity === tagEntity) {\n        <div class=\"hive-gfb-pill-icon-container hive-gfb-pill-tag-icon\">\n            <hive-icon-component\n                size=\"medium\"\n                icon=\"solid/tag.svg\"\n            ></hive-icon-component>\n        </div>\n    }\n\n    <!-- No selections -->\n    @if (selectedProperties.length === 0) {\n        <hive-label\n            class=\"hive-gfb-pill-placeholder-text\"\n            size=\"small\"\n            weight=\"regular\"\n            [label]=\"defaultText || (filter.key | titlecase) || 'All Values'\"\n        >\n        </hive-label>\n    } @else {\n        <hive-label\n            class=\"hive-gfb-pill-name-text\"\n            size=\"small\"\n            weight=\"semibold\"\n            [label]=\"(filter.key | titlecase) + ': '\"\n        >\n        </hive-label>\n        <hive-label\n            class=\"hive-gfb-pill-value-text\"\n            size=\"small\"\n            weight=\"regular\"\n            [label]=\"selectedProperties[0]\"\n        >\n        </hive-label>\n        @if (selectedProperties.length > 1) {\n            <hive-badge\n                class=\"hive-gfb-pill-badge\"\n                [label]=\"'+' + (selectedProperties.length - 1)\"\n                emphasis=\"info\"\n            >\n            </hive-badge>\n        }\n    }\n    <!-- When there is a selection -->\n\n    @if (modifiable) {\n        <div class=\"hive-gfb-pill-icon-container\">\n            <hive-icon-component\n                hiveChevron\n                size=\"medium\"\n                icon=\"light/chevron-down.svg\"\n            ></hive-icon-component>\n        </div>\n    } @else {\n        <div class=\"hive-gfb-pill-icon-container hive-gfb-pill-close-icon\">\n            <hive-icon-component\n                size=\"medium\"\n                icon=\"light/xmark.svg\"\n                (click)=\"clearFilter()\"\n            ></hive-icon-component>\n        </div>\n    }\n</div>\n\n<hive-overlay #gfbPillDropdown takeWidthFromTrigger closeOnPageResize>\n    <hive-gfb-selection-menu\n        [entity]=\"filter.entity\"\n        [key]=\"filter.key\"\n        [keySections]=\"[{ title: undefined, properties: filter.properties }]\"\n        [priorSelection]=\"selectedProperties\"\n        [showBackButtonHeader]=\"false\"\n        (selectionChange)=\"onSelectionChange($event)\"\n    >\n    </hive-gfb-selection-menu>\n</hive-overlay>\n", dependencies: [{ kind: "component", type: LabelComponent, selector: "hive-label", inputs: ["label", "for", "size", "weight", "maxWeight", "horizontalAlignment", "leftIconHelpInfoMessage", "rightIconHelpInfoMessage", "leftIcon", "rightIcon", "required", "textOverflowEllipsis"] }, { kind: "directive", type: OverlayTriggerDirective, selector: "[hiveOverlayTrigger]", inputs: ["disabled", "hiveOverlayTrigger", "shouldToggle"] }, { kind: "component", type: OverlayComponent, selector: "hive-overlay", inputs: ["takeWidthFromTrigger", "closeOnPageResize", "panelClass", "backdropClass", "position", "offsetX", "offsetY", "closeOnBackdropClick", "closeOnOutsideClick", "hasBackdrop", "overlayMinWidth"], outputs: ["visibilityChange"] }, { kind: "component", type: IconComponent, selector: "hive-icon-component", inputs: ["icon", "size"] }, { kind: "directive", type: ChevronDirective, selector: "hive-icon-component[hiveChevron]", inputs: ["rotationDirection", "rotated"] }, { kind: "component", type: BadgeComponent, selector: "hive-badge", inputs: ["label", "icon", "emphasis", "size"] }, { kind: "directive", type: i2$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "component", type: GfbSelectionMenuComponent, selector: "hive-gfb-selection-menu", inputs: ["entity", "key", "keySections", "isLoading", "hasError", "showBackButtonHeader", "priorSelection"], outputs: ["selectionChange", "backButtonClick"] }, { kind: "pipe", type: i2$1.TitleCasePipe, name: "titlecase" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: GfbPillComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hive-gfb-pill', hostDirectives: [HiveThemedDirective], changeDetection: ChangeDetectionStrategy.OnPush, template: "<div\n    class=\"hive-gfb-pill-container\"\n    [ngClass]=\"{ 'hive-gfb-pill-container_clickable': modifiable }\"\n    [hiveOverlayTrigger]=\"gfbPillDropdown\"\n    [disabled]=\"!modifiable\"\n>\n    <!-- For tags specifically, show the tag icon -->\n    <!-- This is needed since tags can have keys that overlap with those expected in other entities, -->\n    <!-- and we want to differentiate them visually. -->\n    @if (filter.entity === tagEntity) {\n        <div class=\"hive-gfb-pill-icon-container hive-gfb-pill-tag-icon\">\n            <hive-icon-component\n                size=\"medium\"\n                icon=\"solid/tag.svg\"\n            ></hive-icon-component>\n        </div>\n    }\n\n    <!-- No selections -->\n    @if (selectedProperties.length === 0) {\n        <hive-label\n            class=\"hive-gfb-pill-placeholder-text\"\n            size=\"small\"\n            weight=\"regular\"\n            [label]=\"defaultText || (filter.key | titlecase) || 'All Values'\"\n        >\n        </hive-label>\n    } @else {\n        <hive-label\n            class=\"hive-gfb-pill-name-text\"\n            size=\"small\"\n            weight=\"semibold\"\n            [label]=\"(filter.key | titlecase) + ': '\"\n        >\n        </hive-label>\n        <hive-label\n            class=\"hive-gfb-pill-value-text\"\n            size=\"small\"\n            weight=\"regular\"\n            [label]=\"selectedProperties[0]\"\n        >\n        </hive-label>\n        @if (selectedProperties.length > 1) {\n            <hive-badge\n                class=\"hive-gfb-pill-badge\"\n                [label]=\"'+' + (selectedProperties.length - 1)\"\n                emphasis=\"info\"\n            >\n            </hive-badge>\n        }\n    }\n    <!-- When there is a selection -->\n\n    @if (modifiable) {\n        <div class=\"hive-gfb-pill-icon-container\">\n            <hive-icon-component\n                hiveChevron\n                size=\"medium\"\n                icon=\"light/chevron-down.svg\"\n            ></hive-icon-component>\n        </div>\n    } @else {\n        <div class=\"hive-gfb-pill-icon-container hive-gfb-pill-close-icon\">\n            <hive-icon-component\n                size=\"medium\"\n                icon=\"light/xmark.svg\"\n                (click)=\"clearFilter()\"\n            ></hive-icon-component>\n        </div>\n    }\n</div>\n\n<hive-overlay #gfbPillDropdown takeWidthFromTrigger closeOnPageResize>\n    <hive-gfb-selection-menu\n        [entity]=\"filter.entity\"\n        [key]=\"filter.key\"\n        [keySections]=\"[{ title: undefined, properties: filter.properties }]\"\n        [priorSelection]=\"selectedProperties\"\n        [showBackButtonHeader]=\"false\"\n        (selectionChange)=\"onSelectionChange($event)\"\n    >\n    </hive-gfb-selection-menu>\n</hive-overlay>\n" }]
        }], propDecorators: { filter: [{
                type: Input,
                args: [{ required: true }]
            }], modifiable: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], defaultText: [{
                type: Input
            }], selectionChange: [{
                type: Output
            }], gfbPillDropdown: [{
                type: ViewChild,
                args: ['gfbPillDropdown']
            }] } });

class GfbNonApplicableFilterButtonComponent {
    constructor() {
        /**
         * List of filters that have been affected by the dropdown.
         * Currently, the only functionality is to clear the filters,
         * so this will return one or more GfbFilters with an empty list of selectedProperties - effectively clearing the filter.
         */
        this.selectionChange = new EventEmitter();
    }
    getMenuItemLabel(filter) {
        if (filter.selectedProperties.length > 1) {
            return `${filter.key}: ${filter.selectedProperties[0]}, +${filter.selectedProperties.length - 1} more`;
        }
        else if (filter.selectedProperties.length === 1) {
            return `${filter.key}: ${filter.selectedProperties[0]}`;
        }
        else {
            // eslint-disable-next-line no-console
            console.error('unexpected filter', filter.entity, filter.key);
            return '–';
        }
    }
    // Clear single filter
    onSelectionChange(event) {
        this.selectionMenuComponent.selection = [];
        this.selectionChange.emit(event.selection.map((filter) => ({
            ...filter,
            selectedProperties: [],
        })));
    }
    // Clear all filters
    clearAll(event) {
        event.stopPropagation();
        this.selectionChange.emit(this.nonApplicableFilters.map((filter) => ({
            ...filter,
            selectedProperties: [],
        })));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: GfbNonApplicableFilterButtonComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.3.12", type: GfbNonApplicableFilterButtonComponent, selector: "hive-gfb-non-applicable-filter-button", inputs: { nonApplicableFilters: "nonApplicableFilters" }, outputs: { selectionChange: "selectionChange" }, viewQueries: [{ propertyName: "nonApplicableFiltersOverlay", first: true, predicate: ["nonApplicableFiltersOverlay"], descendants: true }, { propertyName: "selectionMenuComponent", first: true, predicate: ["selectionMenuComponent"], descendants: true }], hostDirectives: [{ directive: HiveThemedDirective }], ngImport: i0, template: "<hive-button\n    [hiveOverlayTrigger]=\"nonApplicableFiltersOverlay\"\n    size=\"small\"\n    emphasis=\"tertiary\"\n    icon=\"light/filter-slash.svg\"\n>\n</hive-button>\n\n<hive-overlay #nonApplicableFiltersOverlay closeOnPageResize>\n    <hive-selection-menu\n        #selectionMenuComponent\n        class=\"hive-gfb-non-applicable-filter-button-selection-menu\"\n        (selectionChange)=\"onSelectionChange($event)\"\n        hideSeparators\n    >\n        <hive-selection-menu-section label=\"Non applicable filters\">\n        </hive-selection-menu-section>\n        @for (filter of nonApplicableFilters; track filter) {\n            <hive-selection-menu-item\n                [label]=\"getMenuItemLabel(filter)\"\n                [value]=\"filter\"\n                icon=\"light/xmark.svg\"\n            ></hive-selection-menu-item>\n        }\n        <button\n            slot=\"selection-menu-footer\"\n            class=\"hive-clear-all-button\"\n            type=\"button\"\n            (click)=\"clearAll($event)\"\n        >\n            <hive-label label=\"Clear All\"></hive-label>\n        </button>\n    </hive-selection-menu>\n</hive-overlay>\n", dependencies: [{ kind: "component", type: SelectionMenuComponent, selector: "hive-selection-menu", inputs: ["selectionItems", "selectionContent", "hasFilter", "multiselect", "hasLoadingError", "isLoading", "debounceWait", "hideSeparators", "selection"], outputs: ["selectionChange", "tryAgainClick", "filterChange"] }, { kind: "component", type: SelectionMenuItemComponent, selector: "hive-selection-menu-item", inputs: ["label", "value", "icon", "testId", "disabled"] }, { kind: "component", type: SelectionMenuSectionComponent, selector: "hive-selection-menu-section", inputs: ["label"] }, { kind: "component", type: ButtonComponent, selector: "hive-button", inputs: ["type", "menuButtonActive", "hasMenuButtonCaret", "label", "accessibleName", "icon", "iconPosition", "emphasis", "title", "size", "isLoading", "disabled", "rounded", "width"] }, { kind: "component", type: LabelComponent, selector: "hive-label", inputs: ["label", "for", "size", "weight", "maxWeight", "horizontalAlignment", "leftIconHelpInfoMessage", "rightIconHelpInfoMessage", "leftIcon", "rightIcon", "required", "textOverflowEllipsis"] }, { kind: "directive", type: OverlayTriggerDirective, selector: "[hiveOverlayTrigger]", inputs: ["disabled", "hiveOverlayTrigger", "shouldToggle"] }, { kind: "component", type: OverlayComponent, selector: "hive-overlay", inputs: ["takeWidthFromTrigger", "closeOnPageResize", "panelClass", "backdropClass", "position", "offsetX", "offsetY", "closeOnBackdropClick", "closeOnOutsideClick", "hasBackdrop", "overlayMinWidth"], outputs: ["visibilityChange"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: GfbNonApplicableFilterButtonComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hive-gfb-non-applicable-filter-button', hostDirectives: [HiveThemedDirective], changeDetection: ChangeDetectionStrategy.OnPush, template: "<hive-button\n    [hiveOverlayTrigger]=\"nonApplicableFiltersOverlay\"\n    size=\"small\"\n    emphasis=\"tertiary\"\n    icon=\"light/filter-slash.svg\"\n>\n</hive-button>\n\n<hive-overlay #nonApplicableFiltersOverlay closeOnPageResize>\n    <hive-selection-menu\n        #selectionMenuComponent\n        class=\"hive-gfb-non-applicable-filter-button-selection-menu\"\n        (selectionChange)=\"onSelectionChange($event)\"\n        hideSeparators\n    >\n        <hive-selection-menu-section label=\"Non applicable filters\">\n        </hive-selection-menu-section>\n        @for (filter of nonApplicableFilters; track filter) {\n            <hive-selection-menu-item\n                [label]=\"getMenuItemLabel(filter)\"\n                [value]=\"filter\"\n                icon=\"light/xmark.svg\"\n            ></hive-selection-menu-item>\n        }\n        <button\n            slot=\"selection-menu-footer\"\n            class=\"hive-clear-all-button\"\n            type=\"button\"\n            (click)=\"clearAll($event)\"\n        >\n            <hive-label label=\"Clear All\"></hive-label>\n        </button>\n    </hive-selection-menu>\n</hive-overlay>\n" }]
        }], propDecorators: { nonApplicableFilters: [{
                type: Input,
                args: [{ required: true }]
            }], selectionChange: [{
                type: Output
            }], nonApplicableFiltersOverlay: [{
                type: ViewChild,
                args: ['nonApplicableFiltersOverlay']
            }], selectionMenuComponent: [{
                type: ViewChild,
                args: ['selectionMenuComponent']
            }] } });

const GFB_SERVICE_TOKEN = new InjectionToken('gfb-service');
/**
 * The Global Filter Bar (GFB) Component enhances user experience by providing efficient and customizable filtering options.
 * When used in conjunction with a provided GfbService, the GFB Component can be used to filter some elements of a page based
 * on user selections.
 *
 * **Note that for the GFB to work correctly, an injection token (GFB_SERVICE_TOKEN) matching the GfbService interface must be provided within the component using the GFB.**
 *
 * @example
 * providers: [{ provide: GFB_SERVICE_TOKEN, useClass: MyOwnImplementationOfGfbService }],
 */
class GfbComponent {
    constructor(gfbService, destroyRef) {
        this.gfbService = gfbService;
        this.destroyRef = destroyRef;
        /**
         * Allow additional filters to be added from the "plus" button
         * @default true
         */
        this.allowAdditionalFilters = true;
        // For the entity menu - that is, the first layer of the overlay when an additional filter selection is made
        this.entityMenuError = false;
        this.entityMenuLoading = false;
        this.selectedEntityKey = '';
        this.selectedEntityKeyFilter = {
            entity: '',
            key: '',
            properties: [],
            selectedProperties: [],
        };
        // All keys from all applicable entities
        this.applicableEntityKeyList = [];
        // All keys from all applicable entities, minus those from the 'Default' filters.
        // Used for the additional filters menu
        this.additionalEntityKeyList = [];
        // NON-applicable filters (i.e. filters for entities that are not in the applicableEntities list)
        this.nonApplicableFilters = [];
        // If no selection has been made, use the default filters, otherwise modify when
        // a selection has been made to keep track of the current state
        this.defaultFiltersWithSelection = [];
        // Applicable filters that are not in the default filters
        // these may have been carried over from another page, or added with the plus button
        this.additionalFilters = [];
        // Keep track of whether we have any filters applied at all
        this.anyActiveFilters = false;
        this.keyError = false;
        this.keyLoading = false;
        this.selectedKey = '';
        this.keyPropertyList = [];
        this.currentState = [];
    }
    ngOnInit() {
        this.gfbService
            .getCurrentState$()
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((states) => {
            this.refreshCurrentState(states);
        }, (error) => {
            // eslint-disable-next-line no-console
            console.error('hive-gfb: Error subscribing to current state', error);
        });
    }
    ngOnChanges(changes) {
        if (changes['defaultFilters']) {
            this.defaultFiltersWithSelection = [...(this.defaultFilters || [])];
        }
        if (changes['applicableEntities']) {
            this.entityMenuLoading = true;
            const entityObservables = this.applicableEntities?.map((entity) => this.gfbService.getKeysFromEntity(entity));
            if (entityObservables && entityObservables.length > 0) {
                forkJoin(entityObservables)
                    .pipe(takeUntilDestroyed(this.destroyRef))
                    .subscribe((entityKeyList) => {
                    const allEntityKeyList = entityKeyList.reduce((acc, val) => acc.concat(val), []);
                    this.applicableEntityKeyList =
                        allEntityKeyList.filter((entity) => {
                            return this.applicableEntities
                                ?.map((applicableEntity) => applicableEntity.toLowerCase())
                                .includes((entity.title || '').toLowerCase());
                        });
                    // Create the additionalEntityKeyList by filtering out the default filters
                    this.additionalEntityKeyList =
                        this.applicableEntityKeyList.map((entity) => {
                            return {
                                title: entity.title,
                                properties: entity.properties.filter((key) => {
                                    return !this.defaultFilters?.find((defaultFilter) => defaultFilter.entity ===
                                        entity.title &&
                                        defaultFilter.key ===
                                            key);
                                }),
                            };
                        });
                    this.entityMenuLoading = false;
                    this.entityMenuError = false;
                }, () => {
                    this.entityMenuLoading = false;
                    this.entityMenuError = true;
                });
            }
            else {
                this.entityMenuLoading = false;
                this.entityMenuError = false;
            }
        }
    }
    /**
     * @internal
     */
    onKeySelection(selection) {
        this.keyLoading = true;
        // Close the hive-gfb-entity-menu overlay and open the hive-gfb-selection-menu overlay
        if (this.overlayTrigger && this.additionalKeyPropertyMenuOverlay) {
            this.overlayTrigger.hideOverlay();
            this.overlayTrigger.hiveOverlayTrigger =
                this.additionalKeyPropertyMenuOverlay;
            this.overlayTrigger.showOverlay();
        }
        // if we have a key selection, get the selected properties for the key
        this.selectedEntityKeyFilter = this.currentState.find((state) => state.entity === selection.entity &&
            state.key === selection.key) || { entity: '', key: '', properties: [], selectedProperties: [] };
        this.gfbService
            .getPropertiesFromKey(selection.entity, selection.key)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((keyPropertyList) => {
            // Set the variables needed to pass to hive-gfb-selection-menu
            this.keyPropertyList = keyPropertyList;
            this.selectedEntityKey = selection.entity;
            this.selectedKey = selection.key;
            // Finish loading
            this.keyLoading = false;
            this.keyError = false;
        }, () => {
            // If error, finish loading with error state
            this.keyLoading = false;
            this.keyError = true;
        });
    }
    /**
     * @internal
     */
    onPropertySelection(selections) {
        for (const newFilter of selections) {
            // Update the current state with the new selection
            const currentStateIndex = this.currentState.findIndex((state) => state.entity === newFilter.entity &&
                state.key === newFilter.key);
            if (currentStateIndex > -1) {
                // If the filter already exists, and there is a selection, update the selection
                if (newFilter.selectedProperties.length > 0) {
                    this.currentState[currentStateIndex] = newFilter;
                }
                else {
                    // If the filter already exists, and there is no selection, remove the filter
                    this.currentState.splice(currentStateIndex, 1);
                }
            }
            else {
                this.currentState.push(newFilter);
            }
        }
        this.gfbService.setStates(this.currentState);
        // Close/reset the overlay
        if (this.overlayTrigger && this.additionalEntityKeyMenuOverlay) {
            this.overlayTrigger.hideOverlay();
            this.overlayTrigger.hiveOverlayTrigger =
                this.additionalEntityKeyMenuOverlay;
        }
    }
    /**
     * When the second-layer overlay is closed, either with or without a selection,
     * reset the overlay to the first layer
     * @internal
     */
    onKeyPropertyMenuOverlayVisibilityChange(event) {
        if (!event) {
            this.selectedEntityKey = '';
            this.selectedKey = '';
            this.keyPropertyList = [];
            if (this.overlayTrigger && this.additionalEntityKeyMenuOverlay) {
                this.overlayTrigger.hiveOverlayTrigger =
                    this.additionalEntityKeyMenuOverlay;
            }
        }
    }
    /**
     * @internal
     */
    onBackClick() {
        if (this.overlayTrigger && this.additionalEntityKeyMenuOverlay) {
            this.overlayTrigger.hideOverlay();
            this.overlayTrigger.hiveOverlayTrigger =
                this.additionalEntityKeyMenuOverlay;
            this.overlayTrigger.showOverlay();
        }
    }
    /**
     * @internal
     */
    clearCurrentState() {
        this.currentState = [];
        this.gfbService.setStates(this.currentState);
    }
    /**
     * @internal
     */
    refreshCurrentState(states) {
        this.currentState = states;
        // set anyActiveFilters to true if we have any selections at all
        this.anyActiveFilters = this.currentState.length > 0;
        // Set selected properties for default filters
        this.defaultFiltersWithSelection =
            this.defaultFilters?.map((filter) => {
                // Deep copy the filter object
                const filterCopy = { ...filter };
                const currentStateFilter = this.currentState.find((state) => state.entity === filter.entity &&
                    state.key === filter.key);
                if (currentStateFilter) {
                    filterCopy.selectedProperties =
                        currentStateFilter.selectedProperties;
                }
                return filterCopy;
            }) || [];
        // Get non-applicable filters that may be present in the current GFB state
        this.nonApplicableFilters = this.currentState.filter((state) => {
            return !this.applicableEntities
                ?.map((entity) => entity.toLowerCase())
                .includes(state.entity.toLowerCase());
        });
        // Get additional (i.e. applicable but not in default filters) filters that may have been applied
        this.additionalFilters = this.currentState.filter((state) => {
            return (this.applicableEntities
                ?.map((entity) => entity.toLowerCase())
                .includes(state.entity.toLowerCase()) &&
                !this.defaultFilters?.find((filter) => filter.entity === state.entity &&
                    filter.key === state.key));
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: GfbComponent, deps: [{ token: GFB_SERVICE_TOKEN }, { token: i0.DestroyRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.3.12", type: GfbComponent, selector: "hive-gfb", inputs: { applicableEntities: "applicableEntities", defaultFilters: "defaultFilters", allowAdditionalFilters: ["allowAdditionalFilters", "allowAdditionalFilters", booleanAttribute] }, viewQueries: [{ propertyName: "overlayTrigger", first: true, predicate: OverlayTriggerDirective, descendants: true }, { propertyName: "additionalEntityKeyMenuOverlay", first: true, predicate: ["additionalEntityKeyMenuOverlay"], descendants: true }, { propertyName: "additionalKeyPropertyMenuOverlay", first: true, predicate: ["additionalKeyPropertyMenuOverlay"], descendants: true }], usesOnChanges: true, hostDirectives: [{ directive: HiveThemedDirective }], ngImport: i0, template: "<div class=\"hive-gfb-container\">\n    @for (defaultFilter of defaultFiltersWithSelection; track defaultFilter) {\n        <hive-gfb-pill\n            [filter]=\"defaultFilter\"\n            (selectionChange)=\"onPropertySelection([$event])\"\n        >\n        </hive-gfb-pill>\n    }\n\n    @for (additionalFilter of additionalFilters; track additionalFilter) {\n        <hive-gfb-pill\n            [filter]=\"additionalFilter\"\n            [modifiable]=\"false\"\n            (selectionChange)=\"onPropertySelection([$event])\"\n        >\n        </hive-gfb-pill>\n    }\n\n    @if (nonApplicableFilters.length > 0) {\n        <hive-gfb-non-applicable-filter-button\n            [nonApplicableFilters]=\"nonApplicableFilters\"\n            (selectionChange)=\"onPropertySelection($event)\"\n        >\n        </hive-gfb-non-applicable-filter-button>\n    }\n\n    @if (allowAdditionalFilters) {\n        <hive-button\n            [hiveOverlayTrigger]=\"additionalEntityKeyMenuOverlay\"\n            size=\"small\"\n            emphasis=\"tertiary\"\n            icon=\"light/plus.svg\"\n            data-testid=\"hive-gfb-additional-filter-button\"\n        >\n        </hive-button>\n    }\n\n    @if (anyActiveFilters) {\n        <hive-button\n            size=\"small\"\n            emphasis=\"tertiary\"\n            label=\"Clear All\"\n            (click)=\"clearCurrentState()\"\n        >\n        </hive-button>\n    }\n</div>\n\n<hive-overlay\n    #additionalEntityKeyMenuOverlay\n    takeWidthFromTrigger\n    closeOnPageResize\n>\n    <hive-gfb-entity-menu\n        [entitySections]=\"additionalEntityKeyList\"\n        [isLoading]=\"entityMenuLoading\"\n        [hasError]=\"entityMenuError\"\n        (selectionChange)=\"onKeySelection($event)\"\n    >\n    </hive-gfb-entity-menu>\n</hive-overlay>\n\n<hive-overlay\n    #additionalKeyPropertyMenuOverlay\n    takeWidthFromTrigger\n    closeOnPageResize\n    (visibilityChange)=\"onKeyPropertyMenuOverlayVisibilityChange($event)\"\n>\n    <hive-gfb-selection-menu\n        [entity]=\"selectedEntityKey\"\n        [key]=\"selectedKey\"\n        [keySections]=\"keyPropertyList\"\n        [priorSelection]=\"selectedEntityKeyFilter.selectedProperties\"\n        [isLoading]=\"keyLoading\"\n        [hasError]=\"keyError\"\n        (selectionChange)=\"onPropertySelection([$event])\"\n        (backButtonClick)=\"onBackClick()\"\n    >\n    </hive-gfb-selection-menu>\n</hive-overlay>\n", dependencies: [{ kind: "component", type: ButtonComponent, selector: "hive-button", inputs: ["type", "menuButtonActive", "hasMenuButtonCaret", "label", "accessibleName", "icon", "iconPosition", "emphasis", "title", "size", "isLoading", "disabled", "rounded", "width"] }, { kind: "directive", type: OverlayTriggerDirective, selector: "[hiveOverlayTrigger]", inputs: ["disabled", "hiveOverlayTrigger", "shouldToggle"] }, { kind: "component", type: OverlayComponent, selector: "hive-overlay", inputs: ["takeWidthFromTrigger", "closeOnPageResize", "panelClass", "backdropClass", "position", "offsetX", "offsetY", "closeOnBackdropClick", "closeOnOutsideClick", "hasBackdrop", "overlayMinWidth"], outputs: ["visibilityChange"] }, { kind: "component", type: GfbSelectionMenuComponent, selector: "hive-gfb-selection-menu", inputs: ["entity", "key", "keySections", "isLoading", "hasError", "showBackButtonHeader", "priorSelection"], outputs: ["selectionChange", "backButtonClick"] }, { kind: "component", type: GfbEntityMenuComponent, selector: "hive-gfb-entity-menu", inputs: ["entitySections", "isLoading", "hasError"], outputs: ["selectionChange"] }, { kind: "component", type: GfbPillComponent, selector: "hive-gfb-pill", inputs: ["filter", "modifiable", "defaultText"], outputs: ["selectionChange"] }, { kind: "component", type: GfbNonApplicableFilterButtonComponent, selector: "hive-gfb-non-applicable-filter-button", inputs: ["nonApplicableFilters"], outputs: ["selectionChange"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: GfbComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hive-gfb', hostDirectives: [HiveThemedDirective], changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"hive-gfb-container\">\n    @for (defaultFilter of defaultFiltersWithSelection; track defaultFilter) {\n        <hive-gfb-pill\n            [filter]=\"defaultFilter\"\n            (selectionChange)=\"onPropertySelection([$event])\"\n        >\n        </hive-gfb-pill>\n    }\n\n    @for (additionalFilter of additionalFilters; track additionalFilter) {\n        <hive-gfb-pill\n            [filter]=\"additionalFilter\"\n            [modifiable]=\"false\"\n            (selectionChange)=\"onPropertySelection([$event])\"\n        >\n        </hive-gfb-pill>\n    }\n\n    @if (nonApplicableFilters.length > 0) {\n        <hive-gfb-non-applicable-filter-button\n            [nonApplicableFilters]=\"nonApplicableFilters\"\n            (selectionChange)=\"onPropertySelection($event)\"\n        >\n        </hive-gfb-non-applicable-filter-button>\n    }\n\n    @if (allowAdditionalFilters) {\n        <hive-button\n            [hiveOverlayTrigger]=\"additionalEntityKeyMenuOverlay\"\n            size=\"small\"\n            emphasis=\"tertiary\"\n            icon=\"light/plus.svg\"\n            data-testid=\"hive-gfb-additional-filter-button\"\n        >\n        </hive-button>\n    }\n\n    @if (anyActiveFilters) {\n        <hive-button\n            size=\"small\"\n            emphasis=\"tertiary\"\n            label=\"Clear All\"\n            (click)=\"clearCurrentState()\"\n        >\n        </hive-button>\n    }\n</div>\n\n<hive-overlay\n    #additionalEntityKeyMenuOverlay\n    takeWidthFromTrigger\n    closeOnPageResize\n>\n    <hive-gfb-entity-menu\n        [entitySections]=\"additionalEntityKeyList\"\n        [isLoading]=\"entityMenuLoading\"\n        [hasError]=\"entityMenuError\"\n        (selectionChange)=\"onKeySelection($event)\"\n    >\n    </hive-gfb-entity-menu>\n</hive-overlay>\n\n<hive-overlay\n    #additionalKeyPropertyMenuOverlay\n    takeWidthFromTrigger\n    closeOnPageResize\n    (visibilityChange)=\"onKeyPropertyMenuOverlayVisibilityChange($event)\"\n>\n    <hive-gfb-selection-menu\n        [entity]=\"selectedEntityKey\"\n        [key]=\"selectedKey\"\n        [keySections]=\"keyPropertyList\"\n        [priorSelection]=\"selectedEntityKeyFilter.selectedProperties\"\n        [isLoading]=\"keyLoading\"\n        [hasError]=\"keyError\"\n        (selectionChange)=\"onPropertySelection([$event])\"\n        (backButtonClick)=\"onBackClick()\"\n    >\n    </hive-gfb-selection-menu>\n</hive-overlay>\n" }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [GFB_SERVICE_TOKEN]
                }] }, { type: i0.DestroyRef }], propDecorators: { applicableEntities: [{
                type: Input
            }], defaultFilters: [{
                type: Input
            }], allowAdditionalFilters: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], overlayTrigger: [{
                type: ViewChild,
                args: [OverlayTriggerDirective]
            }], additionalEntityKeyMenuOverlay: [{
                type: ViewChild,
                args: ['additionalEntityKeyMenuOverlay']
            }], additionalKeyPropertyMenuOverlay: [{
                type: ViewChild,
                args: ['additionalKeyPropertyMenuOverlay']
            }] } });

class GfbModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: GfbModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: GfbModule, declarations: [GfbSelectionMenuComponent,
            GfbEntityMenuComponent,
            GfbComponent,
            GfbPillComponent,
            GfbNonApplicableFilterButtonComponent], imports: [SelectionMenuModule,
            ButtonComponent,
            LabelComponent,
            OverlayTriggerDirective,
            OverlayComponent,
            IconComponent,
            ChevronDirective,
            BadgeModule,
            MenuModule,
            NgClass,
            TitleCasePipe,
            NgForOf,
            NgIf], exports: [GfbComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: GfbModule, imports: [SelectionMenuModule,
            ButtonComponent,
            LabelComponent,
            OverlayComponent,
            IconComponent,
            BadgeModule,
            MenuModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: GfbModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        GfbSelectionMenuComponent,
                        GfbEntityMenuComponent,
                        GfbComponent,
                        GfbPillComponent,
                        GfbNonApplicableFilterButtonComponent,
                    ],
                    exports: [GfbComponent],
                    imports: [
                        SelectionMenuModule,
                        ButtonComponent,
                        LabelComponent,
                        OverlayTriggerDirective,
                        OverlayComponent,
                        IconComponent,
                        ChevronDirective,
                        BadgeModule,
                        MenuModule,
                        NgClass,
                        TitleCasePipe,
                        NgForOf,
                        NgIf,
                    ],
                }]
        }] });

// Having a mock service tanks the code coverage numbers, we can ignore it
/* istanbul ignore next */
class MockGfbService {
    constructor() {
        this.currentState = [];
        this.currentState$ = new BehaviorSubject([]);
    }
    getKeysFromEntity(entity) {
        switch (entity) {
            case 'appliance':
                return of([
                    {
                        title: 'appliance',
                        properties: [
                            'Name',
                            'Appliance ID',
                            'City',
                            'Chassis',
                            'Serial Number',
                        ],
                    },
                ]);
            case 'volume':
                return of([
                    {
                        title: 'volume',
                        properties: ['Volume Name'],
                    },
                ]);
            case 'tag':
                return of([
                    {
                        title: 'tag',
                        properties: ['Name'],
                    },
                ]);
            default:
                return of([
                    {
                        title: 'Section A',
                        properties: ['Property A', 'Property B', 'Property C'],
                    },
                ]);
        }
    }
    getPropertiesFromKey(entity, key) {
        switch (key) {
            case 'Name':
                if (entity === 'tag') {
                    return of([
                        {
                            title: 'Name',
                            properties: [
                                'Tag Name 1',
                                'Tag Name 2',
                                'Tag Name 3',
                            ],
                        },
                    ]);
                }
                else {
                    return of([
                        {
                            title: 'Name',
                            properties: ['Name 1', 'Name 2', 'Name 3'],
                        },
                    ]);
                }
            case 'Appliance ID':
                return of([
                    {
                        title: 'Appliance ID',
                        properties: ['123', '456', '789'],
                    },
                ]);
            case 'City':
                return of([
                    {
                        title: 'City',
                        properties: [
                            'Amarillo',
                            'Berlin',
                            'Carmel-by-the-Sea',
                            'Denver',
                            'Helsinki',
                            'Houston',
                            'London',
                            'New York City',
                            'Prague',
                            'Santa Clara',
                            'Seattle',
                            'Tokyo',
                        ],
                    },
                ]);
            case 'Chassis':
                return of([
                    {
                        title: 'Chassis',
                        properties: ['Chassis 1', 'Chassis 2', 'Chassis 3'],
                    },
                ]);
            case 'Serial Number':
                return of([
                    {
                        title: 'Serial Number',
                        properties: [
                            '111-111-111',
                            '123-456-789',
                            'XXX-XXX-XXX',
                        ],
                    },
                ]);
            case 'Volume Name':
                return of([
                    {
                        title: 'Volume Name',
                        properties: ['vol1', 'vol2', 'vol3'],
                    },
                ]);
            default:
                return of([
                    {
                        title: 'Section A',
                        properties: ['Property A', 'Property B', 'Property C'],
                    },
                ]);
        }
    }
    getCurrentState$() {
        // return currentState as a subject
        return this.currentState$;
    }
    setStates(states) {
        this.currentState = states;
        this.currentState$.next(this.currentState);
    }
}

class FocusNextDirective {
    constructor(document) {
        this.document = document;
        this.destroy$ = new Subject();
        /**
         * @internal
         */
        this.toBeSelected = new Subject();
        this.isAppleDevice = this.isApple(this.document);
    }
    ngOnInit() {
        this.toBeSelected
            .pipe(takeUntil(this.destroy$), throttleTime(10, undefined, { trailing: true }), tap((element) => element.select()))
            .subscribe();
    }
    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
    /**
     * @param document
     *
     * @internal
     */
    isApple(document) {
        const userAgent = document.defaultView?.navigator.userAgent ?? '';
        if (userAgent.indexOf('Mac') !== -1) {
            return true;
        }
        return /iPad|iPhone|iPod|Mac/.test(userAgent);
    }
    /**
     * @param event
     *
     * @internal
     */
    onKeyDown(event) {
        const element = event.target;
        const maxLength = +(element.getAttribute('maxlength') ?? 0);
        if (element.value.length < maxLength) {
            return;
        }
        this.selectNext(event);
    }
    /**
     * @param event
     *
     * @internal
     */
    onBackspace(event) {
        const element = event.target;
        if (element.value.length) {
            return;
        }
        this.selectPrevious(event);
    }
    /**
     * @param event
     *
     * @internal
     */
    onDelete(event) {
        if (this.isAppleDevice) {
            this.onBackspace(event);
        }
        else {
            const element = event.target;
            if (element.value.length) {
                return;
            }
            this.selectNext(event);
        }
    }
    /**
     * @param event
     *
     * @internal
     */
    selectPrevious(event) {
        const element = event.target;
        const sibling = element.previousElementSibling;
        sibling?.focus();
        if (!sibling) {
            this.toBeSelected.next(element);
        }
    }
    /**
     * @param event
     *
     * @internal
     */
    selectNext(event) {
        const element = event.target;
        const sibling = element.nextElementSibling;
        sibling?.focus();
        if (!sibling) {
            this.toBeSelected.next(element);
        }
    }
    onFocus(event) {
        this.toBeSelected.next(event.target);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FocusNextDirective, deps: [{ token: DOCUMENT }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: FocusNextDirective, isStandalone: true, selector: "input[hiveFocusNext]", host: { listeners: { "input": "onKeyDown($event)", "keydown.backspace": "onBackspace($event)", "keydown.delete": "onDelete($event)", "keydown.ArrowLeft": "selectPrevious($event)", "keydown.ArrowRight": "selectNext($event)", "focus": "onFocus($event)" } }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FocusNextDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'input[hiveFocusNext]',
                    standalone: true,
                }]
        }], ctorParameters: () => [{ type: Document, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }], propDecorators: { onKeyDown: [{
                type: HostListener,
                args: ['input', ['$event']]
            }], onBackspace: [{
                type: HostListener,
                args: ['keydown.backspace', ['$event']]
            }], onDelete: [{
                type: HostListener,
                args: ['keydown.delete', ['$event']]
            }], selectPrevious: [{
                type: HostListener,
                args: ['keydown.ArrowLeft', ['$event']]
            }], selectNext: [{
                type: HostListener,
                args: ['keydown.ArrowRight', ['$event']]
            }], onFocus: [{
                type: HostListener,
                args: ['focus', ['$event']]
            }] } });

/**
 * The OTP (One-Time Password) Fields component is used to facilitate the input of a multi-digit one-time password, typically sent to a user's device for authentication or verification purposes.
 *
 * @example
 *  <hive-one-time-password
 *      [(ngModel)]="text"
 *      length="6"
 *      data-testid="hive-one-time-password">
 *  </hive-one-time-password>
 *
 *  @example
 *  <form [formGroup]="formGroup" (ngSubmit)="onSubmit($event)" style="display: flex; flex-direction: column; align-items: center; width: 400px; gap: 20px; margin-bottom: 8px;">
 *      <hive-one-time-password
 *          [formControl]="formGroup.controls.defaultControl"
 *          label="Default"
 *          [length]="length"
 *          assistanceText="You can specify assistance text for it"
 *      >
 *      </hive-one-time-password>
 *  </form>
 *
 */
class OneTimePasswordComponent {
    constructor(elementRef, cdr, injector, destroyRef, formBuilder, formComponentValidity) {
        this.elementRef = elementRef;
        this.cdr = cdr;
        this.injector = injector;
        this.destroyRef = destroyRef;
        this.formBuilder = formBuilder;
        this.formComponentValidity = formComponentValidity;
        this.value = '';
        this.autofocus = false;
        this.size = 'large';
        /**
         * Native `blur` event of `<input type="text" />`
         *
         * @see HTMLInputElement
         */
        this.blur = new EventEmitter();
        /**
         * Native `input` event of `<input type="text" />`
         *
         * @see HTMLInputElement
         */
        this.input = new EventEmitter();
        /**
         * Use to disable component
         */
        this.disabled = false;
        this._value = '';
        this.destroyRef$ = inject(DestroyRef);
        this._uniqId = uniqueId('hive-one-time-password-');
        /**
         * 6 is the default value
         */
        this._length = 6;
        /**
         * @internal
         */
        this.onModelChange = () => { };
        /**
         * @internal
         */
        this.onModelTouch = () => { };
    }
    get length() {
        return this._length;
    }
    /**
     * Length of OTP password
     */
    set length(value) {
        this._length = coerceNumberProperty(value);
    }
    get _control() {
        return this.formComponentValidity.ngControl?.control;
    }
    ngOnInit() {
        this.initFormGroup();
        this.injector
            .get(NgControl, null, {
            optional: true,
        })
            ?.control?.statusChanges.pipe(safeTakeUntilDestroyed(this.destroyRef))
            .subscribe(() => {
            this.cdr.markForCheck();
        });
    }
    /**
     * @internal
     */
    writeValue(value) {
        this._value = value;
        this.replaceValues(value);
    }
    /**
     * @internal
     */
    registerOnChange(fn) {
        this.onModelChange = fn;
    }
    /**
     * @internal
     */
    registerOnTouched(fn) {
        this.onModelTouch = fn;
    }
    /**
     * @internal
     */
    setDisabledState(isDisabled) {
        this.disabled = booleanAttribute(isDisabled);
        this.triggerDisabledState();
    }
    ngOnChanges(changes) {
        if (changes['length']) {
            this.updateNumberOfControls(changes['length'].currentValue);
        }
        if (changes['value']) {
            this.replaceValues(changes['value'].currentValue);
        }
        if (changes['disabled']) {
            this.setDisabledState(changes['disabled'].currentValue);
        }
    }
    handlePaste(event) {
        event.preventDefault();
        const value = event.clipboardData.getData('text');
        this.replaceValues(value);
    }
    handleBlur(e) {
        const clickedInside = this.elementRef.nativeElement.contains(e.relatedTarget);
        if (!clickedInside) {
            this.onModelTouch?.();
            this._formGroup?.markAllAsTouched();
            if (this._formGroup?.errors) {
                this._control?.setErrors(this._formGroup?.errors ?? null);
            }
            this.blur.emit(e);
        }
    }
    trackByFn(index, item) {
        return item.key;
    }
    initFormGroup() {
        function formGroupValidator(group) {
            const values = Object.keys(group.getRawValue());
            const hasEmptyValue = values.some((key) => !group.getRawValue()[key]);
            return hasEmptyValue ? { required: true } : null;
        }
        this._formGroup = this.formBuilder.group({}, {
            updateOn: 'change',
            validators: [formGroupValidator],
        });
        this.updateNumberOfControls(this._length);
        this.triggerDisabledState();
        this._formGroup.valueChanges
            .pipe(safeTakeUntilDestroyed(this.destroyRef$))
            .subscribe((value) => {
            this.onModelChange?.(Object.values(value).join(''));
        });
    }
    triggerDisabledState() {
        if (this.disabled) {
            this._formGroup?.disable();
        }
        else {
            this._formGroup?.enable();
        }
    }
    replaceValues(value) {
        if (value === null || value === undefined || !this._formGroup) {
            return;
        }
        const values = range(value.length)
            .map(this.indexToId.bind(this))
            .reduce((acc, id, index) => ({
            ...acc,
            [id]: value[index],
        }), {});
        this._formGroup.patchValue(values);
    }
    updateNumberOfControls(length) {
        if (!this._formGroup) {
            return;
        }
        const newIdsRange = range(length).map(this.indexToId.bind(this));
        const oldIdsRange = Object.keys(this._formGroup.controls);
        const idsToRemove = oldIdsRange.filter((id) => !newIdsRange.includes(id));
        const idsToAdd = newIdsRange.filter((id) => !oldIdsRange.includes(id));
        idsToRemove.forEach((id) => this._formGroup?.removeControl(id));
        idsToAdd.forEach((id) => this._formGroup?.addControl(id, new FormControl('', Validators.required)));
    }
    indexToId(index) {
        return `${this._uniqId}-${index}`;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: OneTimePasswordComponent, deps: [{ token: i0.ElementRef }, { token: i0.ChangeDetectorRef }, { token: i0.Injector }, { token: i0.DestroyRef }, { token: i1$3.FormBuilder }, { token: FormComponentValidityDirective }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.3.12", type: OneTimePasswordComponent, isStandalone: true, selector: "hive-one-time-password", inputs: { label: "label", errorMessages: "errorMessages", assistanceText: "assistanceText", value: "value", autofocus: "autofocus", size: "size", disabled: ["disabled", "disabled", booleanAttribute], length: "length" }, outputs: { blur: "blur", input: "input" }, providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => OneTimePasswordComponent),
                multi: true,
            },
        ], usesOnChanges: true, hostDirectives: [{ directive: HiveThemedDirective }, { directive: FormComponentValidityDirective }], ngImport: i0, template: "@if (_formGroup; as formGroup) {\n    <div\n        [formGroup]=\"formGroup\"\n        class=\"hive-one-time-password\"\n        [class.hive-one-time-password--form-group-invalid]=\"formGroup.invalid\"\n    >\n        <hive-form-input-base\n            increasedContentGap\n            horizontalAlignment=\"center\"\n            [assistanceText]=\"assistanceText\"\n            [errorMessages]=\"errorMessages\"\n            [hasError]=\"formComponentValidity.invalid\"\n            [label]=\"label\"\n            [required]=\"formComponentValidity.required\"\n            [disabled]=\"disabled\"\n        >\n            <div class=\"hive-one-time-password__container\">\n                @for (\n                    formControl of formGroup.controls | keyvalue;\n                    track trackByFn(i, formControl);\n                    let i = $index\n                ) {\n                    <input\n                        inputmode=\"text\"\n                        maxlength=\"1\"\n                        hiveFocusNext\n                        class=\"hive-one-time-password__input\"\n                        [class.hive-one-time-password__input--invalid]=\"\n                            formComponentValidity.isControlInvalid(\n                                formControl.value\n                            )\n                        \"\n                        [ngClass]=\"[\n                            'hive-one-time-password__input--size-' + size,\n                        ]\"\n                        [formControlName]=\"formControl.key\"\n                        [attr.aria-invalid]=\"formComponentValidity.invalid\"\n                        (blur)=\"handleBlur($event)\"\n                        (paste)=\"handlePaste($event)\"\n                        (input)=\"input.emit($event)\"\n                    />\n                }\n            </div>\n        </hive-form-input-base>\n    </div>\n}\n", dependencies: [{ kind: "ngmodule", type: ReactiveFormsModule }, { kind: "directive", type: i1$3.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1$3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$3.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i1$3.MaxLengthValidator, selector: "[maxlength][formControlName],[maxlength][formControl],[maxlength][ngModel]", inputs: ["maxlength"] }, { kind: "directive", type: i1$3.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$3.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "directive", type: FocusNextDirective, selector: "input[hiveFocusNext]" }, { kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i2$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "pipe", type: i2$1.KeyValuePipe, name: "keyvalue" }, { kind: "component", type: FormInputBaseComponent, selector: "hive-form-input-base", inputs: ["label", "for", "required", "disabled", "helpInfoIcon", "helpInfoMessage", "errorMessages", "hasError", "assistanceText", "horizontalAlignment", "increasedContentGap"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
__decorate([
    RequiredInput('Length of OTP password must be specified')
], OneTimePasswordComponent.prototype, "length", null);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: OneTimePasswordComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hive-one-time-password', changeDetection: ChangeDetectionStrategy.OnPush, standalone: true, imports: [
                        ReactiveFormsModule,
                        FocusNextDirective,
                        CommonModule,
                        FormInputBaseComponent,
                    ], hostDirectives: [HiveThemedDirective, FormComponentValidityDirective], providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => OneTimePasswordComponent),
                            multi: true,
                        },
                    ], template: "@if (_formGroup; as formGroup) {\n    <div\n        [formGroup]=\"formGroup\"\n        class=\"hive-one-time-password\"\n        [class.hive-one-time-password--form-group-invalid]=\"formGroup.invalid\"\n    >\n        <hive-form-input-base\n            increasedContentGap\n            horizontalAlignment=\"center\"\n            [assistanceText]=\"assistanceText\"\n            [errorMessages]=\"errorMessages\"\n            [hasError]=\"formComponentValidity.invalid\"\n            [label]=\"label\"\n            [required]=\"formComponentValidity.required\"\n            [disabled]=\"disabled\"\n        >\n            <div class=\"hive-one-time-password__container\">\n                @for (\n                    formControl of formGroup.controls | keyvalue;\n                    track trackByFn(i, formControl);\n                    let i = $index\n                ) {\n                    <input\n                        inputmode=\"text\"\n                        maxlength=\"1\"\n                        hiveFocusNext\n                        class=\"hive-one-time-password__input\"\n                        [class.hive-one-time-password__input--invalid]=\"\n                            formComponentValidity.isControlInvalid(\n                                formControl.value\n                            )\n                        \"\n                        [ngClass]=\"[\n                            'hive-one-time-password__input--size-' + size,\n                        ]\"\n                        [formControlName]=\"formControl.key\"\n                        [attr.aria-invalid]=\"formComponentValidity.invalid\"\n                        (blur)=\"handleBlur($event)\"\n                        (paste)=\"handlePaste($event)\"\n                        (input)=\"input.emit($event)\"\n                    />\n                }\n            </div>\n        </hive-form-input-base>\n    </div>\n}\n" }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: i0.ChangeDetectorRef }, { type: i0.Injector }, { type: i0.DestroyRef }, { type: i1$3.FormBuilder }, { type: FormComponentValidityDirective }], propDecorators: { label: [{
                type: Input
            }], errorMessages: [{
                type: Input
            }], assistanceText: [{
                type: Input
            }], value: [{
                type: Input
            }], autofocus: [{
                type: Input
            }], size: [{
                type: Input
            }], blur: [{
                type: Output
            }], input: [{
                type: Output
            }], disabled: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], length: [{
                type: Input
            }] } });

/**
 * Multiselect component uses `SelectionMenuComponent` internally, and its behavior
 * and appearance are almost identical to the `DropdownComponent`. However, unlike
 * the `DropdownComponent`, the `MultiselectComponent` allows for multiple selections.
 *
 * When items are selected, they are displayed inside the multiselect container as
 * chips (see: `ChipComponent`). The user can remove a selection by clicking on the
 * close icon in each chip, or by deselecting the item in the dropdown.
 *
 * @example
 * <hive-multiselect
 *    [label]="label"
 *    [(selection)]="selection"
 * >
 *     <hive-selection-menu-item
 *         *ngFor="let item of items"
 *         [value]="item.value"
 *         [label]="item.label"
 *         [disabled]="item.isDisabled"
 *     ></hive-selection-menu-item>
 * </hive-dropdown>
 */
class MultiselectComponent {
    constructor(cdr, injector, destroyRef, formComponentValidityDirective) {
        this.cdr = cdr;
        this.injector = injector;
        this.destroyRef = destroyRef;
        this.formComponentValidityDirective = formComponentValidityDirective;
        /**
         * Displays an asterisk after the label, indicating that the field is required.
         * @default false
         */
        this.required = false;
        /**
         * The icon is displayed next to the label.
         * Shows a help message when hovered.
         *
         * @default 'info'
         */
        this.helpInfoIcon = 'info';
        /**
         * `tabindex` attribute for the chip, to allow for keyboard navigation.
         *
         * @see {@link HTMLInputElement.prototype#tabindex}
         */
        this.tabindex = 0;
        /**
         * The size of the multiselect dropdown.
         * @see FieldSize
         * @default 'medium'
         */
        this.size = 'medium';
        /**
         * Whether the dropdown has filter input.
         * @default false
         */
        this.hasFilter = false;
        // endregion
        /**
         * Defines debounce wait time for the filter input.
         *
         * If `null`, default value is used.
         *
         * @default 300
         *
         * @see DebounceChangeDirective.debounceWait
         */
        this.debounceWait = null;
        // region states
        /**
         * Whether the selection panel is in error state.
         */
        this.hasLoadingError = false;
        /**
         * Whether the selection panel is in loading state.
         */
        this.isLoading = false;
        /**
         * Whether the component is disabled.
         */
        this.disabled = false;
        /**
         * Defines whether the filter input should be autofocused when selection menu is opened.
         *
         * @default true
         */
        this.hasFilterAutofocus = true;
        // region Outputs
        /**
         * Emits when a user clicks on the link which is displayed when the
         * selection-menu is in error state.
         */
        this.tryAgainClick = new EventEmitter();
        /**
         * Emits when a user changes selection, i.e., clicks on an item.
         */
        this.selectionChange = new EventEmitter();
        /**
         * Emits when a user types in the filter input.
         */
        this.filterChange = new EventEmitter();
        this.selectedLabels = [];
        this.isOverlayVisible = false;
        this.chipOverflow = false;
        this.dropdownItems$ = new BehaviorSubject([]);
        this.dropdownItems = new QueryList();
        this.dropdownContent = new QueryList();
        this._unfiltered = true;
        this._unfilteredDropdownItems = [];
        this.destroy$ = new Subject();
        // endregion
        this._selection = null;
        // region ControlValueAccessor
        /**
         * @internal
         */
        this.onModelChange = () => { };
        /**
         * @internal
         */
        this.onModelTouch = () => { };
    }
    /**
     * Selected items.
     */
    get selection() {
        return this._selection;
    }
    set selection(value) {
        this._selection = value;
        this.selectedLabels = this.getLabelOfSelectedItems(this._unfilteredDropdownItems, this._selection);
        this.calculateChipOverflow();
    }
    // endregion
    ngOnInit() {
        this.injector
            .get(NgControl, null, {
            optional: true,
        })
            ?.control?.statusChanges.pipe(safeTakeUntilDestroyed(this.destroyRef))
            .subscribe(() => {
            this.cdr.markForCheck();
        });
    }
    ngAfterContentInit() {
        this.dropdownItems.changes
            .pipe(takeUntil(this.destroy$))
            .subscribe((items) => {
            this.selectedLabels = this.getLabelOfSelectedItems(this.dropdownItems.toArray(), this.selection);
            this.dropdownItems$.next(items);
            // Needed so that the selection remains persistent after the
            // dropdown items change due to filtering.
            if (this._unfiltered) {
                this._unfilteredDropdownItems =
                    this.dropdownItems.toArray();
            }
        });
        this.dropdownItems.notifyOnChanges();
        this.cdr.detectChanges();
    }
    /**
     * @internal
     */
    writeValue(value) {
        this.selection = value;
        this.cdr.detectChanges();
    }
    /**
     * @internal
     */
    registerOnChange(fn) {
        this.onModelChange = fn;
    }
    /**
     * @internal
     */
    registerOnTouched(fn) {
        this.onModelTouch = fn;
    }
    /**
     * @internal
     */
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
        this.cdr.detectChanges();
    }
    // region Used for calculating chip overflow
    onResize() {
        this.calculateChipOverflow();
    }
    /**
     * @internal
     */
    handleFilterChange(filter) {
        this._unfiltered = filter === '';
        this.filterChange.emit(filter);
    }
    /**
     * @internal
     */
    handleVisibilityChange(isVisible) {
        this.isOverlayVisible = isVisible;
        if (isVisible) {
            this.selectionMenu?.initFocusKeyManager();
        }
        this.onModelTouch();
        if (this.isOverlayVisible && this.hasFilterAutofocus) {
            this.selectionMenu?.focusFilter();
        }
    }
    /**
     * @internal
     */
    handleSelectionChange(event) {
        this.selection = event.selection;
        this.onModelChange(this.selection);
        this.selectionChange.emit(this.selection);
        this.selectedLabels = this.getLabelOfSelectedItems(this._unfilteredDropdownItems, this.selection);
        this.calculateChipOverflow();
    }
    /**
     * @internal
     */
    removeSelectionByChipLabel(label) {
        this.selection = this.selection?.filter((item) => {
            const itemLabel = this.dropdownItems.find((dropdownItem) => dropdownItem.value === item)?.label;
            return itemLabel !== label;
        });
        this.onModelChange(this.selection || []);
        this.selectionChange.emit(this.selection);
    }
    /**
     * @internal
     */
    getLabelOfSelectedItems(selectionMenuItems, selectedItems) {
        return selectionMenuItems
            .filter((item) => selectedItems?.includes(item.value))
            .map((item) => item.label);
    }
    /**
     * @internal
     * Calculate chip overflow
     */
    calculateChipOverflow() {
        // Change detection needs to happen both before (to get the correct
        // dimension for currentSelectionChipBoundary) and after (to update the
        // view with the new value of chipOverflow)
        this.cdr.detectChanges();
        if (this.currentSelectionChipBoundary !== undefined) {
            this.chipOverflow =
                this.currentSelectionChipBoundary.nativeElement.scrollWidth >
                    this.currentSelectionContainerBoundary.nativeElement
                        .clientWidth;
        }
        else {
            // if the chip boundary is not defined, we should assume that there
            // are no chips and no overflow
            this.chipOverflow = false;
        }
        this.cdr.detectChanges();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: MultiselectComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.Injector }, { token: i0.DestroyRef }, { token: FormComponentValidityDirective }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.3.12", type: MultiselectComponent, selector: "hive-multiselect", inputs: { label: "label", required: ["required", "required", booleanAttribute], helpInfoIcon: "helpInfoIcon", helpInfoMessage: "helpInfoMessage", errorMessages: "errorMessages", assistanceText: "assistanceText", tabindex: "tabindex", size: "size", placeholder: "placeholder", hasFilter: ["hasFilter", "hasFilter", booleanAttribute], debounceWait: "debounceWait", hasLoadingError: "hasLoadingError", isLoading: "isLoading", disabled: ["disabled", "disabled", booleanAttribute], hasFilterAutofocus: ["hasFilterAutofocus", "hasFilterAutofocus", booleanAttribute], selection: "selection" }, outputs: { tryAgainClick: "tryAgainClick", selectionChange: "selectionChange", filterChange: "filterChange" }, host: { listeners: { "window:resize": "onResize()" } }, providers: [
            SELECTION_MENU_PROVIDER,
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => MultiselectComponent),
                multi: true,
            },
        ], queries: [{ propertyName: "dropdownItems", predicate: SelectionMenuItemComponent, descendants: true }, { propertyName: "dropdownContent", predicate: SELECTION_MENU_CONTENT, descendants: true }], viewQueries: [{ propertyName: "currentSelectionContainerBoundary", first: true, predicate: ["currentSelectionContainerBoundary"], descendants: true }, { propertyName: "currentSelectionChipBoundary", first: true, predicate: ["currentSelectionChipBoundary"], descendants: true }, { propertyName: "selectionMenu", first: true, predicate: ["selectionMenu"], descendants: true }, { propertyName: "selectionListOverlay", first: true, predicate: ["selectionMenuOverlay"], descendants: true }], hostDirectives: [{ directive: HiveThemedDirective }, { directive: FormComponentValidityDirective }], ngImport: i0, template: "<hive-form-input-base\n    [label]=\"label\"\n    [required]=\"formComponentValidityDirective.required || required\"\n    [helpInfoIcon]=\"helpInfoIcon\"\n    [helpInfoMessage]=\"helpInfoMessage\"\n    [errorMessages]=\"errorMessages\"\n    [hasError]=\"formComponentValidityDirective.invalid\"\n    [assistanceText]=\"assistanceText\"\n    [disabled]=\"disabled\"\n>\n    <div\n        data-testid=\"hive-multiselect-dropdown-container\"\n        class=\"hive-multiselect-dropdown-container\"\n        shouldToggle\n        [class.hive-multiselect-dropdown-container--disabled]=\"disabled\"\n        [class.hive-multiselect-dropdown-container--invalid]=\"\n            formComponentValidityDirective.invalid\n        \"\n        [class.hive-multiselect-dropdown-container--opened]=\"isOverlayVisible\"\n        [ngClass]=\"['hive-multiselect-dropdown-container--' + size]\"\n        [attr.aria-invalid]=\"formComponentValidityDirective.invalid\"\n        [hiveOverlayTrigger]=\"selectionMenuOverlay\"\n        [tabindex]=\"disabled ? -1 : tabindex\"\n    >\n        <div\n            class=\"hive-multiselect-dropdown-current-selection-container\"\n            #currentSelectionContainerBoundary\n        >\n            @if ((selectedLabels | isDefined) && selectedLabels.length > 0) {\n                <div\n                    class=\"hive-multiselect-dropdown-current-selection\"\n                    #currentSelectionChipBoundary\n                >\n                    @for (label of selectedLabels; track label) {\n                        @if (label | isDefined) {\n                            <hive-chip\n                                closable\n                                [value]=\"label\"\n                                [size]=\"size === 'small' ? 'smallest' : 'small'\"\n                                [disabled]=\"disabled\"\n                                (chipClose)=\"removeSelectionByChipLabel(label!)\"\n                            ></hive-chip>\n                        }\n                    }\n                </div>\n            } @else {\n                <span class=\"hive-multiselect-dropdown_placeholder\">\n                    {{ placeholder }}\n                </span>\n            }\n        </div>\n\n        @if (chipOverflow) {\n            <hive-label\n                class=\"hive-multiselect-chip-overflow-ellipsis\"\n                size=\"medium\"\n                weight=\"regular\"\n                label=\"&hellip;\"\n            ></hive-label>\n        }\n\n        <div class=\"hive-multiselect-error-icon-container\">\n            @if (formComponentValidityDirective.invalid) {\n                <hive-icon-component\n                    class=\"hive-multiselect-dropdown-error-icon\"\n                    icon=\"light/circle-exclamation.svg\"\n                    size=\"medium\"\n                ></hive-icon-component>\n            }\n        </div>\n\n        <div class=\"hive-multiselect-dropdown-icon-container\">\n            <hive-icon-component\n                hiveChevron\n                size=\"medium\"\n                icon=\"light/chevron-down.svg\"\n                [rotated]=\"isOverlayVisible\"\n            ></hive-icon-component>\n        </div>\n    </div>\n</hive-form-input-base>\n\n<hive-overlay\n    #selectionMenuOverlay\n    (visibilityChange)=\"handleVisibilityChange($event)\"\n    takeWidthFromTrigger\n    closeOnPageResize\n>\n    <hive-selection-menu\n        #selectionMenu\n        class=\"hive-multiselect-dropdown_selection-menu\"\n        [selectionItems]=\"$any(dropdownItems$ | async)\"\n        [selectionContent]=\"dropdownContent.toArray()\"\n        [selection]=\"(selection | isDefined) ? selection : []\"\n        [hasFilter]=\"hasFilter\"\n        [multiselect]=\"true\"\n        [hasLoadingError]=\"hasLoadingError\"\n        [isLoading]=\"isLoading\"\n        [debounceWait]=\"debounceWait\"\n        (selectionChange)=\"handleSelectionChange($event)\"\n        (tryAgainClick)=\"tryAgainClick.emit()\"\n        (filterChange)=\"handleFilterChange($event)\"\n    >\n        <ng-container\n            ngProjectAs=\"hive-selection-menu-item, hive-selection-menu-section, ng-container\"\n        >\n            <ng-content\n                select=\"hive-selection-menu-item, hive-selection-menu-section, ng-container\"\n            ></ng-content>\n        </ng-container>\n    </hive-selection-menu>\n</hive-overlay>\n", dependencies: [{ kind: "directive", type: i2$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "component", type: FormInputBaseComponent, selector: "hive-form-input-base", inputs: ["label", "for", "required", "disabled", "helpInfoIcon", "helpInfoMessage", "errorMessages", "hasError", "assistanceText", "horizontalAlignment", "increasedContentGap"] }, { kind: "component", type: IconComponent, selector: "hive-icon-component", inputs: ["icon", "size"] }, { kind: "directive", type: OverlayTriggerDirective, selector: "[hiveOverlayTrigger]", inputs: ["disabled", "hiveOverlayTrigger", "shouldToggle"] }, { kind: "component", type: OverlayComponent, selector: "hive-overlay", inputs: ["takeWidthFromTrigger", "closeOnPageResize", "panelClass", "backdropClass", "position", "offsetX", "offsetY", "closeOnBackdropClick", "closeOnOutsideClick", "hasBackdrop", "overlayMinWidth"], outputs: ["visibilityChange"] }, { kind: "component", type: SelectionMenuComponent, selector: "hive-selection-menu", inputs: ["selectionItems", "selectionContent", "hasFilter", "multiselect", "hasLoadingError", "isLoading", "debounceWait", "hideSeparators", "selection"], outputs: ["selectionChange", "tryAgainClick", "filterChange"] }, { kind: "component", type: ChipComponent, selector: "hive-chip", inputs: ["icon", "size", "property", "value", "selectable", "disabled", "tabindex", "closable", "selected", "hasError", "showNewChipAnimation", "highlightNewChip"], outputs: ["chipClose", "selectedChange"] }, { kind: "component", type: LabelComponent, selector: "hive-label", inputs: ["label", "for", "size", "weight", "maxWeight", "horizontalAlignment", "leftIconHelpInfoMessage", "rightIconHelpInfoMessage", "leftIcon", "rightIcon", "required", "textOverflowEllipsis"] }, { kind: "directive", type: ChevronDirective, selector: "hive-icon-component[hiveChevron]", inputs: ["rotationDirection", "rotated"] }, { kind: "pipe", type: i2$1.AsyncPipe, name: "async" }, { kind: "pipe", type: IsDefinedPipe, name: "isDefined" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: MultiselectComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hive-multiselect', changeDetection: ChangeDetectionStrategy.OnPush, hostDirectives: [HiveThemedDirective, FormComponentValidityDirective], providers: [
                        SELECTION_MENU_PROVIDER,
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => MultiselectComponent),
                            multi: true,
                        },
                    ], template: "<hive-form-input-base\n    [label]=\"label\"\n    [required]=\"formComponentValidityDirective.required || required\"\n    [helpInfoIcon]=\"helpInfoIcon\"\n    [helpInfoMessage]=\"helpInfoMessage\"\n    [errorMessages]=\"errorMessages\"\n    [hasError]=\"formComponentValidityDirective.invalid\"\n    [assistanceText]=\"assistanceText\"\n    [disabled]=\"disabled\"\n>\n    <div\n        data-testid=\"hive-multiselect-dropdown-container\"\n        class=\"hive-multiselect-dropdown-container\"\n        shouldToggle\n        [class.hive-multiselect-dropdown-container--disabled]=\"disabled\"\n        [class.hive-multiselect-dropdown-container--invalid]=\"\n            formComponentValidityDirective.invalid\n        \"\n        [class.hive-multiselect-dropdown-container--opened]=\"isOverlayVisible\"\n        [ngClass]=\"['hive-multiselect-dropdown-container--' + size]\"\n        [attr.aria-invalid]=\"formComponentValidityDirective.invalid\"\n        [hiveOverlayTrigger]=\"selectionMenuOverlay\"\n        [tabindex]=\"disabled ? -1 : tabindex\"\n    >\n        <div\n            class=\"hive-multiselect-dropdown-current-selection-container\"\n            #currentSelectionContainerBoundary\n        >\n            @if ((selectedLabels | isDefined) && selectedLabels.length > 0) {\n                <div\n                    class=\"hive-multiselect-dropdown-current-selection\"\n                    #currentSelectionChipBoundary\n                >\n                    @for (label of selectedLabels; track label) {\n                        @if (label | isDefined) {\n                            <hive-chip\n                                closable\n                                [value]=\"label\"\n                                [size]=\"size === 'small' ? 'smallest' : 'small'\"\n                                [disabled]=\"disabled\"\n                                (chipClose)=\"removeSelectionByChipLabel(label!)\"\n                            ></hive-chip>\n                        }\n                    }\n                </div>\n            } @else {\n                <span class=\"hive-multiselect-dropdown_placeholder\">\n                    {{ placeholder }}\n                </span>\n            }\n        </div>\n\n        @if (chipOverflow) {\n            <hive-label\n                class=\"hive-multiselect-chip-overflow-ellipsis\"\n                size=\"medium\"\n                weight=\"regular\"\n                label=\"&hellip;\"\n            ></hive-label>\n        }\n\n        <div class=\"hive-multiselect-error-icon-container\">\n            @if (formComponentValidityDirective.invalid) {\n                <hive-icon-component\n                    class=\"hive-multiselect-dropdown-error-icon\"\n                    icon=\"light/circle-exclamation.svg\"\n                    size=\"medium\"\n                ></hive-icon-component>\n            }\n        </div>\n\n        <div class=\"hive-multiselect-dropdown-icon-container\">\n            <hive-icon-component\n                hiveChevron\n                size=\"medium\"\n                icon=\"light/chevron-down.svg\"\n                [rotated]=\"isOverlayVisible\"\n            ></hive-icon-component>\n        </div>\n    </div>\n</hive-form-input-base>\n\n<hive-overlay\n    #selectionMenuOverlay\n    (visibilityChange)=\"handleVisibilityChange($event)\"\n    takeWidthFromTrigger\n    closeOnPageResize\n>\n    <hive-selection-menu\n        #selectionMenu\n        class=\"hive-multiselect-dropdown_selection-menu\"\n        [selectionItems]=\"$any(dropdownItems$ | async)\"\n        [selectionContent]=\"dropdownContent.toArray()\"\n        [selection]=\"(selection | isDefined) ? selection : []\"\n        [hasFilter]=\"hasFilter\"\n        [multiselect]=\"true\"\n        [hasLoadingError]=\"hasLoadingError\"\n        [isLoading]=\"isLoading\"\n        [debounceWait]=\"debounceWait\"\n        (selectionChange)=\"handleSelectionChange($event)\"\n        (tryAgainClick)=\"tryAgainClick.emit()\"\n        (filterChange)=\"handleFilterChange($event)\"\n    >\n        <ng-container\n            ngProjectAs=\"hive-selection-menu-item, hive-selection-menu-section, ng-container\"\n        >\n            <ng-content\n                select=\"hive-selection-menu-item, hive-selection-menu-section, ng-container\"\n            ></ng-content>\n        </ng-container>\n    </hive-selection-menu>\n</hive-overlay>\n" }]
        }], ctorParameters: () => [{ type: i0.ChangeDetectorRef }, { type: i0.Injector }, { type: i0.DestroyRef }, { type: FormComponentValidityDirective }], propDecorators: { label: [{
                type: Input
            }], required: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], helpInfoIcon: [{
                type: Input
            }], helpInfoMessage: [{
                type: Input
            }], errorMessages: [{
                type: Input
            }], assistanceText: [{
                type: Input
            }], tabindex: [{
                type: Input
            }], size: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], hasFilter: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], debounceWait: [{
                type: Input
            }], hasLoadingError: [{
                type: Input
            }], isLoading: [{
                type: Input
            }], disabled: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], hasFilterAutofocus: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], tryAgainClick: [{
                type: Output
            }], selectionChange: [{
                type: Output
            }], filterChange: [{
                type: Output
            }], currentSelectionContainerBoundary: [{
                type: ViewChild,
                args: ['currentSelectionContainerBoundary']
            }], currentSelectionChipBoundary: [{
                type: ViewChild,
                args: ['currentSelectionChipBoundary']
            }], selectionMenu: [{
                type: ViewChild,
                args: ['selectionMenu']
            }], selectionListOverlay: [{
                type: ViewChild,
                args: ['selectionMenuOverlay']
            }], dropdownItems: [{
                type: ContentChildren,
                args: [SelectionMenuItemComponent, { descendants: true }]
            }], dropdownContent: [{
                type: ContentChildren,
                args: [SELECTION_MENU_CONTENT, { descendants: true }]
            }], selection: [{
                type: Input
            }], onResize: [{
                type: HostListener,
                args: ['window:resize']
            }] } });

class MultiselectModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: MultiselectModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: MultiselectModule, declarations: [MultiselectComponent], imports: [CommonModule,
            FormsModule,
            ReactiveFormsModule,
            LoadingSpinnerComponent,
            FormInputBaseComponent,
            CheckboxComponent,
            IconComponent,
            OverlayTriggerDirective,
            OverlayComponent,
            SelectionMenuModule,
            ChipComponent,
            IsDefinedPipe,
            LabelComponent,
            ChevronDirective], exports: [MultiselectComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: MultiselectModule, imports: [CommonModule,
            FormsModule,
            ReactiveFormsModule,
            LoadingSpinnerComponent,
            FormInputBaseComponent,
            CheckboxComponent,
            IconComponent,
            OverlayComponent,
            SelectionMenuModule,
            ChipComponent,
            LabelComponent] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: MultiselectModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [MultiselectComponent],
                    imports: [
                        CommonModule,
                        FormsModule,
                        ReactiveFormsModule,
                        LoadingSpinnerComponent,
                        FormInputBaseComponent,
                        CheckboxComponent,
                        IconComponent,
                        OverlayTriggerDirective,
                        OverlayComponent,
                        SelectionMenuModule,
                        ChipComponent,
                        IsDefinedPipe,
                        LabelComponent,
                        ChevronDirective,
                    ],
                    exports: [MultiselectComponent],
                }]
        }] });

const PageBaseLayoutAnimations = {
    navigationSlideInOutTrigger: trigger('navigationSlideInOutTrigger', [
        state('void', style({ transform: 'translateX(-100%)' })),
        state('*', style({ transform: 'translateX(0)' })),
        transition('void <=> *', [animate('0.3s ease')]),
    ]),
    headerSlideInOutTrigger: trigger('headerSlideInOutTrigger', [
        state('void', style({ transform: 'translateY(-100%)' })),
        state('*', style({ transform: 'translateY(0)' })),
        transition('void <=> *', [animate('0.3s ease')]),
    ]),
    overlayFadeInOutTrigger: trigger('overlayFadeInOutTrigger', [
        state('void', style({ opacity: 0 })),
        state('*', style({ opacity: 1 })),
        transition('void <=> *', [animate('0.3s ease')]),
    ]),
};

/**
 * The Page Base Layout component is a wrapper for the entire application. It
 * uses content projection to position a supplied hive-app-header and hive-app-navigation
 * menu, and handles the interaction between them both. It also provides a space for
 * router-outlet to render the current route's component.
 */
class PageBaseLayoutComponent {
    constructor(layoutService, navigationStateService, appHeaderStateService, destroyRef, changeDetectorRef) {
        this.layoutService = layoutService;
        this.navigationStateService = navigationStateService;
        this.appHeaderStateService = appHeaderStateService;
        this.destroyRef = destroyRef;
        this.changeDetectorRef = changeDetectorRef;
        /**
         * Whether to force hiding the navigation menu. If true, the left-hand navigation
         * will be hidden, and the page content will take the full width, regardless
         * of the value of the `navigationOpen` property.
         *
         * @default false
         */
        this.forceHideNavigation = false;
        /**
         * Whether to force hiding the header.
         */
        this.forceHideHeader = false;
        /**
         * Whenever user clicks on the backdrop, or the burger menu button, this event will be emitted with the new state.
         */
        this.navigationOpenChange = this.navigationStateService.navigationOpenChange;
        /**
         * @internal
         */
        this.navigationOpen$ = this.navigationStateService.open$;
        this.headerHidden$ = this.appHeaderStateService.hidden$;
        this.headerVisible$ = this.appHeaderStateService.visible$;
        this.isLargeScreen$ = this.layoutService.isLargeScreen$;
        this.displayBackdrop$ = combineLatest([
            this.navigationOpen$,
            this.isLargeScreen$,
        ]).pipe(map(([navigationOpen, isLargeScreen]) => navigationOpen && !isLargeScreen));
    }
    /**
     * Controls the state of the navigation panel.
     *
     * @internal
     */
    set navigationOpen(value) {
        this.navigationStateService.toggleOpen(value, false);
    }
    /**
     * @internal
     */
    handleBackdropClick() {
        this.navigationStateService.toggleOpen(false);
    }
    ngAfterViewInit() {
        this.isLargeScreen$
            .pipe(safeTakeUntilDestroyed(this.destroyRef))
            .subscribe((isLargeScreen) => {
            this.navigationStateService.toggleOpen(isLargeScreen);
            this.changeDetectorRef.detectChanges();
        });
    }
    ngOnChanges(changes) {
        if ('forceHideNavigation' in changes) {
            this.navigationStateService.toggleForceHidden(this.forceHideNavigation);
        }
        if ('forceHideHeader' in changes) {
            this.appHeaderStateService.toggleHidden(this.forceHideHeader, false);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PageBaseLayoutComponent, deps: [{ token: LayoutService }, { token: LeftNavigationStateService }, { token: AppHeaderStateService }, { token: i0.DestroyRef }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.3.12", type: PageBaseLayoutComponent, isStandalone: true, selector: "hive-page-base-layout", inputs: { forceHideNavigation: ["forceHideNavigation", "forceHideNavigation", booleanAttribute], forceHideHeader: ["forceHideHeader", "forceHideHeader", booleanAttribute], navigationOpen: ["navigationOpen", "navigationOpen", booleanAttribute] }, outputs: { navigationOpenChange: "navigationOpenChange" }, usesOnChanges: true, ngImport: i0, template: "<div\n    class=\"hive-page-base-layout\"\n    [class.hive-page-base-layout--navigation-hidden]=\"\n        (navigationOpen$ | async) === false\n    \"\n    [class.hive-page-base-layout--header-hidden]=\"headerHidden$ | async\"\n    [class.hive-page-base-layout--large-screen]=\"isLargeScreen$ | async\"\n>\n    @if (headerVisible$ | async) {\n        <div\n            [@headerSlideInOutTrigger]=\"true\"\n            class=\"hive-page-base-layout__header\"\n        >\n            <ng-content select=\"hive-app-header\"></ng-content>\n        </div>\n    }\n\n    @if (navigationOpen$ | async; as isNavigationOpen) {\n        <div\n            [@navigationSlideInOutTrigger]=\"isNavigationOpen\"\n            class=\"hive-page-base-layout__navigation\"\n            [class.hive-page-base-layout__navigation--large-screen]=\"\n                isLargeScreen$ | async\n            \"\n        >\n            <ng-content\n                select=\"hive-left-navigation,hive-app-navigation\"\n            ></ng-content>\n        </div>\n    }\n\n    <div class=\"hive-page-base-layout__content\">\n        <ng-content></ng-content>\n    </div>\n\n    @if (displayBackdrop$ | async) {\n        <div\n            [@overlayFadeInOutTrigger]=\"navigationOpen$ | async\"\n            class=\"hive-page-base-layout__backdrop\"\n            (click)=\"handleBackdropClick()\"\n        ></div>\n    }\n</div>\n", dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "pipe", type: i2$1.AsyncPipe, name: "async" }], animations: [
            PageBaseLayoutAnimations.navigationSlideInOutTrigger,
            PageBaseLayoutAnimations.headerSlideInOutTrigger,
            PageBaseLayoutAnimations.overlayFadeInOutTrigger,
        ] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PageBaseLayoutComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hive-page-base-layout', standalone: true, imports: [CommonModule], animations: [
                        PageBaseLayoutAnimations.navigationSlideInOutTrigger,
                        PageBaseLayoutAnimations.headerSlideInOutTrigger,
                        PageBaseLayoutAnimations.overlayFadeInOutTrigger,
                    ], template: "<div\n    class=\"hive-page-base-layout\"\n    [class.hive-page-base-layout--navigation-hidden]=\"\n        (navigationOpen$ | async) === false\n    \"\n    [class.hive-page-base-layout--header-hidden]=\"headerHidden$ | async\"\n    [class.hive-page-base-layout--large-screen]=\"isLargeScreen$ | async\"\n>\n    @if (headerVisible$ | async) {\n        <div\n            [@headerSlideInOutTrigger]=\"true\"\n            class=\"hive-page-base-layout__header\"\n        >\n            <ng-content select=\"hive-app-header\"></ng-content>\n        </div>\n    }\n\n    @if (navigationOpen$ | async; as isNavigationOpen) {\n        <div\n            [@navigationSlideInOutTrigger]=\"isNavigationOpen\"\n            class=\"hive-page-base-layout__navigation\"\n            [class.hive-page-base-layout__navigation--large-screen]=\"\n                isLargeScreen$ | async\n            \"\n        >\n            <ng-content\n                select=\"hive-left-navigation,hive-app-navigation\"\n            ></ng-content>\n        </div>\n    }\n\n    <div class=\"hive-page-base-layout__content\">\n        <ng-content></ng-content>\n    </div>\n\n    @if (displayBackdrop$ | async) {\n        <div\n            [@overlayFadeInOutTrigger]=\"navigationOpen$ | async\"\n            class=\"hive-page-base-layout__backdrop\"\n            (click)=\"handleBackdropClick()\"\n        ></div>\n    }\n</div>\n" }]
        }], ctorParameters: () => [{ type: LayoutService }, { type: LeftNavigationStateService }, { type: AppHeaderStateService }, { type: i0.DestroyRef }, { type: i0.ChangeDetectorRef }], propDecorators: { forceHideNavigation: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], forceHideHeader: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], navigationOpenChange: [{
                type: Output
            }], navigationOpen: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }] } });

class PageBaseLayoutModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PageBaseLayoutModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: PageBaseLayoutModule, imports: [CommonModule,
            AppHeaderModule,
            LeftNavigationModule,
            PageBaseLayoutComponent], exports: [PageBaseLayoutComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PageBaseLayoutModule, imports: [CommonModule,
            AppHeaderModule,
            LeftNavigationModule,
            PageBaseLayoutComponent] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PageBaseLayoutModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        AppHeaderModule,
                        LeftNavigationModule,
                        PageBaseLayoutComponent,
                    ],
                    exports: [PageBaseLayoutComponent],
                }]
        }] });

/**
 * This component is used to display a text area.
 * It can be used to display a text area with a label, help info, error messages,
 * and assistance text.
 *
 * @example
 * <hive-text-area
 *    label="Example text area"
 *    [disabled]="false"
 *    size="large"
 *    helpInfoMessage="Your info message"
 *    helpInfoIcon="question"
 *    placeholder="Start typing"
 *    [readonly]="false"
 *    assistanceText="Assistance text"
 *    [errorMessages]="['Error message']"
 * ></hive-text-area>
 */
class TextAreaComponent {
    constructor(cdr, injector, destroyRef, formComponentValidityDirective) {
        this.cdr = cdr;
        this.injector = injector;
        this.destroyRef = destroyRef;
        this.formComponentValidityDirective = formComponentValidityDirective;
        /**
         * Use to specify sizing of the component
         */
        this.size = 'small';
        /**
         * Native `blur` event of `<input type="text" />`
         *
         * @see HTMLInputElement
         */
        this.blur = new EventEmitter();
        /**
         * Native `input` event of `<input type="text" />`
         *
         * @see HTMLInputElement
         */
        this.input = new EventEmitter();
        /**
         * Native `focus` event of text-area.
         *
         * @see HTMLTextAreaElement
         */
        this.focus = new EventEmitter();
        this._id = uniqueId('hive-text-area--');
        this._readonly = false;
        this._value = '';
        this._disabled = false;
        /**
         * @internal
         */
        this.onModelChange = () => { };
        /**
         * @internal
         */
        this.onModelTouch = () => { };
    }
    /**
     * When present, it specifies that the component cannot be edited.
     */
    get readonly() {
        return this._readonly;
    }
    set readonly(value) {
        this._readonly = coerceBooleanProperty(value);
    }
    get value() {
        return this._value;
    }
    set value(val) {
        this._value = val ?? '';
        this.onModelChange(val);
        this.onModelTouch();
    }
    /**
     * Use to disable the field
     */
    get disabled() {
        return this._disabled;
    }
    set disabled(value) {
        this._disabled = coerceBooleanProperty(value);
    }
    get textAreaClass() {
        return {
            ['hive-text-area-input-container-size--' + this.size]: true,
            'hive-text-area-input-container--disabled': this._disabled,
            'hive-text-area-input-container--error': this.formComponentValidityDirective.invalid,
        };
    }
    /**
     * @internal
     */
    writeValue(value) {
        this._value = value;
        this.cdr.detectChanges();
    }
    /**
     * @internal
     */
    registerOnChange(fn) {
        this.onModelChange = fn;
    }
    /**
     * @internal
     */
    registerOnTouched(fn) {
        this.onModelTouch = fn;
    }
    /**
     * @internal
     */
    setDisabledState(isDisabled) {
        this._disabled = isDisabled;
        this.cdr.detectChanges();
    }
    ngOnInit() {
        this.injector
            .get(NgControl, null, {
            optional: true,
        })
            ?.control?.statusChanges.pipe(safeTakeUntilDestroyed(this.destroyRef))
            .subscribe(() => {
            this.cdr.markForCheck();
        });
    }
    handleBlur(e) {
        this.onModelTouch();
        this.blur.emit(e);
    }
    handleInput(e) {
        if (this._disabled || this.readonly) {
            return;
        }
        this.input.emit(e);
        this.onModelChange(e.target?.value);
    }
    handleChange(e) {
        if (this._disabled || this.readonly) {
            return;
        }
        this.onModelChange(e.target?.value);
    }
    handleFocus(e) {
        this.focus.emit(e);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TextAreaComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.Injector }, { token: i0.DestroyRef }, { token: FormComponentValidityDirective }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.3.12", type: TextAreaComponent, isStandalone: true, selector: "hive-text-area", inputs: { label: "label", size: "size", helpInfoMessage: "helpInfoMessage", helpInfoIcon: "helpInfoIcon", placeholder: "placeholder", errorMessages: "errorMessages", assistanceText: "assistanceText", maxLength: ["maxLength", "maxLength", numberAttribute], name: "name", required: ["required", "required", booleanAttribute], readonly: "readonly", value: "value", disabled: "disabled" }, outputs: { blur: "blur", input: "input", focus: "focus" }, providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => TextAreaComponent),
                multi: true,
            },
        ], hostDirectives: [{ directive: HiveThemedDirective }, { directive: FormComponentValidityDirective }], ngImport: i0, template: "<hive-form-input-base\n    class=\"hive-text-area-input-wrapper\"\n    [for]=\"_id\"\n    [assistanceText]=\"assistanceText\"\n    [errorMessages]=\"errorMessages\"\n    [hasError]=\"formComponentValidityDirective.invalid\"\n    [helpInfoIcon]=\"helpInfoIcon\"\n    [helpInfoMessage]=\"helpInfoMessage\"\n    [label]=\"label\"\n    [required]=\"formComponentValidityDirective.required || required\"\n    [disabled]=\"disabled\"\n>\n    <div\n        [ngClass]=\"textAreaClass\"\n        [attr.disabled]=\"_disabled || null\"\n        class=\"hive-text-area-input-container\"\n    >\n        <textarea\n            class=\"hive-text-area-input\"\n            cols=\"auto\"\n            [id]=\"_id\"\n            [disabled]=\"_disabled\"\n            [attr.maxLength]=\"maxLength || null\"\n            [attr.name]=\"name || null\"\n            [(ngModel)]=\"value\"\n            [attr.aria-invalid]=\"formComponentValidityDirective.invalid\"\n            [attr.placeholder]=\"placeholder || null\"\n            [attr.readonly]=\"readonly || null\"\n            (input)=\"handleInput($event)\"\n            (change)=\"handleChange($event)\"\n            (blur)=\"handleBlur($event)\"\n            (focus)=\"handleFocus($event)\"\n        ></textarea>\n\n        <div class=\"hive-text-area-icon-container\">\n            @if (formComponentValidityDirective.invalid) {\n                <hive-icon-component\n                    class=\"hive-text-area-error-icon\"\n                    icon=\"light/circle-exclamation.svg\"\n                    size=\"medium\"\n                ></hive-icon-component>\n            }\n        </div>\n    </div>\n</hive-form-input-base>\n", dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i2$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "ngmodule", type: FormsModule }, { kind: "directive", type: i1$3.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1$3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$3.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "ngmodule", type: ReactiveFormsModule }, { kind: "component", type: FormInputBaseComponent, selector: "hive-form-input-base", inputs: ["label", "for", "required", "disabled", "helpInfoIcon", "helpInfoMessage", "errorMessages", "hasError", "assistanceText", "horizontalAlignment", "increasedContentGap"] }, { kind: "component", type: IconComponent, selector: "hive-icon-component", inputs: ["icon", "size"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TextAreaComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hive-text-area', standalone: true, imports: [
                        CommonModule,
                        FormsModule,
                        ReactiveFormsModule,
                        FormInputBaseComponent,
                        IconComponent,
                    ], changeDetection: ChangeDetectionStrategy.OnPush, hostDirectives: [HiveThemedDirective, FormComponentValidityDirective], providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => TextAreaComponent),
                            multi: true,
                        },
                    ], template: "<hive-form-input-base\n    class=\"hive-text-area-input-wrapper\"\n    [for]=\"_id\"\n    [assistanceText]=\"assistanceText\"\n    [errorMessages]=\"errorMessages\"\n    [hasError]=\"formComponentValidityDirective.invalid\"\n    [helpInfoIcon]=\"helpInfoIcon\"\n    [helpInfoMessage]=\"helpInfoMessage\"\n    [label]=\"label\"\n    [required]=\"formComponentValidityDirective.required || required\"\n    [disabled]=\"disabled\"\n>\n    <div\n        [ngClass]=\"textAreaClass\"\n        [attr.disabled]=\"_disabled || null\"\n        class=\"hive-text-area-input-container\"\n    >\n        <textarea\n            class=\"hive-text-area-input\"\n            cols=\"auto\"\n            [id]=\"_id\"\n            [disabled]=\"_disabled\"\n            [attr.maxLength]=\"maxLength || null\"\n            [attr.name]=\"name || null\"\n            [(ngModel)]=\"value\"\n            [attr.aria-invalid]=\"formComponentValidityDirective.invalid\"\n            [attr.placeholder]=\"placeholder || null\"\n            [attr.readonly]=\"readonly || null\"\n            (input)=\"handleInput($event)\"\n            (change)=\"handleChange($event)\"\n            (blur)=\"handleBlur($event)\"\n            (focus)=\"handleFocus($event)\"\n        ></textarea>\n\n        <div class=\"hive-text-area-icon-container\">\n            @if (formComponentValidityDirective.invalid) {\n                <hive-icon-component\n                    class=\"hive-text-area-error-icon\"\n                    icon=\"light/circle-exclamation.svg\"\n                    size=\"medium\"\n                ></hive-icon-component>\n            }\n        </div>\n    </div>\n</hive-form-input-base>\n" }]
        }], ctorParameters: () => [{ type: i0.ChangeDetectorRef }, { type: i0.Injector }, { type: i0.DestroyRef }, { type: FormComponentValidityDirective }], propDecorators: { label: [{
                type: Input
            }], size: [{
                type: Input
            }], helpInfoMessage: [{
                type: Input
            }], helpInfoIcon: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], errorMessages: [{
                type: Input
            }], assistanceText: [{
                type: Input
            }], maxLength: [{
                type: Input,
                args: [{ transform: numberAttribute }]
            }], name: [{
                type: Input
            }], required: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], blur: [{
                type: Output
            }], input: [{
                type: Output
            }], focus: [{
                type: Output
            }], readonly: [{
                type: Input
            }], value: [{
                type: Input
            }], disabled: [{
                type: Input
            }] } });

/**
 * Tag component used to categorize or organize content in application or website.
 *
 * @example
 * <hive-tag severity="info" label="Info"></hive-tag>
 * <hive-tag severity="success" label="Success"></hive-tag>
 * <hive-tag size="small" severity="warning" label="Warning"></hive-tag>
 */
class TagComponent {
    constructor() {
        /**
         * Indicates the severity of the tag component.
         */
        this.severity = 'unknown';
        /**
         * Text that appears in the tag component.
         */
        this.label = 'Example tag';
        /**
         * Size of the tag component.
         */
        this.size = 'smallest';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TagComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: TagComponent, isStandalone: true, selector: "hive-tag", inputs: { severity: "severity", label: "label", size: "size" }, host: { properties: { "attr.data-severity": "this.severity" } }, hostDirectives: [{ directive: HiveThemedDirective }], ngImport: i0, template: `
        <hive-label
            class="hive-tag_label"
            [size]="size"
            weight="semibold"
            [label]="label"
        ></hive-label>
    `, isInline: true, dependencies: [{ kind: "component", type: LabelComponent, selector: "hive-label", inputs: ["label", "for", "size", "weight", "maxWeight", "horizontalAlignment", "leftIconHelpInfoMessage", "rightIconHelpInfoMessage", "leftIcon", "rightIcon", "required", "textOverflowEllipsis"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TagComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'hive-tag',
                    template: `
        <hive-label
            class="hive-tag_label"
            [size]="size"
            weight="semibold"
            [label]="label"
        ></hive-label>
    `,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    hostDirectives: [HiveThemedDirective],
                    standalone: true,
                    imports: [LabelComponent],
                }]
        }], propDecorators: { severity: [{
                type: HostBinding,
                args: ['attr.data-severity']
            }, {
                type: Input
            }], label: [{
                type: Input
            }], size: [{
                type: Input
            }] } });

class KeyValueComponent {
    constructor() {
        this.type = 'complex';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: KeyValueComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: KeyValueComponent, isStandalone: true, selector: "hive-key-value", inputs: { value: "value", icon: "icon", type: "type" }, hostDirectives: [{ directive: HiveThemedDirective }], ngImport: i0, template: `
        <div class="hive-key-value">
            <div
                class="hive-key-value_key"
                [ngClass]="{
                    'hive-key-value_key-simple--vertical':
                        type === 'simple-vertical',
                    'hive-key-value_key-simple--horizontal':
                        type === 'simple-horizontal',
                }"
            >
                <ng-content select="a[hive-link], hive-label" />
            </div>

            <div class="hive-key-value_value">
                <div class="hive-key-value_counter">{{ value }}</div>

                <div class="hive-key-value_icon-container">
                    <hive-icon-component
                        class="hive-key-value_icon"
                        [icon]="icon"
                        size="2x-large"
                    />
                </div>
            </div>
        </div>
    `, isInline: true, dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i2$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "component", type: IconComponent, selector: "hive-icon-component", inputs: ["icon", "size"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: KeyValueComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'hive-key-value',
                    template: `
        <div class="hive-key-value">
            <div
                class="hive-key-value_key"
                [ngClass]="{
                    'hive-key-value_key-simple--vertical':
                        type === 'simple-vertical',
                    'hive-key-value_key-simple--horizontal':
                        type === 'simple-horizontal',
                }"
            >
                <ng-content select="a[hive-link], hive-label" />
            </div>

            <div class="hive-key-value_value">
                <div class="hive-key-value_counter">{{ value }}</div>

                <div class="hive-key-value_icon-container">
                    <hive-icon-component
                        class="hive-key-value_icon"
                        [icon]="icon"
                        size="2x-large"
                    />
                </div>
            </div>
        </div>
    `,
                    standalone: true,
                    hostDirectives: [HiveThemedDirective],
                    imports: [CommonModule, IconComponent, LinkComponent, LabelComponent],
                }]
        }], propDecorators: { value: [{
                type: Input
            }], icon: [{
                type: Input
            }], type: [{
                type: Input
            }] } });

const TAB_VIEW_SCROLL_DEBOUNCE_TIME = 50;
/**
 * Tab View allows users to navigate through different sets of content within an application or website.
 *
 * ### Content Projection
 *
 * `hive-tab-view` consists of `hive-tab-panel` components, each representing a single tab.
 *
 * Each `hive-tab-view` component can have it's own content which
 * will be projected underneath the tabs when the tab is selected.
 *
 * ### Inputs
 *
 * Selection is defined by 0-based `activeIndex` input which sets respective tab
 * as `selected`.
 *
 * If it's expected that `hive-tab-view` will have more tabs than can fit in the viewport,
 * set `overflow` to `true` to have tabs scrollable.
 *
 * ### Outputs
 *
 * Changing active tab by user interaction will emit `activeIndexChange` `EventEmitter`
 * with an index of an activated tab.
 */
class TabViewComponent {
    /**
     * Sets the index of the active tab.
     *
     * @throws if index is out of bounds
     */
    get activeIndex() {
        return this._activeIndex;
    }
    set activeIndex(value) {
        if (!isDefined(value)) {
            return;
        }
        if (this.tabPanels && (value < 0 || value >= this.tabPanels.length)) {
            console.error(`Tab index ${value} is out of bounds.`);
            return;
        }
        this._activeIndex = value;
        this.tabPanels &&
            this.setActiveIndex(this._activeIndex, this.tabPanels);
        this.cdr.markForCheck();
    }
    /**
     * Better to rely on actual button width than on tokens.
     *
     * At all moments, only one button is visible. We need to find, which, and multiply its width by 2.
     */
    get scrollButtonsWidth() {
        return ((this.leftScrollButton?.nativeElement.offsetWidth ?? 0) * 2 ||
            (this.rightScrollButton?.nativeElement.offsetWidth ?? 0) * 2);
    }
    constructor(cdr, destroyRef) {
        this.cdr = cdr;
        this.destroyRef = destroyRef;
        /**
         * If tab view is expected to be overflown, set this property to `true`
         * to have tabs scrollable.
         */
        this.overflow = false;
        /**
         * Emits when active tab index is changed by user interaction.
         */
        this.activeIndexChange = new EventEmitter();
        this._activeIndex = 0;
        this.isLeftScrollButtonDisabled = new BehaviorSubject(true);
        this.isRightScrollButtonDisabled = new BehaviorSubject(false);
    }
    ngAfterContentInit() {
        // since `tabPanels` are not defined on `ngOnInit`, we want to
        // call `activeIndex` setter one more time when `tabPanels` are ready
        this.activeIndex = this._activeIndex;
    }
    ngAfterViewInit() {
        merge(fromEvent(this.scrollableTabsContainer.nativeElement, 'scroll'), fromEvent(window, 'resize'), observeOnResize(this.scrollableTabsContainer.nativeElement))
            .pipe(
        // although subscribe does not receive any values, we need to start with
        // something, and container's `nativeElement` is a safe bet
        startWith$1(this.scrollableTabsContainer?.nativeElement), takeUntilDestroyed(this.destroyRef), 
        // debounce, not throttling, is used because the specific cases
        // this logic is used for is leftmost and rightmost scroll states
        // throttle would immediately emit the first scroll value and ignore
        // all the rest
        // but we want to have it the other way around: ignore all scroll events
        // EXCEPT the last one
        debounceTime$1(TAB_VIEW_SCROLL_DEBOUNCE_TIME))
            .subscribe(() => {
            const divElement = this.scrollableTabsContainer.nativeElement;
            // truncate because `scrollLeft` is a float
            const scrollRight = Math.trunc(divElement.scrollWidth -
                divElement.clientWidth -
                divElement.scrollLeft);
            this.isLeftScrollButtonDisabled.next(divElement.scrollLeft === 0);
            this.isRightScrollButtonDisabled.next(scrollRight === 0);
            // for some reason, when tab-view container is resized, we need to
            // call changeDetection even though Subjects are used.
            this.cdr.detectChanges();
        });
    }
    /**
     * @param activeIndex
     * @param tabPanels
     * @internal
     */
    setActiveIndex(activeIndex, tabPanels) {
        const activePanel = tabPanels?.get(activeIndex);
        if (activePanel && activePanel !== this.activePanel) {
            activePanel.selected = true;
            activePanel.runChangeDetection();
            if (this.activePanel) {
                this.activePanel.selected = false;
                this.activePanel.runChangeDetection();
            }
            this.activePanel = activePanel;
            // update to project content of correct tab
            this.cdr.detectChanges();
        }
    }
    /**
     * @param panel
     * @internal
     */
    setActivePanel(panel) {
        const index = this.tabPanels?.toArray().indexOf(panel);
        index !== undefined && this.setActiveIndex(index, this.tabPanels);
        this.activeIndex = index;
        this.activeIndexChange.emit(index);
    }
    handleLeftScrollButtonClick() {
        const width = this.scrollableTabsContainer.nativeElement.getBoundingClientRect()
            .width;
        this.scrollableTabsContainer?.nativeElement.scrollBy({
            left: -width + this.scrollButtonsWidth,
            behavior: 'smooth',
        });
    }
    handleRightScrollButtonClick() {
        const width = this.scrollableTabsContainer.nativeElement.getBoundingClientRect()
            .width;
        this.scrollableTabsContainer?.nativeElement.scrollBy({
            left: width - this.scrollButtonsWidth,
            behavior: 'smooth',
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TabViewComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.DestroyRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.3.12", type: TabViewComponent, selector: "hive-tab-view", inputs: { overflow: ["overflow", "overflow", booleanAttribute], activeIndex: "activeIndex" }, outputs: { activeIndexChange: "activeIndexChange" }, queries: [{ propertyName: "tabPanels", predicate: i0.forwardRef(() => TabPanelComponent), descendants: true }], viewQueries: [{ propertyName: "scrollableTabsContainer", first: true, predicate: ["scrollableTabsContainer"], descendants: true }, { propertyName: "leftScrollButton", first: true, predicate: ["leftScrollButton"], descendants: true, read: ElementRef }, { propertyName: "rightScrollButton", first: true, predicate: ["rightScrollButton"], descendants: true, read: ElementRef }], hostDirectives: [{ directive: HiveThemedDirective }], ngImport: i0, template: "<div class=\"hive-tab-view_container\">\n    <div class=\"hive-tab-view_content\">\n        @if (overflow) {\n            <hive-button\n                #leftScrollButton\n                data-testid=\"hive-tab-view_left-scroll-button\"\n                class=\"hive-tab-view_left-scroll-button\"\n                size=\"medium\"\n                emphasis=\"tertiary\"\n                icon=\"light/chevron-left.svg\"\n                [disabled]=\"isLeftScrollButtonDisabled | async\"\n                (click)=\"handleLeftScrollButtonClick()\"\n            ></hive-button>\n        }\n\n        <div\n            class=\"hive-tab-view_tabs-container\"\n            [class.hive-tab-view_tabs-container--overflow]=\"overflow\"\n            [class.hive-tab-view_tabs-container--left-border-visible]=\"\n                overflow && (isLeftScrollButtonDisabled | async)\n            \"\n            [class.hive-tab-view_tabs-container--right-border-visible]=\"\n                overflow && (isRightScrollButtonDisabled | async)\n            \"\n        >\n            <div\n                #scrollableTabsContainer\n                class=\"hive-tab-view_scrollable-tabs-container\"\n                data-testid=\"hive-tab-view_scrollable-tabs-container\"\n            >\n                <ng-content select=\"hive-tab-panel\"></ng-content>\n            </div>\n\n            <hive-separator></hive-separator>\n        </div>\n\n        @if (overflow) {\n            <hive-button\n                #rightScrollButton\n                data-testid=\"hive-tab-view_right-scroll-button\"\n                class=\"hive-tab-view_right-scroll-button\"\n                size=\"medium\"\n                emphasis=\"tertiary\"\n                icon=\"light/chevron-right.svg\"\n                [disabled]=\"isRightScrollButtonDisabled | async\"\n                (click)=\"handleRightScrollButtonClick()\"\n            ></hive-button>\n        }\n    </div>\n</div>\n\n<div class=\"hive-tab-view_content-projection\">\n    <ng-container\n        *ngTemplateOutlet=\"activePanel?.contentProjectionTemplate ?? null\"\n    ></ng-container>\n</div>\n", dependencies: [{ kind: "directive", type: i2$1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "component", type: SeparatorComponent, selector: "hive-separator", inputs: ["orientation"] }, { kind: "component", type: ButtonComponent, selector: "hive-button", inputs: ["type", "menuButtonActive", "hasMenuButtonCaret", "label", "accessibleName", "icon", "iconPosition", "emphasis", "title", "size", "isLoading", "disabled", "rounded", "width"] }, { kind: "pipe", type: i2$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TabViewComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hive-tab-view', changeDetection: ChangeDetectionStrategy.OnPush, hostDirectives: [HiveThemedDirective], template: "<div class=\"hive-tab-view_container\">\n    <div class=\"hive-tab-view_content\">\n        @if (overflow) {\n            <hive-button\n                #leftScrollButton\n                data-testid=\"hive-tab-view_left-scroll-button\"\n                class=\"hive-tab-view_left-scroll-button\"\n                size=\"medium\"\n                emphasis=\"tertiary\"\n                icon=\"light/chevron-left.svg\"\n                [disabled]=\"isLeftScrollButtonDisabled | async\"\n                (click)=\"handleLeftScrollButtonClick()\"\n            ></hive-button>\n        }\n\n        <div\n            class=\"hive-tab-view_tabs-container\"\n            [class.hive-tab-view_tabs-container--overflow]=\"overflow\"\n            [class.hive-tab-view_tabs-container--left-border-visible]=\"\n                overflow && (isLeftScrollButtonDisabled | async)\n            \"\n            [class.hive-tab-view_tabs-container--right-border-visible]=\"\n                overflow && (isRightScrollButtonDisabled | async)\n            \"\n        >\n            <div\n                #scrollableTabsContainer\n                class=\"hive-tab-view_scrollable-tabs-container\"\n                data-testid=\"hive-tab-view_scrollable-tabs-container\"\n            >\n                <ng-content select=\"hive-tab-panel\"></ng-content>\n            </div>\n\n            <hive-separator></hive-separator>\n        </div>\n\n        @if (overflow) {\n            <hive-button\n                #rightScrollButton\n                data-testid=\"hive-tab-view_right-scroll-button\"\n                class=\"hive-tab-view_right-scroll-button\"\n                size=\"medium\"\n                emphasis=\"tertiary\"\n                icon=\"light/chevron-right.svg\"\n                [disabled]=\"isRightScrollButtonDisabled | async\"\n                (click)=\"handleRightScrollButtonClick()\"\n            ></hive-button>\n        }\n    </div>\n</div>\n\n<div class=\"hive-tab-view_content-projection\">\n    <ng-container\n        *ngTemplateOutlet=\"activePanel?.contentProjectionTemplate ?? null\"\n    ></ng-container>\n</div>\n" }]
        }], ctorParameters: () => [{ type: i0.ChangeDetectorRef }, { type: i0.DestroyRef }], propDecorators: { scrollableTabsContainer: [{
                type: ViewChild,
                args: ['scrollableTabsContainer']
            }], leftScrollButton: [{
                type: ViewChild,
                args: ['leftScrollButton', { read: ElementRef }]
            }], rightScrollButton: [{
                type: ViewChild,
                args: ['rightScrollButton', { read: ElementRef }]
            }], tabPanels: [{
                type: ContentChildren,
                args: [forwardRef(() => TabPanelComponent), { descendants: true }]
            }], overflow: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], activeIndex: [{
                type: Input
            }], activeIndexChange: [{
                type: Output
            }] } });

class TabPanelComponent {
    constructor(cdr, tabView) {
        this.cdr = cdr;
        this.tabView = tabView;
        /**
         * Defines if tab is selected
         */
        this.selected = false;
        /**
         * Defines if tab is disabled.
    
         * If `true`, tab cannot be selected by user interaction,
         * though it can be selected programmatically by setting `activeIndex` on `hive-tab-view`.
         */
        this.disabled = false;
    }
    isItemBadge(item) {
        return item?.type === 'badge';
    }
    isItemIcon(item) {
        return item?.type === 'icon';
    }
    /**
     * @internal
     */
    runChangeDetection() {
        this.cdr.detectChanges();
    }
    handleTabClick() {
        if (this.disabled) {
            return;
        }
        this.tabView.setActivePanel(this);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TabPanelComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: forwardRef(() => TabViewComponent) }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.3.12", type: TabPanelComponent, selector: "hive-tab-panel", inputs: { heading: "heading", selected: ["selected", "selected", booleanAttribute], disabled: ["disabled", "disabled", booleanAttribute], item: "item" }, viewQueries: [{ propertyName: "contentProjectionTemplate", first: true, predicate: ["contentProjectionTemplate"], descendants: true, static: true }], hostDirectives: [{ directive: HiveThemedDirective }], ngImport: i0, template: "<div\n    class=\"hive-tab-view_tab\"\n    [class.hive-tab-view_tab--selected]=\"selected\"\n    [class.hive-tab-view_tab--disabled]=\"disabled\"\n    [attr.aria-disabled]=\"disabled\"\n    [tabindex]=\"disabled ? -1 : 0\"\n    (click)=\"handleTabClick()\"\n    (keydown.enter)=\"handleTabClick()\"\n    (keydown.space)=\"$event.preventDefault(); handleTabClick()\"\n>\n    {{ heading }}\n\n    @if (isItemBadge(item)) {\n        <hive-badge\n            [label]=\"item.label\"\n            [icon]=\"item.icon\"\n            [emphasis]=\"item.emphasis\"\n        ></hive-badge>\n    }\n\n    @if (isItemIcon(item)) {\n        <hive-icon-component\n            [icon]=\"item.icon\"\n            [size]=\"item.size\"\n        ></hive-icon-component>\n    }\n</div>\n\n<ng-template #contentProjectionTemplate>\n    <ng-content></ng-content>\n</ng-template>\n", dependencies: [{ kind: "component", type: BadgeComponent, selector: "hive-badge", inputs: ["label", "icon", "emphasis", "size"] }, { kind: "component", type: IconComponent, selector: "hive-icon-component", inputs: ["icon", "size"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TabPanelComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hive-tab-panel', changeDetection: ChangeDetectionStrategy.OnPush, hostDirectives: [HiveThemedDirective], template: "<div\n    class=\"hive-tab-view_tab\"\n    [class.hive-tab-view_tab--selected]=\"selected\"\n    [class.hive-tab-view_tab--disabled]=\"disabled\"\n    [attr.aria-disabled]=\"disabled\"\n    [tabindex]=\"disabled ? -1 : 0\"\n    (click)=\"handleTabClick()\"\n    (keydown.enter)=\"handleTabClick()\"\n    (keydown.space)=\"$event.preventDefault(); handleTabClick()\"\n>\n    {{ heading }}\n\n    @if (isItemBadge(item)) {\n        <hive-badge\n            [label]=\"item.label\"\n            [icon]=\"item.icon\"\n            [emphasis]=\"item.emphasis\"\n        ></hive-badge>\n    }\n\n    @if (isItemIcon(item)) {\n        <hive-icon-component\n            [icon]=\"item.icon\"\n            [size]=\"item.size\"\n        ></hive-icon-component>\n    }\n</div>\n\n<ng-template #contentProjectionTemplate>\n    <ng-content></ng-content>\n</ng-template>\n" }]
        }], ctorParameters: () => [{ type: i0.ChangeDetectorRef }, { type: TabViewComponent, decorators: [{
                    type: Inject,
                    args: [forwardRef(() => TabViewComponent)]
                }] }], propDecorators: { contentProjectionTemplate: [{
                type: ViewChild,
                args: ['contentProjectionTemplate', { static: true }]
            }], heading: [{
                type: Input
            }], selected: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], disabled: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], item: [{
                type: Input
            }] } });

class TabViewModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TabViewModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: TabViewModule, declarations: [TabViewComponent, TabPanelComponent], imports: [CommonModule,
            BadgeModule,
            IconComponent,
            SeparatorComponent,
            ButtonComponent], exports: [TabViewComponent, TabPanelComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TabViewModule, imports: [CommonModule,
            BadgeModule,
            IconComponent,
            ButtonComponent] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TabViewModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [TabViewComponent, TabPanelComponent],
                    imports: [
                        CommonModule,
                        BadgeModule,
                        IconComponent,
                        SeparatorComponent,
                        ButtonComponent,
                    ],
                    exports: [TabViewComponent, TabPanelComponent],
                }]
        }] });

function hiveSeverityAttribute(severity) {
    const severities = ['major', 'warning', 'success', 'info'];
    return severities.find((s) => s === severity) || 'info';
}

/**
 * Inline notifications are small messages or alerts that appear within the content
 * of a user interface to provide feedback, guidance, or warnings related to user
 * actions or system events.
 *
 * Note that as a general rule for description,
 * `<p class="hive-paragraph-small hive-paragraph-regular">` text should be used.
 * This is free-flow content component in Figma with `size: small` and `weight: regular` properties.
 *
 * To avoid collisions between `[hive-links]` that should be projected as description
 * and those which should be projected as call-to-action, use `slot="hive-call-to-action"`
 * for the latter.
 *
 * @version 1.3.0
 */
class InlineNotificationComponent {
    constructor() {
        /**
         * Specifies appearance and icon
         *
         * `error` is deprecated, use `major` instead.
         */
        this.severity = 'info';
        /**
         * Notification heading
         */
        this.heading = '';
        /**
         * Icon to be shown in the notification
         */
        this.icon = '';
        /**
         * Defines if icon should be shown.
         *
         * @default true
         */
        this.showIcon = true;
        /**
         * Show loading spinner
         */
        this.isLoading = false;
        this.destroyRef$ = inject(DestroyRef);
    }
    get _icon() {
        const icons = {
            major: 'light/triangle-exclamation.svg',
            warning: 'light/circle-exclamation.svg',
            success: 'light/circle-check.svg',
            info: 'light/circle-info.svg',
        };
        return this.icon || icons[this.severity];
    }
    ngAfterViewInit() {
        this.buttons.changes
            .pipe(safeTakeUntilDestroyed(this.destroyRef$), startWith$1(this.buttons.toArray()), map(() => this.buttons.toArray()), map((buttons) => buttons.filter((button) => button.size !== 'small')), tap$1((misconfiguredButtons) => {
            for (const button of misconfiguredButtons) {
                console.error('<hive-inline-notification> items should be only with small size.\n', 'Misconfigured element: ', button);
            }
        }))
            .subscribe();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: InlineNotificationComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.3.12", type: InlineNotificationComponent, isStandalone: true, selector: "hive-inline-notification", inputs: { severity: ["severity", "severity", hiveSeverityAttribute], heading: ["heading", "heading", stringAttribute], icon: ["icon", "icon", stringAttribute], showIcon: ["showIcon", "showIcon", booleanAttribute], isLoading: ["isLoading", "isLoading", booleanAttribute] }, queries: [{ propertyName: "buttons", predicate: ButtonComponent }], hostDirectives: [{ directive: HiveThemedDirective }], ngImport: i0, template: "<div\n    class=\"hive-inline-notification-container\"\n    [ngClass]=\"'hive-inline-notification-container--severity-' + severity\"\n>\n    <div class=\"hive-inline-notification-content-container\">\n        @if (showIcon || isLoading) {\n            <div class=\"hive-inline-notification_severity-icon-container\">\n                @switch (isLoading) {\n                    @case (true) {\n                        <hive-loading-spinner\n                            class=\"hive-inline-notification_severity-progress\"\n                            size=\"medium\"\n                            displayMode=\"centered\"\n                        />\n                    }\n                    @default {\n                        <hive-icon-component\n                            class=\"hive-inline-notification_severity-icon\"\n                            size=\"medium\"\n                            [icon]=\"_icon\"\n                        />\n                    }\n                }\n            </div>\n        }\n\n        <div class=\"hive-inline-notification-content\">\n            @if (heading) {\n                <hive-label size=\"small\" weight=\"semibold\" [label]=\"heading\" />\n            }\n\n            <div class=\"hive-inline-notification-text-and-actions\">\n                <div class=\"hive-inline-notification-message\">\n                    <ng-content\n                        select=\"*:not(hive-button[size='small']):not(a[hive-link][slot='hive-call-to-action'])\"\n                    ></ng-content>\n                </div>\n\n                <div class=\"hive-inline-notification-buttons\">\n                    <ng-content\n                        select=\"hive-button[size='small'], a[hive-link][slot='hive-call-to-action']\"\n                    ></ng-content>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n", dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i2$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "component", type: IconComponent, selector: "hive-icon-component", inputs: ["icon", "size"] }, { kind: "component", type: LabelComponent, selector: "hive-label", inputs: ["label", "for", "size", "weight", "maxWeight", "horizontalAlignment", "leftIconHelpInfoMessage", "rightIconHelpInfoMessage", "leftIcon", "rightIcon", "required", "textOverflowEllipsis"] }, { kind: "component", type: LoadingSpinnerComponent, selector: "hive-loading-spinner", inputs: ["displayMode", "orientation", "label", "size"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: InlineNotificationComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hive-inline-notification', changeDetection: ChangeDetectionStrategy.OnPush, standalone: true, hostDirectives: [HiveThemedDirective], imports: [
                        CommonModule,
                        SvgDirective,
                        IconComponent,
                        LinkComponent,
                        LabelComponent,
                        IsDefinedPipe,
                        LoadingSpinnerComponent,
                    ], template: "<div\n    class=\"hive-inline-notification-container\"\n    [ngClass]=\"'hive-inline-notification-container--severity-' + severity\"\n>\n    <div class=\"hive-inline-notification-content-container\">\n        @if (showIcon || isLoading) {\n            <div class=\"hive-inline-notification_severity-icon-container\">\n                @switch (isLoading) {\n                    @case (true) {\n                        <hive-loading-spinner\n                            class=\"hive-inline-notification_severity-progress\"\n                            size=\"medium\"\n                            displayMode=\"centered\"\n                        />\n                    }\n                    @default {\n                        <hive-icon-component\n                            class=\"hive-inline-notification_severity-icon\"\n                            size=\"medium\"\n                            [icon]=\"_icon\"\n                        />\n                    }\n                }\n            </div>\n        }\n\n        <div class=\"hive-inline-notification-content\">\n            @if (heading) {\n                <hive-label size=\"small\" weight=\"semibold\" [label]=\"heading\" />\n            }\n\n            <div class=\"hive-inline-notification-text-and-actions\">\n                <div class=\"hive-inline-notification-message\">\n                    <ng-content\n                        select=\"*:not(hive-button[size='small']):not(a[hive-link][slot='hive-call-to-action'])\"\n                    ></ng-content>\n                </div>\n\n                <div class=\"hive-inline-notification-buttons\">\n                    <ng-content\n                        select=\"hive-button[size='small'], a[hive-link][slot='hive-call-to-action']\"\n                    ></ng-content>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n" }]
        }], propDecorators: { severity: [{
                type: Input,
                args: [{ transform: hiveSeverityAttribute }]
            }], heading: [{
                type: Input,
                args: [{ transform: stringAttribute }]
            }], icon: [{
                type: Input,
                args: [{ transform: stringAttribute }]
            }], showIcon: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], isLoading: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], buttons: [{
                type: ContentChildren,
                args: [ButtonComponent]
            }] } });

/**
 * Constant used to refer to the ID attribute.
 * @constant {string}
 */
const PARENT_ATTRIBUTE = 'id';
/**
 * Constant used to refer to the headers attribute.
 * @constant {string}
 */
const PARENT_REFERENCE_ATTRIBUTE = 'headers';
/**
 * Uniq parent reference for root elements
 */
const ROOT_PARENT_REFERENCE = Math.random().toString();
class TableService {
    constructor() {
        /**
         * `ReplaySubject` is used to pass data top-to-bottom.
         * Inner components inside the table may not be initialized at the time
         * when values will be passed through `Observables`,
         * so they will be passed post-factum
         * */
        this.filterInput$ = new ReplaySubject(1);
        this.filterOutput$ = new Subject();
        this.filterDebounceWait$ = new ReplaySubject(1);
        this.sortInput = new ReplaySubject(1);
        this.sortInput$ = this.sortInput.asObservable();
        this.sortOutput = new Subject();
        this.sortOutput$ = this.sortOutput.asObservable();
    }
    /**
     * Updates the hidden state for each heading directive.
     * @param tableHeadingDirectives
     * @param hiddenColumns
     */
    static updateHiddenColumns(tableHeadingDirectives, hiddenColumns) {
        for (const tableHeadingDirective of tableHeadingDirectives) {
            const { id, _parentReference } = tableHeadingDirective;
            const parentDefined = _parentReference !== undefined && _parentReference !== null;
            const isCurrentHeaderHidden = hiddenColumns.includes(id);
            const isParentHeaderHidden = parentDefined
                ? hiddenColumns.includes(_parentReference)
                : false;
            tableHeadingDirective._isHidden =
                isCurrentHeaderHidden || isParentHeaderHidden;
        }
        return tableHeadingDirectives;
    }
    /**
     * Builds a tree of table heading directives (using the parent reference attribute and the id attribute).
     * @param headingDirectives
     */
    static buildTree(headingDirectives) {
        if (!headingDirectives.length) {
            return [];
        }
        const data = groupBy(headingDirectives, (heading) => heading._parentReference ?? ROOT_PARENT_REFERENCE);
        const { [ROOT_PARENT_REFERENCE]: roots, ...children } = data;
        for (const rootElement of roots) {
            rootElement._cols = children[rootElement[PARENT_ATTRIBUTE]] ?? [];
            rootElement._parentalHeader = rootElement._cols.length > 0;
            if (!rootElement._cols.length && Object.keys(children).length) {
                rootElement._rowSpan = 2;
                continue;
            }
            for (const child of rootElement._cols) {
                child._cols = [];
                child._parentalHeader = false;
            }
        }
        return roots;
    }
    static calculateHeaderAdjacency(tableHeadingDirectives) {
        for (const rootElement of tableHeadingDirectives) {
            rootElement._hasLeftAdjacentVisibleHeader = false;
            rootElement._hasRightAdjacentVisibleHeader = false;
            for (const child of rootElement._cols) {
                child._hasLeftAdjacentVisibleHeader = false;
                child._hasRightAdjacentVisibleHeader = false;
            }
        }
        const visibleRoots = tableHeadingDirectives.filter(({ _isHidden }) => !_isHidden);
        for (let i = 0; i < visibleRoots.length; i++) {
            const leftAdjacentVisibleHeader = visibleRoots
                .slice(0, i)
                .reverse()
                .find(({ _isHidden }) => !_isHidden);
            const rightAdjacentVisibleHeader = visibleRoots
                .slice(i + 1)
                .find(({ _isHidden }) => !_isHidden);
            visibleRoots[i]._hasLeftAdjacentVisibleHeader = Boolean(leftAdjacentVisibleHeader);
            const firstVisibleChild = visibleRoots[i]._cols.find(({ _isHidden }) => !_isHidden);
            if (firstVisibleChild) {
                firstVisibleChild._hasLeftAdjacentVisibleHeader = Boolean(leftAdjacentVisibleHeader);
            }
            visibleRoots[i]._hasRightAdjacentVisibleHeader = Boolean(rightAdjacentVisibleHeader);
            const lastVisibleChild = visibleRoots[i]._cols
                .slice()
                .reverse()
                .find(({ _isHidden }) => !_isHidden);
            if (lastVisibleChild) {
                lastVisibleChild._hasRightAdjacentVisibleHeader = Boolean(rightAdjacentVisibleHeader);
            }
        }
        return tableHeadingDirectives;
    }
    /**
     * Updates the number of visible children for each heading directive.
     * @param tableHeadingDirectives
     */
    static updateNumberOfVisibleChildren(tableHeadingDirectives) {
        for (const rootElement of tableHeadingDirectives) {
            rootElement._numberOfTotalChildren = rootElement._cols.length;
            rootElement._numberOfVisibleChildren = rootElement._cols.filter(({ _isHidden }) => !_isHidden).length;
            for (const child of rootElement._cols) {
                child._numberOfVisibleChildren = 0;
                child._numberOfTotalChildren = 0;
            }
            if (!rootElement._cols.length) {
                rootElement._numberOfVisibleChildren = 1;
                rootElement._numberOfTotalChildren = 1;
            }
        }
        return tableHeadingDirectives;
    }
    /**
     * Updates the order property for each heading directive.
     *
     * This is a kind of polyfill for column-combinator
     * feature in CSS, which isn't yet released.
     */
    static updateOrders(tableHeadingDirectives) {
        let order = 1;
        for (const headingDirective of tableHeadingDirectives) {
            headingDirective._order = order;
            if (!headingDirective._cols.length) {
                order++;
            }
            else {
                for (const child of headingDirective._cols) {
                    child._order = order;
                    order++;
                }
            }
        }
        return tableHeadingDirectives;
    }
    /**
     * Since the table should have a border only for colgroups,
     * we need to find first and last visible elements
     * in each group to apply border to them.
     * @param tableHeadingDirectives
     */
    static updateLastAndFirstInGroup(tableHeadingDirectives) {
        for (const headingDirective of tableHeadingDirectives) {
            for (const child of headingDirective._cols) {
                child._firstInGroup = false;
                child._lastInGroup = false;
            }
            const firstNonHiddenChild = headingDirective._cols.find(({ _isHidden }) => !_isHidden);
            if (firstNonHiddenChild) {
                firstNonHiddenChild._firstInGroup = true;
            }
            // @todo: When we start to use ES2023 - `const lastNonHiddenChild = headingDirective._cols.slice().findLast(({_isHidden}) => !_isHidden);`
            const lastNonHiddenChild = headingDirective._cols
                .slice()
                .reverse()
                .find(({ _isHidden }) => !_isHidden);
            if (lastNonHiddenChild) {
                lastNonHiddenChild._lastInGroup = true;
            }
        }
        return tableHeadingDirectives;
    }
    /**
     * Table needs to know the last visible top-level element to apply resizable
     * handle fix in order to avoid having horizontal overflow.
     * @param tableHeadingDirectives
     * @returns
     */
    static updateLastVisibleInTable(tableHeadingDirectives) {
        for (const headingDirective of tableHeadingDirectives) {
            headingDirective._lastVisibleInTable = false;
            for (const child of headingDirective._cols) {
                child._lastVisibleInTable = false;
            }
        }
        const lastVisible = tableHeadingDirectives
            .slice()
            .reverse()
            .find(({ _isHidden }) => !_isHidden);
        if (lastVisible) {
            lastVisible._lastVisibleInTable = true;
            const lastVisibleChildColInTable = lastVisible._cols
                .slice()
                .reverse()
                .find(({ _isHidden }) => !_isHidden);
            if (lastVisibleChildColInTable) {
                lastVisibleChildColInTable._lastVisibleInTable = true;
            }
        }
        return tableHeadingDirectives;
    }
    static updateScrolled(tableHeadingDirectives, canScrollLeft, canScrollRight) {
        for (const headingDirective of tableHeadingDirectives) {
            headingDirective._canScrollLeft = canScrollLeft;
            headingDirective._canScrollRight = canScrollRight;
            for (const child of headingDirective._cols) {
                child._canScrollLeft = canScrollLeft;
                child._canScrollRight = canScrollRight;
            }
        }
        return tableHeadingDirectives;
    }
    /**
     * Computes the offsets for the sticky columns.
     * For left-aligned columns, we need to compute the left offsets
     * (previousElementLeftOffset + previousElementWidth) from the beginning of the array.
     *
     * For right-aligned columns, we need to compute the right offsets
     * (previousElementRightOffset + previousElementWidth) from the end of the array.
     * @param tableHeadingDirectives
     */
    static computeOffsets(tableHeadingDirectives) {
        function isUniqFrozen(headingDirective, index, array) {
            const uniqOrder = array.findIndex((h) => h._order === headingDirective._order) ===
                index;
            return headingDirective.isFrozen && uniqOrder;
        }
        const tableHeadingDirectivesWithOnlyUniqOrders = tableHeadingDirectives
            .slice()
            .reverse() // we do reverse since we're interested in the latest <tr/> > <td/> elements
            .filter(isUniqFrozen) // remove duplicates
            .sort((a, b) => a._order - b._order); // restore the original order
        const leftRects = TableService.computeLeftOffsets(tableHeadingDirectivesWithOnlyUniqOrders);
        const rightRects = TableService.computeRightOffsets(tableHeadingDirectivesWithOnlyUniqOrders, tableHeadingDirectives);
        // Produce a pack of css custom properties for each sticky column to be used in the template
        return leftRects
            .concat(rightRects.reverse())
            .reduce((acc, { serviceWidth, serviceRight, serviceLeft, ...rect }) => Object.assign(acc, rect), {});
    }
    static calculateRightmostLeftAlignedFrozenColumn(tableHeadingDirectives) {
        for (const headingDirective of tableHeadingDirectives) {
            headingDirective._rightmostLeftAligned = false;
        }
        const rightmostLeftAlignedFrozenColumn = tableHeadingDirectives
            .slice()
            .reverse()
            .find((headingDirective) => headingDirective.isFrozen && headingDirective.leftAligned);
        if (rightmostLeftAlignedFrozenColumn) {
            rightmostLeftAlignedFrozenColumn._rightmostLeftAligned = true;
        }
        return tableHeadingDirectives;
    }
    static calculateLeftmostRightAlignedFrozenColumn(tableHeadingDirectives) {
        for (const headingDirective of tableHeadingDirectives) {
            headingDirective._leftmostRightAligned = false;
        }
        const leftmostRightAlignedFrozenColumn = tableHeadingDirectives
            .slice()
            .find((headingDirective) => headingDirective.isFrozen && headingDirective.rightAligned);
        if (leftmostRightAlignedFrozenColumn) {
            leftmostRightAlignedFrozenColumn._leftmostRightAligned = true;
        }
        return tableHeadingDirectives;
    }
    /**
     * Computes the left offsets for the sticky columns.
     * @param tableHeadingDirectivesWithOnlyUniqOrders
     * @private
     */
    static computeLeftOffsets(tableHeadingDirectivesWithOnlyUniqOrders) {
        const leftRects = [];
        // if the first element has order 1, we allow it to be frozen
        if (tableHeadingDirectivesWithOnlyUniqOrders.at(0)?._order === 1) {
            for (const [index, element,] of tableHeadingDirectivesWithOnlyUniqOrders.entries()) {
                const notFirst = index !== 0;
                // Sticky columns have to be stacked together
                // and always have to start from the first column for left-aligned columns
                const hasGap = element._order -
                    tableHeadingDirectivesWithOnlyUniqOrders.at(index - 1)
                        ._order !==
                    1;
                if (notFirst && hasGap) {
                    break;
                }
                const previousElementLeftOffset = leftRects.at(-1)?.['serviceLeft'] ?? 0;
                const previousElementWidth = leftRects.at(-1)?.['serviceWidth'] ?? 0;
                const currentLeftOffset = previousElementLeftOffset + previousElementWidth;
                const currentWidth = element.getBoundingClientRect().width;
                leftRects.push({
                    [`--hive-frozen-column-left-${leftRects.length + 1}-offset`]: `${currentLeftOffset}px`,
                    [`--hive-frozen-column-left-${leftRects.length + 1}-position`]: 'sticky',
                    serviceWidth: currentWidth,
                    serviceLeft: currentLeftOffset,
                });
            }
        }
        return leftRects;
    }
    /**
     * Computes the right offsets for the sticky columns.
     * @param tableHeadingDirectivesWithOnlyUniqOrders
     * @param tableHeadingDirectives
     * @private
     */
    static computeRightOffsets(tableHeadingDirectivesWithOnlyUniqOrders, tableHeadingDirectives) {
        const rightRects = [];
        const parentColumns = tableHeadingDirectives.filter((heading) => heading._parentReference === undefined);
        // if the last frozen element is the last element, we allow it to be frozen
        if (tableHeadingDirectivesWithOnlyUniqOrders.at(-1)?._order ===
            parentColumns.at(-1)?._order) {
            const reversed = tableHeadingDirectivesWithOnlyUniqOrders
                .slice()
                .reverse();
            for (const [index, element] of reversed.entries()) {
                const notFirst = index !== 0;
                const hasGap = element._order - reversed.at(index - 1)._order !== -1;
                // Sticky columns have to be stacked together
                // and always have to start from the last column for right-aligned columns
                if (notFirst && hasGap) {
                    break;
                }
                const previousElementRightOffset = rightRects.at(-1)?.['serviceRight'] ?? 0;
                const previousElementWidth = rightRects.at(-1)?.['serviceWidth'] ?? 0;
                const currentRightOffset = previousElementRightOffset + previousElementWidth;
                const currentWidth = element.getBoundingClientRect().width;
                rightRects.push({
                    [`--hive-frozen-column-right-${rightRects.length + 1}-offset`]: `${currentRightOffset}px`,
                    [`--hive-frozen-column-right-${rightRects.length + 1}-position`]: 'sticky',
                    serviceWidth: currentWidth,
                    serviceRight: currentRightOffset,
                });
            }
        }
        return rightRects;
    }
    onFilterInput(filter) {
        this.filterInput$.next(filter);
    }
    onFilterOutput(filter) {
        this.filterOutput$.next(filter);
    }
    onFilterDebounceWaitChange(wait) {
        if (isDefined(wait)) {
            this.filterDebounceWait$.next(wait);
        }
    }
    onSortInput(sort) {
        this.sortInput.next(sort);
    }
    onSortOutput(sort) {
        this.sortOutput.next(sort);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TableService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TableService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TableService, decorators: [{
            type: Injectable
        }] });

/**
 * Checks if the value is an array of strings.
 * @param value
 * @returns
 */
function isArrayOfStrings(value) {
    return (Array.isArray(value) && value.every((item) => typeof item === 'string'));
}

/**
 * This is a directive to manage frozen column.
 * Please don't use this directive directly, use `FrozenHeaderColumnDirective` or `FrozenCellDirective` instead.
 */
class FrozenColumnDirective {
    constructor() {
        this._frozen = true;
        this._alignFrozen = 'left';
    }
    get frozen() {
        return this._frozen;
    }
    get alignRight() {
        return this._alignFrozen === 'right';
    }
    get alignLeft() {
        return this._alignFrozen === 'left';
    }
    get alignFrozen() {
        return this._alignFrozen;
    }
    /**
     * Set the alignment of the frozen column.
     * @param value
     *
     * @default left
     */
    set alignFrozen(value) {
        this._alignFrozen = value;
    }
    /**
     * Set the state of the frozen column. (true/false)
     * @param value
     *
     * @default true
     */
    set hiveFrozenColumn(value) {
        this._frozen = coerceBooleanProperty(value);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FrozenColumnDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: FrozenColumnDirective, isStandalone: true, selector: "[frozenColumnInternal]", inputs: { alignFrozen: "alignFrozen", hiveFrozenColumn: "hiveFrozenColumn" }, host: { properties: { "class.hive-frozen-column": "this._frozen", "class.hive-frozen-column--right-aligned": "this.alignRight", "class.hive-frozen-column--left-aligned": "this.alignLeft" } }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FrozenColumnDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[frozenColumnInternal]',
                    standalone: true,
                }]
        }], propDecorators: { _frozen: [{
                type: HostBinding,
                args: ['class.hive-frozen-column']
            }], alignRight: [{
                type: HostBinding,
                args: ['class.hive-frozen-column--right-aligned']
            }], alignLeft: [{
                type: HostBinding,
                args: ['class.hive-frozen-column--left-aligned']
            }], alignFrozen: [{
                type: Input
            }], hiveFrozenColumn: [{
                type: Input
            }] } });

const COL_MIN_WIDTH_PX = 42;
/**
 * Directive to manage table header.
 *
 * @example:
 *      <th hive-header id="header-id" [primaryText]="['Header', 'text']"></th>
 *
 * @example:
 *      <th hive-header id="header-id" primaryText="Header text"></th>
 *
 * @example:
 *      <th hive-header
 *          id="header-id"
 *          headers="parent-header-id"
 *          colWidth="100px"
 *          primaryText="Header text"
 *          columnToggleName="Column customizer name"
 *          visibilityMode="column-toggle-disabled">
 *      </th>
 *
 * @example:
 *      <th hive-header
 *          id="header-id"
 *          colWeight="1"
 *          primaryText="Header text"
 *          visibilityMode="column-toggle-ignored">
 *      </th>
 *
 * @example:
 *      <th hive-header
 *          id="header-id"
 *          headers="parent-header-id"
 *          columnToggleName="column-toggle-ignored">
 *      </th>
 */
class TableHeadingDirective {
    // resizable columns to be less than 42px
    /**
     * @internal
     */
    constructor(el, frozenColumn) {
        this.el = el;
        this.frozenColumn = frozenColumn;
        /**
         * @internal
         */
        this._firstInGroup = false;
        /**
         * @internal
         */
        this._lastInGroup = false;
        /**
         * @internal
         */
        this._parentalHeader = false;
        /**
         * @internal
         */
        this._canScrollLeft = false;
        /**
         * @internal
         */
        this._canScrollRight = false;
        /**
         * @internal
         */
        this._rightmostLeftAligned = false;
        /**
         * @internal
         */
        this._leftmostRightAligned = false;
        /**
         * @internal
         */
        this._hasLeftAdjacentVisibleHeader = false;
        /**
         * @internal
         */
        this._hasRightAdjacentVisibleHeader = false;
        this._lastVisibleInTable$ = new BehaviorSubject(false);
        /**
         * @internal This is an alias for ':nth-child'. It's computed internally and should not be used directly. We use that property to render borders between columns.
         */
        this._order = 0;
        this._rowSpan = 1;
        this.primaryText = [];
        /**
         * @internal
         */
        this._cols = [];
        /**
         * @internal
         */
        this._colWidthPx = 0;
        this.class = 'hive-table-heading';
        this.scopeCol = 'col';
        /**
         * If true, the column's right border can be used as a handle to resize it.
         *
         * @note To ensure resizing works correctly when the table is smaller than its container (and stretches to fit), we recommend setting tableWidth to auto in the parent table.
         * @default false
         */
        this.resizable = false;
    }
    /**
     * @internal
     */
    get _lastVisibleInTable() {
        return this._lastVisibleInTable$.getValue();
    }
    set _lastVisibleInTable(value) {
        this._lastVisibleInTable$.next(value);
    }
    /**
     * Utility text is used as a value for `hive-column-toggle` search.
     *
     * - If columnToggleName is provided, it will be used as is.
     * - If primaryText is an array, it will be joined with space.
     * - If primaryText is a string, it will be used as is.
     * - If primaryText is not provided, empty string will be used.
     *
     * @internal
     */
    get utilityText() {
        if (isString(this.columnToggleName)) {
            return this.columnToggleName;
        }
        else if (isArrayOfStrings(this.primaryText)) {
            return this.primaryText.join(' ');
        }
        else if (isString(this.primaryText)) {
            return this.primaryText;
        }
        else {
            return '';
        }
    }
    /**
     * Width of column. Might to be XXpx or XX% values. Other units might not work.
     */
    get colWidth() {
        return this._colWidth;
    }
    set colWidth(value) {
        this._colWidth = value;
        this._colWidthPx = typeof value === 'string' ? parseInt(value, 10) : 0;
    }
    /**
     * @internal
     */
    get _parentReference() {
        return this.headers?.split(' ')?.at(0);
    }
    /**
     * @internal
     */
    get isFrozen() {
        return this.frozenColumn?.frozen;
    }
    /**
     * @internal
     */
    get leftAligned() {
        return this.frozenColumn?.alignFrozen === 'left';
    }
    /**
     * @internal
     */
    get rightAligned() {
        return this.frozenColumn?.alignFrozen === 'right';
    }
    /**
     * @internal
     */
    get isChildHeader() {
        return !this._parentalHeader && this._parentReference;
    }
    get attrColspan() {
        return this._cols.length || null;
    }
    get headersAttribute() {
        return this.headers ?? null;
    }
    get widthForColGroup() {
        return this._cols?.length && this.id ? this.colWidth : null;
    }
    // Discussed with design team, we don't want
    get weightForColGroup() {
        return this._cols?.length && this.id ? this.colWeight : null;
    }
    handleDragResize(offsetX) {
        const colWidth = this.getBoundingClientRect().width;
        const newWidth = colWidth + offsetX;
        this._colWidthPx =
            newWidth > COL_MIN_WIDTH_PX ? newWidth : COL_MIN_WIDTH_PX;
        this.colWidth = this._colWidthPx + 'px';
    }
    getBoundingClientRect() {
        return this.el.nativeElement.getBoundingClientRect();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TableHeadingDirective, deps: [{ token: i0.ElementRef }, { token: FrozenColumnDirective, optional: true }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "16.1.0", version: "17.3.12", type: TableHeadingDirective, isStandalone: true, inputs: { visibilityMode: "visibilityMode", primaryText: "primaryText", columnToggleName: "columnToggleName", headers: "headers", id: "id", colWeight: "colWeight", resizable: ["resizable", "resizable", booleanAttribute], colWidth: "colWidth" }, host: { properties: { "class.hive-table-heading--hidden": "this._isHidden", "class.hive-table-heading--first-in-group": "this._firstInGroup", "class.hive-table-heading--last-in-group": "this._lastInGroup", "class.hive-table-heading--parental-header": "this._parentalHeader", "class.hive-table-heading--can-scroll-left": "this._canScrollLeft", "class.hive-table-heading--can-scroll-right": "this._canScrollRight", "class.hive-table-heading--rightmost-left-aligned": "this._rightmostLeftAligned", "class.hive-table-heading--leftmost-right-aligned": "this._leftmostRightAligned", "class.hive-table-heading--has-left-adjacent-visible-header": "this._hasLeftAdjacentVisibleHeader", "class.hive-table-heading--has-right-adjacent-visible-header": "this._hasRightAdjacentVisibleHeader", "attr.ordered": "this._order", "attr.rowspan": "this._rowSpan", "attr.visibility-mode": "this.visibilityMode", "attr.id": "this.id", "class": "this.class", "attr.scope": "this.scopeCol", "class.hive-table-heading--last-visible-in-table": "this._lastVisibleInTable", "class.hive-table-heading--child-header": "this.isChildHeader", "attr.colspan": "this.attrColspan", "attr.headers": "this.headersAttribute", "style.--width": "this.widthForColGroup", "style.--weight": "this.weightForColGroup" } }, ngImport: i0 }); }
}
__decorate([
    RequiredInput('ID attribute is required for every header') // @todo: remove after Angular 16 migration
], TableHeadingDirective.prototype, "id", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TableHeadingDirective, decorators: [{
            type: Directive,
            args: [{
                    standalone: true,
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: FrozenColumnDirective, decorators: [{
                    type: Optional
                }] }], propDecorators: { _isHidden: [{
                type: HostBinding,
                args: ['class.hive-table-heading--hidden']
            }], _firstInGroup: [{
                type: HostBinding,
                args: ['class.hive-table-heading--first-in-group']
            }], _lastInGroup: [{
                type: HostBinding,
                args: ['class.hive-table-heading--last-in-group']
            }], _parentalHeader: [{
                type: HostBinding,
                args: ['class.hive-table-heading--parental-header']
            }], _canScrollLeft: [{
                type: HostBinding,
                args: ['class.hive-table-heading--can-scroll-left']
            }], _canScrollRight: [{
                type: HostBinding,
                args: ['class.hive-table-heading--can-scroll-right']
            }], _rightmostLeftAligned: [{
                type: HostBinding,
                args: ['class.hive-table-heading--rightmost-left-aligned']
            }], _leftmostRightAligned: [{
                type: HostBinding,
                args: ['class.hive-table-heading--leftmost-right-aligned']
            }], _hasLeftAdjacentVisibleHeader: [{
                type: HostBinding,
                args: ['class.hive-table-heading--has-left-adjacent-visible-header']
            }], _hasRightAdjacentVisibleHeader: [{
                type: HostBinding,
                args: ['class.hive-table-heading--has-right-adjacent-visible-header']
            }], _order: [{
                type: HostBinding,
                args: ['attr.ordered']
            }], _rowSpan: [{
                type: HostBinding,
                args: ['attr.rowspan']
            }], visibilityMode: [{
                type: HostBinding,
                args: ['attr.visibility-mode']
            }, {
                type: Input
            }], primaryText: [{
                type: Input
            }], columnToggleName: [{
                type: Input
            }], headers: [{
                type: Input
            }], id: [{
                type: HostBinding,
                args: [`attr.${PARENT_ATTRIBUTE}`]
            }, {
                type: Input
            }], colWeight: [{
                type: Input
            }], class: [{
                type: HostBinding,
                args: ['class']
            }], scopeCol: [{
                type: HostBinding,
                args: ['attr.scope']
            }], _lastVisibleInTable: [{
                type: HostBinding,
                args: ['class.hive-table-heading--last-visible-in-table']
            }], resizable: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], colWidth: [{
                type: Input
            }], isChildHeader: [{
                type: HostBinding,
                args: ['class.hive-table-heading--child-header']
            }], attrColspan: [{
                type: HostBinding,
                args: ['attr.colspan']
            }], headersAttribute: [{
                type: HostBinding,
                args: [`attr.${PARENT_REFERENCE_ATTRIBUTE}`]
            }], widthForColGroup: [{
                type: HostBinding,
                args: ['style.--width']
            }], weightForColGroup: [{
                type: HostBinding,
                args: ['style.--weight']
            }] } });

function scrollWatch(element) {
    return fromEvent(element, 'scroll').pipe(map$1(() => element), startWith(element), map$1(({ scrollLeft, scrollWidth, clientWidth, scrollHeight, clientHeight, scrollTop, }) => ({
        canScrollLeft: scrollLeft > 0,
        canScrollRight: scrollLeft + clientWidth < scrollWidth,
        canScrollUp: scrollTop > 0,
        canScrollDown: scrollTop + clientHeight < scrollHeight,
    })), distinctUntilChanged((a, b) => {
        return (a.canScrollLeft === b.canScrollLeft &&
            a.canScrollRight === b.canScrollRight &&
            a.canScrollUp === b.canScrollUp &&
            a.canScrollDown === b.canScrollDown);
    }));
}

const RESIZING_PERSISTENCE_STORE = new InjectionToken('ResizingPersistenceStore', {
    factory: () => inject(DOCUMENT).defaultView.localStorage,
});

/**
 * For cells with custom content you can use `hive-template-cell` component to make them more consistent. It contains basic styling with align/padding logic configurable.
 *
 * @example
 * <td hive-template-cell>
 *    <hive-progress-bar
 *        percent="40"
 *        label="Example"
 *    ></hive-progress-bar>
 * </td>
 */
class TemplateCellComponent {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TemplateCellComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: TemplateCellComponent, selector: "td[hive-template-cell]", hostDirectives: [{ directive: HiveThemedDirective }], ngImport: i0, template: `
        <div class="hive-cell-wrapper">
            <div class="hive-template-cell">
                <ng-content></ng-content>
            </div>
        </div>
    `, isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TemplateCellComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'td[hive-template-cell]',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: `
        <div class="hive-cell-wrapper">
            <div class="hive-template-cell">
                <ng-content></ng-content>
            </div>
        </div>
    `,
                    hostDirectives: [HiveThemedDirective],
                }]
        }] });

/**
 * A table is an element used to display data in a grid format, with rows and columns.
 * It is typically used to present tabular data, such as
 * a list of items, records, or statistics.
 *
 * A table in a UI can be used to sort, filter and paginate data.
 */
class TableComponent {
    constructor(tableService, changeDetectorRef, ngZone, templatePipe, destroyRef, resizingPersistenceStorage) {
        this.tableService = tableService;
        this.changeDetectorRef = changeDetectorRef;
        this.ngZone = ngZone;
        this.templatePipe = templatePipe;
        this.destroyRef = destroyRef;
        this.resizingPersistenceStorage = resizingPersistenceStorage;
        /**
         *  Adding scrollable property along with a scrollHeight for the data viewport enables vertical scrolling with fixed headers.
         *  @default false
         */
        this.scrollable = false;
        /**
         * By default, filter change is triggered on `change` event.
         * But it can be changed to `keyup`/`keydown`/`keypress`/`input` events.
         */
        this.emitFiltersOn = 'input';
        /**
         * List of hidden columns' ids
         */
        this.hiddenColumns = [];
        /**
         * Displays a loading spinner to indicate that data load is in progress.
         */
        this.isLoading = false;
        /**
         * Displays an error message to indicate failed data request.
         */
        this.hasLoadingError = false;
        /**
         * Width sizing strategy for the table.
         */
        this.tableWidth = '100%';
        /**
         * Callback to invoke when a header clicked to change sorting.
         */
        this.sortChange = this.tableService.sortOutput$;
        this.columnResize = new EventEmitter();
        /**
         * @internal
         */
        this.tableHeight$ = new BehaviorSubject(null);
        /**
         * @internal
         */
        this.sizeUpdate$ = new Subject();
        this._hiddenColumns$ = new BehaviorSubject([]);
        this.columnVisibilityChange = this._hiddenColumns$.pipe(filter$1(() => !!this.tableHeadingDirectives), distinctUntilChanged((a, b) => a.sort().join(',') === b.sort().join(',')), map$1((hiddenColumns) => {
            return this.tableHeadingDirectives.map((tableHeader) => {
                const isHidden = hiddenColumns.includes(tableHeader.id);
                return { id: tableHeader.id, isVisible: !isHidden };
            });
        }));
        this.canScrollLeft$ = new BehaviorSubject(false);
        this.canScrollRight$ = new BehaviorSubject(false);
        this.canScrollUp$ = new BehaviorSubject(false);
        this._tableHeadingDirectives$ = new BehaviorSubject([]);
        /**
         * @internal
         */
        this.colGroups$ = combineLatest([
            this._tableHeadingDirectives$,
            this._hiddenColumns$,
        ])
            .pipe(delay(0), map$1(([tableHeadingDirectives, hiddenColumns]) => this.ngZone.runOutsideAngular(() => TableService.updateHiddenColumns(tableHeadingDirectives, hiddenColumns))), map$1((tableHeadingDirectives) => this.ngZone.runOutsideAngular(() => TableService.buildTree(tableHeadingDirectives))), map$1((tableHeadingDirectives) => this.ngZone.runOutsideAngular(() => TableService.updateNumberOfVisibleChildren(tableHeadingDirectives))), map$1((tableHeadingDirectives) => this.ngZone.runOutsideAngular(() => TableService.updateOrders(tableHeadingDirectives))))
            .pipe(map$1((tableHeadingDirectives) => this.ngZone.runOutsideAngular(() => TableService.updateLastAndFirstInGroup(tableHeadingDirectives))), map$1((tableHeadingDirectives) => this.ngZone.runOutsideAngular(() => TableService.updateLastVisibleInTable(tableHeadingDirectives))), map$1((tableHeadingDirectives) => this.ngZone.runOutsideAngular(() => TableService.calculateRightmostLeftAlignedFrozenColumn(tableHeadingDirectives))), map$1((tableHeadingDirectives) => this.ngZone.runOutsideAngular(() => TableService.calculateLeftmostRightAlignedFrozenColumn(tableHeadingDirectives))), map$1((tableHeadingDirectives) => this.ngZone.runOutsideAngular(() => TableService.calculateHeaderAdjacency(tableHeadingDirectives))));
        /**
         * @internal - used to compute the column offset
         */
        this.columnOffset$ = this.colGroups$.pipe(delay(1000), switchMap$1(() => this._tableHeadingDirectives$), filter$1((tableHeadingDirectives) => tableHeadingDirectives?.length > 0), map$1((tableHeadingDirectives) => this.ngZone.runOutsideAngular(() => TableService.computeOffsets(tableHeadingDirectives))));
        this._numberOfColumns$ = this.colGroups$.pipe(map$1((tableHeadingDirectives) => tableHeadingDirectives.reduce((acc, curr) => acc + (curr._cols.length || 1), 0)));
        /**
         * Updates when flag `hasLoadingError` changed
         */
        this._hasLoadingError$ = new BehaviorSubject(false);
        this._tableLayout$ = this.colGroups$.pipe(startWith$1([]), map$1((tableHeadingDirectives) => tableHeadingDirectives.length ? 'fixed' : 'auto'), distinctUntilChanged());
        /**
         * Updates when flag `isLoading` changed
         */
        this._isLoading$ = new BehaviorSubject(false);
        /**
         * This is an absolutely deliberate decision to put the 'body' template
         * in a separate property, because 'body' template is used to populate
         * each row of the table, thus leading to hundreds of unnecessary
         * calls to `tableTemplatePipe` where `.find()` is used every table rerender
         * @protected
         */
        this.bodyTemplate = null;
        this.destroyRef$ = inject(DestroyRef);
        /**
         * Callback to invoke when a header clicked to change filtering.
         *
         * Note that `filters` and `filterChange` are not related
         * and emit different signatures.
         */
        this.filterChange = this.tableService.filterOutput$.pipe(safeTakeUntilDestroyed(this.destroyRef$), filter$1((filterEvent) => filterEvent.eventType === 'input'), filter$1((filterEvent) => this.emitFiltersOn === filterEvent.eventType), map$1(({ filter }) => filter));
        /**
         * Updates when table data changed
         */
        this._value$ = new BehaviorSubject([]);
        this.tableResizingPersistenceApplied = false;
        this.defaultTrackByFunction = (_, item) => (this.dataKey ? item[this.dataKey] : item);
        combineLatest([this.colGroups$, this.sizeUpdate$])
            .pipe(skip(1), safeTakeUntilDestroyed(this.destroyRef), tap(([colGroups]) => {
            if (this.resizingPersistenceStoreId &&
                !this.tableResizingPersistenceApplied) {
                const storeVal = this.resizingPersistenceStorage.getItem(`hive-table-resizing-state-${this.resizingPersistenceStoreId}`);
                if (storeVal) {
                    const sizeRecords = JSON.parse(storeVal);
                    colGroups.forEach((colGroup) => {
                        const sizeRecord = sizeRecords.find((size) => size.id === colGroup.id);
                        if (sizeRecord) {
                            colGroup.colWidth = sizeRecord.width;
                            colGroup.colWeight = sizeRecord.weight;
                        }
                    });
                }
                this.tableResizingPersistenceApplied = true;
            }
            const sizes = colGroups.map((colGroup) => {
                return {
                    id: colGroup.id,
                    width: colGroup.colWidth,
                    weight: colGroup.colWeight,
                };
            });
            if (this.resizingPersistenceStoreId) {
                this.resizingPersistenceStorage.setItem(`hive-table-resizing-state-${this.resizingPersistenceStoreId}`, JSON.stringify(sizes));
            }
            this.columnResize.emit(sizes);
        }))
            .subscribe();
    }
    /**
     * Angular `TrackByFunction`, which is used inside the table
     * as `[ngForTrackBy]`
     */
    get trackByFunction() {
        return this.rowTrackBy ?? this.defaultTrackByFunction;
    }
    ngAfterContentInit() {
        this.contentTemplates.changes.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((value) => {
            this.bodyTemplate = this.templatePipe.transform('body', value);
            this.changeDetectorRef.detectChanges();
        });
        this.contentTemplates.notifyOnChanges();
    }
    ngAfterViewInit() {
        this.tableHeadingDirectives.changes.subscribe((tableHeadingDirectives) => {
            this._tableHeadingDirectives$.next(tableHeadingDirectives.toArray());
        });
        timer(0)
            .pipe(safeTakeUntilDestroyed(this.destroyRef$))
            .subscribe(() => {
            this.changeDetectorRef.detectChanges();
        });
        this.columnOffset$
            .pipe(switchMap$1(() => scrollWatch(this.tableWrapper.nativeElement)), safeTakeUntilDestroyed(this.destroyRef$))
            .subscribe(({ canScrollLeft, canScrollRight, canScrollUp }) => {
            this.canScrollLeft$.next(canScrollLeft);
            this.canScrollRight$.next(canScrollRight);
            this.canScrollUp$.next(canScrollUp);
            this.ngZone.runOutsideAngular(() => {
                TableService.updateScrolled(this._tableHeadingDirectives$.getValue(), canScrollLeft, canScrollRight);
            });
        });
        this._value$
            .pipe(safeTakeUntilDestroyed(this.destroyRef$))
            .subscribe(() => {
            this.changeDetectorRef.detectChanges();
        });
        observeOnResize(this.tableWrapper.nativeElement)
            .pipe(safeTakeUntilDestroyed(this.destroyRef$))
            .subscribe((entries) => {
            this.tableHeight$.next(entries[0].contentRect.height);
        });
        timer(0)
            .pipe(safeTakeUntilDestroyed(this.destroyRef$))
            .subscribe(() => {
            this.sizeUpdate$.next();
        });
    }
    ngOnChanges(changes) {
        if (changes['hiddenColumns']) {
            this.setHiddenColumns(changes['hiddenColumns'].currentValue);
        }
        if (changes['isLoading']) {
            this._isLoading$.next(changes['isLoading'].currentValue);
        }
        if (changes['hasLoadingError']) {
            this._hasLoadingError$.next(changes['hasLoadingError'].currentValue);
        }
        if (changes['value']) {
            this._value$.next(changes['value'].currentValue);
        }
        if (changes['filters']) {
            this.tableService.onFilterInput(changes['filters'].currentValue);
        }
        if (changes['filterDebounceWait']) {
            this.tableService.onFilterDebounceWaitChange(changes['filterDebounceWait'].currentValue);
        }
        if (changes['sort']) {
            this.tableService.onSortInput(changes['sort'].currentValue);
        }
    }
    /**
     * @param columnIds
     *
     * @internal - used by column toggle to override the hidden columns
     */
    setHiddenColumns(columnIds) {
        this._hiddenColumns$.next(columnIds);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TableComponent, deps: [{ token: TableService }, { token: i0.ChangeDetectorRef }, { token: i0.NgZone }, { token: HiveTemplatePipe }, { token: i0.DestroyRef }, { token: RESIZING_PERSISTENCE_STORE }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.3.12", type: TableComponent, selector: "hive-table", inputs: { dataKey: "dataKey", rowTrackBy: "rowTrackBy", scrollable: ["scrollable", "scrollable", booleanAttribute], scrollHeight: "scrollHeight", emitFiltersOn: "emitFiltersOn", filters: "filters", filterDebounceWait: ["filterDebounceWait", "filterDebounceWait", numberAttribute], hiddenColumns: "hiddenColumns", isLoading: ["isLoading", "isLoading", booleanAttribute], hasLoadingError: ["hasLoadingError", "hasLoadingError", booleanAttribute], value: "value", sort: "sort", tableWidth: "tableWidth", resizingPersistenceStoreId: "resizingPersistenceStoreId" }, outputs: { sortChange: "sortChange", columnResize: "columnResize", columnVisibilityChange: "columnVisibilityChange", filterChange: "filterChange" }, providers: [TableService, HiveTemplatePipe], queries: [{ propertyName: "tableHeadingDirectives", predicate: TableHeadingDirective, descendants: true }, { propertyName: "contentTemplates", predicate: HiveTemplateDirective }], viewQueries: [{ propertyName: "tableWrapper", first: true, predicate: ["tableWrapper"], descendants: true, static: true }, { propertyName: "viewTemplates", predicate: HiveTemplateDirective, descendants: true }], usesOnChanges: true, hostDirectives: [{ directive: HiveThemedDirective }], ngImport: i0, template: "@if (\n    ('utilityActions' | hiveTemplate: contentTemplates) ||\n    ('toolbar' | hiveTemplate: contentTemplates)\n) {\n    <div class=\"hive-table_top-bar\">\n        @if (\n            'utilityActions' | hiveTemplate: contentTemplates;\n            as utilityActionsTemplate\n        ) {\n            <div class=\"hive-table_utility-actions\">\n                <ng-container\n                    [ngTemplateOutlet]=\"utilityActionsTemplate\"\n                ></ng-container>\n            </div>\n        }\n        @if ('toolbar' | hiveTemplate: contentTemplates; as toolbarTemplate) {\n            <div class=\"hive-table_toolbar\">\n                <ng-container\n                    [ngTemplateOutlet]=\"toolbarTemplate\"\n                ></ng-container>\n            </div>\n        }\n    </div>\n}\n\n<ng-content></ng-content>\n\n<div\n    class=\"hive-table-wrapper\"\n    [ngClass]=\"{\n        'hive-table-wrapper--can-scroll-left': canScrollLeft$ | async,\n        'hive-table-wrapper--can-scroll-right': canScrollRight$ | async,\n        'hive-table-wrapper--can-scroll-up': canScrollUp$ | async,\n        'hive-table-wrapper--scrollable': scrollable,\n    }\"\n    [ngStyle]=\"columnOffset$ | async\"\n    [style.max-height]=\"scrollHeight\"\n    [style.table-layout]=\"_tableLayout$ | async\"\n    #tableWrapper\n>\n    <div class=\"hive-table-container\">\n        <table class=\"hive-table\" [style.width]=\"tableWidth\">\n            <ng-container\n                *ngTemplateOutlet=\"'colgroup' | hiveTemplate: viewTemplates\"\n            />\n            <thead class=\"hive-table-head\">\n                <ng-container\n                    *ngTemplateOutlet=\"\n                        'header' | hiveTemplate: contentTemplates\n                    \"\n                />\n            </thead>\n            <tbody class=\"hive-table-body\">\n                @if (value?.length) {\n                    @if (_hasLoadingError$ | async) {\n                        <tr>\n                            <td\n                                [attr.colspan]=\"_numberOfColumns$ | async\"\n                                data-testid=\"table-state\"\n                                hive-template-cell\n                            >\n                                <div class=\"hive-table-status\">\n                                    <ng-container\n                                        *ngTemplateOutlet=\"\n                                            'errorMessage'\n                                                | hiveTemplate\n                                                    : contentTemplates\n                                                    : viewTemplates\n                                        \"\n                                    />\n                                </div>\n                            </td>\n                        </tr>\n                    } @else {\n                        @for (\n                            rowData of value;\n                            track trackByFunction($index, rowData)\n                        ) {\n                            <ng-container\n                                *ngTemplateOutlet=\"\n                                    bodyTemplate;\n                                    context: {\n                                        $implicit: rowData,\n                                        rowIndex: $index,\n                                    }\n                                \"\n                            ></ng-container>\n                        }\n                    }\n                } @else {\n                    <tr>\n                        <td\n                            [attr.colspan]=\"_numberOfColumns$ | async\"\n                            data-testid=\"table-state\"\n                            hive-template-cell\n                        >\n                            <div class=\"hive-table-status\">\n                                @if (_isLoading$ | async) {\n                                    <ng-container\n                                        *ngTemplateOutlet=\"\n                                            'loadingIndicator'\n                                                | hiveTemplate\n                                                    : contentTemplates\n                                                    : viewTemplates\n                                        \"\n                                    />\n                                } @else if (_hasLoadingError$ | async) {\n                                    <ng-container\n                                        *ngTemplateOutlet=\"\n                                            'errorMessage'\n                                                | hiveTemplate\n                                                    : contentTemplates\n                                                    : viewTemplates\n                                        \"\n                                    />\n                                } @else {\n                                    <ng-container\n                                        *ngTemplateOutlet=\"\n                                            'noDataMessage'\n                                                | hiveTemplate\n                                                    : contentTemplates\n                                                    : viewTemplates\n                                        \"\n                                    />\n                                }\n                            </div>\n                        </td>\n                    </tr>\n                }\n                @if (value?.length && (_isLoading$ | async)) {\n                    <div class=\"hive-overlay\">\n                        <ng-container\n                            [ngTemplateOutlet]=\"\n                                'loadingIndicator'\n                                    | hiveTemplate\n                                        : contentTemplates\n                                        : viewTemplates\n                            \"\n                        ></ng-container>\n                    </div>\n                }\n            </tbody>\n        </table>\n    </div>\n</div>\n\n<ng-template hiveTemplate=\"colgroup\">\n    @for (colGroup of colGroups$ | async; track colGroup) {\n        <colgroup\n            [ngStyle]=\"{\n                '--total-children': colGroup._numberOfTotalChildren,\n                '--visible-children': colGroup._numberOfVisibleChildren,\n            }\"\n            [span]=\"colGroup._numberOfTotalChildren\"\n            class=\"hive-table-colgroup\"\n        >\n            @for (col of colGroup._cols; track col) {\n                <col\n                    [attr.headers]=\"col.headers\"\n                    [class.hive-table-col--hidden]=\"col._isHidden ?? null\"\n                    [ngStyle]=\"{\n                        '--weight': col.colWeight ?? null,\n                        '--width': col.colWidth ?? null,\n                    }\"\n                    class=\"hive-table-col\"\n                />\n            } @empty {\n                <col\n                    [attr.headers]=\"colGroup.id\"\n                    [class.hive-table-col--hidden]=\"colGroup._isHidden ?? null\"\n                    [ngStyle]=\"{\n                        '--weight': colGroup.colWeight ?? null,\n                        '--width': colGroup.colWidth ?? null,\n                    }\"\n                    class=\"hive-table-col\"\n                />\n            }\n        </colgroup>\n    }\n</ng-template>\n\n<ng-template hiveTemplate=\"errorMessage\">\n    <hive-empty-state\n        heading=\"Unable to load data\"\n        [description]=\"[\n            'There was an error while loading the data from the server.',\n            'Please refresh the page or try again later.',\n        ]\"\n        data-testid=\"hive-table-state_error\"\n    ></hive-empty-state>\n</ng-template>\n\n<ng-template hiveTemplate=\"noDataMessage\">\n    <hive-empty-state\n        description=\"Try adjusting your search or filters to find what you\u2019re looking for.\"\n        heading=\"No results found\"\n        data-testid=\"hive-table-state_empty\"\n    ></hive-empty-state>\n</ng-template>\n\n<ng-template hiveTemplate=\"loadingIndicator\">\n    <hive-loading-spinner\n        data-testid=\"hive-table-state_loading\"\n        label=\"Loading\"\n        size=\"x-large\"\n        displayMode=\"centered\"\n    ></hive-loading-spinner>\n</ng-template>\n", dependencies: [{ kind: "component", type: LoadingSpinnerComponent, selector: "hive-loading-spinner", inputs: ["displayMode", "orientation", "label", "size"] }, { kind: "component", type: EmptyStateComponent, selector: "hive-empty-state", inputs: ["heading", "description", "icon", "size"] }, { kind: "directive", type: HiveTemplateDirective, selector: "ng-template[hiveTemplate]", inputs: ["hiveTemplate"] }, { kind: "directive", type: i2$1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i2$1.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "directive", type: i2$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "component", type: TemplateCellComponent, selector: "td[hive-template-cell]" }, { kind: "pipe", type: HiveTemplatePipe, name: "hiveTemplate" }, { kind: "pipe", type: i2$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TableComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hive-table', providers: [TableService, HiveTemplatePipe], hostDirectives: [HiveThemedDirective], changeDetection: ChangeDetectionStrategy.OnPush, template: "@if (\n    ('utilityActions' | hiveTemplate: contentTemplates) ||\n    ('toolbar' | hiveTemplate: contentTemplates)\n) {\n    <div class=\"hive-table_top-bar\">\n        @if (\n            'utilityActions' | hiveTemplate: contentTemplates;\n            as utilityActionsTemplate\n        ) {\n            <div class=\"hive-table_utility-actions\">\n                <ng-container\n                    [ngTemplateOutlet]=\"utilityActionsTemplate\"\n                ></ng-container>\n            </div>\n        }\n        @if ('toolbar' | hiveTemplate: contentTemplates; as toolbarTemplate) {\n            <div class=\"hive-table_toolbar\">\n                <ng-container\n                    [ngTemplateOutlet]=\"toolbarTemplate\"\n                ></ng-container>\n            </div>\n        }\n    </div>\n}\n\n<ng-content></ng-content>\n\n<div\n    class=\"hive-table-wrapper\"\n    [ngClass]=\"{\n        'hive-table-wrapper--can-scroll-left': canScrollLeft$ | async,\n        'hive-table-wrapper--can-scroll-right': canScrollRight$ | async,\n        'hive-table-wrapper--can-scroll-up': canScrollUp$ | async,\n        'hive-table-wrapper--scrollable': scrollable,\n    }\"\n    [ngStyle]=\"columnOffset$ | async\"\n    [style.max-height]=\"scrollHeight\"\n    [style.table-layout]=\"_tableLayout$ | async\"\n    #tableWrapper\n>\n    <div class=\"hive-table-container\">\n        <table class=\"hive-table\" [style.width]=\"tableWidth\">\n            <ng-container\n                *ngTemplateOutlet=\"'colgroup' | hiveTemplate: viewTemplates\"\n            />\n            <thead class=\"hive-table-head\">\n                <ng-container\n                    *ngTemplateOutlet=\"\n                        'header' | hiveTemplate: contentTemplates\n                    \"\n                />\n            </thead>\n            <tbody class=\"hive-table-body\">\n                @if (value?.length) {\n                    @if (_hasLoadingError$ | async) {\n                        <tr>\n                            <td\n                                [attr.colspan]=\"_numberOfColumns$ | async\"\n                                data-testid=\"table-state\"\n                                hive-template-cell\n                            >\n                                <div class=\"hive-table-status\">\n                                    <ng-container\n                                        *ngTemplateOutlet=\"\n                                            'errorMessage'\n                                                | hiveTemplate\n                                                    : contentTemplates\n                                                    : viewTemplates\n                                        \"\n                                    />\n                                </div>\n                            </td>\n                        </tr>\n                    } @else {\n                        @for (\n                            rowData of value;\n                            track trackByFunction($index, rowData)\n                        ) {\n                            <ng-container\n                                *ngTemplateOutlet=\"\n                                    bodyTemplate;\n                                    context: {\n                                        $implicit: rowData,\n                                        rowIndex: $index,\n                                    }\n                                \"\n                            ></ng-container>\n                        }\n                    }\n                } @else {\n                    <tr>\n                        <td\n                            [attr.colspan]=\"_numberOfColumns$ | async\"\n                            data-testid=\"table-state\"\n                            hive-template-cell\n                        >\n                            <div class=\"hive-table-status\">\n                                @if (_isLoading$ | async) {\n                                    <ng-container\n                                        *ngTemplateOutlet=\"\n                                            'loadingIndicator'\n                                                | hiveTemplate\n                                                    : contentTemplates\n                                                    : viewTemplates\n                                        \"\n                                    />\n                                } @else if (_hasLoadingError$ | async) {\n                                    <ng-container\n                                        *ngTemplateOutlet=\"\n                                            'errorMessage'\n                                                | hiveTemplate\n                                                    : contentTemplates\n                                                    : viewTemplates\n                                        \"\n                                    />\n                                } @else {\n                                    <ng-container\n                                        *ngTemplateOutlet=\"\n                                            'noDataMessage'\n                                                | hiveTemplate\n                                                    : contentTemplates\n                                                    : viewTemplates\n                                        \"\n                                    />\n                                }\n                            </div>\n                        </td>\n                    </tr>\n                }\n                @if (value?.length && (_isLoading$ | async)) {\n                    <div class=\"hive-overlay\">\n                        <ng-container\n                            [ngTemplateOutlet]=\"\n                                'loadingIndicator'\n                                    | hiveTemplate\n                                        : contentTemplates\n                                        : viewTemplates\n                            \"\n                        ></ng-container>\n                    </div>\n                }\n            </tbody>\n        </table>\n    </div>\n</div>\n\n<ng-template hiveTemplate=\"colgroup\">\n    @for (colGroup of colGroups$ | async; track colGroup) {\n        <colgroup\n            [ngStyle]=\"{\n                '--total-children': colGroup._numberOfTotalChildren,\n                '--visible-children': colGroup._numberOfVisibleChildren,\n            }\"\n            [span]=\"colGroup._numberOfTotalChildren\"\n            class=\"hive-table-colgroup\"\n        >\n            @for (col of colGroup._cols; track col) {\n                <col\n                    [attr.headers]=\"col.headers\"\n                    [class.hive-table-col--hidden]=\"col._isHidden ?? null\"\n                    [ngStyle]=\"{\n                        '--weight': col.colWeight ?? null,\n                        '--width': col.colWidth ?? null,\n                    }\"\n                    class=\"hive-table-col\"\n                />\n            } @empty {\n                <col\n                    [attr.headers]=\"colGroup.id\"\n                    [class.hive-table-col--hidden]=\"colGroup._isHidden ?? null\"\n                    [ngStyle]=\"{\n                        '--weight': colGroup.colWeight ?? null,\n                        '--width': colGroup.colWidth ?? null,\n                    }\"\n                    class=\"hive-table-col\"\n                />\n            }\n        </colgroup>\n    }\n</ng-template>\n\n<ng-template hiveTemplate=\"errorMessage\">\n    <hive-empty-state\n        heading=\"Unable to load data\"\n        [description]=\"[\n            'There was an error while loading the data from the server.',\n            'Please refresh the page or try again later.',\n        ]\"\n        data-testid=\"hive-table-state_error\"\n    ></hive-empty-state>\n</ng-template>\n\n<ng-template hiveTemplate=\"noDataMessage\">\n    <hive-empty-state\n        description=\"Try adjusting your search or filters to find what you\u2019re looking for.\"\n        heading=\"No results found\"\n        data-testid=\"hive-table-state_empty\"\n    ></hive-empty-state>\n</ng-template>\n\n<ng-template hiveTemplate=\"loadingIndicator\">\n    <hive-loading-spinner\n        data-testid=\"hive-table-state_loading\"\n        label=\"Loading\"\n        size=\"x-large\"\n        displayMode=\"centered\"\n    ></hive-loading-spinner>\n</ng-template>\n" }]
        }], ctorParameters: () => [{ type: TableService }, { type: i0.ChangeDetectorRef }, { type: i0.NgZone }, { type: HiveTemplatePipe }, { type: i0.DestroyRef }, { type: Storage, decorators: [{
                    type: Inject,
                    args: [RESIZING_PERSISTENCE_STORE]
                }] }], propDecorators: { tableHeadingDirectives: [{
                type: ContentChildren,
                args: [TableHeadingDirective, { descendants: true }]
            }], dataKey: [{
                type: Input
            }], rowTrackBy: [{
                type: Input
            }], scrollable: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], scrollHeight: [{
                type: Input
            }], emitFiltersOn: [{
                type: Input
            }], filters: [{
                type: Input
            }], filterDebounceWait: [{
                type: Input,
                args: [{ transform: numberAttribute }]
            }], hiddenColumns: [{
                type: Input
            }], isLoading: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], hasLoadingError: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], value: [{
                type: Input
            }], sort: [{
                type: Input
            }], tableWidth: [{
                type: Input
            }], resizingPersistenceStoreId: [{
                type: Input
            }], sortChange: [{
                type: Output
            }], columnResize: [{
                type: Output
            }], viewTemplates: [{
                type: ViewChildren,
                args: [HiveTemplateDirective]
            }], contentTemplates: [{
                type: ContentChildren,
                args: [HiveTemplateDirective]
            }], columnVisibilityChange: [{
                type: Output
            }], tableWrapper: [{
                type: ViewChild,
                args: ['tableWrapper', { static: true }]
            }], filterChange: [{
                type: Output
            }] } });

class DebounceChangeModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DebounceChangeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: DebounceChangeModule, imports: [CommonModule, DebounceChangeDirective], exports: [DebounceChangeDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DebounceChangeModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DebounceChangeModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, DebounceChangeDirective],
                    exports: [DebounceChangeDirective],
                }]
        }] });

/**
 * Standalone SVG info icon
 *
 * @example
 * <hive-info-icon helpInfoIcon="question"></hive-info-icon>
 */
class InfoIconComponent {
    constructor() {
        this.helpInfoIcon = 'info';
    }
    /**
     * @internal
     */
    get helpInfoIconPath() {
        return this.helpInfoIcon === 'question'
            ? 'light/circle-question.svg'
            : 'light/circle-info.svg';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: InfoIconComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: InfoIconComponent, isStandalone: true, selector: "hive-info-icon", inputs: { helpInfoIcon: "helpInfoIcon" }, hostDirectives: [{ directive: HiveThemedDirective }], ngImport: i0, template: `
        <svg [hive-svg]="helpInfoIconPath" [width]="11" [height]="11"></svg>
    `, isInline: true, dependencies: [{ kind: "directive", type: SvgDirective, selector: "svg[hive-svg]", inputs: ["hive-svg", "width", "height"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: InfoIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'hive-info-icon',
                    template: `
        <svg [hive-svg]="helpInfoIconPath" [width]="11" [height]="11"></svg>
    `,
                    hostDirectives: [HiveThemedDirective],
                    standalone: true,
                    imports: [SvgDirective],
                }]
        }], propDecorators: { helpInfoIcon: [{
                type: Input
            }] } });

/**
 * Allows users to navigate through large amounts of data by viewing a specific subset of data at a time.
 *
 * @note Functions similarly to the pagination component from pure1-gui.
 *
 * @example
 * <hive-pagination [totalItemCount]="totalItemCount" [offset]="offset" [(itemsPerPage)]="itemsPerPage" [pageSizeDropdownVisible]="pageSizeDropdownVisible" [itemsPerPageOptions]="itemsPerPageOptions" (pageChange)="changeCallback($event)"></hive-pagination>
 */
class PaginationComponent {
    // When loading or undefined inputs, default to disable.
    get backButtonsDisabled() {
        if (this.isDefinedPipe.transform(this.totalItemCount)) {
            return this.offset <= 0 || this.disabled;
        }
        return true;
    }
    get forwardButtonsDisabled() {
        if (this.isDefinedPipe.transform(this.totalItemCount)) {
            return (this.offset + this._itemsPerPage >= this.totalItemCount ||
                this.disabled);
        }
        return true;
    }
    constructor(isDefinedPipe, destroyRef$) {
        this.isDefinedPipe = isDefinedPipe;
        this.destroyRef$ = destroyRef$;
        /**
         *  The current pagination offset, normalized along with {@link itemsPerPage}
         *  to ensure we have no partial pages. This means that regardless of input,
         *  the offset will be adjusted to be divisible by {@link itemsPerPage}.
         *
         */
        this.offset = 0;
        /**
         * The number of items within the dataset to show per page.
         * Will be overriden by the value from the dropdown if both are provided.
         * @default 10
         */
        this.itemsPerPage = 10;
        /**
         * Options for the items per page dropdown.
         * If empty, the dropdown will be hidden.
         * @default [10, 25, 50]
         */
        this.itemsPerPageOptions = [10, 25, 50];
        this.disabled = false;
        /**
         *  Emits a {@link Number} event when clicked, signifying the new {@link offset} value.
         */
        this.pageChange = new EventEmitter();
        /**
         * Emits a {@link Number} event when the items per page dropdown is changed.
         */
        this.itemsPerPageChange = new EventEmitter();
        this._pageSizeDropdownVisible = true;
        this._itemsPerPage = 10;
    }
    get label() {
        if (!this.totalItemCount) {
            return '0 of 0';
        }
        const rangeStart = Math.max(this.offset + 1, 1);
        const rangeEnd = Math.min(this.offset + this._itemsPerPage, this.totalItemCount);
        return `${rangeStart} - ${rangeEnd} of ${this.totalItemCount}`;
    }
    ngOnChanges(changes) {
        if (changes['itemsPerPageOptions']) {
            this._itemsPerPage = this.itemsPerPageOptions[0];
        }
        if (changes['itemsPerPageOptions'] ||
            changes['pageSizeDropdownVisible']) {
            if (this.itemsPerPageOptions.length === 0) {
                this._pageSizeDropdownVisible = false;
            }
            else {
                this._pageSizeDropdownVisible = coerceBooleanProperty(this.pageSizeDropdownVisible);
            }
        }
        if (changes['itemsPerPage']) {
            this._itemsPerPage = this.itemsPerPage;
        }
        if (changes['pageSizeDropdownVisible'] ||
            changes['itemsPerPageOptions'] ||
            changes['itemsPerPage']) {
            const hasMissingOption = !this.itemsPerPageOptions.includes(this.itemsPerPage);
            if (this._pageSizeDropdownVisible && hasMissingOption) {
                console.warn(`itemsPerPage must be one of the itemsPerPageOptions, but was ${this.itemsPerPage}`);
                this._itemsPerPage = this.itemsPerPageOptions[0];
            }
        }
        this.triggerPageChangeWhenOffsetHasRemainder();
    }
    computeProperOffset(currentOffset, itemsPerPage) {
        const currentPageNumber = Math.floor(currentOffset / itemsPerPage);
        const offsetWithoutPartial = currentPageNumber * itemsPerPage;
        // Don't allow negative pages
        return Math.max(offsetWithoutPartial, 0);
    }
    selectPage(newOffset) {
        const totalItemsDefined = this.isDefinedPipe.transform(this.totalItemCount);
        const itemsPerPageDefined = this.isDefinedPipe.transform(this._itemsPerPage);
        if (itemsPerPageDefined && totalItemsDefined) {
            // Make sure the new offset is divisible by the itemsPerPage (no partial pages)
            newOffset = this.computeProperOffset(newOffset, this._itemsPerPage);
        }
        else {
            // Otherwise, just reset to 0
            newOffset = 0;
        }
        this.emitPageChange(newOffset);
    }
    get hasRemainder() {
        const remainder = this.offset % this._itemsPerPage;
        const hasRemainder = remainder !== 0;
        const remainderIsNumber = !isNaN(remainder);
        return hasRemainder && remainderIsNumber;
    }
    triggerPageChangeWhenOffsetHasRemainder() {
        // If we're provided with partial page, automatically step back to the immediately prior full page
        if (this.hasRemainder) {
            // Need this in a timeout to avoid circular updates (ExpressionChangedAfterItHasBeenCheckedError)
            timer(0)
                .pipe(take(1), takeUntilDestroyed(this.destroyRef$))
                .subscribe(() => {
                this.selectPage(this.offset);
            });
        }
    }
    emitPageChange(offset) {
        this.pageChange.emit(offset);
    }
    pageSizeChanged(newPageSize) {
        this._itemsPerPage = newPageSize;
        this.itemsPerPageChange.emit(newPageSize);
        this.triggerPageChangeWhenOffsetHasRemainder();
        this.emitPageChange(this.offset);
    }
    get isTotalItemCountLessThanMinimalItemsPerPageOption() {
        const totalItemCount = this.totalItemCount;
        const hasOptions = this.itemsPerPageOptions.length > 0;
        const totalItemCountDefined = this.isDefinedPipe.transform(totalItemCount);
        return (hasOptions &&
            totalItemCountDefined &&
            totalItemCount <= Math.min(...this.itemsPerPageOptions));
    }
    get isDropdownDisabled() {
        const hasNoOptions = this.itemsPerPageOptions.length <= 1;
        const cannotGoNextOrPrevious = this.forwardButtonsDisabled && this.backButtonsDisabled;
        const isTotalItemCountLessThanMinimalItemsPerPageOption = this.isTotalItemCountLessThanMinimalItemsPerPageOption;
        if (cannotGoNextOrPrevious &&
            isTotalItemCountLessThanMinimalItemsPerPageOption) {
            return true;
        }
        return hasNoOptions || this.disabled;
    }
    get isDropdownVisible() {
        return (this.isDefinedPipe.transform(this.totalItemCount) &&
            this._pageSizeDropdownVisible);
    }
    goNextPage() {
        if (this.forwardButtonsDisabled) {
            return;
        }
        this.selectPage(this.offset + this._itemsPerPage);
    }
    goPreviousPage() {
        if (this.backButtonsDisabled) {
            return;
        }
        this.selectPage(this.offset - this._itemsPerPage);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PaginationComponent, deps: [{ token: IsDefinedPipe }, { token: i0.DestroyRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.3.12", type: PaginationComponent, isStandalone: true, selector: "hive-pagination", inputs: { totalItemCount: "totalItemCount", offset: "offset", itemsPerPage: "itemsPerPage", pageSizeDropdownVisible: "pageSizeDropdownVisible", itemsPerPageOptions: "itemsPerPageOptions", disabled: ["disabled", "disabled", booleanAttribute] }, outputs: { pageChange: "pageChange", itemsPerPageChange: "itemsPerPageChange" }, providers: [IsDefinedPipe], usesOnChanges: true, hostDirectives: [{ directive: HiveThemedDirective }], ngImport: i0, template: "<nav class=\"hive-pagination-container\">\n    <div class=\"hive-pagination-button-container\">\n        <hive-button\n            [disabled]=\"backButtonsDisabled\"\n            (click)=\"goPreviousPage()\"\n            icon=\"light/angle-left.svg\"\n            emphasis=\"tertiary\"\n        ></hive-button>\n\n        <hive-label\n            class=\"hive-pagination-label-container\"\n            [label]=\"label\"\n        ></hive-label>\n\n        <hive-button\n            [disabled]=\"forwardButtonsDisabled\"\n            (click)=\"goNextPage()\"\n            icon=\"light/angle-right.svg\"\n            emphasis=\"tertiary\"\n        ></hive-button>\n\n        @if (isDropdownVisible) {\n            <hive-dropdown\n                class=\"hive-pagination_dropdown\"\n                [ngModel]=\"_itemsPerPage\"\n                (ngModelChange)=\"pageSizeChanged($event)\"\n                [disabled]=\"isDropdownDisabled\"\n                size=\"small\"\n            >\n                @for (item of itemsPerPageOptions; track item) {\n                    <hive-selection-menu-item\n                        [label]=\"item + ''\"\n                        [value]=\"item\"\n                    ></hive-selection-menu-item>\n                }\n            </hive-dropdown>\n            <hive-label\n                class=\"hive-pagination_per-page-label\"\n                label=\"&nbsp;per page\"\n            ></hive-label>\n        }\n    </div>\n</nav>\n", dependencies: [{ kind: "ngmodule", type: FormsModule }, { kind: "directive", type: i1$3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$3.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: ButtonComponent, selector: "hive-button", inputs: ["type", "menuButtonActive", "hasMenuButtonCaret", "label", "accessibleName", "icon", "iconPosition", "emphasis", "title", "size", "isLoading", "disabled", "rounded", "width"] }, { kind: "component", type: LabelComponent, selector: "hive-label", inputs: ["label", "for", "size", "weight", "maxWeight", "horizontalAlignment", "leftIconHelpInfoMessage", "rightIconHelpInfoMessage", "leftIcon", "rightIcon", "required", "textOverflowEllipsis"] }, { kind: "ngmodule", type: DropdownModule }, { kind: "component", type: DropdownComponent, selector: "hive-dropdown", inputs: ["selection", "size", "hasFilter", "debounceWait", "hasLoadingError", "isLoading", "disabled", "label", "required", "helpInfoIcon", "helpInfoMessage", "errorMessages", "assistanceText", "placeholder", "hasFilterAutofocus"], outputs: ["tryAgainClick", "selectionChange", "filterChange"] }, { kind: "ngmodule", type: SelectionMenuModule }, { kind: "component", type: SelectionMenuItemComponent, selector: "hive-selection-menu-item", inputs: ["label", "value", "icon", "testId", "disabled"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PaginationComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hive-pagination', standalone: true, imports: [
                        FormsModule,
                        ButtonComponent,
                        LabelComponent,
                        IsDefinedPipe,
                        DropdownModule,
                        SelectionMenuModule,
                    ], providers: [IsDefinedPipe], changeDetection: ChangeDetectionStrategy.OnPush, hostDirectives: [HiveThemedDirective], template: "<nav class=\"hive-pagination-container\">\n    <div class=\"hive-pagination-button-container\">\n        <hive-button\n            [disabled]=\"backButtonsDisabled\"\n            (click)=\"goPreviousPage()\"\n            icon=\"light/angle-left.svg\"\n            emphasis=\"tertiary\"\n        ></hive-button>\n\n        <hive-label\n            class=\"hive-pagination-label-container\"\n            [label]=\"label\"\n        ></hive-label>\n\n        <hive-button\n            [disabled]=\"forwardButtonsDisabled\"\n            (click)=\"goNextPage()\"\n            icon=\"light/angle-right.svg\"\n            emphasis=\"tertiary\"\n        ></hive-button>\n\n        @if (isDropdownVisible) {\n            <hive-dropdown\n                class=\"hive-pagination_dropdown\"\n                [ngModel]=\"_itemsPerPage\"\n                (ngModelChange)=\"pageSizeChanged($event)\"\n                [disabled]=\"isDropdownDisabled\"\n                size=\"small\"\n            >\n                @for (item of itemsPerPageOptions; track item) {\n                    <hive-selection-menu-item\n                        [label]=\"item + ''\"\n                        [value]=\"item\"\n                    ></hive-selection-menu-item>\n                }\n            </hive-dropdown>\n            <hive-label\n                class=\"hive-pagination_per-page-label\"\n                label=\"&nbsp;per page\"\n            ></hive-label>\n        }\n    </div>\n</nav>\n" }]
        }], ctorParameters: () => [{ type: IsDefinedPipe }, { type: i0.DestroyRef }], propDecorators: { totalItemCount: [{
                type: Input
            }], offset: [{
                type: Input
            }], itemsPerPage: [{
                type: Input
            }], pageSizeDropdownVisible: [{
                type: Input
            }], itemsPerPageOptions: [{
                type: Input
            }], disabled: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], pageChange: [{
                type: Output
            }], itemsPerPageChange: [{
                type: Output
            }] } });

class CoerceBooleanPropertyPipe {
    transform(value) {
        return coerceBooleanProperty(value);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CoerceBooleanPropertyPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CoerceBooleanPropertyPipe, isStandalone: true, name: "coerceBooleanProperty" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CoerceBooleanPropertyPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'coerceBooleanProperty',
                    standalone: true,
                }]
        }] });

class CellPositioningContainerDirective {
    constructor() {
        /**
         * Horizontal alignment of the content inside the cell.
         * @default left
         */
        this.containerHorizontalAlignment = 'left';
    }
    get leftHorizontal() {
        return this.containerHorizontalAlignment === 'left';
    }
    get centerHorizontal() {
        return this.containerHorizontalAlignment === 'center';
    }
    get rightHorizontal() {
        return this.containerHorizontalAlignment === 'right';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CellPositioningContainerDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: CellPositioningContainerDirective, selector: "hive-cell-positioning-container", inputs: { containerHorizontalAlignment: "containerHorizontalAlignment" }, host: { properties: { "class.hive-cell-positioning-container-horizontal--left": "this.leftHorizontal", "class.hive-cell-positioning-container-horizontal--center": "this.centerHorizontal", "class.hive-cell-positioning-container-horizontal--right": "this.rightHorizontal" } }, hostDirectives: [{ directive: HiveThemedDirective }], ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CellPositioningContainerDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'hive-cell-positioning-container',
                    hostDirectives: [HiveThemedDirective],
                }]
        }], propDecorators: { containerHorizontalAlignment: [{
                type: Input
            }], leftHorizontal: [{
                type: HostBinding,
                args: ['class.hive-cell-positioning-container-horizontal--left']
            }], centerHorizontal: [{
                type: HostBinding,
                args: ['class.hive-cell-positioning-container-horizontal--center']
            }], rightHorizontal: [{
                type: HostBinding,
                args: ['class.hive-cell-positioning-container-horizontal--right']
            }] } });

/**
 * Table provides built-in single and multiple selection features where selected rows are bound to the
 * selection property and `onRowsSelect` - `onRowsUnselect` events are provided as optional callbacks and
 * '`selectionChange`'.
 * In order to enable this feature, define a `selectionMode`, bind a selection reference and add
 * `hiveTableRow` directive whose value is the `rowData` to the rows that can be selected.
 * To disable selection events on a particular row use `disabled`. By default,
 * each row click adds or removes the row from the selection.
 */
class TableSelectionManagerDirective {
    /**
     * Indicates whether multiple rows can be selected.
     */
    get allowMultiSelect() {
        return this.selectionMode === 'multiple';
    }
    constructor() {
        /**
         * The rows to be used for the table.
         */
        this.value = [];
        /**
         * The mode of selection. It could be 'single' for single row selection, 'multiple' for multiple rows selection,
         * or 'singleRequired' for single selection where the selected row cannot be deselected, only changed.
         */
        this.selectionMode = 'multiple';
        /**
         * The initial selection state of the rows.
         */
        this.selection = [];
        /**
         * An event that is emitted when rows are selected.
         */
        this.rowsSelect = new EventEmitter();
        /**
         * An event that is emitted when rows are unselected.
         */
        this.rowsUnselect = new EventEmitter();
        /**
         * An event that is emitted when the selection changes.
         */
        this.selectionChange = new EventEmitter();
        /**
         * A Subject that emits when the selection model instance has changed.
         * @internal
         */
        this.selectionModel$ = new BehaviorSubject(new SelectionModel(this.allowMultiSelect, this.selection ?? [], true, (a, b) => a[this.dataKey] === b[this.dataKey]));
        /**
         * @internal
         */
        this.selectionRows$ = new BehaviorSubject([]);
        /**
         * @internal
         */
        this.selectableRows$ = this.selectionRows$.pipe(
        // Switch to the array of items
        switchMap$1((items) => {
            // Map each item's disabled$ to include the item reference
            const itemObservables = items.map((item) => combineLatest([item.isDisabled$, item.selectable$]).pipe(map$1(([disabled, selectable]) => ({
                item,
                canBeSelected: !disabled && selectable,
            }))));
            // Combine the latest values from all item observables
            return combineLatest(itemObservables).pipe(
            // Filter out disabled items and extract the item
            map$1((itemStates) => itemStates
                .filter(({ canBeSelected }) => canBeSelected)
                .map(({ item }) => item)));
        }));
        /**
         * @internal
         */
        this.isAllSelected$ = merge(this.selectionModel$, this.selectionModel$.pipe(switchMap$1((model) => model.changed))).pipe(switchMap$1(() => combineLatest([
            this.selectableRows$,
            this.selectionModel$.pipe(map$1((model) => model.selected)),
        ])), map$1(([rows, selected]) => rows.every((row) => selected.includes(row.hiveTableRow))));
        /**
         * @internal
         */
        this.isAnySelected$ = merge(this.selectionModel$, this.selectionModel$.pipe(switchMap$1((model) => model.changed))).pipe(switchMap$1(() => combineLatest([
            this.selectableRows$,
            this.selectionModel$.pipe(map$1((model) => model.selected)),
        ])), map$1(([rows, selected]) => rows.some((row) => selected.includes(row.hiveTableRow))));
        this.selectionTriggeredBy = null;
        this.destroyRef = inject(DestroyRef);
        this.selectionModel$
            .pipe(safeTakeUntilDestroyed(this.destroyRef), switchMap$1((selectionModel) => selectionModel.changed), this.getEventEmitters())
            .subscribe();
    }
    ngAfterViewInit() {
        this.rows.changes.pipe(startWith$1(this.rows.toArray()), map$1(() => this.rows.toArray()), map$1((rows) => rows.filter(({ hiveTableRow }) => isDefined(hiveTableRow))), map$1((rows) => rows), safeTakeUntilDestroyed(this.destroyRef)).subscribe((rows) => {
            this.selectionRows$.next(rows);
        });
    }
    ngOnChanges(changes) {
        if (changes['selectionMode'] || changes['dataKey']) {
            const previousSelection = this.selectionModel$.value.selected;
            this.selectionModel$.next(new SelectionModel(this.allowMultiSelect, previousSelection, true, (a, b) => a[this.dataKey] === b[this.dataKey]));
        }
        if (changes['selection']) {
            const selectionModel = this.selectionModel$.getValue();
            selectionModel.clear();
            selectionModel.select(...(this.selection ?? []));
        }
    }
    toggleRow(row, source) {
        if (this.selectionMode === 'singleRequired' &&
            this.selectionModel$.getValue().isSelected(row)) {
            return;
        }
        this.selectionTriggeredBy = source ?? null;
        this.selectionModel$.getValue().toggle(row);
    }
    /**
     * @internal
     * @param row
     */
    isSelected$(row) {
        return merge(this.selectionModel$, this.selectionModel$.pipe(switchMap$1((model) => model.changed))).pipe(startWith$1(null), switchMap$1(() => this.selectionModel$), map$1((model) => model.isSelected(row)));
    }
    async toggleAllRows() {
        const allSelectableRows = await firstValueFrom(this.selectableRows$);
        const isAllSelected = await firstValueFrom(this.isAllSelected$);
        this.selectionTriggeredBy = 'header';
        if (isAllSelected) {
            this.selectionModel$
                .getValue()
                .deselect(...allSelectableRows.map((row) => row.hiveTableRow));
        }
        else {
            this.selectionModel$
                .getValue()
                .select(...allSelectableRows.map((row) => row.hiveTableRow));
        }
    }
    /**
     * Emits 3 different events from selectionModel changes event - selection, un-selection and changed
     * @internal
     */
    getEventEmitters() {
        return (selectionChange) => selectionChange.pipe(filter(() => !!this.selectionTriggeredBy), tap(({ added, removed, source }) => {
            if (added?.length) {
                this.rowsSelect?.emit?.({
                    data: added,
                    type: this.selectionTriggeredBy,
                });
            }
            if (removed?.length) {
                this.rowsUnselect?.emit?.({
                    data: removed,
                    type: this.selectionTriggeredBy,
                });
            }
            // check if selectionModel.selected is equal to this.selection
            if (source.selected.length !== this.selection?.length ||
                !source.selected.reduce((acc, row) => acc && this.selection.includes(row), true)) {
                // CLOUD-121226
                // only emit selectionchange if the selectionModel.selected is different from this.selection
                this.selectionChange?.emit?.({
                    data: source.selected,
                    type: this.selectionTriggeredBy,
                });
            }
        }), tap(() => {
            this.selectionTriggeredBy = null;
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TableSelectionManagerDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: TableSelectionManagerDirective, selector: "hive-table", inputs: { value: "value", selectionMode: "selectionMode", dataKey: "dataKey", selection: "selection" }, outputs: { rowsSelect: "rowsSelect", rowsUnselect: "rowsUnselect", selectionChange: "selectionChange" }, queries: [{ propertyName: "rows", predicate: i0.forwardRef(() => TableRowDirective) }], usesOnChanges: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TableSelectionManagerDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'hive-table',
                }]
        }], ctorParameters: () => [], propDecorators: { rows: [{
                type: ContentChildren,
                args: [forwardRef(() => TableRowDirective)]
            }], value: [{
                type: Input
            }], selectionMode: [{
                type: Input
            }], dataKey: [{
                type: Input
            }], selection: [{
                type: Input
            }], rowsSelect: [{
                type: Output
            }], rowsUnselect: [{
                type: Output
            }], selectionChange: [{
                type: Output
            }] } });

class TableHoverManagerDirective {
    constructor() {
        this.selectionModel = new SelectionModel(false, [], true, (a, b) => {
            if (this.dataKey) {
                return a[this.dataKey] === b[this.dataKey];
            }
            else {
                return a === b;
            }
        });
    }
    /**
     * Sets highlight state of a row
     *
     * @param value
     * @internal
     */
    setHoverState(value) {
        if (value) {
            this.selectionModel.select(value);
        }
        else {
            this.selectionModel.clear();
        }
    }
    /**
     * Returns whether the row is hovered or not
     * @param value
     * @internal
     */
    isHovered(value) {
        return this.selectionModel.changed.pipe(startWith$1(this.selectionModel.isSelected(value)), map(() => this.selectionModel.isSelected(value)), distinctUntilChanged());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TableHoverManagerDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: TableHoverManagerDirective, selector: "hive-table", inputs: { dataKey: "dataKey" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TableHoverManagerDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'hive-table',
                }]
        }], propDecorators: { dataKey: [{
                type: Input
            }] } });

/**
 * Represents the row directive with an option to make table rows selectable.
 */
class TableRowDirective {
    constructor(selectionManager, hoverManager, elementRef) {
        this.selectionManager = selectionManager;
        this.hoverManager = hoverManager;
        this.elementRef = elementRef;
        /**
         * A flag indicating whether the row is disabled.
         * Disabled rows cannot be selected and are excluded from keyboard navigation.
         *
         * @default false
         */
        this.disabled = false;
        /**
         * A flag indicating whether the row is selectable.
         *
         * Otherwise, table row is only responsible for rows highlight (hover).
         * @param value
         *
         * @default false
         */
        this.selectable = false;
        /**
         * @internal
         */
        this.isDisabled$ = new BehaviorSubject(this.disabled);
        /**
         * @internal
         */
        this.tableRow$ = new BehaviorSubject(this.hiveTableRow);
        /**
         * @internal
         */
        this.selectable$ = new BehaviorSubject(this.selectable);
        this.isSelected$ = this.tableRow$.pipe(switchMap$1((row) => this.selectionManager.isSelected$(row)));
        /**
         * @internal
         */
        this.baseClass = true;
        this.destroyRef$ = inject(DestroyRef);
    }
    get tabIndex() {
        return this.disabled ? null : 0;
    }
    ngOnInit() {
        merge(fromEvent(this.elementRef.nativeElement, 'pointerenter'), fromEvent(this.elementRef.nativeElement, 'focus'))
            .pipe(safeTakeUntilDestroyed(this.destroyRef$))
            .subscribe(() => {
            this.setHighlightState();
        });
        merge(fromEvent(this.elementRef.nativeElement, 'pointerleave'), fromEvent(this.elementRef.nativeElement, 'focusout'))
            .pipe(safeTakeUntilDestroyed(this.destroyRef$))
            .subscribe(() => {
            this.unsetHighlightState();
        });
        merge(fromEvent(this.elementRef.nativeElement, 'click'), fromEvent(this.elementRef.nativeElement, 'keydown.space'))
            .pipe(safeTakeUntilDestroyed(this.destroyRef$))
            .subscribe(() => this.toggleRow());
        this.tableRow$
            .pipe(safeTakeUntilDestroyed(this.destroyRef$), switchMap$1((row) => this.hoverManager.isHovered(row)))
            .subscribe((isHovered) => {
            const htmlElement = this.elementRef
                .nativeElement;
            htmlElement.classList.toggle('hive-table-row--has-highlight', isHovered);
        });
        this.isSelected$
            .pipe(safeTakeUntilDestroyed(this.destroyRef$))
            .subscribe((isSelected) => {
            const htmlElement = this.elementRef
                .nativeElement;
            htmlElement.classList.toggle('hive-table-row--has-selection', isSelected);
        });
    }
    ngOnChanges(changes) {
        if (changes['disabled']) {
            this.isDisabled$.next(booleanAttribute(changes['disabled'].currentValue));
        }
        if (changes['hiveTableRow']) {
            this.tableRow$.next(changes['hiveTableRow'].currentValue);
        }
        if (changes['selectable']) {
            this.selectable$.next(booleanAttribute(changes['selectable'].currentValue));
        }
    }
    /**
     * Toggles the selection state of the row.
     * This is usually called when the row is clicked or when the space key is pressed while the row is focused.
     *
     * @internal
     */
    async toggleRow(source = 'row') {
        const isDisabled = await firstValueFrom(this.isDisabled$);
        const isSelectable = await firstValueFrom(this.selectable$);
        if (isDisabled || !isSelectable) {
            return;
        }
        this.selectionManager.toggleRow(this.hiveTableRow, source);
    }
    setHighlightState() {
        this.hoverManager.setHoverState(this.hiveTableRow);
    }
    unsetHighlightState() {
        this.hoverManager.setHoverState();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TableRowDirective, deps: [{ token: forwardRef(() => TableSelectionManagerDirective) }, { token: forwardRef(() => TableHoverManagerDirective) }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "16.1.0", version: "17.3.12", type: TableRowDirective, selector: "tr[hiveTableRow]", inputs: { disabled: ["disabled", "disabled", booleanAttribute], hiveTableRow: "hiveTableRow", selectable: ["selectable", "selectable", booleanAttribute] }, host: { properties: { "class.hive-table-row--disabled": "this.disabled", "class.hive-table-row--selectable": "this.selectable", "class.hive-table-row": "this.baseClass", "attr.tabindex": "this.tabIndex" } }, exportAs: ["hiveTableRow"], usesOnChanges: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TableRowDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'tr[hiveTableRow]',
                    exportAs: 'hiveTableRow',
                }]
        }], ctorParameters: () => [{ type: TableSelectionManagerDirective, decorators: [{
                    type: Inject,
                    args: [forwardRef(() => TableSelectionManagerDirective)]
                }] }, { type: TableHoverManagerDirective, decorators: [{
                    type: Inject,
                    args: [forwardRef(() => TableHoverManagerDirective)]
                }] }, { type: i0.ElementRef }], propDecorators: { disabled: [{
                type: HostBinding,
                args: ['class.hive-table-row--disabled']
            }, {
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], hiveTableRow: [{
                type: Input,
                args: [{ required: true }]
            }], selectable: [{
                type: HostBinding,
                args: ['class.hive-table-row--selectable']
            }, {
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], baseClass: [{
                type: HostBinding,
                args: ['class.hive-table-row']
            }], tabIndex: [{
                type: HostBinding,
                args: ['attr.tabindex']
            }] } });

/**
 * @internal
 */
class DisabledTableRowDirective {
    constructor(
    // optional because in some cases, developers might define some 'empty'
    // `hive-cells` outside the `<tr hiveTableRow>`, thus breaking the logic.
    tableRow) {
        this.tableRow = tableRow;
        /**
         * For `legacy` theme, CSS `opacity` is applied.
         */
        this.isTableRowDisabled$ = combineLatest([
            this.tableRow?.isDisabled$ ?? of(false),
        ]).pipe(map(([isDisabled]) => isDisabled));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DisabledTableRowDirective, deps: [{ token: TableRowDirective, optional: true }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: DisabledTableRowDirective, isStandalone: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DisabledTableRowDirective, decorators: [{
            type: Directive,
            args: [{
                    standalone: true,
                }]
        }], ctorParameters: () => [{ type: TableRowDirective, decorators: [{
                    type: Optional
                }] }] });

function transformTableCellEmphasis(value) {
    return oneOfOrDefault(value, 'none', 'warning', 'critical');
}

/**
 * @internal
 */
class PrimaryTextComponent {
    constructor() {
        this.textOverflow = 'none';
        this.type = 'header';
        /**
         * If `true`, the text will be displayed in a disabled state.
         */
        this.disabled = false;
        this._type$ = new BehaviorSubject('header');
        this.weight$ = this._type$.pipe(map((type) => {
            if (type === 'header') {
                return 'semibold';
            }
            return 'regular';
        }));
    }
    ngOnChanges(changes) {
        if (changes['type']) {
            this._type$.next(changes['type'].currentValue);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PrimaryTextComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.3.12", type: PrimaryTextComponent, selector: "hive-primary-text", inputs: { primaryText: "primaryText", textOverflow: "textOverflow", type: "type", disabled: ["disabled", "disabled", booleanAttribute] }, usesOnChanges: true, hostDirectives: [{ directive: HiveThemedDirective }], ngImport: i0, template: `
        @for (line of primaryText | toArray; track line) {
            <hive-label
                class="hive-primary-text_line"
                [class.hive-primary-text_line--disabled]="disabled"
                [class.hive-primary-text_line--subheader]="type === 'subheader'"
                [class.hive-primary-text_line--header]="type === 'header'"
                [class.hive-primary-text_line--cell]="type === 'cell'"
                [attr.title]="textOverflow === 'tooltip' ? line : null"
                [label]="line"
                [weight]="weight$ | async"
                size="small"
            ></hive-label>
        }
    `, isInline: true, dependencies: [{ kind: "component", type: LabelComponent, selector: "hive-label", inputs: ["label", "for", "size", "weight", "maxWeight", "horizontalAlignment", "leftIconHelpInfoMessage", "rightIconHelpInfoMessage", "leftIcon", "rightIcon", "required", "textOverflowEllipsis"] }, { kind: "pipe", type: ToArrayPipe, name: "toArray" }, { kind: "pipe", type: i2$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PrimaryTextComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'hive-primary-text',
                    template: `
        @for (line of primaryText | toArray; track line) {
            <hive-label
                class="hive-primary-text_line"
                [class.hive-primary-text_line--disabled]="disabled"
                [class.hive-primary-text_line--subheader]="type === 'subheader'"
                [class.hive-primary-text_line--header]="type === 'header'"
                [class.hive-primary-text_line--cell]="type === 'cell'"
                [attr.title]="textOverflow === 'tooltip' ? line : null"
                [label]="line"
                [weight]="weight$ | async"
                size="small"
            ></hive-label>
        }
    `,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    hostDirectives: [HiveThemedDirective],
                }]
        }], propDecorators: { primaryText: [{
                type: Input
            }], textOverflow: [{
                type: Input
            }], type: [{
                type: Input
            }], disabled: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }] } });

/**
 * Cell has basic functionality to improve consistency between tables
 * and makes it easier to display data.
 */
class CellComponent {
    constructor(disabledRowDirective) {
        this.disabledRowDirective = disabledRowDirective;
        /**
         * Icon position.
         * @default left
         */
        this.iconPosition = 'left';
        /**
         * Horizontal alignment of the content inside the cell.
         * @default left
         */
        this.containerHorizontalAlignment = 'left';
        /**
         * Use to define icon for {@see helpInfoMessage} tooltip.
         *
         * @default info
         */
        this.helpInfoIcon = 'info';
        /**
         * Truncation behavior.
         *
         * Will NOT work with a custom link provided using content projection
         *
         * @default none
         */
        this.textOverflow = 'none';
        /**
         * Emphasis of the cell.
         */
        this.emphasis = 'none';
        this.isString = isString;
    }
    get emphasisClass() {
        return 'hive-cell--emphasis-' + this.emphasis;
    }
    get iconPath() {
        if (this.icon) {
            return this.icon;
        }
        if (this.emphasis === 'warning') {
            return 'light/circle-exclamation.svg';
        }
        if (this.emphasis === 'critical') {
            return 'light/triangle-exclamation.svg';
        }
        return null;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CellComponent, deps: [{ token: DisabledTableRowDirective }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.3.12", type: CellComponent, selector: "td[hive-cell]", inputs: { primaryText: "primaryText", icon: "icon", iconSize: "iconSize", iconStyle: "iconStyle", iconPosition: "iconPosition", containerHorizontalAlignment: "containerHorizontalAlignment", primaryTextTooltip: "primaryTextTooltip", helpInfoMessage: "helpInfoMessage", helpInfoIcon: "helpInfoIcon", iconTooltip: "iconTooltip", primaryTextNgClass: "primaryTextNgClass", textOverflow: "textOverflow", emphasis: ["emphasis", "emphasis", transformTableCellEmphasis] }, host: { properties: { "class": "this.emphasisClass" } }, hostDirectives: [{ directive: HiveThemedDirective }, { directive: DisabledTableRowDirective }], ngImport: i0, template: "<div class=\"hive-cell-wrapper\">\n    <hive-cell-positioning-container\n        [containerHorizontalAlignment]=\"containerHorizontalAlignment\"\n    >\n        <div class=\"hive-cell_container\">\n            @if (iconPath && iconPosition === 'left') {\n                <div\n                    class=\"hive-cell_icon-container\"\n                    hiveTooltip\n                    [hiveTooltipDescription]=\"\n                        isString(iconTooltip) ? iconTooltip : null\n                    \"\n                    [hiveTooltipCustomContentTemplateRef]=\"\n                        !isString(iconTooltip) ? iconTooltip : null\n                    \"\n                >\n                    <hive-icon-component\n                        class=\"hive-cell_icon\"\n                        [ngStyle]=\"$any(iconStyle)\"\n                        [icon]=\"iconPath\"\n                        [size]=\"iconSize\"\n                    ></hive-icon-component>\n                </div>\n            }\n\n            <div class=\"hive-cell_text-container\">\n                @if ((primaryText | isMultilineTextEmpty) === false) {\n                    <div\n                        class=\"hive-cell_primary-text\"\n                        hiveTooltip\n                        [hiveTooltipDescription]=\"\n                            isString(primaryTextTooltip)\n                                ? primaryTextTooltip\n                                : null\n                        \"\n                        [hiveTooltipCustomContentTemplateRef]=\"\n                            !isString(primaryTextTooltip)\n                                ? primaryTextTooltip\n                                : null\n                        \"\n                    >\n                        <hive-primary-text\n                            type=\"cell\"\n                            [disabled]=\"\n                                disabledRowDirective.isTableRowDisabled$ | async\n                            \"\n                            [primaryText]=\"primaryText\"\n                            [ngClass]=\"[primaryTextNgClass || '']\"\n                            [textOverflow]=\"textOverflow\"\n                        ></hive-primary-text>\n                    </div>\n                }\n\n                <ng-content select=\"hive-table-secondary-text\"></ng-content>\n            </div>\n\n            @if (iconPath && iconPosition === 'right') {\n                <div\n                    class=\"hive-cell_icon-container\"\n                    hiveTooltip\n                    [hiveTooltipDescription]=\"\n                        isString(iconTooltip) ? iconTooltip : null\n                    \"\n                    [hiveTooltipCustomContentTemplateRef]=\"\n                        !isString(iconTooltip) ? iconTooltip : null\n                    \"\n                >\n                    <hive-icon-component\n                        class=\"hive-cell_icon\"\n                        [ngStyle]=\"$any(iconStyle)\"\n                        [icon]=\"iconPath\"\n                        [size]=\"iconSize\"\n                    ></hive-icon-component>\n                </div>\n            }\n\n            @if (helpInfoMessage) {\n                <div class=\"hive-cell_info-icon-container\">\n                    <hive-info-icon\n                        class=\"hive-cell_info-icon\"\n                        hiveTooltip\n                        [hiveTooltipDescription]=\"\n                            isString(helpInfoMessage) ? helpInfoMessage : null\n                        \"\n                        [hiveTooltipCustomContentTemplateRef]=\"\n                            !isString(helpInfoMessage) ? helpInfoMessage : null\n                        \"\n                        [helpInfoIcon]=\"helpInfoIcon\"\n                    ></hive-info-icon>\n                </div>\n            }\n        </div>\n    </hive-cell-positioning-container>\n</div>\n", dependencies: [{ kind: "component", type: InfoIconComponent, selector: "hive-info-icon", inputs: ["helpInfoIcon"] }, { kind: "component", type: IconComponent, selector: "hive-icon-component", inputs: ["icon", "size"] }, { kind: "directive", type: TooltipDirective, selector: "[hiveTooltip]", inputs: ["hiveTooltipHeading", "hiveTooltipDescription", "hiveTooltipCustomContentTemplateRef", "hiveTooltipCustomContentContext", "disableTooltip", "hiveTooltipPosition", "hideDelay", "showDelay", "windowClass"], outputs: ["tooltipWindowHovered"] }, { kind: "directive", type: i2$1.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "directive", type: i2$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: CellPositioningContainerDirective, selector: "hive-cell-positioning-container", inputs: ["containerHorizontalAlignment"] }, { kind: "component", type: PrimaryTextComponent, selector: "hive-primary-text", inputs: ["primaryText", "textOverflow", "type", "disabled"] }, { kind: "pipe", type: IsMultilineTextEmptyPipe, name: "isMultilineTextEmpty" }, { kind: "pipe", type: i2$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CellComponent, decorators: [{
            type: Component,
            args: [{ selector: 'td[hive-cell]', changeDetection: ChangeDetectionStrategy.OnPush, hostDirectives: [HiveThemedDirective, DisabledTableRowDirective], template: "<div class=\"hive-cell-wrapper\">\n    <hive-cell-positioning-container\n        [containerHorizontalAlignment]=\"containerHorizontalAlignment\"\n    >\n        <div class=\"hive-cell_container\">\n            @if (iconPath && iconPosition === 'left') {\n                <div\n                    class=\"hive-cell_icon-container\"\n                    hiveTooltip\n                    [hiveTooltipDescription]=\"\n                        isString(iconTooltip) ? iconTooltip : null\n                    \"\n                    [hiveTooltipCustomContentTemplateRef]=\"\n                        !isString(iconTooltip) ? iconTooltip : null\n                    \"\n                >\n                    <hive-icon-component\n                        class=\"hive-cell_icon\"\n                        [ngStyle]=\"$any(iconStyle)\"\n                        [icon]=\"iconPath\"\n                        [size]=\"iconSize\"\n                    ></hive-icon-component>\n                </div>\n            }\n\n            <div class=\"hive-cell_text-container\">\n                @if ((primaryText | isMultilineTextEmpty) === false) {\n                    <div\n                        class=\"hive-cell_primary-text\"\n                        hiveTooltip\n                        [hiveTooltipDescription]=\"\n                            isString(primaryTextTooltip)\n                                ? primaryTextTooltip\n                                : null\n                        \"\n                        [hiveTooltipCustomContentTemplateRef]=\"\n                            !isString(primaryTextTooltip)\n                                ? primaryTextTooltip\n                                : null\n                        \"\n                    >\n                        <hive-primary-text\n                            type=\"cell\"\n                            [disabled]=\"\n                                disabledRowDirective.isTableRowDisabled$ | async\n                            \"\n                            [primaryText]=\"primaryText\"\n                            [ngClass]=\"[primaryTextNgClass || '']\"\n                            [textOverflow]=\"textOverflow\"\n                        ></hive-primary-text>\n                    </div>\n                }\n\n                <ng-content select=\"hive-table-secondary-text\"></ng-content>\n            </div>\n\n            @if (iconPath && iconPosition === 'right') {\n                <div\n                    class=\"hive-cell_icon-container\"\n                    hiveTooltip\n                    [hiveTooltipDescription]=\"\n                        isString(iconTooltip) ? iconTooltip : null\n                    \"\n                    [hiveTooltipCustomContentTemplateRef]=\"\n                        !isString(iconTooltip) ? iconTooltip : null\n                    \"\n                >\n                    <hive-icon-component\n                        class=\"hive-cell_icon\"\n                        [ngStyle]=\"$any(iconStyle)\"\n                        [icon]=\"iconPath\"\n                        [size]=\"iconSize\"\n                    ></hive-icon-component>\n                </div>\n            }\n\n            @if (helpInfoMessage) {\n                <div class=\"hive-cell_info-icon-container\">\n                    <hive-info-icon\n                        class=\"hive-cell_info-icon\"\n                        hiveTooltip\n                        [hiveTooltipDescription]=\"\n                            isString(helpInfoMessage) ? helpInfoMessage : null\n                        \"\n                        [hiveTooltipCustomContentTemplateRef]=\"\n                            !isString(helpInfoMessage) ? helpInfoMessage : null\n                        \"\n                        [helpInfoIcon]=\"helpInfoIcon\"\n                    ></hive-info-icon>\n                </div>\n            }\n        </div>\n    </hive-cell-positioning-container>\n</div>\n" }]
        }], ctorParameters: () => [{ type: DisabledTableRowDirective }], propDecorators: { primaryText: [{
                type: Input
            }], icon: [{
                type: Input
            }], iconSize: [{
                type: Input
            }], iconStyle: [{
                type: Input
            }], iconPosition: [{
                type: Input
            }], containerHorizontalAlignment: [{
                type: Input
            }], primaryTextTooltip: [{
                type: Input
            }], helpInfoMessage: [{
                type: Input
            }], helpInfoIcon: [{
                type: Input
            }], iconTooltip: [{
                type: Input
            }], primaryTextNgClass: [{
                type: Input
            }], textOverflow: [{
                type: Input
            }], emphasis: [{
                type: Input,
                args: [{ transform: transformTableCellEmphasis }]
            }], emphasisClass: [{
                type: HostBinding,
                args: ['class']
            }] } });

class LinkCellComponent {
    constructor(disabledRowDirective) {
        this.disabledRowDirective = disabledRowDirective;
        /**
         * Disable redirect if {@link linkHref} specified
         */
        this.disableLinkRedirect = false;
        /**
         * Whether the link is external. External will open the link in a new tab,
         * and is indicated visually by an icon appended to the link text.
         *
         * @default false
         */
        this.external = false;
        /**
         * Truncation behavior.
         *
         * Will not work with a custom link provided using content projection
         */
        this.textOverflow = 'none';
        /**
         * Horizontal alignment of the content inside the cell.
         *
         * @default left
         */
        this.containerHorizontalAlignment = 'left';
        /**
         * On click event handler. Throws click event object with 'url' (from {@link linkHref}).
         *
         * Will not work with a custom link provided using content projection
         */
        this.linkClick = new EventEmitter();
        this.isString = isString;
    }
    handleLinkClick(event) {
        if (this.disableLinkRedirect) {
            event.preventDefault();
        }
        event.stopPropagation();
        this.linkClick.emit({ event, url: this.linkHref });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: LinkCellComponent, deps: [{ token: DisabledTableRowDirective }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.3.12", type: LinkCellComponent, selector: "td[hive-link-cell]", inputs: { linkText: "linkText", linkHref: "linkHref", disableLinkRedirect: "disableLinkRedirect", linkTooltip: "linkTooltip", external: ["external", "external", booleanAttribute], textOverflow: "textOverflow", containerHorizontalAlignment: "containerHorizontalAlignment" }, outputs: { linkClick: "linkClick" }, hostDirectives: [{ directive: HiveThemedDirective }, { directive: DisabledTableRowDirective }], ngImport: i0, template: `
        <div class="hive-cell-wrapper">
            <hive-cell-positioning-container>
                <div class="hive-link-cell_container">
                    @if (linkText | isDefined) {
                        <a
                            hive-link
                            [disabled]="
                                disabledRowDirective.isTableRowDisabled$ | async
                            "
                            [external]="external"
                            [attr.href]="linkHref ? linkHref : null"
                            hiveTooltip="linkTooltip"
                            [hiveTooltipDescription]="
                                isString(linkTooltip) ? linkTooltip : null
                            "
                            [hiveTooltipCustomContentTemplateRef]="
                                !isString(linkTooltip) ? linkTooltip : null
                            "
                            [attr.title]="
                                textOverflow === 'tooltip' ? linkText : null
                            "
                            (click)="handleLinkClick($event)"
                        >
                            {{ linkText }}
                        </a>
                    }

                    @if ((linkText | isDefined) === false) {
                        <ng-content select="a[hive-link]"></ng-content>
                    }
                </div>
            </hive-cell-positioning-container>
        </div>
    `, isInline: true, dependencies: [{ kind: "component", type: LinkComponent, selector: "a[hive-link]", inputs: ["disabled", "size", "external"] }, { kind: "directive", type: TooltipDirective, selector: "[hiveTooltip]", inputs: ["hiveTooltipHeading", "hiveTooltipDescription", "hiveTooltipCustomContentTemplateRef", "hiveTooltipCustomContentContext", "disableTooltip", "hiveTooltipPosition", "hideDelay", "showDelay", "windowClass"], outputs: ["tooltipWindowHovered"] }, { kind: "directive", type: CellPositioningContainerDirective, selector: "hive-cell-positioning-container", inputs: ["containerHorizontalAlignment"] }, { kind: "pipe", type: IsDefinedPipe, name: "isDefined" }, { kind: "pipe", type: i2$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: LinkCellComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'td[hive-link-cell]',
                    template: `
        <div class="hive-cell-wrapper">
            <hive-cell-positioning-container>
                <div class="hive-link-cell_container">
                    @if (linkText | isDefined) {
                        <a
                            hive-link
                            [disabled]="
                                disabledRowDirective.isTableRowDisabled$ | async
                            "
                            [external]="external"
                            [attr.href]="linkHref ? linkHref : null"
                            hiveTooltip="linkTooltip"
                            [hiveTooltipDescription]="
                                isString(linkTooltip) ? linkTooltip : null
                            "
                            [hiveTooltipCustomContentTemplateRef]="
                                !isString(linkTooltip) ? linkTooltip : null
                            "
                            [attr.title]="
                                textOverflow === 'tooltip' ? linkText : null
                            "
                            (click)="handleLinkClick($event)"
                        >
                            {{ linkText }}
                        </a>
                    }

                    @if ((linkText | isDefined) === false) {
                        <ng-content select="a[hive-link]"></ng-content>
                    }
                </div>
            </hive-cell-positioning-container>
        </div>
    `,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    hostDirectives: [HiveThemedDirective, DisabledTableRowDirective],
                }]
        }], ctorParameters: () => [{ type: DisabledTableRowDirective }], propDecorators: { linkText: [{
                type: Input
            }], linkHref: [{
                type: Input
            }], disableLinkRedirect: [{
                type: Input
            }], linkTooltip: [{
                type: Input
            }], external: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], textOverflow: [{
                type: Input
            }], containerHorizontalAlignment: [{
                type: Input
            }], linkClick: [{
                type: Output
            }] } });

class SquareCellComponent {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SquareCellComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: SquareCellComponent, selector: "td[hive-square-cell]", hostDirectives: [{ directive: HiveThemedDirective }], ngImport: i0, template: `
        <div class="hive-cell-wrapper hive-square-cell_wrapper">
            <ng-content></ng-content>
        </div>
    `, isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SquareCellComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'td[hive-square-cell]',
                    template: `
        <div class="hive-cell-wrapper hive-square-cell_wrapper">
            <ng-content></ng-content>
        </div>
    `,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    hostDirectives: [HiveThemedDirective],
                }]
        }] });

const COLUMN_TOGGLE_PERSISTENCE_STORE = new InjectionToken('ColumnTogglePersistenceStore', {
    factory: () => inject(DOCUMENT).defaultView.sessionStorage,
});

/**
 * Technically, table is not expected to have more than one level of nesting.
 * However, this is not enforced in the code in any way.
 * To avoid issues with that, better to recursively clone the nested columns.
 *
 * @param nestedColumns
 * @returns
 */
function cloneNestedColumns(nestedColumns) {
    return nestedColumns.map((subCol) => ({
        id: subCol.id,
        cols: cloneNestedColumns(subCol._cols),
        utilityText: subCol.utilityText,
        isHidden: subCol._isHidden,
        visibilityMode: subCol.visibilityMode,
    }));
}
function getNotIgnoredColumns(tableHeadersParam) {
    const columns = [];
    for (const tableHeader of tableHeadersParam) {
        if (tableHeader.visibilityMode === 'column-toggle-ignored')
            continue;
        const nestedColumns = cloneNestedColumns(tableHeader._cols.filter((subCol) => subCol.visibilityMode !== 'column-toggle-ignored'));
        columns.push({
            id: tableHeader.id,
            cols: nestedColumns,
            utilityText: tableHeader.utilityText,
            isHidden: tableHeader._isHidden,
            visibilityMode: tableHeader.visibilityMode,
        });
    }
    return columns;
}
/**
 * This component is used to toggle columns in the table.
 * Supports persisting the state of the columns.
 * By default, it will be stored in SessionStorage.
 * Storage of the state can be provided using `COLUMN_TOGGLE_PERSISTENCE_STORE` injection token.
 * ```
 * {
 *      provide: COLUMN_TOGGLE_PERSISTENCE_STORE,
 *      useFactory: (injector: Injector) => {
 *          return injector.get(DOCUMENT).defaultView!.localStorage;
 *      },
 *      deps: [Injector],
 * },
 * ```
 */
class ColumnToggleComponent {
    get tableComponent() {
        const tableComponent = this.table || this.parentTable;
        if (!tableComponent) {
            throw new Error('Table component is required. Please provide it as an input or use the component inside the table.');
        }
        return tableComponent;
    }
    constructor(parentTable, persistenceStorage, cdr) {
        this.parentTable = parentTable;
        this.persistenceStorage = persistenceStorage;
        this.cdr = cdr;
        /**
         * Emits when the selection of columns changes.
         *
         * @see {HiveSelectionChange}
         */
        this.columnsChange = new EventEmitter();
        this.columns = [];
        this.filteredColumns = [];
        this.selectedColumnsIds = [];
        this.filter = '';
        this.destroyRef = inject(DestroyRef);
        this._selectedColumnsInitialized = false;
        this.persistenceApplied = false;
        this.noDefaultColumnWarningIssued = false;
    }
    ngOnInit() {
        this.tableComponent.colGroups$
            .pipe(skip(1), takeUntilDestroyed(this.destroyRef)) // skip first value, as it is the empty value because of detectChanges
            .subscribe((colGroups) => {
            this.columns = getNotIgnoredColumns(colGroups);
            if (!this.noDefaultColumnWarningIssued) {
                this.ensureThatThereIsDefaultColumn();
            }
            this.cdr.detectChanges();
            this.selectedColumnsIds = [];
            const columns = this.getAllColumns();
            // If first set, take selection from persistence storage
            if (this.persistStateId && !this.persistenceApplied) {
                const storeVal = this.persistenceStorage.getItem(`hive-column-toggle-state-${this.persistStateId}`);
                if (storeVal) {
                    const selectedColumns = JSON.parse(storeVal ?? '[]');
                    const hiddenColumns = [];
                    columns.forEach((column) => {
                        if (!selectedColumns.some((sc) => column.id === sc) ||
                            column.visibilityMode ===
                                'column-toggle-ignored') {
                            hiddenColumns.push(column.id);
                        }
                        else {
                            this.selectedColumnsIds.push(column.id);
                        }
                    });
                    this.tableComponent.setHiddenColumns(hiddenColumns);
                }
                else {
                    this.updateSelectedColumnIds(columns);
                }
                this.persistenceApplied = true;
            }
            else {
                this.updateSelectedColumnIds(columns);
            }
            if (!this._selectedColumnsInitialized &&
                this.selectedColumnsIds.length !== 0) {
                this._selectedColumnsInitialized = true;
            }
            this.updateFilteredColumns();
            this.cdr.detectChanges();
        });
    }
    updateSelectedColumnIds(columns) {
        columns.forEach((column) => {
            if (column.isHidden ||
                column.visibilityMode === 'column-toggle-ignored') {
                return;
            }
            this.selectedColumnsIds.push(column.id);
        });
        if (this.persistStateId) {
            this.persistenceStorage.setItem(`hive-column-toggle-state-${this.persistStateId}`, JSON.stringify(this.selectedColumnsIds));
        }
    }
    handleChange(event) {
        // this transformation is needed because table utilizes concept of
        // 'hidden columns', rather than 'visible columns' (= selectedColumns)
        const hiddenColumns = this.getAllColumns()
            .filter((column) => !event.selection.includes(column.id))
            .map((column) => column.id);
        this.tableComponent.setHiddenColumns(hiddenColumns);
    }
    handleFilterChange(filter) {
        this.filter = filter;
        this.updateFilteredColumns();
    }
    handleSelectionChange(event) {
        this.columnsChange.emit(event);
        this.handleChange(event);
    }
    updateFilteredColumns() {
        this.filteredColumns = this.columns.filter((column) => {
            return (this.isMatchingFilter(column) ||
                column.cols.some((c) => this.isMatchingFilter(c)));
        });
    }
    isMatchingFilter(column) {
        return column.utilityText
            ?.toLowerCase()
            .includes(this.filter.toLowerCase());
    }
    getAllColumns() {
        const result = new Array();
        this.columns.forEach((column) => {
            result.push(column);
            column?.cols.map((child) => {
                result.push(child);
            });
        });
        return result;
    }
    ensureThatThereIsDefaultColumn() {
        if (!this.columns.some((column) => {
            return (column.visibilityMode === 'column-toggle-disabled' &&
                !column.isHidden);
        })) {
            // eslint-disable-next-line no-console
            console.warn('ColumnToggleComponent: There is no default column (column-toggle-disabled and visible). This can lead to situation where all columns are hidden which is not recommended.');
            this.noDefaultColumnWarningIssued = true;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ColumnToggleComponent, deps: [{ token: TableComponent, optional: true }, { token: COLUMN_TOGGLE_PERSISTENCE_STORE }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.3.12", type: ColumnToggleComponent, selector: "hive-column-toggle", inputs: { persistStateId: "persistStateId", table: "table" }, outputs: { columnsChange: "columnsChange" }, hostDirectives: [{ directive: HiveThemedDirective }], ngImport: i0, template: "<hive-menu\n    #menu\n    position=\"bottomEnd\"\n    [closeOnMenuClick]=\"false\"\n    [closeOnPageResize]=\"true\"\n    [useContentPadding]=\"false\"\n>\n    <hive-button\n        hiveMenuButton\n        icon=\"light/table-columns.svg\"\n        size=\"small\"\n        emphasis=\"tertiary\"\n        hiveTooltip\n        hiveTooltipDescription=\"Customize columns\"\n        hiveTooltipPosition=\"bottomLeft\"\n        [caret]=\"false\"\n        [disableTooltip]=\"menu.overlayComponent?.connectedOverlayOpen\"\n    ></hive-button>\n\n    <hive-selection-menu\n        multiselect\n        hasFilter\n        (selectionChange)=\"handleSelectionChange($event)\"\n        [selection]=\"selectedColumnsIds\"\n        (filterChange)=\"handleFilterChange($event)\"\n    >\n        <ng-container ngProjectAs=\"hive-selection-menu-item\">\n            @for (column of filteredColumns; track column.id) {\n                @if (column.cols.length) {\n                    <hive-selection-menu-group-item\n                        [value]=\"column.id\"\n                        [label]=\"column.utilityText\"\n                        [disabled]=\"\n                            column.visibilityMode === 'column-toggle-disabled'\n                        \"\n                    >\n                        @for (col of column.cols; track col.id) {\n                            <hive-selection-menu-item\n                                [value]=\"col.id\"\n                                [label]=\"col.utilityText\"\n                                [disabled]=\"\n                                    col.visibilityMode ===\n                                    'column-toggle-disabled'\n                                \"\n                            ></hive-selection-menu-item>\n                        }\n                    </hive-selection-menu-group-item>\n                } @else {\n                    <hive-selection-menu-item\n                        [value]=\"column.id\"\n                        [label]=\"column.utilityText\"\n                        [disabled]=\"\n                            column.visibilityMode === 'column-toggle-disabled'\n                        \"\n                    ></hive-selection-menu-item>\n                }\n            }\n        </ng-container>\n    </hive-selection-menu>\n</hive-menu>\n", dependencies: [{ kind: "component", type: ButtonComponent, selector: "hive-button", inputs: ["type", "menuButtonActive", "hasMenuButtonCaret", "label", "accessibleName", "icon", "iconPosition", "emphasis", "title", "size", "isLoading", "disabled", "rounded", "width"] }, { kind: "component", type: SelectionMenuComponent, selector: "hive-selection-menu", inputs: ["selectionItems", "selectionContent", "hasFilter", "multiselect", "hasLoadingError", "isLoading", "debounceWait", "hideSeparators", "selection"], outputs: ["selectionChange", "tryAgainClick", "filterChange"] }, { kind: "component", type: SelectionMenuItemComponent, selector: "hive-selection-menu-item", inputs: ["label", "value", "icon", "testId", "disabled"] }, { kind: "component", type: SelectionMenuGroupItemComponent, selector: "hive-selection-menu-group-item", inputs: ["label", "value", "disabled"] }, { kind: "directive", type: TooltipDirective, selector: "[hiveTooltip]", inputs: ["hiveTooltipHeading", "hiveTooltipDescription", "hiveTooltipCustomContentTemplateRef", "hiveTooltipCustomContentContext", "disableTooltip", "hiveTooltipPosition", "hideDelay", "showDelay", "windowClass"], outputs: ["tooltipWindowHovered"] }, { kind: "directive", type: MenuButtonDirective, selector: "hive-button[hiveMenuButton]", inputs: ["caret"] }, { kind: "component", type: MenuComponent, selector: "hive-menu", inputs: ["position", "overlay", "offsetX", "offsetY", "closeOnMenuClick", "closeOnPageResize", "useContentPadding"], outputs: ["visibilityChange", "menuClick"], exportAs: ["hiveMenu"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ColumnToggleComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hive-column-toggle', changeDetection: ChangeDetectionStrategy.OnPush, hostDirectives: [HiveThemedDirective], template: "<hive-menu\n    #menu\n    position=\"bottomEnd\"\n    [closeOnMenuClick]=\"false\"\n    [closeOnPageResize]=\"true\"\n    [useContentPadding]=\"false\"\n>\n    <hive-button\n        hiveMenuButton\n        icon=\"light/table-columns.svg\"\n        size=\"small\"\n        emphasis=\"tertiary\"\n        hiveTooltip\n        hiveTooltipDescription=\"Customize columns\"\n        hiveTooltipPosition=\"bottomLeft\"\n        [caret]=\"false\"\n        [disableTooltip]=\"menu.overlayComponent?.connectedOverlayOpen\"\n    ></hive-button>\n\n    <hive-selection-menu\n        multiselect\n        hasFilter\n        (selectionChange)=\"handleSelectionChange($event)\"\n        [selection]=\"selectedColumnsIds\"\n        (filterChange)=\"handleFilterChange($event)\"\n    >\n        <ng-container ngProjectAs=\"hive-selection-menu-item\">\n            @for (column of filteredColumns; track column.id) {\n                @if (column.cols.length) {\n                    <hive-selection-menu-group-item\n                        [value]=\"column.id\"\n                        [label]=\"column.utilityText\"\n                        [disabled]=\"\n                            column.visibilityMode === 'column-toggle-disabled'\n                        \"\n                    >\n                        @for (col of column.cols; track col.id) {\n                            <hive-selection-menu-item\n                                [value]=\"col.id\"\n                                [label]=\"col.utilityText\"\n                                [disabled]=\"\n                                    col.visibilityMode ===\n                                    'column-toggle-disabled'\n                                \"\n                            ></hive-selection-menu-item>\n                        }\n                    </hive-selection-menu-group-item>\n                } @else {\n                    <hive-selection-menu-item\n                        [value]=\"column.id\"\n                        [label]=\"column.utilityText\"\n                        [disabled]=\"\n                            column.visibilityMode === 'column-toggle-disabled'\n                        \"\n                    ></hive-selection-menu-item>\n                }\n            }\n        </ng-container>\n    </hive-selection-menu>\n</hive-menu>\n" }]
        }], ctorParameters: () => [{ type: TableComponent, decorators: [{
                    type: Optional
                }] }, { type: Storage, decorators: [{
                    type: Inject,
                    args: [COLUMN_TOGGLE_PERSISTENCE_STORE]
                }] }, { type: i0.ChangeDetectorRef }], propDecorators: { persistStateId: [{
                type: Input
            }], table: [{
                type: Input
            }], columnsChange: [{
                type: Output
            }] } });

class FrozenCellDirective {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FrozenCellDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: FrozenCellDirective, selector: "td[hiveFrozenColumn]", hostDirectives: [{ directive: FrozenColumnDirective, inputs: ["alignFrozen", "alignFrozen", "hiveFrozenColumn", "hiveFrozenColumn"] }], ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FrozenCellDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'td[hiveFrozenColumn]',
                    hostDirectives: [
                        {
                            directive: FrozenColumnDirective,
                            inputs: ['alignFrozen', 'hiveFrozenColumn'],
                        },
                    ],
                }]
        }] });

/**
 * To make a column frozen, add the `[hiveFrozenColumn]` directive to the corresponding `<th>` and `<td>` tags of the column.
 *
 * Toggling `hiveFrozenColumn` property toggles column freezing.
 */
class FrozenHeaderColumnDirective {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FrozenHeaderColumnDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: FrozenHeaderColumnDirective, selector: "th[hiveFrozenColumn]", hostDirectives: [{ directive: FrozenColumnDirective, inputs: ["alignFrozen", "alignFrozen", "hiveFrozenColumn", "hiveFrozenColumn"] }], ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FrozenHeaderColumnDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'th[hiveFrozenColumn]',
                    hostDirectives: [
                        {
                            directive: FrozenColumnDirective,
                            inputs: ['alignFrozen', 'hiveFrozenColumn'],
                        },
                    ],
                }]
        }] });

class HeaderPositioningContainerComponent {
    constructor() {
        /**
         * The horizontal alignment of the content inside the header.
         * @default left
         */
        this.containerHorizontalAlignment = 'left';
        /**
         * The vertical alignment of the content inside the header.
         * @default top
         */
        this.containerVerticalAlignment = 'top';
    }
    get leftHorizontal() {
        return this.containerHorizontalAlignment === 'left';
    }
    get centerHorizontal() {
        return this.containerHorizontalAlignment === 'center';
    }
    get rightHorizontal() {
        return this.containerHorizontalAlignment === 'right';
    }
    get topVertical() {
        return this.containerVerticalAlignment === 'top';
    }
    get centerVertical() {
        return this.containerVerticalAlignment === 'center';
    }
    get bottomVertical() {
        return this.containerVerticalAlignment === 'bottom';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: HeaderPositioningContainerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: HeaderPositioningContainerComponent, selector: "hive-header-positioning-container", inputs: { containerHorizontalAlignment: "containerHorizontalAlignment", containerVerticalAlignment: "containerVerticalAlignment" }, host: { properties: { "class.hive-header-positioning-container-horizontal--left": "this.leftHorizontal", "class.hive-header-positioning-container-horizontal--center": "this.centerHorizontal", "class.hive-header-positioning-container-horizontal--right": "this.rightHorizontal", "class.hive-header-positioning-container-vertical--top": "this.topVertical", "class.hive-header-positioning-container-vertical--center": "this.centerVertical", "class.hive-header-positioning-container-vertical--bottom": "this.bottomVertical" } }, hostDirectives: [{ directive: HiveThemedDirective }], ngImport: i0, template: `
        <div class="hive-header-positioning-container_content">
            <ng-content></ng-content>
        </div>
    `, isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: HeaderPositioningContainerComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'hive-header-positioning-container',
                    template: `
        <div class="hive-header-positioning-container_content">
            <ng-content></ng-content>
        </div>
    `,
                    hostDirectives: [HiveThemedDirective],
                }]
        }], propDecorators: { containerHorizontalAlignment: [{
                type: Input
            }], containerVerticalAlignment: [{
                type: Input
            }], leftHorizontal: [{
                type: HostBinding,
                args: ['class.hive-header-positioning-container-horizontal--left']
            }], centerHorizontal: [{
                type: HostBinding,
                args: ['class.hive-header-positioning-container-horizontal--center']
            }], rightHorizontal: [{
                type: HostBinding,
                args: ['class.hive-header-positioning-container-horizontal--right']
            }], topVertical: [{
                type: HostBinding,
                args: ['class.hive-header-positioning-container-vertical--top']
            }], centerVertical: [{
                type: HostBinding,
                args: ['class.hive-header-positioning-container-vertical--center']
            }], bottomVertical: [{
                type: HostBinding,
                args: ['class.hive-header-positioning-container-vertical--bottom']
            }] } });

/**
 * @internal
 */
class SortIconComponent {
    constructor() {
        this.sortState = null;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SortIconComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.3.12", type: SortIconComponent, selector: "hive-sort-icon", inputs: { sortState: "sortState" }, hostDirectives: [{ directive: HiveThemedDirective }], ngImport: i0, template: `
        <div class="hive-sort-icon_container">
            @switch (sortState) {
                @case ('hover-asc') {
                    <svg
                        [height]="12"
                        [width]="12"
                        class="hive-sort-icon hive-sort-icon--hover hive-sort-icon--up"
                        hive-svg="light/arrow-up-wide-short.svg"
                    ></svg>
                }
                @case ('hover-desc') {
                    <svg
                        [height]="12"
                        [width]="12"
                        class="hive-sort-icon hive-sort-icon--hover hive-sort-icon--down"
                        hive-svg="light/arrow-down-wide-short.svg"
                    ></svg>
                }
                @case ('asc') {
                    <svg
                        [height]="12"
                        [width]="12"
                        class="hive-sort-icon hive-sort-icon--up"
                        hive-svg="light/arrow-up-wide-short.svg"
                    ></svg>
                }
                @case ('desc') {
                    <svg
                        [height]="12"
                        [width]="12"
                        class="hive-sort-icon hive-sort-icon--down"
                        hive-svg="light/arrow-down-wide-short.svg"
                    ></svg>
                }
            }
        </div>
    `, isInline: true, dependencies: [{ kind: "directive", type: SvgDirective, selector: "svg[hive-svg]", inputs: ["hive-svg", "width", "height"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SortIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'hive-sort-icon',
                    template: `
        <div class="hive-sort-icon_container">
            @switch (sortState) {
                @case ('hover-asc') {
                    <svg
                        [height]="12"
                        [width]="12"
                        class="hive-sort-icon hive-sort-icon--hover hive-sort-icon--up"
                        hive-svg="light/arrow-up-wide-short.svg"
                    ></svg>
                }
                @case ('hover-desc') {
                    <svg
                        [height]="12"
                        [width]="12"
                        class="hive-sort-icon hive-sort-icon--hover hive-sort-icon--down"
                        hive-svg="light/arrow-down-wide-short.svg"
                    ></svg>
                }
                @case ('asc') {
                    <svg
                        [height]="12"
                        [width]="12"
                        class="hive-sort-icon hive-sort-icon--up"
                        hive-svg="light/arrow-up-wide-short.svg"
                    ></svg>
                }
                @case ('desc') {
                    <svg
                        [height]="12"
                        [width]="12"
                        class="hive-sort-icon hive-sort-icon--down"
                        hive-svg="light/arrow-down-wide-short.svg"
                    ></svg>
                }
            }
        </div>
    `,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    hostDirectives: [HiveThemedDirective],
                }]
        }], propDecorators: { sortState: [{
                type: Input
            }] } });

class SortIconPipe {
    transform(sortState, hover, defaultSortState) {
        if (hover && sortState === null && defaultSortState === 'asc') {
            return 'hover-asc';
        }
        else if (hover && sortState === null && defaultSortState === 'desc') {
            return 'hover-desc';
        }
        else {
            return sortState;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SortIconPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: SortIconPipe, isStandalone: true, name: "sortIcon" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SortIconPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'sortIcon',
                    standalone: true,
                    pure: true,
                }]
        }] });

/**
 * Use for custom sorting scenarios. Adds sort icon and handles sorting state
 */
class HeaderSortWrapperComponent {
    constructor() {
        this.sortOrder = null;
        this.sortIconPosition = 'right';
        this.defaultSortOrder = 'asc';
        this.hover = false;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: HeaderSortWrapperComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.3.12", type: HeaderSortWrapperComponent, selector: "hive-header-sort-wrapper", inputs: { sortKey: "sortKey", sortOrder: "sortOrder", sortIconPosition: "sortIconPosition", defaultSortOrder: "defaultSortOrder", containerHorizontalAlignment: "containerHorizontalAlignment", hover: "hover" }, hostDirectives: [{ directive: HiveThemedDirective }], ngImport: i0, template: `
        <div
            class="hive-header-sort-wrapper_container"
            [class.hive-header-sort-wrapper_horizontal--left]="
                containerHorizontalAlignment === 'left'
            "
            [class.hive-header-sort-wrapper_horizontal--center]="
                containerHorizontalAlignment === 'center'
            "
            [class.hive-header-sort-wrapper_horizontal--right]="
                containerHorizontalAlignment === 'right'
            "
        >
            @if ((sortKey | isDefined) && sortIconPosition === 'left') {
                <div
                    data-testid="hive-sort-icon"
                    class="hive-header-sort-wrapper_sort-icon hive-header-sort-wrapper_sort-icon--left"
                >
                    <hive-sort-icon
                        [sortState]="
                            sortOrder | sortIcon: hover : defaultSortOrder
                        "
                    ></hive-sort-icon>
                </div>
            }

            <div class="hive-header-sort-wrapper_content">
                <ng-content></ng-content>
            </div>

            @if ((sortKey | isDefined) && sortIconPosition === 'right') {
                <div
                    data-testid="hive-sort-icon"
                    class="hive-header-sort-wrapper_sort-icon hive-header-sort-wrapper_sort-icon--right"
                >
                    <hive-sort-icon
                        [sortState]="
                            sortOrder | sortIcon: hover : defaultSortOrder
                        "
                    ></hive-sort-icon>
                </div>
            }
        </div>

        <ng-template #sortIcon>
            <div
                data-testid="hive-sort-icon"
                class="hive-header-sort-wrapper_sort-icon"
                [class.hive-header-sort-wrapper_sort-icon--left]="
                    sortIconPosition === 'left'
                "
                [class.hive-header-sort-wrapper_sort-icon--right]="
                    sortIconPosition === 'right'
                "
            >
                <hive-sort-icon
                    [sortState]="sortOrder | sortIcon: hover : defaultSortOrder"
                ></hive-sort-icon>
            </div>
        </ng-template>
    `, isInline: true, dependencies: [{ kind: "component", type: SortIconComponent, selector: "hive-sort-icon", inputs: ["sortState"] }, { kind: "pipe", type: IsDefinedPipe, name: "isDefined" }, { kind: "pipe", type: SortIconPipe, name: "sortIcon" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: HeaderSortWrapperComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'hive-header-sort-wrapper',
                    template: `
        <div
            class="hive-header-sort-wrapper_container"
            [class.hive-header-sort-wrapper_horizontal--left]="
                containerHorizontalAlignment === 'left'
            "
            [class.hive-header-sort-wrapper_horizontal--center]="
                containerHorizontalAlignment === 'center'
            "
            [class.hive-header-sort-wrapper_horizontal--right]="
                containerHorizontalAlignment === 'right'
            "
        >
            @if ((sortKey | isDefined) && sortIconPosition === 'left') {
                <div
                    data-testid="hive-sort-icon"
                    class="hive-header-sort-wrapper_sort-icon hive-header-sort-wrapper_sort-icon--left"
                >
                    <hive-sort-icon
                        [sortState]="
                            sortOrder | sortIcon: hover : defaultSortOrder
                        "
                    ></hive-sort-icon>
                </div>
            }

            <div class="hive-header-sort-wrapper_content">
                <ng-content></ng-content>
            </div>

            @if ((sortKey | isDefined) && sortIconPosition === 'right') {
                <div
                    data-testid="hive-sort-icon"
                    class="hive-header-sort-wrapper_sort-icon hive-header-sort-wrapper_sort-icon--right"
                >
                    <hive-sort-icon
                        [sortState]="
                            sortOrder | sortIcon: hover : defaultSortOrder
                        "
                    ></hive-sort-icon>
                </div>
            }
        </div>

        <ng-template #sortIcon>
            <div
                data-testid="hive-sort-icon"
                class="hive-header-sort-wrapper_sort-icon"
                [class.hive-header-sort-wrapper_sort-icon--left]="
                    sortIconPosition === 'left'
                "
                [class.hive-header-sort-wrapper_sort-icon--right]="
                    sortIconPosition === 'right'
                "
            >
                <hive-sort-icon
                    [sortState]="sortOrder | sortIcon: hover : defaultSortOrder"
                ></hive-sort-icon>
            </div>
        </ng-template>
    `,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    hostDirectives: [HiveThemedDirective],
                }]
        }], propDecorators: { sortKey: [{
                type: Input
            }], sortOrder: [{
                type: Input
            }], sortIconPosition: [{
                type: Input
            }], defaultSortOrder: [{
                type: Input
            }], containerHorizontalAlignment: [{
                type: Input
            }], hover: [{
                type: Input
            }] } });

/**
 * Provides filtering and sorting support. Specify content with input properties.
 */
class HeaderComponent {
    constructor(tableHeading, tableService, table, element) {
        this.tableHeading = tableHeading;
        this.tableService = tableService;
        this.table = table;
        this.element = element;
        /**
         * The horizontal alignment of the content inside the header.
         * @default left
         */
        this.containerHorizontalAlignment = 'left';
        /**
         * The vertical alignment of the content inside the header.
         * @default top
         */
        this.containerVerticalAlignment = 'top';
        /**
         * Use to define icon for {@see helpInfoMessage} tooltip.
         *
         * @default info
         */
        this.helpInfoIcon = 'info';
        /**
         * Length is defined in `milliseconds`.
         *
         * Effective only when `emitFiltersOn` in `TableComponent` is set to `change`.
         *
         * @see `TableComponent.emitFiltersOn`
         * @see `filterMetadata`
         *
         * @default 300 (from `TableComponent`)
         */
        this.debounceWait = null;
        this.filterQuery$ = this.tableService.filterInput$.pipe(map((filter) => this.filterMetadata
            ? this.handleFilterUpdate(filter, this.filterMetadata)
            : ''));
        this.containerHorizontalAlignment$ = new BehaviorSubject('left');
        this.computedContainerHorizontalAlignment = combineLatest([this.containerHorizontalAlignment$]).pipe(map(([containerHorizontalAlignment]) => {
            if (isDefined(containerHorizontalAlignment)) {
                return containerHorizontalAlignment;
            }
            return 'left';
        }));
        this.sortIconPosition$ = this.computedContainerHorizontalAlignment.pipe(map((containerHorizontalAlignment) => {
            if (containerHorizontalAlignment === 'right') {
                return 'left';
            }
            return 'right';
        }));
        this.sortOrder = null;
        this.hover = false;
        this.isString = isString;
        this.destroyRef$ = inject(DestroyRef);
        this.cdr = inject(ChangeDetectorRef);
        this._defaultSortOrder = 'asc';
        this.directiveHovered$ = merge(fromEvent(this.element.nativeElement, 'mouseover').pipe(map(() => true)), fromEvent(this.element.nativeElement, 'mouseout').pipe(map(() => false))).pipe(debounceTime$1(100), distinctUntilChanged());
    }
    /**
     * Defines the default sort order after the first click on the header.
     *
     * @default null
     */
    set defaultSortOrder(sortOrder) {
        this._defaultSortOrder = sortOrder ?? 'asc';
    }
    get primaryTextType() {
        return this.tableHeading?._parentReference ? 'subheader' : 'header';
    }
    get tabIndex() {
        return this.sortKey ? 0 : -1;
    }
    get isSortable() {
        return isDefined(this.sortKey);
    }
    ngOnInit() {
        merge(this.tableService.sortInput$, this.tableService.sortOutput$)
            .pipe(safeTakeUntilDestroyed(this.destroyRef$))
            .subscribe((sort) => {
            this.sortOrder = this.handleSortChange(sort, this.sortKey);
            this.cdr.markForCheck();
        });
        this.directiveHovered$.subscribe((hovered) => {
            this.hover = !!hovered;
            this.cdr.detectChanges();
        });
    }
    ngOnChanges(changes) {
        if (changes['containerHorizontalAlignment']?.currentValue) {
            this.containerHorizontalAlignment$.next(changes['containerHorizontalAlignment'].currentValue);
        }
    }
    handleBlur(event) {
        if (this.filterMetadata) {
            const value = event.target.value;
            this.emitFilterToService(value, this.filterMetadata, 'blur');
        }
    }
    handleInput(query) {
        if (this.filterMetadata) {
            this.emitFilterToService(query, this.filterMetadata, 'input');
        }
    }
    emitFilterToService(query, filterMetadata, eventType) {
        const filter = {
            entity: filterMetadata.entity,
            key: filterMetadata.key,
            value: query,
        };
        this.tableService.onFilterOutput({ filter, eventType });
    }
    handleFilterUpdate(filter, filterMetadata) {
        return filter?.[filterMetadata.entity]?.[filterMetadata.key] ?? '';
    }
    handleDragResize(event) {
        event.source._dragRef.reset();
        this.tableHeading.handleDragResize(event.distance.x);
        this.table.sizeUpdate$.next();
    }
    handleClick() {
        if (!this.sortKey)
            return;
        const order = this.sortOrder === null
            ? this._defaultSortOrder
            : this.sortOrder === 'desc'
                ? 'asc'
                : 'desc';
        this.tableService.onSortOutput({
            key: this.sortKey,
            order,
        });
    }
    handleSortChange(sort, sortKey) {
        return sort && sortKey === sort.key ? sort.order : null;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: HeaderComponent, deps: [{ token: TableHeadingDirective }, { token: TableService }, { token: TableComponent }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.3.12", type: HeaderComponent, selector: "th[hive-header]", inputs: { primaryText: "primaryText", containerHorizontalAlignment: "containerHorizontalAlignment", containerVerticalAlignment: "containerVerticalAlignment", helpInfoMessage: "helpInfoMessage", helpInfoIcon: "helpInfoIcon", sortKey: "sortKey", filterMetadata: "filterMetadata", debounceWait: "debounceWait", defaultSortOrder: "defaultSortOrder" }, host: { listeners: { "click": "handleClick()", "keydown.enter": "handleClick()" }, properties: { "attr.tabindex": "this.tabIndex", "class.hive-header--sortable": "this.isSortable" } }, usesOnChanges: true, hostDirectives: [{ directive: HiveThemedDirective }, { directive: TableHeadingDirective, inputs: ["visibilityMode", "visibilityMode", "primaryText", "primaryText", "columnToggleName", "columnToggleName", "headers", "headers", "id", "id", "colWeight", "colWeight", "colWidth", "colWidth", "resizable", "resizable"] }], ngImport: i0, template: "<div class=\"hive-header-wrapper\">\n    <hive-header-positioning-container\n        [class.hive-header_positioning-container--resizable]=\"\n            tableHeading.resizable\n        \"\n        [containerHorizontalAlignment]=\"\n            computedContainerHorizontalAlignment | async\n        \"\n        [containerVerticalAlignment]=\"containerVerticalAlignment\"\n    >\n        <div\n            class=\"hive-header_container\"\n            [class.hive-header_container--subheader]=\"\n                tableHeading._parentReference\n            \"\n        >\n            <hive-header-sort-wrapper\n                [sortKey]=\"sortKey\"\n                [sortOrder]=\"sortOrder\"\n                [defaultSortOrder]=\"_defaultSortOrder\"\n                [sortIconPosition]=\"sortIconPosition$ | async\"\n                [containerHorizontalAlignment]=\"\n                    computedContainerHorizontalAlignment | async\n                \"\n                [hover]=\"hover\"\n            >\n                <hive-primary-text\n                    [type]=\"primaryTextType\"\n                    [primaryText]=\"primaryText\"\n                ></hive-primary-text>\n\n                @if (helpInfoMessage) {\n                    <hive-info-icon\n                        class=\"table-header-info-icon\"\n                        [helpInfoIcon]=\"helpInfoIcon\"\n                        hiveTooltip\n                        [hiveTooltipDescription]=\"\n                            isString(helpInfoMessage) ? helpInfoMessage : null\n                        \"\n                        [hiveTooltipCustomContentTemplateRef]=\"\n                            !isString(helpInfoMessage) ? helpInfoMessage : null\n                        \"\n                    ></hive-info-icon>\n                }\n            </hive-header-sort-wrapper>\n\n            <div\n                class=\"hive-header_secondary-text-container\"\n                [ngClass]=\"[\n                    'hive-header_secondary-text-container--horizontal-alignment-' +\n                        containerHorizontalAlignment,\n                ]\"\n            >\n                <ng-content select=\"hive-table-secondary-text\"></ng-content>\n            </div>\n\n            @if (filterMetadata) {\n                <div\n                    class=\"hive-header_input-container\"\n                    (click)=\"$event.stopPropagation()\"\n                    (keydown.enter)=\"$event.stopPropagation()\"\n                >\n                    <hive-text-field\n                        class=\"hive-header_input\"\n                        size=\"small\"\n                        [showClear]=\"true\"\n                        [ngModel]=\"filterQuery$ | async\"\n                        [debounceWait]=\"\n                            debounceWait ??\n                            (tableService.filterDebounceWait$ | async)\n                        \"\n                        (debounceChange)=\"handleInput($event)\"\n                        (blur)=\"handleBlur($event)\"\n                    >\n                    </hive-text-field>\n                </div>\n            }\n        </div>\n    </hive-header-positioning-container>\n\n    @if (tableHeading.resizable) {\n        <div\n            role=\"separator\"\n            class=\"hive-header-resize-handle-container\"\n            [class.hive-header-resize-handle-container--header-last-visible-in-table]=\"\n                tableHeading._lastVisibleInTable$ | async\n            \"\n            (click)=\"$event.stopPropagation()\"\n            (cdkDragEnded)=\"handleDragResize($event)\"\n            cdkDrag\n            cdkDragLockAxis=\"x\"\n        >\n            <div\n                class=\"hive-header-resize-handle_separator\"\n                [style.height.px]=\"table.tableHeight$ | async\"\n            ></div>\n        </div>\n    }\n</div>\n", dependencies: [{ kind: "directive", type: i5.CdkDrag, selector: "[cdkDrag]", inputs: ["cdkDragData", "cdkDragLockAxis", "cdkDragRootElement", "cdkDragBoundary", "cdkDragStartDelay", "cdkDragFreeDragPosition", "cdkDragDisabled", "cdkDragConstrainPosition", "cdkDragPreviewClass", "cdkDragPreviewContainer"], outputs: ["cdkDragStarted", "cdkDragReleased", "cdkDragEnded", "cdkDragEntered", "cdkDragExited", "cdkDragDropped", "cdkDragMoved"], exportAs: ["cdkDrag"] }, { kind: "directive", type: i1$3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$3.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "directive", type: DebounceChangeDirective, selector: "[debounceChange][ngModel]", inputs: ["debounceWait"], outputs: ["debounceChange"] }, { kind: "component", type: InfoIconComponent, selector: "hive-info-icon", inputs: ["helpInfoIcon"] }, { kind: "component", type: TextFieldComponent, selector: "hive-text-field", inputs: ["label", "size", "helpInfoMessage", "helpInfoIcon", "placeholder", "readonly", "errorMessages", "assistanceText", "name", "leftIcon", "disabled", "showClear", "required", "min", "max", "maxLength", "step", "type", "filled", "value"], outputs: ["blur", "input"] }, { kind: "directive", type: TooltipDirective, selector: "[hiveTooltip]", inputs: ["hiveTooltipHeading", "hiveTooltipDescription", "hiveTooltipCustomContentTemplateRef", "hiveTooltipCustomContentContext", "disableTooltip", "hiveTooltipPosition", "hideDelay", "showDelay", "windowClass"], outputs: ["tooltipWindowHovered"] }, { kind: "directive", type: i2$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "component", type: HeaderPositioningContainerComponent, selector: "hive-header-positioning-container", inputs: ["containerHorizontalAlignment", "containerVerticalAlignment"] }, { kind: "component", type: HeaderSortWrapperComponent, selector: "hive-header-sort-wrapper", inputs: ["sortKey", "sortOrder", "sortIconPosition", "defaultSortOrder", "containerHorizontalAlignment", "hover"] }, { kind: "component", type: PrimaryTextComponent, selector: "hive-primary-text", inputs: ["primaryText", "textOverflow", "type", "disabled"] }, { kind: "pipe", type: i2$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: HeaderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'th[hive-header]', changeDetection: ChangeDetectionStrategy.OnPush, hostDirectives: [
                        HiveThemedDirective,
                        {
                            directive: TableHeadingDirective,
                            inputs: [
                                'visibilityMode',
                                'primaryText',
                                'columnToggleName',
                                'headers',
                                'id',
                                'colWeight',
                                'colWidth',
                                'resizable',
                            ],
                        },
                    ], template: "<div class=\"hive-header-wrapper\">\n    <hive-header-positioning-container\n        [class.hive-header_positioning-container--resizable]=\"\n            tableHeading.resizable\n        \"\n        [containerHorizontalAlignment]=\"\n            computedContainerHorizontalAlignment | async\n        \"\n        [containerVerticalAlignment]=\"containerVerticalAlignment\"\n    >\n        <div\n            class=\"hive-header_container\"\n            [class.hive-header_container--subheader]=\"\n                tableHeading._parentReference\n            \"\n        >\n            <hive-header-sort-wrapper\n                [sortKey]=\"sortKey\"\n                [sortOrder]=\"sortOrder\"\n                [defaultSortOrder]=\"_defaultSortOrder\"\n                [sortIconPosition]=\"sortIconPosition$ | async\"\n                [containerHorizontalAlignment]=\"\n                    computedContainerHorizontalAlignment | async\n                \"\n                [hover]=\"hover\"\n            >\n                <hive-primary-text\n                    [type]=\"primaryTextType\"\n                    [primaryText]=\"primaryText\"\n                ></hive-primary-text>\n\n                @if (helpInfoMessage) {\n                    <hive-info-icon\n                        class=\"table-header-info-icon\"\n                        [helpInfoIcon]=\"helpInfoIcon\"\n                        hiveTooltip\n                        [hiveTooltipDescription]=\"\n                            isString(helpInfoMessage) ? helpInfoMessage : null\n                        \"\n                        [hiveTooltipCustomContentTemplateRef]=\"\n                            !isString(helpInfoMessage) ? helpInfoMessage : null\n                        \"\n                    ></hive-info-icon>\n                }\n            </hive-header-sort-wrapper>\n\n            <div\n                class=\"hive-header_secondary-text-container\"\n                [ngClass]=\"[\n                    'hive-header_secondary-text-container--horizontal-alignment-' +\n                        containerHorizontalAlignment,\n                ]\"\n            >\n                <ng-content select=\"hive-table-secondary-text\"></ng-content>\n            </div>\n\n            @if (filterMetadata) {\n                <div\n                    class=\"hive-header_input-container\"\n                    (click)=\"$event.stopPropagation()\"\n                    (keydown.enter)=\"$event.stopPropagation()\"\n                >\n                    <hive-text-field\n                        class=\"hive-header_input\"\n                        size=\"small\"\n                        [showClear]=\"true\"\n                        [ngModel]=\"filterQuery$ | async\"\n                        [debounceWait]=\"\n                            debounceWait ??\n                            (tableService.filterDebounceWait$ | async)\n                        \"\n                        (debounceChange)=\"handleInput($event)\"\n                        (blur)=\"handleBlur($event)\"\n                    >\n                    </hive-text-field>\n                </div>\n            }\n        </div>\n    </hive-header-positioning-container>\n\n    @if (tableHeading.resizable) {\n        <div\n            role=\"separator\"\n            class=\"hive-header-resize-handle-container\"\n            [class.hive-header-resize-handle-container--header-last-visible-in-table]=\"\n                tableHeading._lastVisibleInTable$ | async\n            \"\n            (click)=\"$event.stopPropagation()\"\n            (cdkDragEnded)=\"handleDragResize($event)\"\n            cdkDrag\n            cdkDragLockAxis=\"x\"\n        >\n            <div\n                class=\"hive-header-resize-handle_separator\"\n                [style.height.px]=\"table.tableHeight$ | async\"\n            ></div>\n        </div>\n    }\n</div>\n" }]
        }], ctorParameters: () => [{ type: TableHeadingDirective }, { type: TableService }, { type: TableComponent }, { type: i0.ElementRef }], propDecorators: { primaryText: [{
                type: Input
            }], containerHorizontalAlignment: [{
                type: Input
            }], containerVerticalAlignment: [{
                type: Input
            }], helpInfoMessage: [{
                type: Input
            }], helpInfoIcon: [{
                type: Input
            }], sortKey: [{
                type: Input
            }], filterMetadata: [{
                type: Input
            }], debounceWait: [{
                type: Input
            }], defaultSortOrder: [{
                type: Input
            }], tabIndex: [{
                type: HostBinding,
                args: ['attr.tabindex']
            }], isSortable: [{
                type: HostBinding,
                args: ['class.hive-header--sortable']
            }], handleClick: [{
                type: HostListener,
                args: ['click']
            }, {
                type: HostListener,
                args: ['keydown.enter']
            }] } });

class SquareHeaderComponent {
    constructor(tableHeadingDirective) {
        this.tableHeadingDirective = tableHeadingDirective;
        // by mockups, checkbox columns should take width of 42px
        this.tableHeadingDirective.colWidth = '42px';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SquareHeaderComponent, deps: [{ token: TableHeadingDirective }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: SquareHeaderComponent, selector: "th[hive-square-header]", hostDirectives: [{ directive: HiveThemedDirective }, { directive: TableHeadingDirective, inputs: ["visibilityMode", "visibilityMode", "columnToggleName", "columnToggleName", "id", "id"] }], ngImport: i0, template: `
        <div class="hive-header-wrapper hive-square-header_wrapper">
            <ng-content></ng-content>
        </div>
    `, isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SquareHeaderComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'th[hive-square-header]',
                    template: `
        <div class="hive-header-wrapper hive-square-header_wrapper">
            <ng-content></ng-content>
        </div>
    `,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    hostDirectives: [
                        HiveThemedDirective,
                        {
                            directive: TableHeadingDirective,
                            inputs: ['visibilityMode', 'columnToggleName', 'id'],
                        },
                    ],
                }]
        }], ctorParameters: () => [{ type: TableHeadingDirective }] });

/**
 * A component to render table header cell with custom content inside.
 *
 * @example basic usage:
 *     <th hive-template-header>
 *         <h5>SOME CONTENT</h5>
 *     </th>
 *
 * @example for a table with column customizer:
 *    <th hive-template-header columnToggleName="Column customizer name">
 *        <h5>SOME CONTENT</h5>
 *    </th>
 */
class TemplateHeaderComponent {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TemplateHeaderComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: TemplateHeaderComponent, selector: "th[hive-template-header]", hostDirectives: [{ directive: HiveThemedDirective }, { directive: TableHeadingDirective, inputs: ["visibilityMode", "visibilityMode", "primaryText", "primaryText", "columnToggleName", "columnToggleName", "headers", "headers", "id", "id", "colWeight", "colWeight", "colWidth", "colWidth", "resizable", "resizable"] }], ngImport: i0, template: `
        <div class="hive-header-wrapper">
            <ng-content></ng-content>
        </div>
    `, isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TemplateHeaderComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'th[hive-template-header]',
                    template: `
        <div class="hive-header-wrapper">
            <ng-content></ng-content>
        </div>
    `,
                    hostDirectives: [
                        HiveThemedDirective,
                        {
                            directive: TableHeadingDirective,
                            inputs: [
                                'visibilityMode',
                                'primaryText',
                                'columnToggleName',
                                'headers',
                                'id',
                                'colWeight',
                                'colWidth',
                                'resizable',
                            ],
                        },
                    ],
                }]
        }] });

/**
 * Represents a component for the table row checkbox.
 *
 * This component is responsible for the checkbox that is associated with each row in the table.
 */
class TableCheckboxComponent {
    constructor(row) {
        this.row = row;
    }
    /**
     * Toggles the selection state of the current row.
     * This is called when the checkbox associated with the row is clicked.
     *
     * @returns - The updated selection state of the row.
     * @internal
     */
    toggle() {
        return this.row.toggleRow('checkbox');
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TableCheckboxComponent, deps: [{ token: forwardRef(() => TableRowDirective) }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: TableCheckboxComponent, selector: "hive-table-checkbox", hostDirectives: [{ directive: HiveThemedDirective }], ngImport: i0, template: ` <hive-checkbox
        [checked]="row.isSelected$ | async"
        [disabled]="row.isDisabled$ | async"
        (checkedChange)="toggle()"
        (click)="$event.stopPropagation()"
        (keydown.space)="$event.stopPropagation()"
    ></hive-checkbox>`, isInline: true, dependencies: [{ kind: "component", type: CheckboxComponent, selector: "hive-checkbox", inputs: ["size", "disabled", "id", "checked", "required", "indeterminate", "tabIndex"], outputs: ["checkedChange", "indeterminateChange"] }, { kind: "pipe", type: i2$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TableCheckboxComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'hive-table-checkbox',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: ` <hive-checkbox
        [checked]="row.isSelected$ | async"
        [disabled]="row.isDisabled$ | async"
        (checkedChange)="toggle()"
        (click)="$event.stopPropagation()"
        (keydown.space)="$event.stopPropagation()"
    ></hive-checkbox>`,
                    hostDirectives: [HiveThemedDirective],
                }]
        }], ctorParameters: () => [{ type: TableRowDirective, decorators: [{
                    type: Inject,
                    args: [forwardRef(() => TableRowDirective)]
                }] }] });

/**
 * Represents a component for the table header checkbox.
 *
 * This component is responsible for the checkbox that is associated with the header of the table.
 */
class TableHeaderCheckboxComponent {
    constructor(selectionManager) {
        this.selectionManager = selectionManager;
        this.hasSelectableRows$ = this.selectionManager.selectableRows$.pipe(map$1((rows) => !isEmpty(rows)));
        this.checked$ = combineLatest([
            this.selectionManager.isAllSelected$,
            this.hasSelectableRows$,
        ]).pipe(map$1(([isAllSelected, hasSelectableRows]) => isAllSelected && hasSelectableRows));
        this.indeterminate$ = combineLatest([
            this.selectionManager.isAnySelected$,
            this.checked$,
        ]).pipe(map$1(([isAnySelected, checked]) => isAnySelected && !checked));
    }
    /**
     * Toggles the selection state of all rows in the table.
     * This is called when the header checkbox is clicked.
     *
     * @returns - The updated selection states of all rows in the table.
     * @internal
     */
    toggleAllRows() {
        return this.selectionManager.toggleAllRows();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TableHeaderCheckboxComponent, deps: [{ token: forwardRef(() => TableSelectionManagerDirective) }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: TableHeaderCheckboxComponent, selector: "hive-table-header-checkbox", hostDirectives: [{ directive: HiveThemedDirective }], ngImport: i0, template: ` <hive-checkbox
        [checked]="checked$ | async"
        [indeterminate]="indeterminate$ | async"
        [disabled]="(hasSelectableRows$ | async) === false"
        (checkedChange)="toggleAllRows()"
        (click)="$event.stopPropagation()"
    ></hive-checkbox>`, isInline: true, dependencies: [{ kind: "component", type: CheckboxComponent, selector: "hive-checkbox", inputs: ["size", "disabled", "id", "checked", "required", "indeterminate", "tabIndex"], outputs: ["checkedChange", "indeterminateChange"] }, { kind: "pipe", type: i2$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TableHeaderCheckboxComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'hive-table-header-checkbox',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: ` <hive-checkbox
        [checked]="checked$ | async"
        [indeterminate]="indeterminate$ | async"
        [disabled]="(hasSelectableRows$ | async) === false"
        (checkedChange)="toggleAllRows()"
        (click)="$event.stopPropagation()"
    ></hive-checkbox>`,
                    hostDirectives: [HiveThemedDirective],
                }]
        }], ctorParameters: () => [{ type: TableSelectionManagerDirective, decorators: [{
                    type: Inject,
                    args: [forwardRef(() => TableSelectionManagerDirective)]
                }] }] });

class HiveBodyTemplateDirective {
    constructor() {
        /**
         * Requires `angularCompilerOptions.strictTemplates` in `tsconfig.json` to be `true`
         *
         * Provide an array of values to the input
         * to help Angular's language server
         * to infer the type of the template context for IDE.
         */
        this.valueType = [];
    }
    // a little bit of magic
    static ngTemplateContextGuard(dir, ctx) {
        return true;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: HiveBodyTemplateDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: HiveBodyTemplateDirective, isStandalone: true, selector: "ng-template[hiveTemplate=\"body\"]", inputs: { valueType: "valueType" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: HiveBodyTemplateDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'ng-template[hiveTemplate="body"]',
                    standalone: true,
                }]
        }], propDecorators: { valueType: [{
                type: Input
            }] } });

/**
 * A component which is used to display secondary text in table
 */
class TableSecondaryTextComponent {
    constructor() {
        /**
         * The text to display in the cell.
         */
        this.label = '';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TableSecondaryTextComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: TableSecondaryTextComponent, selector: "hive-table-secondary-text", inputs: { label: "label" }, ngImport: i0, template: ' <hive-label [label]="label" size="smallest"></hive-label> ', isInline: true, dependencies: [{ kind: "component", type: LabelComponent, selector: "hive-label", inputs: ["label", "for", "size", "weight", "maxWeight", "horizontalAlignment", "leftIconHelpInfoMessage", "rightIconHelpInfoMessage", "leftIcon", "rightIcon", "required", "textOverflowEllipsis"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TableSecondaryTextComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'hive-table-secondary-text',
                    template: ' <hive-label [label]="label" size="smallest"></hive-label> ',
                }]
        }], propDecorators: { label: [{
                type: Input
            }] } });

class TableModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TableModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: TableModule, declarations: [TableComponent,
            CellPositioningContainerDirective,
            CellComponent,
            LinkCellComponent,
            TableSecondaryTextComponent,
            SquareCellComponent,
            TemplateCellComponent,
            HeaderPositioningContainerComponent,
            HeaderComponent,
            SquareHeaderComponent,
            TemplateHeaderComponent,
            SortIconComponent,
            HeaderSortWrapperComponent,
            FrozenHeaderColumnDirective,
            FrozenCellDirective,
            ColumnToggleComponent,
            PrimaryTextComponent,
            TableRowDirective,
            TableCheckboxComponent,
            TableHeaderCheckboxComponent,
            TableSelectionManagerDirective,
            TableHoverManagerDirective], imports: [DragDropModule,
            FormsModule,
            LoadingSpinnerComponent,
            DebounceChangeModule,
            SvgDirective,
            InfoIconComponent,
            EmptyStateComponent,
            IconComponent,
            OverlayComponent,
            CheckboxComponent,
            ButtonComponent,
            TextFieldComponent,
            LinkComponent,
            HiveTemplateDirective,
            HiveBodyTemplateDirective,
            NonNullPipe,
            SeparatorComponent,
            SelectionMenuModule,
            OverlayTriggerDirective,
            IsDefinedPipe,
            FrozenColumnDirective,
            HiveTemplatePipe,
            ToArrayPipe,
            CoerceBooleanPropertyPipe,
            SortIconPipe,
            TableHeadingDirective,
            LabelComponent,
            PaginationComponent,
            TooltipModule,
            IsMultilineTextEmptyPipe,
            NgTemplateOutlet,
            AsyncPipe,
            NgStyle,
            NgClass,
            MenuModule], exports: [TableComponent,
            CellPositioningContainerDirective,
            CellComponent,
            LinkCellComponent,
            TableSecondaryTextComponent,
            SquareCellComponent,
            TemplateCellComponent,
            HeaderPositioningContainerComponent,
            HeaderComponent,
            SquareHeaderComponent,
            TemplateHeaderComponent,
            SortIconComponent,
            HeaderSortWrapperComponent,
            FrozenHeaderColumnDirective,
            FrozenCellDirective,
            ColumnToggleComponent,
            PrimaryTextComponent,
            TableRowDirective,
            TableCheckboxComponent,
            TableHeaderCheckboxComponent,
            TableSelectionManagerDirective,
            TableHoverManagerDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TableModule, imports: [DragDropModule,
            FormsModule,
            LoadingSpinnerComponent,
            DebounceChangeModule,
            EmptyStateComponent,
            IconComponent,
            OverlayComponent,
            CheckboxComponent,
            ButtonComponent,
            TextFieldComponent,
            LinkComponent,
            SelectionMenuModule,
            LabelComponent,
            PaginationComponent,
            TooltipModule,
            MenuModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TableModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        TableComponent,
                        CellPositioningContainerDirective,
                        CellComponent,
                        LinkCellComponent,
                        TableSecondaryTextComponent,
                        SquareCellComponent,
                        TemplateCellComponent,
                        HeaderPositioningContainerComponent,
                        HeaderComponent,
                        SquareHeaderComponent,
                        TemplateHeaderComponent,
                        SortIconComponent,
                        HeaderSortWrapperComponent,
                        FrozenHeaderColumnDirective,
                        FrozenCellDirective,
                        ColumnToggleComponent,
                        PrimaryTextComponent,
                        TableRowDirective,
                        TableCheckboxComponent,
                        TableHeaderCheckboxComponent,
                        TableSelectionManagerDirective,
                        TableHoverManagerDirective,
                    ],
                    exports: [
                        TableComponent,
                        CellPositioningContainerDirective,
                        CellComponent,
                        LinkCellComponent,
                        TableSecondaryTextComponent,
                        SquareCellComponent,
                        TemplateCellComponent,
                        HeaderPositioningContainerComponent,
                        HeaderComponent,
                        SquareHeaderComponent,
                        TemplateHeaderComponent,
                        SortIconComponent,
                        HeaderSortWrapperComponent,
                        FrozenHeaderColumnDirective,
                        FrozenCellDirective,
                        ColumnToggleComponent,
                        PrimaryTextComponent,
                        TableRowDirective,
                        TableCheckboxComponent,
                        TableHeaderCheckboxComponent,
                        TableSelectionManagerDirective,
                        TableHoverManagerDirective,
                    ],
                    imports: [
                        DragDropModule,
                        FormsModule,
                        LoadingSpinnerComponent,
                        DebounceChangeModule,
                        SvgDirective,
                        InfoIconComponent,
                        EmptyStateComponent,
                        IconComponent,
                        OverlayComponent,
                        CheckboxComponent,
                        ButtonComponent,
                        TextFieldComponent,
                        LinkComponent,
                        HiveTemplateDirective,
                        HiveBodyTemplateDirective,
                        NonNullPipe,
                        SeparatorComponent,
                        SelectionMenuModule,
                        OverlayTriggerDirective,
                        IsDefinedPipe,
                        FrozenColumnDirective,
                        HiveTemplatePipe,
                        ToArrayPipe,
                        CoerceBooleanPropertyPipe,
                        SortIconPipe,
                        TableHeadingDirective,
                        LabelComponent,
                        PaginationComponent,
                        TooltipModule,
                        IsMultilineTextEmptyPipe,
                        NgTemplateOutlet,
                        AsyncPipe,
                        NgStyle,
                        NgClass,
                        MenuModule,
                    ],
                }]
        }] });

/**
 * Details panel used to display additional information about the selected item.
 *
 * @category Components
 *
 * @example
 * <div
 *     #targetElement
 *     data-testid="content"
 *     style="
 *         padding: 1rem;
 *         min-height: 20vh;
 *         max-height: 80vh;
 *         height: 100%;
 *         overflow: auto;
 *     "
 * >
 *     <h1>Some page content</h1>
 *     <p>
 *         Some text
 *     </p>
 * </div>
 * <hive-page-draggable-splitter
 *     (resize)="resize($event)"
 *     [targetElement]="targetElement"
 *     data-testid="resize-handle"
 * >
 * </hive-page-draggable-splitter>
 * <hive-details-panel
 *     (close)="close($event)"
 *     [closable]="closable"
 *     [headerInfoMessage]="headerInfoMessage"
 *     [heading]="heading"
 * >
 *     <p>
 *         Details panel content
 *     </p>
 * </hive-details-panel>
 */
class DetailsPanelComponent {
    constructor() {
        /**
         * Event emitted when user press "close" button
         */
        this.close = new EventEmitter();
        this.isString = isString;
    }
    get isClosable() {
        return coerceBooleanProperty(this.closable);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DetailsPanelComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.3.12", type: DetailsPanelComponent, isStandalone: true, selector: "hive-details-panel", inputs: { heading: "heading", headerInfoMessage: "headerInfoMessage", closable: "closable" }, outputs: { close: "close" }, hostDirectives: [{ directive: HiveThemedDirective }], ngImport: i0, template: "@if (heading || closable) {\n    <header class=\"hive-details-panel-header\">\n        <h6 class=\"hive-details-panel-header-title\">\n            {{ heading }}\n            @if (heading && headerInfoMessage) {\n                <hive-info-icon\n                    class=\"hive-details-panel-header-title-info-icon\"\n                    hiveTooltip\n                    [hiveTooltipDescription]=\"\n                        isString(headerInfoMessage) ? headerInfoMessage : null\n                    \"\n                    [hiveTooltipCustomContentTemplateRef]=\"\n                        !isString(headerInfoMessage) ? headerInfoMessage : null\n                    \"\n                ></hive-info-icon>\n            }\n        </h6>\n        @if (isClosable) {\n            <hive-button\n                (click)=\"close.emit($event)\"\n                icon=\"light/xmark.svg\"\n                emphasis=\"tertiary\"\n                class=\"hive-details-panel-header-close-button\"\n                type=\"button\"\n            >\n            </hive-button>\n        }\n    </header>\n}\n\n<main class=\"hive-details-panel-body\">\n    <ng-content></ng-content>\n</main>\n", dependencies: [{ kind: "ngmodule", type: TooltipModule }, { kind: "directive", type: TooltipDirective, selector: "[hiveTooltip]", inputs: ["hiveTooltipHeading", "hiveTooltipDescription", "hiveTooltipCustomContentTemplateRef", "hiveTooltipCustomContentContext", "disableTooltip", "hiveTooltipPosition", "hideDelay", "showDelay", "windowClass"], outputs: ["tooltipWindowHovered"] }, { kind: "component", type: ButtonComponent, selector: "hive-button", inputs: ["type", "menuButtonActive", "hasMenuButtonCaret", "label", "accessibleName", "icon", "iconPosition", "emphasis", "title", "size", "isLoading", "disabled", "rounded", "width"] }, { kind: "component", type: InfoIconComponent, selector: "hive-info-icon", inputs: ["helpInfoIcon"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DetailsPanelComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hive-details-panel', imports: [
                        IconComponent,
                        SvgDirective,
                        TooltipModule,
                        ButtonComponent,
                        InfoIconComponent,
                    ], standalone: true, changeDetection: ChangeDetectionStrategy.OnPush, hostDirectives: [HiveThemedDirective], template: "@if (heading || closable) {\n    <header class=\"hive-details-panel-header\">\n        <h6 class=\"hive-details-panel-header-title\">\n            {{ heading }}\n            @if (heading && headerInfoMessage) {\n                <hive-info-icon\n                    class=\"hive-details-panel-header-title-info-icon\"\n                    hiveTooltip\n                    [hiveTooltipDescription]=\"\n                        isString(headerInfoMessage) ? headerInfoMessage : null\n                    \"\n                    [hiveTooltipCustomContentTemplateRef]=\"\n                        !isString(headerInfoMessage) ? headerInfoMessage : null\n                    \"\n                ></hive-info-icon>\n            }\n        </h6>\n        @if (isClosable) {\n            <hive-button\n                (click)=\"close.emit($event)\"\n                icon=\"light/xmark.svg\"\n                emphasis=\"tertiary\"\n                class=\"hive-details-panel-header-close-button\"\n                type=\"button\"\n            >\n            </hive-button>\n        }\n    </header>\n}\n\n<main class=\"hive-details-panel-body\">\n    <ng-content></ng-content>\n</main>\n" }]
        }], propDecorators: { heading: [{
                type: Input
            }], headerInfoMessage: [{
                type: Input
            }], closable: [{
                type: Input
            }], close: [{
                type: Output
            }] } });

/**
 * Component representing a draggable splitter.
 * This component supports dragging operations along the Y-axis.
 * Allows you to resize previous element using dragging element on top of next element.
 *
 *
 * During usage of this component, it may be necessary to define an initial height of the target element and the draggable element to guarantee they are displayed consistently.
 *
 *
 * @category Components
 *
 * @example
 * <div
 *     #targetElement
 *     data-testid="content"
 *     style="
 *         padding: 1rem;
 *         min-height: 20vh;
 *         max-height: 80vh;
 *         height: 100%;
 *         overflow: auto;
 *         box-sizing: border-box;
 *     "
 * >
 *     <h1>Some page content</h1>
 *     <p>
 *         Some text
 *     </p>
 * </div>
 * <hive-page-draggable-splitter
 *     (resize)="resize($event)"
 *     [targetElement]="targetElement"
 *     data-testid="resize-handle"
 * >
 * </hive-page-draggable-splitter>
 * <hive-details-panel
 *     (close)="close($event)"
 *     [closable]="closable"
 *     [headerInfoMessage]="headerInfoMessage"
 *     [heading]="heading"
 * >
 *     <p>
 *         Details panel content
 *     </p>
 * </hive-details-panel>
 */
class PageDraggableSplitterComponent {
    /**
     * Initializes a new instance of the PageDraggableSplitterComponent class.
     * @param {ElementRef} elementRef The element reference of the component.
     * @param document
     * @param ngZone
     */
    constructor(elementRef, document, ngZone) {
        this.elementRef = elementRef;
        this.document = document;
        this.ngZone = ngZone;
        /**
         * Flag indicating whether the dragging operation is in progress.
         */
        this.isMoving = false;
        /**
         * Subject to trigger unsubscription when the component is destroyed.
         * @private
         */
        this.destroy$ = new Subject();
    }
    /**
     * Called when the component is initialized.
     * Subscribes to the start, move, and end events of the drag operation.
     */
    ngOnInit() {
        this.initHeight = this.targetElement.style.height;
        let heightBeforeMoving = this.elementRef.nativeElement.getBoundingClientRect().height;
        const { dragStart$, dragMove$, dragEnd$ } = this.getEvents();
        dragStart$.pipe(takeUntil(this.destroy$)).subscribe(() => {
            heightBeforeMoving =
                this.targetElement.getBoundingClientRect().height;
            this.isMoving = true;
        });
        dragEnd$.pipe(takeUntil(this.destroy$)).subscribe(() => {
            this.isMoving = false;
        });
        dragMove$.pipe(takeUntil(this.destroy$)).subscribe((event) => {
            this.ngZone.runOutsideAngular(() => {
                this.targetElement.style.height = `${heightBeforeMoving + event.distance.y}px`;
            });
        });
    }
    /**
     * Called when the component is destroyed.
     * Completes the destroy$ subject to trigger unsubscription.
     */
    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
        this.ngZone.runOutsideAngular(() => {
            if (this.targetElement?.style) {
                this.targetElement.style.height = this.initHeight;
            }
        });
    }
    /**
     * Gets the events of the drag operation.
     * @protected
     */
    getEvents() {
        const mouseDown$ = fromEvent(this.elementRef.nativeElement, 'mousedown');
        const mouseMove$ = fromEvent(this.document, 'mousemove');
        const mouseUp$ = fromEvent(this.document, 'mouseup');
        const dragStart$ = mouseDown$;
        const dragEnd$ = mouseUp$;
        const dragMove$ = dragStart$.pipe(switchMap((start) => mouseMove$.pipe(
        // we transform the mouseDown and mouseMove event to get the necessary information
        map$1((moveEvent) => ({
            distance: {
                x: moveEvent.clientX - start.clientX,
                y: moveEvent.clientY - start.clientY,
            },
            dropPoint: {
                x: moveEvent.clientX,
                y: moveEvent.clientY,
            },
        })), takeUntil(dragEnd$))));
        return {
            dragStart$,
            dragMove$,
            dragEnd$,
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PageDraggableSplitterComponent, deps: [{ token: i0.ElementRef }, { token: DOCUMENT }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: PageDraggableSplitterComponent, isStandalone: true, selector: "hive-page-draggable-splitter", inputs: { targetElement: "targetElement" }, host: { properties: { "class.dragging": "this.isMoving" } }, ngImport: i0, template: `
        <hive-icon-component
            icon="light/ellipsis.svg"
            size="medium"
        ></hive-icon-component>
    `, isInline: true, dependencies: [{ kind: "component", type: IconComponent, selector: "hive-icon-component", inputs: ["icon", "size"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
__decorate([
    RequiredInput()
], PageDraggableSplitterComponent.prototype, "targetElement", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PageDraggableSplitterComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'hive-page-draggable-splitter',
                    template: `
        <hive-icon-component
            icon="light/ellipsis.svg"
            size="medium"
        ></hive-icon-component>
    `,
                    standalone: true,
                    imports: [IconComponent],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: Document, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }, { type: i0.NgZone }], propDecorators: { targetElement: [{
                type: Input
            }], isMoving: [{
                type: HostBinding,
                args: ['class.dragging']
            }] } });

/**
 * Progress Bar represents the progress of a task, operation, or process to provide users with a visual indication of how much of a task has been completed, and how much remains.
 */
class ProgressBarComponent {
    constructor() {
        /**
         * The range is from 0 to 100
         */
        this.percent = 0;
        /**
         * @internal
         * Use to define icon for {@see helpInfoMessage} tooltip.
         */
        this.helpInfoIcon = 'info';
        /**
         * The number of decimal places to display
         */
        this.digitsInfo = '1.0-0';
        /**
         * Defines the placement of the percentage
         *
         * @default none
         */
        this.percentagePosition = 'none';
        /**
         * Defines the color of the progress bar
         */
        this.state = 'info';
        /**
         * Marks the progress bar as disabled.
         */
        this.disabled = false;
        this.progressBarUniqueId = uniqueId('hive-progress-bar-');
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ProgressBarComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.3.12", type: ProgressBarComponent, isStandalone: true, selector: "hive-progress-bar", inputs: { percent: ["percent", "percent", numberAttribute], label: ["label", "label", stringOrUndefinedAttribute], helpInfoIcon: "helpInfoIcon", digitsInfo: "digitsInfo", helpInfoMessage: "helpInfoMessage", assistanceText: "assistanceText", percentagePosition: "percentagePosition", state: "state", progressBarTestId: "progressBarTestId", disabled: ["disabled", "disabled", booleanAttribute] }, hostDirectives: [{ directive: HiveThemedDirective }], ngImport: i0, template: "<hive-form-input-base\n    [helpInfoMessage]=\"helpInfoMessage\"\n    [helpInfoIcon]=\"helpInfoIcon\"\n    [label]=\"label\"\n    [for]=\"progressBarUniqueId\"\n    [disabled]=\"disabled\"\n>\n    <div\n        class=\"hive-progress-bar\"\n        [ngClass]=\"'hive-progress-bar--position-' + percentagePosition\"\n    >\n        <meter\n            [id]=\"progressBarUniqueId\"\n            [value]=\"percent\"\n            min=\"0\"\n            max=\"100\"\n            class=\"hive-progress-bar__meter\"\n            [ngClass]=\"'hive-progress-bar__meter--' + state\"\n            [attr.data-testid]=\"progressBarTestId\"\n            [attr.disabled]=\"disabled || null\"\n        >\n            {{ percent }}%\n        </meter>\n        @if (percentagePosition !== 'lower-left' && assistanceText) {\n            <div\n                class=\"hive-progress-bar__assistance-text\"\n                data-testid=\"hive-progress-bar-assistance-text\"\n            >\n                {{ assistanceText }}\n            </div>\n        }\n        @if (percentagePosition !== 'none') {\n            <div\n                class=\"hive-progress-bar__percentage\"\n                data-testid=\"hive-progress-bar-percentage\"\n            >\n                {{ percent | number: digitsInfo }}%\n            </div>\n        }\n    </div>\n</hive-form-input-base>\n", dependencies: [{ kind: "component", type: FormInputBaseComponent, selector: "hive-form-input-base", inputs: ["label", "for", "required", "disabled", "helpInfoIcon", "helpInfoMessage", "errorMessages", "hasError", "assistanceText", "horizontalAlignment", "increasedContentGap"] }, { kind: "directive", type: NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "pipe", type: DecimalPipe, name: "number" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ProgressBarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hive-progress-bar', changeDetection: ChangeDetectionStrategy.OnPush, hostDirectives: [HiveThemedDirective], standalone: true, imports: [SvgDirective, FormInputBaseComponent, NgClass, DecimalPipe], template: "<hive-form-input-base\n    [helpInfoMessage]=\"helpInfoMessage\"\n    [helpInfoIcon]=\"helpInfoIcon\"\n    [label]=\"label\"\n    [for]=\"progressBarUniqueId\"\n    [disabled]=\"disabled\"\n>\n    <div\n        class=\"hive-progress-bar\"\n        [ngClass]=\"'hive-progress-bar--position-' + percentagePosition\"\n    >\n        <meter\n            [id]=\"progressBarUniqueId\"\n            [value]=\"percent\"\n            min=\"0\"\n            max=\"100\"\n            class=\"hive-progress-bar__meter\"\n            [ngClass]=\"'hive-progress-bar__meter--' + state\"\n            [attr.data-testid]=\"progressBarTestId\"\n            [attr.disabled]=\"disabled || null\"\n        >\n            {{ percent }}%\n        </meter>\n        @if (percentagePosition !== 'lower-left' && assistanceText) {\n            <div\n                class=\"hive-progress-bar__assistance-text\"\n                data-testid=\"hive-progress-bar-assistance-text\"\n            >\n                {{ assistanceText }}\n            </div>\n        }\n        @if (percentagePosition !== 'none') {\n            <div\n                class=\"hive-progress-bar__percentage\"\n                data-testid=\"hive-progress-bar-percentage\"\n            >\n                {{ percent | number: digitsInfo }}%\n            </div>\n        }\n    </div>\n</hive-form-input-base>\n" }]
        }], propDecorators: { percent: [{
                type: Input,
                args: [{ transform: numberAttribute }]
            }], label: [{
                type: Input,
                args: [{ transform: stringOrUndefinedAttribute }]
            }], helpInfoIcon: [{
                type: Input
            }], digitsInfo: [{
                type: Input
            }], helpInfoMessage: [{
                type: Input
            }], assistanceText: [{
                type: Input
            }], percentagePosition: [{
                type: Input
            }], state: [{
                type: Input
            }], progressBarTestId: [{
                type: Input
            }], disabled: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }] } });

/**
 * Segment Button Group allows users to select a single (multiple in some cases) option from a group of related options.
 */
class SegmentButtonGroupComponent {
    constructor() {
        /**
         * If true, multiple buttons can be selected at the same time.
         */
        this.multiselect = false;
        /**
         * If true, the button group is disabled.
         */
        this.disabled = false;
        /**
         * @internal
         */
        this._disabled$ = new BehaviorSubject(false);
        this._selectionModel$ = new BehaviorSubject(new SelectionModel(this.multiselect));
        /**
         * Emits the current selection on subscription and whenever the selection changes.
         * @internal
         */
        this.selectionModel$ = merge(this._selectionModel$, this._selectionModel$.pipe(switchMap$1((selectionModel) => selectionModel.changed), map(() => this._selectionModel$.getValue())));
        this.destroyRef$ = inject(DestroyRef);
        // region ControlValueAccessor
        /**
         * @internal
         */
        /* istanbul ignore next */
        this.onModelChange = () => { };
        /**
         * @internal
         */
        /* istanbul ignore next */
        this.onModelTouch = () => { };
    }
    /**
     * @internal
     */
    writeValue(value) {
        if (value) {
            this._selectionModel$
                .getValue()
                .select(...(Array.isArray(value) ? value : [value]));
        }
        else {
            this._selectionModel$.getValue().clear();
        }
    }
    /**
     * @internal
     */
    registerOnChange(fn) {
        this.onModelChange = fn;
    }
    /**
     * @internal
     */
    /* istanbul ignore next */
    registerOnTouched(fn) {
        this.onModelTouch = fn;
    }
    /**
     * @internal
     */
    setDisabledState(isDisabled) {
        this._disabled$.next(isDisabled);
    }
    // endregion
    ngOnChanges({ disabled, multiselect }) {
        if (disabled) {
            this._disabled$.next(disabled.currentValue);
        }
        if (multiselect) {
            const previousSelection = this._selectionModel$.getValue().selected;
            this._selectionModel$.next(new SelectionModel(multiselect.currentValue, previousSelection));
        }
    }
    /**
     * @internal
     */
    handleItemClicked(value) {
        this.selectionModel$
            .pipe(first(), safeTakeUntilDestroyed(this.destroyRef$))
            .subscribe((model) => {
            if (model.isMultipleSelection()) {
                model.toggle(value);
            }
            else {
                model.select(value);
            }
        });
        this.onModelChange(this._selectionModel$.getValue().selected);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SegmentButtonGroupComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "16.1.0", version: "17.3.12", type: SegmentButtonGroupComponent, selector: "hive-segment-button-group", inputs: { multiselect: ["multiselect", "multiselect", booleanAttribute], disabled: ["disabled", "disabled", booleanAttribute] }, providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => SegmentButtonGroupComponent),
                multi: true,
            },
        ], usesOnChanges: true, hostDirectives: [{ directive: HiveThemedDirective }], ngImport: i0, template: "<ng-content select=\"hive-segment-button,a[hive-segment-button]\"></ng-content>\n", changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SegmentButtonGroupComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hive-segment-button-group', hostDirectives: [HiveThemedDirective], changeDetection: ChangeDetectionStrategy.OnPush, providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => SegmentButtonGroupComponent),
                            multi: true,
                        },
                    ], template: "<ng-content select=\"hive-segment-button,a[hive-segment-button]\"></ng-content>\n" }]
        }], propDecorators: { multiselect: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], disabled: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }] } });

class SegmentButtonComponent {
    /**
     * Value of the button.
     */
    set value(value) {
        // since value is required, it doesn't trigger ngOnChanges
        this._value$.next(value);
    }
    constructor(
    /**
     * @internal
     */
    segmentButtonGroupComponent) {
        this.segmentButtonGroupComponent = segmentButtonGroupComponent;
        /**
         * Disables the button.
         */
        this.disabled = false;
        this.hiveSegmentButton = true;
        this._disabled$ = new BehaviorSubject(false);
        this._icon$ = new BehaviorSubject(undefined);
        this._selectedIcon$ = new BehaviorSubject(undefined);
        this._label$ = new BehaviorSubject(undefined);
        this._value$ = new BehaviorSubject(null);
        this.destroyRef$ = inject(DestroyRef);
        /**
         * @internal
         */
        this._isActive$ = combineLatest([
            this.segmentButtonGroupComponent.selectionModel$,
            this._value$,
        ]).pipe(map$1(([selectionModel, value]) => selectionModel.isSelected(value)));
        /**
         * @internal
         */
        this.labelWeight$ = this._isActive$.pipe(map$1((active) => (active ? 'semibold' : 'regular')));
        /**
         * @internal
         */
        this.isDisabled$ = combineLatest([
            this.segmentButtonGroupComponent._disabled$,
            this._disabled$,
        ]).pipe(map$1(([groupDisabled, itemDisabled]) => groupDisabled || itemDisabled));
        /**
         * @internal
         */
        this.showIcon$ = combineLatest([
            this._icon$,
            this._label$,
        ]).pipe(map$1(([showIcon, showLabel]) => !!showIcon && !showLabel));
        /**
         * @internal
         */
        this.icon$ = combineLatest([
            this._icon$,
            this._selectedIcon$,
            this._isActive$,
        ]).pipe(map$1(([icon, selectedIcon, isActive]) => isActive ? (selectedIcon ?? icon) : icon));
    }
    /**
     * @internal
     */
    handleClick() {
        combineLatest([this._disabled$, this._value$])
            .pipe(safeTakeUntilDestroyed(this.destroyRef$), first(), filter(([disabled]) => !disabled))
            .subscribe(([, value]) => {
            this.segmentButtonGroupComponent.handleItemClicked(value);
        });
    }
    ngOnChanges({ icon, selectedIcon, label, disabled }) {
        const keys = [
            [icon, this._icon$],
            [selectedIcon, this._selectedIcon$],
            [label, this._label$],
            [disabled, this._disabled$],
        ];
        for (const [changeSource, changeTarget] of keys) {
            if (changeSource) {
                changeTarget.next(changeSource.currentValue);
            }
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SegmentButtonComponent, deps: [{ token: SegmentButtonGroupComponent }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.3.12", type: SegmentButtonComponent, selector: "hive-segment-button,a[hive-segment-button]", inputs: { icon: "icon", selectedIcon: "selectedIcon", label: "label", value: "value", disabled: ["disabled", "disabled", booleanAttribute] }, host: { listeners: { "click": "handleClick()" }, properties: { "attr.hive-segment-button": "this.hiveSegmentButton" } }, usesOnChanges: true, hostDirectives: [{ directive: HiveThemedDirective }], ngImport: i0, template: "<button\n    [class.hive-segment-button--active]=\"_isActive$ | async\"\n    [class.hive-segment-button--disabled]=\"isDisabled$ | async\"\n    [class.hive-segment-button--icon-only]=\"showIcon$ | async\"\n    [disabled]=\"isDisabled$ | async\"\n    class=\"hive-segment-button\"\n    type=\"button\"\n>\n    @if (label) {\n        <hive-label\n            [label]=\"label\"\n            [weight]=\"labelWeight$ | async\"\n            class=\"hive-segment-button-label\"\n            data-testid=\"segment-button-label\"\n            maxWeight=\"semibold\"\n        />\n    }\n    @if (showIcon$ | async) {\n        <hive-icon-component [icon]=\"icon$ | async\" size=\"medium\" />\n    }\n</button>\n", dependencies: [{ kind: "component", type: LabelComponent, selector: "hive-label", inputs: ["label", "for", "size", "weight", "maxWeight", "horizontalAlignment", "leftIconHelpInfoMessage", "rightIconHelpInfoMessage", "leftIcon", "rightIcon", "required", "textOverflowEllipsis"] }, { kind: "component", type: IconComponent, selector: "hive-icon-component", inputs: ["icon", "size"] }, { kind: "pipe", type: i2$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SegmentButtonComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hive-segment-button,a[hive-segment-button]', changeDetection: ChangeDetectionStrategy.OnPush, hostDirectives: [HiveThemedDirective], template: "<button\n    [class.hive-segment-button--active]=\"_isActive$ | async\"\n    [class.hive-segment-button--disabled]=\"isDisabled$ | async\"\n    [class.hive-segment-button--icon-only]=\"showIcon$ | async\"\n    [disabled]=\"isDisabled$ | async\"\n    class=\"hive-segment-button\"\n    type=\"button\"\n>\n    @if (label) {\n        <hive-label\n            [label]=\"label\"\n            [weight]=\"labelWeight$ | async\"\n            class=\"hive-segment-button-label\"\n            data-testid=\"segment-button-label\"\n            maxWeight=\"semibold\"\n        />\n    }\n    @if (showIcon$ | async) {\n        <hive-icon-component [icon]=\"icon$ | async\" size=\"medium\" />\n    }\n</button>\n" }]
        }], ctorParameters: () => [{ type: SegmentButtonGroupComponent }], propDecorators: { icon: [{
                type: Input
            }], selectedIcon: [{
                type: Input
            }], label: [{
                type: Input
            }], value: [{
                type: Input,
                args: [{ required: true }]
            }], disabled: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], hiveSegmentButton: [{
                type: HostBinding,
                args: ['attr.hive-segment-button']
            }], handleClick: [{
                type: HostListener,
                args: ['click']
            }] } });

class SegmentButtonGroupModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SegmentButtonGroupModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: SegmentButtonGroupModule, declarations: [SegmentButtonGroupComponent, SegmentButtonComponent], imports: [CommonModule,
            FormsModule,
            ReactiveFormsModule,
            LabelComponent,
            IconComponent], exports: [SegmentButtonGroupComponent, SegmentButtonComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SegmentButtonGroupModule, imports: [CommonModule,
            FormsModule,
            ReactiveFormsModule,
            LabelComponent,
            IconComponent] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SegmentButtonGroupModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [SegmentButtonGroupComponent, SegmentButtonComponent],
                    imports: [
                        CommonModule,
                        FormsModule,
                        ReactiveFormsModule,
                        LabelComponent,
                        IconComponent,
                    ],
                    exports: [SegmentButtonGroupComponent, SegmentButtonComponent],
                }]
        }] });

class StepperStepComponent extends CdkStep {
    constructor() {
        super(...arguments);
        /**
         * Set true to allow the step to be always clickable.
         */
        this.isLink = false;
        /**
         * Use to emphasize the warning on the step.
         */
        this.hasWarning = false;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: StepperStepComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "16.1.0", version: "17.3.12", type: StepperStepComponent, selector: "hive-stepper-step", inputs: { description: "description", icon: "icon", isLink: ["isLink", "isLink", booleanAttribute], hasWarning: ["hasWarning", "hasWarning", booleanAttribute] }, providers: [{ provide: CdkStep, useExisting: StepperStepComponent }], usesInheritance: true, ngImport: i0, template: '<ng-template><ng-content></ng-content></ng-template>', isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: StepperStepComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'hive-stepper-step',
                    template: '<ng-template><ng-content></ng-content></ng-template>',
                    providers: [{ provide: CdkStep, useExisting: StepperStepComponent }],
                }]
        }], propDecorators: { description: [{
                type: Input
            }], icon: [{
                type: Input
            }], isLink: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], hasWarning: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }] } });

class StepperShowPredefinedIconsService extends BehaviorSubject {
    constructor() {
        super(false);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: StepperShowPredefinedIconsService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: StepperShowPredefinedIconsService, providedIn: null }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: StepperShowPredefinedIconsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: null,
                }]
        }], ctorParameters: () => [] });

/**
 * @internal
 */
class InternalStepperItemComponent {
    onStepClick() {
        this.stepClick.emit();
    }
    constructor(stepperShowPredefinedIconsService) {
        this.stepperShowPredefinedIconsService = stepperShowPredefinedIconsService;
        this.isActive = false;
        /**
         * Set true to show step always as link
         */
        this.isLink = false;
        this.stepClick = new EventEmitter();
        this.predefinedIcons = {
            current: 'solid/hourglass-half.svg',
            error: 'solid/triangle-exclamation.svg',
            warning: 'solid/exclamation.svg',
            completed: 'solid/check.svg',
            future: '',
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: InternalStepperItemComponent, deps: [{ token: StepperShowPredefinedIconsService, optional: true }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.3.12", type: InternalStepperItemComponent, selector: "hive-internal-stepper-item", inputs: { stepNumber: "stepNumber", label: "label", icon: "icon", description: "description", stepState: "stepState", iconSize: "iconSize", orientation: "orientation", isActive: ["isActive", "isActive", booleanAttribute], isLink: ["isLink", "isLink", booleanAttribute] }, outputs: { stepClick: "stepClick" }, hostDirectives: [{ directive: HiveThemedDirective }], ngImport: i0, template: "<div\n    class=\"hive-internal-stepper-item\"\n    [class.hive-internal-stepper-item--horizontal]=\"\n        orientation === 'horizontal'\n    \"\n    [class.hive-internal-stepper-item--vertical]=\"orientation === 'vertical'\"\n>\n    <span\n        class=\"hive-internal-stepper-item-circle\"\n        [class.hive-internal-stepper-item-circle--completed]=\"\n            stepState === 'completed'\n        \"\n        [class.hive-internal-stepper-item-circle--error]=\"stepState === 'error'\"\n        [class.hive-internal-stepper-item-circle--warning]=\"\n            stepState === 'warning'\n        \"\n        [class.hive-internal-stepper-item-circle--current]=\"\n            stepState === 'current'\n        \"\n        [class.hive-internal-stepper-item-circle--future]=\"\n            stepState === 'future'\n        \"\n    >\n        @if (icon) {\n            <hive-icon-component [icon]=\"icon\" [size]=\"iconSize\" />\n        } @else if (\n            stepState !== 'future' &&\n            (stepperShowPredefinedIconsService | async)\n        ) {\n            <hive-icon-component\n                [icon]=\"predefinedIcons[stepState]\"\n                [size]=\"iconSize\"\n            />\n        } @else {\n            {{ stepNumber + 1 }}\n        }\n    </span>\n    @if (isActive && !isLink) {\n        <hive-label\n            class=\"hive-internal-stepper-item-label\"\n            size=\"small\"\n            weight=\"semibold\"\n            [label]=\"label\"\n        />\n    }\n    @if (!isActive || isLink) {\n        <span class=\"hive-internal-stepper-item-link-container\">\n            <a\n                hive-link\n                class=\"hive-internal-stepper-item-link\"\n                (click)=\"onStepClick()\"\n                (keydown.enter)=\"onStepClick()\"\n            >\n                {{ label }}\n            </a>\n            <hive-icon-component\n                class=\"hive-internal-stepper-item-icon\"\n                size=\"smallest\"\n                icon=\"regular/pen.svg\"\n            ></hive-icon-component>\n        </span>\n    }\n    @if (description | isDefined) {\n        <span class=\"hive-internal-stepper-item-assistive\">\n            {{ description }}\n        </span>\n    }\n    <span\n        class=\"hive-internal-stepper-item-bar\"\n        [class.hive-internal-stepper-item-bar--completed]=\"\n            stepState === 'completed'\n        \"\n    >\n    </span>\n</div>\n", dependencies: [{ kind: "component", type: IconComponent, selector: "hive-icon-component", inputs: ["icon", "size"] }, { kind: "component", type: LabelComponent, selector: "hive-label", inputs: ["label", "for", "size", "weight", "maxWeight", "horizontalAlignment", "leftIconHelpInfoMessage", "rightIconHelpInfoMessage", "leftIcon", "rightIcon", "required", "textOverflowEllipsis"] }, { kind: "component", type: LinkComponent, selector: "a[hive-link]", inputs: ["disabled", "size", "external"] }, { kind: "pipe", type: i2$1.AsyncPipe, name: "async" }, { kind: "pipe", type: IsDefinedPipe, name: "isDefined" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: InternalStepperItemComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hive-internal-stepper-item', changeDetection: ChangeDetectionStrategy.OnPush, hostDirectives: [HiveThemedDirective], template: "<div\n    class=\"hive-internal-stepper-item\"\n    [class.hive-internal-stepper-item--horizontal]=\"\n        orientation === 'horizontal'\n    \"\n    [class.hive-internal-stepper-item--vertical]=\"orientation === 'vertical'\"\n>\n    <span\n        class=\"hive-internal-stepper-item-circle\"\n        [class.hive-internal-stepper-item-circle--completed]=\"\n            stepState === 'completed'\n        \"\n        [class.hive-internal-stepper-item-circle--error]=\"stepState === 'error'\"\n        [class.hive-internal-stepper-item-circle--warning]=\"\n            stepState === 'warning'\n        \"\n        [class.hive-internal-stepper-item-circle--current]=\"\n            stepState === 'current'\n        \"\n        [class.hive-internal-stepper-item-circle--future]=\"\n            stepState === 'future'\n        \"\n    >\n        @if (icon) {\n            <hive-icon-component [icon]=\"icon\" [size]=\"iconSize\" />\n        } @else if (\n            stepState !== 'future' &&\n            (stepperShowPredefinedIconsService | async)\n        ) {\n            <hive-icon-component\n                [icon]=\"predefinedIcons[stepState]\"\n                [size]=\"iconSize\"\n            />\n        } @else {\n            {{ stepNumber + 1 }}\n        }\n    </span>\n    @if (isActive && !isLink) {\n        <hive-label\n            class=\"hive-internal-stepper-item-label\"\n            size=\"small\"\n            weight=\"semibold\"\n            [label]=\"label\"\n        />\n    }\n    @if (!isActive || isLink) {\n        <span class=\"hive-internal-stepper-item-link-container\">\n            <a\n                hive-link\n                class=\"hive-internal-stepper-item-link\"\n                (click)=\"onStepClick()\"\n                (keydown.enter)=\"onStepClick()\"\n            >\n                {{ label }}\n            </a>\n            <hive-icon-component\n                class=\"hive-internal-stepper-item-icon\"\n                size=\"smallest\"\n                icon=\"regular/pen.svg\"\n            ></hive-icon-component>\n        </span>\n    }\n    @if (description | isDefined) {\n        <span class=\"hive-internal-stepper-item-assistive\">\n            {{ description }}\n        </span>\n    }\n    <span\n        class=\"hive-internal-stepper-item-bar\"\n        [class.hive-internal-stepper-item-bar--completed]=\"\n            stepState === 'completed'\n        \"\n    >\n    </span>\n</div>\n" }]
        }], ctorParameters: () => [{ type: StepperShowPredefinedIconsService, decorators: [{
                    type: Optional
                }] }], propDecorators: { stepNumber: [{
                type: Input,
                args: [{ required: true }]
            }], label: [{
                type: Input,
                args: [{ required: true }]
            }], icon: [{
                type: Input
            }], description: [{
                type: Input
            }], stepState: [{
                type: Input,
                args: [{ required: true }]
            }], iconSize: [{
                type: Input,
                args: [{ required: true }]
            }], orientation: [{
                type: Input,
                args: [{ required: true }]
            }], isActive: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], isLink: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], stepClick: [{
                type: Output
            }] } });

/**
 *
 * @param index
 * @param currentStep
 * @param hasError
 * @param hasWarning
 * @param enabledCurrentStepHighlighting
 * @param stepperCompleted
 * @returns StepsStepState
 */
function calculateStepState(index, currentStep, hasError = false, hasWarning = false, enabledCurrentStepHighlighting = true, stepperCompleted = false) {
    switch (true) {
        case index === currentStep &&
            enabledCurrentStepHighlighting &&
            !stepperCompleted:
            return 'current';
        case hasError:
            return 'error';
        case hasWarning:
            return 'warning';
        case index < currentStep || stepperCompleted:
            return 'completed';
        default:
            return 'future';
    }
}
/**
 * Stepper component displays a series of steps or stages in a process or workflow. It's based on CdkStepper from @angular/cdk.
 *
 * ### Content Projection
 *
 *  `<hive-stepper-step>` is a component which is used to define each step. It's based on CdkStep from @angular/cdk.
 *
 * ### Step numeration
 *
 *  Steps are numerated automatically, starting from 1.
 */
class StepperComponent extends CdkStepper {
    constructor() {
        super(...arguments);
        /**
         * Should it appear as wizard or not
         * It is expected to use wizard mode altogether with orientation=vertical
         * It is NOT expected to use wizard mode together with orientation=horizontal
         */
        this.wizardMode = false;
        /**
         * @internal
         */
        this.calculateStepState = calculateStepState;
        this.stepperShowPredefinedIconsService = inject(StepperShowPredefinedIconsService);
        /**
         * Enables highlighting of the current step. Default behaviour is to highlight the current step.
         */
        this.enabledCurrentStepHighlighting = true;
        /**
         * Whether all steps are completed. Error and warning states of steps are still respected.
         */
        this.completed = false;
    }
    /**
     * Set true to show predefined icons for steps.
     */
    set showPredefinedIcons(value) {
        this.stepperShowPredefinedIconsService.next(value);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: StepperComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.3.12", type: StepperComponent, selector: "hive-stepper", inputs: { wizardMode: ["wizardMode", "wizardMode", booleanAttribute], showPredefinedIcons: ["showPredefinedIcons", "showPredefinedIcons", booleanAttribute], enabledCurrentStepHighlighting: ["enabledCurrentStepHighlighting", "enabledCurrentStepHighlighting", booleanAttribute], completed: ["completed", "completed", booleanAttribute] }, providers: [
            { provide: CdkStepper, useExisting: StepperComponent },
            StepperShowPredefinedIconsService,
        ], queries: [{ propertyName: "stepperSteps", predicate: StepperStepComponent }], usesInheritance: true, hostDirectives: [{ directive: HiveThemedDirective }], ngImport: i0, template: "<div\n    class=\"hive-stepper\"\n    [class.hive-stepper--horizontal]=\"orientation === 'horizontal'\"\n    [class.hive-stepper--vertical]=\"orientation === 'vertical'\"\n    [class.hive-grid-container]=\"wizardMode && steps.length\"\n>\n    <ul\n        class=\"hive-stepper-steps\"\n        [class.hive-grid-container-col-2]=\"wizardMode\"\n        [class.hive-grid-container-col-xs-12]=\"wizardMode\"\n        [class.hive-grid-container-order-sm-2]=\"wizardMode\"\n        [class.hive-grid-container-col-offset-sm-9]=\"wizardMode\"\n    >\n        @for (step of stepperSteps; track step; let index = $index) {\n            <hive-internal-stepper-item\n                [label]=\"step.label\"\n                [stepNumber]=\"index\"\n                [description]=\"step.description\"\n                [icon]=\"step.icon\"\n                [stepState]=\"\n                    calculateStepState(\n                        index,\n                        selectedIndex,\n                        step.hasError,\n                        step.hasWarning,\n                        enabledCurrentStepHighlighting,\n                        completed\n                    )\n                \"\n                [iconSize]=\"orientation === 'horizontal' ? 'small' : 'smallest'\"\n                [orientation]=\"orientation\"\n                [isLink]=\"step.isLink\"\n                [isActive]=\"!step.completed || index === selectedIndex\"\n                (stepClick)=\"step.select()\"\n            />\n        }\n    </ul>\n    @if (steps.length) {\n        <div\n            [class.hive-grid-container-col-7]=\"wizardMode\"\n            [class.hive-grid-container-order-sm-1]=\"wizardMode\"\n            [class.hive-grid-container-col-xs-12]=\"wizardMode\"\n            [class.hive-grid-container-col-sm-8]=\"wizardMode\"\n            [class.hive-grid-container-col-md-7]=\"wizardMode\"\n            [class.hive-grid-container-col-offset-md-1]=\"wizardMode\"\n        >\n            @for (step of steps; track step) {\n                <div [hidden]=\"step !== selected\" class=\"hive-stepper-content\">\n                    <ng-container [ngTemplateOutlet]=\"step.content\" />\n                </div>\n            }\n        </div>\n    }\n</div>\n", dependencies: [{ kind: "directive", type: i2$1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "component", type: InternalStepperItemComponent, selector: "hive-internal-stepper-item", inputs: ["stepNumber", "label", "icon", "description", "stepState", "iconSize", "orientation", "isActive", "isLink"], outputs: ["stepClick"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: StepperComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hive-stepper', providers: [
                        { provide: CdkStepper, useExisting: StepperComponent },
                        StepperShowPredefinedIconsService,
                    ], hostDirectives: [HiveThemedDirective], template: "<div\n    class=\"hive-stepper\"\n    [class.hive-stepper--horizontal]=\"orientation === 'horizontal'\"\n    [class.hive-stepper--vertical]=\"orientation === 'vertical'\"\n    [class.hive-grid-container]=\"wizardMode && steps.length\"\n>\n    <ul\n        class=\"hive-stepper-steps\"\n        [class.hive-grid-container-col-2]=\"wizardMode\"\n        [class.hive-grid-container-col-xs-12]=\"wizardMode\"\n        [class.hive-grid-container-order-sm-2]=\"wizardMode\"\n        [class.hive-grid-container-col-offset-sm-9]=\"wizardMode\"\n    >\n        @for (step of stepperSteps; track step; let index = $index) {\n            <hive-internal-stepper-item\n                [label]=\"step.label\"\n                [stepNumber]=\"index\"\n                [description]=\"step.description\"\n                [icon]=\"step.icon\"\n                [stepState]=\"\n                    calculateStepState(\n                        index,\n                        selectedIndex,\n                        step.hasError,\n                        step.hasWarning,\n                        enabledCurrentStepHighlighting,\n                        completed\n                    )\n                \"\n                [iconSize]=\"orientation === 'horizontal' ? 'small' : 'smallest'\"\n                [orientation]=\"orientation\"\n                [isLink]=\"step.isLink\"\n                [isActive]=\"!step.completed || index === selectedIndex\"\n                (stepClick)=\"step.select()\"\n            />\n        }\n    </ul>\n    @if (steps.length) {\n        <div\n            [class.hive-grid-container-col-7]=\"wizardMode\"\n            [class.hive-grid-container-order-sm-1]=\"wizardMode\"\n            [class.hive-grid-container-col-xs-12]=\"wizardMode\"\n            [class.hive-grid-container-col-sm-8]=\"wizardMode\"\n            [class.hive-grid-container-col-md-7]=\"wizardMode\"\n            [class.hive-grid-container-col-offset-md-1]=\"wizardMode\"\n        >\n            @for (step of steps; track step) {\n                <div [hidden]=\"step !== selected\" class=\"hive-stepper-content\">\n                    <ng-container [ngTemplateOutlet]=\"step.content\" />\n                </div>\n            }\n        </div>\n    }\n</div>\n" }]
        }], propDecorators: { wizardMode: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], stepperSteps: [{
                type: ContentChildren,
                args: [StepperStepComponent]
            }], showPredefinedIcons: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], enabledCurrentStepHighlighting: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], completed: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }] } });

class StepperNextDirective {
    constructor(_stepper) {
        this._stepper = _stepper;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: StepperNextDirective, deps: [{ token: i1$5.CdkStepper }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: StepperNextDirective, selector: "[hiveStepperNext]", host: { listeners: { "click": "_stepper.next()" } }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: StepperNextDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[hiveStepperNext]',
                    host: {
                        '(click)': '_stepper.next()',
                    },
                }]
        }], ctorParameters: () => [{ type: i1$5.CdkStepper }] });

class StepperPreviousDirective {
    constructor(_stepper) {
        this._stepper = _stepper;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: StepperPreviousDirective, deps: [{ token: i1$5.CdkStepper }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: StepperPreviousDirective, selector: "[hiveStepperPrevious]", host: { listeners: { "click": "_stepper.previous()" } }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: StepperPreviousDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[hiveStepperPrevious]',
                    host: {
                        '(click)': '_stepper.previous()',
                    },
                }]
        }], ctorParameters: () => [{ type: i1$5.CdkStepper }] });

class StepperModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: StepperModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: StepperModule, declarations: [StepperComponent,
            StepperStepComponent,
            StepperNextDirective,
            StepperPreviousDirective,
            InternalStepperItemComponent], imports: [CommonModule,
            CdkStepperModule,
            SvgDirective,
            TooltipModule,
            IconComponent,
            IsDefinedPipe,
            LabelComponent,
            LinkComponent], exports: [StepperComponent,
            StepperStepComponent,
            StepperNextDirective,
            StepperPreviousDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: StepperModule, imports: [CommonModule,
            CdkStepperModule,
            TooltipModule,
            IconComponent,
            LabelComponent,
            LinkComponent] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: StepperModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        StepperComponent,
                        StepperStepComponent,
                        StepperNextDirective,
                        StepperPreviousDirective,
                        InternalStepperItemComponent,
                    ],
                    imports: [
                        CommonModule,
                        CdkStepperModule,
                        SvgDirective,
                        TooltipModule,
                        IconComponent,
                        IsDefinedPipe,
                        LabelComponent,
                        LinkComponent,
                    ],
                    exports: [
                        StepperComponent,
                        StepperStepComponent,
                        StepperNextDirective,
                        StepperPreviousDirective,
                    ],
                }]
        }] });

class StatsDataComponent {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: StatsDataComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.3.12", type: StatsDataComponent, selector: "hive-stats-data", inputs: { leftIcon: "leftIcon", rightIcon: "rightIcon", type: "type", grow: "grow" }, host: { properties: { "class.hive-stats-data--has-grow": "this.grow", "style.flex-grow": "this.grow" } }, hostDirectives: [{ directive: HiveThemedDirective }], ngImport: i0, template: "@if (leftIcon) {\n    <div class=\"hive-stats-data_icon-container\">\n        <hive-icon-component\n            class=\"hive-stats-data_icon\"\n            size=\"small\"\n            [icon]=\"leftIcon\"\n        ></hive-icon-component>\n    </div>\n}\n\n<span\n    class=\"hive-stats-data\"\n    [ngClass]=\"{\n        'hive-stats-data--title': type === 'title',\n        'hive-stats-data--value': type === 'value',\n    }\"\n>\n    <ng-content></ng-content>\n</span>\n\n@if (rightIcon) {\n    <div class=\"hive-stats-data_icon-container\">\n        <hive-icon-component\n            class=\"hive-stats-data_icon\"\n            size=\"small\"\n            [icon]=\"rightIcon\"\n        ></hive-icon-component>\n    </div>\n}\n", dependencies: [{ kind: "directive", type: i2$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "component", type: IconComponent, selector: "hive-icon-component", inputs: ["icon", "size"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: StatsDataComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hive-stats-data', changeDetection: ChangeDetectionStrategy.OnPush, hostDirectives: [HiveThemedDirective], template: "@if (leftIcon) {\n    <div class=\"hive-stats-data_icon-container\">\n        <hive-icon-component\n            class=\"hive-stats-data_icon\"\n            size=\"small\"\n            [icon]=\"leftIcon\"\n        ></hive-icon-component>\n    </div>\n}\n\n<span\n    class=\"hive-stats-data\"\n    [ngClass]=\"{\n        'hive-stats-data--title': type === 'title',\n        'hive-stats-data--value': type === 'value',\n    }\"\n>\n    <ng-content></ng-content>\n</span>\n\n@if (rightIcon) {\n    <div class=\"hive-stats-data_icon-container\">\n        <hive-icon-component\n            class=\"hive-stats-data_icon\"\n            size=\"small\"\n            [icon]=\"rightIcon\"\n        ></hive-icon-component>\n    </div>\n}\n" }]
        }], propDecorators: { leftIcon: [{
                type: Input
            }], rightIcon: [{
                type: Input
            }], type: [{
                type: Input
            }], grow: [{
                type: HostBinding,
                args: ['class.hive-stats-data--has-grow']
            }, {
                type: HostBinding,
                args: ['style.flex-grow']
            }, {
                type: Input
            }] } });

/**
 * Stats component utilizes `<hive-stats-data>` component for title and values.
 *
 * For links, `<hive-link>` component is used.
 *
 * Help text is passed as an `@Input()`.
 *
 *
 * To define the growth of particular value block, use `grow` attribute on the `<hive-stats-data>` component.
 *
 * It sets a flex-grow CSS property with passed value on corrseponding element.
 * This way is prefered over overriding CSS styles directly.
 *
 *
 * Squares near text serve the role of placeholders, where actual icons should be put.
 */
class StatsComponent {
    constructor() {
        /**
         * Used to provide additional context or guidance to users about the data being presented.
         */
        this.helpText = '';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: StatsComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.3.12", type: StatsComponent, selector: "hive-stats", inputs: { helpText: "helpText" }, hostDirectives: [{ directive: HiveThemedDirective }], ngImport: i0, template: "<ng-content select=\"hive-stats-data[type='title']\"></ng-content>\n\n<div class=\"hive-stats_value-container\">\n    <ng-content select=\"hive-stats-data[type='value']\"></ng-content>\n</div>\n\n@if (helpText) {\n    <div class=\"hive-stats_help-text\">\n        {{ helpText }}\n    </div>\n}\n\n<ng-content select=\"a[hive-link]\"></ng-content>\n", changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: StatsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hive-stats', changeDetection: ChangeDetectionStrategy.OnPush, hostDirectives: [HiveThemedDirective], template: "<ng-content select=\"hive-stats-data[type='title']\"></ng-content>\n\n<div class=\"hive-stats_value-container\">\n    <ng-content select=\"hive-stats-data[type='value']\"></ng-content>\n</div>\n\n@if (helpText) {\n    <div class=\"hive-stats_help-text\">\n        {{ helpText }}\n    </div>\n}\n\n<ng-content select=\"a[hive-link]\"></ng-content>\n" }]
        }], propDecorators: { helpText: [{
                type: Input
            }] } });

class StatsModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: StatsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: StatsModule, declarations: [StatsComponent, StatsDataComponent], imports: [CommonModule, LinkComponent, IconComponent], exports: [StatsComponent, StatsDataComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: StatsModule, imports: [CommonModule, LinkComponent, IconComponent] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: StatsModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [StatsComponent, StatsDataComponent],
                    imports: [CommonModule, LinkComponent, IconComponent],
                    exports: [StatsComponent, StatsDataComponent],
                }]
        }] });

/**
 * Injection token for the disabled state of the switch group.
 */
const SWITCH_DISABLED_TOKEN = new InjectionToken('disabled');
/**
 * Injection token for the size of the switch group.
 */
const SWITCH_SIZE_TOKEN = new InjectionToken('size');
/**
 * `SwitchComponent` supports grouping multiple switches together using `SwitchGroupComponent`.
 *  The component controls size and disabled state of the switches inside the group.
 */
class SwitchGroupComponent {
    constructor(disabled$, size$) {
        this.disabled$ = disabled$;
        this.size$ = size$;
        /**
         * Positioning of the switches in the group
         */
        this.orientation = 'horizontal';
        this.labelSize$ = this.size$.pipe(map((size) => (size === 'small' ? 'medium' : 'large')));
    }
    /**
     * Makes all internal switch components disabled
     */
    set disabled(isDisabled) {
        this.disabled$.next(isDisabled);
    }
    /**
     * Set size of internal switch components
     */
    set size(size) {
        this.size$.next(size ?? 'small');
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SwitchGroupComponent, deps: [{ token: SWITCH_DISABLED_TOKEN }, { token: SWITCH_SIZE_TOKEN }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "16.1.0", version: "17.3.12", type: SwitchGroupComponent, selector: "hive-switch-group", inputs: { heading: "heading", orientation: "orientation", disabled: ["disabled", "disabled", booleanAttribute], size: "size" }, providers: [
            {
                provide: SWITCH_DISABLED_TOKEN,
                useFactory: () => new BehaviorSubject(false),
            },
            {
                provide: SWITCH_SIZE_TOKEN,
                useFactory: () => new BehaviorSubject('small'),
            },
        ], hostDirectives: [{ directive: HiveThemedDirective }], ngImport: i0, template: ` <div class="hive-switch-group_container">
        <div class="hive-switch-group_heading">
            <hive-label
                [label]="heading"
                [size]="labelSize$ | async"
                weight="semibold"
            ></hive-label>
        </div>

        <div
            class="hive-switch-group_switch-content"
            [ngClass]="['hive-switch-group_switch-content--' + orientation]"
        >
            <ng-content select="hive-switch"></ng-content>
        </div>
    </div>`, isInline: true, dependencies: [{ kind: "directive", type: i2$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "component", type: LabelComponent, selector: "hive-label", inputs: ["label", "for", "size", "weight", "maxWeight", "horizontalAlignment", "leftIconHelpInfoMessage", "rightIconHelpInfoMessage", "leftIcon", "rightIcon", "required", "textOverflowEllipsis"] }, { kind: "pipe", type: i2$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SwitchGroupComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'hive-switch-group',
                    template: ` <div class="hive-switch-group_container">
        <div class="hive-switch-group_heading">
            <hive-label
                [label]="heading"
                [size]="labelSize$ | async"
                weight="semibold"
            ></hive-label>
        </div>

        <div
            class="hive-switch-group_switch-content"
            [ngClass]="['hive-switch-group_switch-content--' + orientation]"
        >
            <ng-content select="hive-switch"></ng-content>
        </div>
    </div>`,
                    hostDirectives: [HiveThemedDirective],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    providers: [
                        {
                            provide: SWITCH_DISABLED_TOKEN,
                            useFactory: () => new BehaviorSubject(false),
                        },
                        {
                            provide: SWITCH_SIZE_TOKEN,
                            useFactory: () => new BehaviorSubject('small'),
                        },
                    ],
                }]
        }], ctorParameters: () => [{ type: i4.BehaviorSubject, decorators: [{
                    type: Inject,
                    args: [SWITCH_DISABLED_TOKEN]
                }] }, { type: i4.BehaviorSubject, decorators: [{
                    type: Inject,
                    args: [SWITCH_SIZE_TOKEN]
                }] }], propDecorators: { heading: [{
                type: Input
            }], orientation: [{
                type: Input
            }], disabled: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], size: [{
                type: Input
            }] } });

let nextUniqueId$2 = 0;
const SWITCH_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => SwitchComponent),
    multi: true,
};
/**
 * The Switch Component, also known as a Toggle Switch, is a user interface
 * element that allows users to toggle between two states,
 * typically representing "on" and "off" or "enabled" and "disabled."
 *
 * @example
 * <hive-switch label="Switch 1"></hive-switch>
 *
 * @example
 * <hive-switch label="Switch 1" [(checked)]="checked"></hive-switch>
 *
 * @example
 * <hive-switch label="Switch 1" [disabled]="true"></hive-switch>
 */
class SwitchComponent {
    /**
     * Whether the switch is disabled.
     * @param isDisabled
     */
    set disabled(isDisabled) {
        this._disabled = isDisabled;
    }
    get disabled() {
        return this._disabled || this._groupDisabled;
    }
    /**
     * The size of the switch.
     * @param size
     */
    set size(size) {
        if (this.size$) {
            logInputGroupWarning(SwitchComponent.name, 'size', SwitchGroupComponent.name);
            return;
        }
        this._size = size ?? 'small';
    }
    /**
     * Whether the switch is checked.
     * @param isChecked
     */
    set checked(isChecked) {
        this._checked = isChecked ?? false;
    }
    get inputId() {
        return `${this.id || this.uniqueId}--hive-switch`;
    }
    constructor(cdr, injector, destroyRef, formComponentValidityDirective, disabled$, size$) {
        this.cdr = cdr;
        this.injector = injector;
        this.destroyRef = destroyRef;
        this.formComponentValidityDirective = formComponentValidityDirective;
        this.disabled$ = disabled$;
        this.size$ = size$;
        /**
         * Whether the switch is required.
         */
        this.required = false;
        /**
         * Emits when the switch becomes checked or unchecked.
         *
         * `true` if the switch is checked, `false` otherwise.
         */
        this.checkedChange = new EventEmitter();
        this._disabled = false;
        this._groupDisabled = false;
        this._size = 'small';
        this._checked = false;
        this.destroyRef$ = inject(DestroyRef);
        // region ControlValueAccessor
        /**
         * @internal
         */
        this.onModelChange = () => { };
        /**
         * @internal
         */
        this.onModelTouch = () => { };
        this.uniqueId = `${++nextUniqueId$2}`;
    }
    ngOnInit() {
        this.injector
            .get(NgControl, null, {
            optional: true,
        })
            ?.control?.statusChanges.pipe(safeTakeUntilDestroyed(this.destroyRef))
            .subscribe(() => {
            this.cdr.markForCheck();
        });
        // Subscribe to disabled$ and size$ if they exist
        subscribeWithCleanup(this.disabled$, (isDisabled) => {
            this._groupDisabled = isDisabled;
        }, this.destroyRef$, this.cdr);
        subscribeWithCleanup(this.size$, (size) => {
            this._size = size;
        }, this.destroyRef$, this.cdr);
    }
    handleInteraction(state, disabled) {
        if (disabled) {
            return;
        }
        this._checked = state;
        this.checkedChange.emit(state);
        this.onModelChange(state);
    }
    /**
     * @internal
     * @param isChecked
     */
    writeValue(isChecked) {
        this.checked = isChecked;
        this.cdr.detectChanges();
    }
    /**
     * @internal
     * @param fn
     */
    registerOnChange(fn) {
        this.onModelChange = fn;
    }
    /**
     * @internal
     * @param fn
     */
    registerOnTouched(fn) {
        this.onModelTouch = fn;
    }
    /**
     * @internal
     * @param isDisabled
     */
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
        this.cdr.detectChanges();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SwitchComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.Injector }, { token: i0.DestroyRef }, { token: FormComponentValidityDirective }, { token: SWITCH_DISABLED_TOKEN, optional: true }, { token: SWITCH_SIZE_TOKEN, optional: true }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "16.1.0", version: "17.3.12", type: SwitchComponent, selector: "hive-switch", inputs: { label: "label", required: ["required", "required", booleanAttribute], disabled: ["disabled", "disabled", booleanAttribute], size: "size", checked: "checked", id: "id" }, outputs: { checkedChange: "checkedChange" }, providers: [SWITCH_VALUE_ACCESSOR], hostDirectives: [{ directive: HiveThemedDirective }, { directive: FormComponentValidityDirective }], ngImport: i0, template: "<div class=\"hive-switch_container\">\n    <input\n        type=\"checkbox\"\n        tabindex=\"-1\"\n        class=\"hive-switch_input\"\n        [attr.aria-invalid]=\"formComponentValidityDirective.webkitInvalid\"\n        [id]=\"inputId\"\n        [disabled]=\"disabled\"\n        [checked]=\"_checked\"\n        (change)=\"handleInteraction(!_checked, _disabled)\"\n    />\n\n    <div\n        tabindex=\"0\"\n        class=\"hive-switch_toggle\"\n        [ngClass]=\"{\n            'hive-switch_toggle--medium': _size === 'medium',\n            'hive-switch_toggle--disabled': disabled,\n            'hive-switch_toggle--error': formComponentValidityDirective.invalid,\n            'hive-switch_toggle--checked': _checked\n        }\"\n        (click)=\"handleInteraction(!_checked, disabled)\"\n        (keydown.space)=\"\n            $event.preventDefault(); handleInteraction(!_checked, disabled)\n        \"\n        (keydown.enter)=\"\n            $event.preventDefault(); handleInteraction(!_checked, disabled)\n        \"\n        (blur)=\"onModelTouch()\"\n    >\n        <div class=\"hive-switch_handle-container\">\n            <div class=\"hive-switch_handle\"></div>\n\n            <svg\n                class=\"hive-switch_checkmark\"\n                xmlns=\"http://www.w3.org/2000/svg\"\n                viewBox=\"0 0 448 512\"\n            >\n                <!--! Font Awesome Pro 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->\n                <path\n                    class=\"hive-switch_checkmark-path\"\n                    d=\"M443.3 100.7c6.2 6.2 6.2 16.4 0 22.6l-272 272c-6.2 6.2-16.4 6.2-22.6 0l-144-144c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L160 361.4 420.7 100.7c6.2-6.2 16.4-6.2 22.6 0z\"\n                />\n            </svg>\n        </div>\n    </div>\n\n    <label [for]=\"inputId\" class=\"hive-switch_label\">\n        <hive-label\n            [size]=\"_size\"\n            weight=\"regular\"\n            [label]=\"label\"\n            [required]=\"formComponentValidityDirective.required || required\"\n        ></hive-label>\n    </label>\n</div>\n", dependencies: [{ kind: "directive", type: i2$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "component", type: LabelComponent, selector: "hive-label", inputs: ["label", "for", "size", "weight", "maxWeight", "horizontalAlignment", "leftIconHelpInfoMessage", "rightIconHelpInfoMessage", "leftIcon", "rightIcon", "required", "textOverflowEllipsis"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SwitchComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hive-switch', hostDirectives: [HiveThemedDirective, FormComponentValidityDirective], changeDetection: ChangeDetectionStrategy.OnPush, providers: [SWITCH_VALUE_ACCESSOR], template: "<div class=\"hive-switch_container\">\n    <input\n        type=\"checkbox\"\n        tabindex=\"-1\"\n        class=\"hive-switch_input\"\n        [attr.aria-invalid]=\"formComponentValidityDirective.webkitInvalid\"\n        [id]=\"inputId\"\n        [disabled]=\"disabled\"\n        [checked]=\"_checked\"\n        (change)=\"handleInteraction(!_checked, _disabled)\"\n    />\n\n    <div\n        tabindex=\"0\"\n        class=\"hive-switch_toggle\"\n        [ngClass]=\"{\n            'hive-switch_toggle--medium': _size === 'medium',\n            'hive-switch_toggle--disabled': disabled,\n            'hive-switch_toggle--error': formComponentValidityDirective.invalid,\n            'hive-switch_toggle--checked': _checked\n        }\"\n        (click)=\"handleInteraction(!_checked, disabled)\"\n        (keydown.space)=\"\n            $event.preventDefault(); handleInteraction(!_checked, disabled)\n        \"\n        (keydown.enter)=\"\n            $event.preventDefault(); handleInteraction(!_checked, disabled)\n        \"\n        (blur)=\"onModelTouch()\"\n    >\n        <div class=\"hive-switch_handle-container\">\n            <div class=\"hive-switch_handle\"></div>\n\n            <svg\n                class=\"hive-switch_checkmark\"\n                xmlns=\"http://www.w3.org/2000/svg\"\n                viewBox=\"0 0 448 512\"\n            >\n                <!--! Font Awesome Pro 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->\n                <path\n                    class=\"hive-switch_checkmark-path\"\n                    d=\"M443.3 100.7c6.2 6.2 6.2 16.4 0 22.6l-272 272c-6.2 6.2-16.4 6.2-22.6 0l-144-144c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L160 361.4 420.7 100.7c6.2-6.2 16.4-6.2 22.6 0z\"\n                />\n            </svg>\n        </div>\n    </div>\n\n    <label [for]=\"inputId\" class=\"hive-switch_label\">\n        <hive-label\n            [size]=\"_size\"\n            weight=\"regular\"\n            [label]=\"label\"\n            [required]=\"formComponentValidityDirective.required || required\"\n        ></hive-label>\n    </label>\n</div>\n" }]
        }], ctorParameters: () => [{ type: i0.ChangeDetectorRef }, { type: i0.Injector }, { type: i0.DestroyRef }, { type: FormComponentValidityDirective }, { type: i4.BehaviorSubject, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [SWITCH_DISABLED_TOKEN]
                }] }, { type: i4.BehaviorSubject, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [SWITCH_SIZE_TOKEN]
                }] }], propDecorators: { label: [{
                type: Input
            }], required: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], disabled: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], size: [{
                type: Input
            }], checked: [{
                type: Input
            }], id: [{
                type: Input
            }], checkedChange: [{
                type: Output
            }] } });

class SwitchModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SwitchModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: SwitchModule, declarations: [SwitchComponent, SwitchGroupComponent], imports: [CommonModule, LabelComponent], exports: [SwitchComponent, SwitchGroupComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SwitchModule, imports: [CommonModule, LabelComponent] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SwitchModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [SwitchComponent, SwitchGroupComponent],
                    imports: [CommonModule, LabelComponent],
                    exports: [SwitchComponent, SwitchGroupComponent],
                }]
        }] });

class SingleValuePickerDirective {
    constructor(cdr) {
        this.cdr = cdr;
        // region ControlValueAccessor implementation
        /**
         * @internal
         */
        this.controlValueAccessorOnChange = () => { };
        /**
         * @internal
         */
        this.controlValueAccessorOnTouched = () => { };
    }
    /**
     * @internal
     */
    writeValue(value) {
        this.value = value;
        this.cdr.markForCheck();
    }
    /**
     * @internal
     */
    registerOnChange(fn) {
        this.controlValueAccessorOnChange = fn;
    }
    /**
     * @internal
     */
    registerOnTouched(fn) {
        this.controlValueAccessorOnTouched = fn;
    }
    /**
     * @internal
     */
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
        this.cdr.markForCheck();
    }
}

/**
 * Injection token for the disabled state of the radio group.
 */
const RADIO_DISABLED_TOKEN = new InjectionToken('disabled');
/**
 * Injection token for the size of the radio group.
 */
const RADIO_SIZE_TOKEN = new InjectionToken('size');
const RADIO_NAME_TOKEN = new InjectionToken('name');
let nextUniqueId$1 = 0;
const RADIO_GROUP_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => RadioGroupComponent),
    multi: true,
};
/**
 * Radio Group is yet another approach to using radio buttons.
 * It is a wrapper around the native radio button input, and provides a way to group radio buttons together.
 *
 *
 * ### That easy!
 *
 * There's no need to pass anything to the `<hive-radio-button>`, except for the `value` and label to make it work.
 *
 *
 * #### Name
 *
 * The `name` property is set on the `<hive-radio-group>` and is passed to radio buttons automatically.
 *
 * If no `name` is set, the unique name will be generated and applied to each `<hive-radio-button>` automatically.
 *
 * #### Disabled
 *
 * It is possible to disable each radio-button separately, but if there's a need to disable the whole group, it is possible to do so by setting the `disabled` property on the `<hive-radio-group>`.
 */
class RadioGroupComponent extends SingleValuePickerDirective {
    /**
     * The value of the selected radio button.
     */
    get value() {
        return this._value;
    }
    set value(newValue) {
        if (this._value !== newValue) {
            this._value = newValue;
            this.updateSelectedRadioFromValue();
            this.checkSelectedRadioButton();
        }
    }
    /**
     * The name of the radio button group. All radio buttons inside this group
     * will use this name.
     *
     * If not specified, unique name will be used.
     */
    set name(value) {
        this.name$.next(value);
    }
    get name() {
        return this._name;
    }
    /**
     * The currently selected radio button.
     *
     * If set to a new radio button, the radio group value will be updated to
     * match the new selected button.
     */
    get selected() {
        return this._selected;
    }
    set selected(selected) {
        this._selected = selected;
        this.value = selected ? selected.value : null;
        this.checkSelectedRadioButton();
    }
    /**
     * Whether the radio group and all radio buttons are disabled.
     *
     * @default false
     */
    set disabled(value) {
        this.disabled$.next(value);
    }
    set size(size) {
        this.size$.next(size ?? 'small');
    }
    constructor(cdr, disabled$, size$, name$) {
        super(cdr);
        this.cdr = cdr;
        this.disabled$ = disabled$;
        this.size$ = size$;
        this.name$ = name$;
        this.labelSize$ = this.size$.pipe(map((size) => (size === 'small' ? 'medium' : 'large')));
        /**
         * Defines radio group layout
         */
        this.orientation = 'vertical';
        this._name = `${nextUniqueId$1++}--hive-radio-group`;
        this._selected = null;
        this.name$.next(this._name);
    }
    checkSelectedRadioButton() {
        if (this._selected && !this._selected.checked) {
            this._selected.checked = true;
        }
    }
    updateSelectedRadioFromValue() {
        const isAlreadySelected = this._selected !== null && this._selected.value === this._value;
        if (this.valueSelectorItems && !isAlreadySelected) {
            this._selected = null;
            this.valueSelectorItems.forEach((radio) => {
                radio.checked = this.value === radio.value;
                if (radio.checked) {
                    this._selected = radio;
                }
            });
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: RadioGroupComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: RADIO_DISABLED_TOKEN }, { token: RADIO_SIZE_TOKEN }, { token: RADIO_NAME_TOKEN }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.3.12", type: RadioGroupComponent, selector: "hive-radio-group", inputs: { heading: "heading", value: "value", name: "name", selected: "selected", disabled: ["disabled", "disabled", booleanAttribute], size: "size", orientation: "orientation" }, providers: [
            RADIO_GROUP_VALUE_ACCESSOR,
            {
                provide: RADIO_DISABLED_TOKEN,
                useFactory: () => new BehaviorSubject(false),
            },
            {
                provide: RADIO_SIZE_TOKEN,
                useFactory: () => new BehaviorSubject('small'),
            },
            {
                provide: RADIO_NAME_TOKEN,
                useFactory: () => new BehaviorSubject(''),
            },
        ], queries: [{ propertyName: "valueSelectorItems", predicate: i0.forwardRef(() => RadioButtonComponent) }], usesInheritance: true, hostDirectives: [{ directive: HiveThemedDirective }], ngImport: i0, template: "@if (heading) {\n    <hive-label\n        [label]=\"heading\"\n        weight=\"semibold\"\n        [size]=\"labelSize$ | async\"\n    ></hive-label>\n}\n\n<div\n    [ngClass]=\"[\n        'hive-radio-group-container',\n        'hive-radio-group-container-positioning__' + orientation,\n    ]\"\n>\n    <ng-content select=\"hive-radio-button\"></ng-content>\n</div>\n", dependencies: [{ kind: "directive", type: i2$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "component", type: LabelComponent, selector: "hive-label", inputs: ["label", "for", "size", "weight", "maxWeight", "horizontalAlignment", "leftIconHelpInfoMessage", "rightIconHelpInfoMessage", "leftIcon", "rightIcon", "required", "textOverflowEllipsis"] }, { kind: "pipe", type: i2$1.AsyncPipe, name: "async" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: RadioGroupComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hive-radio-group', providers: [
                        RADIO_GROUP_VALUE_ACCESSOR,
                        {
                            provide: RADIO_DISABLED_TOKEN,
                            useFactory: () => new BehaviorSubject(false),
                        },
                        {
                            provide: RADIO_SIZE_TOKEN,
                            useFactory: () => new BehaviorSubject('small'),
                        },
                        {
                            provide: RADIO_NAME_TOKEN,
                            useFactory: () => new BehaviorSubject(''),
                        },
                    ], hostDirectives: [HiveThemedDirective], template: "@if (heading) {\n    <hive-label\n        [label]=\"heading\"\n        weight=\"semibold\"\n        [size]=\"labelSize$ | async\"\n    ></hive-label>\n}\n\n<div\n    [ngClass]=\"[\n        'hive-radio-group-container',\n        'hive-radio-group-container-positioning__' + orientation,\n    ]\"\n>\n    <ng-content select=\"hive-radio-button\"></ng-content>\n</div>\n" }]
        }], ctorParameters: () => [{ type: i0.ChangeDetectorRef }, { type: i4.BehaviorSubject, decorators: [{
                    type: Inject,
                    args: [RADIO_DISABLED_TOKEN]
                }] }, { type: i4.BehaviorSubject, decorators: [{
                    type: Inject,
                    args: [RADIO_SIZE_TOKEN]
                }] }, { type: i4.Subject, decorators: [{
                    type: Inject,
                    args: [RADIO_NAME_TOKEN]
                }] }], propDecorators: { heading: [{
                type: Input
            }], value: [{
                type: Input
            }], name: [{
                type: Input
            }], selected: [{
                type: Input
            }], disabled: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], size: [{
                type: Input
            }], orientation: [{
                type: Input
            }], valueSelectorItems: [{
                type: ContentChildren,
                args: [forwardRef(() => RadioButtonComponent)]
            }] } });

let nextUniqueId = 0;
const RADIOBUTTON_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => RadioButtonComponent),
    multi: true,
};
/**
 * Radio buttons are used to allow users to select a single option from a list of options.
 */
class RadioButtonComponent {
    /**
     * @internal
     */
    writeValue(value) {
        this.formValue = value;
        this.checked = this.formValue === this.value;
        this.cdr.markForCheck();
    }
    /**
     * @internal
     */
    registerOnChange(fn) {
        this.controlValueAccessorOnChange = fn;
    }
    /**
     * @internal
     */
    registerOnTouched(fn) {
        this.controlValueAccessorOnTouched = fn;
    }
    /**
     * @internal
     */
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
        this.cdr.markForCheck();
    }
    // endregion
    /**
     * Size of radio button
     */
    get size() {
        return this._size;
    }
    set size(size) {
        if (this.size$) {
            logInputGroupWarning(RadioButtonComponent.name, 'size', RadioGroupComponent.name);
            return;
        }
        this._size = size ?? 'small';
    }
    /**
     * `value` attribute of `<input>`
     *
     * @see {@link HTMLInputElement.prototype#value}
     */
    get value() {
        return this._value;
    }
    set value(value) {
        if (this._value !== value) {
            this._value = value;
            this.checked = false;
            if (this.radioGroup !== null) {
                if (!this.checked) {
                    this.checked = this.radioGroup.value === value;
                }
                if (this.checked) {
                    this.radioGroup.selected = this;
                }
            }
        }
    }
    /**
     * `name` attribute of `<input>`
     *
     * @see {@link HTMLInputElement.prototype#name}
     */
    set name(name) {
        if (this.name$) {
            logInputGroupWarning(RadioButtonComponent.name, 'name', RadioGroupComponent.name);
            return;
        }
        this._name = name;
    }
    get name() {
        return this._name ?? '';
    }
    /**
     * `disabled` attribute of `<input>`
     *
     * @see {@link HTMLInputElement.prototype#disabled}
     */
    get disabled() {
        return this._disabled || this._groupDisabled;
    }
    set disabled(value) {
        this._disabled = value;
        this.cdr.markForCheck();
    }
    /**
     * `checked` attribute of `HTMLInputElement`
     *
     * @see {@link HTMLInputElement.prototype#checked}
     */
    get checked() {
        return this._checked;
    }
    set checked(newCheckedState) {
        if (this._checked !== newCheckedState) {
            this._checked = newCheckedState;
            if (newCheckedState &&
                this.radioGroup &&
                this.radioGroup.value !== this.value) {
                this.radioGroup.selected = this;
            }
            else if (!newCheckedState &&
                this.radioGroup &&
                this.radioGroup.value === this.value) {
                this.radioGroup.selected = null;
            }
            if (newCheckedState) {
                this._radioDispatcher.notify(this.id, this._name ?? '');
            }
            this.cdr.markForCheck();
        }
    }
    constructor(cdr, injector, destroyRef, _radioDispatcher, formComponentValidityDirective, radioGroup, disabled$, size$, name$) {
        this.cdr = cdr;
        this.injector = injector;
        this.destroyRef = destroyRef;
        this._radioDispatcher = _radioDispatcher;
        this.formComponentValidityDirective = formComponentValidityDirective;
        this.radioGroup = radioGroup;
        this.disabled$ = disabled$;
        this.size$ = size$;
        this.name$ = name$;
        // region ControlValueAccessor
        this.controlValueAccessorOnChange = () => { };
        this.controlValueAccessorOnTouched = () => { };
        /**
         * `required` attribute of `<input>`
         *
         * @default false
         * @see {@link HTMLInputElement.prototype#required}
         */
        this.required = false;
        this.destroyRef$ = inject(DestroyRef);
        this.uniqueId = `${++nextUniqueId}`;
        /**
         * @internal
         */
        this._removeUniqueSelectionListener = () => { };
        this._disabled = false;
        this._groupDisabled = false;
        this._checked = false;
        this._value = null;
        this._size = 'small';
        this.id = this.uniqueId;
    }
    ngOnInit() {
        if (this.radioGroup) {
            // If the radio is inside a radio group, determine if it should be checked
            this.checked = this.radioGroup.value === this._value;
            if (this.checked) {
                this.radioGroup.selected = this;
            }
            subscribeWithCleanup(this.name$, (name) => {
                this._name = name;
            }, this.destroyRef$, this.cdr);
            subscribeWithCleanup(this.disabled$, (isDisabled) => {
                this._groupDisabled = isDisabled;
            }, this.destroyRef$, this.cdr);
            subscribeWithCleanup(this.size$, (size) => {
                this._size = size;
            }, this.destroyRef$, this.cdr);
        }
        this.injector
            .get(NgControl, null, {
            optional: true,
        })
            ?.control?.statusChanges.pipe(safeTakeUntilDestroyed(this.destroyRef))
            .subscribe(() => {
            this.cdr.markForCheck();
        });
        this._removeUniqueSelectionListener = this._radioDispatcher.listen((id, name) => {
            if (id !== this.id && name === this._name) {
                this.checked = false;
            }
        });
    }
    ngOnDestroy() {
        this._removeUniqueSelectionListener();
    }
    /**
     * @internal
     */
    get inputId() {
        return `${this.id ?? this.uniqueId}--hive-input-radio-button`;
    }
    /**
     * @internal
     */
    handleChange() {
        if (!this.checked && !this.disabled) {
            this.checked = true;
            if (this.radioGroup) {
                this.radioGroup.controlValueAccessorOnChange(this.value);
            }
            this.controlValueAccessorOnChange(this.value);
        }
    }
    /**
     * @internal
     */
    handleBlur() {
        this.controlValueAccessorOnTouched();
    }
    /**
     * @internal
     */
    markForCheck() {
        this.cdr.markForCheck();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: RadioButtonComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.Injector }, { token: i0.DestroyRef }, { token: i2.UniqueSelectionDispatcher }, { token: FormComponentValidityDirective }, { token: RadioGroupComponent, optional: true }, { token: RADIO_DISABLED_TOKEN, optional: true }, { token: RADIO_SIZE_TOKEN, optional: true }, { token: RADIO_NAME_TOKEN, optional: true }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.3.12", type: RadioButtonComponent, selector: "hive-radio-button", inputs: { size: "size", value: "value", name: "name", disabled: ["disabled", "disabled", booleanAttribute], id: "id", checked: ["checked", "checked", booleanAttribute], required: ["required", "required", booleanAttribute] }, providers: [RADIOBUTTON_VALUE_ACCESSOR], hostDirectives: [{ directive: HiveThemedDirective }, { directive: FormComponentValidityDirective }], ngImport: i0, template: "<div\n    class=\"hive-radio-button_container\"\n    [ngClass]=\"['hive-radio-button_container--size-' + size]\"\n>\n    <input\n        #input\n        type=\"radio\"\n        role=\"radio\"\n        class=\"hive-radio-button_input\"\n        [class.hive-radio-button_input--invalid]=\"\n            formComponentValidityDirective.webkitInvalid\n        \"\n        [attr.aria-invalid]=\"formComponentValidityDirective.webkitInvalid\"\n        [value]=\"value\"\n        [name]=\"name\"\n        [disabled]=\"disabled\"\n        [id]=\"inputId\"\n        [checked]=\"checked\"\n        [required]=\"formComponentValidityDirective.required || required\"\n        (change)=\"handleChange()\"\n        (blur)=\"handleBlur()\"\n    />\n\n    <label\n        class=\"hive-radio-button_label\"\n        [class.hive-radio-button_label--disabled]=\"disabled\"\n        [for]=\"inputId\"\n    >\n        <ng-content></ng-content>\n\n        @if (\n            formComponentValidityDirective.required || required;\n            as isRequired\n        ) {\n            <hive-label\n                data-role=\"required-indication\"\n                label=\"\"\n                [required]=\"isRequired\"\n            ></hive-label>\n        }\n    </label>\n</div>\n", dependencies: [{ kind: "directive", type: i2$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "component", type: LabelComponent, selector: "hive-label", inputs: ["label", "for", "size", "weight", "maxWeight", "horizontalAlignment", "leftIconHelpInfoMessage", "rightIconHelpInfoMessage", "leftIcon", "rightIcon", "required", "textOverflowEllipsis"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: RadioButtonComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hive-radio-button', providers: [RADIOBUTTON_VALUE_ACCESSOR], changeDetection: ChangeDetectionStrategy.OnPush, hostDirectives: [HiveThemedDirective, FormComponentValidityDirective], template: "<div\n    class=\"hive-radio-button_container\"\n    [ngClass]=\"['hive-radio-button_container--size-' + size]\"\n>\n    <input\n        #input\n        type=\"radio\"\n        role=\"radio\"\n        class=\"hive-radio-button_input\"\n        [class.hive-radio-button_input--invalid]=\"\n            formComponentValidityDirective.webkitInvalid\n        \"\n        [attr.aria-invalid]=\"formComponentValidityDirective.webkitInvalid\"\n        [value]=\"value\"\n        [name]=\"name\"\n        [disabled]=\"disabled\"\n        [id]=\"inputId\"\n        [checked]=\"checked\"\n        [required]=\"formComponentValidityDirective.required || required\"\n        (change)=\"handleChange()\"\n        (blur)=\"handleBlur()\"\n    />\n\n    <label\n        class=\"hive-radio-button_label\"\n        [class.hive-radio-button_label--disabled]=\"disabled\"\n        [for]=\"inputId\"\n    >\n        <ng-content></ng-content>\n\n        @if (\n            formComponentValidityDirective.required || required;\n            as isRequired\n        ) {\n            <hive-label\n                data-role=\"required-indication\"\n                label=\"\"\n                [required]=\"isRequired\"\n            ></hive-label>\n        }\n    </label>\n</div>\n" }]
        }], ctorParameters: () => [{ type: i0.ChangeDetectorRef }, { type: i0.Injector }, { type: i0.DestroyRef }, { type: i2.UniqueSelectionDispatcher }, { type: FormComponentValidityDirective }, { type: RadioGroupComponent, decorators: [{
                    type: Optional
                }] }, { type: i4.BehaviorSubject, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [RADIO_DISABLED_TOKEN]
                }] }, { type: i4.BehaviorSubject, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [RADIO_SIZE_TOKEN]
                }] }, { type: i4.BehaviorSubject, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [RADIO_NAME_TOKEN]
                }] }], propDecorators: { size: [{
                type: Input
            }], value: [{
                type: Input
            }], name: [{
                type: Input
            }], disabled: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], id: [{
                type: Input
            }], checked: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], required: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }] } });

class RadioButtonModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: RadioButtonModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: RadioButtonModule, declarations: [RadioButtonComponent, RadioGroupComponent], imports: [CommonModule, FormsModule, ReactiveFormsModule, LabelComponent], exports: [RadioButtonComponent, RadioGroupComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: RadioButtonModule, providers: [UniqueSelectionDispatcher], imports: [CommonModule, FormsModule, ReactiveFormsModule, LabelComponent] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: RadioButtonModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [RadioButtonComponent, RadioGroupComponent],
                    imports: [CommonModule, FormsModule, ReactiveFormsModule, LabelComponent],
                    exports: [RadioButtonComponent, RadioGroupComponent],
                    providers: [UniqueSelectionDispatcher],
                }]
        }] });

function oneOfSizesOrDefault(value) {
    return oneOfOrDefault(value, 'large', 'small', 'medium', 'large');
}
class SectionHeaderComponent {
    constructor() {
        /**
         * Component size, affects breadcrumbs and headline
         */
        this.size = 'large';
        /**
         * Should show the content of the section or not
         */
        this.expanded = true;
        /**
         * Emits when expanded state changes
         */
        this.expandedChange = new EventEmitter();
        /**
         * Should be able to collapse the content
         */
        this.collapsable = false;
        this._expanded = true;
    }
    ngOnChanges(changes) {
        if ('expanded' in changes) {
            this._expanded = this.expanded;
        }
    }
    handleExpandedChange(expanded) {
        this._expanded = expanded;
        this.expandedChange.emit(expanded);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SectionHeaderComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.3.12", type: SectionHeaderComponent, isStandalone: true, selector: "hive-section-header", inputs: { heading: ["heading", "heading", stringOrUndefinedAttribute], description: ["description", "description", stringOrUndefinedAttribute], size: ["size", "size", oneOfSizesOrDefault], expanded: ["expanded", "expanded", booleanAttribute], collapsable: ["collapsable", "collapsable", booleanAttribute] }, outputs: { expandedChange: "expandedChange" }, usesOnChanges: true, hostDirectives: [{ directive: HiveThemedDirective }], ngImport: i0, template: "@if (size === 'large') {\n    <ng-content select=\"hive-breadcrumb\" />\n}\n<hive-collapsable-item\n    [expanded]=\"!collapsable || _expanded\"\n    [nonInteractive]=\"!collapsable\"\n    (expandedChange)=\"handleExpandedChange($event)\"\n>\n    <header class=\"hive-section-header\">\n        @if (collapsable) {\n            <hive-icon-component\n                hiveChevron\n                icon=\"light/chevron-down.svg\"\n                size=\"medium\"\n                rotationDirection=\"counter-clockwise\"\n                [rotated]=\"_expanded\"\n                class=\"icon\"\n            />\n        }\n        <div class=\"hive-section-header__container\">\n            <ng-template #additionalComponents>\n                <span class=\"hive-section-header-icons\">\n                    <ng-content select=\"hive-icon-component\" />\n                </span>\n                <span class=\"hive-section-header-badge\">\n                    <ng-content select=\"hive-badge\" />\n                </span>\n            </ng-template>\n            @switch (size) {\n                @case ('large') {\n                    <h1 class=\"hive-header-semibold\">\n                        {{ heading }}\n                        <ng-container\n                            *ngTemplateOutlet=\"additionalComponents\"\n                        />\n                    </h1>\n                }\n                @case ('medium') {\n                    <h4 class=\"hive-header-semibold\">\n                        {{ heading }}\n                        <ng-container\n                            *ngTemplateOutlet=\"additionalComponents\"\n                        />\n                    </h4>\n                }\n                @case ('small') {\n                    <h6 class=\"hive-header-semibold\">\n                        {{ heading }}\n                        <ng-container\n                            *ngTemplateOutlet=\"additionalComponents\"\n                        />\n                    </h6>\n                }\n            }\n            <div class=\"hive-section-header-actions\">\n                <ng-content select=\"[slot=hive-actions]\" />\n            </div>\n        </div>\n    </header>\n    <p\n        class=\"hive-section-header-description hive-paragraph-small hive-paragraph-regular\"\n    >\n        {{ description }}\n    </p>\n    <ng-content />\n</hive-collapsable-item>\n", dependencies: [{ kind: "component", type: CollapsableItemComponent, selector: "hive-collapsable-item", inputs: ["disabled", "nonInteractive", "expanded"], outputs: ["expandedChange"] }, { kind: "directive", type: ChevronDirective, selector: "hive-icon-component[hiveChevron]", inputs: ["rotationDirection", "rotated"] }, { kind: "component", type: IconComponent, selector: "hive-icon-component", inputs: ["icon", "size"] }, { kind: "directive", type: NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SectionHeaderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hive-section-header', standalone: true, changeDetection: ChangeDetectionStrategy.OnPush, hostDirectives: [HiveThemedDirective], imports: [
                        CollapsableItemComponent,
                        ChevronDirective,
                        IconComponent,
                        NgTemplateOutlet,
                    ], template: "@if (size === 'large') {\n    <ng-content select=\"hive-breadcrumb\" />\n}\n<hive-collapsable-item\n    [expanded]=\"!collapsable || _expanded\"\n    [nonInteractive]=\"!collapsable\"\n    (expandedChange)=\"handleExpandedChange($event)\"\n>\n    <header class=\"hive-section-header\">\n        @if (collapsable) {\n            <hive-icon-component\n                hiveChevron\n                icon=\"light/chevron-down.svg\"\n                size=\"medium\"\n                rotationDirection=\"counter-clockwise\"\n                [rotated]=\"_expanded\"\n                class=\"icon\"\n            />\n        }\n        <div class=\"hive-section-header__container\">\n            <ng-template #additionalComponents>\n                <span class=\"hive-section-header-icons\">\n                    <ng-content select=\"hive-icon-component\" />\n                </span>\n                <span class=\"hive-section-header-badge\">\n                    <ng-content select=\"hive-badge\" />\n                </span>\n            </ng-template>\n            @switch (size) {\n                @case ('large') {\n                    <h1 class=\"hive-header-semibold\">\n                        {{ heading }}\n                        <ng-container\n                            *ngTemplateOutlet=\"additionalComponents\"\n                        />\n                    </h1>\n                }\n                @case ('medium') {\n                    <h4 class=\"hive-header-semibold\">\n                        {{ heading }}\n                        <ng-container\n                            *ngTemplateOutlet=\"additionalComponents\"\n                        />\n                    </h4>\n                }\n                @case ('small') {\n                    <h6 class=\"hive-header-semibold\">\n                        {{ heading }}\n                        <ng-container\n                            *ngTemplateOutlet=\"additionalComponents\"\n                        />\n                    </h6>\n                }\n            }\n            <div class=\"hive-section-header-actions\">\n                <ng-content select=\"[slot=hive-actions]\" />\n            </div>\n        </div>\n    </header>\n    <p\n        class=\"hive-section-header-description hive-paragraph-small hive-paragraph-regular\"\n    >\n        {{ description }}\n    </p>\n    <ng-content />\n</hive-collapsable-item>\n" }]
        }], propDecorators: { heading: [{
                type: Input,
                args: [{ required: true, transform: stringOrUndefinedAttribute }]
            }], description: [{
                type: Input,
                args: [{ transform: stringOrUndefinedAttribute }]
            }], size: [{
                type: Input,
                args: [{ transform: oneOfSizesOrDefault }]
            }], expanded: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], expandedChange: [{
                type: Output
            }], collapsable: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }] } });

class ToolbarComponent {
    constructor() {
        /**
         * The title of the toolbar
         */
        this.title = '';
        /**
         * Whether to show the separator
         */
        this.showSeparator = true;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ToolbarComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.3.12", type: ToolbarComponent, isStandalone: true, selector: "hive-toolbar", inputs: { title: "title", showSeparator: ["showSeparator", "showSeparator", booleanAttribute] }, host: { properties: { "class.hive-toolbar--separator-visible": "this.showSeparator" } }, ngImport: i0, template: "<div class=\"hive-toolbar-left-container\">\n    <div class=\"hive-toolbar-heading-container\">\n        <h6 class=\"hive-header-semibold\">{{ title }}</h6>\n        @if (showSeparator) {\n            <hive-separator orientation=\"vertical\"></hive-separator>\n        }\n    </div>\n    <div class=\"hive-toolbar-left-content-container\">\n        <ng-content select=\"[slot=left-content]\"></ng-content>\n    </div>\n    <div class=\"hive-toolbar-buttons-container\">\n        <ng-content select=\"hive-button[icon]\"></ng-content>\n        <div class=\"hive-toolbar-search-field-container\">\n            <ng-content select=\"[slot=search]\"></ng-content>\n        </div>\n    </div>\n</div>\n<div class=\"hive-toolbar-right-content-container\">\n    <ng-content select=\"[slot=right-content]\"></ng-content>\n</div>\n", dependencies: [{ kind: "component", type: SeparatorComponent, selector: "hive-separator", inputs: ["orientation"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ToolbarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hive-toolbar', standalone: true, imports: [TextFieldComponent, SeparatorComponent], template: "<div class=\"hive-toolbar-left-container\">\n    <div class=\"hive-toolbar-heading-container\">\n        <h6 class=\"hive-header-semibold\">{{ title }}</h6>\n        @if (showSeparator) {\n            <hive-separator orientation=\"vertical\"></hive-separator>\n        }\n    </div>\n    <div class=\"hive-toolbar-left-content-container\">\n        <ng-content select=\"[slot=left-content]\"></ng-content>\n    </div>\n    <div class=\"hive-toolbar-buttons-container\">\n        <ng-content select=\"hive-button[icon]\"></ng-content>\n        <div class=\"hive-toolbar-search-field-container\">\n            <ng-content select=\"[slot=search]\"></ng-content>\n        </div>\n    </div>\n</div>\n<div class=\"hive-toolbar-right-content-container\">\n    <ng-content select=\"[slot=right-content]\"></ng-content>\n</div>\n" }]
        }], propDecorators: { title: [{
                type: Input
            }], showSeparator: [{
                type: HostBinding,
                args: ['class.hive-toolbar--separator-visible']
            }, {
                type: Input,
                args: [{ transform: booleanAttribute }]
            }] } });

class RootDirective {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: RootDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: RootDirective, isStandalone: true, selector: "[hive-root]", host: { properties: { "class.hive-root": "true" } }, hostDirectives: [{ directive: HiveThemedDirective }], ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: RootDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[hive-root]',
                    standalone: true,
                    hostDirectives: [HiveThemedDirective],
                    host: {
                        '[class.hive-root]': 'true',
                    },
                }]
        }] });

/**
 * @internal
 */
class AutofocusService extends Subject {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AutofocusService, deps: null, target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AutofocusService, providedIn: null }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AutofocusService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: null,
                }]
        }] });

const focusableElementsSelector = `
    button:not([tabindex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden]),
    [href]:not([tabindex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden]),
    input:not([tabindex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden]),
    select:not([tabindex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden]),
    textarea:not([tabindex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden]),
    [tabindex]:not([tabindex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden]),
    [contenteditable]:not([tabindex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])
`;
/**
 * This directive is used to focus an element automatically.
 * It searches for the first focusable element and sets the focus state on it.
 */
class AutofocusDirective {
    constructor(elementRef, autofocusService) {
        this.elementRef = elementRef;
        this.autofocusService = autofocusService;
        /**
         * Whether the element should be focused or not.
         */
        this.hiveAutofocus = true;
        this.focused = false;
    }
    static getFocusableElements(element) {
        const focusableElements = Array.from(element.querySelectorAll(focusableElementsSelector));
        const visibleFocusableElements = new Array();
        for (const focusableElement of focusableElements) {
            if (focusableElement.offsetWidth ||
                focusableElement.offsetHeight ||
                focusableElement.getClientRects().length) {
                visibleFocusableElements.push(focusableElement);
            }
        }
        return visibleFocusableElements;
    }
    ngAfterViewChecked() {
        if (!this.focused) {
            this.focusElement();
        }
    }
    ngAfterContentInit() {
        this.autofocusService?.subscribe(() => {
            this.focusElement();
        });
    }
    focusElement() {
        if (this.hiveAutofocus) {
            const focusableElements = AutofocusDirective.getFocusableElements(this.elementRef.nativeElement);
            if (focusableElements.length === 0) {
                this.elementRef.nativeElement.focus();
            }
            if (focusableElements.length > 0) {
                focusableElements[0].focus();
            }
            this.focused = true;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AutofocusDirective, deps: [{ token: i0.ElementRef }, { token: AutofocusService, optional: true }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "16.1.0", version: "17.3.12", type: AutofocusDirective, isStandalone: true, selector: "[hiveAutofocus]", inputs: { hiveAutofocus: ["hiveAutofocus", "hiveAutofocus", booleanAttribute] }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AutofocusDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[hiveAutofocus]',
                    standalone: true,
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: AutofocusService, decorators: [{
                    type: Optional
                }] }], propDecorators: { hiveAutofocus: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }] } });

/**
 * Directive to trigger a content dialog. Usually used on a button.
 *
 * @example
 *  <button [hiveContentDialogTrigger]="myContentDialog">Open Dialog</button>
 *  <hive-content-dialog #myContentDialog>...</hive-content-dialog>
 */
class ContentDialogTriggerDirective {
    onClick() {
        this.hiveContentDialogTrigger.show();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ContentDialogTriggerDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: ContentDialogTriggerDirective, isStandalone: true, selector: "[hiveContentDialogTrigger]", inputs: { hiveContentDialogTrigger: "hiveContentDialogTrigger" }, host: { listeners: { "click": "onClick()" } }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ContentDialogTriggerDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[hiveContentDialogTrigger]', standalone: true }]
        }], propDecorators: { hiveContentDialogTrigger: [{
                type: Input
            }], onClick: [{
                type: HostListener,
                args: ['click']
            }] } });

var HiveContentDialogCloseSource;
(function (HiveContentDialogCloseSource) {
    HiveContentDialogCloseSource["backdrop"] = "backdrop";
    HiveContentDialogCloseSource["close"] = "close";
    HiveContentDialogCloseSource["escape"] = "escape";
    HiveContentDialogCloseSource["other"] = "other";
})(HiveContentDialogCloseSource || (HiveContentDialogCloseSource = {}));

function transformContentDialogSize(value) {
    return oneOfOrDefault(value, 'medium', 'small', 'medium', 'large');
}
/**
 * The component is used to display focused content or actions within a separate overlay.
 * It is often employed to draw the user's attention to specific information, tasks, or interactions.
 *
 * Content Dialog allows the user to define `header` and `description` in two ways: using inputs and using slots.
 *
 * ## List of slots
 *
 * - `header`: header content of the dialog. If you use this slot, the `header` and `description` using input will not be rendered
 * - `actions-left`: dialog actions on the left side
 * - `actions-right`: dialog actions on the right side
 * - no slot: general content of the dialog
 *
 * @example
 * <hive-content-dialog>
 *     <span slot="header">Header</span>
 *     <span slot="actions-left">Actions Left</span>
 *     <span slot="actions-right">Actions Right</span>
 *     <span>Content</span>
 * </hive-content-dialog>
 *
 * ## Full example:
 *
 * @example
 *  <hive-content-dialog
 *      #dialogComponent
 *      showCloseButton
 *      heading="Heading"
 *      description="Description"
 *      headerInfoMessage="Info Message"
 *  >
 *     <span class="hive-regular">Lorem ipsum dolor sit amet, consectetur adipiscing elit.</span>
 *     <hive-button emphasis="secondary" label="Previous" size="small" slot="actions-left"></hive-button>
 *     <hive-button emphasis="primary" label="Next" size="small" slot="actions-right"></hive-button>
 * </hive-content-dialog>
 *
 * <hive-button [hiveContentDialogTrigger]="dialogComponent" label="Dialog Trigger"></hive-button>
 *
 * Also, you can manipulate the dialog state using the `show()`, `hide()` and `toggle('OPEN' | 'CLOSED')` methods of `ContentDialogComponent`.
 *
 * @example:
 * <hive-content-dialog #dialogComponent></hive-content-dialog>
 * <hive-button emphasis="destructive" label="Close" (click)="dialogComponent.hide()"></hive-button>
 *
 * Or you can use specific Hive directive for that: `[hiveContentDialogTrigger]`
 *
 * @example:
 * <hive-content-dialog #dialogComponent></hive-content-dialog>
 * <hive-button [hiveContentDialogTrigger]="dialogComponent" label="Trigger dialog with header"></hive-button>
 *
 * ## Closing the dialog
 *
 * Dialog can be closed by clicking on the backdrop, pressing the `escape` key or clicking on the close button.
 * - Backdrop click and escape key can be disabled by setting `closeOnBackdropClick` to `false`.
 *   They are both tied to the same input
 * - Close button can be enabled by setting `showCloseButton` to `true`
 */
class ContentDialogComponent {
    constructor() {
        /**
         * Content dialog size. Depending on this property, the dialog will be scale differently (including responsive behavior)
         */
        this.size = 'medium';
        /**
         * Sets the loading state of the dialog.
         * It will disable any dialog actions (click on the backdrop, escape key, close button) while the dialog is loading.
         */
        this.isLoading = false;
        /**
         * Emits an event when the dialog is closed.
         */
        this.contentDialogClose = new EventEmitter();
        /**
         * Whether the dialog should have a close button.
         * @param value
         */
        this.showCloseButton = false;
        /**
         * Removes content padding
         * @internal
         */
        this.noPadding = false;
        /**
         * Whether the dialog should be closed when the backdrop is clicked.
         * @param value
         */
        this.closeOnBackdropClick = false;
        this._state = 'closed';
        this.overlay = inject(Overlay);
        this.theming$ = inject(HIVE_THEMING);
        this.destroyRef = inject(DestroyRef);
        this.isString = isString;
        this.autofocusService = inject(AutofocusService);
        this.lastTheme = this.theming$.value;
    }
    get sizeClass() {
        return `hive-content-dialog-window--${this.size}`;
    }
    get isOpen() {
        return this._state === 'open';
    }
    get hasHeading() {
        return !!(this.heading ??
            this.headerInfoMessage ??
            this.description);
    }
    /**
     * This method allows you to set the state of the dialog to open or closed manually.
     */
    show() {
        this.toggle('open');
        this.autofocusService.next();
    }
    /**
     * This method allows you to set the state of the dialog to open or closed manually.
     */
    hide(closeSource) {
        this.toggle('closed', closeSource);
    }
    /**
     * This method allows you to toggle the state of the dialog. If the dialog is open, it will close it and vice versa.
     * If you pass a state, it will set the dialog to that state.
     * @param state
     * @param closeSource
     */
    toggle(state, closeSource) {
        if (this.isLoading) {
            return;
        }
        const stateChange = state !== this._state;
        this._state = state ?? (this.isOpen ? 'closed' : 'open');
        if (!stateChange) {
            return;
        }
        switch (this._state) {
            case 'closed':
                this.contentDialogClose.emit(closeSource ?? HiveContentDialogCloseSource.other);
                this.overlayRef?.detach();
                break;
            case 'open':
                this.createOverlayRef();
                break;
            default:
                break;
        }
    }
    handleEscape() {
        if (this.closeOnBackdropClick) {
            this.hide(HiveContentDialogCloseSource.escape);
        }
    }
    handleClick() {
        this.hide(HiveContentDialogCloseSource.close);
    }
    createOverlayRef() {
        const theming = this.theming$.getValue();
        this.lastTheme = theming;
        const panelClass = ['hive-content-dialog', 'hive-root', `hive-theme-${theming}`];
        const backdropClass = ['hive-content-dialog-backdrop', `hive-theme-${theming}`];
        const positionStrategy = this.overlay
            .position()
            .global()
            .centerHorizontally()
            .centerVertically();
        const scrollStrategy = this.overlay.scrollStrategies.block();
        const config = {
            hasBackdrop: true,
            backdropClass,
            panelClass,
            positionStrategy,
            scrollStrategy,
        };
        this.overlayRef = this.overlay.create(config);
        this.theming$
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((theme) => {
            this.overlayRef?.addPanelClass(`hive-theme-${theme}`);
            this.overlayRef?.backdropElement?.classList.add(`hive-theme-${theme}`);
            this.overlayRef?.removePanelClass(`hive-theme-${this.lastTheme}`);
            this.overlayRef?.backdropElement?.classList.remove(`hive-theme-${this.lastTheme}`);
            this.lastTheme = theme;
        });
        this.overlayRef
            .outsidePointerEvents()
            .pipe(takeUntilDestroyed(this.destroyRef), filter(() => this.closeOnBackdropClick))
            .subscribe(() => {
            this.hide(HiveContentDialogCloseSource.backdrop);
        });
        this.overlayRef.attach(this.portal);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ContentDialogComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.3.12", type: ContentDialogComponent, isStandalone: true, selector: "hive-content-dialog", inputs: { heading: ["heading", "heading", stringOrUndefinedAttribute], description: ["description", "description", stringOrUndefinedAttribute], headerInfoMessage: "headerInfoMessage", size: ["size", "size", transformContentDialogSize], isLoading: ["isLoading", "isLoading", booleanAttribute], showCloseButton: ["showCloseButton", "showCloseButton", booleanAttribute], noPadding: ["noPadding", "noPadding", booleanAttribute], closeOnBackdropClick: ["closeOnBackdropClick", "closeOnBackdropClick", booleanAttribute] }, outputs: { contentDialogClose: "contentDialogClose" }, host: { listeners: { "document:keydown.escape": "handleEscape()" } }, providers: [AutofocusService], viewQueries: [{ propertyName: "portal", first: true, predicate: CdkPortal, descendants: true, static: true }, { propertyName: "contentDialogRef", first: true, predicate: ["contentDialogRef"], descendants: true }], ngImport: i0, template: "<ng-template cdkPortal>\n    <div\n        [ngClass]=\"sizeClass\"\n        class=\"hive-content-dialog-window\"\n        [class.hive-content-dialog-window--no-padding]=\"noPadding\"\n    >\n        @if (showCloseButton) {\n            <hive-button\n                class=\"hive-content-dialog-window__close\"\n                data-role=\"content-dialog-close-button\"\n                emphasis=\"tertiary\"\n                icon=\"light/xmark.svg\"\n                (click)=\"handleClick()\"\n                [disabled]=\"isLoading\"\n            />\n        }\n        <div class=\"hive-content-dialog-window__heading--projected-content\">\n            <ng-content select=\"[slot=heading]\" />\n        </div>\n        @if (hasHeading) {\n            <div class=\"hive-content-dialog-window__heading---default-content\">\n                @if (heading ?? headerInfoMessage) {\n                    <h6\n                        class=\"hive-content-dialog-window__heading-title hive-header-semibold\"\n                    >\n                        {{ heading }}\n                        @if (headerInfoMessage) {\n                            <hive-info-icon\n                                hiveTooltip\n                                [hiveTooltipDescription]=\"\n                                    isString(headerInfoMessage)\n                                        ? headerInfoMessage\n                                        : null\n                                \"\n                                [hiveTooltipCustomContentTemplateRef]=\"\n                                    !isString(headerInfoMessage)\n                                        ? headerInfoMessage\n                                        : null\n                                \"\n                            />\n                        }\n                    </h6>\n                }\n                @if (description) {\n                    <div\n                        class=\"hive-content-dialog-window__heading-description hive-regular\"\n                    >\n                        {{ description }}\n                    </div>\n                }\n            </div>\n        }\n        <div class=\"hive-content-dialog-window__content\">\n            <ng-content />\n        </div>\n        <div class=\"hive-content-dialog-window__actions\">\n            <div class=\"hive-content-dialog-window__actions-left\">\n                <ng-content select=\"[slot=actions-left]\" />\n            </div>\n\n            <div class=\"hive-content-dialog-window__actions-right\">\n                <ng-content select=\"[slot=actions-right]\" />\n            </div>\n        </div>\n    </div>\n</ng-template>\n", dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i2$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "ngmodule", type: PortalModule }, { kind: "directive", type: i2$2.CdkPortal, selector: "[cdkPortal]", exportAs: ["cdkPortal"] }, { kind: "component", type: ButtonComponent, selector: "hive-button", inputs: ["type", "menuButtonActive", "hasMenuButtonCaret", "label", "accessibleName", "icon", "iconPosition", "emphasis", "title", "size", "isLoading", "disabled", "rounded", "width"] }, { kind: "component", type: InfoIconComponent, selector: "hive-info-icon", inputs: ["helpInfoIcon"] }, { kind: "directive", type: TooltipDirective, selector: "[hiveTooltip]", inputs: ["hiveTooltipHeading", "hiveTooltipDescription", "hiveTooltipCustomContentTemplateRef", "hiveTooltipCustomContentContext", "disableTooltip", "hiveTooltipPosition", "hideDelay", "showDelay", "windowClass"], outputs: ["tooltipWindowHovered"] }, { kind: "ngmodule", type: ObserversModule }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ContentDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hive-content-dialog', standalone: true, imports: [
                        CommonModule,
                        PortalModule,
                        ButtonComponent,
                        InfoIconComponent,
                        TooltipDirective,
                        ObserversModule,
                    ], changeDetection: ChangeDetectionStrategy.OnPush, providers: [AutofocusService], template: "<ng-template cdkPortal>\n    <div\n        [ngClass]=\"sizeClass\"\n        class=\"hive-content-dialog-window\"\n        [class.hive-content-dialog-window--no-padding]=\"noPadding\"\n    >\n        @if (showCloseButton) {\n            <hive-button\n                class=\"hive-content-dialog-window__close\"\n                data-role=\"content-dialog-close-button\"\n                emphasis=\"tertiary\"\n                icon=\"light/xmark.svg\"\n                (click)=\"handleClick()\"\n                [disabled]=\"isLoading\"\n            />\n        }\n        <div class=\"hive-content-dialog-window__heading--projected-content\">\n            <ng-content select=\"[slot=heading]\" />\n        </div>\n        @if (hasHeading) {\n            <div class=\"hive-content-dialog-window__heading---default-content\">\n                @if (heading ?? headerInfoMessage) {\n                    <h6\n                        class=\"hive-content-dialog-window__heading-title hive-header-semibold\"\n                    >\n                        {{ heading }}\n                        @if (headerInfoMessage) {\n                            <hive-info-icon\n                                hiveTooltip\n                                [hiveTooltipDescription]=\"\n                                    isString(headerInfoMessage)\n                                        ? headerInfoMessage\n                                        : null\n                                \"\n                                [hiveTooltipCustomContentTemplateRef]=\"\n                                    !isString(headerInfoMessage)\n                                        ? headerInfoMessage\n                                        : null\n                                \"\n                            />\n                        }\n                    </h6>\n                }\n                @if (description) {\n                    <div\n                        class=\"hive-content-dialog-window__heading-description hive-regular\"\n                    >\n                        {{ description }}\n                    </div>\n                }\n            </div>\n        }\n        <div class=\"hive-content-dialog-window__content\">\n            <ng-content />\n        </div>\n        <div class=\"hive-content-dialog-window__actions\">\n            <div class=\"hive-content-dialog-window__actions-left\">\n                <ng-content select=\"[slot=actions-left]\" />\n            </div>\n\n            <div class=\"hive-content-dialog-window__actions-right\">\n                <ng-content select=\"[slot=actions-right]\" />\n            </div>\n        </div>\n    </div>\n</ng-template>\n" }]
        }], propDecorators: { heading: [{
                type: Input,
                args: [{ transform: stringOrUndefinedAttribute }]
            }], description: [{
                type: Input,
                args: [{ transform: stringOrUndefinedAttribute }]
            }], headerInfoMessage: [{
                type: Input
            }], size: [{
                type: Input,
                args: [{ transform: transformContentDialogSize }]
            }], isLoading: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], contentDialogClose: [{
                type: Output
            }], showCloseButton: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], noPadding: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], closeOnBackdropClick: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], portal: [{
                type: ViewChild,
                args: [CdkPortal, { static: true }]
            }], contentDialogRef: [{
                type: ViewChild,
                args: ['contentDialogRef']
            }], handleEscape: [{
                type: HostListener,
                args: ['document:keydown.escape']
            }] } });

/**
 * To get rid of control flow, we can use a map instead of a switch statement.
 */
const ConfirmationDialogEmphasisToButtonEmphasisMap = {
    destructive: 'destructive',
    info: 'primary',
    success: 'primary',
};

function confirmationDialogEmphasis(value) {
    return oneOfOrDefault(value, 'destructive', 'info', 'success', 'warning', 'destructive');
}
/**
 * The Confirmation Dialog is a predefined variant of the Content Dialog component, designed to ensure consistency and simplicity in gathering user confirmation for specific actions.
 *
 * ## Usage
 *
 * The confirmation dialog is a standalone component that can be used anywhere in your application.
 *
 * @example
 *  <hive-button (click)="confirmationDialog.show()">Show Confirmation Dialog</hive-button>
 * <hive-confirmation-dialog
 *    heading="Confirmation Dialog Title"
 *    description="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt"
 *    emphasis="destructive"
 *    (confirm)="confirm()"
 *    (cancel)="cancel()"
 *    #confirmationDialog
 * >
 * </hive-confirmation-dialog>
 *
 * ## Projecting Content
 *
 * You can project content custom content into the confirmation dialog if you aren't satisfied with the default layout.
 *
 * @example
 *  <hive-button (click)="confirmationDialog.show()">Show Confirmation Dialog</hive-button>
 * <hive-confirmation-dialog #confirmationDialog>
 *      <h2>Projecting Content</h2>
 * </hive-confirmation-dialog>
 */
class ConfirmationDialogComponent {
    constructor() {
        /**
         * Provides the ability to autofocus on the confirm or cancel button when the dialog is shown.
         */
        this.autofocus = 'none';
        /**
         * The emphasis of the dialog.
         * @default 'destructive'
         */
        this.emphasis = 'destructive';
        /**
         * The label of the primary action button.
         * @default 'Confirm'
         */
        this.primaryActionLabel = 'Confirm';
        /**
         * The label of the secondary action button.
         * @default 'No, Take Me Back'
         */
        this.secondaryActionLabel = 'No, Take Me Back';
        /**
         * Whether secondary action button will be hidden.
         * @default false
         */
        this.secondaryActionHidden = false;
        /**
         * Whether primary action button will be hidden.
         * @default false
         */
        this.primaryActionHidden = false;
        /**
         * Emits when the primary action button is clicked.
         */
        this.confirm = new EventEmitter();
        /**
         * Emits when the secondary action button is clicked.
         */
        this.cancel = new EventEmitter();
        /**
         * Whether the dialog is in a loading state.
         * This will disable the confirm and cancel buttons and show a loading spinner on the confirm button.
         */
        this.isLoading = false;
        this.autofocusService = inject(AutofocusService);
    }
    get primaryActionEmphasis() {
        return ConfirmationDialogEmphasisToButtonEmphasisMap[this.emphasis];
    }
    /**
     * Shows the dialog.
     */
    show() {
        this.contentDialog.show();
        this.autofocusService.next();
    }
    /**
     * Hides the dialog.
     */
    hide() {
        this.contentDialog.hide();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ConfirmationDialogComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.3.12", type: ConfirmationDialogComponent, isStandalone: true, selector: "hive-confirmation-dialog", inputs: { autofocus: "autofocus", emphasis: ["emphasis", "emphasis", confirmationDialogEmphasis], heading: ["heading", "heading", stringOrUndefinedAttribute], description: ["description", "description", stringOrUndefinedAttribute], icon: ["icon", "icon", stringOrUndefinedAttribute], primaryActionLabel: ["primaryActionLabel", "primaryActionLabel", stringOrUndefinedAttribute], secondaryActionLabel: ["secondaryActionLabel", "secondaryActionLabel", stringOrUndefinedAttribute], secondaryActionHidden: ["secondaryActionHidden", "secondaryActionHidden", booleanAttribute], primaryActionHidden: ["primaryActionHidden", "primaryActionHidden", booleanAttribute], isLoading: ["isLoading", "isLoading", booleanAttribute] }, outputs: { confirm: "confirm", cancel: "cancel" }, providers: [AutofocusService], viewQueries: [{ propertyName: "contentDialog", first: true, predicate: ContentDialogComponent, descendants: true, static: true }], ngImport: i0, template: "<hive-content-dialog noPadding size=\"small\">\n    <div class=\"hive-confirmation-dialog\">\n        <div\n            class=\"hive-confirmation-dialog__body hive-confirmation-dialog__body--projected\"\n            data-testid=\"hive-confirmation-dialog__body--projected\"\n        >\n            <ng-content></ng-content>\n        </div>\n\n        <div\n            class=\"hive-confirmation-dialog__body\"\n            data-testid=\"hive-confirmation-dialog__body\"\n        >\n            @if (!icon) {\n                <div\n                    [ngClass]=\"{\n                        'hive-confirmation-dialog__body-icon--destructive':\n                            emphasis === 'destructive',\n                        'hive-confirmation-dialog__body-icon--info':\n                            emphasis === 'info',\n                        'hive-confirmation-dialog__body-icon--success':\n                            emphasis === 'success',\n                    }\"\n                    class=\"hive-confirmation-dialog__body-icon\"\n                >\n                    @switch (emphasis) {\n                        @case ('destructive') {\n                            <hive-icon-component\n                                icon=\"light/triangle-exclamation.svg\"\n                                size=\"large\"\n                            />\n                        }\n                        @case ('info') {\n                            <hive-icon-component\n                                icon=\"light/circle-info.svg\"\n                                size=\"large\"\n                            />\n                        }\n                        @case ('success') {\n                            <hive-icon-component\n                                icon=\"light/circle-check.svg\"\n                                size=\"large\"\n                            />\n                        }\n                    }\n                </div>\n            }\n\n            @if (icon) {\n                <div\n                    class=\"hive-confirmation-dialog__body-icon\"\n                    [ngClass]=\"{\n                        'hive-confirmation-dialog__body-icon--destructive':\n                            emphasis === 'destructive',\n                        'hive-confirmation-dialog__body-icon--info':\n                            emphasis === 'info',\n                    }\"\n                >\n                    <hive-icon-component\n                        [icon]=\"icon\"\n                        size=\"x-large\"\n                    ></hive-icon-component>\n                </div>\n            }\n\n            <div class=\"hive-confirmation-dialog__text-content\">\n                @if (heading) {\n                    <h6 class=\"hive-header-semibold\">\n                        {{ heading }}\n                    </h6>\n                }\n\n                @if (description) {\n                    <p class=\"hive-paragraph-small hive-paragraph-regular\">\n                        {{ description }}\n                    </p>\n                }\n            </div>\n        </div>\n\n        <div class=\"hive-confirmation-dialog__buttons\" slot=\"actions\">\n            @if (!secondaryActionHidden) {\n                <hive-button\n                    (click)=\"cancel.emit()\"\n                    [label]=\"secondaryActionLabel\"\n                    [hiveAutofocus]=\"autofocus === 'cancel'\"\n                    [disabled]=\"isLoading\"\n                    type=\"button\"\n                    data-testid=\"hive-confirmation-dialog__cancel-button\"\n                    emphasis=\"secondary\"\n                />\n            }\n            @if (!primaryActionHidden) {\n                <hive-button\n                    (click)=\"confirm.emit()\"\n                    [emphasis]=\"primaryActionEmphasis\"\n                    [label]=\"primaryActionLabel\"\n                    [hiveAutofocus]=\"autofocus === 'confirm'\"\n                    [isLoading]=\"isLoading\"\n                    type=\"submit\"\n                    data-testid=\"hive-confirmation-dialog__confirm-button\"\n                    emphasis=\"primary\"\n                />\n            }\n\n        </div>\n    </div>\n</hive-content-dialog>\n", dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i2$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "component", type: ContentDialogComponent, selector: "hive-content-dialog", inputs: ["heading", "description", "headerInfoMessage", "size", "isLoading", "showCloseButton", "noPadding", "closeOnBackdropClick"], outputs: ["contentDialogClose"] }, { kind: "component", type: ButtonComponent, selector: "hive-button", inputs: ["type", "menuButtonActive", "hasMenuButtonCaret", "label", "accessibleName", "icon", "iconPosition", "emphasis", "title", "size", "isLoading", "disabled", "rounded", "width"] }, { kind: "component", type: IconComponent, selector: "hive-icon-component", inputs: ["icon", "size"] }, { kind: "directive", type: AutofocusDirective, selector: "[hiveAutofocus]", inputs: ["hiveAutofocus"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ConfirmationDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hive-confirmation-dialog', standalone: true, imports: [
                        CommonModule,
                        ContentDialogComponent,
                        ButtonComponent,
                        IconComponent,
                        AutofocusDirective,
                        ContentDialogComponent,
                    ], providers: [AutofocusService], template: "<hive-content-dialog noPadding size=\"small\">\n    <div class=\"hive-confirmation-dialog\">\n        <div\n            class=\"hive-confirmation-dialog__body hive-confirmation-dialog__body--projected\"\n            data-testid=\"hive-confirmation-dialog__body--projected\"\n        >\n            <ng-content></ng-content>\n        </div>\n\n        <div\n            class=\"hive-confirmation-dialog__body\"\n            data-testid=\"hive-confirmation-dialog__body\"\n        >\n            @if (!icon) {\n                <div\n                    [ngClass]=\"{\n                        'hive-confirmation-dialog__body-icon--destructive':\n                            emphasis === 'destructive',\n                        'hive-confirmation-dialog__body-icon--info':\n                            emphasis === 'info',\n                        'hive-confirmation-dialog__body-icon--success':\n                            emphasis === 'success',\n                    }\"\n                    class=\"hive-confirmation-dialog__body-icon\"\n                >\n                    @switch (emphasis) {\n                        @case ('destructive') {\n                            <hive-icon-component\n                                icon=\"light/triangle-exclamation.svg\"\n                                size=\"large\"\n                            />\n                        }\n                        @case ('info') {\n                            <hive-icon-component\n                                icon=\"light/circle-info.svg\"\n                                size=\"large\"\n                            />\n                        }\n                        @case ('success') {\n                            <hive-icon-component\n                                icon=\"light/circle-check.svg\"\n                                size=\"large\"\n                            />\n                        }\n                    }\n                </div>\n            }\n\n            @if (icon) {\n                <div\n                    class=\"hive-confirmation-dialog__body-icon\"\n                    [ngClass]=\"{\n                        'hive-confirmation-dialog__body-icon--destructive':\n                            emphasis === 'destructive',\n                        'hive-confirmation-dialog__body-icon--info':\n                            emphasis === 'info',\n                    }\"\n                >\n                    <hive-icon-component\n                        [icon]=\"icon\"\n                        size=\"x-large\"\n                    ></hive-icon-component>\n                </div>\n            }\n\n            <div class=\"hive-confirmation-dialog__text-content\">\n                @if (heading) {\n                    <h6 class=\"hive-header-semibold\">\n                        {{ heading }}\n                    </h6>\n                }\n\n                @if (description) {\n                    <p class=\"hive-paragraph-small hive-paragraph-regular\">\n                        {{ description }}\n                    </p>\n                }\n            </div>\n        </div>\n\n        <div class=\"hive-confirmation-dialog__buttons\" slot=\"actions\">\n            @if (!secondaryActionHidden) {\n                <hive-button\n                    (click)=\"cancel.emit()\"\n                    [label]=\"secondaryActionLabel\"\n                    [hiveAutofocus]=\"autofocus === 'cancel'\"\n                    [disabled]=\"isLoading\"\n                    type=\"button\"\n                    data-testid=\"hive-confirmation-dialog__cancel-button\"\n                    emphasis=\"secondary\"\n                />\n            }\n            @if (!primaryActionHidden) {\n                <hive-button\n                    (click)=\"confirm.emit()\"\n                    [emphasis]=\"primaryActionEmphasis\"\n                    [label]=\"primaryActionLabel\"\n                    [hiveAutofocus]=\"autofocus === 'confirm'\"\n                    [isLoading]=\"isLoading\"\n                    type=\"submit\"\n                    data-testid=\"hive-confirmation-dialog__confirm-button\"\n                    emphasis=\"primary\"\n                />\n            }\n\n        </div>\n    </div>\n</hive-content-dialog>\n" }]
        }], propDecorators: { autofocus: [{
                type: Input
            }], emphasis: [{
                type: Input,
                args: [{ transform: confirmationDialogEmphasis }]
            }], heading: [{
                type: Input,
                args: [{ transform: stringOrUndefinedAttribute }]
            }], description: [{
                type: Input,
                args: [{ transform: stringOrUndefinedAttribute }]
            }], icon: [{
                type: Input,
                args: [{ transform: stringOrUndefinedAttribute }]
            }], primaryActionLabel: [{
                type: Input,
                args: [{ transform: stringOrUndefinedAttribute }]
            }], secondaryActionLabel: [{
                type: Input,
                args: [{ transform: stringOrUndefinedAttribute }]
            }], secondaryActionHidden: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], primaryActionHidden: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], confirm: [{
                type: Output
            }], cancel: [{
                type: Output
            }], isLoading: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], contentDialog: [{
                type: ViewChild,
                args: [ContentDialogComponent, { static: true }]
            }] } });

const MAX_VALUE_LENGTH = 5;
/**
 * The Statistic Card component is a fundamental element used to display statistical information or key metrics in a visually appealing and structured manner.
 *
 * @example Emphasis enabled
 * <hive-statistic-card heading="Total Capacity" value="1.2 PB" icon="capacity.svg" emphasis/>
 *
 * @example Emphasis controlled by input
 * <hive-statistic-card heading="Total Capacity" value="1.2 PB" icon="capacity.svg" [emphasis]="emphasis"/>
 *
 * @example Without emphasis
 * <hive-statistic-card heading="Total Capacity" value="1.2 PB"/>
 *
 * @example Without value
 * <hive-statistic-card heading="Total Capacity"/>
 *
 * @example Disabled
 * <hive-statistic-card heading="Total Capacity" disabled/>
 *
 * @example Selected
 * <hive-statistic-card heading="Total Capacity" value="1.2 PB" icon="capacity.svg" [emphasis]="emphasis" [disabled]="disabled" [ngModel]="true"/>
 */
class StatisticCardComponent {
    constructor() {
        /**
         * If enabled - changes the color of value.
         */
        this.emphasis = false;
        /**
         * Disables the component.
         */
        this.disabled = false;
        /**
         * Read-only state of the component.
         */
        this.readOnly = false;
        this.checked = false;
        this.hasValueTruncation = true;
        this.valueToDisplay = '';
        this.iconFits = true;
        this.changeDetectorRef = inject(ChangeDetectorRef);
        /**
         * @internal
         */
        this.onChange = () => { };
        /**
         * @internal
         */
        this.onTouch = () => { };
    }
    /**
     * @internal
     */
    registerOnChange(fn) {
        this.onChange = fn;
    }
    /**
     * @internal
     */
    registerOnTouched(fn) {
        this.onTouch = fn;
    }
    /**
     * @internal
     */
    writeValue(checked) {
        this.checked = checked;
        this.changeDetectorRef.detectChanges();
    }
    ngOnChanges(changes) {
        if (changes['value']) {
            this.updateHasValueTruncation();
            this.updateValueToDisplay();
            this.updateIconFits();
        }
    }
    onModelChange(e) {
        if ([this.disabled, this.readOnly].some((x) => x)) {
            return;
        }
        this.checked = e;
        this.onChange(e);
    }
    updateValueToDisplay() {
        if (this.value) {
            this.valueToDisplay = this.hasValueTruncation
                ? `${this.value.slice(0, MAX_VALUE_LENGTH)}…`
                : this.value;
        }
        else {
            this.valueToDisplay = '-';
        }
    }
    updateHasValueTruncation() {
        this.hasValueTruncation = this.value
            ? this.value?.length > MAX_VALUE_LENGTH
            : false;
    }
    updateIconFits() {
        this.iconFits = this.value
            ? this.value.length < MAX_VALUE_LENGTH
            : true;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: StatisticCardComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.3.12", type: StatisticCardComponent, isStandalone: true, selector: "hive-statistic-card", inputs: { heading: ["heading", "heading", stringOrUndefinedAttribute], value: ["value", "value", stringAttribute], icon: ["icon", "icon", stringOrUndefinedAttribute], emphasis: ["emphasis", "emphasis", booleanAttribute], disabled: ["disabled", "disabled", booleanAttribute], readOnly: ["readOnly", "readOnly", booleanAttribute] }, providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => StatisticCardComponent),
                multi: true,
            },
        ], usesOnChanges: true, hostDirectives: [{ directive: HiveThemedDirective }], ngImport: i0, template: "<div\n    (click)=\"onModelChange(!checked)\"\n    (keydown.enter)=\"onModelChange(!checked)\"\n    [attr.tabindex]=\"disabled ? null : 0\"\n    [ngClass]=\"{\n        'hive-statistic-card--empty-heading': !heading,\n        'hive-statistic-card--emphasis': emphasis,\n        'hive-statistic-card--disabled': disabled,\n        'hive-statistic-card--readonly': readOnly,\n        'hive-statistic-card--checked': checked,\n    }\"\n    class=\"hive-statistic-card\"\n>\n    <div class=\"hive-statistic-card__container\">\n        <div class=\"hive-statistic-card__container__metric\">\n            @if (heading | isDefined) {\n                <hive-label\n                    class=\"hive-statistic-card__heading\"\n                    size=\"small\"\n                    weight=\"regular\"\n                    [label]=\"heading\"\n                />\n            }\n\n            <div\n                class=\"hive-statistic-card__value\"\n                [class.hive-statistic-card__value--disabled]=\"disabled\"\n                [class.hive-statistic-card__value--empty]=\"!value\"\n                [class.hive-statistic-card__value--emphasis]=\"emphasis\"\n                [attr.title]=\"hasValueTruncation ? value : null\"\n            >\n                {{ valueToDisplay }}\n            </div>\n        </div>\n\n        @if (iconFits && !!heading) {\n            @if (icon | isDefined) {\n                <div class=\"hive-statistic-card__icon-container\">\n                    <hive-icon-component\n                        class=\"hive-statistic-card__icon\"\n                        size=\"2x-large\"\n                        [icon]=\"icon\"\n                    />\n                </div>\n            }\n        }\n    </div>\n</div>\n", dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i2$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "component", type: IconComponent, selector: "hive-icon-component", inputs: ["icon", "size"] }, { kind: "pipe", type: IsDefinedPipe, name: "isDefined" }, { kind: "component", type: LabelComponent, selector: "hive-label", inputs: ["label", "for", "size", "weight", "maxWeight", "horizontalAlignment", "leftIconHelpInfoMessage", "rightIconHelpInfoMessage", "leftIcon", "rightIcon", "required", "textOverflowEllipsis"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: StatisticCardComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hive-statistic-card', standalone: true, changeDetection: ChangeDetectionStrategy.OnPush, providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => StatisticCardComponent),
                            multi: true,
                        },
                    ], imports: [CommonModule, IconComponent, IsDefinedPipe, LabelComponent], hostDirectives: [HiveThemedDirective], template: "<div\n    (click)=\"onModelChange(!checked)\"\n    (keydown.enter)=\"onModelChange(!checked)\"\n    [attr.tabindex]=\"disabled ? null : 0\"\n    [ngClass]=\"{\n        'hive-statistic-card--empty-heading': !heading,\n        'hive-statistic-card--emphasis': emphasis,\n        'hive-statistic-card--disabled': disabled,\n        'hive-statistic-card--readonly': readOnly,\n        'hive-statistic-card--checked': checked,\n    }\"\n    class=\"hive-statistic-card\"\n>\n    <div class=\"hive-statistic-card__container\">\n        <div class=\"hive-statistic-card__container__metric\">\n            @if (heading | isDefined) {\n                <hive-label\n                    class=\"hive-statistic-card__heading\"\n                    size=\"small\"\n                    weight=\"regular\"\n                    [label]=\"heading\"\n                />\n            }\n\n            <div\n                class=\"hive-statistic-card__value\"\n                [class.hive-statistic-card__value--disabled]=\"disabled\"\n                [class.hive-statistic-card__value--empty]=\"!value\"\n                [class.hive-statistic-card__value--emphasis]=\"emphasis\"\n                [attr.title]=\"hasValueTruncation ? value : null\"\n            >\n                {{ valueToDisplay }}\n            </div>\n        </div>\n\n        @if (iconFits && !!heading) {\n            @if (icon | isDefined) {\n                <div class=\"hive-statistic-card__icon-container\">\n                    <hive-icon-component\n                        class=\"hive-statistic-card__icon\"\n                        size=\"2x-large\"\n                        [icon]=\"icon\"\n                    />\n                </div>\n            }\n        }\n    </div>\n</div>\n" }]
        }], propDecorators: { heading: [{
                type: Input,
                args: [{ transform: stringOrUndefinedAttribute }]
            }], value: [{
                type: Input,
                args: [{ transform: stringAttribute }]
            }], icon: [{
                type: Input,
                args: [{ transform: stringOrUndefinedAttribute }]
            }], emphasis: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], disabled: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], readOnly: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }] } });

/**
 * Ease-in appearance animation for Toast.
 * This motion provides a smooth and visually appealing transition when the element appears on the screen.
 */
const slideInOut = trigger('slideInOut', [
    state('open', style({
        transform: 'translateY(0)',
        opacity: 1,
    })),
    state('*', style({
        transform: 'translateY(-10%)',
        opacity: 0,
    })),
    transition('* => open', animate('200ms ease-in')),
    transition('open => *', animate('200ms ease-out')),
]);

/**
 * The Toast component is used to display brief messages about app processes at the bottom of the screen. It provides users with immediate feedback based on their previous actions.
 *
 * ### Position and motion
 * The Toast component centered at the bottom of the screen and have a pop-up ease-in motion. This motion provides a smooth and visually appealing transition when the Toast appears on the screen.
 *
 * ### Automatic dismissal
 * To avoid cluttering the user interface, the Toast automatically disappear after 5 seconds (default) to provide users with enough time to read the message before it disappears.
 * Stop dismissal countdown on hover to keep Toast message visible.
 *
 * To render toast use ToastService.
 *
 * @example
 *  ```
 *
 *  import { ToastService, ToastModule } from '@pure/hive';
 *
 *  @NgModule({
 *      imports: [
 *          // import toast module
 *          ToastModule,
 *      ],
 *  })
 *  export class AppModule {
 *  }
 *
 *  @Component({
 *      selector: 'literally-any-component',
 *      template: `<button (click)="addToast()">Add toast</button>`,
 *  })
 *  export class LiterallyAnyComponent {
 *      // 2. inject toast service
 *      constructor(private readonly toastService: ToastService) {
 *          // 3. Use it like here
 *          this.toastService.addToast({heading: 'Title', message: 'Message', severity: 'info'});
 *      }
 *  }
 *
 * ```
 *
 */
class ToastComponent {
    constructor(changeDetectorRef) {
        this.changeDetectorRef = changeDetectorRef;
        /**
         * Toast severity.
         */
        this.severity = 'default';
        /**
         * Emits when toast is ready to be removed from DOM.
         * Notifies `ToastService` to remove toast from the list of toasts and from DOM.
         * @internal
         */
        this.readyToBeRemovedFromDOM = new Subject();
        /**
         * Emits `true` if pointer is over the toast and `false` otherwise.
         * Used for closing toast after 5 seconds if pointer is not over it.
         * @internal
         */
        this.pointerOver = new BehaviorSubject(false);
        /**
         * State used for animation of closing/opening.
         */
        this.toastState = 'open';
        this.ICON = {
            major: 'light/triangle-exclamation.svg',
            default: null,
        };
    }
    ngOnDestroy() {
        /**
         * We need to complete internal observable like pointerOver and readyToBeRemovedFromDOM
         * to avoid memory leaks.
         */
        this.pointerOver.complete();
        this.readyToBeRemovedFromDOM.complete();
    }
    /**
     * Closes the toast with animation of closing.
     * When animation is finished, handleTransitionEnd callback will be called to remove toast from DOM.
     * @internal
     */
    _closeToastWithAnimation() {
        this.toastState = 'closed';
        this.changeDetectorRef.detectChanges();
    }
    /**
     * Emits `true` to pointerOver if pointer is over the toast.
     */
    handleMouseEnter() {
        this.pointerOver.next(true);
    }
    /**
     * Emits `false` to pointerOver if pointer is out of the toast.
     */
    handleMouseLeave() {
        this.pointerOver.next(false);
    }
    /**
     * Animation callback.
     * This callback triggers event to remove toast from DOM.
     * @param toState
     */
    handleTransitionEnd({ toState }) {
        if (toState === 'closed') {
            this.readyToBeRemovedFromDOM.next();
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ToastComponent, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.3.12", type: ToastComponent, selector: "hive-toast", inputs: { severity: "severity", heading: "heading", message: "message" }, outputs: { readyToBeRemovedFromDOM: "readyToBeRemovedFromDOM", pointerOver: "pointerOver" }, host: { listeners: { "pointerenter": "handleMouseEnter()", "pointerleave": "handleMouseLeave()" } }, hostDirectives: [{ directive: HiveThemedDirective }], ngImport: i0, template: "<div\n    (@slideInOut.done)=\"handleTransitionEnd($event)\"\n    [@slideInOut]=\"toastState\"\n    [ngClass]=\"'hive-toast--' + severity\"\n    class=\"hive-toast\"\n    [hiveInvertedColors]=\"true\"\n>\n    <div\n        class=\"hive-toast__container\"\n        [class.hive-toast__container--single-text-group]=\"!heading || !message\"\n    >\n        @if (ICON[severity ?? 'default']; as icon) {\n            <hive-icon-component\n                class=\"hive-toast__icon\"\n                [icon]=\"icon\"\n                size=\"medium\"\n            ></hive-icon-component>\n        }\n\n        <div class=\"hive-toast__content\">\n            <div class=\"hive-toast__text-content\">\n                @if (heading) {\n                    <hive-label\n                        [label]=\"heading\"\n                        class=\"hive-toast__title\"\n                        size=\"medium\"\n                        weight=\"semibold\"\n                    ></hive-label>\n                }\n\n                @if (message) {\n                    <p\n                        class=\"hive-toast__message hive-paragraph-small hive-paragraph-regular\"\n                    >\n                        {{ message }}\n                    </p>\n                }\n            </div>\n\n            <hive-button\n                class=\"hive-toast__close_button\"\n                emphasis=\"tertiary\"\n                icon=\"light/xmark.svg\"\n                size=\"smallest\"\n                (click)=\"_closeToastWithAnimation()\"\n            ></hive-button>\n        </div>\n    </div>\n</div>\n", dependencies: [{ kind: "directive", type: i2$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "component", type: LabelComponent, selector: "hive-label", inputs: ["label", "for", "size", "weight", "maxWeight", "horizontalAlignment", "leftIconHelpInfoMessage", "rightIconHelpInfoMessage", "leftIcon", "rightIcon", "required", "textOverflowEllipsis"] }, { kind: "component", type: IconComponent, selector: "hive-icon-component", inputs: ["icon", "size"] }, { kind: "component", type: ButtonComponent, selector: "hive-button", inputs: ["type", "menuButtonActive", "hasMenuButtonCaret", "label", "accessibleName", "icon", "iconPosition", "emphasis", "title", "size", "isLoading", "disabled", "rounded", "width"] }, { kind: "directive", type: InvertedColorsDirective, selector: "[hiveInvertedColors]", inputs: ["hiveInvertedColors"] }], animations: [slideInOut], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ToastComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hive-toast', changeDetection: ChangeDetectionStrategy.OnPush, hostDirectives: [HiveThemedDirective], animations: [slideInOut], template: "<div\n    (@slideInOut.done)=\"handleTransitionEnd($event)\"\n    [@slideInOut]=\"toastState\"\n    [ngClass]=\"'hive-toast--' + severity\"\n    class=\"hive-toast\"\n    [hiveInvertedColors]=\"true\"\n>\n    <div\n        class=\"hive-toast__container\"\n        [class.hive-toast__container--single-text-group]=\"!heading || !message\"\n    >\n        @if (ICON[severity ?? 'default']; as icon) {\n            <hive-icon-component\n                class=\"hive-toast__icon\"\n                [icon]=\"icon\"\n                size=\"medium\"\n            ></hive-icon-component>\n        }\n\n        <div class=\"hive-toast__content\">\n            <div class=\"hive-toast__text-content\">\n                @if (heading) {\n                    <hive-label\n                        [label]=\"heading\"\n                        class=\"hive-toast__title\"\n                        size=\"medium\"\n                        weight=\"semibold\"\n                    ></hive-label>\n                }\n\n                @if (message) {\n                    <p\n                        class=\"hive-toast__message hive-paragraph-small hive-paragraph-regular\"\n                    >\n                        {{ message }}\n                    </p>\n                }\n            </div>\n\n            <hive-button\n                class=\"hive-toast__close_button\"\n                emphasis=\"tertiary\"\n                icon=\"light/xmark.svg\"\n                size=\"smallest\"\n                (click)=\"_closeToastWithAnimation()\"\n            ></hive-button>\n        </div>\n    </div>\n</div>\n" }]
        }], ctorParameters: () => [{ type: i0.ChangeDetectorRef }], propDecorators: { severity: [{
                type: Input
            }], heading: [{
                type: Input
            }], message: [{
                type: Input
            }], readyToBeRemovedFromDOM: [{
                type: Output
            }], pointerOver: [{
                type: Output
            }], handleMouseEnter: [{
                type: HostListener,
                args: ['pointerenter']
            }], handleMouseLeave: [{
                type: HostListener,
                args: ['pointerleave']
            }] } });

class ToastModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ToastModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: ToastModule, declarations: [ToastComponent], imports: [CommonModule,
            OverlayModule,
            LabelComponent,
            IconComponent,
            SvgDirective,
            ButtonComponent,
            IsDefinedPipe,
            InvertedColorsDirective], exports: [ToastComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ToastModule, imports: [CommonModule,
            OverlayModule,
            LabelComponent,
            IconComponent,
            ButtonComponent] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ToastModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [ToastComponent],
                    imports: [
                        CommonModule,
                        OverlayModule,
                        LabelComponent,
                        IconComponent,
                        SvgDirective,
                        ButtonComponent,
                        IsDefinedPipe,
                        InvertedColorsDirective,
                    ],
                    exports: [ToastComponent],
                }]
        }] });

/**
 * Returns the last value from a set.
 *
 * @example
 * const set = new Set([1, 2, 3]);
 * of(set).pipe(lastFromSet(), take(1)).subscribe(console.log); // 3
 * // repeat it
 * of(set).pipe(lastFromSet(), take(1)).subscribe(console.log); // 3
 * // source set not mutated, so you can use it again
 */
function lastFromSet() {
    return (source) => source.pipe(map$1((set) => [...set].pop() || null));
}

/**
 * Emits only truthy values.
 * Similar to filter(Boolean), but works with null, undefined and ''.
 * @example
 * of(1, 2, null, undefined, '', 3).pipe(onlyTruthy()).subscribe(console.log); // 1, 2, 3
 */
function onlyTruthy() {
    return (source) => source.pipe(filter$1((value) => !!value));
}

/**
 * When the value is falsy, delay the observable by the given timeOut otherwise does not emit anything.
 * @param timeOut
 * @example
 * of(1, 2, null, undefined, '', 3).pipe(whenFalsyDoDelay(1000)).subscribe(console.log); // --- 1 --- 2 --- 3
 */
function whenFalsyDoDelay(timeOut) {
    return (source) => source.pipe(switchMap$1((value) => (value ? [] : timer(timeOut))), take(1));
}

const TOAST_TIME_OUT = 5000;
const DEFAULT_TOAST_POINT_OVER_DELAY = 5000;
/**
 * Service for displaying toast.
 * The Toast component centered at the bottom of the screen and have a pop-up ease-in motion. This motion provides a smooth and visually appealing transition when the Toast appears on the screen.
 * To avoid cluttering the user interface, the Toast automatically disappear after 5 seconds (default) to provide users with enough time to read the message before it disappears.
 * Stop dismissal countdown on hover to keep Toast message visible.
 *
 * In 99% cases you need to use only `addToast` method, not toast component directly.
 */
class ToastService {
    constructor(overlay, theming$) {
        this.overlay = overlay;
        this.theming$ = theming$;
        this.destroy$ = new Subject();
        /**
         * Toast delay in milliseconds.
         * Ideally to have injection token for this value, but it's not required for now.
         */
        this.toastDelay$ = new BehaviorSubject(TOAST_TIME_OUT);
        this.toasts$ = new BehaviorSubject(new Set());
        this.toastDelay$
            .pipe(takeUntil(this.destroy$), switchMap$1((timeOut) => this.handleLastToastPointerOver(timeOut)))
            .subscribe();
    }
    /**
     * Adds a toast to the list of toasts$.
     * Every toast will be readyToBeRemovedFromDOM after 5 seconds if pointer is not over it.
     * Toast could be readyToBeRemovedFromDOM by clicking on it.
     *
     * @param toastData - data for toast {heading, message, severity}
     */
    addToast(toastData) {
        const { heading, message, severity } = toastData;
        const { attached, overlayRef } = this.renderToast({
            heading,
            message,
            severity,
        });
        this.toasts$.next(this.toasts$.value.add({ attached, overlayRef }));
        this.handleToastClose(attached).subscribe();
        return attached.instance;
    }
    /**
     * Closes toast with animation of closing.
     *
     * @param toast - toast component instance. Use the value returned by addToast method.
     */
    closeToast(toast) {
        toast._closeToastWithAnimation();
    }
    /**
     * Change toast delay.
     * @param timeOut - delay in milliseconds
     * @internal
     */
    setToastDelay(timeOut) {
        this.toastDelay$.next(timeOut);
    }
    /**
     * @internal - For a some reason we need to have internal annotation for lifecycle hooks of services.
     */
    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
    /**
     * Removes toast from the list of toasts$.
     * @param toast - toast reference to remove
     */
    handleToastClose(toast) {
        return toast.instance.readyToBeRemovedFromDOM.pipe(takeUntil(this.destroy$), take(1), tap(() => {
            const toasts = this.toasts$.value;
            const findToast = [...toasts].find(({ attached }) => attached === toast);
            if (!findToast) {
                return;
            }
            toasts.delete(findToast);
            this.toasts$.next(toasts);
            findToast.overlayRef.dispose();
        }));
    }
    /**
     * Handles pointer over last toast.
     * @param timeOut - delay in milliseconds
     */
    handleLastToastPointerOver(timeOut = DEFAULT_TOAST_POINT_OVER_DELAY) {
        return this.toasts$.pipe(takeUntil(this.destroy$), lastFromSet(), onlyTruthy(), pluckProperty('attached'), this.closeToastAfterTimeout.bind(this)(timeOut));
    }
    /**
     * Closes last toast after timeout.
     * @param timeOut - delay in milliseconds
     */
    closeToastAfterTimeout(timeOut) {
        return (source) => source.pipe(switchMap$1((toast) => {
            return toast.instance.pointerOver.pipe(takeUntil(this.destroy$), whenFalsyDoDelay(timeOut), switchMap$1(() => this.toasts$), lastFromSet(), onlyTruthy(), 
            // Remove last toast
            tap((lastToast) => {
                lastToast.attached.instance._closeToastWithAnimation();
            }));
        }));
    }
    /**
     * Renders toast in the bottom center of the screen using CDK overlay.
     * @param heading - title of toast
     * @param message - message of toast
     * @param severity - severity of toast
     */
    renderToast({ heading, message, severity, }) {
        const theming = this.theming$.getValue();
        const overlayConfig = {
            hasBackdrop: false,
            panelClass: ['hive-root', `hive-theme-${theming}`],
            disposeOnNavigation: false,
            positionStrategy: this.overlay
                .position()
                .global()
                .top(HIVE_SPACING_XXLG)
                .centerHorizontally(),
        };
        const overlayRef = this.overlay.create(overlayConfig);
        const overlayPortal = new ComponentPortal(ToastComponent);
        const attached = overlayRef.attach(overlayPortal);
        Object.assign(attached.instance, { heading, message, severity });
        return { overlayRef, attached };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ToastService, deps: [{ token: i1$1.Overlay }, { token: HIVE_THEMING }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ToastService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ToastService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: i1$1.Overlay }, { type: i4.BehaviorSubject, decorators: [{
                    type: Inject,
                    args: [HIVE_THEMING]
                }] }] });

/**
 * Organization Switcher is used to switch between organizations in case the user is associated with multiple organizations.
 *
 * It utilizes the SelectionMenu component to display a list of organizations and companies.
 *
 * The component is used in the App Header component.
 *
 * @example
 *  <hive-organization-switcher
 *   selectedOrganizationLabel="Pure Storage"
 *   selectedCompanyLabel="Pure1"
 * >
 *   <hive-selection-menu-item label="Pure Storage" value="first"></hive-selection-menu-item>
 * </hive-organization-switcher>
 */
class OrganizationSwitcherComponent {
    constructor() {
        /**
         * Defines the label for the selected organization.
         * We do not use label from selected item because there is no API defined for it.
         */
        this.selectedOrganizationLabel = '';
        /**
         * Defines the label for the selected company.
         * We do not use label from selected item because there is no API defined for it.
         */
        this.selectedCompanyLabel = '';
        /**
         * Defines debounce wait time for the filter input.
         *
         * If `null`, default value is used.
         *
         * @default 300
         *
         * @see DebounceChangeDirective.debounceWait
         */
        this.debounceWait = null;
        /**
         * Whether the selection panel is in error state.
         */
        this.hasLoadingError = false;
        /**
         * Whether the selection panel is in loading state.
         */
        this.isLoading = false;
        /**
         * Whether the component is disabled.
         */
        this.disabled = false;
        /**
         * Defines whether the filter input should be autofocused when selection menu is opened.
         *
         * @default true
         */
        this.hasFilterAutofocus = true;
        /**
         * Emits when a user clicks on the link which is displayed when the
         * selection-menu is in error state.
         */
        this.tryAgainClick = new EventEmitter();
        /**
         * Emits when a user changes selection, i.e., clicks on an item.
         */
        this.selectionChange = new EventEmitter();
        /**
         * Emits when a user types in the filter input.
         */
        this.filterChange = new EventEmitter();
        /**
         * Emits when the visibility of the selection menu changes.
         */
        this.visibilityChange = new EventEmitter();
        /**
         * Selected item.
         */
        this.selection = null;
        this.organizationSwitcherSelectionMenuItems = new QueryList();
        this.organizationSwitcherContent = new QueryList();
        this.isOverlayVisible = false;
        this.cdr = inject(ChangeDetectorRef);
        this.elementRef = inject(ElementRef);
        this.destroyRef = inject(DestroyRef);
        this.orgSwitcherSelectionMenuMinimalWidth$ = new BehaviorSubject(0);
        // region ControlValueAccessor
        /**
         * @internal
         */
        this.onModelChange = () => { };
        /**
         * @internal
         */
        this.onModelTouch = () => { };
    }
    ngOnInit() {
        observeOnResize(this.elementRef.nativeElement)
            .pipe(safeTakeUntilDestroyed(this.destroyRef))
            .subscribe(() => {
            const width = this.elementRef.nativeElement.offsetWidth;
            this.orgSwitcherSelectionMenuMinimalWidth$.next(width);
        });
    }
    ngAfterContentInit() {
        this.organizationSwitcherSelectionMenuItems.notifyOnChanges();
        this.cdr.detectChanges();
    }
    /**
     * @internal
     */
    writeValue(value) {
        this.selection = value;
        this.cdr.detectChanges();
    }
    /**
     * @internal
     */
    registerOnChange(fn) {
        this.onModelChange = fn;
    }
    /**
     * @internal
     */
    registerOnTouched(fn) {
        this.onModelTouch = fn;
    }
    /**
     * @internal
     */
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
        this.cdr.detectChanges();
    }
    // endregion
    /**
     * User interaction handler.
     */
    handleSelectionChange({ selection, }) {
        this.selectionListOverlay?.hideOverlay();
        this.selection = selection.at(0);
        this.onModelChange(this.selection);
        this.selectionChange.emit(this.selection);
        this.selectionListOverlay?.hideOverlay();
        this.cdr.detectChanges();
    }
    handleVisibilityChange(isVisible) {
        this.isOverlayVisible = isVisible;
        // `onModelTouch` is called here because if `onModelTouch`
        // is attached to `<input />` trigger, it is called before `onModelChange`,
        // thus making the component become invalid for a moment,
        // blinking red, which annoying and uncomfortable for eyes.
        if (!this.isOverlayVisible) {
            this.onModelTouch();
        }
        if (this.isOverlayVisible && this.hasFilterAutofocus) {
            this.selectionMenu?.focusFilter();
        }
        this.visibilityChange.emit(this.isOverlayVisible);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: OrganizationSwitcherComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.3.12", type: OrganizationSwitcherComponent, isStandalone: true, selector: "hive-organization-switcher", inputs: { selectedOrganizationLabel: ["selectedOrganizationLabel", "selectedOrganizationLabel", stringAttribute], selectedCompanyLabel: ["selectedCompanyLabel", "selectedCompanyLabel", stringAttribute], debounceWait: ["debounceWait", "debounceWait", numberAttribute], hasLoadingError: ["hasLoadingError", "hasLoadingError", booleanAttribute], isLoading: ["isLoading", "isLoading", booleanAttribute], disabled: ["disabled", "disabled", booleanAttribute], hasFilterAutofocus: ["hasFilterAutofocus", "hasFilterAutofocus", booleanAttribute], selection: "selection" }, outputs: { tryAgainClick: "tryAgainClick", selectionChange: "selectionChange", filterChange: "filterChange", visibilityChange: "visibilityChange" }, providers: [
            SELECTION_MENU_PROVIDER,
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => OrganizationSwitcherComponent),
                multi: true,
            },
        ], queries: [{ propertyName: "organizationSwitcherSelectionMenuItems", predicate: (SelectionMenuItemComponent), descendants: true }, { propertyName: "organizationSwitcherContent", predicate: SELECTION_MENU_CONTENT, descendants: true }], viewQueries: [{ propertyName: "selectionListOverlay", first: true, predicate: ["selectionMenuOverlay"], descendants: true }, { propertyName: "selectionMenu", first: true, predicate: ["selectionMenu"], descendants: true }], hostDirectives: [{ directive: HiveThemedDirective }], ngImport: i0, template: "<button\n    [class.hive-organization-switcher-button-open]=\"isOverlayVisible\"\n    [attr.disabled]=\"disabled || null\"\n    [hiveOverlayTrigger]=\"selectionMenuOverlay\"\n    class=\"hive-organization-switcher-button\"\n    shouldToggle\n    type=\"button\"\n    data-testid=\"hive-organization-switcher-button\"\n>\n    <div class=\"hive-organization-switcher-button-current-value\">\n        @if (selectedOrganizationLabel) {\n            <hive-label\n                [label]=\"selectedOrganizationLabel\"\n                size=\"small\"\n                weight=\"semibold\"\n                horizontalAlignment=\"left\"\n            />\n        }\n        @if (selectedCompanyLabel) {\n            <hive-label\n                [label]=\"selectedCompanyLabel\"\n                size=\"smallest\"\n                weight=\"regular\"\n                horizontalAlignment=\"left\"\n            />\n        }\n    </div>\n\n    <hive-icon-component\n        [rotated]=\"isOverlayVisible\"\n        class=\"hive-button_caret-icon\"\n        hiveChevron\n        icon=\"light/chevron-down.svg\"\n        size=\"small\"\n    ></hive-icon-component>\n</button>\n\n<hive-overlay\n    #selectionMenuOverlay\n    (visibilityChange)=\"handleVisibilityChange($event)\"\n    closeOnPageResize\n    [overlayMinWidth]=\"(orgSwitcherSelectionMenuMinimalWidth$ | async) ?? 0\"\n>\n    <hive-selection-menu\n        #selectionMenu\n        (filterChange)=\"filterChange.emit($event)\"\n        (selectionChange)=\"handleSelectionChange($event)\"\n        (tryAgainClick)=\"tryAgainClick.emit()\"\n        [debounceWait]=\"debounceWait\"\n        [hasLoadingError]=\"hasLoadingError\"\n        [isLoading]=\"isLoading\"\n        [multiselect]=\"false\"\n        [selectionContent]=\"organizationSwitcherContent.toArray()\"\n        [selectionItems]=\"organizationSwitcherSelectionMenuItems.toArray()\"\n        [selection]=\"selection ? [selection] : []\"\n        class=\"hive-organization-switcher-selection-menu\"\n        hasFilter\n    >\n        <ng-container\n            ngProjectAs=\"hive-selection-menu-item, hive-selection-menu-section, ng-container\"\n        >\n            <ng-content\n                select=\"hive-selection-menu-item, hive-selection-menu-section, ng-container\"\n            ></ng-content>\n        </ng-container>\n        <ng-container slot=\"selection-menu-footer\">\n            <ng-content select=\"[slot=footer]\"></ng-content>\n        </ng-container>\n    </hive-selection-menu>\n</hive-overlay>\n", dependencies: [{ kind: "ngmodule", type: SelectionMenuModule }, { kind: "component", type: SelectionMenuComponent, selector: "hive-selection-menu", inputs: ["selectionItems", "selectionContent", "hasFilter", "multiselect", "hasLoadingError", "isLoading", "debounceWait", "hideSeparators", "selection"], outputs: ["selectionChange", "tryAgainClick", "filterChange"] }, { kind: "component", type: OverlayComponent, selector: "hive-overlay", inputs: ["takeWidthFromTrigger", "closeOnPageResize", "panelClass", "backdropClass", "position", "offsetX", "offsetY", "closeOnBackdropClick", "closeOnOutsideClick", "hasBackdrop", "overlayMinWidth"], outputs: ["visibilityChange"] }, { kind: "component", type: LabelComponent, selector: "hive-label", inputs: ["label", "for", "size", "weight", "maxWeight", "horizontalAlignment", "leftIconHelpInfoMessage", "rightIconHelpInfoMessage", "leftIcon", "rightIcon", "required", "textOverflowEllipsis"] }, { kind: "component", type: IconComponent, selector: "hive-icon-component", inputs: ["icon", "size"] }, { kind: "directive", type: ChevronDirective, selector: "hive-icon-component[hiveChevron]", inputs: ["rotationDirection", "rotated"] }, { kind: "directive", type: OverlayTriggerDirective, selector: "[hiveOverlayTrigger]", inputs: ["disabled", "hiveOverlayTrigger", "shouldToggle"] }, { kind: "pipe", type: AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: OrganizationSwitcherComponent, decorators: [{
            type: Component,
            args: [{ changeDetection: ChangeDetectionStrategy.OnPush, selector: 'hive-organization-switcher', standalone: true, hostDirectives: [HiveThemedDirective], imports: [
                        SelectionMenuModule,
                        OverlayComponent,
                        LabelComponent,
                        IconComponent,
                        ChevronDirective,
                        OverlayTriggerDirective,
                        AsyncPipe,
                    ], providers: [
                        SELECTION_MENU_PROVIDER,
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => OrganizationSwitcherComponent),
                            multi: true,
                        },
                    ], template: "<button\n    [class.hive-organization-switcher-button-open]=\"isOverlayVisible\"\n    [attr.disabled]=\"disabled || null\"\n    [hiveOverlayTrigger]=\"selectionMenuOverlay\"\n    class=\"hive-organization-switcher-button\"\n    shouldToggle\n    type=\"button\"\n    data-testid=\"hive-organization-switcher-button\"\n>\n    <div class=\"hive-organization-switcher-button-current-value\">\n        @if (selectedOrganizationLabel) {\n            <hive-label\n                [label]=\"selectedOrganizationLabel\"\n                size=\"small\"\n                weight=\"semibold\"\n                horizontalAlignment=\"left\"\n            />\n        }\n        @if (selectedCompanyLabel) {\n            <hive-label\n                [label]=\"selectedCompanyLabel\"\n                size=\"smallest\"\n                weight=\"regular\"\n                horizontalAlignment=\"left\"\n            />\n        }\n    </div>\n\n    <hive-icon-component\n        [rotated]=\"isOverlayVisible\"\n        class=\"hive-button_caret-icon\"\n        hiveChevron\n        icon=\"light/chevron-down.svg\"\n        size=\"small\"\n    ></hive-icon-component>\n</button>\n\n<hive-overlay\n    #selectionMenuOverlay\n    (visibilityChange)=\"handleVisibilityChange($event)\"\n    closeOnPageResize\n    [overlayMinWidth]=\"(orgSwitcherSelectionMenuMinimalWidth$ | async) ?? 0\"\n>\n    <hive-selection-menu\n        #selectionMenu\n        (filterChange)=\"filterChange.emit($event)\"\n        (selectionChange)=\"handleSelectionChange($event)\"\n        (tryAgainClick)=\"tryAgainClick.emit()\"\n        [debounceWait]=\"debounceWait\"\n        [hasLoadingError]=\"hasLoadingError\"\n        [isLoading]=\"isLoading\"\n        [multiselect]=\"false\"\n        [selectionContent]=\"organizationSwitcherContent.toArray()\"\n        [selectionItems]=\"organizationSwitcherSelectionMenuItems.toArray()\"\n        [selection]=\"selection ? [selection] : []\"\n        class=\"hive-organization-switcher-selection-menu\"\n        hasFilter\n    >\n        <ng-container\n            ngProjectAs=\"hive-selection-menu-item, hive-selection-menu-section, ng-container\"\n        >\n            <ng-content\n                select=\"hive-selection-menu-item, hive-selection-menu-section, ng-container\"\n            ></ng-content>\n        </ng-container>\n        <ng-container slot=\"selection-menu-footer\">\n            <ng-content select=\"[slot=footer]\"></ng-content>\n        </ng-container>\n    </hive-selection-menu>\n</hive-overlay>\n" }]
        }], propDecorators: { selectedOrganizationLabel: [{
                type: Input,
                args: [{ required: true, transform: stringAttribute }]
            }], selectedCompanyLabel: [{
                type: Input,
                args: [{ required: true, transform: stringAttribute }]
            }], debounceWait: [{
                type: Input,
                args: [{ transform: numberAttribute }]
            }], hasLoadingError: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], isLoading: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], disabled: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], hasFilterAutofocus: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], tryAgainClick: [{
                type: Output
            }], selectionChange: [{
                type: Output
            }], filterChange: [{
                type: Output
            }], visibilityChange: [{
                type: Output
            }], selection: [{
                type: Input
            }], selectionListOverlay: [{
                type: ViewChild,
                args: ['selectionMenuOverlay']
            }], selectionMenu: [{
                type: ViewChild,
                args: ['selectionMenu']
            }], organizationSwitcherSelectionMenuItems: [{
                type: ContentChildren,
                args: [(SelectionMenuItemComponent), { descendants: true }]
            }], organizationSwitcherContent: [{
                type: ContentChildren,
                args: [SELECTION_MENU_CONTENT, { descendants: true }]
            }] } });

function nameSizeAttribute(size) {
    return oneOfOrDefault(size, 'small', 'medium');
}
function valueSizeAttribute(size) {
    return oneOfOrDefault(size, 'small', 'medium', 'large', 'extra-large');
}
function componentTypeAttribute(size) {
    return oneOfOrDefault(size, 'vertical', 'horizontal');
}
/**
 * Name-values can be used for displaying a key-value pair in a simple way. Implemented to replace deprecated KeyValue component.
 */
class NameValueComponent {
    constructor() {
        /**
         * Size of a name (label)
         * @default small
         */
        this.nameSize = 'small';
        /**
         * Size of a value
         * @default small
         */
        this.valueSize = 'small';
        /**
         * Hide the whole component if there is no value presented
         * @default false
         */
        this.hideIfEmpty = false;
        /**
         * Placeholder to display if there is no value presented
         * @default '-'
         */
        this.noValuePlaceholder = '-';
        /**
         * Orientation of the whole component
         * @default vertical
         */
        this.type = 'vertical';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NameValueComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "16.1.0", version: "17.3.12", type: NameValueComponent, isStandalone: true, selector: "hive-name-value", inputs: { nameSize: ["nameSize", "nameSize", nameSizeAttribute], valueSize: ["valueSize", "valueSize", valueSizeAttribute], hideIfEmpty: ["hideIfEmpty", "hideIfEmpty", booleanAttribute], noValuePlaceholder: "noValuePlaceholder", type: ["type", "type", componentTypeAttribute] }, ngImport: i0, template: "<div\n    class=\"hive-name-value\"\n    *ngIf=\"!hideIfEmpty\"\n    [ngClass]=\"{\n        'hive-name-value-vertical': type === 'vertical',\n        'hive-name-value-horizontal': type === 'horizontal',\n    }\"\n>\n    <div\n        class=\"hive-name-value_key\"\n        [ngClass]=\"'hive-name-value_key_size-' + nameSize\"\n    >\n        <ng-content select=\"hive-label[slot=name], [hive-link][slot=name]\" />\n    </div>\n\n    <div\n        class=\"hive-name-value_value\"\n        [ngClass]=\"'hive-name-value_value_size-' + valueSize\"\n    >\n        <ng-content select=\"[slot=value]\" />\n\n        <div class=\"hive-name-value_value-empty\">{{ noValuePlaceholder }}</div>\n    </div>\n</div>\n", dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i2$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NameValueComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hive-name-value', standalone: true, imports: [CommonModule], template: "<div\n    class=\"hive-name-value\"\n    *ngIf=\"!hideIfEmpty\"\n    [ngClass]=\"{\n        'hive-name-value-vertical': type === 'vertical',\n        'hive-name-value-horizontal': type === 'horizontal',\n    }\"\n>\n    <div\n        class=\"hive-name-value_key\"\n        [ngClass]=\"'hive-name-value_key_size-' + nameSize\"\n    >\n        <ng-content select=\"hive-label[slot=name], [hive-link][slot=name]\" />\n    </div>\n\n    <div\n        class=\"hive-name-value_value\"\n        [ngClass]=\"'hive-name-value_value_size-' + valueSize\"\n    >\n        <ng-content select=\"[slot=value]\" />\n\n        <div class=\"hive-name-value_value-empty\">{{ noValuePlaceholder }}</div>\n    </div>\n</div>\n" }]
        }], propDecorators: { nameSize: [{
                type: Input,
                args: [{ transform: nameSizeAttribute }]
            }], valueSize: [{
                type: Input,
                args: [{ transform: valueSizeAttribute }]
            }], hideIfEmpty: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], noValuePlaceholder: [{
                type: Input
            }], type: [{
                type: Input,
                args: [{ transform: componentTypeAttribute }]
            }] } });

/**
 * Name-numbers can be used for displaying a key-value pair (where value is a number) in a simple way.
 * Implemented to replace deprecated KeyValue component.
 */
class NameNumberComponent {
    constructor() {
        /**
         * Makes the card interactive (derived from hive-card)
         */
        this.interactive = false;
        /**
         * Makes the card disabled (derived from hive-card)
         */
        this.disabled = false;
        /**
         * Fires when the Card is clicked, works only for interactive cards (derived from hive-card)
         */
        this.cardClick = new EventEmitter();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NameNumberComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "16.1.0", version: "17.3.12", type: NameNumberComponent, isStandalone: true, selector: "hive-name-number", inputs: { interactive: ["interactive", "interactive", booleanAttribute], disabled: ["disabled", "disabled", booleanAttribute] }, outputs: { cardClick: "cardClick" }, ngImport: i0, template: "<hive-card\n    class=\"name-number-card\"\n    [interactive]=\"interactive\"\n    [disabled]=\"disabled\"\n    (cardClick)=\"cardClick.emit()\"\n>\n    <ng-content select=\"hive-name-number-item\" />\n</hive-card>\n", dependencies: [{ kind: "component", type: CardComponent, selector: "hive-card", inputs: ["interactive", "disabled", "selected"], outputs: ["cardClick"] }, { kind: "ngmodule", type: BreadcrumbModule }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NameNumberComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hive-name-number', standalone: true, changeDetection: ChangeDetectionStrategy.OnPush, imports: [CardComponent, BreadcrumbModule], template: "<hive-card\n    class=\"name-number-card\"\n    [interactive]=\"interactive\"\n    [disabled]=\"disabled\"\n    (cardClick)=\"cardClick.emit()\"\n>\n    <ng-content select=\"hive-name-number-item\" />\n</hive-card>\n" }]
        }], propDecorators: { interactive: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], disabled: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], cardClick: [{
                type: Output
            }] } });

class NameNumberItemComponent {
    constructor() {
        this.label = '';
        this.value = '';
        this.comment = '';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NameNumberItemComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: NameNumberItemComponent, isStandalone: true, selector: "hive-name-number-item", inputs: { icon: "icon", label: "label", value: "value", comment: "comment" }, ngImport: i0, template: "<div\n    class=\"hive-name-number-item\"\n    [ngClass]=\"icon ? '' : 'hive-name-number-item_centered'\"\n>\n    <div class=\"hive-name-number-item_name\">\n        <hive-label size=\"small\" [label]=\"label\" />\n    </div>\n    <div class=\"hive-name-number-item_row\">\n        <div class=\"hive-name-number-item_row-value\">\n            <span>{{ value }}</span>\n        </div>\n        <div class=\"hive-name-number-item_row-icon\" *ngIf=\"icon\">\n            <hive-icon-component\n                class=\"hive-key-number-item_row-icon-icon\"\n                [icon]=\"icon\"\n                size=\"x-large\"\n            />\n        </div>\n    </div>\n    <div class=\"hive-name-number-item_comment\" *ngIf=\"comment\">\n        <hive-label size=\"medium\" [label]=\"comment\" />\n    </div>\n</div>\n", dependencies: [{ kind: "component", type: IconComponent, selector: "hive-icon-component", inputs: ["icon", "size"] }, { kind: "component", type: LabelComponent, selector: "hive-label", inputs: ["label", "for", "size", "weight", "maxWeight", "horizontalAlignment", "leftIconHelpInfoMessage", "rightIconHelpInfoMessage", "leftIcon", "rightIcon", "required", "textOverflowEllipsis"] }, { kind: "directive", type: NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NameNumberItemComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hive-name-number-item', standalone: true, imports: [IconComponent, LabelComponent, NgClass, NgIf], template: "<div\n    class=\"hive-name-number-item\"\n    [ngClass]=\"icon ? '' : 'hive-name-number-item_centered'\"\n>\n    <div class=\"hive-name-number-item_name\">\n        <hive-label size=\"small\" [label]=\"label\" />\n    </div>\n    <div class=\"hive-name-number-item_row\">\n        <div class=\"hive-name-number-item_row-value\">\n            <span>{{ value }}</span>\n        </div>\n        <div class=\"hive-name-number-item_row-icon\" *ngIf=\"icon\">\n            <hive-icon-component\n                class=\"hive-key-number-item_row-icon-icon\"\n                [icon]=\"icon\"\n                size=\"x-large\"\n            />\n        </div>\n    </div>\n    <div class=\"hive-name-number-item_comment\" *ngIf=\"comment\">\n        <hive-label size=\"medium\" [label]=\"comment\" />\n    </div>\n</div>\n" }]
        }], propDecorators: { icon: [{
                type: Input
            }], label: [{
                type: Input
            }], value: [{
                type: Input
            }], comment: [{
                type: Input
            }] } });

/**
 * Load indicator is a visual component that displays resource utilization relative to maximum capacity, supports periodic or static data updates, and enables comparison of capacities across multiple items.
 */
class LoadIndicatorComponent {
    constructor() {
        /**
         * Bars of the load indicator represented as number of percentage which it takes of load indicator. The sum of the values should not exceed 100.
         */
        this.loadBars = [];
        /**
         * Defines the first two colors of the load indicator bars. If you have more than two bars please use property colorOfLoadBars
         */
        this.state = 'info';
        /**
         * Option to highlight a quota for the displayed value. The range is from 0 to 100
         */
        this.quota = 0;
        /**
         * Defines the placement of the assistance text
         */
        this.assistanceTextPosition = 'right';
        /**
         * Defines the size of the load indicator
         */
        this.size = 'medium';
        this.loadIndicatorUniqueId = uniqueId('hive-load-indicator-');
        this.sumOfLoadBars = 0;
    }
    ngOnChanges(changes) {
        if (changes['loadBars']) {
            this.sumOfLoadBars = this.loadBars.reduce((a, b) => a + b, 0);
            if (this.sumOfLoadBars > 100) {
                console.warn('The sum of the load bars should not exceed 100.');
            }
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: LoadIndicatorComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.3.12", type: LoadIndicatorComponent, isStandalone: true, selector: "hive-load-indicator", inputs: { loadBars: "loadBars", colorOfLoadBars: "colorOfLoadBars", state: "state", quota: ["quota", "quota", numberAttribute], assistanceText: ["assistanceText", "assistanceText", stringOrUndefinedAttribute], assistanceTextPosition: "assistanceTextPosition", size: "size", loadIndicatorTestId: "loadIndicatorTestId" }, usesOnChanges: true, hostDirectives: [{ directive: HiveThemedDirective }], ngImport: i0, template: "<div class=\"hive-load-indicator\">\n    <div class=\"hive-load-indicator-bar\">\n        <div\n            class=\"hive-load-indicator-bar-meter\"\n            [ngStyle]=\"{\n                'grid-template-columns': loadBars.join('% ') + '% auto',\n            }\"\n            [ngClass]=\"['hive-load-indicator-bar-meter-size--' + size]\"\n        >\n            @for (\n                bar of loadBars;\n                track bar;\n                let index = $index;\n                let last = $last\n            ) {\n                <div\n                    [class.hive-load-indicator-bar-meter-first]=\"index === 0\"\n                    [class.hive-load-indicator-bar-meter-bar-full]=\"\n                        last && sumOfLoadBars >= 100\n                    \"\n                    [ngClass]=\"\n                        colorOfLoadBars\n                            ? []\n                            : [\n                                  'hive-load-indicator-bar-meter-' +\n                                      index +\n                                      '-' +\n                                      state,\n                              ]\n                    \"\n                    [ngStyle]=\"\n                        colorOfLoadBars\n                            ? { background: colorOfLoadBars[index] }\n                            : {}\n                    \"\n                ></div>\n            }\n            <div class=\"hive-load-indicator-bar-meter-filler\"></div>\n            @if (quota) {\n                <div class=\"quota\" [ngStyle]=\"{ left: quota + '%' }\"></div>\n            }\n        </div>\n        @if (assistanceText && assistanceTextPosition === 'right') {\n            <span\n                class=\"hive-load-indicator-assistance-text\"\n                [ngClass]=\"['hive-load-indicator-assistance-text-' + size]\"\n                >{{ assistanceText }}</span\n            >\n        }\n    </div>\n    @if (assistanceText && assistanceTextPosition !== 'right') {\n        <div\n            [ngClass]=\"[\n                'hive-load-indicator-assistance-text-' + assistanceTextPosition,\n            ]\"\n        >\n            <span\n                class=\"hive-load-indicator-assistance-text\"\n                [ngClass]=\"['hive-load-indicator-assistance-text-' + size]\"\n                >{{ assistanceText }}</span\n            >\n        </div>\n    }\n</div>\n", dependencies: [{ kind: "directive", type: NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: LoadIndicatorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hive-load-indicator', changeDetection: ChangeDetectionStrategy.OnPush, hostDirectives: [HiveThemedDirective], standalone: true, imports: [
                        SvgDirective,
                        FormInputBaseComponent,
                        NgClass,
                        DecimalPipe,
                        LabelComponent,
                        IconComponent,
                        NgStyle,
                        AsyncPipe,
                    ], template: "<div class=\"hive-load-indicator\">\n    <div class=\"hive-load-indicator-bar\">\n        <div\n            class=\"hive-load-indicator-bar-meter\"\n            [ngStyle]=\"{\n                'grid-template-columns': loadBars.join('% ') + '% auto',\n            }\"\n            [ngClass]=\"['hive-load-indicator-bar-meter-size--' + size]\"\n        >\n            @for (\n                bar of loadBars;\n                track bar;\n                let index = $index;\n                let last = $last\n            ) {\n                <div\n                    [class.hive-load-indicator-bar-meter-first]=\"index === 0\"\n                    [class.hive-load-indicator-bar-meter-bar-full]=\"\n                        last && sumOfLoadBars >= 100\n                    \"\n                    [ngClass]=\"\n                        colorOfLoadBars\n                            ? []\n                            : [\n                                  'hive-load-indicator-bar-meter-' +\n                                      index +\n                                      '-' +\n                                      state,\n                              ]\n                    \"\n                    [ngStyle]=\"\n                        colorOfLoadBars\n                            ? { background: colorOfLoadBars[index] }\n                            : {}\n                    \"\n                ></div>\n            }\n            <div class=\"hive-load-indicator-bar-meter-filler\"></div>\n            @if (quota) {\n                <div class=\"quota\" [ngStyle]=\"{ left: quota + '%' }\"></div>\n            }\n        </div>\n        @if (assistanceText && assistanceTextPosition === 'right') {\n            <span\n                class=\"hive-load-indicator-assistance-text\"\n                [ngClass]=\"['hive-load-indicator-assistance-text-' + size]\"\n                >{{ assistanceText }}</span\n            >\n        }\n    </div>\n    @if (assistanceText && assistanceTextPosition !== 'right') {\n        <div\n            [ngClass]=\"[\n                'hive-load-indicator-assistance-text-' + assistanceTextPosition,\n            ]\"\n        >\n            <span\n                class=\"hive-load-indicator-assistance-text\"\n                [ngClass]=\"['hive-load-indicator-assistance-text-' + size]\"\n                >{{ assistanceText }}</span\n            >\n        </div>\n    }\n</div>\n" }]
        }], propDecorators: { loadBars: [{
                type: Input
            }], colorOfLoadBars: [{
                type: Input
            }], state: [{
                type: Input
            }], quota: [{
                type: Input,
                args: [{ transform: numberAttribute }]
            }], assistanceText: [{
                type: Input,
                args: [{ transform: stringOrUndefinedAttribute }]
            }], assistanceTextPosition: [{
                type: Input
            }], size: [{
                type: Input
            }], loadIndicatorTestId: [{
                type: Input
            }] } });

class BulkSelectionComponent {
    constructor(pageBaseLayout) {
        this.pageBaseLayout = pageBaseLayout;
        /**
         * List of selected items
         */
        this.selectedItems = input([]);
        /**
         * List of actions that can be performed on selected items
         */
        this.actions = input([]);
        /**
         * Emits a string of action when user selects an action
         */
        this.actionSelected = output();
        /**
         * Emits when the clear selection button is clicked
         */
        this.clearSelection = output();
        /**
         * Emits an id of selected item when an item is removed from the selected items
         */
        this.selectedItemRemoved = output();
        this._isLeftNavigationOpen = signal(false);
        this._actionsOnMainBar = [];
        this._actionsOnMoreButton = [];
        this._fullWidth = 0;
        this.window = inject(DOCUMENT).defaultView;
        this.destroy$ = new Subject();
    }
    ngOnInit() {
        if (this.pageBaseLayout) {
            this.pageBaseLayout.navigationOpen$
                .pipe(takeUntil(this.destroy$))
                .subscribe((navigationOpen) => {
                this._isLeftNavigationOpen.set(navigationOpen);
                this.checkAndHandleOverflow();
            });
        }
    }
    onResize() {
        this.checkAndHandleOverflow();
    }
    ngAfterViewInit() {
        this._fullWidth = this.bulkSelection.nativeElement.scrollWidth;
        this.checkAndHandleOverflow();
    }
    checkAndHandleOverflow() {
        const widthOfLeftNav = this._isLeftNavigationOpen()
            ? Number(HIVE_SIZING_3200.substring(0, HIVE_SIZING_3200.length - 2))
            : 0;
        // calculating the width of the bar plus the margin 40px from each side plus the width of the left navigation if it is open
        const widthOfComponentWithSpaces = this._fullWidth + 80 + widthOfLeftNav;
        if (this.window !== null &&
            widthOfComponentWithSpaces > this.window.innerWidth) {
            this._actionsOnMoreButton = this.actions().slice(2);
            this._actionsOnMainBar = this.actions().slice(0, 2);
        }
        else {
            this._actionsOnMainBar = this.actions();
            this._actionsOnMoreButton = [];
        }
    }
    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: BulkSelectionComponent, deps: [{ token: PageBaseLayoutComponent, optional: true }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.3.12", type: BulkSelectionComponent, isStandalone: true, selector: "hive-bulk-selection", inputs: { selectedItems: { classPropertyName: "selectedItems", publicName: "selectedItems", isSignal: true, isRequired: false, transformFunction: null }, actions: { classPropertyName: "actions", publicName: "actions", isSignal: true, isRequired: false, transformFunction: null } }, outputs: { actionSelected: "actionSelected", clearSelection: "clearSelection", selectedItemRemoved: "selectedItemRemoved" }, host: { listeners: { "window:resize": "onResize($event)" } }, viewQueries: [{ propertyName: "bulkSelection", first: true, predicate: ["bulkSelection"], descendants: true, static: true }], hostDirectives: [{ directive: HiveThemedDirective }], ngImport: i0, template: "<hive-menu\n    #selectedItemsMenu\n    position=\"topStart\"\n    [offsetY]=\"-2\"\n    closeOnPageResize=\"true\"\n    closeOnMenuClick=\"false\"\n    [hiveInvertedColors]=\"true\"\n>\n    @for (item of selectedItems(); track item.id) {\n        <hive-menu-item-bulk-selector\n            [label]=\"item.label\"\n            (deselect)=\"selectedItemRemoved.emit(item.id)\"\n        />\n    }\n</hive-menu>\n\n<hive-menu\n    #moreActionsMenu\n    position=\"topStart\"\n    [offsetY]=\"-2\"\n    closeOnPageResize=\"true\"\n    [hiveInvertedColors]=\"true\"\n>\n    @for (action of _actionsOnMoreButton; track action) {\n        <hive-menu-item\n            [label]=\"action\"\n            (menuItemClick)=\"actionSelected.emit(action)\"\n        />\n    }\n</hive-menu>\n\n<div\n    #bulkSelection\n    class=\"hive-bulk-selector\"\n    [ngStyle]=\"selectedItems().length > 0 ? {} : { display: 'none' }\"\n    [hiveInvertedColors]=\"true\"\n    [class.hive-bulk-selector-menu-open]=\"_isLeftNavigationOpen()\"\n>\n    <hive-button\n        hiveMenuButton\n        [menuRef]=\"selectedItemsMenu\"\n        [label]=\"selectedItems().length + ' selected'\"\n        emphasis=\"tertiary\"\n        data-testid=\"bulk-selection-menu-button\"\n    />\n    <hive-separator orientation=\"vertical\" />\n    @for (action of _actionsOnMainBar; track action) {\n        <hive-button\n            (click)=\"actionSelected.emit(action)\"\n            emphasis=\"tertiary\"\n            [label]=\"action\"\n            [attr.data-testid]=\"'bulk-selection-action-button-' + action\"\n        />\n    }\n    @if (_actionsOnMoreButton.length > 0) {\n        <hive-button\n            hiveMenuButton\n            [menuRef]=\"moreActionsMenu\"\n            label=\"More\"\n            emphasis=\"tertiary\"\n        />\n    }\n\n    <hive-separator orientation=\"vertical\" />\n\n    <hive-button\n        (click)=\"clearSelection.emit()\"\n        emphasis=\"tertiary\"\n        label=\"Clear selection\"\n        icon=\"light/xmark.svg\"\n        iconPosition=\"right\"\n        data-testid=\"bulk-selection-clear-button\"\n    />\n</div>\n", dependencies: [{ kind: "component", type: SeparatorComponent, selector: "hive-separator", inputs: ["orientation"] }, { kind: "component", type: ButtonComponent, selector: "hive-button", inputs: ["type", "menuButtonActive", "hasMenuButtonCaret", "label", "accessibleName", "icon", "iconPosition", "emphasis", "title", "size", "isLoading", "disabled", "rounded", "width"] }, { kind: "directive", type: InvertedColorsDirective, selector: "[hiveInvertedColors]", inputs: ["hiveInvertedColors"] }, { kind: "ngmodule", type: MenuModule }, { kind: "directive", type: MenuButtonDirective, selector: "hive-button[hiveMenuButton]", inputs: ["caret"] }, { kind: "component", type: MenuComponent, selector: "hive-menu", inputs: ["position", "overlay", "offsetX", "offsetY", "closeOnMenuClick", "closeOnPageResize", "useContentPadding"], outputs: ["visibilityChange", "menuClick"], exportAs: ["hiveMenu"] }, { kind: "component", type: MenuItemComponent, selector: "hive-menu-item", inputs: ["label", "disabled", "destructive", "external"], outputs: ["menuItemClick"] }, { kind: "component", type: MenuItemBulkSelectorComponent, selector: "hive-menu-item-bulk-selector", inputs: ["label"], outputs: ["deselect"] }, { kind: "directive", type: NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: BulkSelectionComponent, decorators: [{
            type: Component,
            args: [{ selector: 'hive-bulk-selection', standalone: true, imports: [
                        OverlayComponent,
                        ChevronDirective,
                        IconComponent,
                        LabelComponent,
                        SeparatorComponent,
                        ButtonComponent,
                        OverlayTriggerDirective,
                        InvertedColorsDirective,
                        MenuModule,
                        NgClass,
                        NgStyle,
                        NgTemplateOutlet,
                    ], changeDetection: ChangeDetectionStrategy.OnPush, hostDirectives: [HiveThemedDirective], template: "<hive-menu\n    #selectedItemsMenu\n    position=\"topStart\"\n    [offsetY]=\"-2\"\n    closeOnPageResize=\"true\"\n    closeOnMenuClick=\"false\"\n    [hiveInvertedColors]=\"true\"\n>\n    @for (item of selectedItems(); track item.id) {\n        <hive-menu-item-bulk-selector\n            [label]=\"item.label\"\n            (deselect)=\"selectedItemRemoved.emit(item.id)\"\n        />\n    }\n</hive-menu>\n\n<hive-menu\n    #moreActionsMenu\n    position=\"topStart\"\n    [offsetY]=\"-2\"\n    closeOnPageResize=\"true\"\n    [hiveInvertedColors]=\"true\"\n>\n    @for (action of _actionsOnMoreButton; track action) {\n        <hive-menu-item\n            [label]=\"action\"\n            (menuItemClick)=\"actionSelected.emit(action)\"\n        />\n    }\n</hive-menu>\n\n<div\n    #bulkSelection\n    class=\"hive-bulk-selector\"\n    [ngStyle]=\"selectedItems().length > 0 ? {} : { display: 'none' }\"\n    [hiveInvertedColors]=\"true\"\n    [class.hive-bulk-selector-menu-open]=\"_isLeftNavigationOpen()\"\n>\n    <hive-button\n        hiveMenuButton\n        [menuRef]=\"selectedItemsMenu\"\n        [label]=\"selectedItems().length + ' selected'\"\n        emphasis=\"tertiary\"\n        data-testid=\"bulk-selection-menu-button\"\n    />\n    <hive-separator orientation=\"vertical\" />\n    @for (action of _actionsOnMainBar; track action) {\n        <hive-button\n            (click)=\"actionSelected.emit(action)\"\n            emphasis=\"tertiary\"\n            [label]=\"action\"\n            [attr.data-testid]=\"'bulk-selection-action-button-' + action\"\n        />\n    }\n    @if (_actionsOnMoreButton.length > 0) {\n        <hive-button\n            hiveMenuButton\n            [menuRef]=\"moreActionsMenu\"\n            label=\"More\"\n            emphasis=\"tertiary\"\n        />\n    }\n\n    <hive-separator orientation=\"vertical\" />\n\n    <hive-button\n        (click)=\"clearSelection.emit()\"\n        emphasis=\"tertiary\"\n        label=\"Clear selection\"\n        icon=\"light/xmark.svg\"\n        iconPosition=\"right\"\n        data-testid=\"bulk-selection-clear-button\"\n    />\n</div>\n" }]
        }], ctorParameters: () => [{ type: PageBaseLayoutComponent, decorators: [{
                    type: Optional
                }] }], propDecorators: { bulkSelection: [{
                type: ViewChild,
                args: ['bulkSelection', { static: true }]
            }], onResize: [{
                type: HostListener,
                args: ['window:resize', ['$event']]
            }] } });

/*
 * Public API Surface of Hive
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ACTIVE_MODEL, AccordionComponent, AccordionModule, AccordionStepComponent, AccordionStepperComponent, AccordionStepperModule, AccordionTabComponent, AppHeaderComponent, AppHeaderHelpMenuDirective, AppHeaderModule, AppHeaderStateService, AppNavigationModule, AutofocusDirective, AutofocusService, AvatarComponent, AvatarMenuComponent, AvatarModule, BadgeComponent, BadgeDotComponent, BadgeDotDirective, BadgeModule, BreadcrumbComponent, BreadcrumbItemComponent, BreadcrumbModule, BulkSelectionComponent, ButtonComponent, ButtonGroupComponent, CHECKBOX_DISABLED_TOKEN, CHECKBOX_SIZE_TOKEN, CHECKBOX_VALUE_ACCESSOR, COLUMN_TOGGLE_PERSISTENCE_STORE, CardComponent, CellComponent, CellPositioningContainerDirective, CheckboxComponent, CheckboxGroupComponent, ChevronDirective, ChipComponent, CoerceBooleanPropertyPipe, CollapsableItemComponent, ColumnToggleComponent, ConfirmationDialogComponent, ConfirmationDialogEmphasisToButtonEmphasisMap, ContentDialogComponent, ContentDialogTriggerDirective, DebounceChangeDirective, DebounceChangeModule, DeprecatedAppNavigationDirective, DetailsPanelComponent, DisabledTableRowDirective, DropdownComponent, DropdownModule, EXPANSION_MODEL, EmptyStateComponent, FormComponentValidityDirective, FormInputBaseComponent, FrozenCellDirective, FrozenColumnDirective, FrozenHeaderColumnDirective, GFB_SERVICE_TOKEN, GfbComponent, GfbEntityMenuComponent, GfbModule, GfbNonApplicableFilterButtonComponent, GfbPillComponent, GfbSelectionMenuComponent, HIVE_THEMING, HeaderComponent, HeaderPositioningContainerComponent, HeaderSortWrapperComponent, HiveBodyTemplateDirective, HiveTemplateDirective, HiveTemplatePipe, HiveThemedDirective, IconComponent, InfoIconComponent, InlineNotificationComponent, InvertedColorsDirective, IsDefinedPipe, IsMultilineTextEmptyPipe, KeyValueComponent, LabelComponent, LayoutService, LeftNavigationComponent, LeftNavigationItemComponent, LeftNavigationModule, LeftNavigationStateService, LinkCellComponent, LinkComponent, LoadIndicatorComponent, LoadingSpinnerComponent, MenuButtonDirective, MenuComponent, MenuItemBulkSelectorComponent, MenuItemComponent, MenuModule, MenuSectionComponent, MenuTriggerDirective, MockGfbService, MultiselectComponent, MultiselectModule, NameNumberComponent, NameNumberItemComponent, NameValueComponent, NonNullPipe, OneTimePasswordComponent, OrganizationSwitcherComponent, OverlayComponent, OverlayTriggerDirective, PageBaseLayoutComponent, PageBaseLayoutModule, PageDraggableSplitterComponent, PaginationComponent, PopUpComponent, PopUpModule, PopUpTriggerDirective, PredefinedPositions, PrimaryTextComponent, ProgressBarComponent, RADIOBUTTON_VALUE_ACCESSOR, RADIO_DISABLED_TOKEN, RADIO_GROUP_VALUE_ACCESSOR, RADIO_NAME_TOKEN, RADIO_SIZE_TOKEN, RadioButtonComponent, RadioButtonModule, RadioGroupComponent, RootDirective, SELECTION_MENU_PROVIDER, SVG_ROOT, SWITCH_DISABLED_TOKEN, SWITCH_SIZE_TOKEN, SectionHeaderComponent, SegmentButtonComponent, SegmentButtonGroupComponent, SegmentButtonGroupModule, SelectionMenuBaseItemComponent, SelectionMenuComponent, SelectionMenuFilters, SelectionMenuGroupItemComponent, SelectionMenuItemComponent, SelectionMenuModule, SelectionMenuSectionComponent, SelectionMenuService, SeparatorComponent, SortIconComponent, SortIconPipe, SquareCellComponent, SquareHeaderComponent, StatisticCardComponent, StatsComponent, StatsDataComponent, StatsModule, StepperComponent, StepperModule, StepperNextDirective, StepperPreviousDirective, StepperStepComponent, SvgDirective, SwitchComponent, SwitchGroupComponent, SwitchModule, TabPanelComponent, TabViewComponent, TabViewModule, TableCheckboxComponent, TableComponent, TableHeaderCheckboxComponent, TableHeadingDirective, TableHoverManagerDirective, TableModule, TableRowDirective, TableSecondaryTextComponent, TableSelectionManagerDirective, TagComponent, TemplateCellComponent, TemplateHeaderComponent, TextAreaComponent, TextFieldComponent, Themes, ToArrayPipe, ToastComponent, ToastModule, ToastService, ToggleButtonComponent, ToolbarComponent, TooltipDirective, TooltipModule, TooltipWindowComponent, accordionSizeAttribute, calculateStepState, chipSizeAttribute, coerceMultilineString, confirmationDialogEmphasis, debounceWaitAttribute, getNotIgnoredColumns, helpInfoIconAttribute, hiveSeverityAttribute, htmlInputTypeAttribute, inputTextFieldSizeAttribute, isDefined, isMultilineTextEmpty, loadingSpinnerModeAttribute, loadingSpinnerOrientationAttribute, loadingSpinnerSizeAttribute, logInputGroupWarning, oneOfOrDefault, openCloseAnimation, stringAttribute, stringOrUndefinedAttribute, transformContentDialogSize, transformOrientation };
